export const QUESTIONS = [
  {
    "id": 1,
    "question": "The organization that Chris works for has disabled automatic updates. What is the most common reason for disabling automatic updates for organizational systems?",
    "choice_a": "To avoid disruption of the work process for office workers",
    "choice_b": "To prevent security breaches due to malicious patches and updates",
    "choice_c": "To avoid issues with problematic patches and updates",
    "choice_d": "All of the above",
    "correct_answer": "C",
    "explanation": "The most common reason to disable automatic patching is to avoid issues with problematic or flawed patches and updates. In most environments the need to patch regularly is accepted and handled for office workers without causing significant disruption. That concern would be different if the systems being patched were part of an industrial process or factory production environment. Malicious patches from legitimate sources such as an automatic update repository are exceptionally rare and are not a common concern or driver of this behavior.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      283,
      284,
      162,
      165,
      166
    ],
    "source": "211418_Assessment Test"
  },
  {
    "id": 2,
    "question": "Which of the following is the least volatile according to the forensic order of volatility?",
    "choice_a": "The system\u2019s routing table",
    "choice_b": "Logs",
    "choice_c": "Temp files",
    "choice_d": "CPU registers",
    "correct_answer": "B",
    "explanation": "Logs, along with any file that is stored on disk without the intention of being frequently overwritten, are the least volatile item listed. In order from most volatile to least from the answers here, you could list these as CPU registers, the system\u2019s routing table, temp files, and logs.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      262,
      268,
      263,
      270,
      260
    ],
    "source": "211418_Assessment Test"
  },
  {
    "id": 3,
    "question": "Ed wants to trick a user into connecting to his evil twin access point (AP). What type of attack should he conduct to increase his chances of the user connecting to it?",
    "choice_a": "A disassociation attack",
    "choice_b": "An application denial-of-service attack",
    "choice_c": "A known plain-text attack",
    "choice_d": "A network denial-of-service attack",
    "correct_answer": "A",
    "explanation": "If Ed can cause his target to disassociate from the access point they are currently connected to, he can use a higher transmission power or closer access point to appear higher in the list of access points. If he is successful at fooling the user or system into connecting to his AP, he can then conduct on-path attacks or attempt other exploits. Denial-of-service attacks are unlikely to cause a system to associate with another AP, and a known plain-text attack is a type of cryptographic attack and is not useful for this type of attempt.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      230,
      228,
      74,
      126,
      34
    ],
    "source": "211418_Assessment Test"
  },
  {
    "id": 4,
    "question": "What term is used to describe wireless site surveys that show the relative power of access points on a diagram of the building or facility?",
    "choice_a": "Signal surveys",
    "choice_b": "db maps",
    "choice_c": "AP topologies",
    "choice_d": "Heatmaps",
    "correct_answer": "D",
    "explanation": "Site surveys that show relative power on a map or diagram are called heatmaps. They can help show where access points provide a strong signal, and where multiple APs may be competing with each other due to channel overlap or other issues. They can also help identify dead zones where signal does not reach. Signal surveys, db maps, and AP topologies were made up for this question.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      231,
      232,
      193,
      211,
      150
    ],
    "source": "211418_Assessment Test"
  },
  {
    "id": 5,
    "question": "What hardware device is used to create the hardware root of trust for modern desktops and laptops?",
    "choice_a": "System memory",
    "choice_b": "A HSM",
    "choice_c": "The CPU",
    "choice_d": "The TPM",
    "correct_answer": "D",
    "explanation": "A hardware root of trust provides a unique element that means that a board or device cannot be replicated. A Trusted Platform Module (TPM) is commonly used to provide the hardware root of trust. CPUs and system memory are not unique in this way for common desktops and laptops, and a hardware security module (HSM) is used to create, manage, and store cryptographic certificates as well as perform and offload cryptographic operations.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      132,
      137,
      139,
      236,
      237
    ],
    "source": "211418_Assessment Test"
  },
  {
    "id": 6,
    "question": "Angela wants to prevent users in her organization from changing their passwords repeatedly after they have been changed so that they cannot reuse their current password. What two password security settings does she need to implement to make this occur?",
    "choice_a": "Set a password history and a minimum password age.",
    "choice_b": "Set a password history and a complexity setting.",
    "choice_c": "Set a password minimum and maximum age.",
    "choice_d": "Set password complexity and maximum age.",
    "correct_answer": "A",
    "explanation": "Angela needs to retain a password history and set a minimum password age so that users cannot simply reset their password until they have changed the password enough times to bypass the history.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      194,
      148,
      143,
      137,
      139
    ],
    "source": "211418_Assessment Test"
  },
  {
    "id": 7,
    "question": "Chris wants to establish a backup site that is fully ready to take over for full operations for his organization at any time. What type of site should he set up?",
    "choice_a": "A cold site",
    "choice_b": "A clone site",
    "choice_c": "A hot site",
    "choice_d": "A ready site",
    "correct_answer": "C",
    "explanation": "Hot sites are ready to take over operations in real time. Cold sites are typically simply ready buildings with basic infrastructure in place to set up a site. Clone sites and ready sites are not typical terms used in the industry.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      158,
      150,
      159,
      161,
      153
    ],
    "source": "211418_Assessment Test"
  },
  {
    "id": 8,
    "question": "Which of the following is not a common constraint of embedded and specialized systems?",
    "choice_a": "Computational power",
    "choice_b": "Overly complex firewall settings",
    "choice_c": "Lack of network connectivity",
    "choice_d": "Inability to patch",
    "correct_answer": "B",
    "explanation": "Embedded and specialized systems tend to have lower-power CPUs, less memory, less storage, and often may not be able to handle CPU-intensive tasks like cryptographic algorithms or built-in security tools. Thus, having a firewall is relatively unlikely, particularly if there isn\u2019t network connectivity built in or the device is expected to be deployed to a secure network.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      204,
      218,
      173,
      211,
      185
    ],
    "source": "211418_Assessment Test"
  },
  {
    "id": 9,
    "question": "Gary is reviewing his system\u2019s SSH logs and sees logins for the user named \u201cGary\u201d with passwords like password1, passsword2 \u2026 PassworD. What type of attack has Gary discovered?",
    "choice_a": "A dictionary attack",
    "choice_b": "A rainbow table attack",
    "choice_c": "A pass-the-hash attack",
    "choice_d": "A password spraying attack",
    "correct_answer": "A",
    "explanation": "A dictionary attack will use a set of likely passwords along with common variants of those passwords to try to break into an account. Repeated logins for a single user ID with iterations of various passwords is likely a dictionary account. A rainbow table is used to match a hashed password with the password that was hashed to that value. A pass-the-hash attack provides a captured authentication hash to try to act like an authorized user. A password spraying attack uses a known password (often from a breach) for many different sites to try to log in to them.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      37,
      38,
      128,
      39,
      73
    ],
    "source": "211418_Assessment Test"
  },
  {
    "id": 10,
    "question": "Kathleen wants to set up a system that allows access into a high-security zone from a low-security zone. What type of solution should she configure?",
    "choice_a": "VDI",
    "choice_b": "A container",
    "choice_c": "A screened subnet",
    "choice_d": "A jump server",
    "correct_answer": "D",
    "explanation": "Jump servers are systems that are used to provide a presence and access path in a different security zone. VDI is a virtual desktop infrastructure and is used to provide controlled virtual systems for productivity and application presentation among other uses. A container is a way to provide a scalable, predictable application environment without having a full underlying virtual system, and a screened subnet is a secured zone exposed to a lower trust level area or population.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      11,
      177,
      211,
      175,
      193
    ],
    "source": "211418_Assessment Test"
  },
  {
    "id": 11,
    "question": "Derek\u2019s organization is worried about a disgruntled employee publishing sensitive business information. What type of threat should Derek work to protect against?",
    "choice_a": "Shoulder surfing",
    "choice_b": "Social engineering",
    "choice_c": "Insider threats",
    "choice_d": "Phishing",
    "correct_answer": "C",
    "explanation": "Derek\u2019s organization is worried about insider threats, or threats that are created by employees and others who are part of the organization or are otherwise trusted by the organization. Social engineering involves deceiving people to achieve an attacker\u2019s goals. Phishing attempts to acquire personal information through social engineering and other techniques, and shoulder surfing is a technique where malicious actors watch over someone\u2019s shoulder to acquire information like passwords or credit card numbers.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      17,
      12,
      32,
      33,
      34
    ],
    "source": "211418_Assessment Test"
  },
  {
    "id": 12,
    "question": "Jeff is concerned about the effects that a ransomware attack might have on his organization and is designing a backup methodology that would allow the organization to quickly restore data after such an attack. What type of control is Jeff implementing?",
    "choice_a": "Corrective",
    "choice_b": "Preventive",
    "choice_c": "Detective",
    "choice_d": "Deterrent",
    "correct_answer": "A",
    "explanation": "Corrective controls remediate security issues that have already occurred. Restoring backups after a ransomware attack is an example of a corrective control. Preventative controls attempt to stop future issues. Detective controls focus on detecting issues and events, and deterrent controls attempt to deter actions.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      6,
      1,
      2,
      5,
      284
    ],
    "source": "211418_Assessment Test"
  },
  {
    "id": 13,
    "question": "Samantha is investigating a cybersecurity incident where an internal user used his computer to participate in a denial-of-service attack against a third party. What type of policy was most likely violated?",
    "choice_a": "BPA",
    "choice_b": "SLA",
    "choice_c": "AUP",
    "choice_d": "MOU",
    "correct_answer": "C",
    "explanation": "This activity is almost certainly a violation of the organization\u2019s acceptable use policy (AUP), which should contain provisions describing appropriate use of networks and computing resources belonging to the organization. BPA is not a common term in this context. Service level agreements (SLAs) determine an agreed upon level of service, and MOUs, or memorandums of understanding are used to document agreements between organizations.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      276,
      275,
      280,
      279,
      281
    ],
    "source": "211418_Assessment Test"
  },
  {
    "id": 14,
    "question": "Jean recently completed the user acceptance testing process and is getting her code ready to deploy. What environment should house her code before it is released for use?",
    "choice_a": "Test",
    "choice_b": "Production",
    "choice_c": "Development",
    "choice_d": "Staging",
    "correct_answer": "D",
    "explanation": "The staging environment is a transition environment for code that has successfully cleared testing and is waiting to be deployed into production. This is where the code should reside before it is released for use. The development environment is where developers work on the code prior to preparing it for deployment. The test environment is where the software or systems can be tested without impacting the production environment. The production environment is the live system. Software, patches, and other changes that have been tested and approved move to production.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      284,
      283,
      6,
      102,
      98
    ],
    "source": "211418_Assessment Test"
  },
  {
    "id": 15,
    "question": "Rob has created a document that describes how staff in his organization can use organizationally owned devices, including if and when personal use is allowed. What type of policy has Rob created?",
    "choice_a": "A change management policy",
    "choice_b": "An acceptable use policy",
    "choice_c": "An access control policy",
    "choice_d": "A playbook",
    "correct_answer": "B",
    "explanation": "Acceptable use policies define how organizational systems, devices, and services can and should be used. Change management policies determine how an organization handles change and change control. Access control documentation is typically handled as a standard, and playbooks describe how perform specific duties or processes.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      275,
      276,
      278,
      279,
      280
    ],
    "source": "211418_Assessment Test"
  },
  {
    "id": 16,
    "question": "Oren obtained a certificate for his domain covering <code>*.acmewidgets.net</code>. Which one of the following domains would not be covered by this certificate?",
    "choice_a": "<code>www.acmewidgets.net</code>",
    "choice_b": "<code>acmewidgets.net</code>",
    "choice_c": "<code>test.mail.acmewidgets.net</code>",
    "choice_d": "<code>mobile.acmewidgets.net</code>",
    "correct_answer": "C",
    "explanation": "Wildcard certificates protect the listed domain as well as all first-level subdomains. <code>test.mail.acmewidgets.net</code> is a second-level subdomain of <code>acmewidgets.net</code> and would not be covered by this certificate.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      118,
      120,
      122,
      121,
      119
    ],
    "source": "211418_Assessment Test"
  },
  {
    "id": 17,
    "question": "Richard is sending a message to Grace and would like to apply a digital signature to the message before sending it. What key should he use to create the digital signature?",
    "choice_a": "Richard\u2019s private key",
    "choice_b": "Richard\u2019s public key",
    "choice_c": "Grace\u2019s private key",
    "choice_d": "Grace\u2019s public key",
    "correct_answer": "A",
    "explanation": "The sender of a message may digitally sign the message by encrypting a message digest with the sender\u2019s own private key.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      116,
      105,
      115,
      107,
      112
    ],
    "source": "211418_Assessment Test"
  },
  {
    "id": 18,
    "question": "Stephanie is reviewing a customer transaction database and comes across the data table shown here. What data minimization technique has most likely been used to obscure the credit card information in this table?<img src=\"/question_assets/Security+/fintrouf001.png\"/>",
    "choice_a": "Destruction",
    "choice_b": "Masking",
    "choice_c": "Hashing",
    "choice_d": "Tokenization",
    "correct_answer": "C",
    "explanation": "This data most closely resembles hashed data, as the fields are all the same length and appear to contain meaningless but unique data. If the field was tokenized, it would be more likely to contain a sequential number or other recognizable identifier. If the field was masked, it would contain asterisks or other placeholder characters.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      10,
      318,
      9,
      316,
      319
    ],
    "source": "211418_Assessment Test"
  },
  {
    "id": 19,
    "question": "Andrew is working with his financial team to purchase a cybersecurity insurance policy to cover the financial impact of a data breach. What type of risk management strategy is he using?",
    "choice_a": "Risk avoidance",
    "choice_b": "Risk transference",
    "choice_c": "Risk acceptance",
    "choice_d": "Risk mitigation",
    "correct_answer": "B",
    "explanation": "Purchasing insurance is the most common example of risk transference\u2014shifting liability to a third party. Avoidance involves efforts to prevent the risk from occurring, acceptance is just that\u2014formally accepting that the risk may occur, and mitigation attempts to limit the impact of the risk.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      309,
      310,
      312,
      313,
      3
    ],
    "source": "211418_Assessment Test"
  },
  {
    "id": 20,
    "question": "Shelly is writing a document that describes the steps that incident response teams will follow upon first notice of a potential incident. What type of document is she creating?",
    "choice_a": "Guideline",
    "choice_b": "Standard",
    "choice_c": "Procedure",
    "choice_d": "Policy",
    "correct_answer": "C",
    "explanation": "Procedures provide checklist-style sets of step-by-step instructions guiding how employees should react in a given circumstance. Procedures commonly guide the early stages of incident response. Standards define how policies should be implemented. Guidelines are voluntary, whereas policies are mandatory.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      243,
      240,
      241,
      242,
      246
    ],
    "source": "211418_Assessment Test"
  },
  {
    "id": 21,
    "question": "Matt is updating the organization\u2019s threat assessment process. What category of control is Matt implementing?",
    "choice_a": "Operational",
    "choice_b": "Technical",
    "choice_c": "Corrective",
    "choice_d": "Managerial",
    "correct_answer": "D",
    "explanation": "Managerial controls are procedural mechanisms that focus on the mechanics of the risk management process. Threat assessment is an example of one of these activities.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      6,
      282,
      285,
      284
    ],
    "source": "211418_Ch01"
  },
  {
    "id": 22,
    "question": "Jade\u2019s organization recently suffered a security breach that affected stored credit card data. Jade\u2019s primary concern is the fact that the organization is subject to sanctions for violating the provisions of the Payment Card Industry Data Security Standard. What category of risk is concerning Jade?",
    "choice_a": "Strategic",
    "choice_b": "Compliance",
    "choice_c": "Operational",
    "choice_d": "Financial",
    "correct_answer": "B",
    "explanation": "The breach of credit card information may cause many different impacts on the organization, including compliance, operational, and financial risks. However, in this scenario, Jade\u2019s primary concern is violating PCI DSS, making his concern a compliance risk.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      4,
      292,
      310,
      294,
      312
    ],
    "source": "211418_Ch01"
  },
  {
    "id": 23,
    "question": "Chris is responding to a security incident that compromised one of his organization\u2019s web servers. He believes that the attackers defaced one or more pages on the website. What cybersecurity objective did this attack violate?",
    "choice_a": "Confidentiality",
    "choice_b": "Nonrepudiation",
    "choice_c": "Integrity",
    "choice_d": "Availability",
    "correct_answer": "C",
    "explanation": "The defacement of a website alters content without authorization and is, therefore, a violation of the integrity objective. The attackers may also have breached the confidentiality or availability of the website, but the scenario does not provide us with enough information to draw those conclusions.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      1,
      2,
      6,
      5,
      107
    ],
    "source": "211418_Ch01"
  },
  {
    "id": 24,
    "question": "Gwen is exploring a customer transaction reporting system and discovers the table shown here. What type of data minimization has most likely been used on this table?<img src=\"/question_assets/Security+/c01uf001.png\"/>",
    "choice_a": "Destruction",
    "choice_b": "Masking",
    "choice_c": "Tokenization",
    "choice_d": "Hashing",
    "correct_answer": "B",
    "explanation": "In this case, the first 12 digits of the credit card have been removed and replaced with asterisks. This is an example of data masking.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      318,
      10,
      319,
      9,
      11
    ],
    "source": "211418_Ch01"
  },
  {
    "id": 25,
    "question": "Tonya is concerned about the risk that an attacker will attempt to gain access to her organization\u2019s database server. She is searching for a control that would discourage the attacker from attempting to gain access. What type of security control is she seeking to implement?",
    "choice_a": "Preventive",
    "choice_b": "Detective",
    "choice_c": "Corrective",
    "choice_d": "Deterrent",
    "correct_answer": "D",
    "explanation": "Deterrent controls are designed to prevent an attacker from attempting to violate security policies in the first place. Preventive controls would attempt to block an attack that was about to take place. Corrective controls would remediate the issues that arose during an attack. Detective controls detect issues or indicators of issues.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      5,
      162,
      163,
      164
    ],
    "source": "211418_Ch01"
  },
  {
    "id": 26,
    "question": "Greg is implementing a data loss prevention system. He would like to ensure that it protects against transmissions of sensitive information by guests on his wireless network. What DLP technology would best meet this goal?",
    "choice_a": "Watermarking",
    "choice_b": "Pattern recognition",
    "choice_c": "Host-based",
    "choice_d": "Network-based",
    "correct_answer": "D",
    "explanation": "In this case, Greg must use a network-based DLP system. Host-based DLP requires the use of agents, which would not be installed on guest systems. Greg may use watermarking and/or pattern recognition to identify the sensitive information, but he must use network-based DLP to meet his goal.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      9,
      8,
      11,
      193,
      232
    ],
    "source": "211418_Ch01"
  },
  {
    "id": 27,
    "question": "What term best describes data that is being sent between two systems over a network connection?",
    "choice_a": "Data at rest",
    "choice_b": "Data in transit",
    "choice_c": "Data in processing",
    "choice_d": "Data in use",
    "correct_answer": "B",
    "explanation": "Data being sent over a network is data in transit. Data at rest is stored data that resides on hard drives, tapes, in the cloud, or on other storage media. Data in processing, or data in use, is data that is actively in use by a computer system.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      8,
      9,
      11,
      318,
      10
    ],
    "source": "211418_Ch01"
  },
  {
    "id": 28,
    "question": "Tina is tuning her organization\u2019s intrusion prevention system to prevent false positive alerts. What type of control is Tina implementing?",
    "choice_a": "Technical control",
    "choice_b": "Physical control",
    "choice_c": "Managerial control",
    "choice_d": "Operational control",
    "correct_answer": "A",
    "explanation": "Technical controls enforce confidentiality, integrity, and availability in the digital space. Examples of technical security controls include firewall rules, access control lists, intrusion prevention systems, and encryption.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      6,
      1,
      282,
      283
    ],
    "source": "211418_Ch01"
  },
  {
    "id": 29,
    "question": "Which one of the following is not a common goal of a cybersecurity attacker?",
    "choice_a": "Disclosure",
    "choice_b": "Denial",
    "choice_c": "Alteration",
    "choice_d": "Allocation",
    "correct_answer": "D",
    "explanation": "The three primary goals of cybersecurity attackers are disclosure, alteration, and denial. These map directly to the three objectives of cybersecurity professionals: confidentiality, integrity, and availability.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      2,
      1,
      98,
      6,
      5
    ],
    "source": "211418_Ch01"
  },
  {
    "id": 30,
    "question": "Tony is reviewing the status of his organization\u2019s defenses against a breach of their file server. He believes that a compromise of the file server could reveal information that would prevent the company from continuing to do business. What term best describes the risk that Tony is considering?",
    "choice_a": "Strategic",
    "choice_b": "Reputational",
    "choice_c": "Financial",
    "choice_d": "Operational",
    "correct_answer": "A",
    "explanation": "The risk that Tony is contemplating could fit any one of these categories. However, his primary concern is that the company may no longer be able to do business if the risk materializes. This is a strategic risk.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      3,
      310,
      307,
      312,
      304
    ],
    "source": "211418_Ch01"
  },
  {
    "id": 31,
    "question": "Which one of the following data elements is not commonly associated with identity theft?",
    "choice_a": "Social Security number",
    "choice_b": "Driver\u2019s license number",
    "choice_c": "Frequent flyer number",
    "choice_d": "Passport number",
    "correct_answer": "C",
    "explanation": "Although it is possible that a frequent flyer account number, or any other account number for that matter, could be used in identity theft, it is far more likely that identity thieves would use core identity documents. These include drivers\u2019 licenses, passports, and Social Security numbers.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      316,
      10,
      318,
      9,
      11
    ],
    "source": "211418_Ch01"
  },
  {
    "id": 32,
    "question": "What term best describes an organization\u2019s desired security state?",
    "choice_a": "Control objectives",
    "choice_b": "Security priorities",
    "choice_c": "Strategic goals",
    "choice_d": "Best practices",
    "correct_answer": "A",
    "explanation": "As an organization analyzes its risk environment, technical and business leaders determine the level of protection required to preserve the confidentiality, integrity, and availability of their information and systems. They express these requirements by writing the control objectives that the organization wishes to achieve. These control objectives are statements of a desired security state.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      273,
      276,
      277,
      278,
      280
    ],
    "source": "211418_Ch01"
  },
  {
    "id": 33,
    "question": "Lou mounted the sign below on the fence surrounding his organization\u2019s datacenter. What control type <i>best</i> describes this control?<img src=\"/question_assets/Security+/c01uf002.png\"/>",
    "choice_a": "Compensating",
    "choice_b": "Detective",
    "choice_c": "Physical",
    "choice_d": "Deterrent",
    "correct_answer": "D",
    "explanation": "This question is a little tricky. The use of an actual guard dog could be considered a deterrent, physical, or detective control. It could even be a compensating control in some circumstances. However, the question asks about the presence of a <i>sign</i> and does not state that an actual dog is used. The sign only has value as a deterrent control. Be careful when facing exam questions like this to read the details of the question.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      6,
      5,
      163,
      164,
      166
    ],
    "source": "211418_Ch01"
  },
  {
    "id": 34,
    "question": "What technology uses mathematical algorithms to render information unreadable to those lacking the required key?",
    "choice_a": "Data loss prevention",
    "choice_b": "Data obfuscation",
    "choice_c": "Data minimization",
    "choice_d": "Data encryption",
    "correct_answer": "D",
    "explanation": "Encryption technology uses mathematical algorithms to protect information from prying eyes, both while it is in transit over a network and while it resides on systems. Encrypted data is unintelligible to anyone who does not have access to the appropriate decryption key, making it safe to store and transmit encrypted data over otherwise insecure means.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      108,
      104,
      106,
      105,
      103
    ],
    "source": "211418_Ch01"
  },
  {
    "id": 35,
    "question": "Greg recently conducted an assessment of his organization\u2019s security controls and discovered a potential gap: the organization does not use full-disk encryption on laptops. What type of control gap exists in this case?",
    "choice_a": "Detective",
    "choice_b": "Corrective",
    "choice_c": "Deterrent",
    "choice_d": "Preventive",
    "correct_answer": "D",
    "explanation": "The use of full-disk encryption is intended to prevent a security incident from occurring if a device is lost or stolen. Therefore, this is a preventive control gap.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      198,
      99,
      100,
      5
    ],
    "source": "211418_Ch01"
  },
  {
    "id": 36,
    "question": "What compliance regulation most directly affects the operations of a health-care provider?",
    "choice_a": "HIPAA",
    "choice_b": "PCI DSS",
    "choice_c": "GLBA",
    "choice_d": "SOX",
    "correct_answer": "A",
    "explanation": "Although a health-care provider may be impacted by any of these regulations, the Health Insurance Portability and Accountability Act (HIPAA) provides direct regulations for the security and privacy of protected health information and would have the most direct impact on a health-care provider.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      292,
      4,
      293,
      317,
      287
    ],
    "source": "211418_Ch01"
  },
  {
    "id": 37,
    "question": "Nolan is writing an after action report on a security breach that took place in his organization. The attackers stole thousands of customer records from the organization\u2019s database. What cybersecurity principle was most impacted in this breach?",
    "choice_a": "Availability",
    "choice_b": "Nonrepudiation",
    "choice_c": "Confidentiality",
    "choice_d": "Integrity",
    "correct_answer": "C",
    "explanation": "The disclosure of sensitive information to unauthorized individuals is a violation of the principle of confidentiality.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      1,
      2,
      98,
      100,
      6
    ],
    "source": "211418_Ch01"
  },
  {
    "id": 38,
    "question": "Which one of the following objectives is not one of the three main objectives that information security professionals must achieve to protect their organizations against cybersecurity threats?",
    "choice_a": "Integrity",
    "choice_b": "Nonrepudiation",
    "choice_c": "Availability",
    "choice_d": "Confidentiality",
    "correct_answer": "B",
    "explanation": "The three primary objectives of cybersecurity professionals are confidentiality, integrity, and availability.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      1,
      2,
      98,
      5,
      6
    ],
    "source": "211418_Ch01"
  },
  {
    "id": 39,
    "question": "Which one of the following data protection techniques is reversible when conducted properly?",
    "choice_a": "Tokenization",
    "choice_b": "Masking",
    "choice_c": "Hashing",
    "choice_d": "Shredding",
    "correct_answer": "A",
    "explanation": "Tokenization techniques use a lookup table and are designed to be reversible. Masking and hashing techniques replace the data with values that can\u2019t be reversed back to the original data if performed properly. Shredding, when conducted properly, physically destroys data so that it may not be recovered.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      10,
      318,
      319,
      316,
      9
    ],
    "source": "211418_Ch01"
  },
  {
    "id": 40,
    "question": "Which one of the following statements is not true about compensating controls under PCI DSS?",
    "choice_a": "Controls used to fulfill one PCI DSS requirement may be used to compensate for the absence of a control needed to meet another requirement.",
    "choice_b": "Controls must meet the intent of the original requirement.",
    "choice_c": "Controls must meet the rigor of the original requirement.",
    "choice_d": "Compensating controls must provide a similar level of defense as the original requirement.",
    "correct_answer": "A",
    "explanation": "PCI DSS compensating controls must be \u201cabove and beyond\u201d other PCI DSS requirements. This specifically bans the use of a control used to meet one requirement as a compensating control for another requirement.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      5,
      285,
      284,
      162
    ],
    "source": "211418_Ch01"
  },
  {
    "id": 41,
    "question": "Which of the following measures is not commonly used to assess threat intelligence?",
    "choice_a": "Timeliness",
    "choice_b": "Detail",
    "choice_c": "Accuracy",
    "choice_d": "Relevance",
    "correct_answer": "B",
    "explanation": "Although higher levels of detail can be useful, they aren\u2019t a common measure used to assess threat intelligence. Instead, the timeliness, accuracy, and relevance of the information are considered critical to determining whether you should use the threat information.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      21,
      20,
      22,
      23,
      62
    ],
    "source": "211418_Ch02"
  },
  {
    "id": 42,
    "question": "Which one of the following motivations is most commonly attributed to hacktivists?",
    "choice_a": "War",
    "choice_b": "Financial gain",
    "choice_c": "Political/philosophical beliefs",
    "choice_d": "Ethical",
    "correct_answer": "C",
    "explanation": "Hacktivists are defined by the motivation behind their actions\u2014advancing their political or philosophical beliefs. They engage in cyberattacks that they believe will advance their causes.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      15,
      12,
      19,
      13,
      32
    ],
    "source": "211418_Ch02"
  },
  {
    "id": 43,
    "question": "Kolin is a penetration tester who works for a cybersecurity company. His firm was hired to conduct a penetration test against a health-care system, and Kolin is working to gain access to the systems belonging to a hospital in that system. What term best describes Kolin\u2019s work?",
    "choice_a": "Authorized attacker",
    "choice_b": "Unauthorized attacker",
    "choice_c": "Unknown attacker",
    "choice_d": "Semi-authorized attacker",
    "correct_answer": "A",
    "explanation": "Attacks that are conducted as part of an authorized penetration test are white-hat hacking attacks, regardless of whether they are conducted by internal employees or an external firm. Kolin is, therefore, engaged in white-hat hacking. If he were acting on his own, without authorization, his status would depend on his intent. If he had malicious intent, his activity would be considered black-hat hacking. If he simply intended to report vulnerabilities to the hospital, his attack would be considered gray hat and he would likely be semi-authorized.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      13,
      12,
      19,
      15,
      17
    ],
    "source": "211418_Ch02"
  },
  {
    "id": 44,
    "question": "Which one of the following attackers is most likely to be associated with an APT?",
    "choice_a": "Nation-state actor",
    "choice_b": "Hacktivist",
    "choice_c": "Unskilled",
    "choice_d": "Insider",
    "correct_answer": "A",
    "explanation": "Advanced persistent threats (APTs) are most commonly associated with nation-state actors. It is unlikely that an APT group would leverage the unsophisticated services of an unskilled script kiddie type attacker. It is also unlikely that a hacktivist would have access to APT resources. Although APTs may take advantage of insider access, they are most commonly associated with nation-state actors.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      16,
      12,
      14,
      15,
      18
    ],
    "source": "211418_Ch02"
  },
  {
    "id": 45,
    "question": "Which organization did the U.S. government help create to share knowledge between organizations in specific verticals?",
    "choice_a": "DHS",
    "choice_b": "SANS",
    "choice_c": "CERTS",
    "choice_d": "ISACs",
    "correct_answer": "D",
    "explanation": "The U.S. government created the Information Sharing and Analysis Centers (ISACs). ISACs help infrastructure owners and operators share threat information, and provide tools and assistance to their members.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      23,
      20,
      22,
      21,
      91
    ],
    "source": "211418_Ch02"
  },
  {
    "id": 46,
    "question": "Which of the following threat actors typically has the greatest access to resources?",
    "choice_a": "Nation-state actors",
    "choice_b": "Organized crime",
    "choice_c": "Hacktivists",
    "choice_d": "Insider threats",
    "correct_answer": "A",
    "explanation": "Nation-state actors are government sponsored, and they typically have the greatest access to resources, including tools, money, and talent.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      12,
      16,
      19,
      15,
      17
    ],
    "source": "211418_Ch02"
  },
  {
    "id": 47,
    "question": "Of the threat vectors shown here, which one is most commonly exploited by attackers who are at a distant location?",
    "choice_a": "Email",
    "choice_b": "Direct access",
    "choice_c": "Wireless",
    "choice_d": "Removable media",
    "correct_answer": "A",
    "explanation": "Email is the most common threat vector exploited by attackers who use phishing and other social engineering tactics to gain access to an organization. The other vectors listed here, direct access, wireless, and removable media, all require physical proximity to an organization and are not easily executed from a remote location.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      33,
      19,
      34,
      32,
      25
    ],
    "source": "211418_Ch02"
  },
  {
    "id": 48,
    "question": "Which one of the following is the best example of a hacktivist group?",
    "choice_a": "Chinese military",
    "choice_b": "U.S. government",
    "choice_c": "Russian mafia",
    "choice_d": "Anonymous",
    "correct_answer": "D",
    "explanation": "The Chinese military and U.S. government are examples of nation-state actors and advanced persistent threats (APTs). The Russian mafia is an example of a criminal syndicate. Anonymous is the world\u2019s most prominent hacktivist group.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      15,
      12,
      16,
      19,
      13
    ],
    "source": "211418_Ch02"
  },
  {
    "id": 49,
    "question": "What type of assessment is particularly useful for identifying insider threats?",
    "choice_a": "Behavioral",
    "choice_b": "Instinctual",
    "choice_c": "Habitual",
    "choice_d": "IoCs",
    "correct_answer": "A",
    "explanation": "Behavioral assessments are very useful when you are attempting to identify insider threats. Since insider threats are often hard to distinguish from normal behavior, the context of the actions performed\u2014such as after-hours logins, misuse of credentials, logins from abnormal locations, or abnormal patterns\u2014and other behavioral indicators are often used.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      17,
      244,
      12,
      245,
      19
    ],
    "source": "211418_Ch02"
  },
  {
    "id": 50,
    "question": "Cindy is concerned that her organization may be targeted by a supply chain attack and is conducting a review of all of her vendor and supplier partners. Which one of the following organizations is least likely to be the conduit for a supply chain attack?",
    "choice_a": "Hardware provider",
    "choice_b": "Software provider",
    "choice_c": "Managed service provider",
    "choice_d": "Talent provider",
    "correct_answer": "D",
    "explanation": "Supply chain attacks are typically associated with vendors and suppliers that provide technology infrastructure or services that may be compromised. This would include hardware and software providers as well as managed service providers (MSPs). Talent providers, who help with staffing solutions, are generally not considered common avenues for supply chain attacks.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      19,
      88,
      202,
      184,
      16
    ],
    "source": "211418_Ch02"
  },
  {
    "id": 51,
    "question": "Greg believes that an attacker may have installed malicious firmware in a network device before it was provided to his organization by the supplier. What type of threat vector best describes this attack?",
    "choice_a": "Supply chain",
    "choice_b": "Removable media",
    "choice_c": "Cloud",
    "choice_d": "Direct access",
    "correct_answer": "A",
    "explanation": "Tampering with equipment before it reaches the intended user is an example of a supply chain threat. It is also possible to describe this attack as a direct access attack because it involved physical access to the device, but supply chain is a more relevant answer. You should be prepared to select the best possible choice from several possible correct answers when you take the exam. Security+ questions often use this type of misdirection.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      19,
      184,
      12,
      202,
      245
    ],
    "source": "211418_Ch02"
  },
  {
    "id": 52,
    "question": "Ken is conducting threat research on Transport Layer Security (TLS) and would like to consult the authoritative reference for the protocol\u2019s technical specification. What resource would best meet his needs?",
    "choice_a": "Academic journal",
    "choice_b": "Internet RFCs",
    "choice_c": "Subject matter experts",
    "choice_d": "Textbooks",
    "correct_answer": "B",
    "explanation": "All of these resources might contain information about the technical details of TLS, but Internet Request for Comments (RFC) documents are the definitive technical standards for Internet protocols. Consulting the RFCs would be Ken\u2019s best option.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      50,
      137,
      22,
      93,
      199
    ],
    "source": "211418_Ch02"
  },
  {
    "id": 53,
    "question": "Wendy is scanning cloud-based repositories for sensitive information. Which one of the following should concern her most, if discovered in a public repository?",
    "choice_a": "Product manuals",
    "choice_b": "Source code",
    "choice_c": "API keys",
    "choice_d": "Open source data",
    "correct_answer": "C",
    "explanation": "All of these items could be concerning, depending on the circumstances. However, API keys should <i>never</i> be found in public repositories because they may grant unauthorized individuals access to information and resources.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      85,
      178,
      22,
      52,
      138
    ],
    "source": "211418_Ch02"
  },
  {
    "id": 54,
    "question": "Which one of the following threat research tools is used to visually display information about the location of threat actors?",
    "choice_a": "Threat map",
    "choice_b": "Predictive analysis",
    "choice_c": "Vulnerability feed",
    "choice_d": "STIX",
    "correct_answer": "A",
    "explanation": "Threat maps are graphical tools that display information about the geographic locations of attackers and their targets. These tools are most often used as interesting marketing gimmicks, but they can also help identify possible threat sources.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      247,
      246,
      20,
      23,
      91
    ],
    "source": "211418_Ch02"
  },
  {
    "id": 55,
    "question": "Vince recently received the hash values of malicious software that several other firms in his industry found installed on their systems after a compromise. What term best describes this information?",
    "choice_a": "Vulnerability feed",
    "choice_b": "IoC",
    "choice_c": "TTP",
    "choice_d": "RFC",
    "correct_answer": "B",
    "explanation": "Specific details of attacks that may be used to identify compromises are known as indicators of compromise (IoCs). This data may also be described as an adversary tactics, techniques, and procedures (TTP), but the fact that it is a set of file signatures makes it more closely match the definition of an IoC.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      244,
      25,
      26,
      30,
      31
    ],
    "source": "211418_Ch02"
  },
  {
    "id": 56,
    "question": "Ursula recently discovered that a group of developers are sharing information over a messaging tool provided by a cloud vendor but not sanctioned by her organization. What term best describes this use of technology?",
    "choice_a": "Shadow IT",
    "choice_b": "System integration",
    "choice_c": "Vendor management",
    "choice_d": "Data exfiltration",
    "correct_answer": "A",
    "explanation": "The developers in question are using unapproved technology for business purposes. This is the classic definition of shadow IT. It is possible to describe this as data exfiltration, but there is no indication that the data security has been compromised, so shadow IT is a better description here. Remember, you will often be asked to choose the best answer from multiple correct answers on the exam.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      171,
      93,
      246,
      240,
      144
    ],
    "source": "211418_Ch02"
  },
  {
    "id": 57,
    "question": "Tom\u2019s organization recently learned that the vendor is discontinuing support for their customer relationship management (CRM) system. What should concern Tom the most from a security perspective?",
    "choice_a": "Unavailability of future patches",
    "choice_b": "Lack of technical support",
    "choice_c": "Theft of customer information",
    "choice_d": "Increased costs",
    "correct_answer": "A",
    "explanation": "Tom\u2019s greatest concern should be that running unsupported software exposes his organization to the risk of new, unpatchable vulnerabilities. It is certainly true that they will no longer receive technical support, but this is a less important issue from a security perspective. There is no indication in the scenario that discontinuing the product will result in the theft of customer information or increased costs.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      51,
      63,
      207,
      93,
      240
    ],
    "source": "211418_Ch02"
  },
  {
    "id": 58,
    "question": "Which one of the following information sources would not be considered an OSINT source?",
    "choice_a": "DNS lookup",
    "choice_b": "Search engine research",
    "choice_c": "Port scans",
    "choice_d": "WHOIS queries",
    "correct_answer": "C",
    "explanation": "Port scans are an active reconnaissance technique that probe target systems and would not be considered open source intelligence (OSINT). Search engine research, DNS lookups, and WHOIS queries are all open source resources.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      24,
      18,
      35,
      245,
      13
    ],
    "source": "211418_Ch02"
  },
  {
    "id": 59,
    "question": "Edward Snowden was a government contractor who disclosed sensitive government documents to journalists to uncover what he believed were unethical activities. Which of the following terms best describe Snowden\u2019s activities? (Choose two.)",
    "choice_a": "Insider",
    "choice_b": "State actor",
    "choice_c": "Hacktivist",
    "choice_d": "APT",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "As a government contractor, Snowden had authorized access to classified information and exploited this access to make an unauthorized disclosure of that information. This clearly makes him fit into the category of an insider. He did so with political motivations, making him fit the category of hacktivist as well.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      15,
      17,
      13,
      19,
      244
    ],
    "source": "211418_Ch02",
    "choice_e": "Organized crime"
  },
  {
    "id": 60,
    "question": "Renee is a cybersecurity hobbyist. She receives an email about a new web-based grading system being used by her son\u2019s school and she visits the site. She notices that the URL for the site looks like this:<br> <code>https://www.myschool.edu/grades.php&studentID=1023425</code><br>She realizes that 1023425 is her son\u2019s student ID number and she then attempts to access the following similar URLs:<br> <code>https://www.myschool.edu/grades.php&studentID=1023423</code><br> <code>https://www.myschool.edu/grades.php&studentID=1023424</code><br> <code>https://www.myschool.edu/grades.php&studentID=1023426</code><br> <code>https://www.myschool.edu/grades.php&studentID=1023427</code><br>When she does so, she accesses the records of other students. She closes the records and immediately informs the school principal of the vulnerability. What term best describes Renee\u2019s work?",
    "choice_a": "Authorized hacking",
    "choice_b": "Unknown hacking",
    "choice_c": "Semi-authorized hacking",
    "choice_d": "Unauthorized hacking",
    "correct_answer": "C",
    "explanation": "Renee was not authorized to perform this security testing, so her work does not fit into the category of white-hat hacking, or authorized hacking. However, she also does not have malicious intent, so her work cannot be categorized as an unauthorized, or black-hat attack. Instead, it fits somewhere in between the two extremes and would best be described as semi-authorized, or gray-hat hacking.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      13,
      76,
      67,
      19,
      32
    ],
    "source": "211418_Ch02"
  },
  {
    "id": 61,
    "question": "Ryan wants to prevent logic bombs created by insider threats from impacting his organization. What technique will most effectively limit the likelihood of logic bombs being put in place?",
    "choice_a": "Deploying antivirus software",
    "choice_b": "Using a code review process",
    "choice_c": "Deploying endpoint detection and response (EDR) software",
    "choice_d": "Disabling autorun for USB drives",
    "correct_answer": "B",
    "explanation": "Logic bombs are embedded in code, so Ryan\u2019s organization would get the most benefit from a code review process for any code that goes into production. Antivirus and EDR are unlikely to detect logic bombs created by staff in Ryan\u2019s organization.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      69,
      17,
      72,
      83,
      245
    ],
    "source": "211418_Ch03"
  },
  {
    "id": 62,
    "question": "Yasmine believes that her organization may be dealing with an advanced rootkit and wants to write IoC definitions for it. Which of the following is not likely to be a useful IoC for a rootkit?",
    "choice_a": "File hashes",
    "choice_b": "Command and control domains",
    "choice_c": "Pop-ups demanding a ransom",
    "choice_d": "Behavior-based identifiers",
    "correct_answer": "C",
    "explanation": "Rootkits are intended to be stealthy, and a pop-up demanding ransom works against that purpose. File hashes, command and control details, and behavior-based identifiers are all useful IoCs likely to be relevant to a rootkit.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      29,
      244,
      25,
      26,
      30
    ],
    "source": "211418_Ch03"
  },
  {
    "id": 63,
    "question": "Nathan works at a school and notices that one of his staff appears to have logged in and changed grades for a single student to higher grades, even in classes that staff member is not responsible for. When asked, the staff member says that they did not perform the action. Which of the following is the most likely way that a student could have gotten access to the staff member\u2019s password?",
    "choice_a": "A keylogger",
    "choice_b": "A rootkit",
    "choice_c": "Spyware",
    "choice_d": "A logic bomb",
    "correct_answer": "A",
    "explanation": "Nathan should check the staff member\u2019s computer for a keylogger, which would have captured their username and password. A student could have then used the staff member\u2019s credentials to make the changes described. A rootkit would be used to retain access, spyware gathers a variety of data but is not specifically aimed at capturing keystrokes like this, and logic bombs have specific events or triggers that cause them to take action.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      30,
      29,
      26,
      244,
      19
    ],
    "source": "211418_Ch03"
  },
  {
    "id": 64,
    "question": "Amanda notices traffic between her systems and a known malicious host on TCP port 6667. What type of traffic is she most likely detecting?",
    "choice_a": "Command and control",
    "choice_b": "Spyware",
    "choice_c": "A worm",
    "choice_d": "A hijacked web browser",
    "correct_answer": "A",
    "explanation": "Amanda has most likely discovered a botnet\u2019s command and control channel, and the system or systems she is monitoring are probably using IRC as the command and control channel. Spyware is likely to simply send data to a central server via HTTP/HTTPS, worms spread by attacking vulnerable services, and a hijacked web browser would probably operate on common HTTP or HTTPS ports (80/443).",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      31,
      26,
      30,
      27,
      25
    ],
    "source": "211418_Ch03"
  },
  {
    "id": 65,
    "question": "Mike discovers that attackers have left software that allows them to have remote access to systems on a computer in his company\u2019s network. How should he describe or classify this malware?",
    "choice_a": "A worm",
    "choice_b": "Crypto malware",
    "choice_c": "A trojan",
    "choice_d": "A backdoor",
    "correct_answer": "D",
    "explanation": "Remote access to a system is typically provided by a backdoor. Backdoors may also appear in firmware or even in hardware. None of the other items listed provide remote access by default, although they may have a backdoor as part of a more capable malware package.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      26,
      29,
      31,
      28,
      25
    ],
    "source": "211418_Ch03"
  },
  {
    "id": 66,
    "question": "What is the primary impact of bloatware?",
    "choice_a": "Consuming resources",
    "choice_b": "Logging keystrokes",
    "choice_c": "Providing information about users and devices to third parties",
    "choice_d": "Allowing unauthorized remote access",
    "correct_answer": "A",
    "explanation": "Bloatware is typically not a significant security threat, but it consumes resources like disk space, CPU, and memory. Unfortunately, some bloatware can be vulnerable and may not get regularly patched, meaning it\u2019s both useless and a potential risk!",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      202,
      183,
      88,
      184,
      14
    ],
    "source": "211418_Ch03"
  },
  {
    "id": 67,
    "question": "What type of malware is used to gather information about a user\u2019s browsing habits and system?",
    "choice_a": "A Trojan",
    "choice_b": "Bloatware",
    "choice_c": "Spyware",
    "choice_d": "A rootkit",
    "correct_answer": "C",
    "explanation": "Spyware is specifically designed to gather information about users and systems and to send that data back to a central collector. Trojans pretend to be useful software and include malicious components, bloatware is preinstalled software that isn\u2019t needed, and rootkits are used to conceal malicious software and retain a foothold on compromised systems.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      30,
      26,
      29,
      27,
      28
    ],
    "source": "211418_Ch03"
  },
  {
    "id": 68,
    "question": "Matt uploads a malware sample to a third-party malware scanning site that uses multiple antimalware and antivirus engines to scan the sample. He receives multiple different answers for what the malware package is. What has occurred?",
    "choice_a": "The package contains more than one piece of malware.",
    "choice_b": "The service is misconfigured.",
    "choice_c": "The malware is polymorphic and changed while being tested.",
    "choice_d": "Different vendors use different names for malware packages.",
    "correct_answer": "D",
    "explanation": "One of the challenges security practitioners can face when attempting to identify malware is that different antivirus and antimalware vendors will name malware packages and families differently. This means that Matt may need to look at different names to figure out what he is dealing with.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      244,
      28,
      29,
      31,
      27
    ],
    "source": "211418_Ch03"
  },
  {
    "id": 69,
    "question": "Nancy is concerned that there is a software keylogger on the system she\u2019s investigating. What best describes data that may have been stolen?",
    "choice_a": "All files on the system",
    "choice_b": "All keyboard input",
    "choice_c": "All files the user accessed while the keylogger was active",
    "choice_d": "Keyboard and other input from the user",
    "correct_answer": "D",
    "explanation": "While keyloggers often focus on keyboard input, other types of input may also be captured, meaning Nancy should worry about any user input that occurred while the keylogger was installed. Keyloggers typically do not target files on systems, although if Nancy finds a keylogger, she may want to check for other malware packages with additional capabilities.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      30,
      25,
      29,
      28,
      244
    ],
    "source": "211418_Ch03"
  },
  {
    "id": 70,
    "question": "A system in Elaine\u2019s company has suddenly displayed a message demanding payment in Bitcoin and claiming that the data from the system has been encrypted. What type of malware has Elaine likely encountered?",
    "choice_a": "Worms",
    "choice_b": "A virus",
    "choice_c": "Ransomware",
    "choice_d": "Rootkit",
    "correct_answer": "C",
    "explanation": "Ransomware demands payment to be made while typically using encryption to make data inaccessible. Worms, viruses, and rootkits are not defined by behavior like this.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      25,
      28,
      27,
      29,
      30
    ],
    "source": "211418_Ch03"
  },
  {
    "id": 71,
    "question": "Rick believes that a system he is responsible for has been compromised with malware that uses a rootkit to obtain and retain access to the system. When he runs an antimalware tool\u2019s scanner, the system doesn\u2019t show any malware. If he has other data that indicates the system is infected, what should his next step be if he wants to determine what malware may be on the system?",
    "choice_a": "Rerun the antimalware scan.",
    "choice_b": "Mount the drive on another system and scan it that way.",
    "choice_c": "Disable the systems antivirus because it may be causing a false negative.",
    "choice_d": "The system is not infected and he should move on.",
    "correct_answer": "B",
    "explanation": "Rootkits are designed to hide from antimalware scanners and can often defeat locally run scans. Mounting the drive in another system in read-only mode or booting from a USB drive and scanning using a trusted, known good operating system can be an effective way to determine what malware is on a potentially infected system.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      29,
      28,
      30,
      31,
      184
    ],
    "source": "211418_Ch03"
  },
  {
    "id": 72,
    "question": "A recently terminated developer from Jaya\u2019s organization has contacted the organization claiming that they left code in an application that they wrote that will delete files and bring the application down if they are not employed by the company. What type of malware is this?",
    "choice_a": "Ransomware",
    "choice_b": "Extortionware",
    "choice_c": "A logic bomb",
    "choice_d": "A Trojan",
    "correct_answer": "C",
    "explanation": "Jaya\u2019s former employee is describing a logic bomb, malicious code that will cause harm when a trigger or specific action occurs. In this case, the former employee is claiming that the trigger is them not being employed at the company. Jaya will need to assess all of the code that the employee wrote to determine if a logic bomb exists. Ransomware is a type of malicious software that typically uses encryption to extort a ransom. Extortionware is not a commonly used term. Trojans appear to be useful or desirable software but contain malicious code.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      17,
      25,
      26,
      27,
      69
    ],
    "source": "211418_Ch03"
  },
  {
    "id": 73,
    "question": "Selah wants to ensure that malware is completely removed from a system. What should she do to ensure this?",
    "choice_a": "Run multiple antimalware tools and use them to remove all detections.",
    "choice_b": "Wipe the drive and reinstall from known good media.",
    "choice_c": "Use the delete setting in her antimalware software rather than the quarantine setting.",
    "choice_d": "There is no way to ensure the system is safe and it should be destroyed.",
    "correct_answer": "B",
    "explanation": "In most malware infection scenarios, wiping the drive and reinstalling from known good media is the best option available. If the malware has tools that can infect the system BIOS/UEFI, even this may not be sufficient, but BIOS/UEFI resident malware is relatively uncommon. Multiple antivirus and antimalware tools, even if they are set to delete malware, may still fail against unknown or advanced malware packages. Destroying systems is uncommon, expensive, and unlikely to be acceptable to most organizations as a means of dealing with a malware infection.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      29,
      28,
      184,
      26,
      27
    ],
    "source": "211418_Ch03"
  },
  {
    "id": 74,
    "question": "What is the key difference between a worm and a virus?",
    "choice_a": "What operating system they run on",
    "choice_b": "How they spread",
    "choice_c": "What their potential impact is",
    "choice_d": "The number of infections",
    "correct_answer": "B",
    "explanation": "The key difference between worms and viruses is how they spread. Worms spread themselves, whereas viruses rely on human interaction.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      27,
      28,
      32,
      19,
      34
    ],
    "source": "211418_Ch03"
  },
  {
    "id": 75,
    "question": "Ben wants to analyze Python code that he believes may be malicious code written by an employee of his organization. What can he do to determine if the code is malicious?",
    "choice_a": "Run a decompiler against it to allow him to read the code",
    "choice_b": "Open the file using a text editor to review the code",
    "choice_c": "Test the code using an antivirus tool",
    "choice_d": "Submit the Python code to a malware testing website",
    "correct_answer": "B",
    "explanation": "Python is an interpreted rather than a compiled language, so Ben doesn\u2019t need to use a decompiler. Instead, his best bet is to open the file and review the code to see what it does. Since it was written by an employee, it is unlikely that it will match an existing known malicious package, which means antivirus and antimalware tools and sites will be useless.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      69,
      88,
      17,
      87,
      71
    ],
    "source": "211418_Ch03"
  },
  {
    "id": 76,
    "question": "Which of the following defenses is most likely to prevent Trojan installation?",
    "choice_a": "Installing patches for known vulnerabilities",
    "choice_b": "Preventing downloads from application stores",
    "choice_c": "Preventing the use of USB drives",
    "choice_d": "Disabling autorun from USB drives",
    "correct_answer": "B",
    "explanation": "Trojans are often found in application stores where they appear to be innocuous but desirable applications or are listed in confusingly similar ways to legitimate applications. Many organizations choose to lock down the ability to acquire applications from app stores to prevent this type of issue. Since Trojans do not self-spread and rely on user action, patching typically won\u2019t prevent them. While users may try to transfer files via USB, this isn\u2019t the most common means for modern Trojans to spread.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      26,
      25,
      32,
      19,
      31
    ],
    "source": "211418_Ch03"
  },
  {
    "id": 77,
    "question": "Jason\u2019s security team reports that a recent WordPress vulnerability seems to have been exploited by malware and that their organization\u2019s entire WordPress service cluster has been infected. What type of malware is most likely involved if a vulnerability in the software was exploited over the network?",
    "choice_a": "A logic bomb",
    "choice_b": "A Trojan",
    "choice_c": "A worm",
    "choice_d": "A rootkit",
    "correct_answer": "C",
    "explanation": "Worms often spread via networks, taking advantage of vulnerabilities to install themselves on targeted systems and then to propagate further. Trojans require human interaction to install software that appears desirable. Logic bombs are embedded in code and perform actions when triggers like a date or event occur. Rootkits are used to hide malware and to conceal attacker\u2019s actions.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      27,
      26,
      28,
      31,
      29
    ],
    "source": "211418_Ch03"
  },
  {
    "id": 78,
    "question": "Hui\u2019s organization recently purchased new Windows computers from an office supply store. The systems have a number of unwanted programs on them that load at startup that were installed by the manufacturer. What type of software is this?",
    "choice_a": "Viruses",
    "choice_b": "Trojans",
    "choice_c": "Spyware",
    "choice_d": "Bloatware",
    "correct_answer": "D",
    "explanation": "Unwanted, typically preinstalled programs are known as bloatware. They take up space and resources without providing value, and many organizations either uninstall them or install clean operating system images to avoid them. There is no indication of malicious activity in the question, so these are most likely not viruses, Trojans, or spyware.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      28,
      26,
      29,
      202,
      183
    ],
    "source": "211418_Ch03"
  },
  {
    "id": 79,
    "question": "What type of malware connects to a command and control system, allowing attackers to manage, control, and update it remotely?",
    "choice_a": "A bot",
    "choice_b": "A drone",
    "choice_c": "A vampire",
    "choice_d": "A worm",
    "correct_answer": "A",
    "explanation": "Bots connect to command and control (C&C) systems, allowing them to be updated, controlled, and managed remotely. Worms spread via vulnerabilities, and drones and vampires aren\u2019t common terms for malware.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      31,
      26,
      29,
      28,
      27
    ],
    "source": "211418_Ch03"
  },
  {
    "id": 80,
    "question": "Randy believes that a system that he is responsible for was infected after a user picked up a USB drive and plugged it in. The user claims that they only opened one file on the drive to see who might own it. What type of malware is most likely involved?",
    "choice_a": "A virus",
    "choice_b": "A worm",
    "choice_c": "A trojan",
    "choice_d": "A spyware tool",
    "correct_answer": "A",
    "explanation": "Randy knows that viruses spread through user interaction with files on thumb drives. A worm would spread itself, a Trojan would look like a useful or desirable file, and there is no indication of spyware in the question.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      28,
      26,
      27,
      30,
      31
    ],
    "source": "211418_Ch03"
  },
  {
    "id": 81,
    "question": "Joseph receives an email notifying him that he needs to change his password due to a recent account issue. He notices that the email links him to a website using the domain amaz0n.com. What type of attack should he describe this as?",
    "choice_a": "Typosquatting",
    "choice_b": "Phishing",
    "choice_c": "Smishing",
    "choice_d": "A watering hole attack",
    "correct_answer": "B",
    "explanation": "This email is an attempt to get account information and is a phishing email. Joseph did not enter the URL himself, which is the behavior that a typosquatter relies on. A smishing attack relies on SMS, and a watering hole attack uses a frequently visited website.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      33,
      34,
      36,
      75,
      73
    ],
    "source": "211418_Ch04"
  },
  {
    "id": 82,
    "question": "When you combine phishing with voicemail, it is known as:",
    "choice_a": "Whaling",
    "choice_b": "Spoofing",
    "choice_c": "Spooning",
    "choice_d": "Vishing",
    "correct_answer": "D",
    "explanation": "Vishing is a form of phishing done via voice phones call or voicemail. Whaling focuses on targeting important targets for phishing attacks, whereas spoofing is a general term that means faking things. Spooning is not a technical term used for security practices.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      33,
      34,
      19,
      25,
      14
    ],
    "source": "211418_Ch04"
  },
  {
    "id": 83,
    "question": "While reviewing her logs, Michele notices that a remote system has attempted to log into her server via SSH using the username admin and a variety of passwords like \u201cpassword\u201d and \u201cninja.\u201d What type of attack has Michele noticed?",
    "choice_a": "A brute-force attack",
    "choice_b": "Shoulder surfing",
    "choice_c": "An on-path attack",
    "choice_d": "Pretexting",
    "correct_answer": "A",
    "explanation": "Michele has discovered a brute-force attack, which relies on trying a large number of passwords, often combined with a list of usernames to try. Shoulder surfing attacks involve an attacker watching as a user enters information like a password or credit card data. On-path attacks intercept data sent via a network, and pretexting is a social engineering attack that relies on a believable reason for attackers to need a victim to take action.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      37,
      73,
      32,
      226,
      34
    ],
    "source": "211418_Ch04"
  },
  {
    "id": 84,
    "question": "Joanna wants to detect password spraying attacks. What type of rule should she deploy through her security systems?",
    "choice_a": "Match attempts to log into many systems with the same username and password.",
    "choice_b": "Match multiple attempts to log into the same user account using different passwords.",
    "choice_c": "Match repeated use of the same password during failed login attempts for multiple usernames.",
    "choice_d": "Match all attempts to use passwords with slight changes for the same account.",
    "correct_answer": "C",
    "explanation": "Password spraying involves the use of the same password to attempt to log into multiple accounts. Joanna should search for uses of the same password for different accounts.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      37,
      244,
      73,
      38,
      221
    ],
    "source": "211418_Ch04"
  },
  {
    "id": 85,
    "question": "One of the staff at Susan\u2019s organization has reported that a critical vendor has contacted them about an unpaid invoice. After Susan investigates, she discovers that the invoice was sent from an email account that was not typically a contact and that the invoice requested payment to a PayPal account. What type of social engineering attack has Susan most likely discovered?",
    "choice_a": "Smishing",
    "choice_b": "Business email compromise",
    "choice_c": "Disinformation",
    "choice_d": "Typosquatting",
    "correct_answer": "B",
    "explanation": "Susan has most likely discovered a business email compromise and should reach out to the impacted organization to inform them of the potentially compromised account. Smishing would occur via SMS, there is nothing in the question to indicate a disinformation campaign was part of this, and there is no URL mentioned and thus typosquatting can be dismissed as well.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      34,
      33,
      32,
      35,
      36
    ],
    "source": "211418_Ch04"
  },
  {
    "id": 86,
    "question": "Selah infects the ads on a website that users from her target company frequently visit with malware as part of her penetration test. What technique has she used?",
    "choice_a": "A watering hole attack",
    "choice_b": "Vishing",
    "choice_c": "Whaling",
    "choice_d": "Typosquatting",
    "correct_answer": "A",
    "explanation": "Watering hole attacks rely on compromising or infecting a website that targeted users frequently visit, much like animals will visit a common watering hole. Vishing is phishing via voice, whaling is a targeted phishing attack against senior or important staff, and typosquatting registers similar URLs that are likely to be inadvertently entered in order to harvest clicks or conduct malicious activity.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      36,
      33,
      13,
      19,
      25
    ],
    "source": "211418_Ch04"
  },
  {
    "id": 87,
    "question": "Ben wants to determine if brute-force password attacks are being used against his company. What log information is least likely to be useful when working to detect brute-force attacks?",
    "choice_a": "Source IP address or hostname",
    "choice_b": "Failed login logs",
    "choice_c": "The password that was used for each attempt",
    "choice_d": "The geographic location of system being logged into",
    "correct_answer": "D",
    "explanation": "The source IP or hostname; the failed login logs with time, date, username, and other information; and the password that was used for each failed attempt would be useful for watching for brute-force attempts. Knowing where the system being logged into is located isn\u2019t useful when tracking brute-force attempts. Logging failed passwords can be problematic as it can reveal actual passwords by allowing log reviewers to see failures driven by typos, so Ben may want to avoid that sort of log even though it can be useful!",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      37,
      73,
      244,
      38,
      39
    ],
    "source": "211418_Ch04"
  },
  {
    "id": 88,
    "question": "Melissa receives a call and the caller informs her a senior manager in her organization needs her to buy gift cards for an event that starts in an hour. The caller says that the senior leader forgot to get the cards, and that the event is critical to her organization. Melissa buys the cards and sends them to the Gmail address the caller says that the senior leader needs them sent to. What type of attack has Melissa fallen for?",
    "choice_a": "Phishing",
    "choice_b": "Pretexting",
    "choice_c": "Business email compromise",
    "choice_d": "Carding",
    "correct_answer": "B",
    "explanation": "The caller is using pretexting, providing Melissa with a story that relies on urgency and perceived authority to get her to take actions she might normally question. This social engineering attack is not a phishing attack aimed at gathering information or credentials, it does not involve business email accounts being compromised, and carding is not a topic covered in the Security+ exam outline.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      32,
      34,
      33,
      73,
      35
    ],
    "source": "211418_Ch04"
  },
  {
    "id": 89,
    "question": "Alaina wants to determine if a password spraying attack was used against her organization. Which of the following indicators would be most useful as part of her investigation?",
    "choice_a": "The time the login attempts happened",
    "choice_b": "The passwords used for failed attempts",
    "choice_c": "The source IP address of the attempts",
    "choice_d": "The number of failed attempts for each user",
    "correct_answer": "B",
    "explanation": "Password spraying attempts try to use a single common password for many user accounts. Determining if a single password is being used over and over can help catch basic password spraying attempts. The time, source IP, or number of failed attempts do not indicate password spraying.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      37,
      244,
      73,
      38,
      125
    ],
    "source": "211418_Ch04"
  },
  {
    "id": 90,
    "question": "Which of the following human vectors is primarily associated with nation-state actors?",
    "choice_a": "Misinformation campaigns",
    "choice_b": "Watering hole attacks",
    "choice_c": "Business email compromise",
    "choice_d": "Password spraying",
    "correct_answer": "A",
    "explanation": "Misinformation and disinformation campaigns are primarily associated with nation-state actors, but are increasingly used by other organizations and even individuals as well. Watering hole attacks, business email compromise, and password spraying are broadly used attacks.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      35,
      16,
      33,
      34,
      36
    ],
    "source": "211418_Ch04"
  },
  {
    "id": 91,
    "question": "Nicole accidentally types <code>www.smazon.com</code> into her browser and discovers that she is directed to a different site loaded with ads and pop-ups. Which of the following is the most accurate description of the attack she has experienced?",
    "choice_a": "DNS hijacking",
    "choice_b": "Pharming",
    "choice_c": "Typosquatting",
    "choice_d": "Hosts file compromise",
    "correct_answer": "C",
    "explanation": "Typosquatting uses misspellings and common typos of websites to redirect traffic for profit or malicious reasons. Fortunately in reality, if you visit smazon.com, you\u2019ll be redirected to the actual amazon.com website, as Amazon knows about and works to prevent this type of issue. DNS hijacking and hosts file modifications both attempt to redirect traffic to actual URLs or hostnames to different destinations, and pharming does redirect legitimate traffic to fake sites, but typosquatting is the more specific answer.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      36,
      227,
      75,
      34,
      82
    ],
    "source": "211418_Ch04"
  },
  {
    "id": 92,
    "question": "Devon is a penetration tester and sets up malicious tools on his target organization\u2019s primary internal website. What type of attack is he conducting?",
    "choice_a": "A misinformation campaign",
    "choice_b": "A watering hole attack",
    "choice_c": "A typosquatting attack",
    "choice_d": "A disinformation campaign",
    "correct_answer": "B",
    "explanation": "Devon is conducting a watering hole attack that leverages a frequently visited site to deploy malware. There is no description of misinformation or disinformation in the question, and there is not a typo described that would lead to a typosquatting attack being successful.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      36,
      13,
      19,
      35,
      82
    ],
    "source": "211418_Ch04"
  },
  {
    "id": 93,
    "question": "Phishing emails sent pretending to be from a company that recipients are familiar with and likely to respond to is what type of attack?",
    "choice_a": "Phishing",
    "choice_b": "Pharming",
    "choice_c": "Brand impersonation",
    "choice_d": "Pretexting",
    "correct_answer": "C",
    "explanation": "Brand impersonation attacks are designed to appear to be from a company that recipients are likely to be familiar with, and thus are more likely to elicit a response. While these are a type of phishing, the more specific answer of brand impersonation is the best answer. Pretexting is a social engineering concept that provides a reason for the request. Pharming attacks redirect traffic intended to be sent to a legitimate site to a fake website typically designed to simulate the real one.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      34,
      33,
      32,
      19,
      25
    ],
    "source": "211418_Ch04"
  },
  {
    "id": 94,
    "question": "When a caller was recently directed to Amanda, who is a junior IT employee at her company, the caller informed her that they were the head of IT for her organization and that she needed to immediately disable the organization\u2019s firewall. After Amanda made the change, she discovered that the caller was not the head of IT, and that they were actually a penetration tester hired by her company. What social engineering attack best describes this?",
    "choice_a": "Smishing",
    "choice_b": "Pretexting",
    "choice_c": "Impersonation",
    "choice_d": "Vishing",
    "correct_answer": "C",
    "explanation": "This is an example of an impersonation attack. The pentester impersonated the head of IT in order to achieve their goals. The good news is that it was a penetration tester! Smishing is phishing via SMS, vishing is phishing via voice or voicemail, and pretexting provides a reason that the target should perform an action. Here the attack relied on the authority that Amanda believed the caller had.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      32,
      33,
      34,
      13,
      19
    ],
    "source": "211418_Ch04"
  },
  {
    "id": 95,
    "question": "Fred is concerned about text message\u2013based attacks. Which of the following attacks relies on text messages as its primary focus?",
    "choice_a": "Impersonation",
    "choice_b": "Watering hole attacks",
    "choice_c": "Smishing",
    "choice_d": "Business email compromise",
    "correct_answer": "C",
    "explanation": "Smishing attacks are SMS-based. Impersonation attacks could use texts but don\u2019t specifically rely on them. Watering hole attacks use frequently visited websites, whereas business email compromise attacks focus on gaining access to business email accounts to use in follow-up attacks.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      33,
      32,
      19,
      34,
      36
    ],
    "source": "211418_Ch04"
  },
  {
    "id": 96,
    "question": "Sharif notices that his authentication logs have many different usernames showing failed logins with the same password. What type of attack has he discovered?",
    "choice_a": "Credential harvesting",
    "choice_b": "Impersonation",
    "choice_c": "BEC",
    "choice_d": "Spraying",
    "correct_answer": "D",
    "explanation": "Sharif has discovered a spraying attack that uses the same password\u2014often a default or common password\u2014with many usernames. Credential harvesting is the process of gathering credentials like usernames and passwords. Impersonation is a social engineering technique used when an attacker pretends to be someone else. BEC, or business email compromise, involves attackers posing as a trusted individual and asking for actions to be performed.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      37,
      73,
      34,
      32,
      244
    ],
    "source": "211418_Ch04"
  },
  {
    "id": 97,
    "question": "Naomi receives a report of smishing. What type of attack should she be looking for?",
    "choice_a": "Compressed files in phishing",
    "choice_b": "Text message\u2013based phishing",
    "choice_c": "Voicemail-based phishing",
    "choice_d": "Server-based phishing",
    "correct_answer": "B",
    "explanation": "Smishing is a type of phishing that occurs via text (SMS) message.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      33,
      19,
      25,
      244,
      36
    ],
    "source": "211418_Ch04"
  },
  {
    "id": 98,
    "question": "Jack\u2019s organization wants to prevent typosquatting. What option should he select to address this issue?",
    "choice_a": "Copyright the domain name",
    "choice_b": "Purchase the most common typos for his organization\u2019s domain",
    "choice_c": "Trademark the domain name",
    "choice_d": "Disable typo resolution for the domain",
    "correct_answer": "B",
    "explanation": "While it\u2019s nearly impossible to prevent typosquatting, purchasing and registering the most common typos (typo-domains) related to your organization\u2019s domain and redirecting them to your real domain is the most effective option available. Copyrighting or trademarking the domain name does not prevent typosquatting, and typo resolution is not a feature or capability that is available.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      36,
      34,
      75,
      221,
      32
    ],
    "source": "211418_Ch04"
  },
  {
    "id": 99,
    "question": "Gwyne\u2019s company has been contacted by customers asking about a new social media account operating under the company\u2019s brand. The social media account is advertising cryptocurrency, which Gwyne\u2019s organization does not sell or work with. What type of attack best describes what Gwyne\u2019s organization has encountered?",
    "choice_a": "Impersonation",
    "choice_b": "Brand impersonation",
    "choice_c": "Mis-branding",
    "choice_d": "Crypto-phishing",
    "correct_answer": "B",
    "explanation": "Using an organization\u2019s brand in this way is an example of brand impersonation. While this is also an impersonation attack, the more specific description is the best answer here. Misbranding and crypto-phishing were both made up for this question and aren\u2019t commonly used terms.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      34,
      35,
      19,
      32,
      245
    ],
    "source": "211418_Ch04"
  },
  {
    "id": 100,
    "question": "Nation-state-driven social media campaigns about the trustworthiness of the U.S. election in 2016 are an example of what type of social engineering?",
    "choice_a": "Smishing",
    "choice_b": "Pretexting",
    "choice_c": "Disinformation",
    "choice_d": "Spraying",
    "correct_answer": "C",
    "explanation": "Disinformation campaigns are used to shift public opinion or to accomplish other goals. They are not limited to nation-state actors but are an increasingly heavily used social engineering tactic at a broad scale. Smishing relies on SMS messages, pretexting involves using a reason that creates urgency or importance in a request from a social engineer, and spraying is a type of password brute forcing.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      35,
      32,
      16,
      34,
      12
    ],
    "source": "211418_Ch04"
  },
  {
    "id": 101,
    "question": "Which one of the following security assessment techniques assumes that an organization has already been compromised and searches for evidence of that compromise?",
    "choice_a": "Vulnerability scanning",
    "choice_b": "Penetration testing",
    "choice_c": "Threat hunting",
    "choice_d": "War driving",
    "correct_answer": "C",
    "explanation": "Threat hunting is an assessment technique that makes an assumption of compromise and then searches the organization for indicators of compromise that confirm the assumption. Vulnerability scanning, penetration testing, and war driving are all assessment techniques that probe for vulnerabilities but do not assume that a compromise has already taken place.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      62,
      59,
      60,
      43,
      44
    ],
    "source": "211418_Ch05"
  },
  {
    "id": 102,
    "question": "Renee is configuring her vulnerability management solution to perform credentialed scans of servers on her network. What type of account should she provide to the scanner?",
    "choice_a": "Domain administrator",
    "choice_b": "Local administrator",
    "choice_c": "Root",
    "choice_d": "Read-only",
    "correct_answer": "D",
    "explanation": "Credentialed scans only require read-only access to target servers. Renee should follow the principle of least privilege and limit the access available to the scanner.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      148,
      143,
      144,
      43,
      42
    ],
    "source": "211418_Ch05"
  },
  {
    "id": 103,
    "question": "Ryan is planning to conduct a vulnerability scan of a business-critical system using dangerous plug-ins. What would be the best approach for the initial scan?",
    "choice_a": "Run the scan against production systems to achieve the most realistic results possible.",
    "choice_b": "Run the scan during business hours.",
    "choice_c": "Run the scan in a test environment.",
    "choice_d": "Do not run the scan to avoid disrupting the business.",
    "correct_answer": "C",
    "explanation": "Ryan should first run his scan against a test environment to identify likely vulnerabilities and assess whether the scan itself might disrupt business activities.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      65,
      42,
      40,
      63,
      47
    ],
    "source": "211418_Ch05"
  },
  {
    "id": 104,
    "question": "Which one of the following values for the CVSS attack complexity metric would indicate that the specified attack is simplest to exploit?",
    "choice_a": "High",
    "choice_b": "Medium",
    "choice_c": "Low",
    "choice_d": "Severe",
    "correct_answer": "C",
    "explanation": "An attack complexity of \u201clow\u201d indicates that exploiting the vulnerability does not require any specialized conditions.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      46,
      47,
      63,
      41,
      44
    ],
    "source": "211418_Ch05"
  },
  {
    "id": 105,
    "question": "Tara recently analyzed the results of a vulnerability scan report and found that a vulnerability reported by the scanner did not exist because the system was actually patched as specified. What type of error occurred?",
    "choice_a": "False positive",
    "choice_b": "False negative",
    "choice_c": "True positive",
    "choice_d": "True negative",
    "correct_answer": "A",
    "explanation": "A false positive error occurs when the vulnerability scanner reports a vulnerability that does not actually exist.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      48,
      43,
      47,
      49,
      63
    ],
    "source": "211418_Ch05"
  },
  {
    "id": 106,
    "question": "Brian ran a penetration test against a school\u2019s grading system and discovered a flaw that would allow students to alter their grades by exploiting a SQL injection vulnerability. What type of control should he recommend to the school\u2019s cybersecurity team to prevent students from engaging in this type of activity?",
    "choice_a": "Confidentiality",
    "choice_b": "Integrity",
    "choice_c": "Alteration",
    "choice_d": "Availability",
    "correct_answer": "B",
    "explanation": "By allowing students to change their own grades, this vulnerability provides a pathway to unauthorized alteration of information. Brian should recommend that the school deploy integrity controls that prevent unauthorized modifications.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      85,
      148,
      143,
      65,
      60
    ],
    "source": "211418_Ch05"
  },
  {
    "id": 107,
    "question": "Which one of the following security assessment tools is least likely to be used during the reconnaissance phase of a penetration test?",
    "choice_a": "Nmap",
    "choice_b": "Nessus",
    "choice_c": "Metasploit",
    "choice_d": "Nslookup",
    "correct_answer": "C",
    "explanation": "Nmap is a port scanning tool used to enumerate open network ports on a system. Nessus is a vulnerability scanner designed to detect security issues on a system. Nslookup is a DNS information gathering utility. All three of these tools may be used to gather information and detect vulnerabilities. Metasploit is an exploitation framework used to execute and attack and would be better suited for the Attacking and Exploiting phase of a penetration test.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      59,
      60,
      49,
      42,
      52
    ],
    "source": "211418_Ch05"
  },
  {
    "id": 108,
    "question": "During a vulnerability scan, Brian discovered that a system on his network contained this vulnerability:<img src=\"/question_assets/Security+/c05uf001.png\"/> What security control, if deployed, would likely have addressed this issue?",
    "choice_a": "Patch management",
    "choice_b": "File integrity monitoring",
    "choice_c": "Intrusion detection",
    "choice_d": "Threat hunting",
    "correct_answer": "A",
    "explanation": "This vulnerability is corrected by a patch that was released by Microsoft in 2017. A strong patch management program would have identified and remediated the missing patch.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      197,
      51,
      63,
      47,
      45
    ],
    "source": "211418_Ch05"
  },
  {
    "id": 109,
    "question": "Which one of the following tools is most likely to detect an XSS vulnerability?",
    "choice_a": "Static application test",
    "choice_b": "Web application vulnerability scanner",
    "choice_c": "Intrusion detection system",
    "choice_d": "Network vulnerability scanner",
    "correct_answer": "B",
    "explanation": "Intrusion detection systems do not detect vulnerabilities; they detect attacks. The remaining three tools could all possibly discover a cross-site scripting (XSS) vulnerability, but a web application vulnerability scanner is the most likely to detect it because it is specifically designed to test web applications.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      49,
      42,
      43,
      48,
      219
    ],
    "source": "211418_Ch05"
  },
  {
    "id": 110,
    "question": "During a penetration test, Patrick deploys a toolkit on a compromised system and uses it to gain access to other systems on the same network. What term best describes this activity?",
    "choice_a": "Lateral movement",
    "choice_b": "Privilege escalation",
    "choice_c": "Footprinting",
    "choice_d": "OSINT",
    "correct_answer": "A",
    "explanation": "Moving from one compromised system to other systems on the same network is known as lateral movement. Privilege escalation attacks increase the level of access that an attacker has to an already compromised system. Footprinting and OSINT are reconnaissance techniques.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      60,
      59,
      55,
      62,
      63
    ],
    "source": "211418_Ch05"
  },
  {
    "id": 111,
    "question": "Zian is a cybersecurity leader who is coordinating the activities of a security audit. The audit is being done to validate the organization\u2019s financial statements to investors and involves a review of cybersecurity controls. What term best describes this audit?",
    "choice_a": "External audit",
    "choice_b": "Penetration test",
    "choice_c": "Internal audit",
    "choice_d": "Informal audit",
    "correct_answer": "A",
    "explanation": "Audits performed to validate an organization\u2019s financial statements are very formal audits that are performed by independent third-party auditors. This makes them external audits. Internal audits may be more or less formal than external audits but they are generally done only to provide assurance to internal parties and not to investors. Penetration tests may be done as part of an audit but they are not audits themselves.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      293,
      292,
      287,
      288,
      296
    ],
    "source": "211418_Ch05"
  },
  {
    "id": 112,
    "question": "Which one of the following assessment techniques is designed to solicit participation from external security experts and reward them for discovering vulnerabilities?",
    "choice_a": "Threat hunting",
    "choice_b": "Penetration testing",
    "choice_c": "Bug bounty",
    "choice_d": "Vulnerability scanning",
    "correct_answer": "C",
    "explanation": "Bug bounty programs are designed to allow external security experts to test systems and uncover previously unknown vulnerabilities. Bug bounty programs offer successful testers financial rewards to incentivize their participation.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      61,
      58,
      288,
      290,
      310
    ],
    "source": "211418_Ch05"
  },
  {
    "id": 113,
    "question": "Kyle is conducting a penetration test. After gaining access to an organization\u2019s database server, he installs a backdoor on the server to grant himself access in the future. What term best describes this action?",
    "choice_a": "Privilege escalation",
    "choice_b": "Lateral movement",
    "choice_c": "Maneuver",
    "choice_d": "Persistence",
    "correct_answer": "D",
    "explanation": "Backdoors are a persistence tool, designed to make sure that the attacker\u2019s access persists after the original vulnerability is remediated. Kyle can use this backdoor to gain access to the system in the future, even if the original exploit that he used to gain access is no longer effective.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      60,
      59,
      62,
      240,
      250
    ],
    "source": "211418_Ch05"
  },
  {
    "id": 114,
    "question": "Which one of the following techniques would be considered passive reconnaissance?",
    "choice_a": "Port scans",
    "choice_b": "Vulnerability scans",
    "choice_c": "WHOIS lookups",
    "choice_d": "Footprinting",
    "correct_answer": "C",
    "explanation": "WHOIS lookups use external registries and are an example of open source intelligence (OSINT), which is a passive reconnaissance technique. Port scans, vulnerability scans, and footprinting all require active engagement with the target and are, therefore, active reconnaissance.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      57,
      61,
      58,
      303,
      304
    ],
    "source": "211418_Ch05"
  },
  {
    "id": 115,
    "question": "Which element of the SCAP framework can be used to consistently describe vulnerabilities?",
    "choice_a": "CPE",
    "choice_b": "CVE",
    "choice_c": "CVSS",
    "choice_d": "CCE",
    "correct_answer": "B",
    "explanation": "Common Vulnerabilities and Exposures (CVE) provides a standard nomenclature for describing security-related software flaws. Common Platform Enumeration (CPE) provides a standard nomenclature for describing product names and versions. The Common Vulnerability Scoring System (CVSS) provides a standardized approach for measuring and describing the severity of security-related software flaws. Common Configuration Enumeration (CCE) provides a standard nomenclature for discussing system configuration issues.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      50,
      63,
      46,
      47,
      42
    ],
    "source": "211418_Ch05"
  },
  {
    "id": 116,
    "question": "Bruce is conducting a penetration test for a client. The client provided him with full details of their systems in advance. What type of test is Bruce conducting?",
    "choice_a": "Partially known environment test",
    "choice_b": "Detailed environment test",
    "choice_c": "Known environment test",
    "choice_d": "Unknown environment test",
    "correct_answer": "C",
    "explanation": "Known environment tests are performed with full knowledge of the underlying technology, configurations, and settings that make up the target. Unknown environment tests are intended to replicate what an attacker would encounter. Testers are not provided with access to or information about an environment, and instead, they must gather information, discover vulnerabilities, and make their way through an infrastructure or systems like an attacker would. Partially known environment tests are a blend of unknown environment and known environment testing. Detailed environment tests are not a type of penetration test.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      57,
      58,
      61,
      288,
      290
    ],
    "source": "211418_Ch05"
  },
  {
    "id": 117,
    "question": "Lila is working on a penetration testing team and she is unsure whether she is allowed to conduct social engineering as part of the test. What document should she consult to find this information?",
    "choice_a": "Contract",
    "choice_b": "Statement of work",
    "choice_c": "Rules of engagement",
    "choice_d": "Lessons learned report",
    "correct_answer": "C",
    "explanation": "The rules of engagement provide technical details on the parameters of the test. This level of detail would not normally be found in a contract or statement of work (SOW). The lessons learned report is not produced until after the test.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      57,
      58,
      288,
      275,
      276
    ],
    "source": "211418_Ch05"
  },
  {
    "id": 118,
    "question": "Grace would like to determine the operating system running on a system that she is targeting in a penetration test. Which one of the following techniques will most directly provide her with this information?",
    "choice_a": "Port scanning",
    "choice_b": "Footprinting",
    "choice_c": "Vulnerability scanning",
    "choice_d": "Packet capture",
    "correct_answer": "B",
    "explanation": "All of these techniques might provide Grace with information about the operating system running on a device. However, footprinting is a technique specifically designed to elicit this information.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      59,
      60,
      55,
      56,
      40
    ],
    "source": "211418_Ch05"
  },
  {
    "id": 119,
    "question": "Kevin recently identified a new security vulnerability and computed its CVSS base score as 6.5. Which risk category would this vulnerability fall into?",
    "choice_a": "Low",
    "choice_b": "Medium",
    "choice_c": "High",
    "choice_d": "Critical",
    "correct_answer": "B",
    "explanation": "Vulnerabilities with CVSS base scores between 4.0 and 6.9 fit into the medium risk category. Vulnerability scores between 0.1 and 3.9 would be low, between 7.0 and 8.9 would be high, and those between 9.0 and 10.0 would be in the critical risk category.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      306,
      310,
      309,
      307,
      313
    ],
    "source": "211418_Ch05"
  },
  {
    "id": 120,
    "question": "Which one of the CVSS metrics would contain information about the type of account access that an attacker must have to execute an attack?",
    "choice_a": "AV",
    "choice_b": "C",
    "choice_c": "PR",
    "choice_d": "AC",
    "correct_answer": "C",
    "explanation": "The privileges required (PR) metric indicates the type of system access that an attacker must have to execute the attack.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      46,
      63,
      50,
      143,
      145
    ],
    "source": "211418_Ch05"
  },
  {
    "id": 121,
    "question": "Adam is conducting software testing by reviewing the source code of the application. What type of code testing is Adam conducting?",
    "choice_a": "Mutation testing",
    "choice_b": "Static code analysis",
    "choice_c": "Dynamic code analysis",
    "choice_d": "Fuzzing",
    "correct_answer": "B",
    "explanation": "Adam is conducting static code analysis by reviewing the source code. Dynamic code analysis requires running the program, and both mutation testing and fuzzing are types of dynamic analysis.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      49,
      66,
      85,
      65,
      63
    ],
    "source": "211418_Ch06"
  },
  {
    "id": 122,
    "question": "Charles is worried about users conducting SQL injection attacks. Which of the following solutions will best address his concerns?",
    "choice_a": "Using secure session management",
    "choice_b": "Enabling logging on the database",
    "choice_c": "Performing user input validation",
    "choice_d": "Implementing TLS",
    "correct_answer": "C",
    "explanation": "Charles should perform user input validation to strip out any SQL code or other unwanted input. Secure session management can help prevent session hijacking, logging may provide useful information for incident investigation, and implementing TLS can help protect network traffic, but only input validation helps with the issue described.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      83,
      67,
      70,
      72,
      84
    ],
    "source": "211418_Ch06"
  },
  {
    "id": 123,
    "question": "Precompiled SQL statements that only require variables to be input are an example of what type of application security control?",
    "choice_a": "Parameterized queries",
    "choice_b": "Encoding data",
    "choice_c": "Input validation",
    "choice_d": "Appropriate access controls",
    "correct_answer": "A",
    "explanation": "A parameterized query (sometimes called a prepared statement) uses a prebuilt SQL statement to prevent SQL-based attacks. Variables from the application are fed to the query, rather than building a custom query when the application needs data. Encoding data helps to prevent cross-site scripting attacks, as does input validation. Appropriate access controls can prevent access to data that the account or application should not have access to, but they don\u2019t use precompiled SQL statements. Stored procedures are an example of a parameterized query implementation.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      49,
      191,
      86,
      145,
      92
    ],
    "source": "211418_Ch06"
  },
  {
    "id": 124,
    "question": "During a web application test, Ben discovers that the application shows SQL code as part of an error provided to application users. What should he note in his report?",
    "choice_a": "Improper error handling",
    "choice_b": "Code exposure",
    "choice_c": "SQL injection",
    "choice_d": "A default configuration issue",
    "correct_answer": "A",
    "explanation": "Improper error handling often exposes data to users and possibly attackers that should not be exposed. In this case, knowing what SQL code is used inside the application can provide an attacker with details they can use to conduct further attacks. Code exposure is not one of the vulnerabilities we discuss in this book, and SQL code being exposed does not necessarily mean that SQL injection is possible. While this could be caused by a default configuration issue, there is nothing in the question to point to that problem.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      87,
      67,
      70,
      72,
      83
    ],
    "source": "211418_Ch06"
  },
  {
    "id": 125,
    "question": "The application that Scott is writing has a flaw that occurs when two operations are attempted at the same time, resulting in unexpected results when the two actions do not occur in the expected order. What type of flaw does the application have?",
    "choice_a": "Dereferencing",
    "choice_b": "A race condition",
    "choice_c": "An insecure function",
    "choice_d": "Improper error handling",
    "correct_answer": "B",
    "explanation": "The application has a race condition, which occurs when multiple operations cause undesirable results due to their order of completion. De-referencing accesses or uses a memory pointer, an insecure function would have security issues in the function itself, and improper error handling would involve an error and how it was displayed or what data it provided.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      90,
      89,
      67,
      69,
      84
    ],
    "source": "211418_Ch06"
  },
  {
    "id": 126,
    "question": "Every time Susan checks code into her organization\u2019s code repository, it is tested and validated, and then if accepted, it is immediately put into production. What is the term for this?",
    "choice_a": "Continuous integration",
    "choice_b": "Continuous delivery",
    "choice_c": "A security nightmare",
    "choice_d": "Agile development",
    "correct_answer": "B",
    "explanation": "Although this example includes continuous integration, the key thing to notice is that the code is then deployed into production. This means that Susan is operating in a continuous deployment environment, where code is both continually integrated and deployed. Agile is a development methodology and often uses CI/CD, but we cannot determine if Susan is using Agile.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      66,
      178,
      65,
      85,
      92
    ],
    "source": "211418_Ch06"
  },
  {
    "id": 127,
    "question": "Tim is working on a change to a web application used by his organization to fix a known bug. What environment should he be working in?",
    "choice_a": "Test",
    "choice_b": "Development",
    "choice_c": "Staging",
    "choice_d": "Production",
    "correct_answer": "B",
    "explanation": "Developers working on active changes to code should always work in the development environment. The test environment is where the software or systems can be tested without impacting the production environment. The staging environment is a transition environment for code that has successfully cleared testing and is waiting to be deployed into production. The production environment is the live system. Software, patches, and other changes that have been tested and approved move to production.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      65,
      85,
      178,
      240,
      93
    ],
    "source": "211418_Ch06"
  },
  {
    "id": 128,
    "question": "Ricky is concerned that developers in his organization make use of third-party code in their applications, which may introduce unknown vulnerabilities. He is concerned about the risk of the organization running code that it is not aware it is using. Which one of the following activities would best address this risk?",
    "choice_a": "Web application firewalls",
    "choice_b": "Package monitoring",
    "choice_c": "Static analysis",
    "choice_d": "Dynamic analysis",
    "correct_answer": "B",
    "explanation": "All of the activities listed here may reduce the risk of the vulnerabilities created by the code. However, Ricky is specifically concerned about the fact that the organization may not be aware of all of the code that it is running. Package monitoring would inventory and monitor these third-party libraries, so that is the best answer here.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      290,
      287,
      304,
      309,
      310
    ],
    "source": "211418_Ch06"
  },
  {
    "id": 129,
    "question": "Which one of the following is not an advantage of automation in cybersecurity operations?",
    "choice_a": "Enforcing baselines",
    "choice_b": "Technical debt",
    "choice_c": "Employee retention",
    "choice_d": "Standardizing infrastructure configurations",
    "correct_answer": "B",
    "explanation": "The main benefits of automation are efficiency and time savings, enforcing baselines, standardizing infrastructure configurations, scaling in a secure manner, retaining employees, reducing reaction time, and serving as a workforce multiplier. Technical debt is one of the potential drawbacks of automation.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      93,
      92,
      91,
      50,
      63
    ],
    "source": "211418_Ch06"
  },
  {
    "id": 130,
    "question": "Chris is creating a script that will automatically screen any user requests and flag those that exceed normal thresholds for manual review. What term best describes this automation use case?",
    "choice_a": "User provisioning",
    "choice_b": "Guard rails",
    "choice_c": "Ticket creation",
    "choice_d": "Escalation",
    "correct_answer": "B",
    "explanation": "This is an example of the guard rails use case for automation. Cybersecurity professionals can use scripting to automatically review user actions and block any that are outside of normal parameters.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      92,
      93,
      91,
      248,
      249
    ],
    "source": "211418_Ch06"
  },
  {
    "id": 131,
    "question": "Which one of the following is not a common drawback of automating cybersecurity operations?",
    "choice_a": "Reducing employee satisfaction",
    "choice_b": "Creating single points of failure",
    "choice_c": "Costs",
    "choice_d": "Complexity",
    "correct_answer": "A",
    "explanation": "Automation normally increases employee retention. The common drawbacks to automation include complexity, cost, creating single points of failure, incurring technical debt, and creating challenges to ongoing supportability.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      93,
      91,
      92,
      257,
      144
    ],
    "source": "211418_Ch06"
  },
  {
    "id": 132,
    "question": "Frank is investigating a security incident where the attacker entered a very long string into an input field, which was followed by a system command. What type of attack likely took place?",
    "choice_a": "Cross-site request forgery",
    "choice_b": "Server-side request forgery",
    "choice_c": "Command injection",
    "choice_d": "Buffer overflow",
    "correct_answer": "D",
    "explanation": "Buffer overflow attacks occur when an attacker manipulates a program into placing more data into an area of memory than is allocated for that program\u2019s use. The goal is to overwrite other information in memory with instructions that may be executed by a different process running on the system.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      89,
      72,
      83,
      90,
      88
    ],
    "source": "211418_Ch06"
  },
  {
    "id": 133,
    "question": "What type of attack places an attacker in the position to eavesdrop on communications between a user and a web server?",
    "choice_a": "On-path attack",
    "choice_b": "Session hijacking",
    "choice_c": "Buffer overflow",
    "choice_d": "Meet-in-the-middle",
    "correct_answer": "A",
    "explanation": "In an on-path attack, the attacker fools the user into thinking that the attacker is actually the target website and presenting a fake authentication form. They may then authenticate to the website on the user\u2019s behalf and obtain the cookie. This is slightly different from a session hijacking attack, where the attacker steals the cookie associated with an active session.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      74,
      82,
      230,
      75,
      34
    ],
    "source": "211418_Ch06"
  },
  {
    "id": 134,
    "question": "Tom is a software developer who creates code for sale to the public. He would like to assure his users that the code they receive actually came from him. What technique can he use to best provide this assurance?",
    "choice_a": "Code signing",
    "choice_b": "Code endorsement",
    "choice_c": "Code encryption",
    "choice_d": "Code obfuscation",
    "correct_answer": "A",
    "explanation": "Code signing provides developers with a way to confirm the authenticity of their code to end users. Developers use a cryptographic function to digitally sign their code with their own private key, and then browsers can use the developer\u2019s public key to verify that signature and ensure that the code is legitimate and was not modified by unauthorized individuals.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      85,
      139,
      140,
      53,
      92
    ],
    "source": "211418_Ch06"
  },
  {
    "id": 135,
    "question": "Chris is reviewing evidence of a cross-site scripting attack where the attacker embedded JavaScript in a URL that a user clicked. The web page then sent the JavaScript to the user in the displayed page. What term best describes this attack?",
    "choice_a": "Reflected XSS",
    "choice_b": "Stored XSS",
    "choice_c": "Persistent XSS",
    "choice_d": "DOM-based XSS",
    "correct_answer": "A",
    "explanation": "This is an example of a reflected attack because the script code is contained within the URL. A persistent or stored attack places the content on a web page or other location where a victim may later access it. DOM-based XSS attacks hide the attack code within the Document Object Model.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      80,
      83,
      82,
      71,
      69
    ],
    "source": "211418_Ch06"
  },
  {
    "id": 136,
    "question": "Joe checks his web server logs and sees that someone sent the following query string to an application running on the server:<br> <code>http://www.mycompany.com/servicestatus.php?serviceID=892&serviceID=892'%20;DROP%20TABLE%20Services;--</code><br>What type of attack was most likely attempted?",
    "choice_a": "Cross-site scripting",
    "choice_b": "Session hijacking",
    "choice_c": "Parameter pollution",
    "choice_d": "On-path",
    "correct_answer": "C",
    "explanation": "This query string is indicative of a parameter pollution attack. In this case, it appears that the attacker was waging a SQL injection attack and tried to use parameter pollution to slip the attack past content filtering technology. The two instances of the <code>serviceID</code> parameter in the query string indicate a parameter pollution attempt.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      84,
      70,
      72,
      71,
      82
    ],
    "source": "211418_Ch06"
  },
  {
    "id": 137,
    "question": "Upon further inspection, Joe finds a series of thousands of requests to the same URL coming from a single IP address. Here are a few examples:<br> <code>http://www.mycompany.com/servicestatus.php?serviceID=1</code><br> <code>http://www.mycompany.com/servicestatus.php?serviceID=2</code><br> <code>http://www.mycompany.com/servicestatus.php?serviceID=3</code><br> <code>http://www.mycompany.com/servicestatus.php?serviceID=4</code><br> <code>http://www.mycompany.com/servicestatus.php?serviceID=5</code><br> <code>http://www.mycompany.com/servicestatus.php?serviceID=6</code><br>What type of vulnerability was the attacker likely trying to exploit?",
    "choice_a": "Insecure direct object reference",
    "choice_b": "File upload",
    "choice_c": "Unvalidated redirect",
    "choice_d": "Session hijacking",
    "correct_answer": "A",
    "explanation": "The series of thousands of requests incrementing a variable indicate that the attacker was most likely attempting to exploit an insecure direct object reference vulnerability.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      76,
      82,
      83,
      72,
      90
    ],
    "source": "211418_Ch06"
  },
  {
    "id": 138,
    "question": "Joe\u2019s adventures in web server log analysis are not yet complete. As he continues to review the logs, he finds the request:<br> <code>http://www.mycompany.com/../../../etc/passwd</code><br>What type of attack was most likely attempted?",
    "choice_a": "SQL injection",
    "choice_b": "Session hijacking",
    "choice_c": "Directory traversal",
    "choice_d": "File upload",
    "correct_answer": "C",
    "explanation": "In this case, the <code>..</code> operators are the telltale giveaway that the attacker was attempting to conduct a directory traversal attack. This particular attack sought to break out of the web server\u2019s root directory and access the <code>/etc/passwd</code> file on the server.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      77,
      78,
      76,
      82,
      72
    ],
    "source": "211418_Ch06"
  },
  {
    "id": 139,
    "question": "Wendy is a penetration tester who wishes to engage in a session hijacking attack. What information is crucial for Wendy to obtain if her attack will be successful?",
    "choice_a": "Session ticket",
    "choice_b": "Session cookie",
    "choice_c": "Username",
    "choice_d": "User password",
    "correct_answer": "B",
    "explanation": "Websites use HTTP cookies to maintain sessions over time. If Wendy is able to obtain a copy of the user\u2019s session cookie, she can use that cookie to impersonate the user\u2019s browser and hijack the authenticated session.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      60,
      59,
      55,
      246,
      250
    ],
    "source": "211418_Ch06"
  },
  {
    "id": 140,
    "question": "Joe is examining the logs for his web server and discovers that a user sent input to a web application that contained the string <code>WAITFOR</code>. What type of attack was the user likely attempting?",
    "choice_a": "Timing-based SQL injection",
    "choice_b": "HTML injection",
    "choice_c": "Cross-site scripting",
    "choice_d": "Content-based SQL injection",
    "correct_answer": "A",
    "explanation": "The use of the SQL <code>WAITFOR</code> command is a signature characteristic of a timing-based SQL injection attack.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      70,
      71,
      83,
      67,
      87
    ],
    "source": "211418_Ch06"
  },
  {
    "id": 141,
    "question": "Mike is sending David an encrypted message using a symmetric encryption algorithm. What key should he use to encrypt the message?",
    "choice_a": "Mike\u2019s public key",
    "choice_b": "Mike\u2019s private key",
    "choice_c": "David\u2019s public key",
    "choice_d": "Shared secret key",
    "correct_answer": "D",
    "explanation": "In symmetric encryption algorithms, both the sender and the receiver use a shared secret key to encrypt and decrypt the message, respectively.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      104,
      108,
      109,
      111,
      105
    ],
    "source": "211418_Ch07"
  },
  {
    "id": 142,
    "question": "Shahla recently discovered an attack where the attacker managed to force a network user to use weak encryption and was then able to decrypt that content. What term best describes this attack?",
    "choice_a": "Downgrade",
    "choice_b": "Collision",
    "choice_c": "Homomorphic encryption",
    "choice_d": "Birthday attack",
    "correct_answer": "A",
    "explanation": "Downgrade attacks try to remove or lower the strength of encryption to allow the decryption of sensitive information. Birthday attacks find collisions where two different inputs produce the same hash value output, but there is no discussion of that in this scenario. Homomorphic encryption is not an attack but a technology that protects privacy by encrypting data in a way that preserves the ability to perform computation on that data.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      131,
      107,
      108,
      223,
      100
    ],
    "source": "211418_Ch07"
  },
  {
    "id": 143,
    "question": "Norm is using full-disk encryption technology to protect the contents of laptops against theft. What goal of cryptography is he attempting to achieve?",
    "choice_a": "Integrity",
    "choice_b": "Non-repudiation",
    "choice_c": "Authentication",
    "choice_d": "Confidentiality",
    "correct_answer": "D",
    "explanation": "Norm\u2019s actions are designed to protect against the unauthorized disclosure of sensitive information. This is a clear example of protecting confidentiality.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      98,
      1,
      99,
      198,
      2
    ],
    "source": "211418_Ch07"
  },
  {
    "id": 144,
    "question": "Brian discovers that a user suspected of stealing sensitive information is posting many image files to a message board. What technique might the individual be using to hide sensitive information in those images?",
    "choice_a": "Steganography",
    "choice_b": "Homomorphic encryption",
    "choice_c": "Replay attack",
    "choice_d": "Birthday attack",
    "correct_answer": "A",
    "explanation": "Steganography is the art of using cryptographic techniques to embed secret messages within another file.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      18,
      30,
      245
    ],
    "source": "211418_Ch07"
  },
  {
    "id": 145,
    "question": "Which one of the following statements about cryptographic keys is incorrect?",
    "choice_a": "All cryptographic keys should be kept secret.",
    "choice_b": "Longer keys are better than shorter keys when the same algorithm is used.",
    "choice_c": "Asymmetric algorithms generally use longer keys than symmetric algorithms.",
    "choice_d": "Digital certificates are designed to share public keys.",
    "correct_answer": "A",
    "explanation": "All of these statements are correct except for the statement that all cryptographic keys should be kept secret. The exception to this rule are public keys used in asymmetric cryptography. These keys should be freely shared.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      105,
      124,
      116,
      106,
      112
    ],
    "source": "211418_Ch07"
  },
  {
    "id": 146,
    "question": "What type of cipher operates on one character of text at a time?",
    "choice_a": "Block cipher",
    "choice_b": "Bit cipher",
    "choice_c": "Stream cipher",
    "choice_d": "Balanced cipher",
    "correct_answer": "C",
    "explanation": "Stream ciphers operate on one character or bit of a message (or data stream) at a time. Block ciphers operate on \u201cchunks,\u201d or blocks, of a message and apply the encryption algorithm to an entire message block at the same time.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      103,
      94,
      95,
      97,
      98
    ],
    "source": "211418_Ch07"
  },
  {
    "id": 147,
    "question": "Vince is choosing a symmetric encryption algorithm for use in his organization. He would like to choose the strongest algorithm from these choices. What algorithm should he choose?",
    "choice_a": "DES",
    "choice_b": "3DES",
    "choice_c": "RSA",
    "choice_d": "AES",
    "correct_answer": "D",
    "explanation": "AES is the successor to 3DES and DES and is the best choice for a symmetric encryption algorithm. RSA is a secure algorithm, but it is asymmetric rather than symmetric.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      108,
      104,
      106,
      102,
      113
    ],
    "source": "211418_Ch07"
  },
  {
    "id": 148,
    "question": "Kevin is configuring a web server to use digital certificates. What technology can he use to allow clients to quickly verify the status of those certificates without contacting a remote server?",
    "choice_a": "CRL",
    "choice_b": "OCSP",
    "choice_c": "Certificate stapling",
    "choice_d": "Certificate pinning",
    "correct_answer": "C",
    "explanation": "The Online Certificate Status Protocol (OCSP) provides real-time checking of a digital certificate\u2019s status using a remote server. Certificate stapling attaches a current OCSP response to the certificate to allow the client to validate the certificate without contacting the OCSP server. Certificate revocation lists (CRLs) are a slower, outdated approach to managing certificate status. Certificate pinning is used to provide an expected key, not to manage certificate status.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      121,
      119,
      118,
      115,
      107
    ],
    "source": "211418_Ch07"
  },
  {
    "id": 149,
    "question": "Acme Widgets has 10 employees and they all need the ability to communicate with one another using a symmetric encryption system. The system should allow any two employees to securely communicate without other employees eavesdropping. If an 11th employee is added to the organization, how many new keys must be added to the system?",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "10",
    "choice_d": "11",
    "correct_answer": "C",
    "explanation": "When the 11th employee joins Acme Widgets, they will need a shared secret key with every existing employee. There are 10 existing employees, so 10 new keys are required.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      104,
      109,
      111,
      105,
      110
    ],
    "source": "211418_Ch07"
  },
  {
    "id": 150,
    "question": "Acme Widgets has 10 employees and they all need the ability to communicate with one another using a symmetric encryption system. The system should allow any two employees to securely communicate without other employees eavesdropping. If Acme Widgets switched to an asymmetric encryption algorithm, how many keys would be required to add the 11th employee?",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "10",
    "choice_d": "11",
    "correct_answer": "B",
    "explanation": "In an asymmetric encryption algorithm, each employee needs only two keys: a public key and a private key. Adding a new user to the system requires the addition of these two keys for that user, regardless of how many other users exist.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      105,
      112,
      104,
      109,
      116
    ],
    "source": "211418_Ch07"
  },
  {
    "id": 151,
    "question": "What type of digital certificate provides the greatest level of assurance that the certificate owner is who they claim to be?",
    "choice_a": "DV",
    "choice_b": "OV",
    "choice_c": "UV",
    "choice_d": "EV",
    "correct_answer": "D",
    "explanation": "Extended validation (EV) certificates provide the highest available level of assurance. The CA issuing an EV certificate certifies that they have verified the identity and authenticity of the certificate subject.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      120,
      119,
      118,
      115,
      116
    ],
    "source": "211418_Ch07"
  },
  {
    "id": 152,
    "question": "Glenn recently obtained a wildcard certificate for <code>*.mydomain.com</code>. Which one of the following domains would not be covered by this certificate?",
    "choice_a": "<code>mydomain.com</code>",
    "choice_b": "<code>core.mydomain.com</code>",
    "choice_c": "<code>dev.www.mydomain.com</code>",
    "choice_d": "<code>mail.mydomain.com</code>",
    "correct_answer": "C",
    "explanation": "Wildcard certificates protect the listed domain as well as all first-level subdomains. <code>dev.www.mydomain.com</code> is a second-level subdomain of <code>mydomain.com</code> and would not be covered by this certificate.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      118,
      120,
      122,
      119,
      121
    ],
    "source": "211418_Ch07"
  },
  {
    "id": 153,
    "question": "Which one of the following servers is almost always an offline CA in a large PKI deployment?",
    "choice_a": "Root CA",
    "choice_b": "Intermediate CA",
    "choice_c": "RA",
    "choice_d": "Internal CA",
    "correct_answer": "A",
    "explanation": "Root CAs are highly protected and not normally used for certificate issuance. A root CA is usually run as an offline CA that delegates authority to intermediate CAs that run as online CAs.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      119,
      124,
      120,
      123,
      118
    ],
    "source": "211418_Ch07"
  },
  {
    "id": 154,
    "question": "Which one of the following certificate formats is closely associated with Windows binary certificate files?",
    "choice_a": "DER",
    "choice_b": "PEM",
    "choice_c": "PFX",
    "choice_d": "P7B",
    "correct_answer": "C",
    "explanation": "The PFX format is most closely associated with Windows systems that store certificates in binary format, whereas the P7B format is used for Windows systems storing files in text format.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      122,
      118,
      120,
      119,
      124
    ],
    "source": "211418_Ch07"
  },
  {
    "id": 155,
    "question": "What type of security solution provides a hardware platform for the storage and management of encryption keys?",
    "choice_a": "HSM",
    "choice_b": "IPS",
    "choice_c": "SIEM",
    "choice_d": "SOAR",
    "correct_answer": "A",
    "explanation": "Hardware security modules (HSMs) provide an effective way to manage encryption keys. These hardware devices store and manage encryption keys in a secure manner that prevents humans from ever needing to work directly with the keys.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      124,
      111,
      102,
      105,
      112
    ],
    "source": "211418_Ch07"
  },
  {
    "id": 156,
    "question": "What type of cryptographic attack attempts to force a user to reduce the level of encryption that they use to communicate with a remote server?",
    "choice_a": "Birthday",
    "choice_b": "Frequency",
    "choice_c": "Downgrade",
    "choice_d": "Collision",
    "correct_answer": "C",
    "explanation": "A downgrade attack is sometimes used against secure communications such as TLS in an attempt to get the user or system to inadvertently shift to less secure cryptographic modes. The idea is to trick the user into shifting to a less secure version of the protocol, one that might be easier to break.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      100,
      108,
      109,
      225,
      123
    ],
    "source": "211418_Ch07"
  },
  {
    "id": 157,
    "question": "David would like to send Mike a message using an asymmetric encryption algorithm. What key should he use to encrypt the message?",
    "choice_a": "David\u2019s public key",
    "choice_b": "David\u2019s private key",
    "choice_c": "Mike\u2019s public key",
    "choice_d": "Mike\u2019s private key",
    "correct_answer": "C",
    "explanation": "When encrypting a message using an asymmetric encryption algorithm, the person performing the encryption does so using the recipient\u2019s public key.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      116,
      105,
      112,
      124,
      119
    ],
    "source": "211418_Ch07"
  },
  {
    "id": 158,
    "question": "When Mike receives the message that David encrypted for him, what key should he use to decrypt the message?",
    "choice_a": "David\u2019s public key",
    "choice_b": "David\u2019s private key",
    "choice_c": "Mike\u2019s public key",
    "choice_d": "Mike\u2019s private key",
    "correct_answer": "D",
    "explanation": "In an asymmetric encryption algorithm, the recipient of a message uses their own private key to decrypt messages that they receive.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      116,
      105,
      112,
      115,
      124
    ],
    "source": "211418_Ch07"
  },
  {
    "id": 159,
    "question": "If David wishes to digitally sign the message that he is sending Mike, what key would he use to create the digital signature?",
    "choice_a": "David\u2019s public key",
    "choice_b": "David\u2019s private key",
    "choice_c": "Mike\u2019s public key",
    "choice_d": "Mike\u2019s private key",
    "correct_answer": "B",
    "explanation": "The sender of a message may digitally sign the message by encrypting a message digest with the sender\u2019s own private key.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      115,
      116,
      105,
      107,
      98
    ],
    "source": "211418_Ch07"
  },
  {
    "id": 160,
    "question": "When Mike receives the digitally signed message from David, what key should he use to verify the digital signature?",
    "choice_a": "David\u2019s public key",
    "choice_b": "David\u2019s private key",
    "choice_c": "Mike\u2019s public key",
    "choice_d": "Mike\u2019s private key",
    "correct_answer": "A",
    "explanation": "The recipient of a digitally signed message may verify the digital signature by decrypting it with the public key of the individual who signed the message.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      116,
      115,
      112,
      105,
      119
    ],
    "source": "211418_Ch07"
  },
  {
    "id": 161,
    "question": "Angela has chosen to federate with other organizations to allow use of services that each organization provides. What role does Angela\u2019s organization play when they authenticate their users and assert that those users are valid to other members of the federation?",
    "choice_a": "Service provider",
    "choice_b": "Relying party",
    "choice_c": "Authentication provider",
    "choice_d": "Identity provider",
    "correct_answer": "D",
    "explanation": "Angela\u2019s organization is acting as an identity provider (IdP). Other members of the federation may act as a service provider or relying party when they allow her users to access their services. Authentication provider is not a named role in typical federation activities.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      136,
      135,
      133,
      134,
      144
    ],
    "source": "211418_Ch08"
  },
  {
    "id": 162,
    "question": "Which of the following technologies is the least effective means of preventing shared accounts?",
    "choice_a": "Password complexity requirements",
    "choice_b": "Requiring biometric authentication",
    "choice_c": "Requiring one-time passwords via a token",
    "choice_d": "Requiring a one-time password via an application",
    "correct_answer": "A",
    "explanation": "Password complexity requirements do not prevent sharing of complex passwords, making it the least effective option from the list. Biometric authentication measures will require the enrolled user to be there, although in some cases such as fingerprint systems, multiple users could each enroll a valid fingerprint for a single account. Both types of one-time passwords could be shared but make it harder and less convenient to share accounts.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      140,
      142,
      141,
      137,
      143
    ],
    "source": "211418_Ch08"
  },
  {
    "id": 163,
    "question": "What major difference is likely to exist between on-premises identity services and those used in a cloud-hosted environment?",
    "choice_a": "Account policy control will be set to the cloud provider\u2019s standards.",
    "choice_b": "The cloud service will provide account and identity management services.",
    "choice_c": "Multifactor authentication will not be supported by the cloud vendor.",
    "choice_d": "None of the above.",
    "correct_answer": "B",
    "explanation": "Most cloud services provide identity and authorization tools for their services. Most, although not all, allow customers to set some or even many of the account policies they will use, and most major vendors support some form of multifactor capability.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      171,
      136,
      140,
      132,
      144
    ],
    "source": "211418_Ch08"
  },
  {
    "id": 164,
    "question": "Amitoj wants to ensure that her organization\u2019s password policy does not allow users to reset their password multiple times until they can reuse their current password. What setting is used to prevent this?",
    "choice_a": "Complexity",
    "choice_b": "Length",
    "choice_c": "Expiration",
    "choice_d": "Age",
    "correct_answer": "D",
    "explanation": "Password age is set to prevent users from resetting their password enough times to bypass reuse settings. Complexity, length, and expiration do not influence this.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      194,
      135,
      208,
      41,
      43
    ],
    "source": "211418_Ch08"
  },
  {
    "id": 165,
    "question": "Which type of multifactor authentication is considered the least secure?",
    "choice_a": "HOTP",
    "choice_b": "SMS",
    "choice_c": "TOTP",
    "choice_d": "Biometric",
    "correct_answer": "B",
    "explanation": "SMS messages are not secure and could be accessed by cloning a SIM card or redirecting VoIP traffic, among other possible threat models. Both HOTP and TOTP tokens and applications as well as biometric factors are generally considered more secure than an SMS-based factor.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      101,
      117,
      111,
      130,
      98
    ],
    "source": "211418_Ch08"
  },
  {
    "id": 166,
    "question": "Geeta has been issued a USB security key as part of her organization\u2019s multifactor implementation. What type of implementation is this?",
    "choice_a": "A hard token",
    "choice_b": "A biometric token",
    "choice_c": "A soft token",
    "choice_d": "An attestation token",
    "correct_answer": "A",
    "explanation": "A USB security key is an example of a hard, or physical, token. An application is an example of a soft token. A biometric factor might be a fingerprint or faceprint. Attestation is a formal verification that something is true. Attestation tokens were made up for this question.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      140,
      139,
      132,
      142,
      136
    ],
    "source": "211418_Ch08"
  },
  {
    "id": 167,
    "question": "Michelle enables the Windows picture password feature to control logins for her laptop. Which type of attribute will it provide?",
    "choice_a": "Somewhere you are",
    "choice_b": "Something you know",
    "choice_c": "Something you are",
    "choice_d": "Someone you know",
    "correct_answer": "B",
    "explanation": "Picture password asks users to click on specific, self-defined parts of a picture. This means that clicking on those points is something you know. Something you are involves biometric traits, and somewhere you are relies on geographic locations.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      140,
      142,
      139,
      132,
      141
    ],
    "source": "211418_Ch08"
  },
  {
    "id": 168,
    "question": "What purpose would Linux file permissions set to <code>rw-r\u2014r-- serve</code>?",
    "choice_a": "To allow the owner to read and write the file, and for the owner\u2019s group and others to be able to read it",
    "choice_b": "To allow all users to read and write the file, and for the group and owner to be able to read it",
    "choice_c": "To allow system administrators to read and write the file, and for users and all others to be able to read it",
    "choice_d": "To prevent reading and writing for all users, and to prevent reading by groups and a specific user",
    "correct_answer": "A",
    "explanation": "Linux file permissions are read left to right, with the first three characters indicating read, write, and execute permissions (<code>rwx</code>) for the owner of the file, the second three apply to the group, and the last three to all other users. Any indicated with a <code>\u2013</code> are not allowed for that set.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      149,
      148,
      144,
      143,
      192
    ],
    "source": "211418_Ch08"
  },
  {
    "id": 169,
    "question": "Theresa wants to implement an access control scheme that sets permissions based on what the individual\u2019s job requires. Which of the following schemes is most suited to this type of implementation?",
    "choice_a": "ABAC",
    "choice_b": "DAC",
    "choice_c": "RBAC",
    "choice_d": "MAC",
    "correct_answer": "C",
    "explanation": "Role-based access control (RBAC) sets permissions based on an individual\u2019s role, which is typically associated with their job. Attribute-based access control (ABAC) is typically matched to other attributes than the job role. Discretionary access control (DAC) and mandatory access control (MAC) are commonly implemented at the operating system level.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      146,
      147,
      285,
      5,
      6
    ],
    "source": "211418_Ch08"
  },
  {
    "id": 170,
    "question": "Which of the following biometric technologies is most broadly deployed due to its ease of use and acceptance from end users?",
    "choice_a": "Voice print recognition",
    "choice_b": "Gait recognition",
    "choice_c": "Retina scanners",
    "choice_d": "Fingerprint scanner",
    "correct_answer": "D",
    "explanation": "Fingerprint scanners are found on many mobile devices and laptops, making them one of the most broadly deployed biometric technologies. Facial recognition is also broadly deployed, but it is not mentioned in this question or offered as an option.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      163,
      5,
      147,
      6,
      164
    ],
    "source": "211418_Ch08"
  },
  {
    "id": 171,
    "question": "Adam want to increase his organization\u2019s passwords resistance to attacks in the event that the password hash database is stolen by attackers. Which of the following password security settings has the largest impact on password cracking if his organization\u2019s current passwords are 8 characters long?",
    "choice_a": "Password complexity",
    "choice_b": "Password length",
    "choice_c": "Password reuse limitations",
    "choice_d": "Preventing the use of common words in passwords",
    "correct_answer": "B",
    "explanation": "Password length has the largest impact on preventing password cracking. When paired with a strong password hash algorithm and proper use of technology like salting, long passwords are much harder to crack. Complexity is the next most important option, as preventing simple repeated characters and similar problematic passwords helps reduce the probability of easily cracked passwords being used. Reuse limitations and preventing common words are less useful.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      137,
      194,
      140,
      143,
      144
    ],
    "source": "211418_Ch08"
  },
  {
    "id": 172,
    "question": "A PIN is an example of what type of factor?",
    "choice_a": "Something you know",
    "choice_b": "Something you are",
    "choice_c": "Something you have",
    "choice_d": "Something you set",
    "correct_answer": "A",
    "explanation": "PINs and passwords are both examples of something you know. Something you set is not a type of factor. Biometric factors are an example of something you are, and a physical USB token would be a common example of something you have.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      140,
      132,
      138,
      139,
      142
    ],
    "source": "211418_Ch08"
  },
  {
    "id": 173,
    "question": "Marie is implementing a PAM solution and wants to ensure that root passwords are available in the event of an outage. Which PAM-related tool is most likely to be useful in this situation?",
    "choice_a": "Ephemeral accounts",
    "choice_b": "Just-in-time permissions",
    "choice_c": "Password vaulting",
    "choice_d": "Token-based authentication",
    "correct_answer": "C",
    "explanation": "Password vaulting, which stores passwords for use with proper authentication and rights, is the most appropriate solution for Marie\u2019s needs. Ephemeral accounts and just-in-time permissions are typically used under normal circumstances to provide least privilege access as needed. Token-based authentication is not specifically a PAM solution.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      145,
      144,
      137,
      138,
      140
    ],
    "source": "211418_Ch08"
  },
  {
    "id": 174,
    "question": "Jill sets her files on a Windows file share to allow Fred to access the files. What type of access control system is she using?",
    "choice_a": "Mandatory access control",
    "choice_b": "Rule-based access control",
    "choice_c": "Attribute-based access control",
    "choice_d": "Discretionary access control",
    "correct_answer": "D",
    "explanation": "Jill is able to make decisions about the rights she grants on her files, meaning this is a discretionary access control system. A mandatory access control system relies on labels to set access control rules. Rule-based access control systems rely on rules to define access, and attribute-based access control systems grant access based on attributes like job roles or locations.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      146,
      147,
      5,
      6,
      285
    ],
    "source": "211418_Ch08"
  },
  {
    "id": 175,
    "question": "Lisa sets up an account on a website that allows her to log in with Google. When she logs in, Google provides an access token to the website that confirms that she is who she says she is but doesn\u2019t provide the site with her password. Which of the following technologies has she used?",
    "choice_a": "LDAP",
    "choice_b": "OAuth",
    "choice_c": "MITRE",
    "choice_d": "RADIUS",
    "correct_answer": "B",
    "explanation": "OAuth is an authentication protocol that allows services to receive authentication tokens from an identity provider without needing the user\u2019s password. LDAP is a directory service and is often used as part of SSO processes. MITRE is a nonprofit organization, and RADIUS is an authentication technology.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      135,
      136,
      132,
      133,
      139
    ],
    "source": "211418_Ch08"
  },
  {
    "id": 176,
    "question": "Kyle has been asked to provide his government-issued ID as part of the creation of his user account. What process should he assume it is being used for?",
    "choice_a": "Biometric enrollment",
    "choice_b": "Just-in-time permission creation",
    "choice_c": "Identity proofing",
    "choice_d": "Federation",
    "correct_answer": "C",
    "explanation": "Kyle can assume that his government-issued ID is being used as part of an identity proofing process to validate that he is who he claims to be. Biometric enrollment typically requires interaction with an enrollment process to scan or capture biometric information. Just-in-time permission creation is done when access is requested and does not require government ID, and federation connects identity providers with service providers, which is not described here.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      144,
      132,
      136,
      145,
      140
    ],
    "source": "211418_Ch08"
  },
  {
    "id": 177,
    "question": "What key concept below best describes only providing the permissions necessary to perform a role?",
    "choice_a": "Least privilege",
    "choice_b": "Best practice",
    "choice_c": "Ephemeral accounts",
    "choice_d": "Mandatory access control",
    "correct_answer": "A",
    "explanation": "The principle of least privilege means that users should only be given the permissions necessary to perform their role. Best practice is a general term describing commonly recommended and accepted industry practices. Temporal accounts are ephemeral, or short-lived accounts. Mandatory access control is an access control scheme.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      285,
      146,
      195,
      6,
      5
    ],
    "source": "211418_Ch08"
  },
  {
    "id": 178,
    "question": "Nina has recently left her organization. What should the organization do with her account?",
    "choice_a": "Transfer it to her replacement.",
    "choice_b": "Reprovision it for another user.",
    "choice_c": "Deprovision her account.",
    "choice_d": "Change the password and preserve the account.",
    "correct_answer": "C",
    "explanation": "Without other factors that would require the account to be retained, deprovisioning accounts that belonged to users who have left the organization is a best practice. Transferring accounts or reprovisioning them may expose data to new users or provide them with rights that they should not have.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      144,
      208,
      207,
      209,
      260
    ],
    "source": "211418_Ch08"
  },
  {
    "id": 179,
    "question": "A person\u2019s name, age, location, or job title are all examples of what?",
    "choice_a": "Biometric factors",
    "choice_b": "Identity factors",
    "choice_c": "Attributes",
    "choice_d": "Account permissions",
    "correct_answer": "C",
    "explanation": "A person\u2019s name, age, location, job title, and even things like their height or their hair color are all attributes that may be associated with a person\u2019s identity. None of these describe biometric factors used for authentication, and identity factors are something you are, something you have, or somewhere you are. Account permissions determine what you can do, not attributes like these.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      132,
      140,
      142,
      136,
      144
    ],
    "source": "211418_Ch08"
  },
  {
    "id": 180,
    "question": "What type of access control scheme best describes the Linux filesystem?",
    "choice_a": "MAC",
    "choice_b": "RBAC",
    "choice_c": "DAC",
    "choice_d": "ABAC",
    "correct_answer": "C",
    "explanation": "Linux users can change who can read, write, or execute files and directories they own, which is discretionary access control (DAC). Mandatory access control (MAC) would enforce settings set by the systems administrator without users having the rights to make their own decisions. While role-based access control is involved, DAC best describes the access control scheme. ABAC is not a default method for setting rights for the Linux filesystem.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      146,
      195,
      147,
      285,
      5
    ],
    "source": "211418_Ch08"
  },
  {
    "id": 181,
    "question": "Naomi wants to handle increasing load by scaling cloud-hosted resources as needed while having the change remain transparent to users. She also wants to allow for upgrades and system replacements transparently. What solution should she select?",
    "choice_a": "Load balancing",
    "choice_b": "Clustering",
    "choice_c": "Geographic diversity",
    "choice_d": "A hot site",
    "correct_answer": "A",
    "explanation": "Naomi should select a load balancing solution. Load balancers allow multiple systems or services to appear like a single resource and can take systems out of the load-balanced pool to allow for upgrades or changes in resources required. Clustering is used to allow groups of computers to perform the same task, but without a load balancer cannot provide the same transparent service appearing as the same system. Geographic diversity and hot sites are concepts used to provide resilience but don\u2019t provide this capability.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      217,
      157,
      150,
      170,
      151
    ],
    "source": "211418_Ch09"
  },
  {
    "id": 182,
    "question": "Rick performs a backup that captures the changes since the last full backup. What type of backup has he performed?",
    "choice_a": "A new full backup",
    "choice_b": "A snapshot",
    "choice_c": "An incremental backup",
    "choice_d": "A differential backup",
    "correct_answer": "D",
    "explanation": "Differential backups back up the changes since the last full backup. Incremental backups back up changes since the last backup, and snapshots are a live copy of a system. This is not a full backup, because it is capturing changes since a full backup.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      153,
      154,
      155,
      152,
      315
    ],
    "source": "211418_Ch09"
  },
  {
    "id": 183,
    "question": "What type of recovery site has some or most systems in place but does not have the data needed to take over operations?",
    "choice_a": "A hot site",
    "choice_b": "A warm site",
    "choice_c": "A cloud site",
    "choice_d": "A cold site",
    "correct_answer": "B",
    "explanation": "Warm sites have systems, connectivity, and power but do not have the live or current data to immediately take over operations. A hot site can immediately take over operations, whereas a cold site has space and power, and likely connectivity, but will require that systems and data be put in place to be used. Cloud sites are not one of the three common types of recovery sites.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      158,
      159,
      161,
      153,
      150
    ],
    "source": "211418_Ch09"
  },
  {
    "id": 184,
    "question": "Ben wants to test his warm site to verify that it will take over operations successfully. What type of testing is this?",
    "choice_a": "Parallel processing",
    "choice_b": "Simulation",
    "choice_c": "Failover",
    "choice_d": "A tabletop exercise",
    "correct_answer": "C",
    "explanation": "Testing that involves an actual failover to another site or service is failover testing. Parallel processing runs both sites or services at the same time; simulation and tabletops both review what would happen without making the actual change.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      161,
      158,
      315,
      160,
      159
    ],
    "source": "211418_Ch09"
  },
  {
    "id": 185,
    "question": "Felix wants to clone a virtual machine. What should he do to capture a live machine, including the machine state?",
    "choice_a": "A full backup",
    "choice_b": "A snapshot",
    "choice_c": "A differential backup",
    "choice_d": "Live boot media",
    "correct_answer": "B",
    "explanation": "Virtual machine snapshots capture the machine state at a point in time and will allow Felix to clone the system. A full backup and a differential backup can be used to capture the disk for the machine but typically will not capture the memory state and other details of the system state. Live boot media allows you to boot and run a nonpersistent system from trusted media.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      174,
      175,
      156,
      153,
      161
    ],
    "source": "211418_Ch09"
  },
  {
    "id": 186,
    "question": "Sally is working to restore her organization\u2019s operations after a disaster took her datacenter offline. What critical document should she refer to as she restarts systems?",
    "choice_a": "The restoration order documentation",
    "choice_b": "The TOTP documentation",
    "choice_c": "The HOTP documentation",
    "choice_d": "The last-known good configuration documentation",
    "correct_answer": "A",
    "explanation": "A documented restoration order helps ensure that systems and services that have dependencies start in the right order and that high-priority or mission-critical services are restored first. TOTP and HOTP are types of one-time password technology, and last-known good configurations are often preserved with a snapshot or other technology that can allow a system to return to a known good status after an issue such as a bad patch or configuration change.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      315,
      153,
      161,
      158,
      150
    ],
    "source": "211418_Ch09"
  },
  {
    "id": 187,
    "question": "Mike wants to stop vehicles from traveling toward the entrance of his building. What physical security control should he implement?",
    "choice_a": "An air gap",
    "choice_b": "A hot aisle",
    "choice_c": "A robotic sentry",
    "choice_d": "A bollard",
    "correct_answer": "D",
    "explanation": "Bollards are physical security controls that prevent vehicles from accessing or ramming doors or other areas. They may look like pillars, planters, or other innocuous objects. An air gap is a physical separation of technology environments; a hot aisle is the aisle where systems in a datacenter exhaust warm air; and unlike in movies, robotic sentries are not commonly deployed and aren\u2019t ready to stop vehicles in most current circumstances.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      162,
      5,
      6,
      163,
      165
    ],
    "source": "211418_Ch09"
  },
  {
    "id": 188,
    "question": "Alecia wants to ensure that her backups cannot be accessed by third parties while stored in an offsite storage location. What should she do to secure her backups?",
    "choice_a": "Hash the backup data.",
    "choice_b": "Avoid the use of offsite storage locations.",
    "choice_c": "Employ security guards.",
    "choice_d": "Encrypt the backup data.",
    "correct_answer": "D",
    "explanation": "Encryption is commonly used to ensure that backup media or data that is exposed is not accessible to third parties. This does mean that Alecia must carefully secure the encryption keys for the backup. Hashing that data would not keep it secure, and if only hashes were stored the data would be unrecoverable. Security guards are expensive and not a complete solution if data is inadvertently exposed, and offsite, secure storage locations are a useful and common solution for organizations that want to have remote backups.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      99,
      100,
      111,
      102,
      1
    ],
    "source": "211418_Ch09"
  },
  {
    "id": 189,
    "question": "Fred wants to be able to recover his database transactions at any point in time if a physical disaster occurs involving his datacenter. His organization uses daily backups. What additional solution should he select to support this need?",
    "choice_a": "Onsite journaling",
    "choice_b": "Onsite snapshots",
    "choice_c": "Offsite journaling",
    "choice_d": "Offsite snapshots",
    "correct_answer": "C",
    "explanation": "Offsite journaling will allow transactions to be recorded and to remain available if a significant event occurred that involved his datacenter. Snapshots are useful at a point in time but do not retain a transaction log between snapshots.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      153,
      315,
      158,
      159,
      150
    ],
    "source": "211418_Ch09"
  },
  {
    "id": 190,
    "question": "Ellen is concerned about her company\u2019s resilience and wants to ensure it can handle either changing loads or support disaster recovery and business continuity efforts if a primary location or datacenter were taken offline. Which of the following should she primarily focus on during her capacity planning?",
    "choice_a": "People, technology, and infrastructure",
    "choice_b": "A generator and a UPS",
    "choice_c": "RAID 0, 1, 5, and 10",
    "choice_d": "Incremental, differential, and full backups",
    "correct_answer": "A",
    "explanation": "Resilience requires capacity planning to ensure that capacity\u2014including staff, technology, and infrastructure\u2014is available when is needed. Although a generator, UPS, various RAID levels, and backups have their place in disaster recovery and contingency planning, they are not the primary focus of resiliency and capacity planning.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      160,
      158,
      150,
      157,
      161
    ],
    "source": "211418_Ch09"
  },
  {
    "id": 191,
    "question": "Madhuri has deployed a replication tool that copies data over to a secondary hot site in real time. What type of replication has she deployed?",
    "choice_a": "Synchronous replication",
    "choice_b": "Journaled replication",
    "choice_c": "Asynchronous replication",
    "choice_d": "Snapshot-based replication",
    "correct_answer": "A",
    "explanation": "Synchronous replication occurs in real time, whereas asynchronous replication occurs after the fact but more regularly than a backup. Journaled and snapshot-based replication are not specific types of replication.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      315,
      158,
      159,
      150,
      151
    ],
    "source": "211418_Ch09"
  },
  {
    "id": 192,
    "question": "What factor is a major reason organizations do not use security guards?",
    "choice_a": "Reliability",
    "choice_b": "Training",
    "choice_c": "Cost",
    "choice_d": "Social engineering",
    "correct_answer": "C",
    "explanation": "Security guards can be one of the costliest physical security controls over time, making the cost of guards one of the most important deciding factors guiding when and where they will be employed. Reliability, training, and the potential for social engineering are all possible issues with security guards, but none of these is the major driver in the decision process.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      164,
      5,
      6,
      162,
      163
    ],
    "source": "211418_Ch09"
  },
  {
    "id": 193,
    "question": "Megan wants to deploy a sensor that is inexpensive, yet will allow her to detect humans entering and moving in a secured room. Which of the following should she select?",
    "choice_a": "An infrared sensor",
    "choice_b": "A microwave sensor",
    "choice_c": "An ultrasonic sensor",
    "choice_d": "A pressure sensor",
    "correct_answer": "A",
    "explanation": "Infrared sensors balance lower cost with the ability to detect humans entering and moving in a space. Microwave sensors are more expensive but can provide better coverage, including traveling through some barriers. Ultrasonic sensors are rarely used for this purpose, and pressure sensors are limited to the pad where they are deployed, making them expensive and challenging to use for rooms or larger spaces.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      166,
      165,
      162,
      5,
      164
    ],
    "source": "211418_Ch09"
  },
  {
    "id": 194,
    "question": "Kathleen wants to discourage potential attackers from entering the facility she is responsible for. Which of the following is <i>not</i> a common control used for this type of preventive defense?",
    "choice_a": "Fences",
    "choice_b": "Lighting",
    "choice_c": "Platform diversity",
    "choice_d": "Video surveillance",
    "correct_answer": "C",
    "explanation": "Fences, lighting, and video surveillance can all help discourage potential malicious actors from entering an area, although a determined adversary will ignore or bypass all three. Platform diversity can help make it harder for attackers to succeed, but this is primarily a resilience tactic, and remains more costly to maintain and implement.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      162,
      165,
      163,
      164
    ],
    "source": "211418_Ch09"
  },
  {
    "id": 195,
    "question": "How does technology diversity help ensure cybersecurity resilience?",
    "choice_a": "It ensures that a vulnerability in a single company\u2019s product will not impact the entire infrastructure.",
    "choice_b": "If a single vendor goes out of business, the company does not need to replace its entire infrastructure.",
    "choice_c": "It means that a misconfiguration will not impact the company\u2019s entire infrastructure.",
    "choice_d": "All of the above.",
    "correct_answer": "D",
    "explanation": "Technology diversity helps ensure that a single failure\u2014due to a vendor, vulnerability, or misconfiguration\u2014will not impact an entire organization. Technology diversity does have additional costs, including training, patch management, and configuration management.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      150,
      159,
      151,
      157,
      160
    ],
    "source": "211418_Ch09"
  },
  {
    "id": 196,
    "question": "Scott sends his backups to a company that keeps them in a secure vault. What type of backup solution has he implemented?",
    "choice_a": "Nearline",
    "choice_b": "Safe",
    "choice_c": "Onsite",
    "choice_d": "Offsite",
    "correct_answer": "D",
    "explanation": "Scott has implemented an offsite backup scheme. His backups will take longer to retrieve because they are at a remote facility and will have to be sent back to him, but they are likely to survive any disaster that occurs in his facility or datacenter. Onsite backups are kept immediately accessible, whereas nearline backups can be retrieved somewhat more slowly than online backups but faster than offline backups. \u201cSafe backups\u201d is not an industry term.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      154,
      155,
      158,
      153,
      159
    ],
    "source": "211418_Ch09"
  },
  {
    "id": 197,
    "question": "Gabby wants to detect physical brute-force attempts against her organization. What solution is best suited to this?",
    "choice_a": "Security guards",
    "choice_b": "Locks",
    "choice_c": "Access badges",
    "choice_d": "An intrusion detection system (IDS)",
    "correct_answer": "A",
    "explanation": "Security guards who can monitor for and understand the signs of a physical brute-force attempt are the most useful control listed. Locks may show signs of attempts but require careful inspection, access badges would require log review and additional information to detect brute-force attacks, and an IDS is useful for network attacks.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      164,
      6,
      5,
      162,
      166
    ],
    "source": "211418_Ch09"
  },
  {
    "id": 198,
    "question": "Florian wants to test his high-availability designs but does not want to interrupt his organization\u2019s normal work. Which of the following is the least disruptive testing scenario?",
    "choice_a": "A failover exercise",
    "choice_b": "A tabletop exercise",
    "choice_c": "A partial failover exercise",
    "choice_d": "A simulation",
    "correct_answer": "B",
    "explanation": "A tabletop exercise is the least disruptive form of exercise. Even simulations have some risk if an employee does not fully realize that the scenario is simulated and takes action. Failover, even partial, involves the potential for disruption.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      161,
      150,
      159,
      160,
      315
    ],
    "source": "211418_Ch09"
  },
  {
    "id": 199,
    "question": "What type of physical security control is shown here?<img src=\"/question_assets/Security+/c09uf001.png\"/>",
    "choice_a": "A Faraday cage",
    "choice_b": "An access control vestibule",
    "choice_c": "A bollard",
    "choice_d": "An air gap",
    "correct_answer": "B",
    "explanation": "An access control vestibule uses a pair of doors. When an individual enters, the first door must be closed and secured before the second door can be opened. This helps prevent tailgating, since the person entering will notice anybody following them through the secured area. A Faraday cage is used to stop electromagnetic interference (EMI), a bollard prevents vehicular traffic, and an air gap is a physical separation of networks or devices.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      163,
      162,
      6,
      5,
      164
    ],
    "source": "211418_Ch09"
  },
  {
    "id": 200,
    "question": "Gurvinder identifies a third-party datacenter provider over 90 miles away to run his redundant datacenter operations. Why has he placed the datacenter that far away?",
    "choice_a": "Because it is required by law",
    "choice_b": "Network traffic latency concerns",
    "choice_c": "Geographic dispersion",
    "choice_d": "Geographic tax reasons",
    "correct_answer": "C",
    "explanation": "Geographic dispersion helps ensure that a single natural or human-made disaster does not disable multiple facilities. This distance is not required by law; latency increases with distance; and though there may be tax reasons in some cases, this is not a typical concern for a security professional.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      150,
      159,
      158,
      161,
      315
    ],
    "source": "211418_Ch09"
  },
  {
    "id": 201,
    "question": "Kevin discovered that his web server was being overwhelmed by traffic, causing a CPU bottleneck. Using the interface offered by his cloud service provider, he added another CPU to the server. What term best describes Kevin\u2019s action?",
    "choice_a": "Elasticity",
    "choice_b": "Horizontal scaling",
    "choice_c": "Vertical scaling",
    "choice_d": "High availability",
    "correct_answer": "C",
    "explanation": "This is an example of adding additional capacity to an existing server, which is also known as vertical scaling. Kevin could also have used horizontal scaling by adding additional web servers. Elasticity involves the ability to both add and remove capacity on demand, and though it does describe this scenario, it\u2019s not as good a description as vertical scaling. There is no mention of increasing the server\u2019s availability.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      170,
      157,
      151,
      160,
      159
    ],
    "source": "211418_Ch10"
  },
  {
    "id": 202,
    "question": "Fran\u2019s organization uses a Type I hypervisor to implement an IaaS offering that it sells to customers. Which one of the following security controls is least applicable to this environment?",
    "choice_a": "Customers must maintain security patches on guest operating systems.",
    "choice_b": "The provider must maintain security patches on the hypervisor.",
    "choice_c": "The provider must maintain security patches on the host operating system.",
    "choice_d": "Customers must manage security groups to mediate network access to guest operating systems.",
    "correct_answer": "C",
    "explanation": "Type I hypervisors, also known as bare-metal hypervisors, run directly on top of the physical hardware and, therefore, do not require a host operating system.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      174,
      175,
      168,
      172,
      182
    ],
    "source": "211418_Ch10"
  },
  {
    "id": 203,
    "question": "Greg would like to find a reference document that describes how to map cloud security controls to different regulatory standards. What document would best assist with this task?",
    "choice_a": "CSA CCM",
    "choice_b": "NIST SP 500-292",
    "choice_c": "ISO 27001",
    "choice_d": "PCI DSS",
    "correct_answer": "A",
    "explanation": "The Cloud Security Alliance (CSA) Cloud Controls Matrix (CCM) is a reference document designed to help organizations understand the appropriate use of cloud security controls and map those controls to various regulatory standards. NIST SP 500-292 is a reference model for cloud computing and operates at a high level. ISO 27001 is a general standard for cybersecurity, and PCI DSS is a regulatory requirement for organizations involved in processing credit card transactions.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      172,
      168,
      179,
      316,
      319
    ],
    "source": "211418_Ch10"
  },
  {
    "id": 204,
    "question": "Wanda is responsible for a series of seismic sensors placed at remote locations. These sensors have low-bandwidth connections, and she would like to place computing power on the sensors to allow them to preprocess data before it is sent back to the cloud. What term best describes this approach?",
    "choice_a": "Edge computing",
    "choice_b": "Client-server computing",
    "choice_c": "Fog computing",
    "choice_d": "Thin client computing",
    "correct_answer": "A",
    "explanation": "This approach may be described as client-server computing, but that is a general term that describes many different operating environments. The better term to use here is edge computing, which involves placing compute power at the client to allow it to perform preprocessing before sending data back to the cloud. Fog computing is a related concept that uses IoT gateway devices that are located in close physical proximity to the sensors.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      173,
      169,
      204,
      193,
      175
    ],
    "source": "211418_Ch10"
  },
  {
    "id": 205,
    "question": "Which one of the following statements about cloud computing is incorrect?",
    "choice_a": "Cloud computing offers ubiquitous, convenient access.",
    "choice_b": "Cloud computing customers store data on hardware that is shared with other customers.",
    "choice_c": "Cloud computing customers provision resources through the service provider\u2019s sales team.",
    "choice_d": "Cloud computing resources are accessed over a network.",
    "correct_answer": "C",
    "explanation": "One of the key characteristics of cloud computing is that customers can access resources on-demand with minimal service provider interaction. Cloud customers do not need to contact a sales representative each time they wish to provision a resource but can normally do so on a self-service basis.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      170,
      168,
      172,
      169,
      157
    ],
    "source": "211418_Ch10"
  },
  {
    "id": 206,
    "question": "Helen designed a new payroll system that she offers to her customers. She hosts the payroll system in AWS and her customers access it through the web. What tier of cloud computing best describes Helen\u2019s service?",
    "choice_a": "PaaS",
    "choice_b": "SaaS",
    "choice_c": "FaaS",
    "choice_d": "IaaS",
    "correct_answer": "B",
    "explanation": "Helen is using IaaS services to create her payroll product. She is then offering that payroll service to her customers as a SaaS solution.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      168,
      172,
      170,
      169,
      175
    ],
    "source": "211418_Ch10"
  },
  {
    "id": 207,
    "question": "Which cloud computing deployment model requires the use of a unifying technology platform to tie together components from different providers?",
    "choice_a": "Public cloud",
    "choice_b": "Private cloud",
    "choice_c": "Community cloud",
    "choice_d": "Hybrid cloud",
    "correct_answer": "D",
    "explanation": "Hybrid cloud environments blend elements of public, private, and/or community cloud solutions. A hybrid cloud requires the use of technology that unifies the different cloud offerings into a single, coherent platform.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      169,
      172,
      159,
      150,
      175
    ],
    "source": "211418_Ch10"
  },
  {
    "id": 208,
    "question": "Which one of the following would not commonly be available as an IaaS service offering?",
    "choice_a": "CRM",
    "choice_b": "Storage",
    "choice_c": "Networking",
    "choice_d": "Computing",
    "correct_answer": "A",
    "explanation": "Customer relationship management (CRM) packages offered in the cloud would be classified as software-as-a-service (SaaS), since they are not infrastructure components. Storage, networking, and computing resources are all common IaaS offerings.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      168,
      172,
      176,
      177,
      175
    ],
    "source": "211418_Ch10"
  },
  {
    "id": 209,
    "question": "Which one of the following is <i>not</i> an example of infrastructure as code?",
    "choice_a": "Defining infrastructure in JSON",
    "choice_b": "Writing code to interact with a cloud provider\u2019s API",
    "choice_c": "Using a cloud provider\u2019s web interface to provision resources",
    "choice_d": "Defining infrastructure in YAML",
    "correct_answer": "C",
    "explanation": "Infrastructure as code (IaC) is any approach that automates the provisioning, management, and deprovisioning of cloud resources. Defining resources through JSON or YAML is IaC, as is writing code that interacts with an API. Provisioning resources through a web interface is manual, not automated, and therefore does not qualify as IaC.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      178,
      92,
      93,
      65,
      85
    ],
    "source": "211418_Ch10"
  },
  {
    "id": 210,
    "question": "Brian is selecting a CASB for his organization, and he would like to use an approach that interacts with the cloud provider directly. Which CASB approach is most appropriate for his needs?",
    "choice_a": "Inline CASB",
    "choice_b": "Outsider CASB",
    "choice_c": "Comprehensive CASB",
    "choice_d": "API-based CASB",
    "correct_answer": "D",
    "explanation": "API-based CASB solutions interact directly with the cloud provider through the provider\u2019s API. Inline CASB solutions intercept requests between the user and the provider. Outsider and comprehensive are not categories of CASB solutions.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      172,
      182,
      177,
      176,
      159
    ],
    "source": "211418_Ch10"
  },
  {
    "id": 211,
    "question": "In which of the following cloud categories are customers typically charged based on the number of virtual server instances dedicated to their use?",
    "choice_a": "IaaS only",
    "choice_b": "SaaS only",
    "choice_c": "IaaS and PaaS",
    "choice_d": "IaaS, SaaS, and PaaS",
    "correct_answer": "C",
    "explanation": "Customers are typically charged for server instances in both IaaS environments, where they directly provision those instances, and PaaS environments, where they request the number of servers needed to support their applications. In an SaaS environment, the customer typically has no knowledge of the number of server instances supporting their use.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      168,
      172,
      170,
      175,
      176
    ],
    "source": "211418_Ch10"
  },
  {
    "id": 212,
    "question": "Brian would like to limit the ability of users inside his organization to provision expensive cloud server instances without permission. What type of control would best help him achieve this goal?",
    "choice_a": "Resource policy",
    "choice_b": "Security group",
    "choice_c": "Multifactor authentication",
    "choice_d": "Secure web gateway",
    "correct_answer": "A",
    "explanation": "Cloud providers offer resource policies that customers may use to limit the actions that users of their accounts may take. Implementing resource policies is a good security practice to limit the damage caused by an accidental command, a compromised account, or a malicious insider.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      145,
      92,
      171,
      148,
      93
    ],
    "source": "211418_Ch10"
  },
  {
    "id": 213,
    "question": "Ursula would like to link the networks in her on-premises datacenter with cloud VPCs in a secure manner. What technology would help her best achieve this goal?",
    "choice_a": "Transit gateway",
    "choice_b": "HSM",
    "choice_c": "VPC endpoint",
    "choice_d": "SWG",
    "correct_answer": "A",
    "explanation": "Cloud providers offer VPC endpoints that allow connections of VPCs to each other using the cloud provider's secure network. Cloud transit gateways extend this model even further, allowing the direct interconnection of cloud VPCs with on-premises VLANs for hybrid cloud operations. Secure web gateways (SWGs) provide a layer of application security for cloud-dependent organizations. Hardware security modules (HSMs) are special-purpose computing devices that manage encryption keys and also perform cryptographic operations in a highly efficient manner.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      177,
      169,
      179,
      212,
      193
    ],
    "source": "211418_Ch10"
  },
  {
    "id": 214,
    "question": "What component of a virtualization platform is primarily responsible for preventing VM escape attacks?",
    "choice_a": "Administrator",
    "choice_b": "Guest operating system",
    "choice_c": "Host operating system",
    "choice_d": "Hypervisor",
    "correct_answer": "D",
    "explanation": "Virtual machine (VM) escape vulnerabilities are the most serious issue that can exist in a virtualized environment, particularly when a virtual host runs systems of differing security levels. In an escape attack, the attacker has access to a single virtual host and then manages to leverage that access to intrude upon the resources assigned to a different virtual machine. The hypervisor is supposed to prevent this type of access by restricting a virtual machine\u2019s access to only those resources assigned to that machine.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      174,
      179,
      175,
      182,
      177
    ],
    "source": "211418_Ch10"
  },
  {
    "id": 215,
    "question": "Ryan is selecting a new security control to meet his organization\u2019s objectives. He would like to use it in their multicloud environment and would like to minimize the administrative work required from his fellow technologists. What approach would best meet his needs?",
    "choice_a": "Third-party control",
    "choice_b": "Internally developed control",
    "choice_c": "Cloud-native control",
    "choice_d": "Any of the above",
    "correct_answer": "A",
    "explanation": "Controls offered by cloud service providers have the advantage of direct integration with the provider\u2019s offerings, often making them cost-effective and user-friendly. Third-party solutions are often more costly, but they bring the advantage of integrating with a variety of cloud providers, facilitating the management of multicloud environments.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      172,
      159,
      169,
      151,
      150
    ],
    "source": "211418_Ch10"
  },
  {
    "id": 216,
    "question": "Kira would like to implement a security control that can implement access restrictions across all of the SaaS solutions used by her organization. What control would best meet her needs?",
    "choice_a": "Security group",
    "choice_b": "Resource policy",
    "choice_c": "CASB",
    "choice_d": "SWG",
    "correct_answer": "C",
    "explanation": "Cloud access security brokers (CASBs) are designed specifically for this situation: enforcing security controls across cloud providers. A secure web gateway (SWG) may be able to achieve Kira\u2019s goal, but it would be more difficult to do so. Security groups and resource policies are controls used in IaaS environments.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      179,
      172,
      177,
      169,
      168
    ],
    "source": "211418_Ch10"
  },
  {
    "id": 217,
    "question": "Howard is assessing the legal risks to his organization based on its handling of PII. The organization is based in the United States, handles the data of customers located in Europe, and stores information in Japanese datacenters. What law would be most important to Howard during his assessment?",
    "choice_a": "Japanese law",
    "choice_b": "European Union law",
    "choice_c": "U.S. law",
    "choice_d": "All should have equal weight.",
    "correct_answer": "D",
    "explanation": "The principle of data sovereignty states that data is subject to the legal restrictions of any jurisdiction where it is collected, stored, or processed. In this case, Howard needs to assess the laws of all three jurisdictions.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      179,
      180,
      319,
      316,
      11
    ],
    "source": "211418_Ch10"
  },
  {
    "id": 218,
    "question": "Brenda\u2019s company provides a managed incident response service to its customers. What term best describes this type of service offering?",
    "choice_a": "MSP",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "MSSP",
    "correct_answer": "D",
    "explanation": "Brenda\u2019s company is offering a technology service to customers on a managed basis, making it a managed service provider (MSP). However, this service is a security service, so the term managed security service provider (MSSP) is a better description of the situation.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      172,
      168,
      151,
      160,
      159
    ],
    "source": "211418_Ch10"
  },
  {
    "id": 219,
    "question": "Tony purchases virtual machines from Microsoft Azure exclusively for use by his organization. What model of cloud computing is this?",
    "choice_a": "Public cloud",
    "choice_b": "Private cloud",
    "choice_c": "Hybrid cloud",
    "choice_d": "Community cloud",
    "correct_answer": "A",
    "explanation": "This is an example of public cloud computing because Tony is using a public cloud provider, Microsoft Azure. The fact that Tony is limiting access to virtual machines to his own organization is not relevant because the determining factor for the cloud model is whether the underlying infrastructure is shared, not whether virtualized resources are shared.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      169,
      168,
      175,
      172,
      179
    ],
    "source": "211418_Ch10"
  },
  {
    "id": 220,
    "question": "Lin\u2019s hardware manufacturer has stopped selling the model of device that Lin\u2019s organization uses and has also stopped providing security or other updates. What phase of the hardware life cycle is the device in?",
    "choice_a": "End-of-life",
    "choice_b": "Legacy",
    "choice_c": "End-of-sales",
    "choice_d": "Senescence",
    "correct_answer": "B",
    "explanation": "Legacy hardware is unsupported and no longer sold. End-of-life typically means that the device is no longer being made but is likely to still have support for a period of time. End-of-sales means the device is no longer being sold, but again, may have support for some time. Senescence is not a term typically used in hardware life cycles.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      206,
      51,
      197,
      207,
      239
    ],
    "source": "211418_Ch11"
  },
  {
    "id": 221,
    "question": "Naomi has discovered the following TCP ports open on a system she wants to harden. Which ports are used for unsecure services and thus should be disabled to allow their secure equivalents to continue to be used?",
    "choice_a": "21, 22, and 80",
    "choice_b": "21 and 80",
    "choice_c": "21, 23, and 80",
    "choice_d": "22 and 443",
    "correct_answer": "C",
    "explanation": "The services listed are:<br>21\u2014FTP <br>22\u2014SSH <br>23\u2014Telnet <br>80\u2014HTTP <br>443\u2014HTTPS <br>Of these services, SSH (Port 22) and HTTPS (port 443) are secure options for remote shell access and HTTP. Although secure mode FTP (FTP/S) may run on TCP 21, there is not enough information to know for sure, and HTTPS can be used for secure file transfer if necessary. Thus, Naomi\u2019s best option is to disable all three likely unsecure protocols: FTP (port 21), Telnet (port 23), and HTTP (port 80).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      223,
      224,
      100,
      6,
      285
    ],
    "source": "211418_Ch11"
  },
  {
    "id": 222,
    "question": "Frank\u2019s organization is preparing to deploy a data loss prevention (DLP) system. What key process should they undertake before they deploy it?",
    "choice_a": "Define data life cycles for all nonsensitive data.",
    "choice_b": "Encrypt all sensitive data.",
    "choice_c": "Implement and use a data classification scheme.",
    "choice_d": "Tag all data by creator or owner.",
    "correct_answer": "C",
    "explanation": "Protecting data using a DLP requires data classification so that the DLP knows which data should be protected and what policies to apply to it. Defining data life cycles can help prevent data from being kept longer than it should be and improves data security by limiting the data that needs to be secured, but it isn\u2019t necessary as part of a DLP deployment. Encrypting all sensitive data may mean the DLP cannot recognize it and may not be appropriate for how it is used. Tagging all data with a creator or owner can be useful but is not required for a DLP rollout\u2014instead, knowing the classification of the data is more important.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      316,
      319,
      9,
      10,
      11
    ],
    "source": "211418_Ch11"
  },
  {
    "id": 223,
    "question": "Oliver wants to store and manage secrets in his cloud service provider\u2019s environment. What type of solution should he look for as part of their offerings?",
    "choice_a": "A TPM",
    "choice_b": "A secure enclave",
    "choice_c": "A KMS",
    "choice_d": "A Titan M",
    "correct_answer": "C",
    "explanation": "Oliver should look for a key management system, or KMS, which will allow him to securely create, store, and manage keys in a cloud environment. TPMs, secure enclaves, and Google\u2019s Titan M are all local hardware solutions.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      111,
      124,
      102,
      109,
      130
    ],
    "source": "211418_Ch11"
  },
  {
    "id": 224,
    "question": "What is the key difference between EDR and XDR solutions?",
    "choice_a": "The variety of malware it can detect",
    "choice_b": "The number of threat feeds that are used",
    "choice_c": "The breadth of the technology stack that is covered",
    "choice_d": "The volume of logs that can be processed",
    "correct_answer": "C",
    "explanation": "XDR is similar to EDR but has a broader perspective covering not only endpoints but also cloud services, security platforms, and other components. Thus, the breadth of coverage of the technology stack is broader for XDR solutions.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      187,
      181,
      171,
      240,
      250
    ],
    "source": "211418_Ch11"
  },
  {
    "id": 225,
    "question": "Michelle wants to prevent unauthorized applications from being installed on a Windows system. What type of tool can she use to stop applications from being installed?",
    "choice_a": "Antivirus",
    "choice_b": "A GPO",
    "choice_c": "An EDR",
    "choice_d": "A HIPS",
    "correct_answer": "B",
    "explanation": "A Windows Group Policy Object (GPO) can be used to control whether users are able to install software. Antivirus will not stop this, nor will EDR or a HIPS.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      6,
      146,
      147,
      282,
      285
    ],
    "source": "211418_Ch11"
  },
  {
    "id": 226,
    "question": "What term is used to describe tools focused on detecting and responding to suspicious activities occurring on endpoints like desktops, laptops, and mobile devices?",
    "choice_a": "EDR",
    "choice_b": "IAM",
    "choice_c": "FDE",
    "choice_d": "ESC",
    "correct_answer": "A",
    "explanation": "Endpoint detection and response (EDR) systems provide monitoring, detection, and response capabilities for systems. EDR systems capture data from endpoints and send it to a central repository, where it can be analyzed for issues and indicators of compromise or used for incident response activities. IAM is identity and access management, FDE is full-disk encryption, and ESC is not a commonly used security acronym.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      187,
      246,
      250,
      257,
      240
    ],
    "source": "211418_Ch11"
  },
  {
    "id": 227,
    "question": "Fred has recently purchased a network router and is preparing to deploy it. Which of the following is a common step in deploying new routers?",
    "choice_a": "Disabling unwanted services",
    "choice_b": "Removing unnecessary software",
    "choice_c": "Installing antivirus",
    "choice_d": "Changing default passwords",
    "correct_answer": "D",
    "explanation": "Network devices as well as many other devices like printers come with default passwords set. Fred should change the default password as part of the process of setting up his new router.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      52,
      192,
      144,
      93,
      240
    ],
    "source": "211418_Ch11"
  },
  {
    "id": 228,
    "question": "Charlene wants to prevent attacks against her system that leverage flaws in the services that it provides while still keeping the services accessible. What hardening technique should she use?",
    "choice_a": "A host-based firewall",
    "choice_b": "A host-based IPS",
    "choice_c": "Encryption",
    "choice_d": "An EDR",
    "correct_answer": "B",
    "explanation": "A host-based intrusion prevention system (HIPS) can detect and prevent attacks against services while allowing the service to be accessible. A firewall can only block based on port, protocol, and IP; encryption won\u2019t prevent this; and an EDR is primarily targeted at malicious software and activity, not at network-based attacks on services.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      6,
      195,
      223,
      282,
      5
    ],
    "source": "211418_Ch11"
  },
  {
    "id": 229,
    "question": "Allan is preparing to harden his organization\u2019s network switches. Which of the following is not a common hardening technique for network devices?",
    "choice_a": "Removing unnecessary software",
    "choice_b": "Installing patches",
    "choice_c": "Administrative VLANs",
    "choice_d": "Changing default passwords",
    "correct_answer": "A",
    "explanation": "Unlike computers and mobile devices, switches and other network devices typically do not have additional software that can be removed. Installing patches, placing administrative interfaces on protected VLANs, and changing default passwords are all common hardening techniques for network devices like switches.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      193,
      211,
      212,
      222,
      218
    ],
    "source": "211418_Ch11"
  },
  {
    "id": 230,
    "question": "Helen\u2019s organization is planning to deploy IoT devices across their buildings as part of a HVAC system. Helen knows that the vendor for the IoT devices does not provide regular security updates to the device\u2019s web interfaces that are used to manage the devices. What security control should she recommend to help protect the devices on the network?",
    "choice_a": "Install host-based firewalls.",
    "choice_b": "Deploy the IoT devices to a protected VLAN.",
    "choice_c": "Install host-based IPS.",
    "choice_d": "Disable the web interfaces for the IoT devices.",
    "correct_answer": "B",
    "explanation": "Since the web interfaces are needed to manage the devices, Helen\u2019s best option is to place the IoT devices in a protected VLAN. IoT devices will not typically allow additional software to be installed, meaning that adding firewalls or a HIPS won\u2019t work.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      193,
      204,
      11,
      218,
      210
    ],
    "source": "211418_Ch11"
  },
  {
    "id": 231,
    "question": "What is the primary reason to remove unnecessary software during hardening efforts?",
    "choice_a": "To reduce the attack footprint of the device",
    "choice_b": "To reduce the number of patches that are installed",
    "choice_c": "To reduce the number of firewall rules required for the device",
    "choice_d": "To support incident response (IR) activities",
    "correct_answer": "A",
    "explanation": "Removing unnecessary software helps to reduce the attack surface of the devices. Not all software runs a service or opens a network port, but installed software provides additional opportunities for attackers to find vulnerabilities. That means that reducing firewall rules is not a primary purpose. While removing it may reduce the number of patches required by a device, that is not the primary driver. Finally, while incident response efforts may point to a need for further hardening to prevent future incidents, removing unnecessary software is not a typical step in support of IR activities.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      200,
      202,
      82,
      19,
      183
    ],
    "source": "211418_Ch11"
  },
  {
    "id": 232,
    "question": "Brian has deployed a system that monitors sensors and uses that data to manage the power distribution for the power company that he works for. Which of the following terms is commonly used to describe this type of control and monitoring solution?",
    "choice_a": "SCADA",
    "choice_b": "SIM",
    "choice_c": "HVAC",
    "choice_d": "AVAD",
    "correct_answer": "A",
    "explanation": "SCADA (supervisory control and data acquisition) is a system architecture that combines data acquisition and control devices with communications methods and interfaces to oversee complex industrial and manufacturing processes, just like those used in utilities. A SIM (subscriber identity module) is the small card used to identify cell phones; HVAC stands for heating, ventilation, and air-conditioning; and AVAD was made up for this question.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      201,
      173,
      204,
      151,
      193
    ],
    "source": "211418_Ch11"
  },
  {
    "id": 233,
    "question": "The organization that Lynn works for wants to deploy an embedded system that needs to process data as it comes in to the device without processing delays or other interruptions. What type of solution does Lynn\u2019s company need to deploy?",
    "choice_a": "An MFP",
    "choice_b": "A HIPS",
    "choice_c": "An SoC",
    "choice_d": "An RTOS",
    "correct_answer": "D",
    "explanation": "A real-time operating system (RTOS) is an OS that is designed to handle data as it is fed to the operating system, rather than delaying handling it as other processes and programs are run. Real-time operating systems are used when processes or procedures are sensitive to delays that might occur if responses do not happen immediately. An MFP is a multifunction printer, a HIPS is a host intrusion prevention system, and an SoC is a system on a chip\u2014which is hardware, which might run an RTOS, but the option does not mention what type of OS the SoC is running.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      204,
      173,
      201,
      151,
      160
    ],
    "source": "211418_Ch11"
  },
  {
    "id": 234,
    "question": "Which of the following is not a common constraint of an embedded system?",
    "choice_a": "Compute",
    "choice_b": "Cost",
    "choice_c": "Network",
    "choice_d": "Authentication",
    "correct_answer": "B",
    "explanation": "Embedded systems are available at many price points. Understanding constraints that limited resources create for embedded systems helps security professionals identify appropriate security controls and options.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      204,
      173,
      151,
      170,
      160
    ],
    "source": "211418_Ch11"
  },
  {
    "id": 235,
    "question": "Jim configures a Windows machine with the built-in BitLocker full-disk encryption tool that uses a TPM chip. When is the machine least vulnerable to having data stolen from it?",
    "choice_a": "When the machine is off",
    "choice_b": "When the machine is booted and logged in but is locked",
    "choice_c": "When the machine is booted and logged in but is unlocked",
    "choice_d": "When the machine is booted and logged in but is asleep",
    "correct_answer": "A",
    "explanation": "Jim knows that once a BitLocker-enabled machine is booted, the drive is unlocked and could be accessed. He would be least worried if the machine were off and was stolen, or if the drive itself were stolen from the machine, since the data would not be accessible in either of those cases.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      99,
      100,
      198,
      1,
      5
    ],
    "source": "211418_Ch11"
  },
  {
    "id": 236,
    "question": "Olivia wants to install a host-based security package that can detect attacks against the system coming from the network, but she does not want to take the risk of blocking the attacks since she fears that she might inadvertently block legitimate traffic. What type of tool could she install that will meet this requirement?",
    "choice_a": "A host firewall",
    "choice_b": "A host-based intrusion detection system",
    "choice_c": "A host-based intrusion prevention system",
    "choice_d": "A data loss prevention tool",
    "correct_answer": "B",
    "explanation": "Olivia should install a host-based intrusion detection system (HIDS). An HIDS can detect and report on potential attacks but does not have the ability to stop them. A host-based intrusion prevention system (HIPS) can be configured to report only on attacks, but it does have the built-in ability to be set up to block them. Firewalls can block known ports, protocols, or applications, but they do not detect attacks\u2014although advanced modern firewalls blur the line between firewalls and other defensive tools. Finally, a data loss prevention (DLP) tool focuses on preventing data exposures, not on stopping network attacks.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      5,
      282,
      283,
      285
    ],
    "source": "211418_Ch11"
  },
  {
    "id": 237,
    "question": "Anita wants to enforce security settings across her organization\u2019s Windows Active Directory domain. What tool can she use to do this?",
    "choice_a": "EDR",
    "choice_b": "Group Policy",
    "choice_c": "XDR",
    "choice_d": "SELinux",
    "correct_answer": "B",
    "explanation": "Group Policy deployed via Active Directory will allow Anita to set security settings across her domain managed systems. EDR and XDR are useful for detecting and responding to malware and malicious actors but not for deploying security configurations. SELinux is a Linux kernel-based security module that provides additional security capabilities and options on top of existing Linux distributions.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      194,
      196,
      148,
      145,
      92
    ],
    "source": "211418_Ch11"
  },
  {
    "id": 238,
    "question": "Chris wants systems that connect to his network to report their boot processes to a server where they can be validated before being permitted to join the network. What technology should he use to do this on the workstations?",
    "choice_a": "UEFI/Trusted boot",
    "choice_b": "BIOS/Trusted boot",
    "choice_c": "UEFI/Measured boot",
    "choice_d": "BIOS/Measured boot",
    "correct_answer": "C",
    "explanation": "Chris knows that BIOS-based systems do not support either of these modes, and that trusted boot validates every component before loading it, whereas measured boot logs the boot process and sends it to a server that can validate it before permitting the system to connect to the network or perform other actions.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      214,
      133,
      194,
      240,
      246
    ],
    "source": "211418_Ch11"
  },
  {
    "id": 239,
    "question": "Elaine wants to securely erase the contents of a tape used for backups in her organization\u2019s tape library. What is the fastest secure erase method available to her that will allow the tape to be reused?",
    "choice_a": "Using a degausser",
    "choice_b": "Wiping the tape by writing a random pattern of 1s and 0s to it",
    "choice_c": "Incinerating the tape",
    "choice_d": "Wiping the tape by writing all 1s or all 0s to it",
    "correct_answer": "A",
    "explanation": "A degausser is a quick and effective way to erase a tape before it is reused. Wiping a tape by writing 1s, 0s, or a pattern of 1s and 0s to it will typically be a slow operation and is not a common method of destroying data on a tape. Incinerating the tape won\u2019t allow it to be reused!",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      154,
      155,
      318,
      8,
      319
    ],
    "source": "211418_Ch11"
  },
  {
    "id": 240,
    "question": "A system that Tony manages sends an SNMP trap. What type of information should Tony expect to receive?",
    "choice_a": "Notification of a vulnerability",
    "choice_b": "Notification of a patch being installed",
    "choice_c": "Notification of an issue",
    "choice_d": "Notification of user being created",
    "correct_answer": "C",
    "explanation": "SNMP traps can be configured to provide additional information, but typical SNMP traps provide information about issues such as links going down, authentication failures, and reboots.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      246,
      247,
      251,
      22,
      133
    ],
    "source": "211418_Ch12"
  },
  {
    "id": 241,
    "question": "Ben wants to observe malicious behavior targeted at multiple systems on a network. He sets up a variety of systems and instruments to allow him to capture copies of attack tools and to document all the attacks that are conducted. What has he set up?",
    "choice_a": "A honeypot",
    "choice_b": "A beartrap",
    "choice_c": "A honeynet",
    "choice_d": "A tarpit",
    "correct_answer": "C",
    "explanation": "A honeynet is a group of systems that intentionally exposes vulnerabilities so that defenders can observe attacker behaviors, techniques, and tools to help them design better defenses.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      5,
      285,
      146,
      162
    ],
    "source": "211418_Ch12"
  },
  {
    "id": 242,
    "question": "Valerie wants to replace the telnet access that she found still in use in her organization. Which protocol should she use to replace it, and what port will it run on?",
    "choice_a": "SFTP, port 21",
    "choice_b": "SSH, port 22",
    "choice_c": "HTTPS, port 443",
    "choice_d": "RDP, port 3389",
    "correct_answer": "B",
    "explanation": "Telnet provides remote command-line access but is not secure. SSH is the most common alternative to telnet, and it operates on port 22.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      53,
      192,
      132,
      133,
      216
    ],
    "source": "211418_Ch12"
  },
  {
    "id": 243,
    "question": "Jill wants to use DNS filtering to prevent users in her organization from visiting potentially malicious sites. What type of service should she use to obtain this information?",
    "choice_a": "An OSINT service",
    "choice_b": "A STP feed",
    "choice_c": "An ACL monitoring service",
    "choice_d": "A reputation service",
    "correct_answer": "D",
    "explanation": "DNS reputation services can provide Jill with an automated feed of malicious sites that she can include in her DNS filter. OSINT (open source intelligence) is gathered without scans but typically won\u2019t provide DNS block lists. STP (Spanning Tree Protocol) prevents loops in networks and is not relevant to DNS filtering, and an access control monitoring service will not be either.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      223,
      1,
      5,
      146,
      147
    ],
    "source": "211418_Ch12"
  },
  {
    "id": 244,
    "question": "Chuck wants to provide access to a protected network from a less trusted network. What type of solution is commonly implemented to provide a secure, monitored access method?",
    "choice_a": "A proxy server",
    "choice_b": "A jump server",
    "choice_c": "A VLAN",
    "choice_d": "An air gap",
    "correct_answer": "B",
    "explanation": "Jump servers are used to provide secure, monitored access to a protected network. Users log in to the jump server, which then has access to the network. Proxies are used to filter or manage traffic and might be used in this scenario, but jump servers are the preferred answer for most organizations and uses. A VLAN (virtual LAN) is used to logically separate network segments. An air gap is a physical disconnection between networks or devices.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      11,
      212,
      193,
      177,
      211
    ],
    "source": "211418_Ch12"
  },
  {
    "id": 245,
    "question": "Kathleen wants to deploy a firewall that can handle large amounts of network traffic while performing advanced firewalling tasks. What type of device should she select?",
    "choice_a": "A NGFW",
    "choice_b": "A WAF",
    "choice_c": "A UTM",
    "choice_d": "A SD-FW",
    "correct_answer": "A",
    "explanation": "A next-generation firewall (NGFW) device is typically designed and built to be more capable at high speeds and throughput than a universal threat management device. Since UTM devices provide such a wide array of services that consume CPU and memory resources, this performance gap can also sometimes be due to the broad set of services that a UTM device provides. A WAF (web application firewall) is specialized in web traffic, and SD-FW was made up for this question.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      6,
      223,
      225,
      1
    ],
    "source": "211418_Ch12"
  },
  {
    "id": 246,
    "question": "Mark wants to prevent DNS poisoning attacks. What technology should he implement to counter them most effectively?",
    "choice_a": "DNSSEC",
    "choice_b": "SDNS",
    "choice_c": "SASE",
    "choice_d": "SD-WAN",
    "correct_answer": "A",
    "explanation": "DNSSEC validates both the origin of DNS information and ensures that DNS responses have not been modified, making it the best option to help prevent DNS poisoning attacks. SDNS was made up for this question. SASE is used to secure networks in complex multilocation environments, and SD-WAN allows for dynamic wide area networks defined by software, but neither provides this type of DNS security.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      223,
      115,
      107,
      114,
      98
    ],
    "source": "211418_Ch12"
  },
  {
    "id": 247,
    "question": "Casey wants to replace her organization\u2019s MPLS-based external connectivity using commodity technologies. What technology should she select to help her manage this?",
    "choice_a": "IPSec VPN",
    "choice_b": "SASE",
    "choice_c": "SD-WAN",
    "choice_d": "TLS VPN",
    "correct_answer": "C",
    "explanation": "SD-WAN (software-defined wide area network) is commonly used to replace MPLS (Multiprotocol Label Switching) networks, which are typically higher cost than other connectivity options. IPSec and TLS-based VPNs are used to connect through untrusted networks, but they do not provide the functionality required. SASE uses SD-WAN and other technologies to ensure secure connectivity in complex network infrastructures with endpoints in many locations.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      177,
      211,
      169,
      159,
      150
    ],
    "source": "211418_Ch12"
  },
  {
    "id": 248,
    "question": "What protocol is used to securely wrap many otherwise insecure protocols?",
    "choice_a": "ISAKMP",
    "choice_b": "SSL",
    "choice_c": "IKE",
    "choice_d": "TLS",
    "correct_answer": "D",
    "explanation": "Transport Layer Security (TLS) is commonly used to wrap (protect) otherwise insecure protocols. In fact, many of the secure protocols simply add TLS to protect them. ISAKMP and IKE are both used for IPSec and can be used to wrap insecure protocols, but they aren\u2019t used alone. SSL is no longer used; TLS has almost entirely replaced it, although SSL is still often casually referred to as TLS.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      100,
      225,
      224,
      123,
      121
    ],
    "source": "211418_Ch12"
  },
  {
    "id": 249,
    "question": "Valentine wants to deploy a secure version of DHCP for her organization. What should she implement?",
    "choice_a": "S-DHCP",
    "choice_b": "DHCP over TLS",
    "choice_c": "DHCPS",
    "choice_d": "There is no secured version of DHCP.",
    "correct_answer": "D",
    "explanation": "While many protocols have a secure version, DHCP does not have a secure option, and protection must be handled by using detection and response mechanisms, rather than an encrypted protocol.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      223,
      100,
      5,
      111,
      98
    ],
    "source": "211418_Ch12"
  },
  {
    "id": 250,
    "question": "What component of a zero-trust architecture forwards requests from subjects and acts on whether subjects are allowed to access resources?",
    "choice_a": "Policy administrators",
    "choice_b": "Policy enforcement points",
    "choice_c": "Policy engines",
    "choice_d": "Policy gateways",
    "correct_answer": "B",
    "explanation": "Policy enforcement points communicate with policy administrators to forward requests from subjects and to receive instructions from them about connections to allow or end. Policy administrators are components that establish or remove the communication path between subjects and resources, including creating session-specific authentication tokens or credentials as needed. Policy engines make policy decisions based on both rules and external systems. Policy gateways are not reference components for zero-trust designs.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      213,
      11,
      172,
      151,
      9
    ],
    "source": "211418_Ch12"
  },
  {
    "id": 251,
    "question": "Gary wants to use secure protocols for email access for his end users. Which of the following groups of protocols should he implement to accomplish this task?",
    "choice_a": "DKIM, DMARC, HTTPS",
    "choice_b": "SPF, POPS, IMAPS",
    "choice_c": "POPS, IMAPS, HTTPS",
    "choice_d": "DMARC, DKIM, SPF",
    "correct_answer": "C",
    "explanation": "End users may use secure POP (POPS), secure IMAP (IMAPS), and secure HTTP (HTTPS) to retrieve email. SPF, DKIM, and DMARC are used to identify and validate email servers, not to access email by end users.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      223,
      224,
      100,
      123,
      118
    ],
    "source": "211418_Ch12"
  },
  {
    "id": 252,
    "question": "Gary wants to prevent his organization\u2019s most sensitive data from being accessed by network-based attackers at any cost. What solution should he implement to ensure this?",
    "choice_a": "An air gap",
    "choice_b": "Firewall rules",
    "choice_c": "An IPS",
    "choice_d": "IPSec",
    "correct_answer": "A",
    "explanation": "Physical isolation like an air gap is used when the additional work to manually transfer files is an acceptable trade-off against the potential for a security event caused by potential network-based attackers. Firewall rules, an IPS, or the use of IPSec to protect traffic will not sufficiently address this issue if any services remain accessible on the system.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      162,
      5,
      99,
      225,
      223
    ],
    "source": "211418_Ch12"
  },
  {
    "id": 253,
    "question": "Madhuri is designing a load-balancing configuration for her company and wants to keep a single node from being overloaded. What type of design will meet this need?",
    "choice_a": "A daisy chain",
    "choice_b": "Active/active",
    "choice_c": "Duck-duck-goose",
    "choice_d": "Active/passive",
    "correct_answer": "B",
    "explanation": "Active/active designs spread traffic among active nodes, helping ensure that a single node will not be overwhelmed. Active/passive designs are useful for disaster recovery and business continuity, but they do not directly address heavy load on a single node. There are many load-balancing schemes, but daisy chains and duck-duck-goose are not among them.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      217,
      157,
      150,
      151,
      160
    ],
    "source": "211418_Ch12"
  },
  {
    "id": 254,
    "question": "What type of NAC will provide Isaac with the greatest amount of information about the systems that are connecting while also giving him the most amount of control of systems and their potential impact on other systems that are connected to the network?",
    "choice_a": "Agent-based, preadmission NAC",
    "choice_b": "Agentless, postadmission NAC",
    "choice_c": "Agent-based NAC, postadmission NAC",
    "choice_d": "Agentless, postadmission NAC",
    "correct_answer": "A",
    "explanation": "Agent-based, preadmission NAC will provide Isaac with the greatest amount of information about a machine and the most control about what connects to the network and what can impact other systems. Since systems will not be connected to the network, even to a quarantine or preadmission zone, until they have been verified, Isaac will have greater control.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      282,
      285,
      146,
      6,
      5
    ],
    "source": "211418_Ch12"
  },
  {
    "id": 255,
    "question": "Danielle\u2019s organization has implemented a tool that combines SD-WAN, a CASB, and Zero Trust, among other security functions, to provide security regardless of where her organization\u2019s devices are. What type of solution has her organization implemented?",
    "choice_a": "A UTM",
    "choice_b": "An NGFW",
    "choice_c": "IPSec",
    "choice_d": "SASE",
    "correct_answer": "D",
    "explanation": "SASE (Secure Access Service Edge) combines network security and device security by leveraging SD-WAN with security tools like Zero Trust, firewalls, and cloud access security brokers (CASBs). Both UTM and NGFW are advanced firewalls but do not provide this full functionality, and IPSec is a protocol used to provide encryption and authentication for network traffic.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      213,
      218,
      177,
      179,
      151
    ],
    "source": "211418_Ch12"
  },
  {
    "id": 256,
    "question": "Wayne is concerned that an on-path attack has been used against computers he is responsible for. What artifact is he most likely to find associated with this attack?",
    "choice_a": "A compromised router",
    "choice_b": "A browser plug-in",
    "choice_c": "A compromised server",
    "choice_d": "A modified hosts file",
    "correct_answer": "B",
    "explanation": "Browser on-path attacks take advantage of malicious browser plug-ins or proxies to modify traffic at the browser level. They do not involve compromised routers or servers, and a modified hosts file is more likely to be involved in an on-path attack.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      226,
      36,
      227,
      74,
      30
    ],
    "source": "211418_Ch12"
  },
  {
    "id": 257,
    "question": "Elle has scanned her organization from an external IP address and has identified all of the services that are visible from the public Internet. What does this enable her to describe?",
    "choice_a": "If the organization is a fail-open organization",
    "choice_b": "Her organization\u2019s OSINT report",
    "choice_c": "Her organization\u2019s attack surface",
    "choice_d": "If the organization is a fail-closed organization",
    "correct_answer": "C",
    "explanation": "Understanding what services your organization offers to the outside world is an important step in describing the organization\u2019s attack surface. Fail open and fail closed describe what happens when devices or systems fail, not vulnerability and service availability information. OSINT is a passive process and scanning is not a passive activity.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      19,
      82,
      200,
      202,
      203
    ],
    "source": "211418_Ch12"
  },
  {
    "id": 258,
    "question": "What technique is used to ensure that DNSSEC-protected DNS information is trustworthy?",
    "choice_a": "It is digitally signed.",
    "choice_b": "It is sent via TLS.",
    "choice_c": "It is encrypted using AES256.",
    "choice_d": "It is sent via an IPSec VPN.",
    "correct_answer": "A",
    "explanation": "DNSSEC does not encrypt data but does rely on digital signatures to ensure that DNS information has not been modified and that it is coming from a server that the domain owner trusts. DNSSEC does not protect confidentiality, which is a key thing to remember when discussing it as a security option. TLS, an IPSec VPN, or encryption via AES are all potential solutions to protect the confidentiality of network data.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      223,
      115,
      107,
      105,
      98
    ],
    "source": "211418_Ch12"
  },
  {
    "id": 259,
    "question": "Fred wants to ensure that the administrative interfaces for the switches and routers are protected so that they cannot be accessed by attackers. Which of the following solutions should he recommend as part of his organization\u2019s network design?",
    "choice_a": "NAC",
    "choice_b": "Trunking",
    "choice_c": "Out-of-band management",
    "choice_d": "Port security",
    "correct_answer": "C",
    "explanation": "Out-of-band management places the administrative interface of a switch, router, or other device on a separate network or requires direct connectivity to the device to access and manage it. This ensures that an attacker who has access to the network cannot make changes to the network devices. NAC and port security help protect the network itself, whereas trunking is used to combine multiple interfaces, VLANs, or ports together.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      212,
      211,
      11,
      193,
      222
    ],
    "source": "211418_Ch12"
  },
  {
    "id": 260,
    "question": "Alyssa wants to harden iOS devices her organization uses. What set of guidelines can she follow to align to common industry security practices?",
    "choice_a": "OWASP",
    "choice_b": "CIS benchmarks",
    "choice_c": "NIST 800-103",
    "choice_d": "NIST 800-111",
    "correct_answer": "B",
    "explanation": "The Center for Internet Security (CIS) provides hardening guidelines known as CIS benchmarks that Alyssa can use as a guide to secure her organization\u2019s iOS devices. OWASP does not provide these, and NIST provides general guidance, not OS- or device-specific configuration guides.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      236,
      196,
      192,
      194,
      137
    ],
    "source": "211418_Ch13"
  },
  {
    "id": 261,
    "question": "Fred\u2019s company issues devices in a BYOD model. That means that Fred wants to ensure that corporate data and applications are kept separate from personal applications on the devices. What technology is best suited to meet this need?",
    "choice_a": "Biometrics",
    "choice_b": "Full-device encryption",
    "choice_c": "Context-aware authentication",
    "choice_d": "Containerization",
    "correct_answer": "D",
    "explanation": "Using a containerization system can allow Fred\u2019s users to run corporate applications and to use corporate data in a secure environment that cannot be accessed by other applications outside of the container on the device. Containerization schemes for mobile devices typically use encryption and other isolation techniques to ensure that data and applications do not cross over. Biometrics and context-aware authentication are useful for ensuring that the right user is using a device but don\u2019t provide this separation. Full-device encryption helps reduce the risk of theft or loss of a device resulting in a data breach.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      235,
      175,
      11,
      9,
      185
    ],
    "source": "211418_Ch13"
  },
  {
    "id": 262,
    "question": "Michelle has deployed iPads to her staff who work her company\u2019s factory floor. She wants to ensure that the devices work only in the factory and that if they are taken home they cannot access business data or services. What type of solution is best suited to her needs?",
    "choice_a": "Context-aware authentication",
    "choice_b": "Geofencing",
    "choice_c": "Geolocation",
    "choice_d": "Unified endpoint management (UEM)",
    "correct_answer": "B",
    "explanation": "Geofencing will allow Michelle to determine what locations the device should work in. The device will then use geolocation to determine when it has moved and where it is. In this case, the correct answer is therefore geofencing\u2014simply having geolocation capabilities would not provide the solution she needs. Context-aware authentication can help by preventing users from logging in when they aren\u2019t in the correct location, but a device that was logged in may not require reauthentication. Finally, UEM, much like mobile device management, can be used to enforce these policies, but the most correct answer is geofencing.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      238,
      237,
      239,
      236,
      140
    ],
    "source": "211418_Ch13"
  },
  {
    "id": 263,
    "question": "Ivan is running an enterprise wireless network and his heatmap shows that two access points are likely conflicting with each other. What will the enterprise access controller most likely do to handle this conflict?",
    "choice_a": "Increase the broadcast power of one of the access points.",
    "choice_b": "Change the SSID for one of the access points.",
    "choice_c": "Disable one of the access points.",
    "choice_d": "Decrease the broadcast power of the access points.",
    "correct_answer": "D",
    "explanation": "When access points conflict, enterprise wireless network management tools will typically decrease the power for both access points until the issue is resolved. Simply increasing power will cause more conflicts, changing the SSID would not serve typical enterprise models that use a single SSID to allow roaming, and disabling an access point may leave coverage gaps.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      231,
      211,
      150,
      210,
      232
    ],
    "source": "211418_Ch13"
  },
  {
    "id": 264,
    "question": "Chris wants to use geolocation technology to find where phones issued by his organization are located. Which of the following is not commonly used as part of geolocation techniques?",
    "choice_a": "Bluetooth",
    "choice_b": "GPS",
    "choice_c": "NFC",
    "choice_d": "Wi-Fi",
    "correct_answer": "C",
    "explanation": "Nearfield communication (NFC) is not typically used for geolocation because of its extremely short range. Geolocation services may use GPS, Wi-Fi, and Bluetooth to identify areas, access points, Bluetooth beacons, and other items that help with location services.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      238,
      140,
      239,
      214,
      133
    ],
    "source": "211418_Ch13"
  },
  {
    "id": 265,
    "question": "Daniel knows that WPA3 has added a method to ensure that brute-force attacks against weak preshared keys are less likely to succeed. What is this technology called?",
    "choice_a": "SAE",
    "choice_b": "CCMP",
    "choice_c": "PSK",
    "choice_d": "WPS",
    "correct_answer": "A",
    "explanation": "Simultaneous Authentication of Equals (SAE) is used to establish a secure peering environment and to protect session traffic. Since the process requires additional cryptographic steps, it causes brute-force attacks to be much slower and thus less likely to succeed while also providing more security than WPA2\u2019s preshared key (PSK) mode. WPS is Wi-Fi Protected Setup, a quick setup capability; CCMP is the encryption mode used for WPA2 networks. WPA3 moves to 128-bit encryption for Personal mode and can support 192-bit encryption in Enterprise mode.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      233,
      214,
      137,
      140,
      54
    ],
    "source": "211418_Ch13"
  },
  {
    "id": 266,
    "question": "Isabelle needs to select the EAP protocol that she will use with her wireless network. She wants to use a secure protocol that does not require client devices to have a certificate, but she does want to require mutual authentication. Which EAP protocol should she use?",
    "choice_a": "EAP-FAST",
    "choice_b": "EAP-TTLS",
    "choice_c": "PEAP",
    "choice_d": "EAP-TLS",
    "correct_answer": "C",
    "explanation": "Isabelle should select PEAP, which doesn\u2019t require client certificates but does provide TLS support. EAP-TTLS provides similar functionality but requires additional software to be installed on some devices. EAP-FAST focuses on quick reauthentication, and EAP-TLS requires certificates to be deployed to the endpoint devices.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      233,
      214,
      133,
      135,
      134
    ],
    "source": "211418_Ch13"
  },
  {
    "id": 267,
    "question": "Theresa has implemented a technology that keeps data for personal use separate from data for her company on mobile devices used by members of her staff. What is this concept called?",
    "choice_a": "Storage segmentation",
    "choice_b": "Multifactor storage",
    "choice_c": "Full-device encryption",
    "choice_d": "Geofencing",
    "correct_answer": "A",
    "explanation": "Storage segmentation is the concept of splitting storage between functions or usage to ensure that information that fits a specific context is not shared or used by applications or services outside of that context. Full-device encryption encrypts the entire device, geofencing is used to determine geographic areas where actions or events may be taken by software, and multifactor storage was made up for this question.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      235,
      212,
      11,
      318,
      9
    ],
    "source": "211418_Ch13"
  },
  {
    "id": 268,
    "question": "A member of Jake\u2019s team tells him that he sideloaded applications on his Android-based company owned phone. What has occurred?",
    "choice_a": "Malware was installed on the phone.",
    "choice_b": "The phone was rooted to allow administrative access.",
    "choice_c": "Applications were installed by copying them instead of via an app store.",
    "choice_d": "The organization\u2019s MDM was disabled to avoid its management controls.",
    "correct_answer": "C",
    "explanation": "Sideloading is the process of copying files between two devices like a phone and a laptop, desktop, or storage device. Jake\u2019s team member has loaded an application without using the Android application store. Sideloading does not necessarily imply malware, rooting, or disabling an MDM, although an MDM may be configured to prevent sideloading.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      239,
      237,
      238,
      254,
      191
    ],
    "source": "211418_Ch13"
  },
  {
    "id": 269,
    "question": "Madhuri disables SMS, MMS, and RCS on phones in her organization. What has she prevented from being sent?",
    "choice_a": "Phone calls and texts",
    "choice_b": "Text messages and multimedia messages",
    "choice_c": "Text messages and firmware updates",
    "choice_d": "Phone calls and multimedia messages",
    "correct_answer": "B",
    "explanation": "SMS (Short Message Service) is used to send text messages, and MMS and RCS provide additional multimedia features. Neither provides phone calls or firmware updates.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      239,
      141,
      236,
      238,
      252
    ],
    "source": "211418_Ch13"
  },
  {
    "id": 270,
    "question": "What is the most frequent concern that leads to GPS tagging being disabled by some companies via an MDM tool?",
    "choice_a": "Chain of custody",
    "choice_b": "The ability to support geofencing",
    "choice_c": "Privacy",
    "choice_d": "Context-aware authentication",
    "correct_answer": "C",
    "explanation": "Geotagging places a location stamp in documents and pictures that can include position, time, and date. This can be a serious privacy issue when pictures or other information are posted, and many individuals and organizations disable GPS tagging. Organizations may want to enforce GPS tagging for some work products, meaning that the ability to enable or disable it in an MDM tool is quite useful. Chain of custody is a forensic concept, the ability to support geofencing does not require GPS tagging, and context-aware authentication may need geolocation but not GPS tagging.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      318,
      319,
      11,
      9,
      182
    ],
    "source": "211418_Ch13"
  },
  {
    "id": 271,
    "question": "Bart wants to use a cellular hotspot to provide Internet connectivity via Wi-Fi. What type of network has he set up for his laptop and phone to connect to?",
    "choice_a": "Ad-hoc",
    "choice_b": "NFC",
    "choice_c": "Point-to-point",
    "choice_d": "RFID",
    "correct_answer": "A",
    "explanation": "This is an ad-hoc network set up to allow devices to connect to the access point provided by the cellular modem. NFC is a short range, low bandwidth connection method used for payments and similar purposes. Point-to-point connections are used to bridge two networks together or for single connections, this is a multi-device network. RFID uses tags and readers.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      231,
      232,
      212,
      211,
      204
    ],
    "source": "211418_Ch13"
  },
  {
    "id": 272,
    "question": "Susan wants to ensure that the threat of a lost phone creating a data breach is minimized. What two technologies should she implement to do this?",
    "choice_a": "Wi-Fi and NFC",
    "choice_b": "Remote wipe and FDE",
    "choice_c": "Containerization and NFC",
    "choice_d": "Geofencing and remote wipe",
    "correct_answer": "B",
    "explanation": "Susan\u2019s best options are to use a combination of full-device encryption (FDE) and remote wipe. If a device is stolen and continues to be connected to the cellular network, or reconnects at any point, the remote wipe will occur. If it does not, or if attackers attempt to get data from the device and it is locked, the encryption will significantly decrease the likelihood of the data being accessed. Of course, cracking a passcode, PIN, or password remains a potential threat. NFC and Wi-Fi are wireless connection methods and have no influence on data breaches due to loss of a device. Geofencing may be useful for some specific organizations that want to take action if devices leave designated areas, but it is not a general solution. Containerization may shield data, but use of containers does not immediately imply encryption or other protection of the data but simply that the environments are separated.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      235,
      185,
      8,
      10,
      318
    ],
    "source": "211418_Ch13"
  },
  {
    "id": 273,
    "question": "What are the two most commonly deployed biometric authentication solutions for mobile devices?",
    "choice_a": "Voice recognition and face recognition",
    "choice_b": "Fingerprint recognition and gait recognition",
    "choice_c": "Face recognition and fingerprint recognition",
    "choice_d": "Voice recognition and fingerprint recognition",
    "correct_answer": "C",
    "explanation": "Current mobile device implementations have focused heavily on facial recognition via services like Apple\u2019s Face ID and fingerprint recognition like Android\u2019s fingerprint scanning and Apple\u2019s Touch ID. Gait recognition is not a widely deployed biometric technology and would be difficult for most mobile device users to use. Voice recognition as a biometric authenticator has not been broadly deployed for mobile devices, whereas voice-activated services are in wide usage.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      142,
      238,
      140,
      139,
      236
    ],
    "source": "211418_Ch13"
  },
  {
    "id": 274,
    "question": "Alaina wants to modify operating system settings and features on her iOS device and to install applications that are not permitted or available via the Apple App Store. What would she need to do to accomplish this?",
    "choice_a": "Deploy an MDM tool to the phone.",
    "choice_b": "Jailbreak the phone.",
    "choice_c": "Keymod the phone.",
    "choice_d": "Install a third-party operating system.",
    "correct_answer": "B",
    "explanation": "Jailbreaking will allow Alaina to obtain administrator access to the underlying phone operating system and to modify operating system settings and options as well as to install applications that are not available via the App Store. Deploying an MDM does not permit all of this, keymodding is not a term used in this context, and installing a third-party OS would allow access but would change the OS.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      79,
      29,
      28,
      26,
      202
    ],
    "source": "211418_Ch13"
  },
  {
    "id": 275,
    "question": "Jerome wants to allow guests to use his organization\u2019s wireless network, but he does not want to provide a preshared key. What solution can he deploy to gather information such as email addresses or other contact information before allowing users to access his open network?",
    "choice_a": "WPS capture mode",
    "choice_b": "Kerberos",
    "choice_c": "WPA2",
    "choice_d": "A captive portal",
    "correct_answer": "D",
    "explanation": "Jerome should deploy a captive portal that requires users to provide information before being moved to a network segment that allows Internet access. WPS capture mode was made up for this question, Kerberos is used for enterprise authentication, and WPA2 supports open, enterprise, or PSK modes but does not provide the capability Jerome needs by itself.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      233,
      214,
      133,
      134,
      216
    ],
    "source": "211418_Ch13"
  },
  {
    "id": 276,
    "question": "Amanda wants to create a view of her buildings that shows Wi-Fi signal strength and coverage. What is this type of view called?",
    "choice_a": "A channel overlay",
    "choice_b": "A PSK",
    "choice_c": "A heatmap",
    "choice_d": "A SSID chart",
    "correct_answer": "C",
    "explanation": "Amanda wants to create a heatmap, which shows the signal strength and coverage for each access point in a facility. Heatmaps can also be used to physically locate an access point by finding the approximate center of the signal. This can be useful to locate rogue access points and other unexpected or undesired wireless devices. PSK stands for preshared key, a channel overlay is not a commonly used term (although channel overlap is a concern for channels that share bandwidth), and SSID chart was made up for this question.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      59,
      62,
      22,
      41,
      63
    ],
    "source": "211418_Ch13"
  },
  {
    "id": 277,
    "question": "Megan wants to prevent access to phones that are misplaced by members of her organization. Which of the following MDM control options is least likely to help her protect phones that are misplaced?",
    "choice_a": "PINs",
    "choice_b": "Device encryption",
    "choice_c": "Remote wipe",
    "choice_d": "Application management",
    "correct_answer": "D",
    "explanation": "Managing applications won\u2019t help protect a misplaced phone from being accessed. PINs, device encryption, and remote wipe will all help keep her organization\u2019s data and devices secure.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      235,
      9,
      8,
      11,
      182
    ],
    "source": "211418_Ch13"
  },
  {
    "id": 278,
    "question": "Gurvinder wants to select a mobile device deployment method that provides employees with devices that they can use as though they\u2019re personally owned to maximize flexibility and ease of use. Which deployment model should he select?",
    "choice_a": "CYOD",
    "choice_b": "COPE",
    "choice_c": "BYOD",
    "choice_d": "MOTD",
    "correct_answer": "B",
    "explanation": "Gurvinder\u2019s requirements fit the COPE (corporate-owned, personally enabled) mobile device deployment model. Choose your own device (CYOD) allows users to choose a device but then centrally manages it. BYOD allows users to use their own device, rather than have the company provide it, and MOTD means message of the day, and is not a mobile device deployment scheme.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      235,
      151,
      160,
      11,
      182
    ],
    "source": "211418_Ch13"
  },
  {
    "id": 279,
    "question": "Octavia discovers that the contact list from her phone has been acquired via a wireless attack. Which of the following is the most likely culprit?",
    "choice_a": "Bluejacking",
    "choice_b": "An evil maid",
    "choice_c": "Bluesnarfing",
    "choice_d": "An evil twin",
    "correct_answer": "C",
    "explanation": "Bluesnarfing is the theft of information from a Bluetooth enabled device. If Octavia left Bluetooth on and had not properly secured her device, then an attacker may have been able to access her contact list and download its contents. A bluejacking attack occurs when unwanted messages are sent to a device via Bluetooth. Evil twins are malicious access points configured to appear to be legitimate access points, and an evil maid attack is an in-person attack where an attacker takes advantage of physical access to hardware to acquire information or to insert malicious software on a device.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      234,
      229,
      230,
      29,
      202
    ],
    "source": "211418_Ch13"
  },
  {
    "id": 280,
    "question": "The following figure shows the Security+ incident response cycle. What item is missing?<img src=\"/question_assets/Security+/c14uf002.png\"/>",
    "choice_a": "Planning",
    "choice_b": "Reporting",
    "choice_c": "Monitoring",
    "choice_d": "Preparation",
    "correct_answer": "D",
    "explanation": "The first item in the incident response cycle used by the Security+ exam is preparation.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      240,
      243,
      242,
      241,
      250
    ],
    "source": "211418_Ch14"
  },
  {
    "id": 281,
    "question": "Michael analyzes network traffic, including packet content, as part of his incident response process. What tool should he use?",
    "choice_a": "Syslog",
    "choice_b": "NetFlow",
    "choice_c": "Packet capture",
    "choice_d": "A SIEM",
    "correct_answer": "C",
    "explanation": "Packet capture will allow Michael to see all the content of packets that are captured to analyze them. NetFlow simply shows source, destination, protocol, and traffic volume. Syslog and a SIEM don\u2019t capture packet content, and instead focus on logs and events.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      267,
      251,
      246,
      253,
      240
    ],
    "source": "211418_Ch14"
  },
  {
    "id": 282,
    "question": "Susan wants to create a dashboard that shows her aggregated log events related to logins from different geographic regions. Her goal is to identify impossible travel scenarios. Which of the following solutions should she select to accomplish that goal?",
    "choice_a": "IPS",
    "choice_b": "OS logs",
    "choice_c": "SIEM",
    "choice_d": "Vulnerability scan data",
    "correct_answer": "C",
    "explanation": "A SIEM with correlation rules for geographic IP information as well as user IDs and authentication events will accomplish Susan\u2019s goals. An IPS may detect attacks, but it isn\u2019t well suited to detecting impossible travel. OS logs would need to be aggregated, and vulnerability scan data won\u2019t show this at all.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      249,
      246,
      247,
      248,
      250
    ],
    "source": "211418_Ch14"
  },
  {
    "id": 283,
    "question": "Selah wants to ensure that users in her organization can only install applications that are evaluated and approved by the organization\u2019s security team. What should she use?",
    "choice_a": "A SIEM",
    "choice_b": "An application deny list",
    "choice_c": "An application allow list",
    "choice_d": "sFlow",
    "correct_answer": "C",
    "explanation": "Application allow lists are used to ensure that only allowed applications are installable on systems. A deny list specifically identifies programs that aren\u2019t allowed. A SIEM doesn\u2019t provide application management capabilities, and sFlow is a flow tool like NetFlow.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      191,
      254,
      237,
      246,
      249
    ],
    "source": "211418_Ch14"
  },
  {
    "id": 284,
    "question": "What is the primary concern with sFlow in a large, busy network?",
    "choice_a": "It may allow buffer overflow attacks against the collector host.",
    "choice_b": "sFlow is not designed for large or complex networks.",
    "choice_c": "sFlow puts extreme load on the flow collector host.",
    "choice_d": "sFlow samples only network traffic, meaning that some detail will be lost.",
    "correct_answer": "D",
    "explanation": "The primary concern for analysts who deploy sFlow is often that it samples only data, meaning some accuracy and nuance can be lost in the collection of flow data. Sampling, as well as the implementation methods for sFlow, means that it scales well to handle complex and busy networks. Although vulnerabilities may exist in sFlow collectors, a buffer overflow is not a primary concern for them.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      251,
      250,
      240,
      22,
      62
    ],
    "source": "211418_Ch14"
  },
  {
    "id": 285,
    "question": "Mark unplugs the network connection from a system that is part of an incident and places tape over its Ethernet jack with a sign that says, \u201cDo not reconnect without approval from IR team.\u201d How is this method best described?",
    "choice_a": "Containment",
    "choice_b": "Isolation",
    "choice_c": "Segmentation",
    "choice_d": "Zoning",
    "correct_answer": "B",
    "explanation": "Mark has isolated the system by removing it from the network and ensuring that it cannot communicate with other systems. Containment would limit the impact of the incident and might leave the system connected but with restricted or protected access. Segmentation moves systems or groups of systems into zones that have similar purposes, data classification, or other restrictions on them.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      256,
      240,
      241,
      254,
      262
    ],
    "source": "211418_Ch14"
  },
  {
    "id": 286,
    "question": "The company that Ben works for wants to test its incident response plan. Ben gathers the incident response team in a room and walks through a scenario to validate the organization\u2019s processes and procedures. What type of event has Ben hosted?",
    "choice_a": "A checklist exercise",
    "choice_b": "A simulation",
    "choice_c": "A tabletop exercise",
    "choice_d": "A fail-over exercise",
    "correct_answer": "C",
    "explanation": "Ben\u2019s organization is conducting a tabletop exercise. Tabletop exercises are conducted with more flexibility\u2014team members are given a scenario and asked how they would respond and what they would do to accomplish tasks they believe would be relevant. Checklist exercises are not a specific type of exercise. A simulation exercise attempts to more fully re-create an actual incident to test responses. Fail-over exercises are conducted by actually failing a datacenter over to a hot location.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      242,
      243,
      240,
      241,
      246
    ],
    "source": "211418_Ch14"
  },
  {
    "id": 287,
    "question": "Madhuri wants to check a PNG-formatted photo for GPS coordinates. Where can she find that information if it exists in the photo?",
    "choice_a": "In the <code>location.txt</code> file appended to the PNG",
    "choice_b": "On the original camera",
    "choice_c": "In the photo\u2019s metadata",
    "choice_d": "In the photo as a steganographically embedded data field",
    "correct_answer": "C",
    "explanation": "If the photo includes GPS data, it will be included in the photo\u2019s metadata. Madhuri can use a tool like ExifTool to review the metadata for useful information. None of the other options are places where data is stored for a PNG image as a normal practice.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      229,
      69,
      202,
      88,
      244
    ],
    "source": "211418_Ch14"
  },
  {
    "id": 288,
    "question": "Alyssa has identified malware on a system. She removes the system from the network to ensure that it cannot impact other systems. What technique has she used to deal with this system?",
    "choice_a": "Quarantine",
    "choice_b": "Segmentation",
    "choice_c": "Converted it to agentless",
    "choice_d": "Deny listing",
    "correct_answer": "A",
    "explanation": "Alyssa\u2019s has quarantined the machine, ensuring it cannot reach other systems or impact the rest of her organization. Segmentation would involve putting the system in protected network zone. Agentless tools are used to send data without a separate program or agent deployed to allow that. Deny lists are used to prevent specific programs or files from being used or deployed to systems.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      254,
      256,
      240,
      214,
      191
    ],
    "source": "211418_Ch14"
  },
  {
    "id": 289,
    "question": "Kristen discovers missing logs as part of her threat hunting activities. What has most likely happened?",
    "choice_a": "The logs hit the end of their life cycle and were rotated.",
    "choice_b": "The system is a newly deployed system.",
    "choice_c": "An attacker wiped the logs to hide evidence.",
    "choice_d": "An attacker encrypted the logs as part of their process.",
    "correct_answer": "C",
    "explanation": "Missing logs are often associated with an attacker attempting to hide evidence of their actions. Log rotation will typically remove the oldest log items and replace them with new log items rather than wiping a log, or will archive the old log file and create a new one. A newly deployed system typically has at least some logs from booting and running. Encrypting logs would leave a file in place even if it couldn\u2019t be read.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      244,
      29,
      221,
      31,
      16
    ],
    "source": "211418_Ch14"
  },
  {
    "id": 290,
    "question": "Ian has been receiving hundreds of false positive alerts from his SIEM every night when scheduled jobs run across his datacenter. What should he adjust on his SIEM to reduce the false positive rate?",
    "choice_a": "Trend analysis",
    "choice_b": "Sensitivity",
    "choice_c": "Correlation rules",
    "choice_d": "Dashboard configuration",
    "correct_answer": "B",
    "explanation": "Ian\u2019s first step should be changing the sensitivity for his alerts. Adjusting the alerts to ignore safe or expected events can help reduce false positives. Correlation rules may then need to be adjusted if they are matching unrelated items. Dashboards are used to visualize data, not for alerting, and trend analysis is used to feed dashboards and reports.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      248,
      249,
      247,
      250,
      246
    ],
    "source": "211418_Ch14"
  },
  {
    "id": 291,
    "question": "Which team member acts as a primary conduit to senior management on an IR team?",
    "choice_a": "Communications and public relations",
    "choice_b": "Information security",
    "choice_c": "Management",
    "choice_d": "Technical expert",
    "correct_answer": "C",
    "explanation": "Members of management or organizational leadership act as a primary conduit to senior leadership for most incident response teams. They also ensure that difficult or urgent decisions can be made without needing escalated authority. Communications and PR staff focus on internal and external communications but are typically not the direct conduit to leadership. Technical and information security experts do most of the incident response work itself.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      241,
      243,
      257,
      246,
      249
    ],
    "source": "211418_Ch14"
  },
  {
    "id": 292,
    "question": "Dana is reviewing her system\u2019s application logs and notices that a full backup of the application was done at 10 a.m. She knows that the job that runs the backup process is set to run overnight. What indicator should she flag this as?",
    "choice_a": "Unexpected logs",
    "choice_b": "Resource consumption",
    "choice_c": "Resource inaccessibility",
    "choice_d": "Out-of-cycle logging",
    "correct_answer": "D",
    "explanation": "This is an example of out-of-cycle logging, or logging that occurs at a different time than expected. This may be because an attacker is using the backup tool to acquire data. Unexpected logs are not an indicator found on the Security+ exam outline. There is no indication of resource consumption or inaccessibility in the question.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      244,
      25,
      245,
      19,
      12
    ],
    "source": "211418_Ch14"
  },
  {
    "id": 293,
    "question": "Jim wants to view log entries that describe actions taken by applications on a Red Hat Linux system. Which of the following tools can he use on the system to view those logs?",
    "choice_a": "<code>logger</code>",
    "choice_b": "syslog-ng",
    "choice_c": "journalctl",
    "choice_d": "<code>tail</code>",
    "correct_answer": "C",
    "explanation": "Red Hat Enterprise uses journalctl to view journal logs that contain application information. Jim should use journalctl to review the logs for the information he needs. The tool also provides functionality that replicates what <code>head</code> and <code>tail</code> can do for logs. Syslog-ng is a logging infrastructure, and though logs may be sent via syslog-ng, it is not mentioned here. <code>logger</code> is a logging utility used to make entries in the system log.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      253,
      250,
      246,
      240,
      192
    ],
    "source": "211418_Ch14"
  },
  {
    "id": 294,
    "question": "Megan wants to ensure that logging is properly configured for her organization\u2019s Windows workstations. What could she use to ensure that logging best practices are configured?",
    "choice_a": "SIEM",
    "choice_b": "Benchmarks",
    "choice_c": "Syslog",
    "choice_d": "Agents",
    "correct_answer": "B",
    "explanation": "Benchmarks often include logging settings and configurations. SIEM is used to gather and analyze logs. Syslog is a standard for logging and sending logs. Agents are used to send logs for systems that don\u2019t have a logging capability.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      194,
      253,
      246,
      249,
      248
    ],
    "source": "211418_Ch14"
  },
  {
    "id": 295,
    "question": "Chris has turned on logon auditing for a Windows system. Which log will show them?",
    "choice_a": "The Windows Application log",
    "choice_b": "The Windows Security log",
    "choice_c": "The Windows System log",
    "choice_d": "All of the above",
    "correct_answer": "B",
    "explanation": "The Windows Security log records logon events when logon auditing is enabled. The Application and System logs do not contain these events.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      246,
      253,
      249,
      250,
      240
    ],
    "source": "211418_Ch14"
  },
  {
    "id": 296,
    "question": "Jayne wants to determine why a ransomware attack was successful against her organization. She plans to conduct a root cause analysis. Which of the following is not a typical root cause analysis method?",
    "choice_a": "Root/branch review",
    "choice_b": "Five whys",
    "choice_c": "Event analysis",
    "choice_d": "Diagramming",
    "correct_answer": "A",
    "explanation": "Five whys, event analysis, and diagramming are all common methods of performing root cause analysis. Root/branch review is not a typical process for this.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      258,
      240,
      270,
      269,
      262
    ],
    "source": "211418_Ch14"
  },
  {
    "id": 297,
    "question": "Hitesh wants to keep a system online but limit the impact of the malware that was found on it while an investigation occurs. What method from the following list should he use?",
    "choice_a": "Containment",
    "choice_b": "Isolation",
    "choice_c": "Segmentation",
    "choice_d": "Black holing",
    "correct_answer": "A",
    "explanation": "Containment activities focus on preventing further malicious actions or attacks. In this case, Hitesh might opt to prevent the malware from spreading but leave the system online due to a critical need or a desire to preserve memory and other artifacts for investigation. Isolation walls a system or systems off from the rest of the world, whereas segmentation is frequently used before incidents occur to create zones or segments of a network or system with different security levels and purposes.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      256,
      240,
      254,
      262,
      250
    ],
    "source": "211418_Ch14"
  },
  {
    "id": 298,
    "question": "What phase in the incident response process leverages indicators of compromise and log analysis as part of a review of events?",
    "choice_a": "Preparation",
    "choice_b": "Containment",
    "choice_c": "Eradication",
    "choice_d": "Identification",
    "correct_answer": "D",
    "explanation": "The Analysis phase focuses on using various techniques to analyze events to identify potential incidents. Preparation focuses on building tools, processes, and procedures to respond to incidents. Eradication involves the removal of artifacts related to the incident, and containment limits the scope and impact of the incident.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      240,
      250,
      22,
      259,
      246
    ],
    "source": "211418_Ch14"
  },
  {
    "id": 299,
    "question": "Henry wants to check to see if services were installed by an attacker. What commonly gathered organizational data can he use to see if a new service appeared on systems?",
    "choice_a": "Registry dumps from systems throughout his organization",
    "choice_b": "Firewall logs",
    "choice_c": "Vulnerability scans",
    "choice_d": "Flow logs",
    "correct_answer": "C",
    "explanation": "Vulnerability scans are the best way to find new services that are offered by systems. In fact, many vulnerability scanners will flag new services when they appear, allowing administrators to quickly notice unexpected new services. Registry information is not regularly dumped or collected in most organizations. Firewall logs and flow logs could show information about the services being used by systems whose traffic passes through them, but this is a less useful and accurate way of identifying new services and would work only if those services were also being used.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      43,
      42,
      63,
      48,
      246
    ],
    "source": "211418_Ch14"
  },
  {
    "id": 300,
    "question": "Felix wants to make an exact copy of a drive using a Linux command-line tool as part of a forensic acquisition process. What command should he use?",
    "choice_a": "<code>df</code>",
    "choice_b": "<code>cp</code>",
    "choice_c": "<code>dd</code>",
    "choice_d": "<code>ln</code>",
    "correct_answer": "C",
    "explanation": "<code>dd</code> is a copying and conversion command for Linux and can be used to create a forensic image that can be validated using an MD5sum or SHA1 hash. The other commands are <code>df</code> for disk usage, <code>cp</code> for copying files, and <code>ln</code> to link files.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      264,
      259,
      263,
      265,
      268
    ],
    "source": "211418_Ch15"
  },
  {
    "id": 301,
    "question": "Greg is preparing a forensic report and needs to describe the tools that were used. What should he report about the tools in addition to their names?",
    "choice_a": "The type of system the tools were installed or run on",
    "choice_b": "The training level or certifications of the team that uses the tools",
    "choice_c": "Any known limitations or issues with the tools",
    "choice_d": "The patch level or installed version of the tools",
    "correct_answer": "C",
    "explanation": "If there are known limitations or issues with the tools used, this should be included in the report. The type of system the tool was installed on may influence performance but should not influence the report or output. Training and certification may be listed as part of a team description but are not required as part of tool description. Finally, patch levels or installed versions are not critical unless there are known issues that would have been described as such.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      270,
      264,
      241,
      240,
      250
    ],
    "source": "211418_Ch15"
  },
  {
    "id": 302,
    "question": "Gabby is preparing chain-of-custody documentation and identifies a gap in hand-off documentation for an original source forensic drive. What issue should she expect to encounter due to this gap?",
    "choice_a": "The evidence may not be admissible in court.",
    "choice_b": "The forensic activities may need to be repeated.",
    "choice_c": "The staff involved may have to re-create the missed log.",
    "choice_d": "The chain of custody may need to be edited to note the problem.",
    "correct_answer": "A",
    "explanation": "If forensic evidence was not properly handled, it may not be admissible in court. Repeating forensic activities won\u2019t reverse mishandling, staff can\u2019t go back and re-create logs, and noting the issue will not resolve it.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      263,
      259,
      265,
      260,
      264
    ],
    "source": "211418_Ch15"
  },
  {
    "id": 303,
    "question": "Mike\u2019s organization has recently moved to a SaaS cloud service and needs to collect forensic data from the cloud service. What process can Mike use to gather the information he needs?",
    "choice_a": "Install forensic imaging software on the cloud service\u2019s servers.",
    "choice_b": "Identify the log information available and request any other desired information from the cloud service provider.",
    "choice_c": "Engage law enforcement to acquire the forensic data.",
    "choice_d": "Request the forensic information from third-party auditors.",
    "correct_answer": "B",
    "explanation": "Mike\u2019s best option is to identify the log information available from the provider and to request any additional information knowing that he may not receive more detail unless there is contractual language that specifies it. SaaS vendors typically won\u2019t allow installation of forensic tools, law enforcement does not perform forensic acquisition for third parties upon request, and auditors don\u2019t provide forensic data acquisition either.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      266,
      171,
      250,
      246,
      259
    ],
    "source": "211418_Ch15"
  },
  {
    "id": 304,
    "question": "Charles wants to obtain a forensic copy of a running virtual machine. What technique should he use to capture the image?",
    "choice_a": "Run <code>dd</code> from within the running machine.",
    "choice_b": "Use FTK Imager from the virtual machine host.",
    "choice_c": "Use the VM host to create a snapshot.",
    "choice_d": "Use WinHex to create a copy from within the running machine.",
    "correct_answer": "C",
    "explanation": "Creating a snapshot will provide a complete copy of the system, including memory state that can then be analyzed for forensic purposes. Copying a running system from a program running within that system can be problematic, since the system itself will change while it is trying to copy itself. FTK Imager can copy drives and files, but it would not handle a running virtual machine.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      264,
      262,
      263,
      261,
      268
    ],
    "source": "211418_Ch15"
  },
  {
    "id": 305,
    "question": "Melissa wants to capture network traffic for forensic purposes. What tool should she use to capture it?",
    "choice_a": "A forensic suite",
    "choice_b": "Wireshark",
    "choice_c": "dd",
    "choice_d": "WinHex",
    "correct_answer": "B",
    "explanation": "Even though Wireshark is not a dedicated network forensic tool, since network traffic is ephemeral, capturing it with a packet sniffer like Wireshark is Melissa\u2019s best option. Forensic suites are useful for analyzing captured images, not capturing network traffic, and dd and WinHex are both useful for packet capture, but not for network traffic analysis.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      267,
      262,
      259,
      264,
      246
    ],
    "source": "211418_Ch15"
  },
  {
    "id": 306,
    "question": "Frank is concerned about the admissibility of his forensic data. Which of the following is not an element he should be concerned about?",
    "choice_a": "Whether the forensic source data has remained unaltered",
    "choice_b": "Whether the practices and procedures would survive review by experts",
    "choice_c": "Whether the evidence is relevant to the case",
    "choice_d": "Whether the forensic information includes a time stamp",
    "correct_answer": "D",
    "explanation": "Forensic information does not have to include a time stamp to be admissible, but time stamps can help build a case that shows when events occurred. Files without a time stamp may still show other information that is useful to the case or may have other artifacts associated with them that can provide context about the time and date.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      263,
      259,
      264,
      252,
      270
    ],
    "source": "211418_Ch15"
  },
  {
    "id": 307,
    "question": "What is the document that tracks the custody or control of a piece of evidence called?",
    "choice_a": "Evidence log",
    "choice_b": "Audit log",
    "choice_c": "Event report",
    "choice_d": "Chain of custody",
    "correct_answer": "D",
    "explanation": "Chain-of-custody documentation tracks evidence throughout its life cycle, with information about who has custody or control and when transfers happened, and continues until the evidence is removed from the legal process and disposed of. The other terms are not used for this practice.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      263,
      259,
      262,
      270,
      260
    ],
    "source": "211418_Ch15"
  },
  {
    "id": 308,
    "question": "Isaac is performing a forensic analysis on two systems that were compromised in the same event in the same facility. As he performs his analysis, he notices that the event appears to have happened almost exactly one hour earlier on one system than the other. What is the most likely issue he has encountered?",
    "choice_a": "The attacker took an hour to get to the second system.",
    "choice_b": "One system is set to an incorrect time zone.",
    "choice_c": "The attacker changed the system clock to throw off forensic practitioners.",
    "choice_d": "The forensic tool is reading the time stamps incorrectly.",
    "correct_answer": "B",
    "explanation": "The most common cause of an hour of difference between two systems in an environment is an incorrectly set time zone. Isaac should check the time zone settings, and then correct his findings based on the time zones set on the systems if necessary.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      269,
      262,
      250,
      258,
      240
    ],
    "source": "211418_Ch15"
  },
  {
    "id": 309,
    "question": "What legal concept determines the law enforcement agency or agencies that will be involved in a case based on location?",
    "choice_a": "Nexus",
    "choice_b": "Nonrepudiation",
    "choice_c": "Jurisdiction",
    "choice_d": "Admissibility",
    "correct_answer": "C",
    "explanation": "Jurisdiction is the legal authority over an area or individuals based on laws that create the jurisdiction. Nexus defines whether a relationship or connection exists, such as a local branch or business location. Non-repudiation ensures that evidence or materials can be connected to their originator. Admissibility determines whether evidence can be used in court.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      261,
      263,
      266,
      240,
      241
    ],
    "source": "211418_Ch15"
  },
  {
    "id": 310,
    "question": "Michael wants to acquire the firmware from a running device for analysis. What method is most likely to succeed?",
    "choice_a": "Use forensic memory acquisition techniques.",
    "choice_b": "Use disk forensic acquisition techniques.",
    "choice_c": "Remove the firmware chip from the system.",
    "choice_d": "Shut down the system and boot to the firmware to copy it to a removable device.",
    "correct_answer": "A",
    "explanation": "Firmware can be challenging to access, but both memory forensic techniques and direct hardware interface access are viable means in some cases. Firmware is not typically stored on the disk and instead is stored in a BIOS or UEFI chip. Removing the chip from the system will leave it unable to run and thus this is not a preferred method. Also, many chips are not removable. Shutting down the device and booting it to the firmware does not provide a means of copying the firmware for most devices. Although the firmware is likely to allow updates, most do not allow downloads or copying.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      264,
      262,
      270,
      271,
      199
    ],
    "source": "211418_Ch15"
  },
  {
    "id": 311,
    "question": "Charles needs to know about actions an individual performed on a PC. What is the best starting point to help him identify those actions?",
    "choice_a": "Review the system log.",
    "choice_b": "Review the event log.",
    "choice_c": "Interview the individual.",
    "choice_d": "Analyze the system\u2019s keystroke log.",
    "correct_answer": "C",
    "explanation": "Although it may be tempting to use a technical answer, interviewing the individual involved is the best starting point when a person performed actions that need to be reviewed. Charles can interview the staff member, and then move on to technical means to validate their responses. System and event logs may have some clues to what occurred, but normal systems do not maintain a keystroke log. In fact, the closest normal element is the command log used by both Windows and Linux to allow command-line input to be recalled as needed.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      241,
      261,
      269,
      262,
      260
    ],
    "source": "211418_Ch15"
  },
  {
    "id": 312,
    "question": "Maria has acquired a disk image from a hard drive using dd, and she wants to ensure that her process is forensically sound. What should her next step be after completing the copy?",
    "choice_a": "Securely wipe the source drive.",
    "choice_b": "Compare the hashes of the source and target drive.",
    "choice_c": "Securely wipe the target drive.",
    "choice_d": "Update her chain-of-custody document.",
    "correct_answer": "B",
    "explanation": "Once a copy is made, hashes for the original and target drive should be compared to ensure that the copy was successful. After that, the chain-of-custody document can be updated to note that a copy was made and will be tracked as it is analyzed while the original is preserved. Wiping either drive after a copy is not part of the process, although a target drive may be wiped after a case is complete.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      265,
      262,
      269,
      270,
      144
    ],
    "source": "211418_Ch15"
  },
  {
    "id": 313,
    "question": "Alex has been handed a flash media device that was quick-formatted and has been asked to recover the data. What data will remain on the drive?",
    "choice_a": "No data will remain on the drive.",
    "choice_b": "Files will remain but file indexes will not.",
    "choice_c": "File indexes will remain, but the files will be gone.",
    "choice_d": "Files and file indexes will remain on the drive.",
    "correct_answer": "B",
    "explanation": "Quick-formatting a drive removes the file indexes but leaves the file content on the drive. Recovery tools look for those files on the drive and piece them back together using metadata, headers, and other clues that help to recover the files.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      268,
      252,
      270,
      250,
      249
    ],
    "source": "211418_Ch15"
  },
  {
    "id": 314,
    "question": "Naomi is preparing to migrate her organization to a cloud service and wants to ensure that she has the appropriate contractual language in place. Which of the following is not a common item she should include?",
    "choice_a": "Right-to-audit clauses",
    "choice_b": "Right to forensic examination",
    "choice_c": "Choice of jurisdiction",
    "choice_d": "Data breach notification timeframe",
    "correct_answer": "B",
    "explanation": "Contracts commonly include right to audit, choice of jurisdiction, and data breach notification time frame clauses, but a right to forensically examine a vendor\u2019s systems or devices is rarely included. Naomi may want to ask about their incident response process and for examples of previous breach notification and incident documentation shared with customers instead.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      266,
      171,
      243,
      259,
      263
    ],
    "source": "211418_Ch15"
  },
  {
    "id": 315,
    "question": "Alaina wants to maintain chain-of-custody documentation and has created a form. Which of the following is not a common element on a chain-of-custody form?",
    "choice_a": "Item identifier number",
    "choice_b": "Signature of the person transferring the item",
    "choice_c": "Signature of the person receiving the item",
    "choice_d": "Method of transport",
    "correct_answer": "D",
    "explanation": "Chain of custody tracks who has an item, how it is collected, where it is stored and how, how it is secured or protected, who collected it, and transfers, but it does not typically include how the items were transported because that is not relevant if the other data is provided.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      263,
      259,
      265,
      270,
      261
    ],
    "source": "211418_Ch15"
  },
  {
    "id": 316,
    "question": "Henry is following the EDRM model and is preparing to review data. What two key tasks occur during this stage?",
    "choice_a": "Validating that time stamps match between systems and that data is properly hashed to confirm that original data is sent",
    "choice_b": "Validating that the legal hold request is valid and that all documented items are included",
    "choice_c": "Validating that the desired data is included and that information that should not be shared is not included",
    "choice_d": "Validating that chain of custody is ensured and that malicious files are not included",
    "correct_answer": "C",
    "explanation": "It is important to ensure that data prepared for e-discovery only contains what it is supposed to, and that information that should not be shared is not included. Time stamps, hashing, chain of custody, and ensuring malicious files are not included are not part of the EDRM model. Validating that a legal hold is valid should happen before preservation, but validating that documented items from the hold are included if they exist should occur.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      261,
      260,
      265,
      263,
      270
    ],
    "source": "211418_Ch15"
  },
  {
    "id": 317,
    "question": "Theresa\u2019s organization has received a legal hold notice for their files and documents. Which of the following is <i>not</i> an action she needs to take?",
    "choice_a": "Ensure that changes to existing documents related to the case are tracked and that originals can be provided.",
    "choice_b": "Preserve all existing documents relevant to the case.",
    "choice_c": "Delete all sensitive documents related to the case.",
    "choice_d": "Prevent backups that contain files related to the case from being overwritten on their normal schedule.",
    "correct_answer": "C",
    "explanation": "Removing information relevant to a legal hold is exactly what the hold is intended to prevent. Theresa\u2019s organization could be in serious legal trouble if they were to intentionally purge or change related information.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      260,
      208,
      263,
      207,
      268
    ],
    "source": "211418_Ch15"
  },
  {
    "id": 318,
    "question": "Gurvinder wants to follow the order of volatility to guide his forensic data acquisition. Which of the following is the least volatile?",
    "choice_a": "RAM",
    "choice_b": "Data on the hard drive",
    "choice_c": "Backups",
    "choice_d": "Remote logs",
    "correct_answer": "C",
    "explanation": "Backups are the least volatile of these options according to the order of volatility. Backups will be kept until they are aged out, which may be days, weeks, or even months in some cases. From most to least volatile, these are RAM, data on the hard drive, remote logs, and then backups.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      262,
      264,
      263,
      240,
      250
    ],
    "source": "211418_Ch15"
  },
  {
    "id": 319,
    "question": "What is the key difference between hashing and checksums?",
    "choice_a": "Both can validate integrity, but a hash also provides a unique digital fingerprint.",
    "choice_b": "A hash can be reversed, and a checksum cannot be.",
    "choice_c": "Checksums provide greater security than hashing.",
    "choice_d": "Checksums have fewer message collisions than a hash.",
    "correct_answer": "A",
    "explanation": "Although both a checksum and a hash can be used to validate message integrity, a hash has fewer collisions than a checksum and will also provide a unique fingerprint for a file. Checksums are primarily used as a quick means of checking that that integrity is maintained, whereas hashes are used for many other purposes such as secure password validation without retaining the original password. A checksum would not be useful for proving a forensic image was identical, but it could be used to ensure that your work had not changed the contents of the drive.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      265,
      264,
      263,
      268,
      262
    ],
    "source": "211418_Ch15"
  },
  {
    "id": 320,
    "question": "Joe is authoring a document that explains to system administrators one way in which they might comply with the organization\u2019s requirement to encrypt all laptops. What type of document is Joe writing?",
    "choice_a": "Policy",
    "choice_b": "Guideline",
    "choice_c": "Procedure",
    "choice_d": "Standard",
    "correct_answer": "B",
    "explanation": "The key phrase in this scenario is \u201cone way.\u201d This indicates that compliance with the document is not mandatory, so Joe must be authoring a guideline. Policies, standards, and procedures are all mandatory.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      275,
      278,
      280,
      273,
      295
    ],
    "source": "211418_Ch16"
  },
  {
    "id": 40,
    "question": "Which one of the following statements is not true about compensating controls under PCI DSS?",
    "choice_a": "Controls used to fulfill one PCI DSS requirement may be used to compensate for the absence of a control needed to meet another requirement.",
    "choice_b": "Controls must meet the intent of the original requirement.",
    "choice_c": "Controls must meet the rigor of the original requirement.",
    "choice_d": "Compensating controls must provide a similar level of defense as the original requirement.",
    "correct_answer": "A",
    "explanation": "PCI DSS compensating controls must be \u201cabove and beyond\u201d other PCI DSS requirements. This specifically bans the use of a control used to meet one requirement as a compensating control for another requirement.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      5,
      285,
      284,
      162
    ],
    "source": "211418_Ch16"
  },
  {
    "id": 321,
    "question": "What law creates privacy obligations for those who handle the personal information of European Union residents?",
    "choice_a": "HIPAA",
    "choice_b": "FERPA",
    "choice_c": "GDPR",
    "choice_d": "PCI DSS",
    "correct_answer": "C",
    "explanation": "The General Data Protection Regulation (GDPR) implements privacy requirements for handling the personal information of EU residents. The Health Insurance Portability and Accountability Act (HIPAA) includes security and privacy rules that affect health-care providers, health insurers, and health information clearinghouses. The Family Educational Rights and Privacy Act (FERPA) applies to educational institutions. The Payment Card Industry Data Security Standard (PCI DSS) applies to credit and debit card information.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      292,
      320,
      4,
      293,
      298
    ],
    "source": "211418_Ch16"
  },
  {
    "id": 322,
    "question": "Which one of the following is <i>not</i> one of the five core security functions defined by the NIST Cybersecurity Framework?",
    "choice_a": "Identify",
    "choice_b": "Contain",
    "choice_c": "Respond",
    "choice_d": "Recover",
    "correct_answer": "B",
    "explanation": "The five security functions described in the NIST Cybersecurity Framework are identify, protect, detect, respond, and recover.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      296,
      292,
      273,
      309,
      310
    ],
    "source": "211418_Ch16"
  },
  {
    "id": 323,
    "question": "What ISO standard provides guidance on privacy controls?",
    "choice_a": "27002",
    "choice_b": "27001",
    "choice_c": "27701",
    "choice_d": "31000",
    "correct_answer": "C",
    "explanation": "The International Organization for Standardization (ISO) publishes ISO 27701, covering privacy controls. ISO 27001 and 27002 cover cybersecurity, and ISO 31000 covers risk management.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      1,
      5,
      6,
      146,
      147
    ],
    "source": "211418_Ch16"
  },
  {
    "id": 324,
    "question": "Which one of the following documents must normally be approved by the CEO or similarly high-level executive?",
    "choice_a": "Standard",
    "choice_b": "Procedure",
    "choice_c": "Guideline",
    "choice_d": "Policy",
    "correct_answer": "D",
    "explanation": "Policies require approval from the highest level of management, usually the CEO. Other documents may often be approved by other managers, such as the CISO.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      276,
      275,
      272,
      274,
      277
    ],
    "source": "211418_Ch16"
  },
  {
    "id": 325,
    "question": "Greg would like to create an umbrella agreement that provides the security terms and conditions for all future work that his organization does with a vendor. What type of agreement should Greg use?",
    "choice_a": "BPA",
    "choice_b": "MOU",
    "choice_c": "MSA",
    "choice_d": "SLA",
    "correct_answer": "C",
    "explanation": "Master service agreements (MSAs) provide an umbrella contract for the work that a vendor does with an organization over an extended period of time. The MSA typically includes detailed security and privacy requirements. Each time the organization enters into a new project with the vendor, they may then create a statement of work (SOW) that contains project-specific details and references the MSA.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      289,
      287,
      290,
      286,
      291
    ],
    "source": "211418_Ch16"
  },
  {
    "id": 326,
    "question": "What organization is known for creating independent security benchmarks covering hardware and software platforms from many different vendors?",
    "choice_a": "Microsoft",
    "choice_b": "Center for Internet Security",
    "choice_c": "Cloud Security Alliance",
    "choice_d": "Cisco",
    "correct_answer": "B",
    "explanation": "All of these organizations produce security standards and benchmarks. However, only the Center for Internet Security (CIS) is known for producing independent benchmarks covering a wide variety of software and hardware.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      299,
      298,
      277,
      275,
      287
    ],
    "source": "211418_Ch16"
  },
  {
    "id": 327,
    "question": "What do many organizations use to schedule and coordinate changes for information systems?",
    "choice_a": "Impact analysis",
    "choice_b": "Backout plans",
    "choice_c": "Maintenance windows",
    "choice_d": "Version control",
    "correct_answer": "C",
    "explanation": "Many organizations use scheduled maintenance windows to coordinate changes to information systems. These windows are preplanned and announced times when all non-emergency changes will take place and often occur on evenings and weekends. A change management process ensures that personnel can perform a security impact analysis. Experts evaluate changes to identify any security impacts before personnel deploy the changes in a production environment. A backout plan allows personnel to undo the change and return the system to its previous state if necessary. Version control ensures that developers and users have access to the latest versions of software and that changes are carefully managed throughout the release process.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      282,
      284,
      285,
      6,
      5
    ],
    "source": "211418_Ch16"
  },
  {
    "id": 328,
    "question": "Which one of the following would <i>not</i> normally be found in an organization\u2019s information security policy?",
    "choice_a": "Statement of the importance of cybersecurity",
    "choice_b": "Requirement to use AES-256 encryption",
    "choice_c": "Delegation of authority",
    "choice_d": "Designation of responsible executive",
    "correct_answer": "B",
    "explanation": "Security policies do not normally contain prescriptive technical guidance, such as a requirement to use a specific encryption algorithm. This type of detail would normally be found in a security standard.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      275,
      276,
      277,
      278,
      279
    ],
    "source": "211418_Ch16"
  },
  {
    "id": 329,
    "question": "Alice, an IT security manager at Acme Corporation, decides to conduct an exercise to test the employees\u2019 ability to recognize phishing emails. She creates fake phishing messages and sends them to the employees. When employees click on the links in the fake messages, they are redirected to a training program. What is the primary purpose of the exercise that Alice is conducting?",
    "choice_a": "To penalize the employees who click on the phishing links",
    "choice_b": "To reward employees who identify the fake phishing messages",
    "choice_c": "To test employees\u2019 ability to recognize phishing messages and help them improve",
    "choice_d": "To gather data for a report on the most gullible departments",
    "correct_answer": "C",
    "explanation": "Alice\u2019s exercise is designed to evaluate how well employees can identify phishing messages and, if they fail to do so, redirect them to a training program that is meant to help them get better at recognizing such messages. The exercise is meant for educational purposes and not for penalizing employees. It is intended to help them improve their skills in recognizing phishing emails. While rewarding employees for identifying phishing emails could be a component of a security awareness program, the exercise described is primarily educational and is focused on helping those who fail to recognize the phishing messages. While data might be collected for analysis and understanding areas where improvement is needed, the intention is not to label departments as gullible.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      301,
      302,
      300,
      310,
      305
    ],
    "source": "211418_Ch16"
  },
  {
    "id": 330,
    "question": "Tonya discovers that an employee is running a side business from his office, using company technology resources. What policy would most likely contain information relevant to this situation?",
    "choice_a": "NDA",
    "choice_b": "AUP",
    "choice_c": "Data ownership",
    "choice_d": "Data classification",
    "correct_answer": "B",
    "explanation": "An organization\u2019s acceptable use policy (AUP) should contain information on what constitutes allowable and unallowable use of company resources. This policy should contain information to help guide Tonya\u2019s next steps.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      276,
      275,
      279,
      300,
      273
    ],
    "source": "211418_Ch16"
  },
  {
    "id": 331,
    "question": "What compliance obligation applies to merchants and service providers who work with credit card information?",
    "choice_a": "FERPA",
    "choice_b": "SOX",
    "choice_c": "HIPAA",
    "choice_d": "PCI DSS",
    "correct_answer": "D",
    "explanation": "The Payment Card Industry Data Security Standard (PCI DSS) provides detailed rules about the storage, processing, and transmission of credit and debit card information. PCI DSS is not a law but rather a contractual obligation that applies to credit card merchants and service providers.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      292,
      280,
      7,
      295,
      289
    ],
    "source": "211418_Ch16"
  },
  {
    "id": 332,
    "question": "Mike is an information security manager at TechRise Solutions. The company has been experiencing an increase in security incidents, and senior management is concerned about the security posture of the organization. They have asked Mike to take proactive measures to strengthen the company\u2019s security culture. What should be Mike\u2019s primary role in enhancing the security awareness and training at TechRise Solutions?",
    "choice_a": "To delegate all security responsibilities to the HR department",
    "choice_b": "To establish, promote, and maintain security training and awareness programs",
    "choice_c": "To create and distribute security awareness posters",
    "choice_d": "To personally conduct security training sessions for all employees",
    "correct_answer": "B",
    "explanation": "As an information security manager, Mike\u2019s primary role would be to establish an effective security training and awareness program, promote it within the organization, and ensure it is maintained effectively to foster a security-conscious culture among employees. This aligns with a proactive approach to reducing security incidents.<br>Mike should take an active role in security training and awareness, rather than delegating all responsibilities to another department. While HR may be involved, Mike\u2019s expertise is crucial in establishing effective programs.<br>Although security awareness posters and training sessions are two components of security awareness efforts, Mike\u2019s role should be much broader, encompassing the establishment, promotion, and maintenance of comprehensive training and awareness programs.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      302,
      301,
      273,
      276,
      298
    ],
    "source": "211418_Ch16"
  },
  {
    "id": 333,
    "question": "Colin would like to implement a security control in his accounting department that is specifically designed to detect cases of fraud that are able to occur despite the presence of other security controls. Which one of the following controls is best suited to meet Colin\u2019s need?",
    "choice_a": "Separation of duties",
    "choice_b": "Least privilege",
    "choice_c": "Dual control",
    "choice_d": "Mandatory vacations",
    "correct_answer": "D",
    "explanation": "Mandatory vacations are designed to force individuals to take time away from the office to allow fraudulent activity to come to light in their absence. The other controls listed here (separation of duties, least privilege, and dual control) are all designed to prevent, rather than detect, fraud.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      285,
      5,
      283,
      1
    ],
    "source": "211418_Ch16"
  },
  {
    "id": 334,
    "question": "Which one of the following security policy framework components does not contain mandatory guidance for individuals in the organization?",
    "choice_a": "Policy",
    "choice_b": "Standard",
    "choice_c": "Procedure",
    "choice_d": "Guideline",
    "correct_answer": "D",
    "explanation": "Guidelines are the only element of the security policy framework that is optional. Compliance with policies, standards, and procedures is mandatory.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      275,
      279,
      277,
      278,
      273
    ],
    "source": "211418_Ch16"
  },
  {
    "id": 335,
    "question": "Rachel is the Head of Security at WebCraft Inc. She wants to create both security training and awareness programs. Which statement best captures the difference between these programs?",
    "choice_a": "Security training requires time to learn new material, whereas awareness efforts use techniques like posters and emails to remind employees of security lessons.",
    "choice_b": "Security training involves giving rewards to employees, whereas awareness efforts involve punishments.",
    "choice_c": "There is no difference; both terms can be used interchangeably.",
    "choice_d": "Security training is for security team members only, whereas security awareness is for all employees.",
    "correct_answer": "A",
    "explanation": "Security training typically involves structured and formal programs where employees learn new security concepts and practices. In contrast, security awareness efforts are more informal and aim to keep security principles top-of-mind for employees through reminders, without requiring them to engage in formal learning.<br>The idea that security training involves giving rewards to employees and awareness efforts involve punishments is not accurate. Security training is meant to educate employees on security concepts and practices, not to serve as a platform for rewards. Similarly, awareness efforts are not punitive; they serve to remind and reinforce security principles among employees. The statement that there is no difference between security training and awareness efforts and that both terms can be used interchangeably is also incorrect. There is a distinct difference between the two in terms of their structure and purpose, as explained in the correct answer. Lastly, the notion that security training is only for security team members while security awareness is for all employees is not true. Security training is important for all employees, depending on their roles and responsibilities, to ensure they understand the security protocols and policies. Security awareness, on the other hand, is a continual reminder for all employees, including the security team, to stay vigilant and informed about security practices.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      302,
      300,
      301,
      273,
      286
    ],
    "source": "211418_Ch16"
  },
  {
    "id": 336,
    "question": "Allan is developing a document that lists the acceptable mechanisms for securely obtaining remote administrative access to servers in his organization. What type of document is Allan writing?",
    "choice_a": "Policy",
    "choice_b": "Standard",
    "choice_c": "Guideline",
    "choice_d": "Procedure",
    "correct_answer": "B",
    "explanation": "Standards describe specific security controls that must be in place for an organization. Allan would not include acceptable mechanisms in a high-level policy document, and this information is too general to be useful as a procedure. Guidelines are not mandatory, so they would not be applicable in this scenario.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      275,
      277,
      279,
      276,
      281
    ],
    "source": "211418_Ch16"
  },
  {
    "id": 337,
    "question": "Which one of the following is not a common use of the NIST Cybersecurity Framework?",
    "choice_a": "Describe the current cybersecurity posture of an organization.",
    "choice_b": "Describe the target future cybersecurity posture of an organization.",
    "choice_c": "Communicate with stakeholders about cybersecurity risk.",
    "choice_d": "Create specific technology requirements for an organization.",
    "correct_answer": "D",
    "explanation": "The NIST Cybersecurity Framework is designed to help organizations describe their current cybersecurity posture, describe their target state for cybersecurity, identify and prioritize opportunities for improvement, assess progress, and communicate with stakeholders about risk. It does not create specific technology requirements.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      296,
      309,
      310,
      314,
      276
    ],
    "source": "211418_Ch16"
  },
  {
    "id": 338,
    "question": "Which one of the following items is <i>not</i> normally included in a request for an exception to security policy?",
    "choice_a": "Description of a compensating control",
    "choice_b": "Description of the risks associated with the exception",
    "choice_c": "Proposed revision to the security policy",
    "choice_d": "Business justification for the exception",
    "correct_answer": "C",
    "explanation": "Requests for an exception to a security policy would not normally include a proposed revision to the policy. Exceptions are documented variances from the policy because of specific technical and/or business requirements. They do not alter the original policy, which remains in force for systems not covered by the exception.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      280,
      275,
      277,
      309,
      310
    ],
    "source": "211418_Ch16"
  },
  {
    "id": 339,
    "question": "Jen identified a missing patch on a Windows server that might allow an attacker to gain remote control of the system. After consulting with her manager, she applied the patch. From a risk management perspective, what has she done?",
    "choice_a": "Removed the threat",
    "choice_b": "Reduced the threat",
    "choice_c": "Removed the vulnerability",
    "choice_d": "Reduced the vulnerability",
    "correct_answer": "C",
    "explanation": "By applying the patch, Jen has removed the vulnerability from her server. This also has the effect of eliminating this particular risk. Jen cannot control the external threat of an attacker attempting to gain access to her server.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      303,
      309,
      312,
      310,
      280
    ],
    "source": "211418_Ch17"
  },
  {
    "id": 340,
    "question": "You notice a high number of SQL injection attacks against a web application run by your organization, so you install a web application firewall to block many of these attacks before they reach the server. How have you altered the severity of this risk?",
    "choice_a": "Reduced the magnitude",
    "choice_b": "Eliminated the vulnerability",
    "choice_c": "Reduced the probability",
    "choice_d": "Eliminated the threat",
    "correct_answer": "C",
    "explanation": "Installing a web application firewall reduces the probability that an attack will reach the web server. Vulnerabilities may still exist in the web application and the threat of an external attack is unchanged. The impact of a successful SQL injection attack is also unchanged by a web application firewall.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      312,
      303,
      309,
      310,
      306
    ],
    "source": "211418_Ch17"
  },
  {
    "id": 341,
    "question": "Refer to the following scenario:<br>Aziz is responsible for the administration of an e-commerce website that generates $100,000 per day in revenue for his firm. The website uses a database that contains sensitive information about the firm\u2019s customers. He expects that a compromise of that database would result in $500,000 of fines against his firm.<br>Aziz is assessing the risk of a SQL injection attack against the database where the attacker would steal all of the customer personally identifiable information (PII) from the database. After consulting threat intelligence, he believes that there is a 5 percent chance of a successful attack in any given year.<br>What is the asset value (AV)?",
    "choice_a": "$5,000",
    "choice_b": "$100,000",
    "choice_c": "$500,000",
    "choice_d": "$600,000",
    "correct_answer": "C",
    "explanation": "The asset at risk in this case is the customer database. Losing control of the database would result in a $500,000 fine, so the asset value (AV) is $500,000.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      310,
      3,
      311,
      305
    ],
    "source": "211418_Ch17"
  },
  {
    "id": 342,
    "question": "Refer to the following scenario:<br>Aziz is responsible for the administration of an e-commerce website that generates $100,000 per day in revenue for his firm. The website uses a database that contains sensitive information about the firm\u2019s customers. He expects that a compromise of that database would result in $500,000 of fines against his firm.<br>Aziz is assessing the risk of a SQL injection attack against the database where the attacker would steal all of the customer personally identifiable information (PII) from the database. After consulting threat intelligence, he believes that there is a 5 percent chance of a successful attack in any given year.<br>What is the exposure factor (EF)?",
    "choice_a": "5%",
    "choice_b": "20%",
    "choice_c": "50%",
    "choice_d": "100%",
    "correct_answer": "D",
    "explanation": "The attack would result in the total loss of customer data stored in the database, making the exposure factor (EF) 100 percent.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      310,
      304,
      303,
      312
    ],
    "source": "211418_Ch17"
  },
  {
    "id": 343,
    "question": "Refer to the following scenario:<br>Aziz is responsible for the administration of an e-commerce website that generates $100,000 per day in revenue for his firm. The website uses a database that contains sensitive information about the firm\u2019s customers. He expects that a compromise of that database would result in $500,000 of fines against his firm.<br>Aziz is assessing the risk of a SQL injection attack against the database where the attacker would steal all of the customer personally identifiable information (PII) from the database. After consulting threat intelligence, he believes that there is a 5 percent chance of a successful attack in any given year.<br>What is the single loss expectancy (SLE)?",
    "choice_a": "$5,000",
    "choice_b": "$100,000",
    "choice_c": "$500,000",
    "choice_d": "$600,000",
    "correct_answer": "C",
    "explanation": "We compute the single loss expectancy (SLE) by multiplying the asset value (AV) ($500,000) and the exposure factor (EF) (100%) to get an SLE of $500,000.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      310,
      311,
      309,
      312
    ],
    "source": "211418_Ch17"
  },
  {
    "id": 344,
    "question": "Refer to the following scenario:<br>Aziz is responsible for the administration of an e-commerce website that generates $100,000 per day in revenue for his firm. The website uses a database that contains sensitive information about the firm\u2019s customers. He expects that a compromise of that database would result in $500,000 of fines against his firm.<br>Aziz is assessing the risk of a SQL injection attack against the database where the attacker would steal all of the customer personally identifiable information (PII) from the database. After consulting threat intelligence, he believes that there is a 5 percent chance of a successful attack in any given year.<br>What is the annualized rate of occurrence (ARO)?",
    "choice_a": "0.05",
    "choice_b": "0.20",
    "choice_c": "2.00",
    "choice_d": "5.00",
    "correct_answer": "A",
    "explanation": "Aziz\u2019s threat intelligence research determined that the threat has a 5 percent likelihood of occurrence each year. This is an ARO of 0.05.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      310,
      305,
      309,
      311
    ],
    "source": "211418_Ch17"
  },
  {
    "id": 345,
    "question": "Refer to the following scenario:<br>Aziz is responsible for the administration of an e-commerce website that generates $100,000 per day in revenue for his firm. The website uses a database that contains sensitive information about the firm\u2019s customers. He expects that a compromise of that database would result in $500,000 of fines against his firm.<br>Aziz is assessing the risk of a SQL injection attack against the database where the attacker would steal all of the customer personally identifiable information (PII) from the database. After consulting threat intelligence, he believes that there is a 5 percent chance of a successful attack in any given year.<br>What is the annualized loss expectancy (ALE)?",
    "choice_a": "$5,000",
    "choice_b": "$25,000",
    "choice_c": "$100,000",
    "choice_d": "$500,000",
    "correct_answer": "B",
    "explanation": "We compute the annualized loss expectancy (ALE) by multiplying the SLE ($500,000) and the ARO (0.05) to get an ALE of $25,000.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      310,
      309,
      312,
      305
    ],
    "source": "211418_Ch17"
  },
  {
    "id": 346,
    "question": "Refer to the following scenario:<br>Grace recently completed a risk assessment of her organization\u2019s exposure to data breaches and determined that there is a high level of risk related to the loss of sensitive personal information. She is considering a variety of approaches to managing this risk.<br>Grace\u2019s first idea is to add a web application firewall to protect her organization against SQL injection attacks. What risk management strategy does this approach adopt?",
    "choice_a": "Risk acceptance",
    "choice_b": "Risk avoidance",
    "choice_c": "Risk mitigation",
    "choice_d": "Risk transference",
    "correct_answer": "C",
    "explanation": "Installing new controls or upgrading existing controls is an effort to reduce the probability or magnitude of a risk. This is an example of a risk mitigation activity.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      309,
      312,
      310,
      311,
      280
    ],
    "source": "211418_Ch17"
  },
  {
    "id": 347,
    "question": "Refer to the following scenario:<br>Grace recently completed a risk assessment of her organization\u2019s exposure to data breaches and determined that there is a high level of risk related to the loss of sensitive personal information. She is considering a variety of approaches to managing this risk.<br>Business leaders are considering dropping the customer activities that collect and store sensitive personal information. What risk management strategy would this approach use?",
    "choice_a": "Risk acceptance",
    "choice_b": "Risk avoidance",
    "choice_c": "Risk mitigation",
    "choice_d": "Risk transference",
    "correct_answer": "B",
    "explanation": "Changing business processes or activities to eliminate a risk is an example of risk avoidance.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      309,
      312,
      311,
      310,
      304
    ],
    "source": "211418_Ch17"
  },
  {
    "id": 348,
    "question": "Refer to the following scenario:<br>Grace recently completed a risk assessment of her organization\u2019s exposure to data breaches and determined that there is a high level of risk related to the loss of sensitive personal information. She is considering a variety of approaches to managing this risk.<br>Grace\u2019s company decided to install the web application firewall and continue doing business. They are still worried about other risks to the information that were not addressed by the firewall and are considering purchasing an insurance policy to cover those risks. What strategy does this use?",
    "choice_a": "Risk acceptance",
    "choice_b": "Risk avoidance",
    "choice_c": "Risk mitigation",
    "choice_d": "Risk transference",
    "correct_answer": "D",
    "explanation": "Insurance policies use a risk transference strategy by shifting some or all of the financial risk from the organization to an insurance company.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      309,
      312,
      310,
      307,
      306
    ],
    "source": "211418_Ch17"
  },
  {
    "id": 349,
    "question": "Refer to the following scenario:<br>Grace recently completed a risk assessment of her organization\u2019s exposure to data breaches and determined that there is a high level of risk related to the loss of sensitive personal information. She is considering a variety of approaches to managing this risk.<br>In the end, Grace\u2019s risk managers found that the insurance policy was too expensive and opted not to purchase it. They are taking no additional action. What risk management strategy is being used in this situation?",
    "choice_a": "Risk acceptance",
    "choice_b": "Risk avoidance",
    "choice_c": "Risk mitigation",
    "choice_d": "Risk transference",
    "correct_answer": "A",
    "explanation": "When an organization decides to take no further action to address remaining risk, they are choosing a strategy of risk acceptance.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      309,
      310,
      312,
      307,
      304
    ],
    "source": "211418_Ch17"
  },
  {
    "id": 350,
    "question": "Under the European Union\u2019s GDPR, what term is assigned to the individual who leads an organization\u2019s privacy efforts?",
    "choice_a": "Data protection officer",
    "choice_b": "Data controller",
    "choice_c": "Data steward",
    "choice_d": "Data processor",
    "correct_answer": "A",
    "explanation": "Under the GDPR, the data protection officer (DPO) is an individual assigned direct responsibility for carrying out an organization\u2019s privacy program.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      292,
      317,
      320,
      276,
      274
    ],
    "source": "211418_Ch17"
  },
  {
    "id": 351,
    "question": "Helen\u2019s organization maintains medical records on behalf of its customers, who are individual physicians. What term best describes the role of Helen\u2019s organization?",
    "choice_a": "Data processor",
    "choice_b": "Data controller",
    "choice_c": "Data owner",
    "choice_d": "Data steward",
    "correct_answer": "A",
    "explanation": "In this case, the physicians maintain the data ownership role. They have chosen to outsource data processing to Helen\u2019s organization, making that organization a data processor.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      317,
      292,
      287,
      289,
      290
    ],
    "source": "211418_Ch17"
  },
  {
    "id": 352,
    "question": "Gene recently conducted an assessment and determined that his organization can be without its main transaction database for a maximum of two hours before unacceptable damage occurs to the business. What metric has Gene identified?",
    "choice_a": "MTBF",
    "choice_b": "MTTR",
    "choice_c": "RTO",
    "choice_d": "RPO",
    "correct_answer": "C",
    "explanation": "The Recovery Time Objective (RTO) is the amount of time that the organization can tolerate a system being down before it is repaired. That is the metric that Gene has identified in this scenario.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      315,
      153,
      160,
      158,
      161
    ],
    "source": "211418_Ch17"
  },
  {
    "id": 353,
    "question": "Tina works for a hospital system and manages the system\u2019s patient records. What category of personal information best describes the information that is likely to be found in those records?",
    "choice_a": "PCI",
    "choice_b": "PHI",
    "choice_c": "PFI",
    "choice_d": "PII",
    "correct_answer": "B",
    "explanation": "This is a tricky question, as it is possible that all of these categories of information may be found in patient records. However, they are most likely to contain protected health information (PHI). PHI could also be described as a subcategory of personally identifiable information (PII), but PHI is a better description. It is also possible that the records might contain payment card information (PCI) or personal financial information (PFI), but that is less likely than PHI.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      319,
      318,
      10,
      8,
      316
    ],
    "source": "211418_Ch17"
  },
  {
    "id": 354,
    "question": "Asa believes that her organization is taking data collected from customers for technical support and using it for marketing without their permission. What principle is most likely being violated?",
    "choice_a": "Data minimization",
    "choice_b": "Data retention",
    "choice_c": "Purpose limitation",
    "choice_d": "Data sovereignty",
    "correct_answer": "C",
    "explanation": "Organizations should only use data for the purposes disclosed during the collection of that data. In this case, the organization collected data for technical support purposes and is now using it for marketing purposes. That violates the principle of purpose limitation.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      320,
      292,
      317,
      294,
      276
    ],
    "source": "211418_Ch17"
  },
  {
    "id": 355,
    "question": "Which one of the following U.S. government classification levels requires the highest degree of security control?",
    "choice_a": "Secret",
    "choice_b": "Confidential",
    "choice_c": "Top Secret",
    "choice_d": "Unclassified",
    "correct_answer": "C",
    "explanation": "Top Secret is the highest level of classification under the U.S. system and, therefore, requires the highest level of security control.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      316,
      318,
      190,
      182,
      211
    ],
    "source": "211418_Ch17"
  },
  {
    "id": 356,
    "question": "Which type of analysis uses numeric data in the analysis, resulting in assessments that allow the very straightforward prioritization of risk?",
    "choice_a": "Qualitative",
    "choice_b": "One-time",
    "choice_c": "Recurring",
    "choice_d": "Quantitative",
    "correct_answer": "D",
    "explanation": "Quantitative risk analysis uses numeric data in the analysis, resulting in assessments that allow the very straightforward prioritization of risks. Qualitative risk analysis substitutes subjective judgments and categories for strict numerical analysis, allowing the assessment of risks that are difficult to quantify. A one-time risk assessment offers the organization a point-in-time view of its current risk state. Recurring risk assessments are performed at regular intervals, such as annually or quarterly.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      306,
      310,
      307,
      309,
      312
    ],
    "source": "211418_Ch17"
  },
  {
    "id": 357,
    "question": "What term is given to an individual or organization who determines the reasons for processing personal information?",
    "choice_a": "Data steward",
    "choice_b": "Data controller",
    "choice_c": "Data processor",
    "choice_d": "Data custodian",
    "correct_answer": "B",
    "explanation": "Data controllers are the entities who determine the reasons for processing personal information and direct the methods of processing that data. This term is used primarily in European law, and it serves as a substitute for the term <i>data owner</i> to avoid a presumption that anyone who collects data has an ownership interest in that data.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      317,
      292,
      320,
      298,
      276
    ],
    "source": "211418_Ch17"
  },
  {
    "id": 358,
    "question": "Brian recently conducted a risk mitigation exercise and has determined the level of risk that remains after implementing a series of controls. What term best describes this risk?",
    "choice_a": "Inherent risk",
    "choice_b": "Control risk",
    "choice_c": "Risk appetite",
    "choice_d": "Residual risk",
    "correct_answer": "D",
    "explanation": "The residual risk is the risk that remains after an organization implements controls designed to mitigate, avoid, and/or transfer the inherent risk.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      312,
      309,
      310,
      311,
      313
    ],
    "source": "211418_Ch17"
  },
  {
    "id": 359,
    "question": "One of Murali\u2019s staff members has malware on their PC. They claim that they downloaded only a spreadsheet tool, and not malware. What type of malware have they encountered if the malware was designed to look legitimate but was actually malicious?",
    "choice_a": "A worm",
    "choice_b": "A virus",
    "choice_c": "A Trojan",
    "choice_d": "A rootkit",
    "correct_answer": "C",
    "explanation": "Trojans, or Trojan horses, are malware designed to appear legitimate but that are actually malicious. Viruses require human interaction to spread, whereas worms propagate on their own via networks, often targeting vulnerable services. Rootkits help attackers obtain and maintain persistent access to systems.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      26,
      28,
      27,
      29,
      31
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 360,
    "question": "The authentication token that Susan uses generates codes based on an algorithm that relies on the current time. What type of token does Susan have?",
    "choice_a": "HOTP",
    "choice_b": "Timestamp",
    "choice_c": "TOTP",
    "choice_d": "Time offset",
    "correct_answer": "C",
    "explanation": "Susan has a time-based OTP (TOTP) token. HMAC-based one-time password (HOTP) tokens use a mathematical function that increments based on an event such as the click of a button. Time stamp and time offset are used for forensic and log analysis but are not types of tokens.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      141,
      140,
      138,
      132,
      134
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 361,
    "question": "What of the following would <i>best</i> allow you to quickly summarize key risk indicators in real time for management using graphs and charts?",
    "choice_a": "Regular updates",
    "choice_b": "Dashboard reporting",
    "choice_c": "Risk trend analysis",
    "choice_d": "Risk event reports",
    "correct_answer": "B",
    "explanation": "Dashboard reporting utilizes visual aids like graphs and charts to summarize risk data, usually in real time. This allows for a quick understanding and monitoring of key risk indicators. Regular updates are routine reports that provide stakeholders with the status of risks, the effectiveness of controls, and any recent changes or developments. Risk trend analysis reporting involves analyzing historical data to identify patterns or trends in the risks faced by the organization. Risk event reports focus on documenting specific risk events, such as security breaches or incidents, their impacts, and the responses taken.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      314,
      310,
      305,
      309,
      293
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 362,
    "question": "Madhuri receives a text message asking her to contact the IRS due to unpaid taxes. When she calls the number in the text message, the person on the other end of the line attempts to get her to disclose her bank account number, Social Security number, and other personal information. What type of attack is this?",
    "choice_a": "Vishing",
    "choice_b": "Phishing",
    "choice_c": "Spearphishing",
    "choice_d": "Smishing",
    "correct_answer": "D",
    "explanation": "Smishing is phishing over SMS or text messages. Phishing is typically done via email, whereas vishing is conducted via the phone. Spearphishing is done via email and specifically targeted at individuals or small groups.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      33,
      32,
      25,
      19,
      35
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 363,
    "question": "Gabby\u2019s organization captures sensitive customer information. Sales representatives and others often work with that data on local workstations and laptops. After a recent inadvertent data breach where a salesperson accidentally sent a spreadsheet of customer information to another customer, the organization is seeking a technology solution that can help prevent similar problems. What should Gabby recommend?",
    "choice_a": "IDS",
    "choice_b": "FSB",
    "choice_c": "DLP",
    "choice_d": "FDE",
    "correct_answer": "C",
    "explanation": "Data loss prevention (DLP) can tag sensitive data and then scan outbound communications for that data. Once tagged data or data that matches specific patterns such as credit card numbers or Social Security numbers is discovered, DLP can alert the user or take other action. An intrusion detection system (IDS) detects inbound traffic patterns but cannot stop an outbound email. FSB is not a security term, and full-disk encryption (FDE) can help prevent data loss if a system is lost or stolen.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      6,
      5,
      2,
      224,
      100
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 364,
    "question": "Fred wants to implement trusted boot and knows that he needs to make sure that his workstations and laptops have the appropriate hardware to support it. What hardware should he ensure is built into the systems he is purchasing?",
    "choice_a": "TPM",
    "choice_b": "HSM",
    "choice_c": "IPS",
    "choice_d": "NGFW",
    "correct_answer": "A",
    "explanation": "A Trusted Platform Module (TPM) is used by UEFI as part of the boot process to validate the boot objects and programs or to document what is started so that boot attestation can occur. A hardware security module (HSM) is used to create, store, and manage encryption keys and certificates. An intrusion prevention system (IPS) and a next-generation firewall (NGFW) are both network security devices.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      124,
      118,
      105,
      100,
      123
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 365,
    "question": "Sarah is a cybersecurity analyst at a growing e-commerce company. She\u2019s tasked with enhancing the company\u2019s email security measures. The management wants to ensure that email messages from their domain are verified for their authenticity and can\u2019t be tampered with, and that other sites know how to handle emails from their domain. Which protocol(s) should Sarah deploy?",
    "choice_a": "SPF only",
    "choice_b": "DKIM only",
    "choice_c": "SPF and DKIM",
    "choice_d": "SPF, DKIM, and DMARC",
    "correct_answer": "D",
    "explanation": "These three protocols work together to secure email. SPF (Sender Protection Framework) allows domain owners to specify which mail servers can send messages from their domain, reducing email spoofing. DKIM (DomainKeys Identified Mail) uses digital signatures to verify the authenticity of email messages, making sure they haven\u2019t been tampered with. DMARC (Domain-based Message Authentication, Reporting, and Conformance) ties together SPF and DKIM and allows the domain owner to specify their usage and dictate policies for handling emails from their domain. By implementing all three, Sarah can achieve the company\u2019s email security objectives.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      220,
      252,
      250,
      246,
      214
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 366,
    "question": "Terry wants to prevent her users from installing specific games on her organization\u2019s computers. Which feature can she use to prevent known applications from being installed?",
    "choice_a": "Application deny list",
    "choice_b": "HIDS",
    "choice_c": "Application allow list",
    "choice_d": "HIPS",
    "correct_answer": "A",
    "explanation": "An application deny list feature blocks specific applications or files from being run or installed on a computer. An application allow list allows for the installation and running of the specified applications or files that are allowed. A host intrusion detection or prevention system will not prevent application installation.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      146,
      282,
      283,
      284
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 367,
    "question": "Susan is designing the physical security controls for her organization\u2019s new building. She would like to ensure that the front doors are protected from a vehicle being used to ram through them. Which physical security control can Susan effectively utilize?",
    "choice_a": "A moat",
    "choice_b": "A wall",
    "choice_c": "Bollards",
    "choice_d": "A fence",
    "correct_answer": "C",
    "explanation": "Bollards are pillars or other structures placed in designated locations to prevent vehicles from passing through an area. Whereas many bollards look like metal poles or concrete pillars, planters, large boulders, and other structures can also serve as bollards. A moat is not a typical security control unless your organization has a castle, and walls and fences are more frequently used to prevent access by people.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      162,
      5,
      6,
      163,
      164
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 368,
    "question": "Isaac needs to sanitize an SSD that uses full-disk encryption and that has been encrypted for its full service life with the company he works for. What is the most effective means of making the data on the SSD no longer retrievable?",
    "choice_a": "Completely overwrite the drive with binary 0s.",
    "choice_b": "Reformat the drive using a full format.",
    "choice_c": "Completely overwrite the drive with random patterns of binary 1s and 0s.",
    "choice_d": "Destroy the encryption key for the drive and then use the SATA <code>secure erase</code> command.",
    "correct_answer": "D",
    "explanation": "Isaac can simply destroy all copies of the encryption key for the drive to make the data very difficult to access. Using the built-in <code>secure erase</code> command will ensure that the data is no longer recoverable under any normal circumstances. Overwriting SSDs and other flash media that are overprovisioned with additional space for wear leveling purposes is likely to miss remnant data in spare or replaced space. Formatting a drive simply removes the file indices and does not remove the data.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      8,
      10,
      316,
      182,
      156
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 369,
    "question": "Tom has documented the set of security settings and procedures used to configure systems before they are deployed in his organization. What industry term describes this sort of documentation?",
    "choice_a": "A lockdown guide",
    "choice_b": "A config FAQ",
    "choice_c": "A secure baseline",
    "choice_d": "A nonrepudiation guide",
    "correct_answer": "C",
    "explanation": "Secure baselines are used to document the settings and procedures used to configure systems or devices. The other answer choices are not common industry terms.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      284,
      5,
      285,
      146,
      162
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 370,
    "question": "Lucca needs to make a forensic copy of a Linux system. What built-in Linux command-line tool can she use for that purpose?",
    "choice_a": "<code>dd</code>",
    "choice_b": "<code>md5sum</code>",
    "choice_c": "<code>cat</code>",
    "choice_d": "<code>grep</code>",
    "correct_answer": "A",
    "explanation": "The Linux <code>dd</code> command can be used to make a complete copy of a disk or volume. Since it is built into most Linux distributions, it is a handy way to make a copy. Once she is done, Lucca should use the <code>shasum</code> command to hash the copy and the original to validate her copying process. None of the other commands can be used to duplicate a disk.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      264,
      265,
      262,
      270,
      260
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 371,
    "question": "What is the virtual IP for a load balancer used for?",
    "choice_a": "It is the IP address used inside the load balancer to communicate with the load-balanced systems.",
    "choice_b": "It is the front-facing IP address for the load-balancing instance.",
    "choice_c": "It is the nonroutable IP address used for the load balancer that allows it to look like many systems.",
    "choice_d": "It is the set of TCP ports used to allow systems to be identified behind the load balancer.",
    "correct_answer": "B",
    "explanation": "A virtual IP (VIP) for a load balancer is the IP address that it uses to present to the world. Client systems connect to the VIP, which is then used to distribute traffic to servers behind the load balancer. It is not the internal IP address, it is not typically a nonroutable IP address because client systems need to get to it, and it is an IP address, not a TCP port.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      150,
      157,
      217,
      177,
      210
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 372,
    "question": "In some encryption algorithms, an initial connection is set up using an asymmetric key pair. Immediately upon the establishment of that session, the two parties create a new symmetric key that is used for the remainder of the connection. What term best describes this type of symmetric key?",
    "choice_a": "One-time keys",
    "choice_b": "Ephemeral keys",
    "choice_c": "Private keys",
    "choice_d": "Public keys",
    "correct_answer": "B",
    "explanation": "Ephemeral, short-lived keys, are used with key establishment. Public and private keys are part of that exchange. A one-time key is not an encryption term, but one-time pads are cryptographic ciphers that are used once and then discarded.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      109,
      110,
      104,
      111,
      102
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 373,
    "question": "Matt is investigating a security incident and would like to review raw network traffic that was sent between systems during the incident. What would be the best source of information for this work?",
    "choice_a": "Packet capture",
    "choice_b": "Vulnerability scans",
    "choice_c": "NetFlow records",
    "choice_d": "IPS logs",
    "correct_answer": "A",
    "explanation": "If packet captures are available, they would be the best source of information for Matt, as they would contain the entire contents of the packets, including their payload. Vulnerability scans would not contain network traffic. NetFlow records only include header information and do not include payload data. IPS logs may contain limited packet data but only for packets that were flagged by the IPS for investigation.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      267,
      251,
      250,
      246,
      219
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 374,
    "question": "Olivia wants to protect against DNS cache poisoning, and she knows that digitally signing DNS replies from protected zones would be helpful as part of that effort. What can she configure to implement this capability?",
    "choice_a": "SDNS",
    "choice_b": "DNS over IKE",
    "choice_c": "DNSSEC",
    "choice_d": "DNS over TLS",
    "correct_answer": "C",
    "explanation": "DNSSEC uses digital signatures to validate information provided by a DNS server, helping to prevent issues such as DNS poisoning. None of the other answers are real DNS security solutions; although you could protect DNS queries with TLS, doing so wouldn\u2019t validate the actual DNS information like DNSSEC does.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      223,
      115,
      105,
      107,
      98
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 375,
    "question": "In the following image, a connection between two systems has been redirected by an attacker. The attacker has spoofed ARP packets to make it so that responses to the legitimate server are instead sent to a system that the attacker controls. When traffic is sent to that system, the attacker reads and potentially modifies the traffic before passing it along the server, then sends back responses from the server after reviewing or modifying them as well. What type of attack is this?<img src=\"/question_assets/Security+/pt01f001.png\"/>",
    "choice_a": "An ARPjacking",
    "choice_b": "A disassociation attack",
    "choice_c": "An on-path attack",
    "choice_d": "A TCP redirect attack",
    "correct_answer": "C",
    "explanation": "This is one form of an on-path attack, an attack that redirects traffic to a system or device controlled by the attacker, which can then take action on network traffic originally destined for another system. ARPjacking and TCP redirect attacks are made up. Disassociation attacks focus on causing Wi-Fi devices to drop their connection and try to reconnect to an access point.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      226,
      234,
      36,
      75,
      229
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 376,
    "question": "The business-critical web application that Nicole runs for her organization has a known zero-day flaw in it that involves SQL injection (SQLi). If Nicole has sample code showing the SQL injection, what type of network security device can she use to protect her application even if a patch isn\u2019t available yet?",
    "choice_a": "A SQL transmogrifier",
    "choice_b": "A stateful packet inspection firewall",
    "choice_c": "An injection guard",
    "choice_d": "A WAF",
    "correct_answer": "D",
    "explanation": "A web application firewall (WAF) can do exactly what Nicole needs. WAF software and hardware specialize in protecting web applications by analyzing traffic sent to the web application and blocking known malicious traffic and traffic patterns. Nicole can write a detection that will match the malicious SQL code from the zero-day attack while being careful not to write an overly broad or overly narrow detection. Once it\u2019s deployed, she can continue to run her web application until a patch is released while remaining safe because of her WAF. Stateful packet inspection firewalls track the communication between two devices but do not detect SQL injection or other application layer detail, and the other options were made up.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      223,
      5,
      1,
      147,
      284
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 377,
    "question": "Bethany is a cybersecurity manager at a major financial institution. As part of her duties, she has been tasked to plan the institution\u2019s information security program, which includes security testing, assessments, and audits. Her team is especially concerned about the security of their newly implemented online banking system. Given that Bethany\u2019s team has limited resources, she needs to prioritize which parts of the system to test first. Which of the following factors is most important for her to consider when scheduling security controls for review?",
    "choice_a": "The availability of advanced testing tools in the market",
    "choice_b": "The number of transactions that pass through the system daily",
    "choice_c": "The personal information stored within the system and its likelihood to come under attack",
    "choice_d": "The average age and background of the system\u2019s users",
    "correct_answer": "C",
    "explanation": "The personal information stored within the system and its likelihood to come under attack aligns with the factors that Bethany should consider when scheduling security controls for review. This includes the sensitivity of the information contained on the tested systems and applications and the risk that the system will come under attack.<br>The availability of tools is not a deciding factor. Instead, Bethany should focus on the effectiveness of her current tools and how they fit into her testing strategy.<br>The number of transactions that pass through the system daily is not necessarily a direct factor for scheduling security controls for review. While high-traffic systems may be more appealing targets for attackers, it\u2019s the system\u2019s overall criticality, sensitivity of data, and risk of attack that should guide decision-making.<br>The average age and background of the system\u2019s users is not relevant to scheduling security controls for review. The demographics of users do not directly affect the vulnerability or the criticality of the system. Instead, system testing should focus on inherent system risks and vulnerabilities.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      310,
      303,
      312,
      306,
      309
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 378,
    "question": "The organization that Cynthia works for has been sent a legal hold notice. What actions must they take?",
    "choice_a": "They should not delete or destroy electronic or paper documents related to the legal case that is in process.",
    "choice_b": "They must send machines, documents, and files to the opposing counsel that may be relevant to the legal case in process.",
    "choice_c": "They must immediately stop performing the actions described in the legal hold document.",
    "choice_d": "All of the above.",
    "correct_answer": "A",
    "explanation": "A legal hold is a notification that litigation is in progress or active and that data and documents related to the case must be preserved. Legal holds are used to ensure that information relevant to the case is not lost or destroyed. It does not require the organization to send machines, documents, or files, and it does not require actions to cease unless there are automated or manual destruction processes or others that might cause the loss of case-related information.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      295,
      320,
      309,
      280,
      297
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 379,
    "question": "Which of the following components is required for an SSL/TLS stripping attack?",
    "choice_a": "An on-path system",
    "choice_b": "A TLS accelerator card",
    "choice_c": "An SSL accelerator card",
    "choice_d": "An SSL/TLS removal script",
    "correct_answer": "A",
    "explanation": "SSL stripping (or TLS stripping) relies on making the end user believe that they have a secure connection but instead proxies that connection via an on-path system that intercepts requests, terminates the SSL or TLS connection, and then passes those requests on to the legitimate server after either capturing or modifying the traffic.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      226,
      74,
      128,
      229,
      230
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 380,
    "question": "Emily, a cybersecurity analyst at a medium-sized firm, is in the process of evaluating a new vendor that will handle sensitive data for her organization. What factors are most important for Emily to consider during this vendor selection process?",
    "choice_a": "The vendor\u2019s marketing strategy and brand recognition",
    "choice_b": "The vendor\u2019s financial stability, reputation, product quality, and regulatory compliance",
    "choice_c": "The number of employees the vendor has and the location of the vendor\u2019s headquarters",
    "choice_d": "The vendor\u2019s total sales in the previous fiscal year and projected growth",
    "correct_answer": "B",
    "explanation": "The vendor\u2019s financial stability, reputation, product quality, and regulatory compliance are pertinent because these factors will help Emily assess the reliability, credibility, and compliance of the vendor, particularly considering they will be handling sensitive data.<br>Choosing based on the vendor\u2019s marketing strategy and brand recognition can be misleading as these do not necessarily reflect the vendor\u2019s security practices, regulatory compliance, or quality of service. The vendor\u2019s number of employees and the location of the vendor\u2019s headquarters are not directly indicative of their suitability to handle sensitive data or their compliance with relevant regulations. Similarly, the vendor\u2019s total sales in the previous fiscal year and projected growth might provide an overview of their business performance but does not shed light on their security measures, compliance status, or how well they can protect sensitive data.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      287,
      290,
      289,
      292,
      295
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 381,
    "question": "What significant improvement in Personal mode wireless was included in WPA3?",
    "choice_a": "Simultaneous authentication of equals",
    "choice_b": "Support for dictionary attacks",
    "choice_c": "Added WPS3",
    "choice_d": "Removed support for AES encryption",
    "correct_answer": "A",
    "explanation": "Simultaneous Authentication of Equals (SAE) is a major addition to WPA3\u2019s Personal mode, and it actually helps prevent dictionary attacks. AES encryption remains in use, but Wi-Fi Protected Setup (WPS) is being removed.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      139,
      140,
      133,
      214,
      54
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 382,
    "question": "Jamie is a system administrator tasked with enhancing the security of a small business network consisting of Windows systems. To accomplish this, Jamie wants to enforce certain security measures such as minimum password lengths and disabling the storage of passwords using reversible encryption. Which of the following approaches would best achieve Jamie\u2019s goal?",
    "choice_a": "Enforce these measures using antivirus software.",
    "choice_b": "Use Group Policy Objects (GPOs) to enforce these measures.",
    "choice_c": "Enforce these measures through firewalls and routers.",
    "choice_d": "Use SELinux to enforce these measures on all systems.",
    "correct_answer": "B",
    "explanation": "Jamie should use Group Policy Objects (GPOs) to enforce these measures. GPOs are an effective method for controlling settings on Windows systems, such as disabling guest accounts, setting minimum password lengths, and restricting software installations. This can be applied both locally or via Active Directory, facilitating the large-scale managed deployments of GPOs. While antivirus software, firewalls and routers, and SELinux can contribute to the security of the network, they don\u2019t directly offer the ability to enforce the specific settings that Jamie is interested in. Moreover, SELinux is a Linux-specific solution and would not apply to the Windows systems on this network. Therefore, using GPOs provides the most comprehensive and effective approach to achieving Jamie\u2019s goal.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      194,
      137,
      148,
      192,
      93
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 383,
    "question": "Which type of governance model uses a bottom-up approach where individual business units are delegated the authority to achieve cybersecurity objectives?",
    "choice_a": "Centralized",
    "choice_b": "Decentralized",
    "choice_c": "Anomalous",
    "choice_d": "Compliance reporting",
    "correct_answer": "B",
    "explanation": "Decentralized governance models use a bottom-up approach, where individual business units are delegated the authority to achieve cybersecurity objectives and then may do so in the manner they see fit. A centralized governance model uses a top-down approach, where a central authority creates policies and standards that are then enforced throughout the organization. Anomalous has to do with anomalous behavior. Employees should be aware of such behavior whether it be risky, unexpected, or unintentional. Organizations need to engage in both internal and external compliance reporting to ensure that they meet the regulatory requirements and maintain transparency within the organization and with external stakeholders.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      274,
      273,
      276,
      275,
      272
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 384,
    "question": "Which of the following best describes why businesses classify their data and the implications for security controls?",
    "choice_a": "Data classification primarily exists for businesses to categorize their marketing strategies.",
    "choice_b": "Data classification programs are solely used by government agencies to classify national security information, not utilized by businesses.",
    "choice_c": "Data classification allows organizations to specify the necessary security controls to protect information based on its sensitivity, impacting the measures used to prevent unauthorized access.",
    "choice_d": "Data classification is an outdated system and no longer plays a role in modern data protection efforts.",
    "correct_answer": "C",
    "explanation": "Organizations use data classification to categorize information based on its sensitivity, which directly informs the necessary security controls for protecting that information from unauthorized access. This process allows a systematic approach to protecting the most crucial data and minimizing potential damage from data breaches. Conversely, data classification isn\u2019t a practice exclusive to business marketing strategies or to the U.S. government\u2019s national security information, as it\u2019s widely utilized across various sectors for diverse types of data. Moreover, far from being outdated, data classification remains a pivotal component of modern data protection strategies, continually evolving to meet the challenges posed by increasing amounts of data and advancing cyber threats.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      316,
      319,
      11,
      9,
      10
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 385,
    "question": "Frank needs to choose a mobile device deployment option for his organization. He wants to allow users to use devices that his organization selects and purchases for their own use. Which mobile solution should he select?",
    "choice_a": "BOYD",
    "choice_b": "COPE",
    "choice_c": "CYOD",
    "choice_d": "VDI",
    "correct_answer": "B",
    "explanation": "The corporate-owned, personally enabled (COPE) model allows end users to use their devices for personal as well as corporate use while providing corporate control and management of the mobile devices. BYOD is a bring-your-own-device model, which can create challenges when users manage and maintain their devices. CYOD, or choose your own device, allows users to select their own device. Virtual desktop infrastructure (VDI) runs applications on a remote system, allowing separation of data and systems while providing functionality to remote devices but is heavily bandwidth and application dependent.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      237,
      238,
      239,
      236,
      197
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 386,
    "question": "What is the key difference between checksums and hashes?",
    "choice_a": "Checksums are unique to every file; hashes are not.",
    "choice_b": "Hashes are reversible and can be used to generate the original file or data; checksums cannot be used to re-create the original file.",
    "choice_c": "Checksums are a small value used to detect errors, whereas hashes map to an arbitrarily sized output that is unique to each file hashed.",
    "choice_d": "There is no difference\u2014checksums and hashes are the same.",
    "correct_answer": "C",
    "explanation": "A checksum is a computation that is used to determine whether a file or message has been changed, allowing error detection. A hash generates a unique value for a file and is a one-way function\u2014it cannot be reversed to re-create the original file.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      114,
      107,
      117,
      115,
      102
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 387,
    "question": "Janet is the cybersecurity lead for a medium-sized company located in a hurricane-prone region. She\u2019s been tasked with designing a plan to ensure the company\u2019s systems remain available and functional, even during a natural disaster. What strategy should she prioritize to maximize resilience and support continuity of operations?",
    "choice_a": "Store all company data on physical servers in a highly secure location.",
    "choice_b": "Use a highly sophisticated cryptographic solution for all systems.",
    "choice_c": "Establish backup datacenters at least 90 miles apart and in a non-hurricane-prone region.",
    "choice_d": "Depend solely on uninterruptible power supply (UPS) systems for power-related contingencies.",
    "correct_answer": "C",
    "explanation": "A resilient cybersecurity strategy would emphasize multiple, distributed redundancies to prevent any single point of failure. Therefore, having backup datacenters located at least 90 miles apart and in a region not prone to hurricanes helps guard against geographically based disasters. Using a single data storage location or relying on a single cryptographic solution doesn\u2019t provide this redundancy, making these strategies insufficient for maximizing resilience. Lastly, while UPS systems are essential for power continuity, they only provide backup power for short periods; thus, relying solely on them won\u2019t fully address longer-term power outages or wider network and system failures.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      150,
      158,
      159,
      153,
      161
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 388,
    "question": "Simon is a system administrator for a technology firm. His organization has high data modification and transaction rates. They need a RAID solution that offers high read speeds, has a fault tolerance for at least one disk failure, and does not require double the storage. Which RAID level should Simon choose for his organization?",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 5",
    "choice_d": "RAID 10",
    "correct_answer": "C",
    "explanation": "Simon should choose RAID 5. This RAID level stripes data across drives with one drive used for parity (checksum) of the data. It offers high read speeds and can sustain a single drive failure without losing data, which aligns with the requirements of Simon\u2019s organization. It does not require double the storage, unlike RAID 1, which is a significant advantage in a high data transaction environment. RAID 0, while providing better I/O performance, is not fault tolerant\u2014all data is lost if a drive fails; hence it is not suitable for Simon\u2019s requirements. RAID 10 is similar to RAID 5 but adds additional performance benefits. However, it does require double the storage of a non-RAID solution because it uses mirroring. Therefore, it does not meet Simon\u2019s requirements.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      152,
      151,
      153,
      150,
      315
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 389,
    "question": "Maria is considering a BYOD device deployment and wants to enroll the devices in an MDM application. What key concern will she likely need to address with her users in the event that a device is lost and the organization wants to respond to ensure no corporate data is lost?",
    "choice_a": "Full-device encryption",
    "choice_b": "Remote wipe",
    "choice_c": "VDI",
    "choice_d": "Storage segmentation",
    "correct_answer": "B",
    "explanation": "Users in Maria\u2019s organization are likely to be concerned about what would be wiped if the device was remotely wiped in the event it was lost. If the organization\u2019s policy is to immediately fully wipe the device, and it is then recovered, their personal data may be lost. Organizational policies for BYOD devices can be complex, and many organizations choose to separate user and corporate data more completely via storage segmentation and other capabilities to avoid this scenario. Full-device encryption can help protect the data but would not typically be a concern for users\u2014most will appreciate it. Virtual desktop infrastructure (VDI) would not have a direct impact on users.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      235,
      9,
      319,
      316,
      11
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 390,
    "question": "Brianna is concerned about undervoltage events and short power outages for her systems in a datacenter. What type of power protection should she put in place to help keep her systems online?",
    "choice_a": "A generator",
    "choice_b": "Dual-power supplies",
    "choice_c": "PDUs",
    "choice_d": "A UPS",
    "correct_answer": "D",
    "explanation": "A UPS (uninterruptible power supply) relies on batteries or other stored power to keep systems online during short power outages, and it can also provide stable power during power sags and undervoltage events. A generator is needed for longer outages, because most UPS systems are intended to stay online for only a few minutes. Dual-power supplies are used to ensure that a single power supply failing or a single power source failing does not take down a server. A power distribution unit (PDU) is used to deliver power to devices. Dual-power supplies are used to ensure that a single power supply failing or a single power source failing does not take down a server.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      150,
      157,
      160,
      158,
      161
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 391,
    "question": "Gabby wants to protect against credential theft and knows that there are detection settings that can help prevent the abuse of stolen credentials. What detection and prevention setting relies on geolocation to protect against malicious use of stolen credentials?",
    "choice_a": "Impossible travel time",
    "choice_b": "Privilege escalation",
    "choice_c": "Time-of-check (TOC)/time-of-use (TOU)",
    "choice_d": "Time-based login",
    "correct_answer": "A",
    "explanation": "Risky login detection schemes look at impossible travel times between geographic locations using GeoIP capabilities. This means that they can detect that a user cannot reasonably have logged in from a site in one location and then traveled to a second location and logged in there. Although VPN usage can cause issues with this, in general this is a useful setting to avoid the use of stolen or shared credentials. Privilege escalation attacks attempt to use the rights of more privileged accounts, such as an administrator account. Time-of-check (TOC)/time-of-use (TOU) exploits are race conditions. Login time restriction is a setting used to prohibit users from logging in outside of specific hours but does not use geographic location.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      238,
      140,
      148,
      246,
      248
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 392,
    "question": "Ben wants to conduct an offline brute-force attack against a Linux system. What file should he work to obtain a copy of?",
    "choice_a": "John the Ripper",
    "choice_b": "The <code>/etc/passwd</code> file",
    "choice_c": "The <code>/etc/shadow</code> file",
    "choice_d": "He does not need a file; he can use SSH.",
    "correct_answer": "C",
    "explanation": "The <code>/etc/shadow</code> file contains password hashes for most modern Linux implementations, and Ben can then use a tool such as rainbow tables or John the Ripper to crack passwords. John itself is not a password file or repository, and <code>/etc/passwd</code> is a secure pointer to <code>/etc/shadow</code> and does not actually contain useful information. Finally, an offline password attack implies activity that does not take place over the network,  so SSH is not a valid answer.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      39,
      38,
      37,
      73,
      77
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 393,
    "question": "The network that Jaime is connecting to requires each device to protect itself from potential threats both from outside the local security zone and from systems that share the same network zone with it. What security design concept requires this type of configuration?",
    "choice_a": "Security zones",
    "choice_b": "Zero trust",
    "choice_c": "Screened subnet",
    "choice_d": "Security tagging",
    "correct_answer": "B",
    "explanation": "A zero-trust network does not trust systems or individuals, even if they are already inside the network\u2019s security perimeter. This means that each device or system must be secure and defended, rather than creating a harder outside security shell at security boundaries like many traditional networks did. Security zones are a level concept based on the level of security for a network segment or other logical division. Screened subnets, also called DMZs, are used to allow access from public or security zones to resources  web servers. Security tagging is not a specific technical term.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      211,
      193,
      212,
      11,
      177
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 394,
    "question": "Jessica is the procurement officer of a multidivision company. She is looking for an informal mechanism to document the relationship between her company and an internal service provider offering a service to a customer in a different business unit of the same company. Which type of agreement is most suitable for Jessica\u2019s needs?",
    "choice_a": "MSA",
    "choice_b": "SLA",
    "choice_c": "MOU",
    "choice_d": "BPA",
    "correct_answer": "C",
    "explanation": "In this context, Jessica\u2019s need is best addressed by a memorandum of understanding (MOU). An MOU provides an informal means to document the relationship between separate parties, making it well suited for situations involving different business units within the same company. On the other hand, a master service agreement (MSA) typically applies to extensive contracts with outside vendors over an extended time frame. Service level agreements (SLAs) delineate the conditions for services supplied by vendors, covering aspects such as performance metrics and available remedies if those metrics are not satisfied. This type of agreement is not usually utilized for internal relationships. Lastly, a business partners agreement (BPA) is used when two organizations agree to conduct business together in a partnership and would not apply in Jessica\u2019s intra-company situation.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      289,
      287,
      290,
      286,
      293
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 395,
    "question": "Thomas has configured UEFI boot attestation on the servers that he is responsible for. What occurs during boot attestation?",
    "choice_a": "Each boot component is checked against a list of signed and known software before it is loaded.",
    "choice_b": "The system builds a chain of trust from component to component as it loads during boot.",
    "choice_c": "The system attests to a verification platform about the trustworthiness of the software it is running after it completes the boot process.",
    "choice_d": "All of the above.",
    "correct_answer": "C",
    "explanation": "Boot attestation provides information about the software that it booted with to an attestation verification platform or system after boot, unlike secure boot, which uses a chained verification process to ensure that each component is signed and acceptable before it is loaded.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      185,
      213,
      153,
      315,
      160
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 396,
    "question": "Daniel wants to make users in his organization visit a different site than they intend to. To accomplish this, he falsifies DNS information in the local DNS server\u2019s cache, causing systems that use that DNS server to get incorrect information. What term describes this attack?",
    "choice_a": "ARP spoofing",
    "choice_b": "DNS phishing",
    "choice_c": "DNS poisoning",
    "choice_d": "Name overload",
    "correct_answer": "C",
    "explanation": "DNS poisoning attacks focus on falsifying DNS information that is then provided as the correct response to systems that rely on the poisoned DNS server. Since this information may be spread to other DNS servers that rely on the poisoned server, it can have a broad impact depending on the server that is poisoned. ARP spoofing involves responding to ARP requests with incorrect information, in essence claiming to be a different system based on the hardware address of the spoofed system or device. DNS phishing and name overload are not common technical or security terms.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      227,
      36,
      230,
      34,
      75
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 397,
    "question": "Liam is an IT manager at a mid-sized company, and he\u2019s tasked with selecting a vendor for their new cloud storage solution. The vendor will handle sensitive customer data and participate in critical business processes. As part of the vendor selection process, Liam is especially interested in a process that evaluates the vendor\u2019s financial stability, business reputation, product quality, and regulatory compliance. What process is Liam employing?",
    "choice_a": "Penetration testing",
    "choice_b": "Supply chain analysis",
    "choice_c": "Vendor questionnaires",
    "choice_d": "Due diligence",
    "correct_answer": "D",
    "explanation": "Liam is employing due diligence in his vendor selection process. This process involves thoroughly investigating potential vendors to ensure they meet the company\u2019s standards and requirements, such as financial stability, business reputation, and regulatory compliance. Penetration testing, on the other hand, refers to a method of evaluating a vendor\u2019s security by simulating attacks to identify vulnerabilities\u2014it is a part of the assessment but not the whole process that Liam is focusing on. Supply chain analysis refers to the analysis of risks associated with a vendor\u2019s own suppliers and doesn\u2019t specifically address the elements Liam is considering. Lastly, vendor questionnaires are tools used to regularly collect information about a vendor\u2019s practices and performance but do not provide the comprehensive evaluation that due diligence offers.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      287,
      288,
      295,
      290,
      308
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 398,
    "question": "Samantha has configured an unused network segment at her company to appear to be vulnerable and has added instrumentation and data-gathering capabilities so that she can observe and analyze what attackers do while attempting to exploit that network. What type of environment has she set up?",
    "choice_a": "A honeynet",
    "choice_b": "A black hole",
    "choice_c": "A honeypot",
    "choice_d": "A tarpit",
    "correct_answer": "A",
    "explanation": "A honeynet is a network that is built to have intentional vulnerabilities that will attract attackers whose actions can then be recorded and studied. A honeypot is a system or device configured in a similar way. A black hole is a network location where traffic is sent that will not be further forwarded. A tarpit is a system configured to slow down attackers.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      97,
      100,
      103,
      107,
      108
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 399,
    "question": "James, a customer service representative at an online retail company, is undergoing a security training program. As part of his role, he frequently communicates with customers, handling their queries and complaints. Which type of training would best equip James to handle social engineering and pretexting attacks that he may encounter in his work?",
    "choice_a": "Role-based training",
    "choice_b": "Anomalous behavior recognition",
    "choice_c": "Hybrid/remote work environment training",
    "choice_d": "Security policy training",
    "correct_answer": "A",
    "explanation": "The correct answer is role-based training. This approach tailors the training content to the specific job responsibilities of an individual. For a customer service representative like James, the focus would be on nontechnical aspects, particularly on dealing with social engineering and pretexting attacks. Anomalous behavior recognition, while important, is more focused on recognizing unexpected or risky behavior internally and is not specifically tailored to his role. Hybrid/remote work environment training and security policy training, although crucial, deal with best practices for remote work security and organizational security policies, respectively, and are not directly related to handling social engineering and pretexting attacks, which are a significant part of James\u2019s job responsibilities.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      300,
      301,
      302,
      276,
      277
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 400,
    "question": "Henry is conducting a penetration test and wants to social-engineer a staff member at his target organization into letting him gain access to a building. He explains that he is there at the request of a senior manager, and that he is late for a meeting with that manager, who is relying on him to be there. What social engineering principle is he using?",
    "choice_a": "Authority",
    "choice_b": "Intimidation",
    "choice_c": "Urgency",
    "choice_d": "Trust",
    "correct_answer": "C",
    "explanation": "Henry is using urgency. If he has expressed the fact that the person could lose their job if they didn\u2019t let him in, he might intimidate them. If he had told them that he was an inspector or enforcement officer, he would have been using perceived authority. Finally, if he exploited their willingness to trust him, he would have used that trust as the foundation of his social engineering attack.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      32,
      73,
      19,
      35,
      81
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 401,
    "question": "The biometric authentication system that Patricia has deployed has been allowing users to authenticate whose fingerprints do not match the users who they are authenticating as. What type of error is this called in biometric systems?",
    "choice_a": "CER",
    "choice_b": "False rejection",
    "choice_c": "False acceptance",
    "choice_d": "The efficacy rate",
    "correct_answer": "C",
    "explanation": "This type of problem is an issue with false acceptance and can be a major issue for biometric systems. Patricia needs to tune the system to reduce the false acceptance rates while minimizing false rejection rates. The crossover error rate (CER) is the point at which the false acceptance rate (FAR) and false rejection rate (FRR) cross over. Efficacy rate simply means how effective something is at performing its desired function.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      142,
      140,
      139,
      48,
      93
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 402,
    "question": "Xavier is implementing multifactor authentication and wants to ensure that he is using different factors. The authentication system he is setting up requires a PIN and a biometric factor. What types of factors are these?",
    "choice_a": "Something you know and something you are",
    "choice_b": "Something you have and something you are",
    "choice_c": "Something you know and something you have",
    "choice_d": "They are both the same factor and cannot be used for multifactor authentication.",
    "correct_answer": "A",
    "explanation": "A PIN is something you know, and a biometric factor is something you are. Xavier is correctly using two different types of factors for his authentication scheme. If he was using a PIN and a password, he would be using two of the same type of factor, reducing the overall security for his environment.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      140,
      142,
      141,
      132,
      137
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 403,
    "question": "What type of Trojan is specifically designed to provide administrative control of the systems it is installed on?",
    "choice_a": "A BRT",
    "choice_b": "A RAT",
    "choice_c": "A root horse",
    "choice_d": "A full Trojan",
    "correct_answer": "B",
    "explanation": "Remote access Trojans (RATs) are Trojans that are specifically designed to provide remote administrative access. The rest of the answers here are made up.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      26,
      29,
      31,
      25,
      27
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 404,
    "question": "Andrea is reviewing a draft of the Domer Doodads information security policy. Which one of the following statements would be more appropriately placed in a different document?",
    "choice_a": "All access to financial systems must use multifactor authentication for remote connections.",
    "choice_b": "Domer Doodads designates the chief information security officer as the individual with primary responsibility for information security.",
    "choice_c": "The chief information security officer is granted the authority to create specific requirements that implement this policy.",
    "choice_d": "Domer Doodads considers cybersecurity and compliance to be of critical importance to the business.",
    "correct_answer": "A",
    "explanation": "It is normal to find statements in an information security policy that declare the importance of cybersecurity to the organization, designate a specific individual as responsible for the cybersecurity function, and grant that individual authority over cybersecurity. Specific requirements, such as requiring multifactor authentication for financial systems, would be more appropriately placed in a standard than a policy.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      275,
      276,
      277,
      281,
      273
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 405,
    "question": "Phil is investigating a security incident where the attackers shut down his organization\u2019s database server. They do not appear to have actually gained access to the system, but shut it down using some type of remote exploit. What principle of cybersecurity was most directly violated during this incident?",
    "choice_a": "Integrity",
    "choice_b": "Confidentiality",
    "choice_c": "Availability",
    "choice_d": "Nonrepudiation",
    "correct_answer": "C",
    "explanation": "This is an example of an availability breach. By shutting down the database server, the attackers were able to deny authorized users access to the server. Confidentiality was not compromised as data was not accessed. And since data was not accessed, it was not changed either, keeping data integrity intact. Nonrepudiation does not play a role in this scenario since we are not concerned with proving data source identity to a recipient.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      1,
      2,
      5,
      283,
      98
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 406,
    "question": "Ian is designing an authorization scheme for his organization\u2019s deployment of a new accounting system. He is considering putting a control in place that would require that two accountants approve any payment request over $100,000. What security principle is Ian seeking to enforce?",
    "choice_a": "Two-person integrity control",
    "choice_b": "Separation of duties",
    "choice_c": "Least privilege",
    "choice_d": "Security through obscurity",
    "correct_answer": "A",
    "explanation": "It is sometimes difficult to distinguish between cases of least privilege, separation of duties, and two-person control. Least privilege means that an employee should have only the access rights necessary to perform their job. That is not the case in this scenario because accountants need to be able to approve payments. Separation of duties occurs when the same employee does not have permission to perform two different actions that, when combined, could undermine security. That is not the case here because both employees are performing the same action: approving the payment. Two-person control occurs when two employees must jointly authorize the same action. That is the case in this scenario. Security through obscurity occurs when the security of a control depends on the secrecy of its mechanism.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      11,
      213,
      182,
      9,
      318
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 407,
    "question": "Brady is developing the architecture for a new data loss prevention system that his organization will use to prevent the exfiltration of sensitive information over the network. What category of control is Brady implementing?",
    "choice_a": "Managerial",
    "choice_b": "Technical",
    "choice_c": "Operational",
    "choice_d": "Detective",
    "correct_answer": "B",
    "explanation": "The control categories recognized by CompTIA are technical, operational, managerial, and physical. Data loss prevention systems use technology to achieve security control objectives and are, therefore, technical controls.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      6,
      2,
      1,
      100
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 408,
    "question": "What type of hypervisor requires that the platform operator routinely patch the host operating system?",
    "choice_a": "Type I hypervisor",
    "choice_b": "Type II hypervisor",
    "choice_c": "Type III hypervisor",
    "choice_d": "Type IV hypervisor",
    "correct_answer": "B",
    "explanation": "A Type II hypervisor is the only type of hypervisor that uses a host operating system. A Type I hypervisor, or bare-metal hypervisor, runs directly on top of the physical hardware. Type III and IV hypervisors do not exist.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      174,
      172,
      169,
      168,
      185
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 409,
    "question": "Which one of the following algorithms is primarily used for the exchange of encryption keys?",
    "choice_a": "PBKDF2",
    "choice_b": "AES",
    "choice_c": "OCSP",
    "choice_d": "Diffie\u2013Hellman",
    "correct_answer": "D",
    "explanation": "Diffie\u2013Hellman is a key exchange algorithm used to create a common shared secret key. The Advanced Encryption Standard (AES) is a symmetric encryption algorithm used to protect data. Password-Based Key Derivation Function 2 (PBKDF2) is a key stretching algorithm used to create strong keys from short passwords. The Online Certificate Status Protocol (OCSP) is used to verify the validity of digital certificates.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      110,
      109,
      104,
      105,
      112
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 410,
    "question": "Tina recently completed a risk management review and identified that the organization is susceptible to an on-path attack. After review with her manager, they jointly decided that accepting the risk is the most appropriate strategy. What should Tina do next?",
    "choice_a": "Design a remediation plan.",
    "choice_b": "Implement additional security controls.",
    "choice_c": "Document the decision.",
    "choice_d": "Repeat the business impact assessment.",
    "correct_answer": "C",
    "explanation": "After accepting a risk, the organization takes no action other than to document the risk as accepted. Implementing additional security controls or designing a remediation plan would not be risk acceptance but would instead fit into the category of risk mitigation. There is no need to repeat the business impact assessment.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      309,
      310,
      313,
      311,
      280
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 411,
    "question": "What ISO standard provides guidance on risk management practices?",
    "choice_a": "ISO 27001",
    "choice_b": "ISO 27002",
    "choice_c": "ISO 27701",
    "choice_d": "ISO 31000",
    "correct_answer": "D",
    "explanation": "The International Organization for Standardization (ISO) publishes ISO 31000, covering risk management. ISO 27001 and 27002 cover cybersecurity, and ISO 27701 covers privacy controls.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      298,
      310,
      309,
      312,
      314
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 412,
    "question": "Phil is conducting a penetration test and has gained access to a target system. The account he has on that system is a standard user account, and Phil is installing a tool that will allow him to gain root access. What term best describes this activity?",
    "choice_a": "Privilege escalation",
    "choice_b": "Lateral movement",
    "choice_c": "Pivoting",
    "choice_d": "Persistence",
    "correct_answer": "A",
    "explanation": "Privilege escalation is the act of increasing the level of access that an attacker has to a system. It is a common exploit to launch after gaining initial access to a system in an attempt to gain administrative access (otherwise known as root or superuser access).",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      79,
      183,
      12,
      245,
      19
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 413,
    "question": "Which one of the following threat actors typically has the lowest level of sophistication?",
    "choice_a": "Organized crime",
    "choice_b": "Unskilled attacker",
    "choice_c": "Hacktivist",
    "choice_d": "Nation-state",
    "correct_answer": "B",
    "explanation": "Unskilled attackers are unsophisticated by definition. They simply use tools that are available for download and lack technical expertise. The other attack sources listed here range in sophistication, but all are more sophisticated than unskilled attackers.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      14,
      12,
      16,
      13,
      15
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 414,
    "question": "Jason is the Chief Information Security Officer (CISO) at a major online retail platform operating in the United States. The platform processes a significant amount of credit card transactions daily. Jason is aware of the company\u2019s obligation to meet certain regulatory standards and also the severe consequences of noncompliance. He seeks to ensure that the company\u2019s practices for storing, processing, and transmitting credit card information adhere to a particular standard. Which of the following regulations is Jason most concerned about?",
    "choice_a": "HIPAA",
    "choice_b": "SOX",
    "choice_c": "PCI DSS",
    "choice_d": "GDPR",
    "correct_answer": "C",
    "explanation": "Jason should primarily focus on the Payment Card Industry Data Security Standard (PCI DSS), which provides detailed rules about the storage, processing, and transmission of credit card information. In contrast, HIPAA applies to health-care providers, insurers, and information clearinghouses, not retail platforms. The Sarbanes\u2013Oxley (SOX) Act focuses on the financial records of publicly traded companies. While the General Data Protection Regulation (GDPR) is essential for any organization processing the data of European Union (EU) residents, it is not specific to credit card data. Hence, while Jason should be aware of all relevant regulations, PCI DSS is the most directly applicable to the company\u2019s credit card transactions.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      292,
      293,
      294,
      277,
      280
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 415,
    "question": "Which one of the following protocols allows the exchange of threat information over HTTPS connections?",
    "choice_a": "TTP",
    "choice_b": "STIX",
    "choice_c": "OpenIOC",
    "choice_d": "TAXII",
    "correct_answer": "D",
    "explanation": "Trusted Automated Exchange of Indicator Information (TAXII) is intended to allow cyberthreat information to be communicated at the application layer via HTTPS. Structured Threat Information Expression (STIX) is an XML format for describing threat components. OpenIOC is an XML format for describing indicators of compromise. TTP is a generic term for adversary tactics, techniques, and procedures and is not a communication protocol or standard.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      22,
      23,
      20,
      21,
      50
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 416,
    "question": "Sarah is an IT compliance officer at a large U.S. publicly traded tech company. Her role involves ensuring that the financial records of the company are secured with a high degree of assurance. She understands that there is a particular act that mandates such assurance for the IT systems storing and processing these records. Which of the following acts is Sarah most focused on ensuring her company complies with?",
    "choice_a": "FERPA",
    "choice_b": "GLBA",
    "choice_c": "SOX",
    "choice_d": "HIPAA",
    "correct_answer": "C",
    "explanation": "Sarah\u2019s main focus in this situation is the Sarbanes\u2013Oxley Act (SOX Act), as it is specifically designed for U.S. publicly traded companies. It insists on a high level of confidence in the IT systems that manage these companies\u2019 financial records. The Family Educational Rights and Privacy Act (FERPA) applies to educational institutions in the U.S., mandating the secure handling of student records. The Gramm\u2013Leach\u2013Bliley Act (GLBA) is aimed at U.S. financial institutions, necessitating them to establish a formal security program. The Health Insurance Portability and Accountability Act (HIPAA) sets the rules for health-care providers, insurance firms, and health information clearinghouses in the U.S., calling for adherence to security and privacy standards related to health information. While each of these regulations plays a crucial role within their specific sectors, in Sarah\u2019s role at a publicly traded tech firm, it\u2019s the SOX Act that is most pertinent.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      292,
      276,
      294,
      272,
      280
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 417,
    "question": "Norm is evaluating the security of his organization\u2019s datacenters and notices that there is a hole in the barbed wire fence protecting the facility. What type of control flaw has Norm identified?",
    "choice_a": "Physical",
    "choice_b": "Detective",
    "choice_c": "Corrective",
    "choice_d": "Compensating",
    "correct_answer": "A",
    "explanation": "A fence is an example of a physical control. Norm has identified a deficiency in a physical control that may be remediated by repairing the fence. A detective control helps pinpoint errors after an event has taken place. Corrective controls make up for an error and help restoration functions. A compensating control is an alternative method with which to implement an alternative substitute control in place of a complicated one that would take longer to implement.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      6,
      162,
      163,
      164
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 418,
    "question": "Gary recently conducted a comprehensive security review of his organization. He identified the 25 top risks to the organization and is pursuing different risk management strategies for each of these risks. In some cases, he is using multiple strategies to address a single risk. His goal is to reduce the overall level of risk so that it lies within his organization\u2019s risk tolerance. Gary decides that the organization should integrate a threat intelligence feed with the firewall. What type of risk management strategy is this?",
    "choice_a": "Risk acceptance",
    "choice_b": "Risk mitigation",
    "choice_c": "Risk avoidance",
    "choice_d": "Risk transference",
    "correct_answer": "B",
    "explanation": "The use of a threat intelligence feed to block connections at the firewall reduces the likelihood of a successful attack and is, therefore, a risk mitigation activity. Risk acceptance would be if Gary decides not to implement any measures against the risk. Risk avoidance would be if the organization ceased to conduct business. And risk transference would be if Gary purchased a cyber insurance policy against the risk.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      309,
      310,
      313,
      312,
      311
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 419,
    "question": "Emily is the Chief Information Security Officer (CISO) at a rapidly growing fintech startup. The company provides services to numerous other businesses, and as a result, they often receive requests from their clients to verify their security controls. To avoid the burden of multiple independent third-party audits from their various clients, Emily is considering a common standard that could be used by auditors to assess the organization\u2019s controls. What standard should Emily consider to alleviate this audit burden?",
    "choice_a": "COBIT",
    "choice_b": "ISO 27001",
    "choice_c": "ISO 27002",
    "choice_d": "SSAE 18",
    "correct_answer": "D",
    "explanation": "Emily is looking for a solution to minimize the load of numerous third-party audits. In such a situation, SSAE 18, also referred to as service organization controls (SOC) audits, is an ideal solution as it provides a common standard for auditors assessing service organizations. It allows the organization to undertake an external assessment instead of multiple third-party assessments, sharing the resulting report with customers and potential clients. While COBIT, ISO 27001, and ISO 27002 are valuable auditing and assessment standards, they do not specifically address the issue of multiple third-party audits. COBIT is a common framework for conducting audits and assessments, ISO 27001 describes an approach for setting up an information security management system, and ISO 27002 provides more detail on the specifics of information security controls, but none of them offer a solution like SSAE 18 for service organizations facing numerous audits.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      288,
      289,
      293,
      308,
      287
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 420,
    "question": "Which one of the following threat actors is most likely to have access to a zero-day exploit?",
    "choice_a": "Nation-state",
    "choice_b": "Hacktivist",
    "choice_c": "Organized crime",
    "choice_d": "Unskilled attacker",
    "correct_answer": "A",
    "explanation": "Zero-day vulnerabilities are difficult to discover and their use is the hallmark of sophisticated, well-resourced nation-state groups. It is far less likely that organized crime, a hacktivist, or an unskilled attacker would have access to a zero-day vulnerability.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      16,
      12,
      15,
      14,
      19
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 421,
    "question": "Which one of the following attacks is an example of a race condition exploitation?",
    "choice_a": "XSRF",
    "choice_b": "TOCTOU",
    "choice_c": "SSRF",
    "choice_d": "XSS",
    "correct_answer": "B",
    "explanation": "The time-of-check-to-time-of-use (TOCTTOU or TOC/TOU) issue is a race condition that occurs when a program checks access permissions too far in advance of a resource request. An example of a cross-site request forgery (XSRF) is when you have multiple tabs open on your browser and you are logged into your bank portal. An XSRF attack might use your present login status to send a command to transfer money out of your account. An example of a server-side request forgery (SSRF) is when an attack is made to the internal network of an organization through a web browser. An example of a cross-site scripting (XSS) attack would be having an attacker\u2019s code executed when you are visiting a website.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      90,
      81,
      80,
      71,
      82
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 422,
    "question": "Gavin is drafting a document that provides a detailed step-by-step process that users may follow to connect to the VPN from remote locations. Alternatively, users may ask IT to help them configure the connection. What term best describes this document?",
    "choice_a": "Policy",
    "choice_b": "Standard",
    "choice_c": "Guideline",
    "choice_d": "Procedure",
    "correct_answer": "D",
    "explanation": "A procedure offers a step-by-step process for completing a cybersecurity activity. The VPN instructions that Gavin is creating are best described using this term. Policies are the overarching security objectives of an organization. Standards follow through on implementing security policies. And guidelines are recommended ways of carrying out a task.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      275,
      278,
      276,
      277,
      279
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 423,
    "question": "Which one of the following environments is least susceptible to an injection attack?",
    "choice_a": "LDAP",
    "choice_b": "SQL",
    "choice_c": "CASB",
    "choice_d": "XML",
    "correct_answer": "C",
    "explanation": "The Lightweight Directory Access Protocol (LDAP), Structured Query Language (SQL), and the Extensible Markup Language (XML) all are command-driven languages that are susceptible to injection attacks. Cloud access security brokers (CASBs) are security platforms that do not typically have injection vulnerabilities.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      71,
      70,
      83,
      67,
      84
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 424,
    "question": "Matthew is concerned about the impact of overlapping international data protection laws on his company\u2019s operations. What principle would best assist Matthew in assessing this situation?",
    "choice_a": "Data sovereignty",
    "choice_b": "Sovereign immunity",
    "choice_c": "Supremacy",
    "choice_d": "Jurisprudence",
    "correct_answer": "A",
    "explanation": "The principle of data sovereignty states that data is subject to the legal restrictions of any jurisdiction where it is collected, stored, or processed. Sovereign immunity, or crown immunity, is a legal doctrine whereby a sovereign or state cannot commit a legal wrong and is immune from civil suit or criminal prosecution. Supremacy is the quality or state of having more power, authority, or status than anyone else. Jurisprudence is the philosophy and theory of law. It is concerned primarily with what the law is and what it ought to be.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      292,
      294,
      320,
      287,
      289
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 425,
    "question": "Under the shared responsibility model, which component always remains the responsibility of the customer, regardless of the cloud service model used?",
    "choice_a": "Data",
    "choice_b": "Application",
    "choice_c": "Hardware",
    "choice_d": "Datacenter",
    "correct_answer": "A",
    "explanation": "In the shared responsibility model for cloud computing, the customer always retains either full or partial responsibility for data security. Responsibility for hardware and physical data centers is the cloud provider\u2019s responsibility under all models. Responsibility for applications is the customer\u2019s responsibility under IaaS, the provider\u2019s responsibility under SaaS, and a shared responsibility under PaaS.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      168,
      172,
      182,
      179,
      8
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 426,
    "question": "Sherry is concerned that a web application in her organization supports unvalidated redirects. Which one of the following approaches would minimize the risk of this attack?",
    "choice_a": "Implementing multifactor authentication",
    "choice_b": "Restricting redirects to her domain",
    "choice_c": "Encrypting session cookies",
    "choice_d": "Requiring HTTPS",
    "correct_answer": "B",
    "explanation": "Unvalidated redirects instruct a web application to direct users to an arbitrary site at the conclusion of their transaction. This approach is quite dangerous because it allows an attacker to send users to a malicious site through a legitimate site that they trust. Sherry should restrict redirects so that they only occur within her trusted domain(s).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      75,
      83,
      81,
      80,
      84
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 427,
    "question": "Norm would like to create an agreement with an SaaS provider that specifies the amount of downtime that is acceptable. What document would typically contain this type of requirement?",
    "choice_a": "MOU",
    "choice_b": "BPA",
    "choice_c": "MSA",
    "choice_d": "SLA",
    "correct_answer": "D",
    "explanation": "Service level agreements (SLAs) are written contracts that specify the conditions of service that will be provided by the vendor and the remedies available to the customer if the vendor fails to meet the SLA. SLAs commonly cover issues such as system availability, data durability, and response time.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      289,
      290,
      288,
      287,
      308
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 428,
    "question": "Which one of the following situations would be described as Shadow IT?",
    "choice_a": "Using an unapproved code repository",
    "choice_b": "Hiring an unqualified systems administrator",
    "choice_c": "Configuring inappropriate access controls",
    "choice_d": "Using a product discontinued by the vendor",
    "correct_answer": "A",
    "explanation": "All of these situations pose a security risk. However, only the use of an unapproved code repository fits the definition of shadow IT\u2014the adoption and use of unapproved technologies by an organization\u2019s employees.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      85,
      178,
      93,
      92,
      144
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 429,
    "question": "Which one of the following tools is an exploitation framework commonly used by penetration testers?",
    "choice_a": "Wireshark",
    "choice_b": "Aircrack-ng",
    "choice_c": "Metasploit",
    "choice_d": "SET",
    "correct_answer": "C",
    "explanation": "Metasploit is the most popular exploitation framework used by penetration testers. Wireshark is a protocol analyzer. Aircrack-ng is a wireless network security testing tool. The Social Engineer\u2019s Toolkit (SET) is a framework for conducting social engineering attacks.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      49,
      59,
      60,
      55,
      63
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 430,
    "question": "Renee would like to send Christopher an encrypted message using an asymmetric encryption algorithm. What key should she use to encrypt the message?",
    "choice_a": "Christopher\u2019s public key",
    "choice_b": "Christopher\u2019s private key",
    "choice_c": "Renee\u2019s public key",
    "choice_d": "Renee\u2019s private key",
    "correct_answer": "A",
    "explanation": "When encrypting a message using an asymmetric encryption algorithm, the person performing the encryption does so using the recipient\u2019s public key.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      116,
      105,
      112,
      124,
      115
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 431,
    "question": "Seamus is conducting a business impact assessment for his organization. He is attempting to determine the risk associated with a denial-of-service attack against his organization\u2019s datacenter. He consulted with various subject matter experts and determined that the attack would not cause any permanent damage to equipment, applications, or data. The primary damage would come in the form of lost revenue. Seamus believes that the organization would lose $75,000 in revenue during a successful attack. Seamus also consulted with his threat management vendor, who considered the probability of a successful attack against his organization and determined that there is a 10 percent chance of a successful attack in the next 12 months. What is the SLE in this scenario?",
    "choice_a": "$625",
    "choice_b": "$6,250",
    "choice_c": "$7,500",
    "choice_d": "$75,000",
    "correct_answer": "D",
    "explanation": "The single loss expectancy (SLE) is the amount of damage expected to occur as the result of a single successful attack. In this case, the scenario provides this information as $75,000.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      310,
      309,
      304,
      305
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 432,
    "question": "Linda is migrating a system from an on-premises environment to an IaaS provider. The system is currently protected using network firewall rules that limit remote access. What cloud control can Linda use to achieve this same objective?",
    "choice_a": "Resource policy",
    "choice_b": "CASB",
    "choice_c": "HSM",
    "choice_d": "Security group",
    "correct_answer": "D",
    "explanation": "Security groups are used to limit network access to a server instance in the cloud. They are the equivalent of network firewall rules in an on-premises environment.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      171,
      92,
      216,
      255,
      189
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 433,
    "question": "Garrett is attempting to manage the cloud server instances used by his organization. They do not currently tag cloud resources with the identity of the responsible individual. What is the primary risk of not better controlling this situation?",
    "choice_a": "VM escaping",
    "choice_b": "Hypervisor breach",
    "choice_c": "Improper permissions",
    "choice_d": "VM sprawl",
    "correct_answer": "D",
    "explanation": "Virtual machine (VM) sprawl occurs when IaaS users create virtual service instances and then forget about them or abandon them, leaving them to accrue costs and accumulate security issues over time. Organizations should maintain instance awareness to avoid VM sprawl issues. VM escaping is where an attacker escapes the isolation of a virtual machine and gets access to the underlying operating system and other VMs on the same physical machine. Hypervisor breaches are cases where an attacker is able to compromise the hypervisor of a virtualization platform and gain access to virtual machine and/or the underlying operating system. Improper permission settings occur when users receive privileges not necessary to carry out their job functions.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      145,
      144,
      171,
      93,
      241
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 434,
    "question": "Paul is the CEO of a large manufacturing company. He is concerned about the company\u2019s compliance obligations and wants reassurance about the effectiveness of the organization\u2019s internal controls. He is considering ordering an audit, but he isn\u2019t sure which type of audit would best meet his needs and would like to keep costs down. Which type of audit should Paul consider for his needs?",
    "choice_a": "External audit",
    "choice_b": "Internal audit",
    "choice_c": "Independent third-party audit",
    "choice_d": "Vulnerability assessment",
    "correct_answer": "B",
    "explanation": "Paul\u2019s scenario is ideally suited to an internal audit. This is because internal audits are often conducted when management or the board of a company wishes to gain assurance that the company is meeting its compliance obligations. Furthermore, these audits are designed to identify control gaps in anticipation of a more formal external audit. While external audits and independent third-party audits can provide validation of an organization\u2019s controls, they are typically performed by outside auditing firms or other organizations, not the organization itself and are more expensive. A vulnerability assessment is very limited in scope and would not uncover many types of compliance issues.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      295,
      7,
      272,
      287,
      310
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 435,
    "question": "Tina is applying a digital signature to a contract so that the recipient can prove that she agreed to its terms. What goal of cryptography most directly describes Tina\u2019s actions?",
    "choice_a": "Nonrepudiation",
    "choice_b": "Confidentiality",
    "choice_c": "Integrity",
    "choice_d": "Authentication",
    "correct_answer": "A",
    "explanation": "Nonrepudiation ensures that individuals can prove to a third party that a message came from its purported sender. Although Tina may also achieve other goals with her approach, this goal is her stated intention.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      98,
      115,
      105,
      107,
      116
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 436,
    "question": "Kevin is using a service where a cloud provider offers a platform that executes his code in response to discrete events. He is billed based on the actual resources consumed during each code execution event. What term best describes this service?",
    "choice_a": "PaaS",
    "choice_b": "SaaS",
    "choice_c": "IaaS",
    "choice_d": "FaaS",
    "correct_answer": "D",
    "explanation": "This is an example of function-as-a-service (FaaS) computing, a subset of platform-as-a-service (PaaS). Although both terms may be used to describe the service Kevin uses, the best answer is FaaS, because it is more specific.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      168,
      169,
      170,
      175,
      176
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 437,
    "question": "Grace received a digitally signed message from Richard and would like to verify the digital signature. What key should she use to perform this verification?",
    "choice_a": "Richard\u2019s public key",
    "choice_b": "Richard\u2019s private key",
    "choice_c": "Grace\u2019s public key",
    "choice_d": "Grace\u2019s private key",
    "correct_answer": "A",
    "explanation": "The recipient of a digitally signed message may verify the digital signature by decrypting it with the public key of the individual who signed the message.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      116,
      115,
      112,
      105,
      119
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 438,
    "question": "Brian recently verified that the cash registers in his retail stores are printing only the last four digits of credit card numbers on receipts, replacing all the other digits with asterisks. The receipt does contain the customer\u2019s name and signature. What type of control has he implemented?",
    "choice_a": "Purging",
    "choice_b": "Tokenization",
    "choice_c": "Masking",
    "choice_d": "Deidentification",
    "correct_answer": "C",
    "explanation": "This is an example of data masking, removing enough digits from sensitive information to render it nonsensitive. Tokenization would replace the existing number with an unrelated number. Purging would remove the data completely. The data is not deidentified because the customer\u2019s name appears on the receipt.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      5,
      6,
      1,
      100,
      99
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 439,
    "question": "Which one of the following approaches, when feasible, is the most effective way to defeat injection attacks?",
    "choice_a": "Input block lists",
    "choice_b": "Input allow lists",
    "choice_c": "Browser-based input validation",
    "choice_d": "Signature detection",
    "correct_answer": "B",
    "explanation": "Input allow list approaches define the specific input type or range that users may provide. When developers can write clear business rules defining allowable user input, allow listing is definitely the most effective way to prevent injection attacks. Block lists achieve the same goal but attempt to block malicious content rather than allow approved content so they are less effective. Browser-based input validation is not a good practice because an attacker can easily bypass that validation. Signature detection is generally not used for injection attacks but rather for antivirus software.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      83,
      71,
      70,
      67,
      82
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 440,
    "question": "Which one of the following categories best describes information protected by HIPAA?",
    "choice_a": "PCI",
    "choice_b": "PII",
    "choice_c": "PHI",
    "choice_d": "SPI",
    "correct_answer": "C",
    "explanation": "The Health Insurance Portability and Accountability Act (HIPAA) mandates the safeguarding of protected health information (PHI). Sensitive personal information (SPI) and personally identifiable information (PII) may fall under HIPAA but do not necessarily do so. Payment card information (PCI) is covered by PCI DSS.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      319,
      318,
      10,
      316,
      8
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 441,
    "question": "What emerging cryptographic technology is commonly used to create a distributed and immutable public ledger?",
    "choice_a": "Quantum computing",
    "choice_b": "Perfect forward secrecy",
    "choice_c": "Homomorphic encryption",
    "choice_d": "Blockchain",
    "correct_answer": "D",
    "explanation": "The blockchain is, in its simplest description, a distributed and immutable public ledger. This means that it can store records in a way that distributes those records among many different systems located around the world and do so in a manner that prevents anyone from tampering with those records. The blockchain creates a data store that nobody can tamper with or destroy.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      131,
      105,
      107,
      109,
      1
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 442,
    "question": "Jessica, a security consultant, is hired by a company to conduct a penetration test. The company provides her with a high-level network diagram but no further details about the systems or configuration. What type of environment test is Jessica likely to conduct?",
    "choice_a": "Known environment test",
    "choice_b": "Unknown environment test",
    "choice_c": "Partially known environment test",
    "choice_d": "Fully known environment test",
    "correct_answer": "C",
    "explanation": "In this scenario, Jessica has been provided with some information about the environment\u2014a high-level network diagram, but not full details about the systems or configuration. This corresponds to a partially known environment test. Known environment tests provide the tester with full knowledge of the technology, configurations, and settings. Unknown environment tests provide no information about the environment and the tester has to discover vulnerabilities as an attacker would. A fully known environment test is not a recognized classification in penetration testing; hence it is not a valid choice.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      56,
      59,
      60,
      55,
      44
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 443,
    "question": "Jake is reviewing a database containing records of customer purchases and comes across the following table. What data minimization technique has most likely been used on the credit card information in this table?<img src=\"/question_assets/Security+/pt01f003.png\"/>",
    "choice_a": "Tokenization",
    "choice_b": "Destruction",
    "choice_c": "Hashing",
    "choice_d": "Masking",
    "correct_answer": "A",
    "explanation": "This data is most likely tokenized. It appears to have been replaced with a sequential identifier that might be used to reference a credit card number contained in a lookup table. If the data had been hashed, it would contain fixed-length hash values. If the data had been masked, it would contain placeholder characters, such as asterisks or Xs.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      318,
      10,
      319,
      316,
      9
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 444,
    "question": "Rhonda needs a digital certificate for a new web server that she is putting online this afternoon. If she has no prior relationship with a CA, what type of certificate can she obtain most quickly?",
    "choice_a": "OV",
    "choice_b": "EV",
    "choice_c": "DV",
    "choice_d": "UV",
    "correct_answer": "C",
    "explanation": "Domain validation (DV) certificates require only verification of domain ownership, which can normally be done through an automated process. Other types of certificates require more thorough and time-consuming verification steps.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      120,
      119,
      118,
      122,
      124
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 445,
    "question": "Andrea is conducting a penetration test and is considering attacking systems belonging to a subsidiary of the target organization in an attempt to gain access. She is unsure whether this is permitted. What document should she consult to determine if this is acceptable activity?",
    "choice_a": "Statement of work",
    "choice_b": "Contract",
    "choice_c": "Rules of engagement",
    "choice_d": "Lessons learned report",
    "correct_answer": "C",
    "explanation": "The rules of engagement provide technical details about the parameters of the test. This level of detail would not normally be found in a contract or statement of work. The lessons learned report is not produced until after the test.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      57,
      58,
      289,
      275,
      276
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 446,
    "question": "Which one of the following reconnaissance techniques allows an attacker to gather information with the least likelihood of the target learning of the attack?",
    "choice_a": "Vulnerability scan",
    "choice_b": "OSINT",
    "choice_c": "Ping sweep",
    "choice_d": "SSH scan",
    "correct_answer": "B",
    "explanation": "Open source intelligence (OSINT) uses research techniques that mine publicly available information about the subject. OSINT would not trigger any alerts in the subject\u2019s security systems. The other active reconnaissance techniques listed here all involve interactions with target systems that would leave log entries and other traces of the attacker\u2019s actions.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      24,
      19,
      244,
      245,
      13
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 447,
    "question": "What term best describes data that is in the memory of a computer system?",
    "choice_a": "Data in transit",
    "choice_b": "Data at rest",
    "choice_c": "Data in storage",
    "choice_d": "Data in use",
    "correct_answer": "D",
    "explanation": "Data in processing, or data in use, is data that is actively in use by a computer system. Data being sent over a network is data in transit. Data at rest is stored data that resides on hard drives, on tapes, in the cloud, or on other storage media.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      8,
      9,
      10,
      319,
      11
    ],
    "source": "211418_PracticeTest1"
  },
  {
    "id": 448,
    "question": "Lori has discovered that a system she is responsible for is sending traffic to an alternate gateway rather than to her organization\u2019s normal gateway. What type of attack is Lori most likely investigating?",
    "choice_a": "A Trojan",
    "choice_b": "An on-path attack",
    "choice_c": "A replay attack",
    "choice_d": "An amplified DDoS",
    "correct_answer": "B",
    "explanation": "Lori has likely encountered an on-path attack that redirects traffic through a system controlled by the attacker. The alternate gateway will be the default route for traffic sent by the system, allowing the attacker to see and potentially manipulate the network traffic. A Trojan is designed to look like a legitimate application or program. A replay attack captures and re-sends valid authentication data, and an amplified DDoS increases traffic sent to a target using flaws and features of various software that result in more traffic being sent than was received.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      226,
      74,
      36,
      26,
      228
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 449,
    "question": "Brian\u2019s security management tool flags multiple usernames for his organization all attempting to log in across systems. When he investigates, he notes that the failed attempts all use the same password. What type of attack has Brian discovered?",
    "choice_a": "A birthday attack",
    "choice_b": "A credential overflow attack",
    "choice_c": "An injection attack",
    "choice_d": "A password spraying attack",
    "correct_answer": "D",
    "explanation": "Brian has discovered a password spraying attack. Password spraying attacks use the same password across multiple usernames to attempt to log in. Birthday attacks attack encryption, credential overflow attacks were made up for this question, and injection attacks are used against SQL databases.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      37,
      73,
      38,
      127,
      72
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 450,
    "question": "When Lucca wants to test a potentially malicious file, he uploads it to a party website. That website places the software in a secured testing environment and documents what it does,  then uses antimalware tools to try to identify it. What is that type of secure testing environment called?",
    "choice_a": "A software jail",
    "choice_b": "A sandbox",
    "choice_c": "A litterbox",
    "choice_d": "A root dungeon",
    "correct_answer": "B",
    "explanation": "Running software in an isolated, instrumented, and protected sandbox is a useful technique when testing unknown, potentially malicious software. Sandboxing techniques are used by many malware analysis tools and companies to allow them to determine what a new malicious application does. The   are made up.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      69,
      72,
      83,
      27,
      25
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 451,
    "question": "Arun wants to determine the best placement for new Wi-Fi access points. What process is typically done to determine where access points should be placed?",
    "choice_a": "A Wi-Fi map",
    "choice_b": "A directional map",
    "choice_c": "A site survey",
    "choice_d": "A SSID survey",
    "correct_answer": "C",
    "explanation": "Site surveys are done to map existing installations and to create wireless signal heat maps to determine where a new access point may be needed or where coverage is weak. Wi-Fi maps, directional maps, and SSID surveys are not common terms used for this purpose.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      231,
      232,
      211,
      150,
      151
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 452,
    "question": "Helena wants to ensure that a drive is properly sanitized before being reused. What process is typically used for a hard drive?",
    "choice_a": "A secure erase",
    "choice_b": "The drive is pulverized.",
    "choice_c": "The drive is incinerated.",
    "choice_d": "The drive is reformatted.",
    "correct_answer": "A",
    "explanation": "Secure erase utilities are frequently used for hard drives. Pulverizing and incinerating drives destroys them, preventing them from being reused. Reformatting does not completely erase data.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      10,
      156,
      155,
      318,
      151
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 453,
    "question": "Cynthia has defined a boundary around her organization in the MDM tool she uses, and users are unable to access institutional data when their mobile devices are outside of that boundary. What is this technique called?",
    "choice_a": "Geofencing",
    "choice_b": "GeoIP",
    "choice_c": "Geotagging",
    "choice_d": "Geolocation",
    "correct_answer": "A",
    "explanation": "Geofencing places a boundary around a location using geolocation services. Actions are taken based on where a device is in relation to the geofence. A geoIP system attempts to match IP addresses to a geographic location or region. Geotagging marks a specific spot, and geolocation is the ability to locate a device or system.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      238,
      237,
      236,
      239,
      214
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 454,
    "question": "Gary has deployed a technology that allows him to manage his network via APIs. He uses the technology to dynamically manage the network as part of his zero-trust deployment and to ensure appropriate performance from the network. What type of network technology is Gary using?",
    "choice_a": "IoT",
    "choice_b": "Virtualization",
    "choice_c": "Containerization",
    "choice_d": "Software-defined networking",
    "correct_answer": "D",
    "explanation": "Software-defined networking (SDN) uses software-based controllers and application programming interfaces to control networks. It is frequently used to ensure proper performance by making dynamic changes to networks and is a common element in zero-trust deployments. IoT (Internet of Things) describes a variety of Internet-connected smart devices. Virtualization can involve software-defined networking as part of its environment but goes beyond what is described. Containerization is used to allow applications to move with only their needed components, making them easy to deploy across systems and operating systems.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      177,
      175,
      173,
      11,
      193
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 455,
    "question": "Bart runs a backup service for his organization, and every day he backs up the changes since the last backup operation he performed. If today\u2019s only backed up the changes since the last backup operation, what type of backup is he performing?",
    "choice_a": "Differential",
    "choice_b": "Full",
    "choice_c": "Incremental",
    "choice_d": "Partial",
    "correct_answer": "C",
    "explanation": "Bart is conducting an incremental backup. Differential backups back up all data that has changed since the last full backup. Incremental backups back up the changes since the last full or incremental backup. Full backups back up all data, and partial backups are not a defined technical term.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      153,
      152,
      154,
      161,
      315
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 456,
    "question": "Angela wants to implement a SSL/TLS inspection capability. What will occur when she enables it?",
    "choice_a": "TLS traffic will be intercepted, decrypted, inspected, then reencrypted and sent on to its destination",
    "choice_b": "TLS traffic will be checked for insecure encryption options",
    "choice_c": "TLS traffic will be hashed and validated against the original traffic that was sent",
    "choice_d": "Intact TLS traffic will be inspected for malicious traffic",
    "correct_answer": "A",
    "explanation": "SSL and TLS inspection systems rely on the ability to intercept and decrypt encrypted communications. This can cause concerns from users who know that otherwise secure communications can be accessed and may lead to some security warnings depending on the implementation. It is not a protocol analysis tool, nor does it hash and validate traffic or inspect intact TLS traffic.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      100,
      118,
      115,
      121,
      225
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 457,
    "question": "Chuck wants to deploy a sensor in his datacenter that will detect humans who enter the space. He has a relatively low budget, so he wants the best coverage he can get inexpensively. What type of sensors should he purchase?",
    "choice_a": "Infrared",
    "choice_b": "Microwave",
    "choice_c": "Pressure",
    "choice_d": "Ultrasonic",
    "correct_answer": "A",
    "explanation": "Chuck knows that infrared sensors are typically less expensive and are well suited to detect humans moving in a space. Microwave sensors typically cost more per sensor but are less likely to be influenced by temperature variations and can work through some substances, allowing them to monitor areas that infrared sensors cannot. Pressure sensors are deployed in specific locations and are not well suited to monitoring a larger facility like a datacenter, and ultrasonic sensors are rarely used in enterprise environments for this type of purpose.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      166,
      162,
      163,
      165,
      1
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 458,
    "question": "Catherine wants to deploy a split-tunnel VPN. What is the key difference between a split-tunnel and a full-tunnel VPN?",
    "choice_a": "The amount of bandwidth available",
    "choice_b": "A split tunnel VPN only sends traffic intended for the VPN client through the tunnel",
    "choice_c": "A split tunnel VPN only sends traffic intended for the remote network through the tunnel",
    "choice_d": "A full-tunnel VPN makes the system appear   it is on the local network",
    "correct_answer": "C",
    "explanation": "A split-tunnel VPN sends traffic intended for the remote VPN network through the tunnel and responses back to the client. It does not force all traffic meant to go to the VPN client through the tunnel\u2014in fact, traffic from systems that are not part of the remote VPN network continues to bypass the VPN tunnel. A full-tunnel VPN makes the system appear         although some VPN systems may prevent local network access while the VPN is turned on. Finally, bandwidth is not determined by the type of tunnel.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      177,
      212,
      211,
      193,
      11
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 459,
    "question": "Todd\u2019s upstream Internet provider informs him that their IPS has detected an attacker who appears to have spoofed his organization\u2019s server IP address to send DNS queries with large responses via UDP to his organization. What type of attack has Todd\u2019s ISP observed?",
    "choice_a": "A reflected DDoS",
    "choice_b": "An amplified, reflected DDoS",
    "choice_c": "An amplified DDoS",
    "choice_d": "A DNS on-path DDoS",
    "correct_answer": "B",
    "explanation": "This DDoS is both amplified by the larger responses and reflected because it is spoofed and sent back to the apparent sender. An on-path attack inserts a system controlled by the attacker into a network path, allowing the attacker to observe and potentially modify traffic.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      228,
      227,
      226,
      31,
      74
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 460,
    "question": "Michelle has received a drive that a manager in her organization retrieved from a staff member\u2019s house. The drive had been left on the manager\u2019s desk for a week before she caught up with Michelle to hand the drive over. What concern should Michelle express about the drive in the event that it is needed for a legal case?",
    "choice_a": "The drive cannot be safely copied after not having power for so long.",
    "choice_b": "The drive may not meet legal hold requirements.",
    "choice_c": "The drive may have lost data after not having power for so long.",
    "choice_d": "There is a gap in the chain of custody for the drive.",
    "correct_answer": "D",
    "explanation": "Since the drive acquisition was both unmonitored and not logged, and since the drive sat without being secured, the chain of custody for the drive cannot be validated. Michelle cannot prove that the drive was handled properly or was not modified between the time it was obtained and when it was handed to her. Drives will not typically lose data or have issues being copied after being unpowered for a week, or even months. There is no requirement for legal hold in this scenario, and no third party requested that the drive or data on the drive be preserved.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      263,
      261,
      240,
      264,
      270
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 461,
    "question": "Rick has been asked to secure a legacy SCADA environment that his organization uses to manage power generation facilities. What recommendation is best suited to a legacy environment that uses a combination of proprietary and open protocols and systems?",
    "choice_a": "Require regular patching and enable local firewalls on all devices to build a trust environment",
    "choice_b": "Deploy  HIPS for each device to protect each system from both known and behavioral threats",
    "choice_c": "Put the SCADA system on an isolated network and strictly control ingress and egress",
    "choice_d": "None of the above",
    "correct_answer": "C",
    "explanation": "Aging infrastructure that is tightly coupled to critical systems like a power generation facility is a common issue that enterprise security practitioners encounter in many industries. Placing devices that cannot otherwise be secured onto an isolated network and ensuring that only trusted and inspected access is allowed is a common solution. Since aging devices are often out of support, cannot be patched, and do not have support for firewalls or host-based intrusion prevention systems (HIPSs), those solutions are often unable to be implemented, particularly for the embedded and specialized devices found in supervisory control and data acquisition (SCADA) and    ICS environments.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      285,
      162,
      225,
      147
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 462,
    "question": "Georgia wants to ensure that if a network tap she has installed fails due to an extended power outage that traffic still flows to her network. What should she deploy?",
    "choice_a": "A passive fail-open tap",
    "choice_b": "A passive fail-closed tap",
    "choice_c": "An active fail-open tap",
    "choice_d": "An active fail-closed tap",
    "correct_answer": "A",
    "explanation": "A passive fail-open tap will continue to work despite a power outage and will pass traffic if it fails. While active taps often include some form of battery backup, Georgia\u2019s best bet in this scenario is a passive tap. Fail-closed taps will stop traffic when they fail and do not meet the requirements Georgia has.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      162,
      163,
      165,
      164
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 463,
    "question": "Marek wants to deploy a firewall that also provides a wide variety of additional security services like antivirus/antimalware, VPN, and IPS. What type of firewall device should he select?",
    "choice_a": "A WAF",
    "choice_b": "A UTM",
    "choice_c": "An EAP",
    "choice_d": "A stateful firewall",
    "correct_answer": "B",
    "explanation": "Unified threat management (UTM) devices are designed to be all-in-one security devices. They commonly offer services ranging from IPS and IDS to spam filtering and antivirus/antimalware. Stateful firewalls do not provide these additional features but do track the state of traffic to allow responses back through the device. A web application firewall (WAF) is specialized to defend against web application threats and attacks, and Extensible Authorization Protocol (EAP) is an authentication protocol, not a firewall.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      225,
      282,
      283,
      146
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 464,
    "question": "Dan needs to select a mobile device deployment model to fit his organization\u2019s needs. He wants to have the maximum amount of control over the devices selected but wants users to be able to install applications they need to make the devices useful to them. What model should he use?",
    "choice_a": "BYOD",
    "choice_b": "COPE",
    "choice_c": "CYOD",
    "choice_d": "COBO",
    "correct_answer": "B",
    "explanation": "The corporate-owned, personally enabled (COPE) model provides devices to users but allows them to use the device for their own use as well. BYOD (bring your own device) simply uses personally owned devices, while CYOD (choose your own device) allows users to select typically from a limited set of devices that the organization purchases and provides. COBO (corporate owned, business only), while not found in the current exam outline, is a common model in high-security environments.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      235,
      151,
      160,
      157,
      11
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 465,
    "question": "Dana needs to deploy and manage applications on mobile devices for her organization and knows that a broad variety of tools support this. Which of the following is not a common tool for this purpose?",
    "choice_a": "MDM",
    "choice_b": "MAM",
    "choice_c": "MARS",
    "choice_d": "UEM",
    "correct_answer": "C",
    "explanation": "Mobile device management (MDM), mobile application management (MAM), and universal endpoint management (UEM)tools are all commonly used manage applications on mobile devices. MARS isn\u2019t a common acronym, Cisco\u2019s MARS product is a monitoring and analysis tool used to mange network devices, not mobile devices.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      282,
      284,
      283,
      285,
      6
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 466,
    "question": "Tom wants to duplicate all traffic passing through a network connection but does not want to add any additional load to the switch that it is passing through. What should he do to accomplish this?",
    "choice_a": "tap.",
    "choice_b": "Enable port spanning.",
    "choice_c": "Enable port mirroring.",
    "choice_d": "Use a tap while enabling port spanning.",
    "correct_answer": "A",
    "explanation": "A tap is a device that independently sends a copy of network traffic to another path or location. Both active and passive taps exist, and they offer the advantage of not requiring the switch or router to process the traffic. Span ports can result in problems ranging from dropped packets to changing how frames interact due to load on the device and timing depending on the scope of the span.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      267,
      219,
      251,
      240,
      250
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 467,
    "question": "Maria wants to use a secure replacement for FTP and wants to use the tool that will require the least additional work to function through her firewall. Which secure replacement should she choose, and for which reason?",
    "choice_a": "FTPS, because it provides strong encryption",
    "choice_b": "SFTP, because it uses the same port as SSH",
    "choice_c": "FTPS, because it uses the same port as SSH",
    "choice_d": "SFTP, because it provides strong encryption",
    "correct_answer": "B",
    "explanation": "SFTP implements file transfers via SSH and only requires a single port to be open. FTPS uses a second port for file transfers, just like FTP. SFTP also allows the use of based authentication, making transfers even easier for users. Both SFTP and FTPS provide strong encryption, so this is not a deciding factor.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      53,
      192,
      215,
      214,
      135
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 468,
    "question": "Abigail\u2019s organization has had a number of users report that their systems were infected with malware after visiting a site belonging to a local business that staff members visit frequently. What type of attack has Abigail\u2019s organization most likely suffered from?",
    "choice_a": "Credential harvesting",
    "choice_b": "A watering hole attack",
    "choice_c": "Whaling",
    "choice_d": "Pretexting",
    "correct_answer": "B",
    "explanation": "A watering hole attack focuses on redirecting a commonly used website to a malicious site. Credential harvesting attacks can use many different techniques to acquire credentials. Whaling is phishing targeting specific important users, and pretexting is a social engineering technique that provides an excuse why a person is conducting an activity or needs specific access.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      36,
      33,
      34,
      32,
      19
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 469,
    "question": "Sally works for a government agency that works with classified information. What threat actor motivation is likely to be her highest concern from nation-state actors?",
    "choice_a": "Ethical",
    "choice_b": "Espionage",
    "choice_c": "Revenge",
    "choice_d": "Financial gain",
    "correct_answer": "B",
    "explanation": "Espionage is a common motivation for nation-state actors. Data exfiltration, disruption and chaos, and war are also likely potential motivations for nation-state actors. Ethical motivations are more commonly associated with hacktivists, whereas revenge is most often associated with insider threats. Financial gain is typically connected to organized crime and insider threats.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      12,
      19,
      16,
      18,
      245
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 470,
    "question": "As part of her organization\u2019s response and recovery controls, Charlene has implemented a remote site that has all the systems needed to operate her company\u2019s IT infrastructure. In the event of a major outage or issue, she would need to bring copies of data to the site. What type of disaster recovery site has she set up?",
    "choice_a": "Cold site",
    "choice_b": "Warm site",
    "choice_c": "Hot site",
    "choice_d": "Availability zone",
    "correct_answer": "B",
    "explanation": "A warm site has all the hardware and networking needed to run essential operations, but does not have the data ready to go. cold site is essentially just space to bring in equipment, networking, and data. A hot site has everything you need, and may the last data updateAvailability zones are a cloud computing concept used by Amazon.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      158,
      315,
      153,
      160,
      161
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 471,
    "question": "What is the primary difference between HIDS and HIPS?",
    "choice_a": "HIDS can only be installed on servers",
    "choice_b": "HIDS can stop attacks and HIPS only log them",
    "choice_c": "HIPS can only be installed on servers",
    "choice_d": "HIDS only log attacks and HIPS can stop them",
    "correct_answer": "D",
    "explanation": "The primary difference between a host intrusion detection system and a host intrusion prevention system is that a can stop attacks by dropping or modifying traffic a host-based intrusion detection system (HIDS) will only log and alert on attacks.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      5,
      282,
      283,
      147
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 472,
    "question": "Joanna wants to implement an access control schema for her organization and needs to identify staff members based on their job title, their location, and whether they are a member of a specific team. What type of access control mechanism should she choose?",
    "choice_a": "ABAC",
    "choice_b": "DAC",
    "choice_c": "MAC",
    "choice_d": "RBAC",
    "correct_answer": "A",
    "explanation": "ABAC (based access control is based on attributes of subjects. In this case, each of the items listed is an attribute that can be used to grant permissions or access. Discretionary access control (DAC) gives resource owners the rights to decide what others can do with their resources. MAC enforces access control at the system or OS level, requiring the administrator to make those choices. RBAC can be either rule or based access control. Here, there are more than roles involved, and no rules were mentioned.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      147,
      146,
      285,
      5,
      6
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 473,
    "question": "Helen is reviewing network traffic in Wireshark and sees the traffic shown here. What should she identify as a likely network event?<img src=\"/question_assets/Security+/pt02f001.png\"/>",
    "choice_a": "A system drop its network connection",
    "choice_b": "A service attack",
    "choice_c": "A force attack",
    "choice_d": "A dictionary attack",
    "correct_answer": "B",
    "explanation": "This traffic pattern is most likely to indicate a attack involving a SYN flood. This is not a distributed attack because there is only one system sending the SYN packets, so Helen might choose to investigate the system or block it.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      228,
      31,
      19,
      245,
      27
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 474,
    "question": "Adam wants to deploy time passwords to his staff, and wants to be able to support many different sites while also providing the ability to enroll users using his MDM system. What tool should he select?",
    "choice_a": "Hardware tokens",
    "choice_b": "Static codes",
    "choice_c": "An authentication application",
    "choice_d": "based push authentication",
    "correct_answer": "C",
    "explanation": "Adam should select an authentication application. Tools like Google Authenticator, Duo, and Microsoft Authenticator all provide the capabilities that he is looking for. Some hardware tokens can handle multiple sites but are not manageable via MDM. Static codes are just that\u2014printed-out codes. Phone-based push authentication could support multiple sites but is far less secure and, again, is not managed via MDM.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      140,
      141,
      132,
      255,
      238
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 475,
    "question": "Elaine wants to protect her endpoint systems from malware and other malicious activity while also providing central monitoring and identification of threat behaviors. What technology should she recommend to best fit this need?",
    "choice_a": "An IPS",
    "choice_b": "A DLP",
    "choice_c": "An EDR",
    "choice_d": "An MSP",
    "correct_answer": "C",
    "explanation": "Endpoint detection and response (EDR) tools protect endpoints while connecting to a central management and analysis console that helps detect and respond to threat behaviors. An intrusion prevention system (IPS) is useful for protecting systems at the network level but is not as well suited to endpoint protection. A data loss prevention (DLP) tool can help prevent data leakage and exfiltration, and an MSP is a managed service provider.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      187,
      186,
      246,
      254,
      189
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 476,
    "question": "Kirk wants to learn more about attacker techniques, and to do so he sets up a system that appears to be vulnerable to attacks he is curious about. He carefully instruments the system and captures all attacker data and actions. What type of system has Kirk set up?",
    "choice_a": "A darknet",
    "choice_b": "A honeypot",
    "choice_c": "A tarpit",
    "choice_d": "A beartrap",
    "correct_answer": "B",
    "explanation": "Kirk has set up a honeypot, an intentionally vulnerable and instrumented system designed to allow defenders to analyze attacker tools and techniques. A darknet is unused network space that is instrumented to allow the observation of network probes and attacks, particularly those that target network space by iterating through IP address ranges. Tarpits are systems that are designed to slow attackers down, such as those that respond to vulnerability scans very slowly with a service on every port. Beartrap is not a security term.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      55,
      219,
      246,
      248,
      42
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 477,
    "question": "Emily wants to check on the success of her organization\u2019s system-hardening process. What information-gathering process is frequently used to quickly validate whether unneeded services have been disabled?",
    "choice_a": "A port scan",
    "choice_b": "A vulnerability scan",
    "choice_c": "A Registry scan",
    "choice_d": "An Opal review",
    "correct_answer": "A",
    "explanation": "A quick port scan is often used to check if unnecessary and unwanted services remain accessible. a vulnerability scan can be used, a port scan will be faster. A Registry scan might be used, but wouldn\u2019t work for Linux systems or other non-Windows devices Opal is an  drives.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      192,
      59,
      40,
      63,
      48
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 478,
    "question": "Jim wants to centrally create, store, and manage certificates and cryptographic keys for his entire organization. What sort of appliance-based hardware solution should he select?",
    "choice_a": "An HSM",
    "choice_b": "A TPM",
    "choice_c": "An XDR",
    "choice_d": "A Secure Enclave",
    "correct_answer": "A",
    "explanation": "Hardware security modules (HSMs) are used to create, store, and manage cryptographic certificates and keys in a secure manner. Trusted platform modules (TPMs) are used to help protect the boot process for systems. XDR (extended detection and response) describes technologies that correlate incident and security event information across a wide range of platforms and systems, and then provide analytics and response capabilities. A secure enclave is a dedicated secure element that is built into Apple\u2019s system on chip modules (SOCs). They provide hardware key management, which is isolated from the main CPU, protecting keys throughout their life cycle and usage.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      124,
      119,
      111,
      112,
      130
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 479,
    "question": "Erica is documenting potential concerns about patching as part of the change management for her organization\u2019s security practices. Which of the following is not a common technical implication of patching?",
    "choice_a": "Legacy applications",
    "choice_b": "Downtime",
    "choice_c": "Service restarts",
    "choice_d": "Application restarts",
    "correct_answer": "A",
    "explanation": "Downtime as well as the need for applications and services to restart are common technical implications of patching processes. Patching doesn\u2019t create legacy applications, but legacy applications are unlikely to have new patches available.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      282,
      283,
      284,
      285,
      5
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 480,
    "question": "Ron receives a notification that computers throughout his organization have begun to display a message demanding that money be paid in Bitcoin to allow restoration of access to important business documents and other files. What type of malware often uses this type of behavior?",
    "choice_a": "Worms",
    "choice_b": "Viruses",
    "choice_c": "Ransomware",
    "choice_d": "Spyware",
    "correct_answer": "C",
    "explanation": "Ransomware demands a ransom paid in Bitcoin to unlock files. paying does often result in the files being restored, this can be a dangerous option and does not guarantee results. Secure, independent backups are the best insurance against cryptographic malware taking your business out of operation. Worms spread themselves, but the actions they take vary from worm to worm, as do the actions taken by viruses. Spyware gathers information about user browsing habits but does not demand a ransom.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      25,
      27,
      26,
      31,
      30
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 481,
    "question": "Which of the following is the most volatile according to the order of volatility for forensics practitioners?",
    "choice_a": "Backups",
    "choice_b": "Disk drives",
    "choice_c": "RAM",
    "choice_d": "Virtual memory",
    "correct_answer": "C",
    "explanation": "RAM, CPU cache, and CPU state (registers) are considered the most volatile for forensics purposes. Virtual memory, disk drives, and backups follow.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      262,
      259,
      267,
      263,
      260
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 482,
    "question": "Ujama is deploying a wireless access point for a small business that won\u2019t use enterprise authentication for wireless. What WPA3 feature ensures that the initial key exchange for personal mode is more secure?",
    "choice_a": "MAC",
    "choice_b": "PSK",
    "choice_c": "SAE",
    "choice_d": "IKE",
    "correct_answer": "C",
    "explanation": "Simultaneous Authentication of Equals (SAE) provides a more secure initial key exchange process than PSKs (preshared keys) did in WPA2. Ujama should implement a WPA-3 personal mode network to meet this need. MAC (Media Access Control) addresses are the hardware addresses used for networked devices. IKE (Internet Key Exchange) is part of the IPSec protocol but is not used for this.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      110,
      109,
      104,
      101,
      98
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 483,
    "question": "What device deployment model is least likely to support an agent-based NAC solution?",
    "choice_a": "owned",
    "choice_b": "Bring your own device",
    "choice_c": "owned, personally enabled",
    "choice_d": "Choose your own device",
    "correct_answer": "B",
    "explanation": "BYOD environments are less likely to find general acceptance of agent-based NAC solutions since they require the installation of an agent that can be obtrusive. That means that agentless NAC solutions are more common when security needs must still be met without an agent being installed.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      147,
      146,
      5,
      6,
      285
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 484,
    "question": "Nathaniel is scanning for SSH servers on his network. What port and protocol should he scan for to find them?",
    "choice_a": "22/UDP",
    "choice_b": "443/UDP",
    "choice_c": "22/TCP",
    "choice_d": "443/TCP",
    "correct_answer": "C",
    "explanation": "The default SSH port is 22 via TCP. some administrators move SSH to a nonstandard port, most invest time in protecting the SSH server and accounts instead.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      59,
      49,
      53,
      192,
      52
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 485,
    "question": "Sarah\u2019s security team has recommended that she place the offsite storage facility for her organization\u2019s backups at least 90 miles away from the primary office location. What is the primary driver of this recommendation?",
    "choice_a": "prevent theft by making the backups hard to get to for local thieves",
    "choice_b": "miles away is the minimum distance to prevent latency issues for backups",
    "choice_c": "miles away a single disaster destroy the main facility and the backups",
    "choice_d": "miles away ensures that different local jurisdiction laws will apply, making it harder for a single legal case to involve the primary data and the backups",
    "correct_answer": "C",
    "explanation": "Geographic diversity is an important concept for redundant sites and backup locations. the minimum distance considered safe varies based on the guidelines you choose to follow, a distance like this is intended to ensure that a single disaster cannot destroy both the primary datacenter or storage location and the backups. the remainder of the answers may sound reasonable, they are not actual reasons for this type of geographic dispersion.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      150,
      159,
      158,
      154,
      315
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 486,
    "question": "Tom wants to properly define the data state for information that is being copied to a drive from a network share. Which data state best describes this?",
    "choice_a": "Data in use",
    "choice_b": "Data in transit",
    "choice_c": "Data in channel",
    "choice_d": "Data at rest",
    "correct_answer": "B",
    "explanation": "Data that is being copied across a network is considered data in transit. Data stored on a drive but not being accessed or used is data at rest. If the file was open and being edited, it would be considered data in use. Data in channel was made up for this question.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      8,
      9,
      222,
      318,
      10
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 487,
    "question": "Alaina has configured the switches and routers in her organization to use a private VLAN connected to dedicated management ports on her network devices. What type of management model is she using?",
    "choice_a": "SAN network management",
    "choice_b": "Serial console management",
    "choice_c": "Network segmentation",
    "choice_d": "Network isolation",
    "correct_answer": "C",
    "explanation": "Connecting to a device via a distinct administrative interface from a protected network is an example of out-of-band management, a form of network segmentation. Isolation would remove the device entirely from the network. A SAN is a storage area network, and serial connections were (and sometimes still are) used for direct console access to devices, but this question does not describe a serial connection.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      285,
      146,
      147,
      163,
      164
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 488,
    "question": "Lucca\u2019s staff has received a text message with a link claiming to be to their annual performance review from HR. Lucca knows that the HR department does not send out performance reviews via text. What type of social engineering attack has Lucca\u2019s organization most likely been targeted by?",
    "choice_a": "A phishing attack",
    "choice_b": "A vishing attack",
    "choice_c": "A smishing attack",
    "choice_d": "A whaling attack",
    "correct_answer": "C",
    "explanation": "Smishing attacks are sent via text message or SMS. Vishing attacks are done by voice or voicemail, and phishing is a general term for attacks that attempt to gain credentials or sensitive information through human interaction. A whaling attack focuses on important individuals in an organization.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      33,
      32,
      19,
      25,
      36
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 489,
    "question": "Greg\u2019s desktop system stores hashes of the system\u2019s firmware, bootloader, drivers, and other components that are loaded at boot in the TPM, bootshe OS uses a remote attestation client to send that information to a server. What type of boot process is he using?",
    "choice_a": "BIOS boot",
    "choice_b": "UEFI hashing",
    "choice_c": "Secure boot",
    "choice_d": "Measured boot",
    "correct_answer": "D",
    "explanation": "This is a UEFI measured boot process. Secure boot validates hashes against known good hashes for those boot elements. BIOS does not support either of these processes. UEFI hashing was made up for this question.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      265,
      262,
      199,
      236,
      268
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 490,
    "question": "Jared wants to exchange keys with a third party in a secure manner. Why is key exchange a concern for cryptographic systems?",
    "choice_a": "Key length makes transferring keys difficult due to size.",
    "choice_b": "Asymmetric encryption require extra security when sending private keys.",
    "choice_c": "Symmetric encryption keys are all identical, meaning that they can be easily transferred.",
    "choice_d": "Users may not have a preexisting secure means of communication.",
    "correct_answer": "D",
    "explanation": "How to exchange keys between two users or systems that have never interacted before is a key problem in cryptographic systems. Protocols like Diffie\u2013Hellman key exchange address this issue for cryptographic systems, allowing users to securely exchange secret keys even if they have no preexisting trusted channel. Key length, even for long keys, does not create inordinately large files. Asymmetric encryption does not require the exchange of private keys, only public keys. Symmetric encryption keys are identical but must be protected, making exchange more challenging.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      109,
      110,
      104,
      105,
      111
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 491,
    "question": "Hank has purchased servers that have dual power supplies. How should he connect the power supplies to ensure that systems stay online?",
    "choice_a": "Connect both power supplies to the same UPS or power distribution system",
    "choice_b": "Connect the power supplies to different UPS or power distribution systems",
    "choice_c": "Leave one power supply disconnected so it can be enabled in case of an issue",
    "choice_d": "Leave one power supply disconnected to avoid providing too much power to the system",
    "correct_answer": "B",
    "explanation": "A dual power supply system is typically connected to two different power infrastructures to ensure that if one side fails the server or system will remain online. This is part of designing and building a fully redundant power infrastructure.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      150,
      151,
      157,
      153,
      161
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 492,
    "question": "Chris operates a database-driven e-commerce website and wants to be able to restore his backups to the point in time when an outage occurs, resulting in a very short recovery point objective (RPO). What type of backup capability will he need to be able to do this without losing data?",
    "choice_a": "Disk-based backup",
    "choice_b": "Cloud-based backup",
    "choice_c": "Journaling",
    "choice_d": "Snapshots",
    "correct_answer": "C",
    "explanation": "Organizations that want to restore databases to a point in time due to a small or short recovery point objective will deploy journaling technology. This will replay transactions to restore a database to a given point in time after it is restored from a backup point. Snapshots, disk, and cloud-based backups can be used for the underlying backup, but journaling provides the to-the-moment restoration capability desired to lose minimal transactions.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      153,
      154,
      155,
      315,
      158
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 493,
    "question": "Theresa\u2019s organization intends to run a hybrid cloud infrastructure. What security implications should she consider if her cloud provider is in another region?",
    "choice_a": "Latency",
    "choice_b": "Redundancy",
    "choice_c": "Compliance",
    "choice_d": "Data integrity",
    "correct_answer": "C",
    "explanation": "Hybrid solutions mean operations in multiple locations. Theresa should consider compliance requirements that may exist in each location. Latency is not a security consideration, and redundancy may impact availability but is not necessarily driven by location, nor is data integrity.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      292,
      287,
      290,
      308,
      310
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 494,
    "question": "Veronica would like to use a service from her cloud provider that will allow her to create, store, and manage the encryption keys used in her environment. What technology would best meet this goal?",
    "choice_a": "TPM",
    "choice_b": "PKI",
    "choice_c": "GPG",
    "choice_d": "HSM",
    "correct_answer": "D",
    "explanation": "Hardware security modules (HSM) are purpose computing devices that manage encryption keys and also perform cryptographic operations in a highly efficient manner. Trusted Platform Modules (TPM) do manage encryption keys, but they are specific to a device and are not available in the cloud. The Public Key Infrastructure (PKI) is the set of policies, procedures, hardware, and software used to issue and create, distribute, store, revoke and manage public keys and security certificates. GPG, also known as GnuPG, implements Pretty Good Privacy (PGP) and uses public and private keys for data encryption and signing.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      124,
      119,
      112,
      130,
      109
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 495,
    "question": "What security control can be used to clearly communicate to users the level of protection required for different data types?",
    "choice_a": "Classification policies",
    "choice_b": "Retention standards",
    "choice_c": "Life cycle practices",
    "choice_d": "Compensating controls",
    "correct_answer": "A",
    "explanation": "Classification policies create different categories of data used within an organization and then specify the level of security control required for each classification level. Using classifications helps users understand the type of protection necessary for each data type they encounter. Retention standards determine how long an organization keeps data, typically based on legal requirements and business requirements. Life cycle practices may include changing metadata or tags as data is archived, becomes outdated, or otherwise needs adjustment during its retention period. Compensating controls are controls that are used to help remediate issues that cannot be directly resolved.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      316,
      319,
      11,
      9,
      318
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 496,
    "question": "What two factors are weighted most heavily when determining the severity of a risk?",
    "choice_a": "Likelihood and probability",
    "choice_b": "Likelihood and impact",
    "choice_c": "Magnitude and impact",
    "choice_d": "Impact and control",
    "correct_answer": "B",
    "explanation": "The two factors that determine the severity of a risk are its probability and magnitude. Likelihood is a synonym for probability. Impact is a synonym for magnitude. Controls are a risk mitigation technique that might be applied to reduce the magnitude and/or probability after determining the severity of a risk.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      310,
      306,
      307,
      312,
      309
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 497,
    "question": "What term best describes data that resides on a hard drive attached to a server?",
    "choice_a": "Data at rest",
    "choice_b": "Data in transit",
    "choice_c": "Data in processing",
    "choice_d": "Data in use",
    "correct_answer": "A",
    "explanation": "Data at rest is stored data that resides on hard drives, tapes, in the cloud, or on other storage media. Data being sent over a network is data in transit or motion. Data in processing, or data in use, is data that is actively in use by a computer system.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      8,
      9,
      10,
      319,
      11
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 498,
    "question": "organization has purchased cybersecurity insurance in case of a breach. What risk management strategy has her organization selected?",
    "choice_a": "Transfer",
    "choice_b": "Accept",
    "choice_c": "Avoid",
    "choice_d": "Mitigate",
    "correct_answer": "A",
    "explanation": "Insurance is a way for organizations to transfer risk to another organization at a cost. Accepting the risk would involve management acknowledging the risk, avoiding the risk would seek to ensure that it doesn\u2019t occur, and mitigation attempts to make the impact less significant.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      309,
      313,
      314,
      310,
      306
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 499,
    "question": "Gwen wants to ensure that applications developed in her organization have effective security practices and processes as part of their creation. What should she do to have the biggest security impact for her organization if they use a continuous integration/continuous delivery (CI/CD) pipeline?",
    "choice_a": "Scan new applications for vulnerabilities before moving them to production.",
    "choice_b": "Build security into the SDLC.",
    "choice_c": "Train developers to ensure security awareness.",
    "choice_d": "Implement third-party code review processes.",
    "correct_answer": "B",
    "explanation": "Ensuring that security is built into the entire software development life cycle is the best option that Gwen can choose. Steps might include code reviews or secure coding techniques, security testing, and ongoing security validation throughout the life cycle. Vulnerability scanning only covers some vulnerabilities and isn\u2019t as effective as having it built into the entire process. Awareness helps, but again building in security throughout will provide greater coverage. Third-party code review is both expensive and slow and is not well suited to a CI/CD environment.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      66,
      85,
      65,
      92,
      93
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 500,
    "question": "Christopher received a message from Renee that was encrypted using an asymmetric encryption algorithm. What key should he use to decrypt the message?",
    "choice_a": "Christopher\u2019s public key",
    "choice_b": "Christopher\u2019s private key",
    "choice_c": "Renee\u2019s public key",
    "choice_d": "Renee\u2019s private key",
    "correct_answer": "B",
    "explanation": "In an asymmetric encryption algorithm, the recipient of a message uses their own private key to decrypt messages that they receive.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      105,
      116,
      115,
      112,
      124
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 501,
    "question": "Jan is concerned that attackers might use a rainbow table attack against her organization\u2019s stored passwords. What is the most effective defense against this type of attack?",
    "choice_a": "Pinning",
    "choice_b": "Key escrow",
    "choice_c": "Input validation",
    "choice_d": "Salting",
    "correct_answer": "D",
    "explanation": "Rainbow table attacks attempt to reverse hashed password value by precomputing the hashes of common passwords. The attacker takes a list of common passwords and runs them through the hash function to generate the rainbow table. They then search through lists of hashed values, looking for matches to the rainbow table. The most common approach to preventing these attacks is salting, which adds a randomly generated value to each password prior to hashing.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      114,
      107,
      102,
      117,
      98
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 502,
    "question": "Christine has been notified that a firewall device has reached its end of life. What should Christine do?",
    "choice_a": "Immediately purchase a new device to replace it.",
    "choice_b": "Begin planning to replace the device when a new version is announced.",
    "choice_c": "Budget for a future replacement before end of support.",
    "choice_d": "Plan to replace the device after end of support.",
    "correct_answer": "C",
    "explanation": "Most organizations plan to replace a device before it reaches end of support. Running devices past their end of support places the organization at risk because no support will be available if something goes wrong. End of life typically means that the device will no longer be sold, but it will continue to receive updates, patches, and support for some time to come.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      206,
      197,
      207,
      243,
      240
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 503,
    "question": "Jen believes that there may be a problem with underlying code in her application having logic flaws that were introduced by an insider threat. Which of the following code analysis options is most likely to help her identify the issue?",
    "choice_a": "Static code analysis",
    "choice_b": "Running the code in a sandbox",
    "choice_c": "Vulnerability scanning",
    "choice_d": "Dynamic code analysis",
    "correct_answer": "A",
    "explanation": "Static code analysis, which looks directly at source code, is the best option to identify logic errors, particularly when an insider threat with knowledge of the code may be involved. Running the code in a sandbox or running a vulnerability scan without knowing what the logic errors are is unlikely to find them. Dynamic code analysis may help but is less likely to find logic errors than static code analysis.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      49,
      63,
      258,
      62,
      48
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 504,
    "question": "organization is subject to PCI DSS. He determines that he will be unable to meet one of the PCI DSS objectives due to technical limitations and has obtained permission from his merchant bank to implement an alternative mechanism in place of the PCI DSS requirement. What type of control is Carl implementing?",
    "choice_a": "Preventive",
    "choice_b": "Compensating",
    "choice_c": "Detective",
    "choice_d": "Corrective",
    "correct_answer": "B",
    "explanation": "The scenario does not tell us whether the control is preventive, detective, or corrective. We do know, however, that it is being used in place of another control requirement that organization is unable to meet and is, therefore, a compensating control.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      5,
      285,
      283,
      284
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 505,
    "question": "Robin is planning to conduct a risk assessment in her organization. She is concerned that it will be difficult to perform the assessment because she needs to include information about both tangible and intangible assets. What would be the most effective risk assessment strategy for her to use?",
    "choice_a": "Quantitative risk assessment",
    "choice_b": "Qualitative risk assessment",
    "choice_c": "Combination of quantitative and qualitative risk assessment",
    "choice_d": "Neither quantitative nor qualitative risk assessment",
    "correct_answer": "C",
    "explanation": "Robin would have achieved the best results by combining elements of quantitative and qualitative risk assessment. Quantitative risk assessment excels at analyzing tangible, financial risks, qualitative risk assessment is good for intangible risks. Combining the two techniques provides a well-rounded risk picture.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      307,
      310,
      314,
      312
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 506,
    "question": "Tony\u2019s SaaS provider guarantees 99.5% uptime. What type of agreement is this type of guarantee typically included in?",
    "choice_a": "A MOA",
    "choice_b": "A MOU",
    "choice_c": "An SOW",
    "choice_d": "An SLA",
    "correct_answer": "D",
    "explanation": "An SLA (service level agreement) defines things like uptime. MOAs (memorandums of agreement) and MOUs (memorandums of understanding) are signed by parties that wish to work together to achieve an objective. A SOW (statement of work) defines the work that will be done as part of an agreement and is legally binding.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      289,
      290,
      287,
      286,
      291
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 507,
    "question": "Which of the following types of exercises is most similar to a real event?",
    "choice_a": "Failover",
    "choice_b": "Parallel processing",
    "choice_c": "Simulations",
    "choice_d": "Tabletop exercises",
    "correct_answer": "A",
    "explanation": "Failover exercises require organizations to actually switch to the backup systems or location. This is the closest to a real event of the four answers. Parallel processing, simulations, and tabletop exercises come next by similarity to a real event.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      161,
      160,
      153,
      315,
      156
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 508,
    "question": "Eve is investigating a security incident where the user of a web application submitted an internal URL to the application and tricked the web server into retrieving sensitive data from that URL and displaying it as output. What term best describes this attack?",
    "choice_a": "SSRF",
    "choice_b": "CSRF",
    "choice_c": "XSS",
    "choice_d": "Command injection",
    "correct_answer": "A",
    "explanation": "Server-side request forgery (SSRF) attacks trick a server into visiting a URL based on user-supplied input. SSRF attacks are possible when a web application accepts URLs from a user as input and then retrieve information from that URL. If the server has access to non-public URLs, an SSRF attack can unintentionally disclose that information to an attacker. CSRF (cross-site request forgery) leverages malicious code to cause users to take action via a website they\u2019re already authenticated to. XSS (cross-site scripting) injects malicious scripts into preexisting websites by getting them to display the scripts, and command injection attacks attempt to run commands on an operating system by leveraging a vulnerable application.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      81,
      80,
      71,
      83,
      82
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 509,
    "question": "Nathaniel believes that he has discovered a race condition in an application. What term associated with race conditions describes the issue that occurs when a value is validated?",
    "choice_a": "Time-of-use",
    "choice_b": "Target-of-evaluation",
    "choice_c": "Time-of-check",
    "choice_d": "Target-of-change",
    "correct_answer": "C",
    "explanation": "Time-of-check (TOC) is the term that describes when a value is validated. If the value is then changed before it is used (time of use), this can allow a race condition to occur. Target-of-evaluation is typically associated with testing or audits, and target-of-change is not a commonly used term related to race conditions.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      90,
      83,
      72,
      69,
      82
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 510,
    "question": "firm is planning to open a new retail store that will accept credit cards. What regulation must the firm comply with as a result of this processing?",
    "choice_a": "FERPA",
    "choice_b": "HIPAA",
    "choice_c": "GLBA",
    "choice_d": "PCI DSS",
    "correct_answer": "D",
    "explanation": "The Payment Card Industry Data Security Standard (PCI DSS) is an industry regulatory framework that specifies the cybersecurity requirements for organizations involved in credit card transactions. The Family Educational Rights and Privacy Act (FERPA) is a U.S. law protecting educational data. The Health Insurance Portability and Accountability Act (HIPAA) protects sensitive patient data. The Gramm\u2013Leach\u2013Bliley Act (GLBA) covers financial institutions that offer consumers financial products or services and requires them to safeguard their data.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      292,
      293,
      280,
      294,
      290
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 511,
    "question": "Jill is reviewing the security controls that her organization uses to protect a sensitive network segment. She determines that the network is lacking adequate IDS capability. What type of control deficiency has Jill identified?",
    "choice_a": "Detective",
    "choice_b": "Corrective",
    "choice_c": "Preventive",
    "choice_d": "Deterrent",
    "correct_answer": "A",
    "explanation": "An intrusion detection system (IDS) identifies potential intrusions that may be taking place on a network and is, therefore, an example of a detective control. An intrusion prevention system (IPS), on the other hand, might actually block the attack and would be an example of a preventive control.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      5,
      165,
      163,
      164
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 512,
    "question": "What component of a zero-trust reference design makes decisions based on rules set as part of the zero-trust configuration?",
    "choice_a": "The policy enforcement point",
    "choice_b": "The policy engine",
    "choice_c": "The policy administrator",
    "choice_d": "The policy enforcer",
    "correct_answer": "B",
    "explanation": "In a zero-trust reference design, a subject\u2019s use of a system that is untrusted connects through a policy enforcement point allowing trusted transactions to the enterprise resources. A policy engine makes policy decisions based on rules that are then acted on by policy administrators. Policy enforcer is not a part of the reference design.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      213,
      211,
      212,
      151,
      156
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 513,
    "question": "Chris is designing a data loss prevention implementation for his organization. His primary goal is to protect a set of product plans that reside in a small data repository. New files are added to this repository on a periodic basis and all of the files in the repository require protection. What technology would best meet needs?",
    "choice_a": "Pattern recognition",
    "choice_b": "Host-based",
    "choice_c": "Watermarking",
    "choice_d": "Network-based",
    "correct_answer": "C",
    "explanation": "Chris could use either host-based or network-based DLP to meet his needs. The key technology in this scenario is the use of watermarking as the identification technique for sensitive data. Chris can tag all the documents in the secure repository with digital watermarks to flag them to the DLP system. Pattern recognition would not be a useful tool in this case because new documents are regularly added to the repository.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      9,
      319,
      316,
      11,
      318
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 514,
    "question": "Brian has used websites, DNS, and other information available via the Internet to gather information about his organization. He intends to use the information to understand what information malicious actors could obtain about his organization. What is information gathered this way known as?",
    "choice_a": "Responsible disclosure",
    "choice_b": "Proprietary information",
    "choice_c": "Open source intelligence",
    "choice_d": "Insider threat data",
    "correct_answer": "C",
    "explanation": "Open source intelligence (OSINT) is information that can be obtained through the Internet without performing scans or other direct data gathering. OSINT is commonly gathered by both defenders and attackers as part of their efforts. Responsible disclosure is the process of information an organization about a flaw or issue that has been discovered. Proprietary information is information that is gathered or created by an organization and is often considered a trade secret or part of a paid service. Insider threats are members of an organization who work against it either inadvertently or on purpose.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      24,
      12,
      19,
      18,
      17
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 515,
    "question": "Klara wants to implement a biometric factor for a multifactor authentication system. What concern should she raise if the biometric system is noted to have a high FRR?",
    "choice_a": "Users who shouldn\u2019t be able to authenticate may be able to.",
    "choice_b": "Users who should be able to authenticate may be rejected.",
    "choice_c": "Users may not be able to successfully enroll in the biometric system.",
    "choice_d": "Users may not be able to change their biometric identifiers.",
    "correct_answer": "B",
    "explanation": "FRR (false rejection rate) describes what happens when a biometric system does not accept a valid biometric factor. Klara should look for a low FAR (false acceptance rate) as well as a low FRR (false rejection rate).",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      142,
      140,
      139,
      141,
      133
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 516,
    "question": "Which of the following is the least likely to be a threat created by having an unsecured wireless network?",
    "choice_a": "Intercepting unencrypted data",
    "choice_b": "Spoofing the SSID to conduct an on-path attack",
    "choice_c": "Distributed denial-of-service attacks",
    "choice_d": "Undesired access by third parties",
    "correct_answer": "C",
    "explanation": "Unsecure wireless can lead to unencrypted data being intercepted, spoofing of the SSID resulting in an on-path attack or access by third parties. Not securing Wi-Fi is less likely to result in a denial-of-service (DoS) attack, and a distributed denial-of-service (DDoS) attack is even less likely.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      230,
      228,
      226,
      234,
      229
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 517,
    "question": "Brian discovers a printed roster of employees that contains the information shown here. What type of data protection has most likely been applied to this report?<img src=\"/question_assets/Security+/pt02f002.png\"/>",
    "choice_a": "Tokenization",
    "choice_b": "Hashing",
    "choice_c": "Encryption",
    "choice_d": "Masking",
    "correct_answer": "D",
    "explanation": "In this report, the first five digits of the Social Security number have been replaced with Xs. This is clearly an example of data masking.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      318,
      10,
      319,
      316,
      9
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 518,
    "question": "Bea wants to establish a password standard. Which of the following organizations does not provide commonly used password guidelines?",
    "choice_a": "NIST",
    "choice_b": "Microsoft",
    "choice_c": "NSA",
    "choice_d": "IEC",
    "correct_answer": "D",
    "explanation": "The U.S. National Institute of Standards and Technology (NIST), Microsoft, and the National Security Agency (NSA) all provide regularly updated password guidelines to help organizations build password policies. The IEC (International Electrical Commission) creates standards for electrical devices, not passwords.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      277,
      275,
      296,
      298,
      299
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 519,
    "question": "April is working with an independent auditor to produce an audit report that she will share with her customers under NDA to demonstrate that her organization has appropriate security controls in place and that those controls are operating effectively. What type of audit report should April expect?",
    "choice_a": "SOC 2 Type 1",
    "choice_b": "SOC 2 Type 2",
    "choice_c": "SOC 3 Type 1",
    "choice_d": "SOC 3 Type 2",
    "correct_answer": "B",
    "explanation": "The fact that the auditor will be assessing the effectiveness of the controls means that this is a Type 2 report, not a Type 1 report. The fact that it will be shared only under NDA means that it is a SOC 2 assessment.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      293,
      298,
      288,
      7,
      286
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 520,
    "question": "Kevin is attempting to determine whether he can destroy a cache of old records that he discovered. What type of policy would most directly answer his question?",
    "choice_a": "Data retention",
    "choice_b": "Data ownership",
    "choice_c": "Data classification",
    "choice_d": "Data minimization",
    "correct_answer": "A",
    "explanation": "The most relevant policy here is the organization\u2019s data retention policy which should outline the standards for keeping records before destruction or disposal.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      316,
      319,
      10,
      9,
      315
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 521,
    "question": "Patrick is a security analyst with a government agency who believes that his organization was targeted by a sophisticated foreign government attack that used a zero-day exploit. What term best describes this threat actor?",
    "choice_a": "Hacktivist",
    "choice_b": "Nation-state",
    "choice_c": "Criminal syndicate",
    "choice_d": "Insider",
    "correct_answer": "B",
    "explanation": "This attack was waged by a foreign government using a sophisticated zero-day attack. The group waging this attack clearly qualifies as nation-state, often called an advanced persistent threat (APT).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      12,
      16,
      29,
      24,
      245
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 522,
    "question": "Samantha has discovered that an attacker was able to log in to systems using a user\u2019s password. The user did not remember a phishing attack or other event when their password might have been exposed but did note that they checked their email using a computer in a hotel lobby while traveling. What type of malware would Samantha expect to find if she was able to examine that system?",
    "choice_a": "A rootkit",
    "choice_b": "A keylogger",
    "choice_c": "A logic bomb",
    "choice_d": "Bloatware",
    "correct_answer": "B",
    "explanation": "A keylogger can capture keystrokes and send them to an attacker. The scenario described most likely reflects a keylogger on the hotel lobby computer. A rootkit is used to retain access to a compromised system and to hide the attacker\u2019s actions. Logic bombs wait to execute until conditions are met like a time and date or other event, and bloatware is simply unwanted software often installed on new machines by manufacturers.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      30,
      29,
      28,
      33,
      19
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 523,
    "question": "Bart wants to monitor for common types of anomalous behavior. Which of the following is not a common part of organizational security awareness and monitoring efforts?",
    "choice_a": "Risky",
    "choice_b": "Unexpected",
    "choice_c": "Repeated",
    "choice_d": "Unintentional",
    "correct_answer": "C",
    "explanation": "Anomalous behavior recognition typically looks at risk, unexpected, and unintentional behaviors. Repeated behavior is commonly in organizations because of ongoing tasks and processes.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      186,
      187,
      250,
      248,
      62
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 524,
    "question": "Which one of the following statements is not true about zero-day attacks?",
    "choice_a": "They may be found in software or hardware.",
    "choice_b": "They have a limited window of use.",
    "choice_c": "They are generally unpatchable.",
    "choice_d": "They are often widely publicized.",
    "correct_answer": "D",
    "explanation": "Zero-day attacks are generally known only to a small group of researchers who discover the vulnerabilities. They are not known to the general public and would likely be patched by the vendor if they became widely known. Zero-day vulnerabilities may exist in any technology component: software or hardware. They are only effective during the limited window of opportunity when they remain unpatchable before the vendor issues a fix.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      16,
      183,
      184,
      200,
      202
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 525,
    "question": "Which one of the following terms best describes the ability of a system to incorporate added capacity as demand increases?",
    "choice_a": "Scalability",
    "choice_b": "Version control",
    "choice_c": "Provisioning",
    "choice_d": "Deprovisioning",
    "correct_answer": "A",
    "explanation": "Scalability says that applications should be designed so that computing resources they require may be incrementally added to support increasing demand. Version control is used as part of development processes to ensure that the right code versions are worked on and used. Provisioning is part of the identity management life cycle and involves identity and rights creation. It can also refer to creating and providing resources or new systems. Deprovisioning is done at the end of a life cycle to remove rights and privileges for identity management, or resources from other environments.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      170,
      157,
      151,
      150,
      159
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 526,
    "question": "What type of attack depends on the fact that users are often logged into many websites simultaneously in the same browser?",
    "choice_a": "Server-side request forgery",
    "choice_b": "Cross-site scripting",
    "choice_c": "Cross-site request forgery",
    "choice_d": "File inclusion",
    "correct_answer": "C",
    "explanation": "XSRF attacks work by making the reasonable assumption that users are often logged into many different websites at the same time. Attackers then embed code in one website that sends a command to a second website. XSS (cross-site scripting) injects malicious scripts into preexisting websites by getting them to display the scripts. XSRF (cross-site request forgery) leverages malicious code to cause users to take action via a website they\u2019re already authenticated to. File inclusion attacks try to take advantage of upload functions that are not properly secured and which can allow programs to be executed or files to be displayed to users.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      81,
      80,
      78,
      83,
      72
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 527,
    "question": "Gary\u2019s organization wants to ensure that a vendor handles availability and resilience and thus adopts an SaaS tool where the vendor is contractually responsible if issues occur. What type of risk management has occurred?",
    "choice_a": "Risk mitigation",
    "choice_b": "Risk acceptance",
    "choice_c": "Risk avoidance",
    "choice_d": "Risk transference",
    "correct_answer": "D",
    "explanation": "Gary has transferred the risk by moving it to a third party via a contract. The organization has not directly taken steps to mitigate the risk, has not accepted it, and has not taken steps to avoid it by making sure it doesn\u2019t happen. Instead, they have signed a contract to transfer the risk.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      309,
      289,
      287,
      290,
      310
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 528,
    "question": "Tina\u2019s organization is operating in a platform-as-a-service (PaaS) environment. Which of the following is a shared responsibility according the shared responsibility matrix in a PaaS environment?",
    "choice_a": "Information and data",
    "choice_b": "Identity infrastructure",
    "choice_c": "Physical hosts",
    "choice_d": "Accounts and identities",
    "correct_answer": "B",
    "explanation": "PaaS environments commonly rely on customers and providers to maintain identity and directory infrastructure, applications, and network controls. Customers manage information and data, devices, and accounts and identities, whereas providers are responsible for operating systems, physical hosts, networks, and datacenters.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      168,
      172,
      177,
      316,
      11
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 529,
    "question": "Mike wants to make it harder to break the encryption for a file that needs to stay secure for a number of years. Which of the following solutions should he select?",
    "choice_a": "Digitally sign the file.",
    "choice_b": "Increase the key length.",
    "choice_c": "Hash the file before encrypting it.",
    "choice_d": "Encrypt the file before hashing it.",
    "correct_answer": "B",
    "explanation": "A longer key is generally stronger for modern cryptosystems, and a longer key will be harder to crack. Signing the file helps with nonrepudiation but not resistance to cracking the encryption. Hashing the file before encrypting it or hashing it after will not help in this scenario.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      102,
      108,
      112,
      99,
      98
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 530,
    "question": "Paul wants to monitor systems in his datacenter for unpatched, insecure services. What type of tool should he use to determine this if he does not have administrative access to all systems and devices?",
    "choice_a": "An SIEM tool",
    "choice_b": "A web application firewall",
    "choice_c": "An SNMP trap",
    "choice_d": "A network vulnerability scanner",
    "correct_answer": "D",
    "explanation": "A vulnerability scanner can detect unpatched and insecure services and provide information about what needs to be remediated. A SIEM, a WAF, and SNMP do not collect or directly provide this information.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      42,
      40,
      43,
      44,
      47
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 531,
    "question": "Renee is responding to a cybersecurity incident at her organization the attackers used a botnet to disrupt access to the website, preventing legitimate customers from placing orders. What type of attack took place?",
    "choice_a": "Destruction",
    "choice_b": "Alteration",
    "choice_c": "Denial",
    "choice_d": "Integrity",
    "correct_answer": "C",
    "explanation": "This is an example of a distributed service (DDoS) attack that disrupted the availability of the website for legitimate users.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      228,
      31,
      244,
      19,
      245
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 532,
    "question": "Tara ran a port scan on a web server hosting her public website and discovered that it is exposing ports 22, 80, and 443 to the world. Which one of these ports poses the greatest security risk?",
    "choice_a": "22",
    "choice_b": "80",
    "choice_c": "443",
    "choice_d": "None of these ports pose a significant risk",
    "correct_answer": "A",
    "explanation": "Port 22 is used by the Shell (SSH) protocol and should generally never be exposed to public access because it enables force SSH attacks. Ports 80 and 443 are commonly exposed on web servers to provide public web access using HTTP and HTTPS, respectively. Although organizations generally now prefer the use of HTTPS, port 80 remains open for the purposes of redirecting connections to port 443.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      183,
      90,
      88,
      84,
      19
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 533,
    "question": "Kayla is conducting threat research and wants to monitor for information from threat actor groups. Which one of the following information sources is most likely to provide her with this information?",
    "choice_a": "Information-sharing organizations",
    "choice_b": "Vendor websites",
    "choice_c": "Responsible disclosure programs",
    "choice_d": "The dark web",
    "correct_answer": "D",
    "explanation": "Ransomware groups and others commonly publish information on the dark web as well as engaging via forums and similar sites there. Kayla\u2019s best bet is the dark web. Information-sharing organizations may gather information from the dark web, but without knowing more about a specific organization, its members, and their methodologies, that\u2019s not certain. Responsible disclosure programs are used to notify vendors of flaws, and vendor websites may provide information specific to their products.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      20,
      22,
      21,
      23,
      62
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 534,
    "question": "Nadean is a software developer who is preparing a new application for release. She wishes to use code signing for the application file that will be deployed to a customer. What key should she use to sign the application?",
    "choice_a": "Her organization\u2019s public key",
    "choice_b": "Her organization\u2019s private key",
    "choice_c": "The customer\u2019s public key",
    "choice_d": "The customer\u2019s private key",
    "correct_answer": "B",
    "explanation": "Digital signatures are always created using the private key of the person or organization creating the digital signature. In this case, Nadean should use her organization\u2019s private key to sign the application.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      116,
      105,
      115,
      112,
      124
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 535,
    "question": "In what cloud security model does the cloud service customer bear the most responsibility for implementing security controls?",
    "choice_a": "SaaS",
    "choice_b": "IaaS",
    "choice_c": "PaaS",
    "choice_d": "FaaS",
    "correct_answer": "B",
    "explanation": "The cloud service customer bears the most responsibility for implementing security controls in an infrastructure-as-a-service (IaaS) environment and the least responsibility in a software-as-a-service (SaaS) environment. This is due to the division of responsibilities under the cloud computing shared responsibility model.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      168,
      172,
      179,
      177,
      182
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 536,
    "question": "Beena is the IPS administrator for her organization. The organization\u2019s threat intelligence feed has provided information about a new attack that the organization\u2019s web servers are vulnerable to. Beena knows that the web servers need to remain online so that her organization can continue to conduct business. What can she do using her IPS to help the most?",
    "choice_a": "Manually create a signature based on the threat information to block attacks.",
    "choice_b": "Provide trend information about attacks based on the threat feed.",
    "choice_c": "Use behavioral information to stop traffic to the web servers.",
    "choice_d": "Send alerts whenever a threat matching the new exploit is detected.",
    "correct_answer": "A",
    "explanation": "Manually created signatures are commonly used in situations where vendors have not yet created them. Beena can create a signature based on the threat information but will have to be careful not to inadvertently block legitimate traffic. Trend information and alerting won\u2019t stop the attacks from succeeding, and behavioral information is less useful in a scenario like this when information about a threat is known and can be leveraged to build a signature.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      245,
      31,
      72,
      82,
      244
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 537,
    "question": "Chris is concerned about the possibility that former employees will disclose sensitive personal information about customers to unauthorized individuals. What is the best mechanism that Chris can use to manage this risk?",
    "choice_a": "AUP",
    "choice_b": "Privacy policy",
    "choice_c": "NDA",
    "choice_d": "Data ownership policy",
    "correct_answer": "C",
    "explanation": "All of the mechanisms listed here may be used to protect private information. However, acceptable use policies (AUPs), privacy policies, and data ownership policies are internal policies that would not be binding on former employees. To manage this risk, Chris\u2019 organization should have all employees sign isclosure agreements (NDAs) that remain binding after the end of the employment relationship.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      309,
      275,
      317,
      289,
      295
    ],
    "source": "211418_PracticeTest2"
  },
  {
    "id": 538,
    "question": "Felicia wants to deploy an encryption solution that will protect files in motion as they are copied between file shares as well as at rest, and also needs it to support granular, per\u2010user security. What type of solution should she select?",
    "choice_a": "Partition encryption",
    "choice_b": "File encryption",
    "choice_c": "Full\u2010disk encryption",
    "choice_d": "Record\u2010level encryption",
    "correct_answer": "B",
    "explanation": "File encryption meets all of the needs described. Full\u2010disk encryption is easier to deploy and manage but does not protect individual files in motion and does not effectively support multiuser scenarios. Partition\u2010level encryption has the same challenges, albeit at a partition rather than full\u2010disk level. Record\u2010level encryption is typically used in databases to protect individual records or entries.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      99,
      100,
      146,
      198,
      224
    ],
    "source": "9781394211395"
  },
  {
    "id": 539,
    "question": "Valerie wants to use a certificate to handle multiple subdomains for her website, including the <code>sales.example.com</code> and <code>support.example.com</code> subdomains. What type of certificate should she use?",
    "choice_a": "A self\u2010signed certificate",
    "choice_b": "A root of trust certificate",
    "choice_c": "A CRL certificate",
    "choice_d": "A wildcard certificate",
    "correct_answer": "D",
    "explanation": "Wildcard certificates are used to handle multiple subdomains with a single certificate. A self\u2010signed certificate will not be recognized by browsers and other services, creating confusion for customers. Root of trust certificates and CRL certificates are not types of certificates.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      118,
      120,
      119,
      122,
      121
    ],
    "source": "9781394211395"
  },
  {
    "id": 540,
    "question": "What information is analyzed during a gap analysis?",
    "choice_a": "Control objectives and controls intended to meet the objectives",
    "choice_b": "Physically separate networks and their potential connection points",
    "choice_c": "Compensating controls and the controls they are replacing",
    "choice_d": "Security procedures and the policies they are designed to support",
    "correct_answer": "A",
    "explanation": "Gap analysis considers control objectives and the controls that are intended to meet the objectives.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      5,
      6,
      285,
      282,
      283
    ],
    "source": "9781394211395"
  },
  {
    "id": 541,
    "question": "Susan's team has recommended an application restart for a production, customer\u2010facing application as part of an urgent patch due to a security update. What technical implication is the most common concern when conducting an application restart?",
    "choice_a": "Application configuration changes caused by the restart",
    "choice_b": "Whether the patch will properly apply",
    "choice_c": "Lack of security controls during the restart",
    "choice_d": "The downtime during the restart",
    "correct_answer": "D",
    "explanation": "In most production environments downtime is the primary concern when considering an application restart. Many application architectures are designed to allow restarts of individual systems or services without creating an outage or downtime. Configuration changes should not be created by a restart, patches generally apply properly, and security controls should be in place throughout the process.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      282,
      283,
      6,
      5,
      1
    ],
    "source": "9781394211395"
  },
  {
    "id": 542,
    "question": "Using a tool like <code>git</code> is most frequently associated with what critical change management process?",
    "choice_a": "Having a backout plan",
    "choice_b": "Stakeholder analysis",
    "choice_c": "Version control",
    "choice_d": "Standard operating procedures (SOPs)",
    "correct_answer": "C",
    "explanation": "Organizations frequently use tools like <code>git</code> to build repositories that support their need for version control. Backout plans might note that you need to return to the prior version but will need to include how to do so. Stakeholder analysis and SOPs are not specifically supported by or improved by using <code>git</code>.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      284,
      282,
      283,
      285,
      118
    ],
    "source": "9781394211395"
  },
  {
    "id": 543,
    "question": "Jacob is concerned that the password used for one of his organization's services is weak, and he wants to make it harder to crack by making it harder to test possible keys during a brute\u2010force attack. What is this technique called?",
    "choice_a": "Master keying",
    "choice_b": "Key stretching",
    "choice_c": "Key rotation",
    "choice_d": "Passphrase armoring",
    "correct_answer": "B",
    "explanation": "Key stretching makes potentially weak keys more resistant to brute\u2010forcing and often involves using a hash or block cipher repeatedly to make the original value harder to crack. Key rotation is the process of changing keys on a periodic basis to limit the impact of potential exposure. Master keying and passphrase armoring are not commonly used concepts for information security, although master keys are used for physical locks.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      102,
      106,
      108,
      114,
      124
    ],
    "source": "9781394211395"
  },
  {
    "id": 544,
    "question": "Log monitoring is an example of what control category?",
    "choice_a": "Technical",
    "choice_b": "Managerial",
    "choice_c": "Operational",
    "choice_d": "Physical",
    "correct_answer": "C",
    "explanation": "Operational controls like log monitoring, change management processes, and vulnerability management are all put in place to support managing and using technology in a secure manner.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      5,
      6,
      282,
      284,
      285
    ],
    "source": "9781394211395"
  },
  {
    "id": 545,
    "question": "Rick wants to make offline brute\u2010force attacks against his password file very difficult for attackers. Which of the following is not a common technique to make passwords harder to crack?",
    "choice_a": "Use of a salt",
    "choice_b": "Use of a pepper",
    "choice_c": "Use of a purpose\u2010built password hashing algorithm",
    "choice_d": "Encrypting password plain text using symmetric encryption",
    "correct_answer": "D",
    "explanation": "Retaining the actual password is not a best practice, and thus encrypting password plain text is not a common technique to make passwords harder to crack. Since the application would need the cryptographic key to read the passwords, anybody who had access to that key could decrypt the passwords. Using a salt, a pepper, and a cryptographic hashing algorithm designed for passwords are all common best practices to prevent offline brute\u2010force attacks.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      107,
      117,
      102,
      106,
      105
    ],
    "source": "9781394211395"
  },
  {
    "id": 546,
    "question": "Diffie\u2013Hellman and RSA are both examples of what important encryption\u2010related solution?",
    "choice_a": "Rekeying",
    "choice_b": "Certificate revocation protocols",
    "choice_c": "Key exchange algorithms",
    "choice_d": "Key generation algorithms",
    "correct_answer": "C",
    "explanation": "Both Diffie\u2013Hellman and RSA are key exchange algorithms designed to securely allow key exchange between users or systems that have not previously communicated.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      110,
      112,
      105,
      109,
      115
    ],
    "source": "9781394211395"
  },
  {
    "id": 547,
    "question": "Sally wants to ensure that her change management process includes a procedure for what to do if the change fails. What should she create to handle this possibility?",
    "choice_a": "An impact analysis",
    "choice_b": "A backout plan",
    "choice_c": "A regression test",
    "choice_d": "A maintenance window",
    "correct_answer": "B",
    "explanation": "Backout plans document what to do to return to a state prior to the change being made and are designed to be implemented if the change fails. They may involve undoing changes, restoring from backups, or taking other steps and they must contain an appropriate level of detail to ensure that the change can be undone. An impact analysis looks at the potential impact of a change, regression testing ensures that old issues are not introduced in new updates, and maintenance windows are scheduled to allow for downtime or other maintenance activities with appropriate communications, staffing, and other needed elements.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      282,
      283,
      284,
      285,
      5
    ],
    "source": "9781394211395"
  },
  {
    "id": 548,
    "question": "Theresa is concerned that her scheduled maintenance window may extend beyond the allocated time due to an unexpected issue. What element from the CIA triad is she concerned about?",
    "choice_a": "Criticality",
    "choice_b": "Accessibility",
    "choice_c": "Integrity",
    "choice_d": "Availability",
    "correct_answer": "D",
    "explanation": "The CIA triad is confidentiality, availability, and integrity. Theresa's extended outage window will impact the availability of her applications and services.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      1,
      2,
      5,
      282,
      6
    ],
    "source": "9781394211395"
  },
  {
    "id": 549,
    "question": "Alaina is concerned about vehicles that might impact her organization's backup generator. What should she install to prevent both inadvertent and purposeful vehicle impacts on a generator installed outside her building near a parking lot?",
    "choice_a": "A speed bump",
    "choice_b": "An access control vestibule",
    "choice_c": "Bollards",
    "choice_d": "A chain\u2010link fence",
    "correct_answer": "C",
    "explanation": "Bollards are used to protect infrastructure and structures, and they are usually concrete or steel posts, planters, or similar structures that are intended to prevent a vehicle from impacting what they protect. Speed bumps won't prevent an impact, although they might slow it. Access control vestibules are used to ensure only authorized personnel access a space, and chain\u2010link fences are not typically sufficient for this type of control.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      162,
      5,
      6,
      164,
      166
    ],
    "source": "9781394211395"
  },
  {
    "id": 550,
    "question": "Ben has deployed a data loss prevention (DLP) tool that inspects data and flags specific data types for review before emails containing it are sent outside the organization. What control type best describes this type of solution?",
    "choice_a": "Managerial",
    "choice_b": "Detective",
    "choice_c": "Corrective",
    "choice_d": "Preventive",
    "correct_answer": "D",
    "explanation": "This is a preventive control that is intended to prevent sensitive data from being sent outside the organization. Managerial controls are procedural mechanisms, corrective controls remediate security issues that have already occurred, and detective controls identify security events that have already occurred.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      5,
      2,
      1,
      282
    ],
    "source": "9781394211395"
  },
  {
    "id": 551,
    "question": "What type of control is a policy or procedure?",
    "choice_a": "Directive",
    "choice_b": "Corrective",
    "choice_c": "Detective",
    "choice_d": "Preventive",
    "correct_answer": "A",
    "explanation": "Policies and procedures are examples of directive control that inform employees and others of what they should do to achieve security objectives. Corrective controls remediate already existing security issues, detective controls identify security events that have already happened, and preventive controls attempt to stop a security issue before it occurs.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      5,
      282,
      284,
      283
    ],
    "source": "9781394211395"
  },
  {
    "id": 552,
    "question": "Murali has deployed a file integrity monitoring tool and has configured alerts to notify him if files are modified. What control type best describes this solution?",
    "choice_a": "Preventive",
    "choice_b": "Deterrent",
    "choice_c": "Directive",
    "choice_d": "Detective",
    "correct_answer": "D",
    "explanation": "This solution monitors for changes and is therefore a detective control. It does not prevent changes, and intruders and malicious actors are unlikely to know about it, making it a poor deterrent. Since it is not a policy or practice, it is not a directive control.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      5,
      282,
      284,
      165
    ],
    "source": "9781394211395"
  },
  {
    "id": 553,
    "question": "Charles wants to reduce the threat scope of compromised credentials. What type of the following security controls is best suited to meeting this need?",
    "choice_a": "Single sign\u2010on",
    "choice_b": "Federation",
    "choice_c": "Zero trust",
    "choice_d": "Multifactor authentication (MFA)",
    "correct_answer": "C",
    "explanation": "Zero trust designs implement continuous verification, which is an effective control used to limit the threat scope of compromised credentials. While multifactor authentication can be a useful control in this circumstance, a fully implemented zero\u2010trust design will provide greater control than just MFA alone. Single sign\u2010on and federation are both likely to increase threat scope in a compromised credential scenario.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      146,
      147,
      285,
      6,
      5
    ],
    "source": "9781394211395"
  },
  {
    "id": 554,
    "question": "Carol wants to obfuscate data that is contained in her database. She wants to be able to refer to the data elements without having the actual data exposed. What type of obfuscation option should she select?",
    "choice_a": "Tokenization",
    "choice_b": "Encryption",
    "choice_c": "Data masking",
    "choice_d": "Data randomization",
    "correct_answer": "A",
    "explanation": "Tokens replace data with a value that is linked specifically to the data, allowing it to be referenced and used without the field being exposed. Encryption is not used for this purpose, data masking hides elements of a data field like digits from a credit card number, and data randomization is not an obfuscation method.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      100,
      99,
      114,
      98,
      105
    ],
    "source": "9781394211395"
  },
  {
    "id": 555,
    "question": "What key is used to decrypt information sent by another individual between two people using public key encryption?",
    "choice_a": "The recipient's private key",
    "choice_b": "The recipient's public key",
    "choice_c": "The sender's private key",
    "choice_d": "The sender's public key",
    "correct_answer": "A",
    "explanation": "The sender uses the receiver's public key to encrypt the message, then the receiver uses their private key to decrypt the message. This ensures that the receiver is the only person who can decrypt a message sent using public key encryption.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      116,
      105,
      112,
      109,
      124
    ],
    "source": "9781394211395"
  },
  {
    "id": 556,
    "question": "Selah's organization has recently experienced a breach and the private keys for her organization's certificates were exposed. What should she immediately do?",
    "choice_a": "Reissue the certificates with changed hostnames and other details.",
    "choice_b": "Replace the certificates with self\u2010signed certificates until they can be replaced by the vendor.",
    "choice_c": "Revoke the certificates and place them on a certificate revocation list.",
    "choice_d": "Replace the certificates with wildcard certificates.",
    "correct_answer": "C",
    "explanation": "If a certificate may have been breached, organizations should immediately revoke the certificates and place them on a certificate revocation list (CRL). They will then need to replace the certificates with new certificates, but changing hostnames is not required as the certificates themselves will be new. The other options are not typical practices.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      121,
      124,
      105,
      119,
      102
    ],
    "source": "9781394211395"
  },
  {
    "id": 557,
    "question": "Which of the following is not a major concern related to downtime caused by patching and system updates?",
    "choice_a": "Attackers compromising the system or service while it is offline",
    "choice_b": "Security systems or functions being offline during restart or shutdown processes",
    "choice_c": "Unexpected extended downtime",
    "choice_d": "Dependencies between systems or services related to downtime",
    "correct_answer": "A",
    "explanation": "Attackers are unlikely to be able to compromise a system or service while it is offline. They may, however, be able to take advantage of the restart or shutdown process if critical security processes are not online for some portion of the process. Unexpected downtime and dependencies between systems must also be considered when planning patching and system updates.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      282,
      285,
      5,
      283,
      1
    ],
    "source": "9781394211395"
  },
  {
    "id": 558,
    "question": "Joanna wants to ensure that the most current version of each component in her application is deployed. What change management process will help the most with this requirement?",
    "choice_a": "Dependency mapping",
    "choice_b": "Version control",
    "choice_c": "Impact analysis",
    "choice_d": "Allow and deny lists",
    "correct_answer": "B",
    "explanation": "Version control is important to ensure that the current and correct version of an application or component is deployed. Dependency mapping can be important to ensure that changed versions don't cause other issues, but it isn't specifically needed to ensure that the current version is what you're deploying. Impact analysis and allow/deny lists are not directly relevant to this requirement.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      284,
      282,
      285,
      5,
      6
    ],
    "source": "9781394211395"
  },
  {
    "id": 559,
    "question": "Greg wants to implement a version control system to ensure that changes are made in ways that will not cause problems for his organization's critical software. Which of the following is not a common feature of version control systems designed for software source code?",
    "choice_a": "Atomic operations",
    "choice_b": "File locking",
    "choice_c": "Regression testing",
    "choice_d": "Tagging and labeling",
    "correct_answer": "C",
    "explanation": "Version control systems track versions but don't do testing themselves. Atomic operations ensure that actions like commits don't overwrite other commits in progress. File locking allows a developer to check out a file while it is being worked on, and tagging and labeling helps developers track files and versions.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      284,
      282,
      285,
      5,
      6
    ],
    "source": "9781394211395"
  },
  {
    "id": 560,
    "question": "Christina wants to implement a physical security control that has the greatest flexibility in how it is applied because she knows that exceptions to security practices may be required at times. Which of the following solutions has the greatest flexibility?",
    "choice_a": "Video surveillance",
    "choice_b": "Security guards",
    "choice_c": "Access badges",
    "choice_d": "Access control vestibules",
    "correct_answer": "B",
    "explanation": "Security guards are expensive but offer the most flexibility when organizations need intelligence and reasoning to be applied to security events and unexpected needs. Christina knows that guards can often identify issues that a fixed sensor or control cannot.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      164,
      5,
      6,
      163,
      162
    ],
    "source": "9781394211395"
  },
  {
    "id": 561,
    "question": "Lisa wants to ensure that theft of a device will not lead to exposure of the data contained on the device if the device is locked or turned off. What type of encryption should she select to best ensure this?",
    "choice_a": "Volume\u2010level encryption",
    "choice_b": "Full\u2010disk encryption",
    "choice_c": "File\u2010level encryption",
    "choice_d": "Partition\u2010level encryption",
    "correct_answer": "B",
    "explanation": "Full\u2010disk encryption provides the most security in situations like this if the device is locked or off. Volume\u2010 and partition\u2010level encryption may leave some drive information or even entire volumes or partitions unencrypted, and file\u2010level encryption is typically selective instead of covering every file on a drive.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      99,
      198,
      100,
      1,
      6
    ],
    "source": "9781394211395"
  },
  {
    "id": 562,
    "question": "Mahmoud has been asked to implement an allow list for websites that users at his company can visit. What concern should he bring up to management due to this request?",
    "choice_a": "Allow lists cannot be used for websites.",
    "choice_b": "Allow lists are overly permissive and are likely to allow unwanted sites to be visited.",
    "choice_c": "Using an allow list for websites will take a lot of time to maintain.",
    "choice_d": "Using an allow list for websites is easily bypassed.",
    "correct_answer": "C",
    "explanation": "In most organizations attempting to use an allow list for websites will take up a lot of time. Mahmoud knows that allow lists can be set up for websites, often at a central network security device\u2013level like a firewall. Bypassing allow lists may be possible, but this can largely be prevented if desired. Allow lists are not overly permissive unless they are configured that way.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      146,
      147,
      285,
      283,
      5
    ],
    "source": "9781394211395"
  },
  {
    "id": 563,
    "question": "Which of the following change management processes does not commonly directly involve stakeholders outside of the IT organization?",
    "choice_a": "Impact analysis",
    "choice_b": "Building the backout plan",
    "choice_c": "The change approval process",
    "choice_d": "Determining the maintenance window",
    "correct_answer": "B",
    "explanation": "Administrators and system owners typically build backout plans. Stakeholders are involved in impact analysis as they help technical staff understand what the impact of changes will be on business areas. They engage in the change approval process, and they help to determine the maintenance window to ensure that impact on the business is minimized.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      282,
      285,
      5,
      6,
      283
    ],
    "source": "9781394211395"
  },
  {
    "id": 564,
    "question": "What hardware component is used to generate, store, and manage cryptographic keys?",
    "choice_a": "A CPU",
    "choice_b": "A NSA",
    "choice_c": "A TPM",
    "choice_d": "A CCA",
    "correct_answer": "C",
    "explanation": "A TPM, or trusted platform module, is a hardware\u2010based, cryptographic processor that is used to generate, store, and manage cryptographic keys. It is also used to help ensure platform integrity by allowing boot validation processes to occur in a secure manner. A CPU is the main processor for a system, NSA is the National Security Agency, and a CCA is a chosen ciphertext attack, a type of attack against cryptographic systems where the attacker can cause a cryptographic system to encrypt known text for analysis.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      124,
      102,
      130,
      118,
      98
    ],
    "source": "9781394211395"
  },
  {
    "id": 565,
    "question": "Chris wants to check to see if a certificate has been revoked. What protocol can he use to validate the current status of a certificate?",
    "choice_a": "TLS",
    "choice_b": "OCRS",
    "choice_c": "SSL",
    "choice_d": "OCSP",
    "correct_answer": "D",
    "explanation": "The Online Certificate Status Protocol (OCSP) is used to validate certificate status, including checking to see if the certificate is on a certificate revocation list (CRL). TLS is Transport Layer Security, a protocol used to encrypt data in transit between systems that relies on cryptographic certificates, but it is not used to validate the status of certificates on a CRL. Despite SSL itself being outmoded, the term SSL is commonly used to refer to TLS\u2014but here, neither TLS nor SSL is the right option. OCRS was made up for this question.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      121,
      119,
      118,
      120,
      223
    ],
    "source": "9781394211395"
  },
  {
    "id": 566,
    "question": "Brian's organization uses a process where a secure module boots systems, then monitors them as each boot stage proceeds. It validates each signed boot stage and reports on whether the boot process was correct or not when complete. What is the secure module used to verify these stages called?",
    "choice_a": "A secure initiation manager",
    "choice_b": "A root of trust",
    "choice_c": "A boot hash",
    "choice_d": "A cryptographic boot manager",
    "correct_answer": "B",
    "explanation": "A root of trust\u2013based secure boot process validates each signed component as it starts and ensures that the trusted components are all loaded as part of the boot process. Changes to the components are reported as exceptions, meaning that the boot process cannot be properly verified or trusted. Secure initiation manager, boot hash, cryptographic boot manager were made up for this question.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      119,
      115,
      114,
      6,
      102
    ],
    "source": "9781394211395"
  },
  {
    "id": 567,
    "question": "A vulnerability scan shows that an embedded device that Alice is responsible for has a vulnerability. She knows the vendor is no longer in business and that there is no updated firmware or software update for the device. To resolve the issue, Alice places a firewall between the device and the rest of the network and creates rules that prevent the vulnerable service from being available to other devices. What type of control has Alice deployed?",
    "choice_a": "A directive control",
    "choice_b": "A compensating control",
    "choice_c": "A detective control",
    "choice_d": "A procedural control",
    "correct_answer": "B",
    "explanation": "Alice has deployed a compensating control since she cannot apply controls like patching, configuration, or updates. Directive controls provide formal directions to staff, detective controls detect issues rather than preventing them directly, and procedural controls are not a type of control type used on the Security+ exam.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      5,
      283,
      285,
      147
    ],
    "source": "9781394211395"
  },
  {
    "id": 568,
    "question": "Jason knows that his Apple system uses a separate portion of its SoC (system on chip) to store keys and biometric information. What is this specialized component called?",
    "choice_a": "A TPM",
    "choice_b": "A HSM",
    "choice_c": "A secure enclave",
    "choice_d": "A screened subnet",
    "correct_answer": "C",
    "explanation": "Apple devices use a specialized, separate coprocessor that uses encrypted memory and storage as well as dedicated cryptographic functions called a secure enclave. This is distinct from a TPM or HSM, and a screened subnet is a networking concept for a space that will be exposed to the less secure zones while needing to remain secure.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      130,
      111,
      102,
      100,
      198
    ],
    "source": "9781394211395"
  },
  {
    "id": 569,
    "question": "What change management term is used to describe the processes that an organization uses for each change that is made to ensure that a consistent process is used?",
    "choice_a": "Standard operating procedures",
    "choice_b": "A change plan",
    "choice_c": "Fixed operating procedures",
    "choice_d": "A backout plan",
    "correct_answer": "A",
    "explanation": "Standard operating procedures (SOPs) are an organization's normal processes that it uses. SOPs are helpful to ensure that organizations have consistent practices that are in use on an ongoing basis. A change plan is specific to a change, and a backout plan is used to undo a change if problems arise. Fixed operating procedures is not a common term used in change management.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      282,
      283,
      285,
      284,
      2
    ],
    "source": "9781394211395"
  },
  {
    "id": 570,
    "question": "Jack knows that there are three common types of database encryption. Which of the following is not a common type of database encryption?",
    "choice_a": "Sensitivity\u2010based encryption",
    "choice_b": "Transparent data encryption",
    "choice_c": "Field\u2010level encryption",
    "choice_d": "Column\u2010level encryption",
    "correct_answer": "A",
    "explanation": "Transparent data encryption, field\u2010level, and column\u2010level encryption are all common types of database encryption. Sensitivity\u2010based encryption is not and was made up for this question.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      99,
      100,
      104,
      105,
      98
    ],
    "source": "9781394211395"
  },
  {
    "id": 571,
    "question": "Ujamaa wants to conduct a gap analysis as part of his security efforts. Which of the following best describes what he will analyze?",
    "choice_a": "Which services are not configured properly",
    "choice_b": "Whether current patches are installed on all systems",
    "choice_c": "The security program as implemented versus best practices",
    "choice_d": "Legal requirements versus the security program",
    "correct_answer": "C",
    "explanation": "Gap analysis focuses on reviewing a security program against common best practices to identify where gaps between practices exist. Ujamaa will select an information security standard like NIST 800\u201053, ISO 27001, or another relevant standard and will validate his organization's controls implementation against it. This may include things like which services are not configured properly, whether patches are installed, and if legal requirements are being met, but any of those answers is not a complete answer in this context.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      5,
      282,
      146,
      285
    ],
    "source": "9781394211395"
  },
  {
    "id": 572,
    "question": "Brandon wants to deploy a detective control that will help him with physical security threats. Which of the following fits his needs?",
    "choice_a": "Fencing",
    "choice_b": "Lighting",
    "choice_c": "Video surveillance",
    "choice_d": "Bollards",
    "correct_answer": "C",
    "explanation": "Video surveillance is a detective control and is useful for detecting security events after they have happened. Fencing, bollards, and lighting are typically considered preventive controls.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      165,
      162,
      164,
      166
    ],
    "source": "9781394211395"
  },
  {
    "id": 573,
    "question": "Jack has deployed a system that appears to attackers to be a vulnerable system. The system is specifically designed to capture information and data from attacks to allow for later analysis. What type of tool has Jack deployed?",
    "choice_a": "A tarpit",
    "choice_b": "A honeypot",
    "choice_c": "A beehive",
    "choice_d": "An intrusion detection system",
    "correct_answer": "B",
    "explanation": "Honeypots are designed to appear to be vulnerable. They are heavily instrumented to capture attacker techniques and tools, allowing for analysis by defenders. Tarpits slow down attackers, beehives are not a term used in this context, and intrusion detection systems (IDSs) are designed to identify and alert about attacks but are not designed to appear to be vulnerable.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5
    ],
    "source": "9781394211395"
  },
  {
    "id": 574,
    "question": "Renee wants to ensure that her logs support nonrepudiation. What should she do to ensure this?",
    "choice_a": "Encrypt, then hash the logs.",
    "choice_b": "Hash the logs and then digitally sign them.",
    "choice_c": "Digitally sign the log file, then encrypt it.",
    "choice_d": "Hash, then encrypt the logs.",
    "correct_answer": "B",
    "explanation": "Calculating a cryptographic hash allows the log's hash to be compared against copies to validate that they match. Digitally signing the hash ensures that it can be verified to be the original. Encrypting the log does not allow it to be verified against an original. Without a digital signature, a hash does not meet Renee's requirement for nonrepudiation.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      115,
      98,
      107,
      116,
      1
    ],
    "source": "9781394211395"
  },
  {
    "id": 575,
    "question": "Isaac wants to deploy sensors to detect intruders in a facility, but he is concerned about the sensors being overly sensitive. What type of sensor is best suited to detecting intruders in an open office environment without significant expense or issues with sensitivity?",
    "choice_a": "Infrared",
    "choice_b": "Pressure",
    "choice_c": "Microwave",
    "choice_d": "Ultrasonic",
    "correct_answer": "A",
    "explanation": "Infrared sensors are commonly used in open spaces. They are well suited to detecting individuals and are less likely to be overly sensitive. They can cover broader fields than a pressure sensor, and ultrasonic sensors are not commonly deployed as facility\u2010level security sensors.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      166,
      165,
      162,
      5,
      163
    ],
    "source": "9781394211395"
  },
  {
    "id": 576,
    "question": "Wayne wants to allow systems to claim identities as part of his AAA process. Which of the following is most commonly used to identify both individuals and systems?",
    "choice_a": "Tokens",
    "choice_b": "Smartcards",
    "choice_c": "Certificates",
    "choice_d": "Usernames",
    "correct_answer": "C",
    "explanation": "Certificates are commonly used to identify both individuals and systems. Tokens, smartcards, and usernames are primarily used by individuals.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      118,
      119,
      105,
      115,
      120
    ],
    "source": "9781394211395"
  },
  {
    "id": 577,
    "question": "What are considerations like database and network connectivity, authentication system access, and network time availability considered in the context of change management processes?",
    "choice_a": "Allowed services",
    "choice_b": "Standard operating procedures",
    "choice_c": "Denied services",
    "choice_d": "Dependencies",
    "correct_answer": "D",
    "explanation": "Database and network connectivity, authentication system access, and network time availability are all common dependencies that must be considered when making changes. Applications and services may fail to start properly if these dependencies are not available when they attempt to start.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      282,
      284,
      283,
      285,
      5
    ],
    "source": "9781394211395"
  },
  {
    "id": 578,
    "question": "What role does the policy engine play in a zero\u2010trust environment?",
    "choice_a": "It creates new administrative policies based on user behavior.",
    "choice_b": "It grants access based on policies created by administrators and based on security systems data.",
    "choice_c": "It enforces policies by monitoring connections between clients and servers.",
    "choice_d": "It suggests new administrative policies based on usage patterns for adoption by the organization.",
    "correct_answer": "B",
    "explanation": "Policy engines decide whether to grant access to resources based on policies created by administrators and based on data provided by tools like endpoint detection and response tools, threat intelligence feeds, and security information and event management tools. It does not create or suggest administrative policies, and it does not directly enforce policies\u2014that occurs at a policy enforcement point, typically through a zero\u2010trust agent on the client and at the resource or service side.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      147,
      146,
      282,
      5,
      6
    ],
    "source": "9781394211395"
  },
  {
    "id": 579,
    "question": "Which of the following is not a common post\u2010change activity found in change management practices?",
    "choice_a": "Updating diagrams",
    "choice_b": "Updating procedures",
    "choice_c": "Updating policies",
    "choice_d": "Updating contracts",
    "correct_answer": "D",
    "explanation": "Contracts tend to be updated as part of a contract renewal process, not as part of a change management process related to technical change.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      282,
      284,
      283,
      5,
      6
    ],
    "source": "9781394211395"
  },
  {
    "id": 580,
    "question": "Which of the following activities should Alaina not restrict as part of her preparation for a change window?",
    "choice_a": "Patching",
    "choice_b": "Scaling clustered systems up or down",
    "choice_c": "Changing hostnames",
    "choice_d": "Modifying database configurations",
    "correct_answer": "B",
    "explanation": "Change windows rely on the documented change being able to be made. Patching and other technical changes may lead to unexpected interactions or dependency changes that are not accounted for in the original change window. Scaling a clustered system up or down does not change the systems and should not be restricted during a change management window.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      282,
      283,
      284,
      285,
      5
    ],
    "source": "9781394211395"
  },
  {
    "id": 581,
    "question": "What two key features define blockchain ledgers?",
    "choice_a": "They are immutable and nontransferable.",
    "choice_b": "They are shared and can be modified by a vote among all participants.",
    "choice_c": "They are unique to each participant and are atomic.",
    "choice_d": "They are shared and immutable.",
    "correct_answer": "D",
    "explanation": "Blockchain ledgers are immutable\u2014they cannot be changed after they are recorded, and they are shared, which means that each participant in the blockchain has access to the entire ledger. Transactions are recorded only once and cannot be tampered with\u2014in fact, if an error is made and recorded, a new record has to be created including the fix, and both records will be accessible to show the history of what occurred.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      131,
      1,
      2,
      107,
      115
    ],
    "source": "9781394211395"
  },
  {
    "id": 582,
    "question": "Damian issues the following command on his Linux server: <code>openssl req -new -newkey rsa:2048 -nodes -keyout exampleserver.key -out exampleserver.csr</code> <br>What has he done?",
    "choice_a": "Created a certificate signing request",
    "choice_b": "Created a certificate revocation request",
    "choice_c": "Signed a certificate signing request",
    "choice_d": "Updated the OCSP record for a certificate",
    "correct_answer": "A",
    "explanation": "Damian has created a certificate signing request, which he can submit to a certificate authority (CA).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      120,
      119,
      105,
      118,
      122
    ],
    "source": "9781394211395"
  },
  {
    "id": 583,
    "question": "Nick's organization sets aside Saturday nights from 2 a.m. to 4 a.m. for scheduled maintenance. What is this type of reserved time typically called?",
    "choice_a": "Allocated downtime",
    "choice_b": "A maintenance window",
    "choice_c": "An unscheduled outage",
    "choice_d": "An allowed outage",
    "correct_answer": "B",
    "explanation": "Preplanned times when maintenance is done and outages may occur is known as a maintenance window. An unscheduled outage is just that\u2014unscheduled and unplanned, often due to a failure or other issue. Allocated downtime and allowed outages are not common terms for this.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      282,
      283,
      285,
      100,
      102
    ],
    "source": "9781394211395"
  },
  {
    "id": 584,
    "question": "Megan wants to assess the impact of a change as part of her change management process. Which of the following is most likely to help her assess impact?",
    "choice_a": "A backout plan",
    "choice_b": "An estimate of the downtime expected",
    "choice_c": "A list of stakeholders",
    "choice_d": "A list of dependencies for impacted systems",
    "correct_answer": "B",
    "explanation": "An estimate of the downtime expected as part of the change will help Megan to assess the impact of the change on her organization's business operations. A backout plan is useful if something goes wrong and can help estimate impact if that happens, but it does not identify impact under normal circumstances. A list of stakeholders can help when communicating with stakeholders to notify them of what will occur, but without the estimate of downtime, Megan will not be able to ask them what the impact would be. Finally, a list of dependencies is helpful to ensure that the change does not have unexpected issues and can help with the impact assessment to determine if other systems may be impacted, but the downtime expected remains the most important item.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      282,
      283,
      285,
      6,
      5
    ],
    "source": "9781394211395"
  },
  {
    "id": 585,
    "question": "Jared wants to estimate the downtime that will result as part of a planned change. Which of the following methods will most effectively help him estimate downtime?",
    "choice_a": "Average the downtime from other recent changes.",
    "choice_b": "Contact the vendor for time estimates for the change.",
    "choice_c": "Perform the change in a test environment.",
    "choice_d": "Use a fixed maintenance window.",
    "correct_answer": "C",
    "explanation": "Organizations often perform changes in a test environment to allow accurate time estimates and to determine if there are issues with the change like undocumented dependencies or problems with patches. Average downtime is a poor indicator of what a specific change may require, a fixed maintenance window does not ensure the change will take that amount of time, and vendors rarely have a full understanding of the environment an organization is operating in.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      282,
      284,
      283,
      285,
      5
    ],
    "source": "9781394211395"
  },
  {
    "id": 586,
    "question": "An encryption method in which all participants have the same key is known as which of the following types of encryption?",
    "choice_a": "Shared hashing",
    "choice_b": "Asymmetric encryption",
    "choice_c": "Symmetric encryption",
    "choice_d": "Universal encryption",
    "correct_answer": "C",
    "explanation": "Symmetric encryption uses the same key for all participants in an exchange. Asymmetric encryption uses public and private keys where public keys are shared and private keys are retained. Shared hashing and universal encryption are not terms commonly used to describe encryption.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      104,
      108,
      105,
      112,
      109
    ],
    "source": "9781394211395"
  },
  {
    "id": 587,
    "question": "What important encryption challenge does asymmetric encryption help with by using public keys?",
    "choice_a": "Evil twins",
    "choice_b": "Collision resistance",
    "choice_c": "Key length",
    "choice_d": "Key exchange",
    "correct_answer": "D",
    "explanation": "Asymmetric encryption makes key exchange possible because public keys are just that: public. They can be shared without causing a loss of cryptographic security or repudiation. They do not help with collision resistance, key length, or evil twins (which are malicious wireless access points).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      105,
      109,
      112,
      115,
      124
    ],
    "source": "9781394211395"
  },
  {
    "id": 588,
    "question": "Rick's cloud provider offers a dedicated hardware security module. Which of the following capabilities is it unlikely to offer?",
    "choice_a": "Validating secure boot processes",
    "choice_b": "Key generation",
    "choice_c": "Encrypting and decrypting data",
    "choice_d": "Creating digital signatures",
    "correct_answer": "A",
    "explanation": "A TPM is used to validate secure boot processes. A hardware security module (HSM) is used for key generation, storage, and management as well as for encrypting and decrypting data and creating and validating digital signatures.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      124,
      112,
      115,
      111,
      105
    ],
    "source": "9781394211395"
  },
  {
    "id": 589,
    "question": "Michelle believes that an image she has discovered in an attacker's directory of files contains additional information that has been hidden in it. What is this type of obfuscation called?",
    "choice_a": "Steganography",
    "choice_b": "Image hashing",
    "choice_c": "PNG warping",
    "choice_d": "Image blocking",
    "correct_answer": "A",
    "explanation": "Steganography is the art of hiding additional data in images. Michelle can use steganography detection tools to attempt to find the data, but attackers may use custom tools that could avoid detection as well. The other options were made up for this question.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      96,
      98,
      1,
      2,
      99
    ],
    "source": "9781394211395"
  },
  {
    "id": 590,
    "question": "Which of the following is not a common transport encryption protocol?",
    "choice_a": "TLS",
    "choice_b": "IPSec",
    "choice_c": "SAML",
    "choice_d": "SSH",
    "correct_answer": "C",
    "explanation": "SAML is the Security Assertion Markup Language, used to exchange authentication and authorization data between identity providers and service providers. TLS, IPSec, and SSH are all common transport encryption protocols.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      223,
      225,
      100,
      104,
      105
    ],
    "source": "9781394211395"
  },
  {
    "id": 591,
    "question": "What technology is record\u2010level encryption most commonly associated with?",
    "choice_a": "Stored audio files",
    "choice_b": "Databases",
    "choice_c": "Physical disks",
    "choice_d": "Removable storage",
    "correct_answer": "B",
    "explanation": "Record\u2010level encryption is commonly associated with databases, where it is used to encrypt each record with a unique encryption key, allowing it to be more secure than database\u2010level encryption.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      99,
      104,
      111,
      100,
      105
    ],
    "source": "9781394211395"
  },
  {
    "id": 592,
    "question": "Yasmine submits the Windows BitLocker key to a central repository after she encryptions the machine. The central repository allows files to be uploaded, but not read, and is protected with access requiring special permissions. What type of solution is Yasmine's company using?",
    "choice_a": "A hardware security module",
    "choice_b": "Perfect forward secrecy",
    "choice_c": "Key escrow",
    "choice_d": "Private keys",
    "correct_answer": "C",
    "explanation": "Yasmine's company has implemented a key escrow process where encryption keys are retained by the organization in case the files on the drive need to be accessed by someone with proper authority. A hardware security module (HSM) is a hardware device used to create and store encryption keys, among other encryption\u2010related functions. Perfect forward secrecy (PFS) is a term used in encryption systems that change keys frequently to ensure that even if a key is hacked, the attacker's access to data will exist in a limited window. Private keys are part of asymmetric encryption schemes and do not reflect the full solution Yasmine's organization is using.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      99,
      124,
      146,
      102,
      106
    ],
    "source": "9781394211395"
  },
  {
    "id": 593,
    "question": "Valerie wants to authenticate her systems using her AAA system. Which of the following options is best suited to system authentication?",
    "choice_a": "Asymmetric authentication",
    "choice_b": "Certificate\u2010based authentication",
    "choice_c": "Symmetric authentication",
    "choice_d": "PIN\u2010based authentication",
    "correct_answer": "B",
    "explanation": "Certificates are commonly used for system authentication in AAA systems. While asymmetric and symmetric are forms of encryption, they are not authentication schemes, and PIN\u2010based authentication is not commonly used for system authentication.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      118,
      122,
      124,
      115,
      105
    ],
    "source": "9781394211395"
  },
  {
    "id": 594,
    "question": "Valentine wants to detect if an intruder has accessed a secured file server. Which of the following techniques will work best with a data loss prevention tool to identify data exfiltration?",
    "choice_a": "A honeypot",
    "choice_b": "A honeynet",
    "choice_c": "A honeyfile",
    "choice_d": "A honeytoken",
    "correct_answer": "C",
    "explanation": "Honeyfiles are files that are intentionally made to look attractive while being configured for detection by data loss prevention and intrusion prevention/detection systems. A honeypot is an intentionally vulnerable system that is used to monitor attacker behavior and techniques for analysis. Honeynets are networks that are configured to be intentionally vulnerable and that operate much like honeypots at a network level. Honeytokens are credentials that are not actually used but that are monitored for use in case an attacker is able to capture them.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      2,
      163,
      165,
      166,
      146
    ],
    "source": "9781394211395"
  },
  {
    "id": 595,
    "question": "Jason has recommended that additional lighting be put in place on the exterior of his building as part of a security upgrade. What type of control is lighting?",
    "choice_a": "Operational",
    "choice_b": "Deterrent",
    "choice_c": "Corrective",
    "choice_d": "Technical",
    "correct_answer": "B",
    "explanation": "Lighting is a deterrent control type and would typically be categorized as a physical control.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      5,
      162,
      163,
      166
    ],
    "source": "9781394211395"
  },
  {
    "id": 596,
    "question": "Which of the following controls is typically the most expensive to implement?",
    "choice_a": "Bollards",
    "choice_b": "Access control vestibules",
    "choice_c": "Security guards",
    "choice_d": "Access badges",
    "correct_answer": "C",
    "explanation": "Any control that requires constant human presence like security guards is likely to have a higher ongoing cost than controls that can be put in place and operate without human intervention or presence.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      164,
      5,
      6,
      285,
      163
    ],
    "source": "9781394211395"
  },
  {
    "id": 597,
    "question": "Frankie wants to validate the integrity of a file by comparing it against an original copy. Which of the following solutions both fulfills this requirement and avoids known security issues?",
    "choice_a": "Hash the original file and the current file using MD5 and compare the hashes.",
    "choice_b": "Hash the original file and the current file using SHA\u20101 and compare the hashes.",
    "choice_c": "Hash the original file and the current file using SHA\u2010256 and compare the hashes.",
    "choice_d": "Hash the original file and the current file using AES and compare the hashes.",
    "correct_answer": "C",
    "explanation": "SHA\u2010256 is the current, secure hashing standard. While it is unlikely that a malicious actor would exploit known flaws in MD5 and SHA\u20101, in most normal operations SHA\u2010256 remains the preferred option when it is available. The Advanced Encryption Standard (AES) is used for encryption, not hashing.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      114,
      107,
      108,
      98,
      1
    ],
    "source": "9781394211395"
  },
  {
    "id": 598,
    "question": "Joanna's organization has a policy that requires a user's password to be immediately reset to lock accounts if the account is determined to have been successfully phished. What type of control is this?",
    "choice_a": "A detective control",
    "choice_b": "A directive control",
    "choice_c": "A compensating control",
    "choice_d": "A preventive control",
    "correct_answer": "B",
    "explanation": "Policies are examples of directive controls. This could also be considered a corrective control, but that is not one of the options listed. Detective controls identify security events that have already occurred, and this does not detect the compromised account\u2014it directs what must happen afterward. A compensating control mitigates risks due to exceptions in the security policy like a violation of policy due to an inability to implement a specific technical control like patching. A preventive control attempts to stop a security issue before it occurs. Here, the issue has already occurred. The policy of directive control tells staff what do to, and the action of locking the account is a corrective control.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      6,
      5,
      285,
      1,
      2
    ],
    "source": "9781394211395"
  },
  {
    "id": 599,
    "question": "Jackie wants to implement an AAA system for her network. What AAA protocol is commonly used for network devices?",
    "choice_a": "OpenID",
    "choice_b": "SAML",
    "choice_c": "RADIUS",
    "choice_d": "TANGENT",
    "correct_answer": "C",
    "explanation": "RADIUS is commonly used for AAA for network devices. OpenID and SAML are more commonly associated with federated services, and TANGENT is not an AAA protocol or server.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      146,
      147,
      223,
      225,
      195
    ],
    "source": "9781394211395"
  },
  {
    "id": 600,
    "question": "Scott wants to automate policy creation in his zero\u2010trust environment's policy engine. Which of the following is not a typical component for automated data and event\u2010driven policy management?",
    "choice_a": "A SIEM",
    "choice_b": "Threat feeds",
    "choice_c": "Infrared sensor data",
    "choice_d": "EDR tools",
    "correct_answer": "C",
    "explanation": "Physical security sensors are not typically part of a zero\u2010trust policy engine feed. Zero\u2010trust environments primarily focus on network and systems access rather than physical security and access.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      147,
      146,
      5,
      6,
      284
    ],
    "source": "9781394211395"
  },
  {
    "id": 601,
    "question": "Valerie's organization has deployed a zero\u2010trust solution, and Valerie receives an authentication prompt when she is attempting to access a file server. What component of the zero\u2010trust architecture is she interacting with?",
    "choice_a": "A policy enforcement point",
    "choice_b": "A policy administrator",
    "choice_c": "The policy engine",
    "choice_d": "The trust manager",
    "correct_answer": "A",
    "explanation": "Valerie is interacting with a policy enforcement point, the agent and resource\u2010side elements that validate trust by requiring authentication and authorization before allowing access to a resource. The policy enforcement point will validate her access through the policy engine, which will be configured by the policy administrator. Trust managers are not a typical component of the zero\u2010trust model.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      147,
      146,
      5,
      6,
      1
    ],
    "source": "9781394211395"
  },
  {
    "id": 602,
    "question": "Matt is assessing his organization's zero\u2010trust model against the NIST Zero Trust Maturity Model. Which of the following is not a common element of zero\u2010trust systems that would be assessed as part of the model?",
    "choice_a": "Identity",
    "choice_b": "Business model",
    "choice_c": "Networks",
    "choice_d": "Devices",
    "correct_answer": "B",
    "explanation": "Identity, devices, networks, applications and workloads, and data are all assessed as part of the NIST Zero Trust Maturity Model. The model does not assess an organization's business model or practices.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      147,
      5,
      6,
      285,
      1
    ],
    "source": "9781394211395"
  },
  {
    "id": 603,
    "question": "Quentin wants to deploy a single sign\u2010on system to allow his users to log in to cloud services. Which of the following technologies is he most likely to deploy?",
    "choice_a": "OpenID",
    "choice_b": "Kerberos",
    "choice_c": "LDAP",
    "choice_d": "TACACS+",
    "correct_answer": "A",
    "explanation": "OpenID is an open standard for decentralized authentication that is used by many cloud service providers. Kerberos, LDAP, and TACACS+ are all most commonly associated with on\u2010site usage.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      101,
      98,
      146,
      105,
      115
    ],
    "source": "9781394211395"
  },
  {
    "id": 604,
    "question": "Marty wants to deploy a corrective control to deal with a recently compromised system. Which of the following would be considered a corrective control?",
    "choice_a": "Patching the vulnerability that allowed the compromise to occur",
    "choice_b": "Deploying full\u2010disk encryption",
    "choice_c": "Deploying an endpoint detection and response (EDR) tool",
    "choice_d": "Enabling logging and sending logs to a SIEM",
    "correct_answer": "A",
    "explanation": "Corrective controls attempt to remediate security issues that have already occurred. Patching the flaw that allowed an attack to succeed is an example of a corrective control. Deploying full\u2010disk encryption or an EDR tool are both examples of preventive controls, and logging and log monitoring are examples of detective controls. It is important to note that in many cases, controls could be identified as multiple potential control types. In cases where controls might fit multiple control types, you should look for the control that is most obviously the correct control type.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      5,
      284,
      283,
      1
    ],
    "source": "9781394211395"
  },
  {
    "id": 605,
    "question": "What important encryption feature is not supported by symmetric encryption?",
    "choice_a": "Confidentiality",
    "choice_b": "Integrity",
    "choice_c": "Nonrepudiation",
    "choice_d": "Authentication",
    "correct_answer": "C",
    "explanation": "Symmetric encryption does not support nonrepudiation because both parties have the same key. Both asymmetric and symmetric encryption can provide confidentiality, integrity, and authentication.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      98,
      115,
      105,
      104,
      117
    ],
    "source": "9781394211395"
  },
  {
    "id": 606,
    "question": "Theresa wants to use a cloud\u2010hosted security solution that will allow her to safely store and manage secrets. What type of solution should she select?",
    "choice_a": "A TPM",
    "choice_b": "A CA",
    "choice_c": "A KMS",
    "choice_d": "A CSR",
    "correct_answer": "C",
    "explanation": "A KMS, or key management system, is a solution that allows you to safely store and manage secrets like keys and certificates. Centralizing a KMS allows organizations to effectively manage their secrets, including tracking their life cycle and rotation. A TPM is used for hardware security on physical systems, a CA is a certificate authority used to create and sign certificates, and a CSR is a certificate signing request.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      124,
      111,
      119,
      120,
      105
    ],
    "source": "9781394211395"
  },
  {
    "id": 607,
    "question": "Joanna is reviewing her account information on an e\u2010commerce website and sees her credit card number displayed as XXXX\u2010XXXX\u2010XXXX\u20101234. What type of data obfuscation is in use?",
    "choice_a": "Hashing",
    "choice_b": "Data masking",
    "choice_c": "Field encryption",
    "choice_d": "Tokenization",
    "correct_answer": "B",
    "explanation": "Data masking conceals elements of a data field or entry, preventing all of it from being seen but leaving it accessible through the database when masking is not used. Tokenization replaces values with a reference value\u2014often a hash that can be used to refer to the value without using the actual entry. Hashing is a one\u2010way function that produces an input of arbitrary length. Field encryption is not a common term.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      114,
      107,
      115,
      99,
      100
    ],
    "source": "9781394211395"
  },
  {
    "id": 608,
    "question": "Amanda's organization wants to use a decentralized blockchain to store data. Which of the following is true about a decentralized blockchain?",
    "choice_a": "No individual or group controls the blockchain.",
    "choice_b": "Only cryptocurrency\u2010related data can be stored in a blockchain.",
    "choice_c": "Blockchain data can be changed after being stored by the original submitter.",
    "choice_d": "Blockchain ledgers are stored on central servers chosen by regular elections among blockchain participants.",
    "correct_answer": "A",
    "explanation": "In a decentralized blockchain, no individual or group controls the blockchain. Blockchains can store many types of data, including but not limited to transactions. Blockchain transactions are permanent once written, and a new transaction or update would need to be recorded rather than revising an existing transaction. Blockchain transactions are stored on the blockchain maintained by participants, not on central servers chosen by election.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      131,
      1,
      2,
      105,
      98
    ],
    "source": "9781394211395"
  },
  {
    "id": 609,
    "question": "What role does a subordinate CA have in a CA hierarchy?",
    "choice_a": "Subordinate CAs issue certificates based on subdomains.",
    "choice_b": "Subordinate CAs provide control over certificate issuance while avoiding the cost of being a root CA.",
    "choice_c": "Subordinate CAs validate root CA activities to ensure auditability.",
    "choice_d": "Subordinate CAs review certificate signing requests before forwarding them to the root CA.",
    "correct_answer": "B",
    "explanation": "Subordinate CAs avoid the cost of maintaining a root CA while providing control over certificates that are issued and allowing specialized support for different types of certificates like SSL and S/MIME. Subordinate CAs can issue certificates for any allowed domain or subdomain, are not required to ensure auditability, and can sign certificates themselves.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      119,
      122,
      120,
      118,
      116
    ],
    "source": "9781394211395"
  },
  {
    "id": 610,
    "question": "Which of the following sensor types is commonly used to detect footsteps?",
    "choice_a": "Infrared",
    "choice_b": "Pressure",
    "choice_c": "Microwave",
    "choice_d": "Ultrasonic",
    "correct_answer": "B",
    "explanation": "Pressure sensors can be deployed to detect footsteps in a secured area. Infrared and microwave sensors are more commonly used to detect motion, and ultrasonic sensors are rarely used for security purposes.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      166,
      162,
      163,
      164,
      165
    ],
    "source": "9781394211395"
  },
  {
    "id": 611,
    "question": "Which of the following is not a managerial control?",
    "choice_a": "Risk assessments",
    "choice_b": "Including security in change management processes",
    "choice_c": "Security planning exercises",
    "choice_d": "Implementing firewalls",
    "correct_answer": "D",
    "explanation": "Firewalls are a technical control, not a managerial control that focuses on the mechanics of the risk management process.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      6,
      285,
      282,
      283
    ],
    "source": "9781394211395"
  },
  {
    "id": 612,
    "question": "What purpose do third\u2010party certificates serve for customers of cloud services?",
    "choice_a": "They reduce costs by using bring\u2010your\u2010own certificates.",
    "choice_b": "They allow certificates for domains other than the service provider's domain.",
    "choice_c": "They provide control over cryptographic security for the customer.",
    "choice_d": "They allow more flexibility in TLS version selection.",
    "correct_answer": "C",
    "explanation": "Third\u2010party certificates allow customers to have full control over the certificate, including the private key and certificate signing request. By bringing your own certificate, encrypted traffic cannot be decrypted by the cloud provider. Using provider\u2010provided or \u2010created certificates leads to a potential risk if the provider is malicious or compromised and private keys managed by the provider are compromised. Bringing your own certificate does not necessarily reduce costs. Providers typically allow certificate signing requests for customer domains and subdomains as needed and supported by the service.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      124,
      116,
      105,
      119,
      102
    ],
    "source": "9781394211395"
  },
  {
    "id": 613,
    "question": "Which of the following is not a common control focused on availability?",
    "choice_a": "Uninterruptible power systems",
    "choice_b": "Redundant Internet connectivity",
    "choice_c": "Disk encryption",
    "choice_d": "Load balancers",
    "correct_answer": "C",
    "explanation": "Disk encryption is commonly used to ensure confidentiality of data. UPS, load balancers, and redundant Internet connectivity all support availability.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      1,
      2,
      5,
      198,
      99
    ],
    "source": "9781394211395"
  },
  {
    "id": 614,
    "question": "What term describes a collection of honeypots on a network intended to capture information about cybersecurity threats?",
    "choice_a": "A honeyfarm",
    "choice_b": "A honeynet",
    "choice_c": "A honeycluster",
    "choice_d": "A darknet",
    "correct_answer": "B",
    "explanation": "Honeynets are collections of decoy systems and devices that are instrumented and monitored, providing organizations and individuals with information about how threat actors attack targeted systems. Honeyfarm and honeycluster are not industry terms, and darknets are segments of unused network space that should not receive traffic. Darknets are monitored to help identify scanning and other attacks since traffic should not flow to them.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      5,
      6,
      165,
      166,
      162
    ],
    "source": "9781394211395"
  },
  {
    "id": 615,
    "question": "Skip wants to implement a deterrent control to prevent physical security issues for his organization. Which of the following controls should he select?",
    "choice_a": "A fence",
    "choice_b": "A generator",
    "choice_c": "Access badges",
    "choice_d": "A camera system",
    "correct_answer": "A",
    "explanation": "Fencing is considered a deterrent because it will discourage potential intruders from accessing facilities. Generators are used to ensure availability and are a preventive control. Access badges are a technical and preventive control in most cases. A camera system is a detective, technical control.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      162,
      5,
      165,
      164
    ],
    "source": "9781394211395"
  },
  {
    "id": 616,
    "question": "What holds the position of the root of trust in a certificate chain?",
    "choice_a": "A hardened hardware device",
    "choice_b": "A TPM",
    "choice_c": "A root certificate",
    "choice_d": "A wildcard certificate",
    "correct_answer": "C",
    "explanation": "The root certificate, or top certificate for a certificate chain, is the root of trust of the chain, and it must be kept secure so the entire certificate and CA hierarchy can be trusted. Hardened hardware devices may be used to store it, but they are not the actual root itself. A TPM is used to store system\u2010specific security data, and wildcard certificates cover more than one subdomain for an organization.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      119,
      118,
      124,
      120,
      121
    ],
    "source": "9781394211395"
  },
  {
    "id": 617,
    "question": "Jill needs to explain the concept of open public ledgers to her organization as management wants to adopt a blockchain\u2010based system. What should she tell them about access to the ledger?",
    "choice_a": "Members must be added by a vote of all current members.",
    "choice_b": "Anyone can join at any time.",
    "choice_c": "Members must be added by a vote of more than 51 percent of current members.",
    "choice_d": "Ledgers are public but membership is private and controlled by the creator of the ledger.",
    "correct_answer": "B",
    "explanation": "By definition, open public ledgers are open and public\u2014anyone can join at any time. No vote is required, and creators do not control the ledger once it is made public.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      131,
      119,
      124,
      5,
      6
    ],
    "source": "9781394211395"
  },
  {
    "id": 618,
    "question": "Olivia wants to use a self\u2010signed certificate in her test environment for her organization's services to save money on commercial certificates. What warning should her team give her about the use of self\u2010signed certificates in a test environment?",
    "choice_a": "Certificate root of trust validation attempts will fail if implemented.",
    "choice_b": "Self\u2010signed certificates cannot be used for external users to support SSL.",
    "choice_c": "Self\u2010signed certificates cannot be used for internal users to support SSL.",
    "choice_d": "Browsers will not allow self\u2010signed certificates to be used when browsing sites.",
    "correct_answer": "A",
    "explanation": "Some software may attempt to validate the certificates in use and could fail. This may also lead to unexpected differences between production certificates and test certificates, which is undesirable in a test environment intended to mirror production. Both internal users and external users can still successfully use self\u2010signed certificates for SSL, but they will receive warnings in modern browsers. Browsers can typically be told to bypass warnings, or self\u2010signed certificates can be added to system certificate chains as needed, although this requires additional work from system administration teams and may not be desirable.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      119,
      118,
      120,
      123,
      121
    ],
    "source": "9781394211395"
  },
  {
    "id": 619,
    "question": "Amanda is concerned about issues with dependencies that may be found during her pending change. What practice should she implement to help ensure unexpected dependency issues are not encountered?",
    "choice_a": "Update organizational policies and procedures before the change.",
    "choice_b": "Update functional diagrams before the change.",
    "choice_c": "Validate the change in a test environment.",
    "choice_d": "Document legacy applications that may create dependencies.",
    "correct_answer": "C",
    "explanation": "The most effective way to ensure that all dependencies have been satisfied is to perform the change in a matching test environment to ensure that all issues have been identified and resolved. Updating policies and procedures as well as diagrams is typically done after major changes that result in a need for updates. Legacy applications that may create dependencies are not the only potential source of dependency issues.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      282,
      284,
      283,
      285,
      223
    ],
    "source": "9781394211395"
  },
  {
    "id": 620,
    "question": "Lucca has implemented an authentication scheme that relies on ticket\u2010granting tickets as part of the authentication process. What common authentication service has he implemented?",
    "choice_a": "TACACS+",
    "choice_b": "Kerberos",
    "choice_c": "MS\u2010CHAP",
    "choice_d": "EAP",
    "correct_answer": "B",
    "explanation": "Kerberos uses authentication tickets and ticket\u2010granting tickets to grant session keys for services that clients present to services to access them. TACACS+, MS\u2010CHAP, and EAP do not use this ticket\u2010based approach.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      101,
      104,
      105,
      102,
      6
    ],
    "source": "9781394211395"
  },
  {
    "id": 621,
    "question": "Jocelyn wants to select a modern encryption algorithm for use in her organization. Which of the following is a currently recommended encryption algorithm?",
    "choice_a": "AES\u2010256",
    "choice_b": "SHA1",
    "choice_c": "DES",
    "choice_d": "Blowfish",
    "correct_answer": "A",
    "explanation": "AES\u2010256 is the only currently recommended encryption solution on the list. SHA\u20101 is a hashing algorithm. DES and Blowfish both have vulnerabilities and have been replaced in modern usage.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      108,
      104,
      102,
      114,
      106
    ],
    "source": "9781394211395"
  },
  {
    "id": 622,
    "question": "Elizabeth wants to classify the following controls by their category. What category best describes lighting, fences, bollards, and access control vestibules?",
    "choice_a": "Technical",
    "choice_b": "Managerial",
    "choice_c": "Operational",
    "choice_d": "Physical",
    "correct_answer": "D",
    "explanation": "Lighting, fences, bollards, and access control vestibules are all examples of physical controls.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      162,
      163,
      166,
      165
    ],
    "source": "9781394211395"
  },
  {
    "id": 623,
    "question": "Jack wants to ensure the integrity of a file that he is sending to a third party via email. How can he provide the integrity of a file to an organization that he has not done business with before?",
    "choice_a": "Encrypt the file and send it to them.",
    "choice_b": "Digitally sign the file.",
    "choice_c": "Send a hash of the file in a separate email.",
    "choice_d": "Email the file size and original name in a separate email.",
    "correct_answer": "B",
    "explanation": "Jack should digitally sign the file and provide his public key to the other organization. This will allow them to validate his signature, as well as the integrity of the signed file. Encrypting the file does not ensure its integrity but does protect its confidentiality. Sending a hash does not ensure that the email was not modified, and emailing file size and name does not ensure the file was not changed.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      115,
      105,
      116,
      107,
      98
    ],
    "source": "9781394211395"
  },
  {
    "id": 624,
    "question": "Annie notices that her browser shows that the certificate for the site she is visiting is not valid. After performing some checks, she sees that the certificate is on the CA's certificate revocation list. Which of the following is not a reason for a certificate to be on a CRL?",
    "choice_a": "The CA is compromised.",
    "choice_b": "The certificate's private key was compromised.",
    "choice_c": "The certificate was signed with a stolen key.",
    "choice_d": "The certificate expired.",
    "correct_answer": "D",
    "explanation": "Certificates expire, but expiration does not place them on a CRL. That avoids extremely long CRLs in most cases, and the expired certificate contains sufficient information to know that the certificate is expired without being on a CRL. Reasons to add a certificate to a CLR include the CA being compromised, the certificate's private key being compromised, a mis\u2010issued certificate, certificate detail changes that require a reissued certificate, or certificates that were fraudulently signed, typically by a subordinate CA that was exploited or had poor practices.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      121,
      119,
      118,
      120,
      6
    ],
    "source": "9781394211395"
  },
  {
    "id": 625,
    "question": "Mohinder wants to use modern, secure hashing algorithms to validate files against known good originals. Which of the following hashing algorithms should he select?",
    "choice_a": "MD5",
    "choice_b": "SHA\u20101",
    "choice_c": "AES\u2010256",
    "choice_d": "SHA\u2010256",
    "correct_answer": "D",
    "explanation": "SHA\u2010256 is the only hashing algorithm listed that is considered current and secure as of the publication of this book. MD5 and SHA\u20101 both have known security issues, and AES\u2010256 is an encryption algorithm.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      114,
      107,
      108,
      106,
      102
    ],
    "source": "9781394211395"
  },
  {
    "id": 626,
    "question": "Derrick wants to validate an encrypted and digitally signed message sent using asymmetric encryption. What does he need from the sender to validate the message?",
    "choice_a": "The sender's private key",
    "choice_b": "Derrick's private key",
    "choice_c": "The sender's public key",
    "choice_d": "Derrick's public key",
    "correct_answer": "C",
    "explanation": "To verify whether a message was signed by a sender, the recipient needs the sender's public key.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      115,
      116,
      105,
      112,
      118
    ],
    "source": "9781394211395"
  },
  {
    "id": 627,
    "question": "The major patch release that Susan's team installed has failed, resulting in a nonworking service. What should her team do according to change management best practices?",
    "choice_a": "Declare an outage.",
    "choice_b": "Follow the documented backout plan.",
    "choice_c": "Restore from backups to the previous version.",
    "choice_d": "Uninstall the patch and validate service function.",
    "correct_answer": "B",
    "explanation": "Creating a complete backout plan and implementing it if something goes wrong that cannot be remediated during a change window is the accepted best practice in this scenario. That may involve restoring from backups or uninstalling the patch, but neither of these options is necessarily the correct answer in all circumstances. Similarly, declaring an outage may be necessary, but following the backout plan and communicating effectively is the best option.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      282,
      283,
      284,
      285,
      5
    ],
    "source": "9781394211395"
  },
  {
    "id": 628,
    "question": "The web server that Angela's organization manages was recently compromised and the SSL certificate's private key was accessed by attackers. Angela's team has completed remediation and has created a new CSR, including a new private key that they have secured. What type of control type best describes the creation of a new key and certificate in this circumstance?",
    "choice_a": "Corrective",
    "choice_b": "Compensating",
    "choice_c": "Deterrent",
    "choice_d": "Detective",
    "correct_answer": "A",
    "explanation": "This is a corrective control because it remediates a security issue after the event has occurred. A compensating control would attempt to mitigate a risk associated with exceptions made to a security policy. Deterrent controls attempt to prevent an attacker from violating security policies, and detective controls identify security events that have already happened.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      120,
      124,
      119,
      118
    ],
    "source": "9781394211395"
  },
  {
    "id": 629,
    "question": "Mikayla's zero\u2010trust system has received a request for access with an identity, and the basic criteria for access have been met. What should the system do next before providing access to the resource requested?",
    "choice_a": "Check the remote system's security status.",
    "choice_b": "Require reauthentication using MFA.",
    "choice_c": "Check the user's rights to ensure they can access the resource.",
    "choice_d": "Determine its level of confidence in the request.",
    "correct_answer": "D",
    "explanation": "A zero\u2010trust system should validate its level of confidence in a request that it receives once the basic criteria have been met. This may involve checking the access against known patterns of access by the user, validating current threat feed information, or checking other details that will help ensure the security and authenticity of the request.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      147,
      146,
      285,
      6,
      5
    ],
    "source": "9781394211395"
  },
  {
    "id": 630,
    "question": "Charles sets up an RDP server on an isolated network segment and places a file on it called <code>passwords.xlsx</code>. He then configures his IPS and DLP systems to monitor for that file exiting the network segment. What type of tool has Charles deployed?",
    "choice_a": "A honeyfile",
    "choice_b": "A SQL trap",
    "choice_c": "A red flag",
    "choice_d": "A trigger file",
    "correct_answer": "A",
    "explanation": "While many honeyfiles use canary tokens, simply monitoring for known files exiting systems that should not be accessed under normal circumstances is also a valid means to construct a honeypot and honeyfile\u2010based detection system. Charles can use the file and the isolated system to detect attackers who attempt to exfiltrate the file. The other answers were made up for this question.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      2,
      100,
      146,
      147
    ],
    "source": "9781394211395"
  },
  {
    "id": 631,
    "question": "Lucca is using precomputed rainbow tables to attempt to crack hashed passwords from a data breach. He knows that two users have the same password, but the hashes do not match. What password hash security technique has Lucca most likely encountered?",
    "choice_a": "Password encryption",
    "choice_b": "Salting",
    "choice_c": "Hash rotation",
    "choice_d": "Password mismatching",
    "correct_answer": "B",
    "explanation": "Salting uses a unique, randomly generated string that is added to each password before it is hashed. That means that even matching passwords will not have the same hash. This prevents rainbow tables from being effectively used against password hashes due to the added computational load it creates for precomputing hashes.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      114,
      107,
      99,
      115,
      117
    ],
    "source": "9781394211395"
  },
  {
    "id": 632,
    "question": "What operating system is commonly associated with secure enclaves?",
    "choice_a": "Windows",
    "choice_b": "iOS",
    "choice_c": "Linux",
    "choice_d": "Android",
    "correct_answer": "B",
    "explanation": "Secure enclaves are used by Apple devices to securely store security information like cryptographic keys.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      99,
      102,
      106,
      112,
      124
    ],
    "source": "9781394211395"
  },
  {
    "id": 633,
    "question": "Isaac is concerned that the passwords that his users are creating are too short and can be easily brute\u2010forced if their hashes were compromised. Rather than make his users remember longer passwords, he would like to implement a technical solution to help make the hashes more resistant to cracking. What solution can he use to help with this?",
    "choice_a": "Implement pass\u2010the\u2010hash algorithms.",
    "choice_b": "Use a collision\u2010resistant hashing algorithm.",
    "choice_c": "Implement key stretching techniques.",
    "choice_d": "Encrypt passwords rather than hashing them.",
    "correct_answer": "C",
    "explanation": "Implementing key stretching techniques can help short\u2014and thus weak\u2014passwords resist brute\u2010force hash cracking techniques. They won't help against brute\u2010force password guessing attacks, so Isaac will need to implement other controls against that type of attack. Pass\u2010the\u2010hash attacks reuse hashes, and thus aren't a technique used to prevent brute\u2010force attacks against hashed passwords. Collision resistance is a requirement for an effective hashing algorithm and should be part of any password hash storage implementation. Encrypting passwords is not a recommended practice because it leaves passwords in the hands of the organization rather than hashes and requires the organization to decrypt passwords to check them when they are used, creating frequent opportunities for exposure.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      117,
      102,
      109,
      114,
      6
    ],
    "source": "9781394211395"
  },
  {
    "id": 634,
    "question": "Christina wants to implement access badges printed with picture IDs for her organization, but she wants to use a wireless reader. What access badge technology is commonly implemented in scenarios like this?",
    "choice_a": "Wi\u2010Fi\u2010enabled access badges",
    "choice_b": "RFID access badges",
    "choice_c": "Bluetooth\u2010enabled access badges",
    "choice_d": "NFC access badges",
    "correct_answer": "B",
    "explanation": "RFID badges are the most commonly implemented wireless identification badges. Wi\u2010Fi and Bluetooth both require additional power for devices and thus are not a good fit for a badge, and NFC\u2010enabled badges have not come into common use at this time, although they are increasingly available for mobile device\u2013enabled badges.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      163,
      162,
      164,
      5,
      165
    ],
    "source": "9781394211395"
  },
  {
    "id": 635,
    "question": "Kendra's vulnerability management team has discovered that Internet of Things (IoT) devices deployed a few years ago to monitor temperatures for critical refrigerated equipment are vulnerable to a new attack. After reviewing the issue, her team has discovered that the devices are no longer supported and that the manufacturer has gone out of business. They suggest moving the devices to an isolated network to help protect them. What type of control has Kendra's team suggested?",
    "choice_a": "A corrective control",
    "choice_b": "A compensating control",
    "choice_c": "A confidentiality control",
    "choice_d": "A coordinated control",
    "correct_answer": "B",
    "explanation": "A compensating control helps to mitigate a risk due to an exception to a security policy. Here, the devices cannot be patched or fixed but are important to the operations of the organization. Moving them to a protected network will help compensate for the lack of patching. Since no security issues have occurred, this is not a corrective control. Confidentiality and coordinated controls are not control types for the Security+ exam.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      5,
      285,
      283,
      284
    ],
    "source": "9781394211395"
  },
  {
    "id": 636,
    "question": "Which of the following is not a common factor in adaptive authentication for zero trust?",
    "choice_a": "Where the user is logging in from",
    "choice_b": "Whether the user has logged in recently from another device",
    "choice_c": "What device the user is logging in from",
    "choice_d": "If the device is configured correctly",
    "correct_answer": "B",
    "explanation": "Adaptive authentication looks at the context of a login, including where they're logging in from\u2014both geographically, and from a network trust perspective, what device they're logging in from, and if the device is configured correctly. In modern, multidevice usage, whether the user has logged in recently from another device isn't as likely to be considered, but if the devices were in different countries it would likely raise a flag!",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      147,
      285,
      5,
      223,
      117
    ],
    "source": "9781394211395"
  },
  {
    "id": 637,
    "question": "Juan's organization is designing their zero\u2010trust model. Which of the following statements is true for network security zones?",
    "choice_a": "All communication is secured, regardless of the network security zone it occurs in.",
    "choice_b": "Communication receives additional security in low\u2010trust zones.",
    "choice_c": "Communication receives less security in high\u2010trust zones.",
    "choice_d": "All zero\u2010trust networks are considered secured zones.",
    "correct_answer": "A",
    "explanation": "One of the basic tenets of zero\u2010trust architecture is that all communication is secured, regardless of the security zone or trust zone that it occurs in. Additional security should not be required, nor should communications receive less security in higher trust zones. All zero\u2010trust networks are considered potential risk areas\u2014thus the zero in zero trust!",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      5,
      225,
      282,
      285
    ],
    "source": "9781394211395"
  },
  {
    "id": 638,
    "question": "What advantage do microwave sensors have over infrared sensors?",
    "choice_a": "They can detect heat signatures.",
    "choice_b": "They are cheaper than infrared sensors.",
    "choice_c": "They can penetrate some types of walls.",
    "choice_d": "They do not interfere with sensitive equipment.",
    "correct_answer": "C",
    "explanation": "Microwave sensors work in temperature ranges that infrared sensors do not, and they can penetrate walls and some small spaces allowing more complete coverage. Microwave sensors cannot detect heat signatures, are not cheaper than infrared sensors, and can interfere with some types of sensitive equipment.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      166,
      165,
      5,
      6,
      164
    ],
    "source": "9781394211395"
  },
  {
    "id": 639,
    "question": "Isaac is conducting a physical penetration test and wants to bypass an access control vestibule. What must he accomplish?",
    "choice_a": "He needs to persuade an individual to allow him to follow them through a single door.",
    "choice_b": "He needs to acquire an individual's access card.",
    "choice_c": "He needs to persuade an individual to allow him to follow them through two doors in a row.",
    "choice_d": "He needs to acquire the individual's access PIN.",
    "correct_answer": "C",
    "explanation": "Access control vestibules are intended to make it obvious that someone is following you through secured doors and may only be large enough for a single person to come through at once. Larger vestibules rely on staff noticing that the person following them through is not providing credentials and ensuring that doors close between access attempts.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      163,
      162,
      164,
      5,
      6
    ],
    "source": "9781394211395"
  },
  {
    "id": 640,
    "question": "Rachel wants to select an obfuscation method that will allow her customer service representatives to validate customer identities without providing full access to customer data. What should she select?",
    "choice_a": "Tokenization",
    "choice_b": "Data masking",
    "choice_c": "Steganography",
    "choice_d": "Hashing",
    "correct_answer": "B",
    "explanation": "Data masking reveals only part of a field and is often used with details like credit card numbers or Social Security numbers where only the last four digits will be revealed for validation purposes.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      100,
      99,
      2,
      5,
      285
    ],
    "source": "9781394211395"
  },
  {
    "id": 641,
    "question": "Valerie's manager has informed her that version control must be implemented for her development team's work. Which of the following is not a common, security\u2010related reason for version control?",
    "choice_a": "To help with patching",
    "choice_b": "To track each contributor's workload",
    "choice_c": "To ensure the proper version is deployed",
    "choice_d": "To help with change management",
    "correct_answer": "B",
    "explanation": "While version control has many useful impacts on security, tracking workload is not a security\u2010related issue for version control.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      284,
      285,
      283,
      6,
      5
    ],
    "source": "9781394211395"
  },
  {
    "id": 642,
    "question": "Jackie's change management process involves reporting functional validation test results to stakeholders. Which of the following is not a common stakeholder or stakeholder group for an application upgrade?",
    "choice_a": "Application administrators",
    "choice_b": "Service owners",
    "choice_c": "System administrators",
    "choice_d": "Auditors",
    "correct_answer": "D",
    "explanation": "While auditors may request application version information during audits, they are not typically notified during normal application updates and patching cycles. Application administrators, service owners, and system administrators are all commonly notified about functional validation test results so that they can take further action or know that the service update is complete.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      282,
      284,
      285,
      5,
      283
    ],
    "source": "9781394211395"
  },
  {
    "id": 643,
    "question": "How many keypairs are required for four individuals to communicate securely using asymmetric encryption?",
    "choice_a": "1",
    "choice_b": "4",
    "choice_c": "8",
    "choice_d": "12",
    "correct_answer": "B",
    "explanation": "Each individual has their own keypair in asymmetric encryption systems; thus, for four individuals to communicate securely using asymmetric encryption four keypairs are needed.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      105,
      112,
      109,
      124,
      115
    ],
    "source": "9781394211395"
  },
  {
    "id": 644,
    "question": "Michelle wants to store secrets for her organization in a cloud service. She wants to ensure the greatest level of security for her organization, and she is willing to spend more money to provide that security. What solution should she look for?",
    "choice_a": "A shared cloud TPM",
    "choice_b": "A shared cloud HSM",
    "choice_c": "A dedicated hardware cloud TPM",
    "choice_d": "A dedicated hardware cloud HSM",
    "correct_answer": "D",
    "explanation": "A dedicated, hardware\u2010based, cloud\u2010hosted hardware security module (HSM) is an appropriate solution for Michelle's needs. Cloud providers often provide shared HSMs as a service, which can increase perceived risk due to the shared underlying hardware. Dedicated hardware is typically available at a higher cost. Trusted platform modules (TPMs) are used to provide secure boot and related services, not to store secrets for an organization.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      124,
      130,
      99,
      100,
      198
    ],
    "source": "9781394211395"
  },
  {
    "id": 645,
    "question": "Murali wants to digitally sign a file. What key does he need to sign it?",
    "choice_a": "The recipient's private key",
    "choice_b": "His private key",
    "choice_c": "The recipient's public key",
    "choice_d": "His public key",
    "correct_answer": "B",
    "explanation": "To sign a file, Murali needs to use his own private key. The recipient can then use their public key to validate the signature.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      116,
      105,
      115,
      112,
      124
    ],
    "source": "9781394211395"
  },
  {
    "id": 646,
    "question": "What information is necessary for a certificate to be identified properly in an OCSP request?",
    "choice_a": "The domain name",
    "choice_b": "The original requestor's name",
    "choice_c": "The certificate's serial number",
    "choice_d": "The identifier for the open public ledger entry",
    "correct_answer": "C",
    "explanation": "OCSP requests must include the certificate's serial number to allow the OCSP responder to check the CA database for the certificate and its status. It does not require the domain name or requestor's name. Open public ledgers are part of blockchains, not OCSP.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      121,
      118,
      124,
      119,
      120
    ],
    "source": "9781394211395"
  },
  {
    "id": 647,
    "question": "Rick checks the certificate for the site he is viewing and sees that it reads <code>*.example.com</code>. What type of certificate is this, and why is it in use?",
    "choice_a": "It is a self\u2010signed certificate, and it is used for testing purposes.",
    "choice_b": "It is a wildcard certificate and is used for testing purposes.",
    "choice_c": "It is a wildcard certificate and is used for multiple subdomains.",
    "choice_d": "It is a self\u2010signed certificate and is used for multiple subdomains.",
    "correct_answer": "C",
    "explanation": "Wildcard certificates have a * in them, denoting that they can be used for any subdomain. For example, in this question, the wildcard would match any *.example.com subdomain like test.example.com and sales.example.com. Self\u2010signed certificates will not link to a root or intermediate CA, and thus cannot be verified with CAs.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      118,
      119,
      120,
      124,
      121
    ],
    "source": "9781394211395"
  },
  {
    "id": 648,
    "question": "John wants to write a procedure that addresses what to do if an employee inadvertently discloses their password due to a phishing attempt. What type of control is John considering?",
    "choice_a": "A directive control",
    "choice_b": "A proactive control",
    "choice_c": "A deterrent control",
    "choice_d": "A preventive control",
    "correct_answer": "A",
    "explanation": "Policies and procedures are examples of directive controls. Deterrent controls attempt to dissuade attackers from taking action. Preventive controls attempt to stop security issues from occurring. Proactive controls are not a control category used on the Security+ exam.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      5,
      285,
      284,
      164
    ],
    "source": "9781394211395"
  },
  {
    "id": 649,
    "question": "Adam has been asked to implement an allow list for websites that his servers can visit. What concern should he raise about the implementation of allow lists?",
    "choice_a": "Allow lists can be difficult to manage and cause failures if sites that are needed are not added.",
    "choice_b": "Allow lists do not prevent sites from being visited if they are not on the allow list.",
    "choice_c": "Allow lists cannot be configured to allow entire domains to be visited, creating significant overhead.",
    "choice_d": "Allow lists are prone to error, allowing unwanted sites to be added.",
    "correct_answer": "A",
    "explanation": "Allow lists can be difficult to manage over time, particularly as manufacturers and vendors add additional download and update sites and subdomains. This creates additional work for administrators and can cause errors or issues with updates and patching if not carefully monitored. Allow lists do prevent sites from being visited if they are not on the list, they can be configured with wildcards to allow entire domains or subdomains if desired, and they only allow sites that are added, meaning any problems with unwanted sites are the responsibility of the allow list administrator.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      282,
      6,
      283,
      285,
      5
    ],
    "source": "9781394211395"
  },
  {
    "id": 650,
    "question": "Jim wants to implement an authentication framework for his wireless network. Which of the following is most commonly used for wireless network authentication?",
    "choice_a": "EAP",
    "choice_b": "MS\u2010CHAP",
    "choice_c": "Kerberos",
    "choice_d": "LDAP",
    "correct_answer": "A",
    "explanation": "EAP is commonly used for authentication to wireless networks. MS\u2010CHAP is used with PPTP\u2010based VPNs, Kerberos is used for organizationwide authentication, and LDAP is used as part of authentication in Microsoft Active Directory domains, among other uses.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      101,
      117,
      118,
      124,
      223
    ],
    "source": "9781394211395"
  },
  {
    "id": 651,
    "question": "Gary is preparing change management documentation for an application restart after patching. What step should immediately follow the application restart?",
    "choice_a": "Validation testing",
    "choice_b": "Documenting the change occurred",
    "choice_c": "Updating version control",
    "choice_d": "Vulnerability scanning",
    "correct_answer": "A",
    "explanation": "Validation testing should follow application restarts to ensure the application is working as expected after the restart. Documentation and updating version information can be done after the validation because if validation fails the change may need to be reversed. Vulnerability scanning should have been done prior to implementation in a test environment if needed, and then should be done as part of ongoing security operations.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      282,
      284,
      1,
      2,
      285
    ],
    "source": "9781394211395"
  },
  {
    "id": 652,
    "question": "Anna has been told that her organization has deployed microwave sensors in the organization's warehouses. What are microwave sensors most frequently used to detect?",
    "choice_a": "Motion",
    "choice_b": "Glass break",
    "choice_c": "Heat signatures",
    "choice_d": "Pressure",
    "correct_answer": "A",
    "explanation": "Microwave sensors are commonly used to detect motion and have advantages over infrared sensors because they can work in a greater temperature range as well as traveling through some obstacles that would not allow infrared to penetrate them. They do not capture audio and are therefore not used for glass\u2010break sensors, they do not capture thermal data like infrared sensors, and they are not pressure sensors.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      166,
      165,
      162,
      5,
      100
    ],
    "source": "9781394211395"
  },
  {
    "id": 653,
    "question": "When is data on a drive that uses full\u2010disk encryption at the greatest risk?",
    "choice_a": "During the system boot process",
    "choice_b": "When the system is off",
    "choice_c": "When the system is logged in and in use",
    "choice_d": "When the system is being shut down",
    "correct_answer": "C",
    "explanation": "In order for a drive to be used, it must be accessible to the operating system, meaning that when the system is logged in and in use data can be accessed. When full\u2010disk encryption systems are booting and not logged in or when they are being shut down, they are typically not in a greater risk state, and they are most secure when shut down.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      100,
      198,
      99,
      1,
      2
    ],
    "source": "9781394211395"
  },
  {
    "id": 654,
    "question": "Alex has configured full\u2010disk encryption for laptops that his organization issues to employees. What cybersecurity objective does this primarily support?",
    "choice_a": "Confidentiality",
    "choice_b": "Availability",
    "choice_c": "Authenticity",
    "choice_d": "Integrity",
    "correct_answer": "A",
    "explanation": "Full\u2010disk encryption primarily supports confidentiality by preventing unwanted access to the drive if it is stolen or otherwise exposed. The three objectives are confidentiality, integrity, and availability, which means authenticity is not a possible answer. Encryption does not increase availability, and integrity ensures that data has not been changed inadvertently or maliciously. Thus, encryption can help, but it is not as strong of an answer as confidentiality.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      1,
      198,
      99,
      100,
      2
    ],
    "source": "9781394211395"
  },
  {
    "id": 655,
    "question": "What process reviews control objectives for an organization, system, or service to determine if controls do not meet the control objectives?",
    "choice_a": "A penetration test",
    "choice_b": "A gap analysis",
    "choice_c": "A Boolean analysis",
    "choice_d": "A risk analysis",
    "correct_answer": "B",
    "explanation": "A gap analysis is used to determine whether controls meet control objectives for a service, an organization, or a system. Penetration tests simulate an attacker trying to gain access or breach systems and other controls. Boolean analysis is not a security term, and risk analysis is done as part of risk assessment.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      282,
      6,
      5,
      285,
      284
    ],
    "source": "9781394211395"
  },
  {
    "id": 656,
    "question": "Frank configures an access control list to ensure that only specific IP addresses are able to connect to a service. What type of control has he deployed?",
    "choice_a": "Managerial",
    "choice_b": "Physical",
    "choice_c": "Technical",
    "choice_d": "Operational",
    "correct_answer": "C",
    "explanation": "Access control lists are best described as technical controls. Managerial controls are procedural mechanisms; physical controls are controls that impact the physical world, like locks or fences; and operational controls are processes used to manage technology in a secure manner, like the change management process Frank will likely follow to make changes to the access control list.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      6,
      147,
      282,
      285
    ],
    "source": "9781394211395"
  },
  {
    "id": 657,
    "question": "Annie has recently implemented a video surveillance system for her organization. What is the largest driver for new ongoing costs for an unmonitored video surveillance system?",
    "choice_a": "Camera maintenance",
    "choice_b": "The ongoing cost of storage",
    "choice_c": "Security guards",
    "choice_d": "Licensing",
    "correct_answer": "B",
    "explanation": "Video surveillance system storage can drive additional costs based on decisions like how long video is retained, sensitivity levels, video resolution, and how heavily trafficked camera covered areas are. Licensing may grow if additional cameras are added, but there is no information in the question indicating changes in the size of the implementation. Since this is an unmonitored system, no guards are involved, and camera maintenance is not a typical issue for a newly deployed system.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      165,
      164,
      6,
      282,
      100
    ],
    "source": "9781394211395"
  },
  {
    "id": 658,
    "question": "Henry's organization has recently experienced a ransomware attack and is restoring backups from a secure backup system. What type of security control is Henry using?",
    "choice_a": "A preventive control",
    "choice_b": "A directive control",
    "choice_c": "A compensating control",
    "choice_d": "A corrective control",
    "correct_answer": "D",
    "explanation": "Restoring from backups helps to remediate a security issue, making this a corrective control. Preventive controls for Henry's situation might include endpoint detection and response (EDR) tools, directive controls would include policies and procedures for ransomware events, and compensating controls would be used if exceptions to the security policies needed to be made.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      5,
      1,
      285,
      284
    ],
    "source": "9781394211395"
  },
  {
    "id": 659,
    "question": "What data obfuscation technique relies on a lookup table that allows you to match the data you want to secure to a randomly generated value to ensure that the actual value is not easily accessible?",
    "choice_a": "Hashing",
    "choice_b": "Tokenization",
    "choice_c": "Randomization",
    "choice_d": "Masking",
    "correct_answer": "B",
    "explanation": "Tokenization commonly uses randomly generated values that are assigned to replace existing known values. The token is stored in a lookup table, allowing the token to be checked against the table if needed. Hashing relies on a hash function, which is not mentioned here; randomization is not a data obfuscation technique; and masking replaces some or all of a sensitive field with a replacement character to ensure the data is unreadable when displayed.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      114,
      107,
      99,
      100,
      1
    ],
    "source": "9781394211395"
  },
  {
    "id": 660,
    "question": "What challenge drives the need for key exchange mechanisms?",
    "choice_a": "The number of keys required for symmetric encryption",
    "choice_b": "The need to determine if a key is public",
    "choice_c": "The need to exchange keys in a way that prevents others from obtaining a copy",
    "choice_d": "The need to securely return keys to their owner after they are traded",
    "correct_answer": "C",
    "explanation": "Key exchange algorithms focus on how to securely exchange keys so that others cannot obtain a copy of the key. Asymmetric encryption is used instead of symmetric encryption to resolve the issue of large numbers of symmetric keys; keys are either public or private in asymmetric systems and determining if they are public is not considered a problem; and keys are not returned to their owner, as only public keys should be exchanged.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      109,
      104,
      105,
      110,
      112
    ],
    "source": "9781394211395"
  },
  {
    "id": 661,
    "question": "Jackie is performing an impact analysis prior to a large\u2010scale change her team is preparing to implement. Which of the following groups is not typically part of the impact analysis?",
    "choice_a": "Stakeholders",
    "choice_b": "System administrators",
    "choice_c": "Service owners",
    "choice_d": "Legal counsel",
    "correct_answer": "D",
    "explanation": "Legal counsel is not typically part of change management processes. Stakeholders, service owners, and system administrators are commonly involved in impact analysis sessions.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      282,
      285,
      5,
      6,
      283
    ],
    "source": "9781394211395"
  },
  {
    "id": 662,
    "question": "Ilya wants to create a certificate signing request. Which of the following is not a typical part of a CSR?",
    "choice_a": "The common name of the server",
    "choice_b": "The organization's legal name",
    "choice_c": "A contact email address",
    "choice_d": "The organization's phone number",
    "correct_answer": "D",
    "explanation": "Certificate requests include the common name (CN); organization (O); organization unit in the organization (OU); city or locality (L); the state, county, or region (S); country (C); and organizational contact email address.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      120,
      118,
      119,
      122,
      107
    ],
    "source": "9781394211395"
  },
  {
    "id": 663,
    "question": "Before Tony stores a password hash, he appends a string of characters that is unique to each password generated using an algorithm he created. What technique is Tony using to help protect his password hashes?",
    "choice_a": "Tokenization",
    "choice_b": "Steganography",
    "choice_c": "Salting",
    "choice_d": "Key stretching",
    "correct_answer": "C",
    "explanation": "Tony is salting his password, which involves adding a string of characters to the password before it is hashed. This creates a unique hash, even if the password itself is an easily guessed or common password.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      107,
      108,
      102,
      106,
      98
    ],
    "source": "9781394211395"
  },
  {
    "id": 664,
    "question": "Which of the following is not a step taken when a transaction is entered in a blockchain?",
    "choice_a": "The value of the block is determined.",
    "choice_b": "The transaction is sent to a peer\u2010to\u2010peer network of computers.",
    "choice_c": "The transaction is validated using equations.",
    "choice_d": "A transaction history is maintained as part of the blockchain.",
    "correct_answer": "A",
    "explanation": "While cryptocurrency is a common use of blockchain technology, it isn't the only use. Values of blocks are not determined as part of transactions\u2014in fact, even in cryptocurrency uses, values are determined by prices set on exchanges as sellers and buyers exchange cryptocurrencies.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      131,
      107,
      114,
      117,
      115
    ],
    "source": "9781394211395"
  },
  {
    "id": 665,
    "question": "Kent wants to encrypt network traffic in transit. What cryptographic protocol is most frequently used to add encryption to existing protocols?",
    "choice_a": "S/MIME",
    "choice_b": "TLS",
    "choice_c": "MPLS",
    "choice_d": "SSH",
    "correct_answer": "B",
    "explanation": "TLS, or Transport Layer Security, is a cryptographic protocol used to secure network traffic in transit. S/MIME, or Secure MIME, is used for digital signatures and encryption for email. MPLS is multiprotocol label switching, a network routing technique. SSH is Secure Shell and is used for encrypted command\u2010line access as well as to tunnel other protocols in some cases.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      100,
      223,
      225,
      224,
      118
    ],
    "source": "9781394211395"
  },
  {
    "id": 666,
    "question": "Which of the following is not a common concern in change management processes related to legacy applications?",
    "choice_a": "Lack of vendor support",
    "choice_b": "Lack of patches and updates",
    "choice_c": "Ongoing licensing costs",
    "choice_d": "Availability of third\u2010party or consultant expertise",
    "correct_answer": "C",
    "explanation": "Legacy applications are often unsupported, don't receive new patches or updates, and have a shrinking or nonexistent base of consultants and experts. Licensing for legal applications is often not available; this making ongoing licensing costs a less frequent concern.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      282,
      284,
      285,
      223,
      5
    ],
    "source": "9781394211395"
  },
  {
    "id": 667,
    "question": "Elaine wants to document the technical concerns that dependencies create as part of her change management process. Which of the following concerns is the most common when dependencies are encountered as part of change management?",
    "choice_a": "Documenting the dependencies to ensure they are addressed",
    "choice_b": "Removing the dependencies as part of the change",
    "choice_c": "Patching the dependencies in addition to the main application",
    "choice_d": "Updating diagrams related to the dependencies",
    "correct_answer": "A",
    "explanation": "Change management processes typically focus on documenting dependencies and ensuring they are met. That may involve ensuring that the appropriate version is installed or that applications are restarted in a specific order, or that a service is available that is needed for a system to successfully function. Removing dependencies is unlikely, patching may or may not be required, and updating diagrams is less important than ensuring the dependencies are understood and met.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      282,
      284,
      285,
      5,
      6
    ],
    "source": "9781394211395"
  },
  {
    "id": 668,
    "question": "Gary has implemented record\u2010level encryption for his database. How many keys will he use in a typical implementation of record\u2010level encryption?",
    "choice_a": "One key per record",
    "choice_b": "One key per column",
    "choice_c": "One key per table",
    "choice_d": "One key per database",
    "correct_answer": "A",
    "explanation": "Record\u2010level encryption relies on a unique key for each record, keeping records private to a user or account in typical usage.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      99,
      102,
      104,
      105,
      147
    ],
    "source": "9781394211395"
  },
  {
    "id": 669,
    "question": "Justin's laptop is part of his organization's zero\u2010trust architecture. What term is used to refer to a device like a laptop, desktop, or mobile device in a zero\u2010trust design?",
    "choice_a": "A subject",
    "choice_b": "A policy engine",
    "choice_c": "A service provider",
    "choice_d": "A policy application point",
    "correct_answer": "A",
    "explanation": "Justin's laptop is a subject. Subjects like users, applications, or devices are not trusted by default. Justin's system is also likely a policy enforcement point, not a policy application point, and will run a zero\u2010trust client application that will interface with the zero\u2010trust framework to determine if the system is secure as part of authentication and authorization processes. Policy engines evaluate policies and use threat information and other data to determine if access should be given in the context of the time, place, and system the request is made from. Service providers are concepts used in federation, rather than in zero\u2010trust environments.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      146,
      147,
      5,
      195,
      285
    ],
    "source": "9781394211395"
  },
  {
    "id": 670,
    "question": "Susan's organization has deployed a zero\u2010trust architecture. Which of the following zero\u2010trust control plane components uses rules to determine who can access a service based on the security status of their system, threat data, and similar information?",
    "choice_a": "Adaptive authorization",
    "choice_b": "Threat scope reduction",
    "choice_c": "Policy\u2010driven access control",
    "choice_d": "Secured zones",
    "correct_answer": "C",
    "explanation": "Policy\u2010driven access control focuses on using rules to determine who can access a service based on security state and other information. Adaptive authorization adjusts authorization levels based on factors like device status, user behavior, and location. Threat scope reduction is a key concept in zero trust that focuses on ensuring that threats have less of a target to attack if they enter the secure environment. Secured zones are no longer a critical concept for zero trust, as continuous verification means all interactions are secured and validated.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      147,
      146,
      5,
      285,
      195
    ],
    "source": "9781394211395"
  },
  {
    "id": 671,
    "question": "Scott wants to implement OCSP as part of an application he is creating. What will he implement?",
    "choice_a": "A corrective control security process",
    "choice_b": "Certificate status checking",
    "choice_c": "Transport encryption",
    "choice_d": "Full\u2010disk encryption",
    "correct_answer": "B",
    "explanation": "OCSP, or the Online Certificate Status Protocol, provides a way to check on the status of a certificate, including whether it has been revoked.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      121,
      119,
      120,
      118,
      123
    ],
    "source": "9781394211395"
  },
  {
    "id": 672,
    "question": "Which of the following is not a common reason to implement key escrow?",
    "choice_a": "Regulatory compliance",
    "choice_b": "Providing access to encrypted data for administrative reasons",
    "choice_c": "Providing access to encrypted data in emergencies",
    "choice_d": "Preventing the need for key rotation after a user leaves",
    "correct_answer": "D",
    "explanation": "Key rotation should occur when a user leaves, even if the key is escrowed. Regulatory compliance as well as providing access for administrative or emergency access to organizational data are common reasons to implement key escrow.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      111,
      124,
      285,
      282,
      100
    ],
    "source": "9781394211395"
  },
  {
    "id": 673,
    "question": "Yariv discovers that he has exposed his private key to other users in his organization by sending it via email instead of his public key. What should he do?",
    "choice_a": "Ask the other users to delete any copies of his private key that they may have.",
    "choice_b": "Immediately add his key to a CRL and reissue the key.",
    "choice_c": "Create a new keypair and notify others that he has replaced his keypair.",
    "choice_d": "Continue to operate as normal as long as the private key was not used maliciously.",
    "correct_answer": "C",
    "explanation": "Once a private key has been exposed, it should not be considered secure, even in an organization of trusted users. Since Yariv exposed his private key via email, he cannot ensure that it is not available in another user's email archives, and he must immediately create a new keypair and advise individuals that he works with of his new public key.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      124,
      105,
      111,
      102,
      115
    ],
    "source": "9781394211395"
  },
  {
    "id": 674,
    "question": "What happens if a mistake is made and an incorrect transaction is entered into the open public ledger in a blockchain?",
    "choice_a": "The transaction is reversed once it is discovered, and the original transaction is removed from the record.",
    "choice_b": "A new transaction must be processed, and both transactions remain in the record.",
    "choice_c": "The original transaction is updated and becomes the new record.",
    "choice_d": "An error block must be mined and labeled with the transaction number and error details.",
    "correct_answer": "B",
    "explanation": "Since blockchains are not changed after transactions are recorded, a new transaction must be recorded and both transactions remain in the record as part of the ledger.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      131,
      284,
      1,
      114,
      115
    ],
    "source": "9781394211395"
  },
  {
    "id": 675,
    "question": "Which of the following activities will not typically result in a need to update policies and procedures?",
    "choice_a": "Deploying a new application",
    "choice_b": "Installing patches for an existing application",
    "choice_c": "Conducting a lessons learned exercise after an incident",
    "choice_d": "Changes in regulations",
    "correct_answer": "B",
    "explanation": "Patches and updates are less likely to result in a need to update policies and procedures. New applications, lessons learned exercises, and regulatory changes are all likely to result in changes to policies and procedures.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      282,
      283,
      285,
      284,
      5
    ],
    "source": "9781394211395"
  },
  {
    "id": 676,
    "question": "Hrant's organization wants to ensure that staff members use both something they know and something they have as part of their physical access control scheme. Which of the following solutions meets that requirement?",
    "choice_a": "Security guards and access badges",
    "choice_b": "Keys and access control vestibules",
    "choice_c": "Access badges and PINs",
    "choice_d": "Security guards and access control vestibules",
    "correct_answer": "C",
    "explanation": "Access badges are an example of something you have, and PINs are an example of something you know. Combining the two is a common requirement to help prevent a lost badge from providing access to a secure facility. A security desk with a guard is more costly but can be more effective if the guards are well trained and diligent, but the needs of Hrant's organization are met properly by the access badge and PIN.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      163,
      5,
      285,
      6,
      164
    ],
    "source": "9781394211395"
  },
  {
    "id": 677,
    "question": "Julia wants to detect if an intruder enters a space using a sensor system. Which of the following is not typically used to detect intruders?",
    "choice_a": "Infrared sensors",
    "choice_b": "Pressure sensors",
    "choice_c": "Microwave sensors",
    "choice_d": "Ultrasonic sensors",
    "correct_answer": "C",
    "explanation": "Microwave sensors are not commonly used to detect intruders. Infrared and ultrasonic sensors are commonly used, and pressure sensors may be used in special circumstances.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      166,
      165,
      163,
      162,
      164
    ],
    "source": "9781394211395"
  },
  {
    "id": 678,
    "question": "Which of the following is not true for a secure cryptographic hash system?",
    "choice_a": "Hashes are a one\u2010way function.",
    "choice_b": "Hashes generate a fixed length output.",
    "choice_c": "Hashes may generate the same output for multiple inputs.",
    "choice_d": "Hashes are commonly used to verify the integrity of files.",
    "correct_answer": "C",
    "explanation": "Secure cryptographic hash systems should not generate the same output for two different inputs. They should, however, be one\u2010way functions and generate fixed length output, and they are commonly used to verify the integrity of files.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      114,
      117,
      115,
      107,
      106
    ],
    "source": "9781394211395"
  },
  {
    "id": 679,
    "question": "Casey wants to prevent tailgating attacks on her datacenter. What type of physical security solution should she put in place?",
    "choice_a": "Video surveillance",
    "choice_b": "Bollards",
    "choice_c": "An access control vestibule",
    "choice_d": "Access badges",
    "correct_answer": "C",
    "explanation": "Access control vestibules are designed to stop tailgating attacks, which occur when someone follows an authorized user into a space. Access badges do not prevent this, as tailgating relies on passing through a door someone with access has opened. Video surveillance may allow you to see the attack but won't stop it, and bollards are used to prevent vehicles from passing through a space.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      163,
      162,
      164,
      5,
      6
    ],
    "source": "9781394211395"
  },
  {
    "id": 680,
    "question": "As Casey continues to work to secure her datacenter, she decides to deploy access badges. What technique will provide the greatest assurance that a stolen or cloned access badge will not allow an attacker access?",
    "choice_a": "Use barcode\u2010based badges.",
    "choice_b": "Require a PIN along with the badge.",
    "choice_c": "Use RFID\u2010based badges.",
    "choice_d": "Include a picture of the user on the badge.",
    "correct_answer": "B",
    "explanation": "Requiring a PIN is the best option unless guards are in place to validate that the person using the badge matches the badge. Even then a PIN may be better than a picture if the badge does not have other elements like holographic seals that will prevent it from being modified. Barcode and RFID badges can still be cloned and are not as effective as requiring a knowledge\u2010based identifier as well as a possession\u2010based identifier.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      163,
      164,
      285,
      101,
      146
    ],
    "source": "9781394211395"
  },
  {
    "id": 681,
    "question": "What term describes the function of digital signatures related to proving that the signature was provided by the owner of a given private key?",
    "choice_a": "Ledger\u2010based validation",
    "choice_b": "Nonrepudiation",
    "choice_c": "Key stretching",
    "choice_d": "Authentication",
    "correct_answer": "B",
    "explanation": "A feature of digital signatures is nonrepudiation. A signed file or message can be proven to be from the signer, proving that it is legitimate. Key stretching describes techniques used to make it harder to crack weak keys. Authentication is the process of validating that a person is who they say they are but is not specific to digital signatures. Ledger\u2010based validation was made up for this question.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      115,
      98,
      105,
      116,
      114
    ],
    "source": "9781394211395"
  },
  {
    "id": 682,
    "question": "John wants to send his public key to another user. What steps are necessary to do so?",
    "choice_a": "The key must be sent using Diffie\u2013Hellman.",
    "choice_b": "The key can simply be sent via email or other means.",
    "choice_c": "The key must be sent using RSA.",
    "choice_d": "The key must be signed, then sent via email or other means.",
    "correct_answer": "B",
    "explanation": "Public keys can simply be sent to another user if so desired. It is common to provide public keys via key servers or even in email signatures, although addition verification that the key belongs to an individual may be desirable, if not required.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      105,
      124,
      119,
      118,
      224
    ],
    "source": "9781394211395"
  },
  {
    "id": 683,
    "question": "Tracy wants to use the most secure salting solution she can. Which of the following options will provide the most secure salt?",
    "choice_a": "Set a salt value and store it in a database.",
    "choice_b": "Set a salt value and store it in the program code.",
    "choice_c": "Generate a unique salt for each hashed entry.",
    "choice_d": "Generate a unique salt value every time a value is used.",
    "correct_answer": "C",
    "explanation": "Generating a unique salt for each hashed entry is the most secure option among those listed. Storing a fixed salt in a database or in code reduces the complexity of the salted information, making it possible for an attacker to acquire the single salt and then attack the stored hashes. Generating a unique salt every time a value is used is impractical due to the rate of change.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      111,
      107,
      114,
      99,
      98
    ],
    "source": "9781394211395"
  },
  {
    "id": 684,
    "question": "Bob conducts a periodic risk assessment of his organization. What category of security control is this?",
    "choice_a": "Technical",
    "choice_b": "Managerial",
    "choice_c": "Operational",
    "choice_d": "Physical",
    "correct_answer": "B",
    "explanation": "Risk assessments are an example of a managerial control, which includes procedural mechanisms related to the risk management process. Technical controls enforce confidentiality, integrity, and availability using technical means. Physical controls like locks and fences impact the physical world. Operational controls include processes put in place to manage technology in a secure manner.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      6,
      285,
      282,
      146
    ],
    "source": "9781394211395"
  },
  {
    "id": 685,
    "question": "After a breach, Jackie removes malicious software from a server that she is responsible for. What control type should she classify this as?",
    "choice_a": "Preventive",
    "choice_b": "Corrective",
    "choice_c": "Compensating",
    "choice_d": "Deterrent",
    "correct_answer": "B",
    "explanation": "Removing malicious software is an example of a corrective control, which seeks to remediate security issues that have already occurred. Preventive controls are intended to stop security issues from occurring. Compensating controls are designed to mitigate risks associated with exemptions to the security policy, like moving systems to a secure network segment because they cannot be patched. Deterrent controls attempt to prevent a malicious actor from violating security policies.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      5,
      282,
      285,
      164
    ],
    "source": "9781394211395"
  },
  {
    "id": 686,
    "question": "What can a root SSL (TLS) certificate do?",
    "choice_a": "Remove a certificate from a CRL",
    "choice_b": "Generate a signing key and use it to sign a new certificate",
    "choice_c": "Authorize new CA users",
    "choice_d": "Allow key stretching",
    "correct_answer": "B",
    "explanation": "Root certificates are at the root of trust in a CA hierarchy and allow signing keys to be created and used to sign certificates. They are not used to authorize new CA users or to remove certificates from a CRL. Key stretching is used to make weak keys stronger, not as part of cryptographic certificates.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      119,
      118,
      105,
      115,
      124
    ],
    "source": "9781394211395"
  },
  {
    "id": 687,
    "question": "Christina wants to authenticate individuals as part of her AAA implementation. What will she need to do to authenticate users?",
    "choice_a": "Match users to roles and ensure that rights are assigned.",
    "choice_b": "Conduct biometric enrollments for every user.",
    "choice_c": "Use identity proofing for each user she creates.",
    "choice_d": "Ensure that users provide an identity and one or more authentication factors.",
    "correct_answer": "D",
    "explanation": "Authentication requires that users provide (claim) an identity and then provide one or more authentication factors like a password, biometric factor, or multifactor code. Authorization relies on matching users and roles to allow users to perform tasks once they are authenticated. Biometric enrollments and identity proofing may be desirable but are not necessarily required for any given authentication system.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      101,
      98,
      146,
      285,
      5
    ],
    "source": "9781394211395"
  },
  {
    "id": 688,
    "question": "Brent\u2019s organization is profiling threat actors that may target their infrastructure and systems. Which of the following is most likely a motivation for a nation\u2010state actor?",
    "choice_a": "Financial gain",
    "choice_b": "Blackmail",
    "choice_c": "Espionage",
    "choice_d": "Blackmail",
    "correct_answer": "C",
    "explanation": "Nation\u2010state actors are typically advanced persistent threats (APTs) and their motivations commonly include espionage, data exfiltration, disruption/chaos, and war. Financial gain is more commonly associated with organized crime, blackmail with insider threats, and ethical with hacktivists.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      12,
      16,
      19,
      18,
      24
    ],
    "source": "9781394211395"
  },
  {
    "id": 689,
    "question": "Ahmed is a sales manager with a major insurance company. He has received an email that is encouraging him to click on a link and fill out a survey. He is suspicious of the email, but it does mention a major insurance association, and that makes him think it might be legitimate. Which of the following best describes this attack?",
    "choice_a": "Phishing",
    "choice_b": "Social engineering",
    "choice_c": "Spear phishing",
    "choice_d": "Trojan horse",
    "correct_answer": "C",
    "explanation": "Spear phishing is targeted to a specific group, in this case insurance professionals. Although this is a form of phishing, the more specific answer is the one you will need to choose on questions like this. Phishing uses social engineering techniques to succeed but is once again a broader answer than spear phishing and thus is not the correct choice. Finally, a Trojan horse pretends to be a legitimate or desirable program or file, which this scenario doesn't describe.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      33,
      32,
      34,
      19,
      26
    ],
    "source": "9781394211395"
  },
  {
    "id": 690,
    "question": "You are a security administrator for a medium\u2010sized bank. You have discovered a piece of software on your bank\u2019s database server that is not supposed to be there. It appears that the software will begin deleting database files if a specific employee is terminated. What best describes this?",
    "choice_a": "Worm",
    "choice_b": "Logic bomb",
    "choice_c": "Trojan horse",
    "choice_d": "Rootkit",
    "correct_answer": "B",
    "explanation": "A logic bomb is malware that performs its malicious activity when some condition is met. A worm is malware that self\u2010propagates. A Trojan horse is malware attached to a legitimate program, and a rootkit is malware that gets root or administrative privileges.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      29,
      26,
      27,
      28,
      31
    ],
    "source": "9781394211395"
  },
  {
    "id": 691,
    "question": "The company that Yarif works for uses a third\u2010party IT support company to manage their cloud\u2010hosted web application infrastructure. How can Yarif best address concerns about potential threat vectors via the managed service provider (MSP)?",
    "choice_a": "Conduct regular vulnerability scans.",
    "choice_b": "Use shared incident response exercises to prepare.",
    "choice_c": "Ensure appropriate contractual coverage for issues.",
    "choice_d": "Require the MSP to have an annual pentest.",
    "correct_answer": "C",
    "explanation": "Using appropriate contractual terms is usually the best available option for handling third\u2010party vendor risk. The terms can include things like security practices, such as pentesting, incident response exercises, and vulnerability scanning, and can also have sufficient penalties to ensure ongoing compliance from responsible companies.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      19,
      24,
      88,
      244,
      13
    ],
    "source": "9781394211395"
  },
  {
    "id": 692,
    "question": "Jill\u2019s organization has received an advisory about a flaw that could allow software running on a virtual machine to execute code on the system that is running the VM hypervisor. What type of vulnerability is this?",
    "choice_a": "A resource reuse issue",
    "choice_b": "A VM escape issue",
    "choice_c": "A jailbreaking issue",
    "choice_d": "A sideloading issue",
    "correct_answer": "B",
    "explanation": "This is an example of a virtual machine (VM) escape vulnerability. Jailbreaking and sideloading are terms used to describe mobile device\u2013related means of violating security, and resource reuse is a VM concern if data is not properly removed before a resource is given to another VM.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      202,
      183,
      88,
      89,
      69
    ],
    "source": "9781394211395"
  },
  {
    "id": 693,
    "question": "Helen is concerned about ransomware attacks against workstations that she is responsible for. Which of the following hardening options is best suited to protecting her organization from ransomware?",
    "choice_a": "Installing host\u2010based firewalls",
    "choice_b": "Installing endpoint protection software",
    "choice_c": "Installing a host\u2010based IPS software",
    "choice_d": "Removing unnecessary software",
    "correct_answer": "B",
    "explanation": "Endpoint protection software like an endpoint detection and response (EDR) or extended detection and response (XDR) tool will provide the greatest protection against ransomware. Firewalls and intrusion prevention systems (IPSs) are less likely to prevent ransomware from being installed, and removing unnecessary software may reduce the attack surface but most ransomware is installed via attacks that leverage users.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      25,
      29,
      31,
      19,
      221
    ],
    "source": "9781394211395"
  },
  {
    "id": 694,
    "question": "The company that Gary works for has deployed a wireless network. Which of the following network options is the most secure?",
    "choice_a": "WPA\u20102 Personal",
    "choice_b": "WPA\u20103",
    "choice_c": "WPA\u20102 Enterprise",
    "choice_d": "WPA\u20104",
    "correct_answer": "B",
    "explanation": "Wi\u2010Fi Protected Access 3 (WPA\u20103) is the most modern, most secure option from the list. WPA\u20104 does not currently exist as of this writing. WPA\u20102 Enterprise requires an authentication server and is less secure than WPA\u20103, while WPA\u20102 Personal allows for a single, set password.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      234,
      202,
      230,
      183,
      37
    ],
    "source": "9781394211395"
  },
  {
    "id": 695,
    "question": "What type of attack depends on the attacker entering JavaScript into a text area that is intended for users to enter text that will be viewed by other users?",
    "choice_a": "SQL injection",
    "choice_b": "Clickjacking",
    "choice_c": "Cross\u2010site scripting",
    "choice_d": "Bluejacking",
    "correct_answer": "C",
    "explanation": "Cross\u2010site scripting (XSS) involves entering a script into text areas that other users will view. SQL injection (SQLi) is not about entering scripts but rather SQL commands. Clickjacking is about tricking users into clicking on the wrong thing. Bluejacking is a Bluetooth attack.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      80,
      83,
      72,
      84,
      70
    ],
    "source": "9781394211395"
  },
  {
    "id": 696,
    "question": "Unusual outbound network traffic, geographical irregularities, and increases in database read volumes are all examples of what key element of threat intelligence?",
    "choice_a": "Predictive analysis",
    "choice_b": "OSINT",
    "choice_c": "Indicators of compromise",
    "choice_d": "Threat maps",
    "correct_answer": "C",
    "explanation": "There are many indicators of compromise (IoCs), including unusual outbound network traffic, geographical irregularities like logins from a country where the person normally does not work, or increases in database read volumes beyond normal traffic patterns. Predictive analysis is analysis work done using datasets to attempt to determine trends and likely attack vectors so that analysts can focus their efforts where they will be most needed and effective. OSINT is open source intelligence, and threat maps are often real\u2010time or near\u2010real\u2010time visualizations of where threats are coming from and where they are headed.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      244,
      25,
      26,
      31,
      24
    ],
    "source": "9781394211395"
  },
  {
    "id": 697,
    "question": "Julie wants to conduct a replay attack. What type of attack is most commonly associated with successful replay attacks?",
    "choice_a": "SQL injection",
    "choice_b": "An on\u2010path attack",
    "choice_c": "Brute force",
    "choice_d": "A DDoS",
    "correct_answer": "B",
    "explanation": "On\u2010path attacks that route traffic through a system or device that the attacker controls allow the attacker to both receive and modify traffic, making replay attacks more likely to succeed. SQL injection attacks are associated with web applications and databases. Brute\u2010force and distributed denial\u2010of\u2010service (DDoS) attacks are not typically associated with replay attacks.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      74,
      82,
      81,
      84,
      128
    ],
    "source": "9781394211395"
  },
  {
    "id": 698,
    "question": "Valerie is investigating a recent incident and checks <code>/var/log</code> on a Linux system. She finds the <code>audit.log</code> file empty despite the system uptime showing over a month of uptime. What has she most likely encountered?",
    "choice_a": "A wiped log",
    "choice_b": "A recent reboot",
    "choice_c": "A system error",
    "choice_d": "Incorrect permissions to view the log",
    "correct_answer": "A",
    "explanation": "Since Valerie is investigating an incident, she should immediately consider the potential that the logs were wiped. That likely means that the intruder has gained privileged access to the system, which should worry her even more! Reboots do not wipe <code>audit.log</code>, and Valerie should have permissions appropriate to perform her function. System errors could explain an empty <code>audit.log,</code> but are unlikely, and an empty log found during an investigation is a cause for concern.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      29,
      244,
      79,
      245,
      183
    ],
    "source": "9781394211395"
  },
  {
    "id": 699,
    "question": "Jack purchases ads on a site that staff members of his target organization frequently visit in preparation for a penetration test. Once his ads start to display, he replaces the underlying code with attack code that redirects visitors to a login page that matches the organization\u2019s own internal website. What type of attack has Jack attempted?",
    "choice_a": "A misinformation attack",
    "choice_b": "A watering hole attack",
    "choice_c": "A disinformation attack",
    "choice_d": "A business website compromise attack",
    "correct_answer": "B",
    "explanation": "Jack has attempted a watering hole attack that leverages a frequently visited site to target a specific group of people. In this case, he is targeting his penetration testing target's users. Misinformation and disinformation are used to change opinions or to provide false information, and while business email compromise attacks are part of the Security+ exam outline, business website compromise attacks are not.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      36,
      35,
      33,
      75,
      13
    ],
    "source": "9781394211395"
  },
  {
    "id": 700,
    "question": "Which of the following is not a common concern related to the hardware vendor supply chain?",
    "choice_a": "Malware preinstalled on hardware",
    "choice_b": "Lack of availability of hardware",
    "choice_c": "Third\u2010party hardware modifications",
    "choice_d": "Malicious firmware modifications",
    "correct_answer": "C",
    "explanation": "While malware, modified firmware, and lack of availability are common concerns with the hardware supply chain, hardware modifications remain relatively uncommon.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      184,
      202,
      88,
      19,
      27
    ],
    "source": "9781394211395"
  },
  {
    "id": 701,
    "question": "Ben wants to conduct a credential replay attack. What should he do first to enable the attack?",
    "choice_a": "Create a phishing email.",
    "choice_b": "Conduct an on\u2010path attack.",
    "choice_c": "Use a brute\u2010force password attack.",
    "choice_d": "Conduct an injection attack.",
    "correct_answer": "B",
    "explanation": "On\u2010path attacks are used to capture, then replay valid credentials for attackers to use. Session tokens are used to counter this type of attack in some cases. Phishing email and brute\u2010force password attacks can help obtain credentials but do not involve credential replay. Injection attacks are typically conducted against database servers.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      74,
      73,
      82,
      83,
      84
    ],
    "source": "9781394211395"
  },
  {
    "id": 702,
    "question": "Nick is assessing internal threat actors and considering what motivations are likely to drive them. Which of the following is the most likely motivation for an internal threat actor?",
    "choice_a": "Espionage",
    "choice_b": "Blackmail",
    "choice_c": "War",
    "choice_d": "Political beliefs",
    "correct_answer": "B",
    "explanation": "Common motivations for internal threat actors include blackmail, financial gain, and ethical reasons. Nation\u2010state threats are more likely to be interested in espionage and war, and hacktivists in political beliefs.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      12,
      17,
      19,
      18,
      16
    ],
    "source": "9781394211395"
  },
  {
    "id": 703,
    "question": "Yasmine is reviewing the software installed on a client\u2019s computer and notices that multiple browser toolbars, weather applications, and social media applications were preinstalled. What term is most commonly used to describe this software?",
    "choice_a": "MSPs",
    "choice_b": "Bloatware",
    "choice_c": "Ransomware",
    "choice_d": "Rootware",
    "correct_answer": "B",
    "explanation": "These are all common examples of bloatware, unwanted but typically not harmful software installed by manufacturers and as part of the installation processes for desired applications. MSPs are managed service providers, ransomware is malware that attempts to hold files for ransom, and rootware was made up for this question.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      29,
      31,
      28,
      25,
      30
    ],
    "source": "9781394211395"
  },
  {
    "id": 704,
    "question": "Ilya is reviewing logs and notices that one of his staff has logged in from his home location in China at 2 p.m., and then logged in from the United Kingdom an hour later. What indicator of compromise should he flag this as?",
    "choice_a": "Concurrent session usage",
    "choice_b": "Resource inaccessibility",
    "choice_c": "Impossible travel",
    "choice_d": "Segmentation",
    "correct_answer": "C",
    "explanation": "Impossible travel describes scenarios where logins or other actions occur from separate physical locations that are too far apart to travel between before the action occurs. Here it is impossible to travel from China to the UK in an hour, and Ilya may need to check in with the employee since no VPN usage was described. It is possible the employee's account is compromised or some other questionable activity is occurring.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      244,
      12,
      17,
      25,
      31
    ],
    "source": "9781394211395"
  },
  {
    "id": 705,
    "question": "Adam\u2019s organization has deployed RFID badges as part of their access control system. Adam is required to enter a 6\u2010digit PIN when he uses his RFID badge and dislikes the additional step. What type of attack is the PIN intended to stop?",
    "choice_a": "Piggybacking",
    "choice_b": "On\u2010path",
    "choice_c": "Concurrent access",
    "choice_d": "Badge cloning",
    "correct_answer": "D",
    "explanation": "Radio frequency identification (RFID) badges can be cloned, but adding an additional factor like a PIN means the badge alone is not sufficient to gain access. Piggybacking involves following an authorized user through a security door or gate. On\u2010path attacks inject an attacker into the middle of a transaction or network connection, allowing them to view and potentially modify traffic. Concurrent session usage or access is an indicator of compromise (IoC) that focuses on multiple systems or users using the same credentials.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      167,
      229,
      244,
      125,
      39
    ],
    "source": "9781394211395"
  },
  {
    "id": 706,
    "question": "Jen recently received an email that appeared to be from one of her vendors asking for a change in the method of payment to another account. She normally works with <code>mike_smith@example.com</code>, but noticed that the email was from <code>mike_smith@examp1e.com</code> on further review. What type of social engineering attack is this?",
    "choice_a": "Vishing",
    "choice_b": "Business email compromise",
    "choice_c": "Smishing",
    "choice_d": "Pretexting",
    "correct_answer": "B",
    "explanation": "Business email compromise (BEC) scams appear to come from legitimate sources and make requests that may seem reasonable like a payment change to a different wire transfer method. Vishing is done via voice, smishing via SMS, and pretexting uses excuses or reasons that the requested action must be taken.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      34,
      33,
      32,
      36,
      19
    ],
    "source": "9781394211395"
  },
  {
    "id": 707,
    "question": "What is the primary concern for security professionals about legacy hardware?",
    "choice_a": "Its likelihood of failure",
    "choice_b": "Lack of patches and updates",
    "choice_c": "Lack of vendor support",
    "choice_d": "Inability to support modern protocols",
    "correct_answer": "B",
    "explanation": "The primary concern for security professionals around legacy hardware is their lack of patches and updates, meaning that security fixes and updates will not exist. While the hardware could fail, that would typically lead to replacement with more modern, supportable options and is a concern for the system administrators and owners. Lack of vendor support and inability to support modern protocols are primarily concerns for owners and system administrators.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      184,
      202,
      200,
      203,
      29
    ],
    "source": "9781394211395"
  },
  {
    "id": 708,
    "question": "Coleen is the web security administrator for an online auction website. A small number of users are complaining that when they visit the website it does not appear to be the correct site. Coleen checks and she can visit the site without any problem, even from computers outside the network. She also checks the web server log and there is no record of those users ever connecting. Which of the following might best explain this?",
    "choice_a": "Typo squatting",
    "choice_b": "SQL injection",
    "choice_c": "Cross\u2010site scripting",
    "choice_d": "Cross\u2010site request forgery",
    "correct_answer": "A",
    "explanation": "From the description it appears that they are not connecting to the real web server but rather a fake server. That indicates typo squatting: having a URL that is named very similarly to a real site so that when users mistype the real site's URL they will go to the fake site.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      36,
      75,
      34,
      230,
      82
    ],
    "source": "9781394211395"
  },
  {
    "id": 709,
    "question": "The organization that Mike works in finds that one of their domains is directing traffic to a competitor\u2019s website. When Mike checks, the domain information has been changed, including the contact and other administrative details for the domain. If the domain had not expired, what has most likely occurred?",
    "choice_a": "DNS hijacking",
    "choice_b": "An on\u2010path attack",
    "choice_c": "Domain hijacking",
    "choice_d": "A zero\u2010day attack",
    "correct_answer": "C",
    "explanation": "Domain hijacking, or domain theft, occurs when the registration or other information for the domain is changed without the original registrant's permission. This may occur because of a compromised account or due to a breach of the domain registrar's security. A common issue is a lapsed domain being purchased by a third party, and this can look like a hijacked domain, but it is a legitimate occurrence if the domain is not renewed! DNS hijacking inserts false information into a DNS server, on\u2010path (man\u2010in\u2010the\u2010middle) attacks capture or modify traffic by causing the traffic to pass through a compromised midpoint, and zero\u2010day attacks are unknown to product vendors and, therefore, no patches are available to correct them.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      227,
      36,
      244,
      19,
      245
    ],
    "source": "9781394211395"
  },
  {
    "id": 710,
    "question": "Lucia\u2019s organization has adopted open source software provided by a third\u2010party vendor as part of their web application. What concern should she express about her software supply chain?",
    "choice_a": "Lack of vendor support",
    "choice_b": "Lack of code auditability",
    "choice_c": "Lack of control over open source dependencies",
    "choice_d": "Lack of updates",
    "correct_answer": "C",
    "explanation": "Open source software dependencies are a primary challenge when considering open source supply chain concerns. In this case, Lucia is using a third\u2010party vendor who can provide support, open source code is auditable, and updates are likely to occur with a vendor involved.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      88,
      19,
      82,
      202,
      184
    ],
    "source": "9781394211395"
  },
  {
    "id": 711,
    "question": "Alice wants to prevent server\u2010side request forgery (SSRF) attacks. Which of the following will not be helpful for preventing them?",
    "choice_a": "Removing all SQL code from submitted HTTP queries",
    "choice_b": "Blocking hostnames like 127.0.01 and localhost",
    "choice_c": "Blocking sensitive URLs like /admin",
    "choice_d": "Applying allow list\u2013based input filters",
    "correct_answer": "A",
    "explanation": "Server\u2010side request forgery (SSRF) attempts typically attempt to get HTTP data passed through and will not include SQL injection. Blocking sensitive hostnames, IP addresses, and URLs are all valid ways to prevent SSRF, as is the use of allow list\u2013based input filters.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      81,
      83,
      72,
      68,
      84
    ],
    "source": "9781394211395"
  },
  {
    "id": 712,
    "question": "Tracy wants to protect desktop and laptop systems in her organization from network attacks. She wants to deploy a tool that can actively stop attacks based on signatures, heuristics, and anomalies. What type of tool should she deploy?",
    "choice_a": "A firewall",
    "choice_b": "Antimalware",
    "choice_c": "HIDS",
    "choice_d": "HIPS",
    "correct_answer": "D",
    "explanation": "A host\u2010based intrusion prevention system (HIPS) can monitor, identify, and stop network traffic that displays network traffic to identify attacks, suspicious behavior, and known bad patterns using signatures. A firewall stops traffic based on rules; antimalware tools are specifically designed to stop malware, not attacks and suspicious network behavior; and a host\u2010based intrusion detection system (HIDS) can only detect, not stop, these behaviors.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      29,
      31,
      228,
      25,
      27
    ],
    "source": "9781394211395"
  },
  {
    "id": 713,
    "question": "Mahmoud is responsible for managing security at a large university. He has just performed a threat analysis for the network, and based on past incidents and studies of similar networks, he has determined that the most prevalent threat to his network are attackers who wish to breach the system, simply to prove they can or for some low\u2010level crime, such as changing a grade. Which term best describes this type of attacker?",
    "choice_a": "Hacktivist",
    "choice_b": "Nation\u2010state",
    "choice_c": "Insider",
    "choice_d": "Unskilled attacker",
    "correct_answer": "D",
    "explanation": "Unskilled attackers, often called script kiddies, tend to use premade tools in unsophisticated ways. Hacktivists take action based on political motivation, insiders operate from inside of an organization, and nation\u2010state actors are typically highly capable and well resourced.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      14,
      12,
      16,
      19,
      13
    ],
    "source": "9781394211395"
  },
  {
    "id": 714,
    "question": "How is phishing different from general spam?",
    "choice_a": "It is sent only to specific targeted individuals.",
    "choice_b": "It is intended to acquire credentials or other data.",
    "choice_c": "It is sent via SMS.",
    "choice_d": "It includes malware in the message.",
    "correct_answer": "B",
    "explanation": "Phishing is intended to acquire data, most often credentials or other information that will be useful to the attacker. Spam is a broader term for unwanted email, although the term is often generally used to describe unwanted communications. Spear phishing targets specific individuals, whereas whaling targets higher\u2010ups such as CEOs in an organization. Smishing is sent via SMS (text message). Malware can be sent in any of these instances, but there is not a specific related term that means \u201cspam with malware in it.\u201d.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      33,
      19,
      36,
      37,
      35
    ],
    "source": "9781394211395"
  },
  {
    "id": 715,
    "question": "Selah includes a question in her procurement request\u2010for\u2010proposal process that asks how long the vendor has been in business and how many existing clients the vendor has. What common issue is this practice intended to help prevent?",
    "choice_a": "Supply chain security issues",
    "choice_b": "Lack of vendor support",
    "choice_c": "Outsourced code development issues",
    "choice_d": "System integration problems",
    "correct_answer": "B",
    "explanation": "Systems and software that no longer have vendor support can be a significant security risk, and ensuring that a vendor will continue to exist and provide support is an important part of many procurement processes. Selah's questions are intended to assess the longevity and viability of the company and whether buying from them will result in her organization having a usable product for the long term.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      184,
      202,
      203,
      200,
      19
    ],
    "source": "9781394211395"
  },
  {
    "id": 716,
    "question": "Frank is a network administrator for a small college. He discovers that several machines on his network are infected with malware. That malware is sending a flood of packets to a target external to the network. What best describes this attack?",
    "choice_a": "SYN flood",
    "choice_b": "DDoS",
    "choice_c": "Botnet",
    "choice_d": "Backdoor",
    "correct_answer": "B",
    "explanation": "His machines are part of a distributed denial\u2010of\u2010service (DDoS) attack. This scenario describes a generic DDoS, not a specific one like SYN flood, which would involve many SYN packets being sent without a full three\u2010way TCP handshake. These machines could be part of a botnet or they may just have a trigger that causes them to launch the attack at a specific time. The real key in this scenario is the DDoS attack. Finally, a backdoor gives an attacker access to the target system.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      228,
      31,
      27,
      244,
      25
    ],
    "source": "9781394211395"
  },
  {
    "id": 717,
    "question": "A sales manager at your company is complaining about slow performance on his computer. When you thoroughly investigate the issue, you find spyware on his computer. He insists that the only thing he has downloaded recently was a freeware stock trading application. What would best explain this situation?",
    "choice_a": "Logic bomb",
    "choice_b": "Trojan",
    "choice_c": "Rootkit",
    "choice_d": "Macro virus",
    "correct_answer": "B",
    "explanation": "A Trojan attaches a malicious program to a legitimate program. When the user downloads and installs the legitimate program, they get the malware. A logic bomb is malware that does its misdeeds when some condition is met. A rootkit is malware that gets administrative, or root, access. A macro virus is a virus that is embedded in a document as a macro.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      26,
      28,
      30,
      29,
      31
    ],
    "source": "9781394211395"
  },
  {
    "id": 718,
    "question": "What threat actor is most likely to be motivated by political beliefs?",
    "choice_a": "Hacktivists",
    "choice_b": "Organized crime",
    "choice_c": "Unskilled attackers",
    "choice_d": "Insider threats",
    "correct_answer": "A",
    "explanation": "Hacktivists are defined by their political motivation. Organized crime is most frequently associated with financial gain as a motivation. While unskilled attackers and insider threats may have political motivations, hacktivists remain the most likely of this list.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      15,
      12,
      19,
      16,
      17
    ],
    "source": "9781394211395"
  },
  {
    "id": 719,
    "question": "What type of threat actors are most likely to have a profit motive for their malicious activities?",
    "choice_a": "State actors",
    "choice_b": "Hacktivists",
    "choice_c": "Unskilled attackers",
    "choice_d": "Organized crime",
    "correct_answer": "D",
    "explanation": "Organized crime may produce, sell, and support malware tools, or may deploy them themselves. Crypto malware and other packages are examples of tools often created and used by criminal syndicates. State actors are more likely to be associated with advanced persistent threats (APTs) aimed at accomplishing goals of the nation\u2010state that supports them. Hacktivists typically have political motivations, whereas unskilled attackers (script kiddies) may simply be in it for recognition or fun.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      16,
      12,
      25,
      19,
      15
    ],
    "source": "9781394211395"
  },
  {
    "id": 720,
    "question": "You have noticed that when in a crowded area, you sometimes get a stream of unwanted text messages. The messages end when you leave the area. What describes this attack?",
    "choice_a": "Bluejacking",
    "choice_b": "Bluesnarfing",
    "choice_c": "Evil twin",
    "choice_d": "Rogue access point",
    "correct_answer": "A",
    "explanation": "Bluejacking involves sending unsolicited messages to Bluetooth devices when they are in range. Bluesnarfing involves getting data from the Bluetooth device. An evil twin attack uses a rogue access point whose name is similar or identical to that of a legitimate access point.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      234,
      229,
      230,
      202,
      19
    ],
    "source": "9781394211395"
  },
  {
    "id": 721,
    "question": "Dennis uses an on\u2010path attack to cause a system to send traffic to his system and then forwards it to the actual server the traffic is intended for. What information will be visible from his system as it passed through it?",
    "choice_a": "All traffic meant for remote systems",
    "choice_b": "All traffic meant for local systems",
    "choice_c": "Only unencrypted traffic",
    "choice_d": "Only unencrypted traffic meant for his system",
    "correct_answer": "A",
    "explanation": "An on\u2010path attack redirects all traffic through an attacker's system that would normally pass through a network gateway. Dennis will be able to see all traffic bound for remote systems, but some of it may be encrypted.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      74,
      227,
      30,
      19,
      81
    ],
    "source": "9781394211395"
  },
  {
    "id": 722,
    "question": "Andrea recently received a phone call claiming to be from her bank. The caller asked for information including her account number and Social Security number to validate her identity. What type of social engineering attack was Andrea the target of?",
    "choice_a": "Smishing",
    "choice_b": "Brand impersonation",
    "choice_c": "A watering hole attack",
    "choice_d": "A business email compromise attack",
    "correct_answer": "B",
    "explanation": "When malicious actors claim to represent a company or organization to accomplish their goals, it is an example of a brand impersonation attack. Here, this is a combination of a vishing attack and a brand impersonation attack. Smishing occurs via SMS, watering hole attacks target sites that their intended victims commonly visit, and business email compromise attempts to gain access to or leverages email accounts.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      33,
      34,
      32,
      73,
      19
    ],
    "source": "9781394211395"
  },
  {
    "id": 723,
    "question": "Jake\u2019s vulnerability scanner reports that the software his organization is running is vulnerable to a cryptographic downgrade attack. What concern should Jake have about this potential issue?",
    "choice_a": "Attackers may be able to force use of a weaker encryption algorithm, making data easier to access.",
    "choice_b": "Attackers may be able to force use of weaker hashing, making it easier to recover passwords.",
    "choice_c": "Attackers may be able to force use of older versions of the software, including previously patched vulnerabilities.",
    "choice_d": "Attackers may be able to force encryption to be turned off, causing information to be sent in plain text.",
    "correct_answer": "A",
    "explanation": "Cryptographic downgrade attacks like POODLE, FREAK, and Logjam all rely on flaws that cause software to use weaker encryption options. This could allow attackers to capture traffic encrypted with weaker encryption, potentially allowing them to decrypt the traffic and read it. They do not allow hashing changes to recover passwords, reversion to old versions of software, or encryption to be entirely turned off.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      128,
      129,
      226,
      125,
      126
    ],
    "source": "9781394211395"
  },
  {
    "id": 724,
    "question": "Rick has three major categories of data and applications in use in his virtualization environment: highly sensitive; business sensitive; and unclassified, or public information. He wants to ensure that data and applications of different sensitivity are not compromised in the event of a breach. What mitigation technique is best suited to this type of requirement?",
    "choice_a": "Application allow lists",
    "choice_b": "Monitoring",
    "choice_c": "Least privilege",
    "choice_d": "Segmentation",
    "correct_answer": "D",
    "explanation": "Segmentation can be used to separate systems and applications of different sensitivity levels. A breach of one segmented group should not automatically mean that the other groupings are in immediate danger. Application allow lists control what applications can be installed but do not introduce separation between systems and applications. Monitoring would allow visibility but does not meet the goal Rick has. Least privilege is an effective practice to ensure only the rights required are in place, but again this does not meet the goal.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      203,
      183,
      83,
      29,
      27
    ],
    "source": "9781394211395"
  },
  {
    "id": 725,
    "question": "Users in your company report someone has been calling their extension and claiming to be doing a survey for a large vendor. Based on the questions asked in the survey, you suspect that this is a scam to elicit information from your company\u2019s employees. What best describes this?",
    "choice_a": "Spear phishing",
    "choice_b": "Vishing",
    "choice_c": "War dialing",
    "choice_d": "Robocalling",
    "correct_answer": "B",
    "explanation": "This is vishing, or using voice calls for phishing. Spear phishing is targeting a small, specific group. War dialing is dialing numbers hoping a computer modem answers. Robocalling is used to place unsolicited telemarketing calls.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      33,
      19,
      12,
      14,
      25
    ],
    "source": "9781394211395"
  },
  {
    "id": 726,
    "question": "As part of a zero\u2010trust environment, Quentin is given rights that he needs only when he needs them through a checkout process and they are then removed when he is done. What mitigation technique best describes this solution?",
    "choice_a": "Segmentation",
    "choice_b": "Isolation",
    "choice_c": "Least privilege",
    "choice_d": "Configuration enforcement",
    "correct_answer": "C",
    "explanation": "This is an example of a least privilege implementation where only the privileges required are issued. The checkout process is a modern addition to least privilege environments where even privileges needed are only issued temporarily, making least privilege even more secure. Segmentation and isolation are used to separate systems or environments, and configuration enforcement is used to ensure that configurations continue to be set as expected.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      183,
      79,
      245,
      202,
      203
    ],
    "source": "9781394211395"
  },
  {
    "id": 727,
    "question": "While performing a scan for wireless networks, Lisa discovers a network that does not use WPA\u20102 or WPA\u20103. What network traffic information can she recover from devices using this network?",
    "choice_a": "All network traffic",
    "choice_b": "Network packet headers, but not packet data",
    "choice_c": "Network packet data, but not headers",
    "choice_d": "DNS and DHCP queries, but not network packet data",
    "correct_answer": "A",
    "explanation": "An insecure, unencrypted, unprotected wireless network will have all of its traffic exposed. If the network is not using WPA\u20102 or WPA\u20103, it is trivial to observe network traffic even if an old protocol like WEP was in use.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      229,
      129,
      226,
      234,
      230
    ],
    "source": "9781394211395"
  },
  {
    "id": 728,
    "question": "Jared is responsible for network security at his company. He has discovered behavior on one computer that certainly appears to be a virus. He has even identified a file he thinks might be the virus. However, using three separate antivirus programs, he finds that none can detect the file. Which of the following is most likely to be occurring?",
    "choice_a": "The computer has a RAT.",
    "choice_b": "The computer has a zero\u2010day exploit.",
    "choice_c": "The computer has a worm.",
    "choice_d": "The computer has a rootkit.",
    "correct_answer": "B",
    "explanation": "Zero\u2010day exploits are new, and they are not in the virus definitions for the antivirus (AV) programs. This makes them difficult to detect, except by their behavior. Remote\u2010access Trojans (RATs), worms, and rootkits are more likely to be detected by AV programs.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      28,
      29,
      26,
      31,
      244
    ],
    "source": "9781394211395"
  },
  {
    "id": 729,
    "question": "John has discovered that an attacker is trying to get network passwords by using software that attempts a series of passwords with a minor change each time the password is tried. What type of attack is this?",
    "choice_a": "Dictionary",
    "choice_b": "Rainbow table",
    "choice_c": "Brute force",
    "choice_d": "Session hijacking",
    "correct_answer": "C",
    "explanation": "Brute force tries every possible combination with small changes each time. Dictionary attacks use a list of words that are believed to be likely passwords. A rainbow table is a precomputed table of hashes. Session hijacking is when the attacker takes over an authenticated session.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      37,
      73,
      38,
      125,
      39
    ],
    "source": "9781394211395"
  },
  {
    "id": 730,
    "question": "Far\u00e8s is the network security administrator for a company that creates advanced routers and switches. He has discovered that his company\u2019s networks have been subjected to a series of advanced attacks by an attacker sponsored by a government over a period of time. What best describes this attack?",
    "choice_a": "DDoS",
    "choice_b": "Brute force",
    "choice_c": "Nation\u2010state",
    "choice_d": "Disassociation attack",
    "correct_answer": "C",
    "explanation": "A nation\u2010state advanced persistent threat (APT) involves sophisticated (i.e., advanced) attacks over a period of time (i.e., persistent). A distributed denial\u2010of\u2010service (DDoS) could be a part of an APT, but in and of itself is unlikely to be an APT. Brute force attempts every possible random combination to get the password or encryption key. In a disassociation attack, the attacker attempts to force the victim into disassociating from a resource.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      16,
      12,
      29,
      27,
      245
    ],
    "source": "9781394211395"
  },
  {
    "id": 731,
    "question": "What type of information is phishing not commonly intended to acquire?",
    "choice_a": "Passwords",
    "choice_b": "Email addresses",
    "choice_c": "Credit card numbers",
    "choice_d": "Personal information",
    "correct_answer": "B",
    "explanation": "Phishing is not commonly used to acquire email addresses. Phishing emails target personal information and sensitive information like passwords and credit card numbers in most cases.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      33,
      34,
      19,
      73,
      12
    ],
    "source": "9781394211395"
  },
  {
    "id": 732,
    "question": "Scott discovers that malware has been installed on one of the systems he is responsible for. Shortly afterward passwords used by the user that the system is assigned to are discovered to be in use by attackers. What type of malicious program should Scott look for on the compromised system?",
    "choice_a": "A rootkit",
    "choice_b": "A keylogger",
    "choice_c": "A worm",
    "choice_d": "None of the above",
    "correct_answer": "B",
    "explanation": "A keylogger is a software or hardware tool used to capture keystrokes. Keyloggers are often used by attackers to capture credentials and other sensitive information. A rootkit is used to obtain and maintain administrative rights on a system, and a worm is a self\u2010spreading form of malware that frequently targets vulnerable services on a network to spread.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      30,
      29,
      27,
      31,
      25
    ],
    "source": "9781394211395"
  },
  {
    "id": 733,
    "question": "Nick purchases his network devices through a gray market supplier that imports them into his region without an official relationship with the network device manufacturer. What risk should Nick identify when he assesses his supply chain risk?",
    "choice_a": "Lack of vendor support",
    "choice_b": "Lack of warranty coverage",
    "choice_c": "Inability to validate the source of the devices",
    "choice_d": "All of the above",
    "correct_answer": "D",
    "explanation": "Acquisition via the gray market can lead to lack of vendor support, lack of warranty coverage, and the inability to validate where the devices came from. Nick should express concerns about the supply chain, and if his devices need to be from a trusted source or supplier with real support he may need to change his organization's acquisition practices.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      19,
      184,
      88,
      203,
      27
    ],
    "source": "9781394211395"
  },
  {
    "id": 734,
    "question": "Naomi is preparing a laptop for a traveling salesperson who frequently needs to connect to untrusted hotel networks. What hardening technique can she use to provide the greatest protection against network\u2010based attacks on untrusted networks?",
    "choice_a": "Install an endpoint detection and response tool.",
    "choice_b": "Install a host\u2010based firewall.",
    "choice_c": "Install an extended detection and response tool.",
    "choice_d": "Install a disk encryption tool.",
    "correct_answer": "B",
    "explanation": "A host\u2010based firewall is an excellent first line of defense for systems that will be deployed to untrusted networks. EDR and XDR are useful for preventing malicious software installs like ransomware, but they do not directly protect against network\u2010based attacks, and disk encryption is a confidentiality control, not a useful tool to prevent network\u2010based attacks.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      203,
      230,
      27,
      29,
      31
    ],
    "source": "9781394211395"
  },
  {
    "id": 735,
    "question": "While conducting a vulnerability scan of her network, Susan discovers that a marketing staff member has set up their own server running a specialized marketing tool. After inquiring about the server, which is vulnerable due to missing patches, Susan discovers that the team set it up themselves because of a need that was not met by existing tools. What type of threat actor has Susan encountered?",
    "choice_a": "An unskilled attacker",
    "choice_b": "An insider threat",
    "choice_c": "Shadow IT",
    "choice_d": "A hacktivist",
    "correct_answer": "C",
    "explanation": "The marketing team has created a shadow IT solution\u2014a solution put in place without central or formal IT support, typically done without IT's assistance or awareness. This creates a risk to the organization due to lack of support and may bring additional risks like licensing and compliance risks. The team did not intend to create an issue and is not actively working against the organization, meaning that they are not unskilled attackers, insider threats, or hacktivists.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      17,
      12,
      14,
      15,
      19
    ],
    "source": "9781394211395"
  },
  {
    "id": 736,
    "question": "Which of the following indicators is most commonly associated with a denial\u2010of\u2010service attack?",
    "choice_a": "Resource inaccessibility",
    "choice_b": "Impossible travel",
    "choice_c": "Missing logs",
    "choice_d": "Blocked content",
    "correct_answer": "A",
    "explanation": "Resource inaccessibility is a common symptom of a denial\u2010of\u2010service attack. Impossible travel is typically found in log events through correlation. Missing logs are frequently indicators of compromised accounts deleting logs, and blocked content is most likely due to reputation service usage.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      244,
      31,
      89,
      227,
      19
    ],
    "source": "9781394211395"
  },
  {
    "id": 737,
    "question": "Henry wants to decommission a server that was used to store sensitive data. What step should he take to ensure the decommissioning process protects the organization\u2019s data?",
    "choice_a": "Reformat the drives as part of the decommissioning process.",
    "choice_b": "Physically destroy the drives as part of the decommissioning process.",
    "choice_c": "Remove the system from organizational inventory as part of the decommissioning process.",
    "choice_d": "Physically destroy the entire system as part of the decommissioning process.",
    "correct_answer": "B",
    "explanation": "Since the drives stored sensitive data and no mention of encryption was made, the drives should be physically destroyed to ensure that no data leakage can occur. It is not necessary to destroy the entire system to ensure this. Reformatting drives does not wipe data, and simply removing the system from inventory is typically part of the process but does not protect organizational data.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      29,
      25,
      17,
      202,
      183
    ],
    "source": "9781394211395"
  },
  {
    "id": 738,
    "question": "Renee has a large number of workstations and servers in her corporate environment and wants to more effectively monitor logs for them. What solution from the following list is best suited to identifying and alerting on issues in a large\u2010scale environment?",
    "choice_a": "Centralized logging",
    "choice_b": "A SIEM",
    "choice_c": "An IPS",
    "choice_d": "An EDR",
    "correct_answer": "B",
    "explanation": "A security information and event management tool (SIEM) is designed to ingest and analyze large volumes of logs and then alert on issues and events. Centralized logging is useful but needs additional tools to alert on issues. An IPS is used to detect and potentially respond to network\u2010based attacks, not to gather and analyze logs, and EDR tools are useful for monitoring endpoints, not for large\u2010scale log ingestion and analysis.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      244,
      245,
      25,
      29,
      30
    ],
    "source": "9781394211395"
  },
  {
    "id": 739,
    "question": "Patrick is reviewing potential attack surfaces for his small business and recently deployed new networked printers for each of his three locations. What should his first action be to begin to properly secure their web management interfaces?",
    "choice_a": "Update the firmware.",
    "choice_b": "Change their default IP address.",
    "choice_c": "Change the default administrator password.",
    "choice_d": "Disable unnecessary services.",
    "correct_answer": "C",
    "explanation": "Patrick knows that the first thing he should do is change the administrator password. Any further security changes, including updating firmware and disabling unnecessary services, can be made once the administrative account has been properly secured. Changing the default IP address does not necessarily improve security for the device.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      203,
      183,
      88,
      73,
      37
    ],
    "source": "9781394211395"
  },
  {
    "id": 740,
    "question": "Paul has performed an nmap scan of a new network connected device. He notices TCP ports 22, 80, and 443 are open. If his hardening guidelines only allow encrypted management interfaces, what port or ports should he disable from this list?",
    "choice_a": "22",
    "choice_b": "80",
    "choice_c": "22 and 80",
    "choice_d": "80 and 443",
    "correct_answer": "B",
    "explanation": "Paul knows that SSH typically uses port 22, HTTP uses port 80, and HTTPS uses port 443. HTTP is the only unencrypted protocol from that list, and thus he should disable port 80.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      226,
      202,
      203,
      183,
      129
    ],
    "source": "9781394211395"
  },
  {
    "id": 741,
    "question": "The following graphic shows a network connection between two systems, and then a network\u2010based attack. What type of attack is shown? <img src=\"/question_assets/Security+/c02uf001.png\" alt=\"Two diagrams. Top: A laptop and a server is connected using communications traffic in two ways. Bottom: The attacker-controlled system connects the laptop and the server using communications traffic.\"/>\n\n<figcaption>Two diagrams. Top: A laptop and a server is connected using communications traffic in two ways. Bottom: The attacker-controlled system connects the laptop and the server using communications traffic.</figcaption>",
    "choice_a": "A denial\u2010of\u2010service attack",
    "choice_b": "A SQL injection attack",
    "choice_c": "An on\u2010path attack",
    "choice_d": "A directory traversal attack",
    "correct_answer": "C",
    "explanation": "An on\u2010path attack redirects traffic to allow an attacker to see and potentially modify the traffic as shown in the graphic. SQL injection is accomplished by inserting SQL into web queries or application traffic, denial\u2010of\u2010service will target a service and no indication of that is shown, and a directory traversal attack will typically show directory manipulation like <code>../../</code>.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      226,
      74,
      82,
      36,
      230
    ],
    "source": "9781394211395"
  },
  {
    "id": 742,
    "question": "Which of the following protocols is most commonly associated with credential relaying attacks?",
    "choice_a": "RDP",
    "choice_b": "NTLM",
    "choice_c": "SQL",
    "choice_d": "TLS",
    "correct_answer": "B",
    "explanation": "While dated, NTLM was historically one of the most common targets of credential relay attacks. RDP, SQL, and TLS are less commonly associated with credential relay attacks. Modern protocols implement encryption, session, IDs, and one\u2010time passwords to prevent this type of attack.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      226,
      128,
      74,
      88,
      183
    ],
    "source": "9781394211395"
  },
  {
    "id": 743,
    "question": "After a recent laptop theft, Jaime\u2019s organization is worried about data breaches driven by lost devices. What endpoint hardening technique is best suited to preventing this?",
    "choice_a": "Encryption",
    "choice_b": "Host\u2010based IPS",
    "choice_c": "Disabling ports and protocols",
    "choice_d": "Changing default passwords",
    "correct_answer": "A",
    "explanation": "Encryption is the appropriate solution to prevent data loss if a system is stolen. A HIPS, disabling ports and protocols, and changing default passwords will not prevent data acquisition from a drive.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      67,
      129,
      39,
      183,
      184
    ],
    "source": "9781394211395"
  },
  {
    "id": 744,
    "question": "Derek wants to conduct a birthday attack against a digital signature. Which of the following best describes the process he would need to take to achieve his goal?",
    "choice_a": "He needs to prepare both a correct and a malicious document and find ways to modify the correct document until its encryption matches the malicious document.",
    "choice_b": "He needs to make sure all dates match in both a correct and a malicious document.",
    "choice_c": "He needs to ensure that the file length and creation date match for both a correct document and a malicious document.",
    "choice_d": "He needs to prepare both a correct and a malicious document, then find ways to modify the malicious document until its hash matches the hash of the correct document.",
    "correct_answer": "D",
    "explanation": "Derek knows that attacking a digital signature requires that hashes match for both an original document and a malicious document. He will modify the malicious document until he finds a way to convey the changes he needs while retaining the matching hash. This type of attack is why hashing algorithms needs to be resistant to birthday attacks.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      127,
      128,
      38,
      39,
      125
    ],
    "source": "9781394211395"
  },
  {
    "id": 745,
    "question": "Ashley\u2019s organization has recently come under attack and has suffered a DNS outage. As she investigated, she found that requests to her DNS servers were sent to open DNS resolvers using spoofed IP addresses with requests that would result in very large responses from the DNS resolvers to the IP addresses that appeared to be making the request. What type of attack targeted Ashley\u2019s organization?",
    "choice_a": "A reflected DDoS",
    "choice_b": "A DNS flood",
    "choice_c": "A mirrored DDoS",
    "choice_d": "A supersized query attack",
    "correct_answer": "A",
    "explanation": "Ashley's organization was the target of a reflected (and amplified) DDoS where attackers took advantage of DNS queries to make small amounts of spoofed traffic into very large amounts of data sent to her servers. DNS floods, mirrored DDoSs, and supersized query attacks were made up for this question.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      228,
      227,
      244,
      245,
      19
    ],
    "source": "9781394211395"
  },
  {
    "id": 746,
    "question": "What term is used to describe the problem when two files have the same hash?",
    "choice_a": "A birthday attack",
    "choice_b": "A collision",
    "choice_c": "A bingo",
    "choice_d": "A match\u2010the\u2010hash attack",
    "correct_answer": "B",
    "explanation": "Collisions occur when two files have the same hash. Secure hashing solutions are collision resistant, meaning that collision\u2010based hash attacks should be unlikely unless an insecure or outdated hash algorithm like MD5 is selected. Birthday attacks leverage the likelihood of collisions in a random set of attacks rather than by progressing linearly through the solution set. Bingo attacks and match\u2010the\u2010hash are both made up for this question.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      127,
      128,
      37,
      38,
      39
    ],
    "source": "9781394211395"
  },
  {
    "id": 747,
    "question": "Kara wants to protect against the most common means of firmware\u2010based exploits. Which of the following is not a common firmware defense mechanism for the vendors of devices that use firmware?",
    "choice_a": "Using signed firmware updates",
    "choice_b": "Using input validation for user input",
    "choice_c": "Encrypting firmware",
    "choice_d": "Code review processes for firmware",
    "correct_answer": "C",
    "explanation": "Firmware is typically not encrypted, but it is commonly digitally signed. Using input validation and code review both help to keep firmware secure.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      184,
      69,
      83,
      202,
      88
    ],
    "source": "9781394211395"
  },
  {
    "id": 748,
    "question": "Annie\u2019s organization has been facing negative social media campaigns for months and is struggling to address them. Numerous bot posts about the company are providing incorrect information about the company. What type of attack is Annie\u2019s company facing?",
    "choice_a": "A misinformation campaign",
    "choice_b": "A pretexting campaign",
    "choice_c": "An impersonation campaign",
    "choice_d": "A disinformation campaign",
    "correct_answer": "D",
    "explanation": "Annie's company is facing a disinformation campaign. If users were simply getting facts wrong, this would be misinformation, but since bots are intentionally misstating information, it is disinformation. Pretexting would attempt to exploit human behaviors to explain why something needed to occur or why an attacker was asking for something. Impersonation occurs when an attacker pretends to be someone they are not.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      35,
      34,
      32,
      31,
      19
    ],
    "source": "9781394211395"
  },
  {
    "id": 749,
    "question": "Ines is concerned about messaging through tools like Discord and Slack as attack vectors. What can she do to most effectively limit the attack surface for threats like this?",
    "choice_a": "Deploy EDR tools to all workstations and devices.",
    "choice_b": "Deploy an organizational communication tool or instance instead of using public tools.",
    "choice_c": "Deploy messaging\u2010aware firewalls.",
    "choice_d": "Deploy messaging\u2010aware IPS systems.",
    "correct_answer": "B",
    "explanation": "In many cases, the best option to limit the attack surface of messaging applications is to use a trusted, internally managed organizational instance rather than public tools or instances. EDR, firewalls, and IPS are not as effective with messaging\u2010based attacks.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      19,
      203,
      34,
      32,
      82
    ],
    "source": "9781394211395"
  },
  {
    "id": 750,
    "question": "Ana\u2019s vendor has informed her that the hardware her organization uses is considered end\u2010of\u2010life. What should Ana do?",
    "choice_a": "Identify replacement hardware and purchase it immediately.",
    "choice_b": "Purchase an extended support contract from a third\u2010party vendor.",
    "choice_c": "Begin plans to phase out the equipment before it reaches end\u2010of\u2010support.",
    "choice_d": "Install final patches and then isolate the hardware from the network.",
    "correct_answer": "C",
    "explanation": "End\u2010of\u2010life announcements typically mean that the equipment is no longer being produced or sold. The equipment will typically have a longer supported life, so Ana can continue to use it but should plan for what to do when end\u2010of\u2010support occurs. At that time, replacing it, isolating it, or purchasing third\u2010party support are all possible solutions depending on Ana's needs.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      184,
      202,
      25,
      244,
      183
    ],
    "source": "9781394211395"
  },
  {
    "id": 751,
    "question": "What threat vector is most impacted by how Windows handles <code>autorun.inf</code> files?",
    "choice_a": "Removable devices",
    "choice_b": "Open service ports",
    "choice_c": "Unsecure Wi\u2010Fi",
    "choice_d": "Watering hole attacks",
    "correct_answer": "A",
    "explanation": "Removable devices like USB thumb drives, digital picture frames, and even keyboards and mice with onboard storage rely on <code>autorun.inf</code> files to automatically run software they provide. While that functionality typically focuses on printing, opening folders, or running media players, it can also be leveraged to automatically run malware. For this reason, many organizations ban removable drives or prohibit autorun from working. Open service ports are commonly associated with applications and services, and autorun doesn't set up or run these, nor does it impact Wi\u2010Fi. Watering hole attacks require attackers to compromise or gain access to a site that targets commonly visit so that they deliver malware to their targets.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      27,
      19,
      25,
      28,
      31
    ],
    "source": "9781394211395"
  },
  {
    "id": 752,
    "question": "Raj wants to reduce the attack surface for a newly purchased laptop. What hardening technique will help him reduce the possibility of remote exploits while also decreasing the amount of ongoing patch management he needs to do for the system?",
    "choice_a": "Encrypt the system\u2019s boot drive.",
    "choice_b": "Install EDR software.",
    "choice_c": "Remove unnecessary software.",
    "choice_d": "Change any default passwords.",
    "correct_answer": "C",
    "explanation": "Raj knows that removing unnecessary software reduces a system's attack surface and also means that he won't have to patch and maintain the software he removes. Encrypting a drive, installing EDR, and changing default passwords won't reduce patch management, but EDR and changing default passwords could help with remote exploit prevention.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      183,
      200,
      202,
      88,
      26
    ],
    "source": "9781394211395"
  },
  {
    "id": 753,
    "question": "Mary has discovered that a web application used by her company does not always handle multithreading properly, particularly when multiple threads access the same variable. This could allow an attacker who discovered this vulnerability to exploit it and crash the server. What type of error has Mary discovered?",
    "choice_a": "Buffer overflow",
    "choice_b": "Logic bomb",
    "choice_c": "Race conditions",
    "choice_d": "Improper error handling",
    "correct_answer": "C",
    "explanation": "A race condition can occur when multiple threads in an application are using the same variable and the situation is not properly handled. A buffer overflow is attempting to put more data in a buffer than it is designed to hold. A logic bomb is malware that performs its misdeed when some logical condition is met. As the name suggests, improper error handling is the lack of adequate or appropriate error handling mechanisms within software.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      90,
      89,
      67,
      69,
      84
    ],
    "source": "9781394211395"
  },
  {
    "id": 754,
    "question": "Allan wants to detect brute\u2010force physical attacks. What should he do if he wants to detect the broadest range of physical attacks?",
    "choice_a": "Deploy a monitored security camera system.",
    "choice_b": "Hire a guard to patrol the facility.",
    "choice_c": "Conduct regular inspections of the facility.",
    "choice_d": "Set up an alarm system.",
    "correct_answer": "A",
    "explanation": "A monitored camera system will detect the broadest range of attacks. Guards will only detect brute\u2010force attacks when they are in the area, and cameras can cover more spaces at once. Inspections may miss attacks where camera recordings and monitoring can show failed and successful attacks. An alarm system won't detect attacks by insiders, who may access spaces they have access to in order to perform malicious actions.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      167,
      203,
      12,
      17,
      19
    ],
    "source": "9781394211395"
  },
  {
    "id": 755,
    "question": "Which of the following is not a common threat vector associated with SMS\u2010based attacks?",
    "choice_a": "Malicious links",
    "choice_b": "SMS\u2010based phishing",
    "choice_c": "SMS\u2010delivered images",
    "choice_d": "MFA exploits",
    "correct_answer": "C",
    "explanation": "Images are not a common threat vector via SMS. Malicious links, phishing via text, and multifactor authentication (MFA) exploits, including sending MFA notices until the recipient approves an MFA request, are all common SMS\u2010related threat vectors.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      33,
      19,
      39,
      25,
      73
    ],
    "source": "9781394211395"
  },
  {
    "id": 756,
    "question": "During a regular review of logs, Jennifer notices that a regularly scheduled script that copies files to another server every hour has run multiple times within the last hour. What indicator of compromise should she categorize this as?",
    "choice_a": "Concurrent session use",
    "choice_b": "Out\u2010of\u2010cycle logging",
    "choice_c": "Missing logs",
    "choice_d": "Impossible travel",
    "correct_answer": "B",
    "explanation": "Jennifer should note this as out\u2010of\u2010cycle logging. It could simply indicate a flaw in the script or another innocuous issue, or it could indicate an attacker exploring scripts to identify what information can be obtained. Concurrent session use occurs when a session is in use from multiple browsers or systems, missing logs are when logs are entirely missing or empty rather than occurring with more frequency than expected, and impossible travel occurs when events or logins occur from different locations by the same user who could not have traveled that distance in the time between the events.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      244,
      17,
      12,
      30,
      221
    ],
    "source": "9781394211395"
  },
  {
    "id": 757,
    "question": "Pete uses a technique that injects code into memory used by another process to allow him to control what the host program does. What is this technique called for Windows dynamically linked libraries?",
    "choice_a": "WinBuff attacks",
    "choice_b": "DLL injection",
    "choice_c": "A SYRINGE attack",
    "choice_d": "A memory traversal attack",
    "correct_answer": "B",
    "explanation": "DLL injection forces a process to load and run code from a dynamically linked library (DLL) that was not originally used by the application or software. This can be used to modify behaviors of the program or to perform malicious actions through the application. WinBuff, SYRINGE, and memory traversal were all made up for this question.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      71,
      72,
      78,
      82,
      89
    ],
    "source": "9781394211395"
  },
  {
    "id": 758,
    "question": "Kathleen wants to control network traffic between subnets using her Cisco network devices. What built\u2010in capability can she use to allow or deny traffic based on port, protocol, and IP address?",
    "choice_a": "A HIPS",
    "choice_b": "ACLs",
    "choice_c": "Least privilege lists",
    "choice_d": "VLANs",
    "correct_answer": "B",
    "explanation": "Access control lists (ACLs) allow or deny traffic based on rules that include protocol, IP addresses, ports, and other details. They do not understand packet content and simply assess traffic based on these basic rules. A HIPS is a host\u2010based intrusion prevention system and is not installed between subnets. Least privilege is a concept, not an application or security tool, and VLANs are used to segment traffic but do not themselves control traffic this way. Instead, VLANs are often combined with ACLs to control network traffic and ensure segmentation.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      203,
      228,
      226,
      83,
      221
    ],
    "source": "9781394211395"
  },
  {
    "id": 759,
    "question": "What is the primary purpose of encryption as a control in enterprise environments?",
    "choice_a": "To preserve availability",
    "choice_b": "To support physical security",
    "choice_c": "To preserve least privilege",
    "choice_d": "To preserve confidentiality",
    "correct_answer": "D",
    "explanation": "Encryption is used to preserve confidentiality. Availability controls work to ensure that assets remain accessible and usable, and encryption can actually work against this in some circumstances, such as if a key is lost or the encrypted file becomes corrupted. Encryption is not used directly to preserve least privilege, nor does it preserve physical security.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      67,
      129,
      226,
      125,
      126
    ],
    "source": "9781394211395"
  },
  {
    "id": 760,
    "question": "What type of attack exploits the trust that a website has for an authenticated user to attack that website by spoofing requests from the trusted user?",
    "choice_a": "Cross\u2010site scripting",
    "choice_b": "Cross\u2010site request forgery",
    "choice_c": "Bluejacking",
    "choice_d": "Evil twin",
    "correct_answer": "B",
    "explanation": "Cross\u2010site request forgery (XSRF or CSRF) sends fake requests to a website that purport to be from a trusted, authenticated user. Cross\u2010site scripting (XSS) exploits the trust the user has for the website and embeds scripts into that website. Bluejacking is a Bluetooth attack. Nothing in this scenario requires or describes an evil twin, which is an attack that uses a malicious access point that duplicates a legitimate AP.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      81,
      82,
      230,
      234,
      83
    ],
    "source": "9781394211395"
  },
  {
    "id": 761,
    "question": "Dana wants to use documented and published IoCs as part of her threat\u2010hunting activities. What should she look for to integrate with her SIEM or other security tools?",
    "choice_a": "Threat feeds",
    "choice_b": "A real\u2010time blackhole list",
    "choice_c": "A vulnerability feed",
    "choice_d": "An IP reputation feed",
    "correct_answer": "A",
    "explanation": "Both commercial and private threat feeds can be used by security tools like SIEM, EDR, and XDR systems to provide them with current information about indicators of compromise. A real\u2010time blackhole list (RBL) and an IP reputation feed are examples of specific threat feeds but are not as broad as threat feeds. Vulnerability definitions are typically integrated with vulnerability scanners, but again are a narrower option than a threat feed.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      24,
      244,
      25,
      26,
      30
    ],
    "source": "9781394211395"
  },
  {
    "id": 762,
    "question": "The malware that Joseph is working to counter has copied itself to workstations across his environment due to a central, shared fileshare. What type of malware is Joseph most likely fighting?",
    "choice_a": "A Trojan",
    "choice_b": "A virus",
    "choice_c": "A keylogger",
    "choice_d": "A rootkit",
    "correct_answer": "B",
    "explanation": "Joseph is most likely fighting a virus, which is capable of copying itself to new locations. A Trojan is malware that is disguised to look like desirable software, a keylogger captures keystrokes, and a rootkit is intended to allow attackers to retain access to compromised systems.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      28,
      27,
      26,
      29,
      25
    ],
    "source": "9781394211395"
  },
  {
    "id": 763,
    "question": "You are responsible for software testing at Acme Corporation. You want to check all software for bugs that might be used by an attacker to gain entrance into the software or your network. You have discovered a web application that would allow a user to attempt to put a 64\u2010bit value into a 4\u2010byte integer variable. What is this type of flaw?",
    "choice_a": "Memory overflow",
    "choice_b": "Buffer overflow",
    "choice_c": "Variable overflow",
    "choice_d": "Integer overflow",
    "correct_answer": "D",
    "explanation": "Placing a larger integer value into a smaller integer variable is an integer overflow. Memory overflow is not a term used, and memory leak is about allocating memory and not deallocating it. Buffer overflows often involve arrays. Variable overflow is not a term used in the industry.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      89,
      69,
      83,
      72,
      88
    ],
    "source": "9781394211395"
  },
  {
    "id": 764,
    "question": "The company that Keith works for uses a backoff algorithm that increases the time between when login attempts are allowed after each failed login. Keith has recently attempted to log in and found that his account is not able to log in again for 15 minutes. What should the security administrators at Keith\u2019s organization do to find potential indicators of malicious activity?",
    "choice_a": "Review authentication logs.",
    "choice_b": "Interview Keith about his recent logins.",
    "choice_c": "Change Keith\u2019s password and check error logs.",
    "choice_d": "Report an incident and start the incident response process.",
    "correct_answer": "A",
    "explanation": "Until more is known, the best route for security administrators is to review the authentication logs in order to gather more information that can indicate whether an issue or security event has occurred. While Keith didn't indicate that he had failed login attempts, it's possible another user mistyped a user ID or that something else happened. Interviewing Keith might help but would provide less information if something malicious or accidental is happening, and the interview process would delay that analysis. Changing his password isn't immediately necessary as failed logins increase the time, not successful logins. Without more information, starting the incident response (IR) process may not be appropriate. If it can be shown that an attack occurred and was successful, the IR process should be started.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      244,
      245,
      37,
      38,
      73
    ],
    "source": "9781394211395"
  },
  {
    "id": 765,
    "question": "Grayson\u2019s organization is concerned about environmental attacks against their datacenter. What type of monitoring is best suited to detecting environmental attacks in a scenario like this?",
    "choice_a": "Video cameras",
    "choice_b": "Intrusion alarm systems",
    "choice_c": "Temperature monitoring sensors",
    "choice_d": "Log analysis",
    "correct_answer": "C",
    "explanation": "Environmental monitoring involves things like temperature, water or flood sensors, and other detection capabilities that help organizations know if a natural disaster or other environmental issue has occurred. Video cameras cannot detect many of these and are not typically deployed to places where they would detect things like under\u2010floor leaks or floods. Intrusion alarm systems do not provide this type of detection, and log analysis would require environmental monitoring sensors.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      167,
      203,
      202,
      200,
      221
    ],
    "source": "9781394211395"
  },
  {
    "id": 766,
    "question": "Jack\u2019s team in HR is paying for an SaaS tool using their HR expense account credit cards without the knowledge of central IT. What type of threat actor does this make Jack\u2019s HR team?",
    "choice_a": "Shadow IT",
    "choice_b": "An inadvertent threat",
    "choice_c": "Internal espionage actors",
    "choice_d": "An insider threat",
    "correct_answer": "A",
    "explanation": "Jack's team has created a shadow IT scenario by purchasing and using software without the awareness or engagement of central IT. They may be an inadvertent threat, but the term is not used to describe threat actors. They're not an intentional threat, and thus aren't an insider threat, and internal espionage actors is not a term used for the Security+ exam.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      17,
      12,
      19,
      13,
      15
    ],
    "source": "9781394211395"
  },
  {
    "id": 767,
    "question": "Amanda is assessing the potential for issues with her organization\u2019s recently adopted IaaS vendor. What cloud vulnerability should she worry about if her system administrators do not effectively manage security groups in AWS?",
    "choice_a": "Insecure APIs",
    "choice_b": "Misconfigurations",
    "choice_c": "Malicious insiders",
    "choice_d": "MFA\u2010based attacks",
    "correct_answer": "B",
    "explanation": "Security groups are used like firewall rules in Amazon Web Services (AWS), and since Amanda's system administrators are not effectively managing security groups, this is most likely to create a misconfiguration issue. Application programming interfaces (APIs) are provided by the vendor, and thus their security is typically a vendor issue or a misconfiguration issue. Malicious insiders are not mentioned, and security group misconfiguration does not drive multifactor authentication (MFA)\u2010based attacks.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      183,
      68,
      82,
      84,
      202
    ],
    "source": "9781394211395"
  },
  {
    "id": 768,
    "question": "Jared\u2019s organization runs Linux servers, and recent vulnerability scans show that the servers are vulnerable to an issue that is described as follows: <br> <code>CVE-2018-5703: tcp_v6_syn_recv_sock function in net/ipv6/tcp_ipv6.c in </code> <br> <code>the Linux kernel through 4.14.11 allows attackers to cause a denial of </code> <br> <code>service (slab out-of-bounds write)</code> <br>What is Jared\u2019s best option to remediate a kernel vulnerability like this?",
    "choice_a": "Patch the application.",
    "choice_b": "Install a HIPS with appropriate rules.",
    "choice_c": "Segment the systems away from the Internet to reduce risk.",
    "choice_d": "Patch the operating system.",
    "correct_answer": "D",
    "explanation": "The Linux kernel is part of the operating system and needs to be handled with an OS patch. There is no application to patch, installing a HIPS might help, but the issue is dated 2018, meaning that a patch likely exists. If there wasn't a patch and this was a new vulnerability, segmentation might be a useful immediate response to reduce risk.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      183,
      79,
      202,
      203,
      245
    ],
    "source": "9781394211395"
  },
  {
    "id": 769,
    "question": "What is the likely outcome of a cryptographic collision attack?",
    "choice_a": "Attackers can decrypt a file without the private key.",
    "choice_b": "Two files that have the same encrypted output but are different files.",
    "choice_c": "Two files that both have the same hash but have different contents.",
    "choice_d": "Attackers can decrypt the file without the public key.",
    "correct_answer": "C",
    "explanation": "Collision attacks target hashes and attempt to produce a file that results in the same hash algorithm output but with different content that they can control.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      127,
      128,
      126,
      38,
      39
    ],
    "source": "9781394211395"
  },
  {
    "id": 770,
    "question": "Sarah is working with a small business and noticed that they have a consumer\u2010grade wireless router serving their business. What common hardening checklist item should she validate first as part of securing the device?",
    "choice_a": "Removing unnecessary software",
    "choice_b": "Running a vulnerability scan",
    "choice_c": "Ensuring the default password has been changed",
    "choice_d": "Ensuring that unneeded ports have been disabled",
    "correct_answer": "C",
    "explanation": "The first step in securing a consumer\u2010grade router is to change the default password. Once that has been completed, updating the firmware, turning off unneeded services, and running a vulnerability scan are all common steps. Routers typically do not have unnecessary software running.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      183,
      73,
      88,
      202,
      229
    ],
    "source": "9781394211395"
  },
  {
    "id": 771,
    "question": "What technique most effectively prevents resource reuse concerns for storage in a virtual environment?",
    "choice_a": "Firmware updates",
    "choice_b": "Volume encryption",
    "choice_c": "Minimizing cluster size",
    "choice_d": "Reformatting drives",
    "correct_answer": "B",
    "explanation": "Ensuring that any volume that is used in a virtual environment is encrypted when created will prevent reuse concerns because data will be unrecoverable even if encrypted data was accessible when drive space was reallocated. Firmware updates, cluster sizes, and reformatting do not properly address this issue.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      25,
      89,
      200,
      202,
      244
    ],
    "source": "9781394211395"
  },
  {
    "id": 772,
    "question": "Michelle is modeling threat actor motivation for her organization and wants to describe ransomware actors. What motivation is not commonly associated with ransomware?",
    "choice_a": "Data exfiltration",
    "choice_b": "Blackmail",
    "choice_c": "Revenge",
    "choice_d": "Financial gain",
    "correct_answer": "C",
    "explanation": "Data exfiltration, blackmail, and financial gain are all common motivations for ransomware actors. Revenge is not a common ransomware actor motivation.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      19,
      12,
      25,
      16,
      18
    ],
    "source": "9781394211395"
  },
  {
    "id": 773,
    "question": "Which of the following is commonly used in a distributed denial\u2010of\u2010service (DDoS) attack?",
    "choice_a": "Phishing",
    "choice_b": "Adware",
    "choice_c": "Botnet",
    "choice_d": "Trojan",
    "correct_answer": "C",
    "explanation": "Botnets are often used to launch DDoS attacks, with the attack coming from all the computers in the botnet simultaneously. Phishing attacks attempt to get the user to give up information, click on a link, or open an attachment. Adware consists of unwanted pop\u2010up ads. A Trojan horse attaches malware to a legitimate program.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      31,
      228,
      19,
      26,
      27
    ],
    "source": "9781394211395"
  },
  {
    "id": 774,
    "question": "Amanda discovers that a member of her organization\u2019s staff has installed a remote\u2010access Trojan on their accounting software server and has been accessing it remotely. What type of threat has she discovered?",
    "choice_a": "Zero\u2010day",
    "choice_b": "Insider threat",
    "choice_c": "Misconfiguration",
    "choice_d": "Weak encryption",
    "correct_answer": "B",
    "explanation": "Amanda has discovered an insider threat. Insider threats can be difficult to discover, as a malicious administrator or other privileged user will often have the ability to conceal their actions or may actually be the person tasked with hunting for threats like this! This is not a zero\u2010day attack\u2014no vulnerability was mentioned, there was no misconfiguration since this was an intentional action, and encryption is not mentioned or discussed.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      17,
      26,
      12,
      18,
      244
    ],
    "source": "9781394211395"
  },
  {
    "id": 775,
    "question": "Postings from Russian agents during the 2016 U.S. presidential campaign to Facebook and Twitter are an example of what type of effort?",
    "choice_a": "Impersonation",
    "choice_b": "Disinformation",
    "choice_c": "Asymmetric warfare",
    "choice_d": "A watering hole attack",
    "correct_answer": "B",
    "explanation": "Disinformation campaigns seek to achieve the goals of the attacker or owner of the campaign. They leverage social media using bots and groups of posters to support the ideas, concepts, or beliefs that align with the goals of the campaign. Impersonation is a type of social engineering attack where the attacker pretends to be someone else. A watering hole attack places malware or malicious code on a site or sites that are frequently visited by a targeted group. Asymmetric warfare is warfare between groups with significantly different power or capabilities.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      35,
      34,
      31,
      19,
      15
    ],
    "source": "9781394211395"
  },
  {
    "id": 776,
    "question": "Which of the following threat actors is most likely to be associated with an advanced persistent threat (APT)?",
    "choice_a": "Hacktivists",
    "choice_b": "Nation\u2010state actors",
    "choice_c": "Unskilled attacker",
    "choice_d": "Insider threats",
    "correct_answer": "B",
    "explanation": "Nation\u2010state actors often have greater resources and skills, making them a more significant threat and far more likely to be associated with an advanced persistent threat actor. Unskilled attackers, also known as script kiddies, hacktivists, and insider threats, tend to be less capable and are all far less likely to be associated with an APT.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      16,
      12,
      15,
      14,
      17
    ],
    "source": "9781394211395"
  },
  {
    "id": 777,
    "question": "Erica wants to conduct an amplified DDoS attack against a system. What key step is required as part of her attack?",
    "choice_a": "Reversing the target\u2019s IP address",
    "choice_b": "Spoofing the target\u2019s IP address",
    "choice_c": "Conducting an on\u2010path attack to send traffic to the target",
    "choice_d": "Spoofing responses from the amplification system to the target",
    "correct_answer": "B",
    "explanation": "Amplification attacks typically use spoofed User Datagram Protocol (UDP) queries sent to servers to increase the volume of traffic sent in response to the target. Erica's process might involve identifying large DNS responses she can get with a small query, then spoofing a target system's IP address in the packets she sends to DNS servers. They would then respond with the large responses, amplifying her requests and creating a distributed denial\u2010of\u2010service attack by using many servers to amplify her traffic. This doesn't require reversing an IP address, conducting an on\u2010path attack, or spoofing the responses from the servers.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      228,
      227,
      19,
      31,
      82
    ],
    "source": "9781394211395"
  },
  {
    "id": 778,
    "question": "Daryl is investigating a recent breach of his company\u2019s web server. The attacker used sophisticated techniques and then defaced the website, leaving messages that were denouncing the company\u2019s public policies. He and his team are trying to determine the type of actor who most likely committed the breach. Based on the information provided, who was the most likely threat actor?",
    "choice_a": "A script",
    "choice_b": "A nation\u2010state",
    "choice_c": "Organized crime",
    "choice_d": "Hacktivists",
    "correct_answer": "D",
    "explanation": "The fact that the website is defaced in a manner related to the company's public indicates that the attackers were most likely engaging in hacktivism to make a political or belief\u2010based point. Scripts, nation\u2010state actors, and organized crime actors don't account for the statements adverse to the company's policies, which is why hacktivism is the real cause.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      15,
      12,
      19,
      16,
      14
    ],
    "source": "9781394211395"
  },
  {
    "id": 779,
    "question": "Which of the following human vectors are most likely to be part of a voice call\u2010based attack?",
    "choice_a": "A watering hole attack",
    "choice_b": "Pretexting",
    "choice_c": "Disinformation",
    "choice_d": "BEC",
    "correct_answer": "B",
    "explanation": "Pretexting and impersonation are common elements in voice call\u2013based attacks. Watering hole attacks leverage commonly visited websites, disinformation is when incorrect information is intentionally provided to change public opinion and could be part of a voice campaign but is not the most common element, and business email compromise (BEC) requires an email to be used, not a voice call.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      33,
      32,
      34,
      35,
      36
    ],
    "source": "9781394211395"
  },
  {
    "id": 780,
    "question": "What is the primary difference in threat vectors between agent client\u2010based and agentless software deployments?",
    "choice_a": "Agentless software does not consume resources and thus cannot result in a resource consumption\u2010based denial\u2010of\u2010service condition.",
    "choice_b": "Client\u2010based software provides a better view of system resources and is able to manage its resource consumption better to avoid issues.",
    "choice_c": "Agentless software does not have an agent that may be potentially vulnerable to attack.",
    "choice_d": "Client\u2010based software allows for greater security because it can be patched.",
    "correct_answer": "C",
    "explanation": "Agentless software does not have an agent installed that can be targeted. That means that the server or control system is the only target for attackers. Agentless software can still consume resources as queries and actions are taken by the server or control plane. Client\u2010based software often has better insights into systems, and may offer additional security features if it is a security tool. Client\u2010based software and agentless software can both be patched to address security issues.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      19,
      202,
      88,
      82,
      183
    ],
    "source": "9781394211395"
  },
  {
    "id": 781,
    "question": "Angela reviews the authentication logs for her website and sees attempts from many different accounts using the same set of passwords. What is this attack technique called?",
    "choice_a": "Brute forcing",
    "choice_b": "Password spraying",
    "choice_c": "Limited login attacks",
    "choice_d": "Account spinning",
    "correct_answer": "B",
    "explanation": "Password spraying is a specific type of brute\u2010force attack that uses a smaller list of common passwords for many accounts to attempt to log in. Although brute forcing is technically correct, the best match here is password spraying. When you encounter questions like this on the exam, make sure you provide the most accurate answer, rather than one that fits but that may not be the best answer. Limited login attacks is a made\u2010up answer, and spinning an account refers to changing the password for an account, often because of a compromise or to prevent a user from logging back into it while preserving the account.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      37,
      73,
      38,
      244,
      125
    ],
    "source": "9781394211395"
  },
  {
    "id": 782,
    "question": "Charles discovers that an attacker has used a vulnerability in a web application that his company runs and has then used that exploit to obtain root privileges on the web server. What type of attack has he discovered?",
    "choice_a": "Cross\u2010site scripting",
    "choice_b": "Privilege escalation",
    "choice_c": "A SQL injection",
    "choice_d": "A race condition",
    "correct_answer": "B",
    "explanation": "A privilege escalation attack can occur horizontally, where attackers obtain similar levels of privilege but for other users, or vertically where they obtain more advanced rights. In this case, Charles has discovered a vertical privilege escalation attack that has allowed the attacker to obtain administrative rights. Cross\u2010site scripting and SQL injection are both common types of web application attacks, and a race condition occurs when data can be changed between when it is checked and when it is used.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      79,
      80,
      70,
      90,
      82
    ],
    "source": "9781394211395"
  },
  {
    "id": 783,
    "question": "Which of the following best describes a zero\u2010day vulnerability?",
    "choice_a": "A vulnerability that the vendor is not yet aware of",
    "choice_b": "A vulnerability that has not yet been breached",
    "choice_c": "A vulnerability that can be quickly exploited (i.e., in zero days)",
    "choice_d": "A vulnerability that will give the attacker brief access (i.e., zero days)",
    "correct_answer": "A",
    "explanation": "A zero\u2010day exploit or attack occurs before the vendor has knowledge of it. The remainder of the answers don't accurately describe a zero\u2010day attack\u2014just because it has not yet been breached does not make it a zero\u2010day, nor is a zero\u2010day necessarily quickly exploitable. Finally, a zero\u2010day attack does not specify how long the attacker may have access.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      19,
      12,
      244,
      183,
      24
    ],
    "source": "9781394211395"
  },
  {
    "id": 784,
    "question": "You have discovered that there are entries in your network\u2019s domain name server that point legitimate domains to unknown and potentially harmful IP addresses. What best describes this type of attack?",
    "choice_a": "A backdoor",
    "choice_b": "An APT",
    "choice_c": "DNS poisoning",
    "choice_d": "A Trojan horse",
    "correct_answer": "C",
    "explanation": "DNS poisoning occurs when false DNS information is inserted into legitimate DNS servers, resulting in traffic being redirected to unwanted or malicious sites. A backdoor provides access to the system by circumventing normal authentication. An APT is an advanced persistent threat. A Trojan horse ties a malicious program to a legitimate program.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      227,
      36,
      26,
      29,
      16
    ],
    "source": "9781394211395"
  },
  {
    "id": 785,
    "question": "What technique drives image\u2010based threat vectors?",
    "choice_a": "Encryption",
    "choice_b": "Hashing",
    "choice_c": "Forgery",
    "choice_d": "Steganography",
    "correct_answer": "D",
    "explanation": "Images can have data, including malware or exfiltrated organizational information using a technique called steganography that embeds data into images without losing the integrity of the image. Encryption, hashing, and forgery are not the direct driver of image\u2010based threat vectors, although encryption is likely to be used as an additional layer to protect data from more advanced threat actors wishing to conceal what they are hiding.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      19,
      30,
      25,
      31,
      29
    ],
    "source": "9781394211395"
  },
  {
    "id": 786,
    "question": "Eric is conducting a penetration test and wants to release a malicious update for an organization\u2019s application. The organization uses public key encryption to sign updates. What does Eric need to deliver an update that systems will accept?",
    "choice_a": "The private key for the signing certificate",
    "choice_b": "A collision with the hashed value of a legitimate update",
    "choice_c": "The public key for the signing certificate",
    "choice_d": "A collision with the hashed value of a malicious update",
    "correct_answer": "A",
    "explanation": "In order to deliver a malicious update that uses a signing certificate, Eric will need to gain access to the private key for the signing certificate. The public key is exactly that\u2014public\u2014and having it will not allow Eric to sign the update. Hashes and collisions are not needed for this type of exploit.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      129,
      67,
      88,
      126,
      69
    ],
    "source": "9781394211395"
  },
  {
    "id": 787,
    "question": "Mike is a network administrator with a small financial services company. He has received a pop\u2010up window that states his files are now encrypted and he must pay .5 bitcoins to get them decrypted. He tries to check the files in question, but their extensions have changed, and he cannot open them. What best describes this situation?",
    "choice_a": "Mike\u2019s machine has a rootkit.",
    "choice_b": "Mike\u2019s machine has ransomware.",
    "choice_c": "Mike\u2019s machine has a logic bomb.",
    "choice_d": "Mike\u2019s machine has been the target of whaling.",
    "correct_answer": "B",
    "explanation": "This is an example of ransomware, which demands payment to return your data. A rootkit provides access to administrator/root privileges. A logic bomb executes its malicious activity when some condition is met. This scenario does not describe whaling, which is a type of phishing attack aimed at leaders in an organization.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      25,
      33,
      29,
      26,
      31
    ],
    "source": "9781394211395"
  },
  {
    "id": 788,
    "question": "Your company is instituting a new security awareness program. You are responsible for educating end users on a variety of threats, including social engineering. Which of the following best defines social engineering?",
    "choice_a": "Illegal copying of software",
    "choice_b": "Gathering information from discarded manuals and printouts",
    "choice_c": "Using people skills to obtain proprietary information",
    "choice_d": "Phishing emails",
    "correct_answer": "C",
    "explanation": "Social engineering is about using people skills to get information you would not otherwise have access to. Illegal copying of software isn't social engineering, nor is gathering of discarded manuals and printouts, which describes dumpster diving. Phishing emails use some social engineering, but that is one example of social engineering, not a definition.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      32,
      73,
      33,
      19,
      35
    ],
    "source": "9781394211395"
  },
  {
    "id": 789,
    "question": "What type of malicious actor will typically have the least amount of resources available to them?",
    "choice_a": "Nation\u2010states",
    "choice_b": "Unskilled actor",
    "choice_c": "Hacktivists",
    "choice_d": "Organized crime",
    "correct_answer": "B",
    "explanation": "Unskilled actors are the least resourced of the common threat actors listed. In general, they flow from nation\u2010state actors as the most highly resourced, to organized crime, to hacktivists, to inside actors, and then to unskilled actors, otherwise known as script kiddies, as the least capable and least resourced actors. As with any scale like this, there is room for some variability between specific actors, but for the exam, you should track them in that order.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      12,
      14,
      16,
      15,
      24
    ],
    "source": "9781394211395"
  },
  {
    "id": 790,
    "question": "Jorge wants to brief his organization\u2019s leadership on common email threat vectors. Which of the following common threats should not be in his presentation?",
    "choice_a": "Phishing",
    "choice_b": "Malware sent via email",
    "choice_c": "Email spoofing",
    "choice_d": "Cross\u2010site scripting",
    "correct_answer": "D",
    "explanation": "Common email threats include phishing, email spoofing, and malware sent via email. Cross\u2010site scripting is done via trusted websites where scripts are injected into user\u2010visible code, causing the user to run the scripts using their credentials.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      33,
      34,
      25,
      26,
      80
    ],
    "source": "9781394211395"
  },
  {
    "id": 791,
    "question": "Jared has discovered malware on the workstations of several users. This particular malware provides administrative privileges for the workstation to an external hacker. What best describes this malware?",
    "choice_a": "Trojan horse",
    "choice_b": "Logic bomb",
    "choice_c": "Multipartite virus",
    "choice_d": "Rootkit",
    "correct_answer": "D",
    "explanation": "Rootkits provide administrative access to systems, thus the \u201croot\u201d in rootkit. A Trojan horse combines malware with a legitimate program. A logic bomb performs its malicious activity when some condition is met. A multipartite virus infects the boot sector and a file.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      29,
      26,
      27,
      28,
      31
    ],
    "source": "9781394211395"
  },
  {
    "id": 792,
    "question": "Michelle discovers that a number of systems throughout her organization are connecting to a changing set of remote systems on TCP port 6667. What is the most likely cause of this, if she believes the traffic is not legitimate and that the systems are infected with malware?",
    "choice_a": "An alternate service port for web traffic",
    "choice_b": "Botnet command\u2010and\u2010control via IRC",
    "choice_c": "Downloads via a peer\u2010to\u2010peer network",
    "choice_d": "Remote\u2010access Trojans",
    "correct_answer": "B",
    "explanation": "This question combines two pieces of knowledge: how botnet command\u2010and\u2010control works, and that IRC's default port is TCP 6667. Although this could be one of the other answers, the most likely answer given the information available is a botnet that uses Internet Relay Chat (IRC) as its command\u2010and\u2010control channel. 6667 is not a common alternate web traffic port, peer\u2010to\u2010peer network traffic is commonly done via HTTP or HTTPS in modern infections, and a remote access\u2010Trojan is likely to behave differently and use another port as well.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      31,
      26,
      29,
      244,
      19
    ],
    "source": "9781394211395"
  },
  {
    "id": 793,
    "question": "Susan performs a vulnerability scan of a small business network and discovers that the organization\u2019s consumer\u2010grade wireless router has a vulnerability in its web server. What issue should she address in her findings?",
    "choice_a": "Firmware patch management",
    "choice_b": "Default configuration issues",
    "choice_c": "An unsecured administrative account",
    "choice_d": "Weak encryption settings",
    "correct_answer": "A",
    "explanation": "Software updates for consumer\u2010grade wireless routers are typically applied as firmware updates, and Susan should recommend that the business owner regularly upgrade their wireless router firmware. If updates are not available, they may need to purchase a new router that will continue to receive updates and configure it appropriately. This is not a default configuration issue nor an unsecured administrative account\u2014neither is mentioned, nor is encryption.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      184,
      183,
      82,
      88,
      203
    ],
    "source": "9781394211395"
  },
  {
    "id": 794,
    "question": "What type of phishing attack occurs via text messages?",
    "choice_a": "Bluejacking",
    "choice_b": "Smishing",
    "choice_c": "Phonejacking",
    "choice_d": "Text whaling",
    "correct_answer": "B",
    "explanation": "The word you will need to know for the Security+ exam for phishing via SMS is \u201csmishing,\u201d a term that combines SMS and phishing. Bluejacking sends unsolicited messages to Bluetooth devices, and phonejacking and text whaling were made up for this question.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      33,
      34,
      32,
      19,
      36
    ],
    "source": "9781394211395"
  },
  {
    "id": 795,
    "question": "John is analyzing a recent malware infection on his company network. He discovers malware that can spread rapidly via vulnerable network services and does not require any interaction from the user. What best describes this malware?",
    "choice_a": "Worm",
    "choice_b": "Virus",
    "choice_c": "Logic bomb",
    "choice_d": "Trojan horse",
    "correct_answer": "A",
    "explanation": "Worms spread themselves via vulnerabilities, making this an example of a worm. A virus is software that self\u2010replicates. A logic bomb executes its malicious activity when some condition is met. A Trojan horse combines malware with a legitimate program.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      27,
      28,
      26,
      29,
      31
    ],
    "source": "9781394211395"
  },
  {
    "id": 796,
    "question": "While reviewing web logs for her organization\u2019s website, Kathleen discovers the entry shown here: <br> <code>GET http://example.com/viewarticle.php?view=../../../config.txt HTTP/1.1</code> <br>What type of attack has she potentially discovered?",
    "choice_a": "A directory traversal attack",
    "choice_b": "A web application buffer overflow",
    "choice_c": "A directory recursion attack",
    "choice_d": "A slashdot attack",
    "correct_answer": "A",
    "explanation": "Directory traversal attacks attempt to exploit tools that can read directories and files by moving through the directory structure. The example would try to read the <code>config.txt</code> file three layers above the working directory of the web application itself. Adding common directory names or common filenames can allow attackers (or penetration testers) to read other files in accessible directories if they are not properly secured. The remainder of the options were made up for this question, although Slashdot is an actual website.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      77,
      78,
      83,
      84,
      76
    ],
    "source": "9781394211395"
  },
  {
    "id": 797,
    "question": "What two files are commonly attacked using offline brute\u2010force attacks?",
    "choice_a": "The Windows Registry and the Linux /etc/passwd file",
    "choice_b": "The Windows SAM and the Linux /etc/passwd file",
    "choice_c": "The Windows SAM and the Linux /etc/shadow file",
    "choice_d": "The Windows Registry and the Linux /etc/shadow file",
    "correct_answer": "C",
    "explanation": "The Windows Security Account Manager (SAM) file and the <code>/etc/shadow</code> file for Linux systems both contain passwords and are popular targets for offline brute\u2010force attacks.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      38,
      37,
      39,
      77,
      128
    ],
    "source": "9781394211395"
  },
  {
    "id": 798,
    "question": "You have noticed that when in a crowded area, data from your cell phone is stolen. Later investigation shows a Bluetooth connection to your phone, one that you cannot explain. What describes this attack?",
    "choice_a": "Bluejacking",
    "choice_b": "Bluesnarfing",
    "choice_c": "An evil twin attack",
    "choice_d": "A remote\u2010access Trojan",
    "correct_answer": "B",
    "explanation": "Bluesnarfing involves accessing data from a Bluetooth device when it is in range. Bluejacking involves sending unsolicited messages to Bluetooth devices when they are in range. Evil twin attacks use a rogue access point whose name is similar or identical to that of a legitimate access point. Nothing in this scenario points to a remote\u2010access Trojan being the cause of the stolen data.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      234,
      229,
      230,
      26,
      202
    ],
    "source": "9781394211395"
  },
  {
    "id": 799,
    "question": "Which of the following situations is not associated with race conditions?",
    "choice_a": "Time\u2010of\u2010check",
    "choice_b": "Time\u2010of\u2010change",
    "choice_c": "Target\u2010of\u2010evaluation",
    "choice_d": "Time\u2010of\u2010use",
    "correct_answer": "B",
    "explanation": "There are three common situations associated with race conditions: time\u2010of\u2010check (TOC), time\u2010of\u2010use (TOU), and target\u2010of\u2010evaluation. Time\u2010of\u2010change is not commonly associated with race conditions.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      90,
      72,
      82,
      79,
      88
    ],
    "source": "9781394211395"
  },
  {
    "id": 800,
    "question": "Gabby wants to protect a legacy platform with known vulnerabilities. Which of the following is not a common isolation or segmentation option that could be used to address this issue?",
    "choice_a": "Disconnect it from the network.",
    "choice_b": "Place the device behind a dedicated firewall and restrict inbound and outbound traffic.",
    "choice_c": "Rely on the outdated OS to confuse attackers.",
    "choice_d": "Move the device to a protected VLAN.",
    "correct_answer": "C",
    "explanation": "Relying on an outdated OS to confuse attackers is not a common isolation or segmentation option used to protect vulnerable legacy platforms. Many organizations have legacy platforms in place that cannot be patched or upgraded but that are still an important part of their business. Security professionals are often asked to suggest ways to secure the systems while leaving them operational. Common options include moving the devices to an isolated virtual LAN (VLAN), disconnecting the devices from the network and ensuring they are not plugged back in, and using a firewall or other security device to ensure that the legacy system is protected from attacks and cannot browse the Internet or perform other actions that could result in compromise.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      184,
      203,
      27,
      200,
      202
    ],
    "source": "9781394211395"
  },
  {
    "id": 801,
    "question": "After running nmap against a system on a network, Lucca sees that TCP port 23 is open and a service is running on it. What issue and resolution should he identify?",
    "choice_a": "Low ports should not be open to the Internet and should be disabled.",
    "choice_b": "Telnet is an insecure protocol and should be disabled.",
    "choice_c": "SSH is an insecure protocol and should be disabled.",
    "choice_d": "Ports 1\u20131024 are well\u2010known ports and must be firewalled.",
    "correct_answer": "B",
    "explanation": "TCP port 23 is typically associated with Telnet, an unencrypted remote shell protocol. Since Telnet sends its authentication and other traffic in the clear (clear/plain text), it should not be used, and Lucca should identify this as a configuration issue involving an insecure protocol.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      183,
      73,
      203,
      88,
      77
    ],
    "source": "9781394211395"
  },
  {
    "id": 802,
    "question": "Charles sets the permissions on the <code>/etc</code> directory on a Linux system to 777 using the <code>chmod</code> command. If Alex later discovers this, what should he report his finding as?",
    "choice_a": "Open or weak permissions",
    "choice_b": "Improper file handling",
    "choice_c": "A privilege escalation attack",
    "choice_d": "None of the above",
    "correct_answer": "A",
    "explanation": "Linux privileges can be set numerically, and 777 sets user, group, and world to all have read, write, and execute access to the entire <code>/etc</code> directory\u2014a very insecure, and thus open or weak permission. Setting permissions like this is a common workaround when permissions aren't working but can expose data or make binaries executable by users who should not have access to them. When you set permissions for a system, remember to set them according to the rule of least privilege: only the permissions that are required for the role or task should be configured.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      183,
      77,
      82,
      88,
      76
    ],
    "source": "9781394211395"
  },
  {
    "id": 803,
    "question": "Under what circumstances are concurrent sessions most commonly considered indicators of compromise?",
    "choice_a": "When they occur on the same system",
    "choice_b": "When they occur on two different systems issued to the same user",
    "choice_c": "When they occur in two different locations at the same time",
    "choice_d": "When they occur in the same location at the same time",
    "correct_answer": "C",
    "explanation": "Concurrent sessions can be relatively common in some applications, so additional data is important when assessing if the event is an IoC. If the event occurs in two different locations, particularly if travel between them would be classified as impossible travel it would more likely be an indicator of compromise or misuse.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      244,
      245,
      30,
      26,
      31
    ],
    "source": "9781394211395"
  },
  {
    "id": 804,
    "question": "During a penetration test, Angela obtains the uniform of a well\u2010known package delivery service and wears it into the target office. She claims to have a delivery for a C\u2010level employee she knows is there and insists that the package must be signed for by that person. What social engineering technique has she used?",
    "choice_a": "Impersonation",
    "choice_b": "Whaling",
    "choice_c": "A watering hole attack",
    "choice_d": "Prepending",
    "correct_answer": "A",
    "explanation": "Angela has impersonated an actual employee of the delivery service to gain access to the company. Company uniforms are a very useful element for in\u2010person social engineering. Whaling is a type of phishing attack aimed at leaders in an organization. A watering hole attack deploys malware or other attack tools at a site or sites that a target group frequently uses. Prepending is not a common security term.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      32,
      33,
      13,
      19,
      73
    ],
    "source": "9781394211395"
  },
  {
    "id": 805,
    "question": "Frank\u2019s organization operates in a shared responsibility cloud environment. What can Frank do to determine if he is suffering from a denial\u2010of\u2010service (DoS) attack against his cloud hosting environment?",
    "choice_a": "Nothing; cloud services do not provide security tools.",
    "choice_b": "Call the cloud service provider to have them stop the DoS attack.",
    "choice_c": "Review the cloud service provider\u2019s security tools and enable logging and anti\u2010DoS tools if they exist.",
    "choice_d": "Call the cloud service provider\u2019s Internet service provider (ISP) and ask them to enable DoS prevention.",
    "correct_answer": "C",
    "explanation": "Frank's best option is to review the anti\u2010denial\u2010of\u2010service and other security tools that his cloud hosting provider provides and to make appropriate use of them. The major infrastructure\u2010as\u2010a\u2010service (IaaS) providers have a variety of security tools that can help both detect and prevent DoS attacks from taking down sites that are hosted in their infrastructure. Calling the cloud service provider's ISP will not work because the ISP works with the cloud provider, not with Frank! It is possible the cloud service provider might be able to assist Frank, but they are most likely to instruct him to use the existing tools that they already provide.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      19,
      12,
      202,
      230,
      221
    ],
    "source": "9781394211395"
  },
  {
    "id": 806,
    "question": "What is the typical goal intent or goal of hacktivists?",
    "choice_a": "Increasing their reputation",
    "choice_b": "Financial gain",
    "choice_c": "Making a political statement",
    "choice_d": "Gathering high\u2010value data",
    "correct_answer": "C",
    "explanation": "The most common motivation for hacktivists is to make a political statement. Reputational gains are often associated with unskilled attackers/script kiddies, whereas financial gain is most commonly a goal of organized crime or insider threats. Gathering high\u2010value data is typical of both nation\u2010state actors and organized crime.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      15,
      12,
      19,
      14,
      16
    ],
    "source": "9781394211395"
  },
  {
    "id": 807,
    "question": "Ryan needs to verify that no unnecessary ports and services are available on his systems, but he cannot run a vulnerability scanner. What is his best option?",
    "choice_a": "Passive network traffic capture to detect services",
    "choice_b": "A configuration review",
    "choice_c": "Active network traffic capture to detect services",
    "choice_d": "Log review",
    "correct_answer": "B",
    "explanation": "Configuration reviews, either using automated tool or manual validation, can be a useful proactive way to ensure that unnecessary ports and services are not accessible. Configuration management tools can also help ensure that expected configurations are in place. Neither passive nor active network packet capture will show services that are not accessed, meaning that open ports could be missed, and log review won't show all open ports either.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      183,
      203,
      67,
      202,
      221
    ],
    "source": "9781394211395"
  },
  {
    "id": 808,
    "question": "John is a network administrator for Acme Company. He has discovered that someone has registered a domain name that is spelled just one letter different than his company\u2019s domain. The website with the misspelled URL is a phishing site. What best describes this attack?",
    "choice_a": "Session hijacking",
    "choice_b": "Cross\u2010site request forgery",
    "choice_c": "Typo squatting",
    "choice_d": "Clickjacking",
    "correct_answer": "C",
    "explanation": "This is an example of typo squatting. The website is off by only one or two letters, and the attacker hopes that users of the real website mistype the URL and are taken to their fake website. Session hijacking is taking over an authenticated session. Cross\u2010site request forgery sends fake requests to a website that purport to be from a trusted, authenticated user. Clickjacking attempts to trick users into clicking on something other than what they intended.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      36,
      33,
      74,
      81,
      19
    ],
    "source": "9781394211395"
  },
  {
    "id": 809,
    "question": "Which of the following best describes malware that will execute some malicious activity when a particular condition is met (i.e., if the condition is met, then executed)?",
    "choice_a": "Boot sector virus",
    "choice_b": "Logic bomb",
    "choice_c": "Buffer overflow",
    "choice_d": "Sparse infector virus",
    "correct_answer": "B",
    "explanation": "A logic bomb performs malicious actions when a specific condition or conditions are met. A boot sector virus infects the boot sector of the hard drive. A buffer overflow occurs when the attacker attempts to put more data in a variable than it can hold. A sparse infector virus performs its malicious activity intermittently to make it harder to detect.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      28,
      89,
      30,
      31,
      25
    ],
    "source": "9781394211395"
  },
  {
    "id": 810,
    "question": "Una\u2019s company is assessing threats to their supply chain and wants to consider the most likely issues that their server hardware supplier may create. Which of the following is not a common concern for organizations assessing hardware providers?",
    "choice_a": "Malicious hardware design",
    "choice_b": "Injection of malicious firmware",
    "choice_c": "Inability to deliver hardware in a timely manner",
    "choice_d": "Malicious software added to default OS images",
    "correct_answer": "A",
    "explanation": "While malicious hardware does exist, few organizations face it as a common threat due to the complexity of the attack and the fact that most hardware providers want to avoid the reputational harm that compromised hardware would create. Malicious firmware and software added to the OS image as well as an inability to deliver hardware in a timely manner are all common concerns with hardware providers.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      19,
      202,
      184,
      88,
      12
    ],
    "source": "9781394211395"
  },
  {
    "id": 811,
    "question": "Helen wants to prevent her staff from sideloading applications to their Android devices. What type of tool is best suited to preventing this type of issue without reducing other functionality for the device?",
    "choice_a": "Disable the Google Play store.",
    "choice_b": "Disable the manufacturer\u2019s store.",
    "choice_c": "Use an EDR tool.",
    "choice_d": "Use an MDM solution.",
    "correct_answer": "D",
    "explanation": "A mobile device management (MDM) solution will allow settings and software to be managed centrally, allowing Helen to both control sideloading permissions and to prevent unwanted applications from being installed. Disabling either the hardware vendor or Google's store does not prevent sideloading from an external media like a microSD card, which can reduce the functionality of devices. An EDR is helpful to identify malicious software but doesn't manage devices and prevent sideloading.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      17,
      200,
      202,
      25,
      31
    ],
    "source": "9781394211395"
  },
  {
    "id": 812,
    "question": "Tori believes that the system she is investigating may have a rootkit resident on the system. What type of behavior is most likely to indicate a rootkit\u2019s presence?",
    "choice_a": "Unusual network traffic",
    "choice_b": "Network scanning",
    "choice_c": "Displaying a ransom notice",
    "choice_d": "Deletion of files",
    "correct_answer": "A",
    "explanation": "Rootkits are designed to help retain control of and access to a system without users noticing. That means that obtrusive behaviors like network scanning, displaying ransom notices, or deletion of files are unusual for rootkits to perform. Other malware components beyond the rootkit may perform these as part of a malicious actor's toolkit.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      29,
      30,
      26,
      31,
      244
    ],
    "source": "9781394211395"
  },
  {
    "id": 813,
    "question": "Neil wants to deploy a host\u2010intrusion prevention system that will use a third\u2010party threat feed to servers in his datacenter. What concern might his system administrators express about the HIPS that he should consider before he makes the decision?",
    "choice_a": "A HIPS may block traffic, causing an outage or disruption.",
    "choice_b": "A HIPS may prevent least privilege configurations.",
    "choice_c": "A HIPS may bypass application allow lists.",
    "choice_d": "A HIPS may make use of segmentation less effective.",
    "correct_answer": "A",
    "explanation": "A HIPS may block legitimate traffic if the traffic matches an existing rule or if a threat feed is used and has a detection that matches that traffic. That means that organizations that deploy HIPS in datacenters where disruptions could cause significant outages are careful about what rules they put in place and how threat feed data is used. A HIPS doesn't prevent least privilege and typically doesn't interact with application allow lists, and segmentation should not impact a HIPS.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      221,
      244,
      183,
      202,
      203
    ],
    "source": "9781394211395"
  },
  {
    "id": 814,
    "question": "Organize the following threat actors by their typical level of sophistication from most sophisticated to least sophisticated: <br>Hacktivists, Nation\u2010state actors, Organized crime, Shadow IT",
    "choice_a": "Hacktivists, Shadow IT, Organized crime, Nation\u2010state actors",
    "choice_b": "Nation\u2010state actors, Organized crime, Hacktivists, Shadow IT",
    "choice_c": "Organized crime, Hacktivists, Shadow IT, Nation\u2010state actors",
    "choice_d": "Shadow IT, Hacktivists, Organized crime, Nation\u2010state actors",
    "correct_answer": "B",
    "explanation": "Nation\u2010state actors are typically the most sophistical adversaries organizations will face. Organized crime is the second most sophisticated actor in general, with hacktivists, then shadow IT following.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      16,
      12,
      15,
      17,
      19
    ],
    "source": "9781394211395"
  },
  {
    "id": 815,
    "question": "What is the most common file\u2010based threat vector?",
    "choice_a": "Phishing",
    "choice_b": "BEC",
    "choice_c": "Malware",
    "choice_d": "XSS",
    "correct_answer": "C",
    "explanation": "Malware is the most common threat vector involving files. Business email and phishing\u2010related compromises that occur through files are typically due to malware. Cross\u2010site scripting relies on embedding code in web pages that users will run when they view them, taking action as their logged\u2010in account.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      19,
      31,
      80,
      78,
      34
    ],
    "source": "9781394211395"
  },
  {
    "id": 816,
    "question": "Drew wants to address a recent Windows vulnerability that has a CVE rating of 9.6. What should his first step be to address the vulnerability?",
    "choice_a": "Isolate the impacted systems.",
    "choice_b": "Disable the service.",
    "choice_c": "Check to see if a patch is available.",
    "choice_d": "Install a host\u2010based firewall.",
    "correct_answer": "C",
    "explanation": "The first step for most organizations when addressing a known vulnerability is to check whether a patch is available. Organizations will also assess the potential risks associated with the patch: has it been widely deployed and tested, are there known issues, and is there a likelihood of disruption due to patching? If there are known issues, other solutions like isolation or deploying additional security controls such as a host\u2010based firewall or firewall rule, or even disabling the service if possible, may be employed.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      183,
      184,
      202,
      245,
      244
    ],
    "source": "9781394211395"
  },
  {
    "id": 817,
    "question": "Clay is decommissioning a server and wants to ensure that the system is properly decommissioned. Once the drives have been wiped or destroyed, what step typically comes next?",
    "choice_a": "Wiping memory",
    "choice_b": "Removing the system from inventory",
    "choice_c": "Removing the system from management",
    "choice_d": "Removing memory",
    "correct_answer": "B",
    "explanation": "Systems are typically removed from management when they are shut down and before disks are wiped. Once they're off and will not return to service, they are wiped and then removed from inventory. Memory wipes and removal are not typical steps in decommissioning processes.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      184,
      202,
      203,
      183,
      25
    ],
    "source": "9781394211395"
  },
  {
    "id": 818,
    "question": "Joe recently ran a port scan and found a service running on TCP port 1433. What type of attacks would he expect against this service?",
    "choice_a": "Web\u2010based attacks",
    "choice_b": "Print\u2010server attacks",
    "choice_c": "Oracle database server attacks",
    "choice_d": "Microsoft SQL Server attacks",
    "correct_answer": "D",
    "explanation": "TCP 1433 is the default service port for Microsoft SQL. Joe will want to take appropriate actions to protect his SQL server, including patching, properly configuration, firewall rules, and network segmentation.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      70,
      73,
      183,
      83,
      67
    ],
    "source": "9781394211395"
  },
  {
    "id": 819,
    "question": "What type of virtualization attack can be prevented by encrypting storage volumes when they are created?",
    "choice_a": "VM escape",
    "choice_b": "Birthday attacks",
    "choice_c": "Pass\u2010the\u2010hash",
    "choice_d": "Resource reuse",
    "correct_answer": "D",
    "explanation": "Encryption prevents resource reuse attacks from occurring because the data will not be accessible to attackers after resources are released and reallocated to third parties. VM escape attacks target the underlying VM infrastructure and could still occur if it was vulnerable. Pass\u2010the\u2010hash attacks are used against authentication systems when a hash can be captured and sent to validate a session, and birthday attacks leverage the likelihood of finding a valid collision more quickly by guessing than by moving linearly through a solution set for a hash.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      184,
      25,
      127,
      38,
      39
    ],
    "source": "9781394211395"
  },
  {
    "id": 820,
    "question": "Tyler discovers that software his organization has deployed sends information about the workstations back to a central server. After capturing network traffic that is being sent, he discovers that it includes the workstation\u2019s IP address, operating system, screen resolution, and information about other installed software. What type of malware should Tyler classify this as?",
    "choice_a": "A Trojan",
    "choice_b": "Bloatware",
    "choice_c": "A keylogger",
    "choice_d": "Spyware",
    "correct_answer": "D",
    "explanation": "Tyler has encountered spyware, software that gathers information to send back to a third party. While spyware is less outright malicious than other types of malware and may even have asked users to agree to release information as part of a click\u2010through during installation, it is still considered malware because it sends information about users, systems, and networks to third parties that is not intended or desired. Trojans are intended to appear like desirable or legitimate software but are malicious; bloatware is preinstalled software that is not needed and takes up disk space, CPU, and memory; and keyloggers capture keystrokes from a keyboard to retain locally or send to a malicious actor.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      30,
      26,
      28,
      31,
      29
    ],
    "source": "9781394211395"
  },
  {
    "id": 821,
    "question": "Eden wants to check errors related to a new security tool installed on her Windows workstation. What log file in Windows contains errors with installed software?",
    "choice_a": "The application log",
    "choice_b": "The security log",
    "choice_c": "The setup log",
    "choice_d": "The system log",
    "correct_answer": "A",
    "explanation": "The application log typically contains information about software that is installed on a Windows workstation, including errors that Eden is trying to identify. The security log contains security events like logins and file deletions. The setup log contains information about the installation of Windows, and the system log contains system\u2010related events like bootup errors.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      183,
      29,
      30,
      28,
      27
    ],
    "source": "9781394211395"
  },
  {
    "id": 822,
    "question": "Trent\u2019s company has recently discovered that their DNS information was changed via their registrar. Investigation showed that an administrator\u2019s workstation was compromised and that the account details for domain administration were contained on the workstation. What type of DNS\u2010based attack is this?",
    "choice_a": "A DNS\u2010based DoS attack",
    "choice_b": "A DNS hijacking attack",
    "choice_c": "A DNS amplification attack",
    "choice_d": "A DNS\u2010based DDoS attack",
    "correct_answer": "B",
    "explanation": "DNS hijacking can occur in a number of ways, including via the registrar, by changing your organization's DNS servers, or via changes to a local hosts file. DNS\u2010based DoS attacks seek to disable or prevent DNS from working, whereas DNS\u2010based DDoS attacks tend to be amplified and reflected by sending spoofed DNS queries with large results that will bog down the network connection of a targeted system or organization.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      227,
      36,
      228,
      244,
      30
    ],
    "source": "9781394211395"
  },
  {
    "id": 823,
    "question": "Giovanni wants to check to see if an impossible travel situation occurred for two logins on a Linux server. What log should he check to confirm or disprove his theory?",
    "choice_a": "/var/log/messages",
    "choice_b": "/var/log/auth.log",
    "choice_c": "/var/log/cron.log",
    "choice_d": "/var/log/travel",
    "correct_answer": "B",
    "explanation": "The <code>auth.log</code> or <code>secure</code> file contains authentication logs for Linux systems and will have such information as user ID, authentication time, and the IP address that the user connected from. Giovanni can use the IP addresses and times along with a geo\u2010IP system to check for impossible travel. <code>/messages</code> contains general log messages, and <code>cron.log</code> contains <code>cron</code> job information. <code>/travel</code> is not a typical Linux log file.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      244,
      25,
      73,
      183,
      245
    ],
    "source": "9781394211395"
  },
  {
    "id": 824,
    "question": "Microsoft\u2019s Intune as well as tools like Jamf are examples of tools that provide what sort of mitigation functionality?",
    "choice_a": "Decommissioning",
    "choice_b": "Configuration enforcement",
    "choice_c": "Segmentation",
    "choice_d": "HIPS",
    "correct_answer": "B",
    "explanation": "Intune and Jamf provide a wide range of hardening functionality, including configuration enforcement.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      183,
      202,
      244,
      28,
      25
    ],
    "source": "9781394211395"
  },
  {
    "id": 825,
    "question": "Nora recently wanted to find information about a scientific discovery and queried an AI large\u2010language model asking for a summary and references. The AI model provided a summary of the discovery and a number of citations. After Nora searched for the articles the AI cited, she discovered that they did not exist. How would this be classified?",
    "choice_a": "As phishing",
    "choice_b": "As misinformation",
    "choice_c": "As disinformation",
    "choice_d": "As brand impersonation",
    "correct_answer": "B",
    "explanation": "Misinformation is incorrect information, but not purposefully so like disinformation. This is true regardless of the way the information is provided. Phishing is used to gather credentials and other sensitive information, and brand impersonation attacks focus on appearing like a legitimate brand or company.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      35,
      34,
      33,
      19,
      24
    ],
    "source": "9781394211395"
  },
  {
    "id": 826,
    "question": "Sandeep wants to address the potential for impersonation attacks against her helpdesk. What technique is most likely to prevent impersonation attacks from being successful with her support staff?",
    "choice_a": "Require callers to verify their identity using non\u2010public information.",
    "choice_b": "Avoid publishing the help desk\u2019s phone number externally.",
    "choice_c": "Require users to complete awareness training.",
    "choice_d": "Require callers to provide a callback number and call back before completing tasks.",
    "correct_answer": "A",
    "explanation": "Requiring callers to validate their identity using non\u2010public information can help to prevent impersonation attacks. Not publishing a support number externally means that internal users will still have it and that it can be leaked or found. Requiring users to provide a callback number only works if business numbers are used, and this tends to prevent support from being effective for traveling users and others who may not be at a desk or able to use a soft phone due to technology issues. User awareness training won't protect the help desk staff from making mistakes.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      34,
      19,
      36,
      12,
      35
    ],
    "source": "9781394211395"
  },
  {
    "id": 827,
    "question": "Bob is conducting a penetration test against a client\u2019s environment and he discovers TCP port 515 exposed to the Internet. What should he report to his client as a potential attack surface?",
    "choice_a": "An exposed Internet connected camera",
    "choice_b": "An exposed print server",
    "choice_c": "An exposed IoT device",
    "choice_d": "An exposed UPS management system",
    "correct_answer": "B",
    "explanation": "TCP port 515 is the LPR port, commonly used for print services. Bob knows that exposing printers to the Internet is not a common practice and should recommend that the print server be segmented away from the Internet so that only internal systems that need to can send print jobs to it.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      203,
      202,
      19,
      82,
      245
    ],
    "source": "9781394211395"
  },
  {
    "id": 828,
    "question": "Which of the following is not a common cryptographic vulnerability?",
    "choice_a": "Downgrade attacks",
    "choice_b": "Magic key attacks",
    "choice_c": "Collision attacks",
    "choice_d": "Birthday attacks",
    "correct_answer": "B",
    "explanation": "The Security+ exam outline expects test takers to be familiar with three types of attacks: downgrade attacks that request weaker encryption types; collision attacks, which focus on finding collisions in hashes, allowing arbitrary changes to files that would normally be verified with hashes; and birthday attacks, which allow nonlinear guesses to be more likely to find a solution than simply progressing through key space. Magic key attacks were made up for this question.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      127,
      128,
      125,
      126,
      129
    ],
    "source": "9781394211395"
  },
  {
    "id": 829,
    "question": "Louis is investigating a malware incident on one of the computers on his network. He has discovered unknown software that seems to be opening a port, allowing someone to remotely connect to the computer. This software seems to have been installed at the same time as a small shareware application. Which of the following best describes this malware?",
    "choice_a": "Trojan",
    "choice_b": "Worm",
    "choice_c": "Logic bomb",
    "choice_d": "Rootkit",
    "correct_answer": "A",
    "explanation": "This is a remote\u2010access Trojan, malware that opens access for someone to remotely access the system. A worm would have spread itself via a vulnerability, whereas a logic bomb runs when some logical condition is met. Finally, a rootkit provides root or administrative access to the system.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      26,
      27,
      29,
      31,
      25
    ],
    "source": "9781394211395"
  },
  {
    "id": 830,
    "question": "Which of the following motivations is not commonly associated with advanced persistent threat actors?",
    "choice_a": "Ethical",
    "choice_b": "War",
    "choice_c": "Data exfiltration",
    "choice_d": "Espionage",
    "correct_answer": "A",
    "explanation": "Ethical concerns are typically associated with hacktivists and some insider threats. APTs are typically nation\u2010state actors and are commonly associated with war, data exfiltration, and espionage operations.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      12,
      16,
      19,
      15,
      18
    ],
    "source": "9781394211395"
  },
  {
    "id": 831,
    "question": "Eve wants to protect against DLL injection attacks. Which of the following practices can help her prevent DLL injection?",
    "choice_a": "Do not allow users to run DLLs.",
    "choice_b": "Avoid using DLLs.",
    "choice_c": "Use fully qualified paths for DLLs instead of searching paths.",
    "choice_d": "Use a DLL vulnerability scanner.",
    "correct_answer": "C",
    "explanation": "DLL injection requires that a DLL be loaded dynamically, and the ability to place a malicious DLL where it will be loaded is critical to the success of this type of attack. That means that using fully qualified DLL paths can help prevent the attack from succeeding. Preventing DLLs from being loaded by users and the programs they run or entirely avoiding using DLLs will cause functional issues for Windows, DLL vulnerability scanners are not a common solution, and avoiding the use of DLLs is not a common practice since DLLs are a key part of Windows systems.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      71,
      83,
      87,
      30,
      184
    ],
    "source": "9781394211395"
  },
  {
    "id": 832,
    "question": "Mackenzie wants to protect her organization from firmware vulnerabilities. What practice is most effective at preventing malicious firmware from being inadvertently downloaded and installed?",
    "choice_a": "Only use digitally signed and validated firmware.",
    "choice_b": "Scan firmware with an antivirus tool.",
    "choice_c": "Only use encrypted firmware.",
    "choice_d": "Avoid updating firmware and only use original firmware.",
    "correct_answer": "A",
    "explanation": "Firmware providers often provide digitally signed firmware that can be validated before it is installed. Mackenzie should ensure that her organization's practices include validating firmware signatures before installation. Antivirus will typically not detect malicious code in firmware files, encrypted firmware without a digital signature does not provide the same protection as digitally signed firmware, and firmware updates should be installed to prevent vulnerabilities from being exploited.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      184,
      129,
      88,
      69,
      83
    ],
    "source": "9781394211395"
  },
  {
    "id": 833,
    "question": "Zoie wants to check for instances of concurrent session usage for her web application. Where should she look for these indicators?",
    "choice_a": "Her firewall logs",
    "choice_b": "Her antivirus (AV) logs",
    "choice_c": "Her authentication logs",
    "choice_d": "Her web application server logs",
    "correct_answer": "D",
    "explanation": "Zoie's best option is to review web application server logs to identify session IDs that are the same coming from different IP addresses. She will not see session IDs in firewall, AV, or authentication logs.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      244,
      74,
      82,
      84,
      30
    ],
    "source": "9781394211395"
  },
  {
    "id": 834,
    "question": "Valerie knows that a system in her environment has been compromised and wants to take immediate action. Which of the following options should she select if she is worried about the system impacting other hosts on the network?",
    "choice_a": "Deploy antimalware tools to the system and scan it.",
    "choice_b": "Immediately isolate the system.",
    "choice_c": "Immediately deploy any missing patches to the system.",
    "choice_d": "Change default passwords and check for unexpected user accounts.",
    "correct_answer": "B",
    "explanation": "Isolating the system is the best option for Valerie to select until she can investigate the system. Isolation will prevent the system from impacting other systems and will also prevent attackers from getting to it. Antimalware and patching are useful options further into the investigation and response process. Changing default passwords and checking for unexpected user accounts is a good practice but won't help protect other systems if the system is compromised.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      31,
      27,
      25,
      244,
      245
    ],
    "source": "9781394211395"
  },
  {
    "id": 835,
    "question": "Casey is worried about downgrade attacks against her Apache web servers. What should she do to most effectively prevent downgrade attacks?",
    "choice_a": "Prevent TLS fallback.",
    "choice_b": "Require current web browsers.",
    "choice_c": "Run the most current version of Apache.",
    "choice_d": "Use an IDS.",
    "correct_answer": "A",
    "explanation": "Preventing fallback options from being used for encryption may stop some clients from connecting but will most effectively prevent downgrade attacks. Current browsers may be needed for this, but requiring that does not prevent attackers from using a downgrade attack if fallback options are allowed. Current web server software does not prevent settings from being weak. An IDS can detect downgrade attempts but cannot stop them.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      226,
      125,
      129,
      84
    ],
    "source": "9781394211395"
  },
  {
    "id": 836,
    "question": "What type of attack is based on sending more data to a target variable than the data can actually hold?",
    "choice_a": "Bluesnarfing",
    "choice_b": "Buffer overflow",
    "choice_c": "Bluejacking",
    "choice_d": "Cross\u2010site scripting",
    "correct_answer": "B",
    "explanation": "Buffer overflow attacks cram more data into a field or buffer than they can accept, overflowing into other memory locations and either crashing the system or application or potentially allowing code to be inserted into executable locations. Bluesnarfing and bluejacking are both Bluetooth attacks. Cross\u2010site scripting attacks allow attackers to inject scripts into pages viewed by other users.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      89,
      83,
      72,
      84,
      69
    ],
    "source": "9781394211395"
  },
  {
    "id": 837,
    "question": "Which of the following is an attack that seeks to attack a website, based on the website\u2019s trust of an authenticated user?",
    "choice_a": "XSS",
    "choice_b": "XSRF",
    "choice_c": "Buffer overflow",
    "choice_d": "Directory traversal",
    "correct_answer": "B",
    "explanation": "Cross\u2010site request forgery (XSRF or CSRF) sends forged requests to a website, supposedly from a trusted user. Cross\u2010site scripting (XSS) is the injection of scripts into a website to exploit the users. A buffer overflow tries to put more data in a variable than the variable can hold. Directory traversal attempts to change directories through URL manipulation to access files that should not normally be accessible to the web server or application.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      81,
      80,
      70,
      83,
      82
    ],
    "source": "9781394211395"
  },
  {
    "id": 838,
    "question": "Mary wants to harden workstations she is responsible for against malware attacks. Which of the following is not a common solution to this?",
    "choice_a": "Installing EDR",
    "choice_b": "Limiting administrative access",
    "choice_c": "Installing antivirus",
    "choice_d": "Using disk encryption",
    "correct_answer": "D",
    "explanation": "Disk encryption does not prevent malware attacks under most circumstances. Use of endpoint detection and response tools, antivirus tools, and limiting administrative access are all common ways to counter malware.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      25,
      28,
      26,
      29,
      79
    ],
    "source": "9781394211395"
  },
  {
    "id": 839,
    "question": "Spyware is an example of what type of malware?",
    "choice_a": "Trojan",
    "choice_b": "Unwanted programs",
    "choice_c": "RAT",
    "choice_d": "Ransomware",
    "correct_answer": "B",
    "explanation": "Spyware and adware are both common examples of unwanted programs. Though not directly malicious, they can pose risks to user privacy as well as create annoyances like pop\u2010ups or other unwanted behaviors. Trojans appear to be legitimate programs or are paired with them, RATs provide remote access and are a subcategory of Trojans, and ransomware demands payment or other actions to avoid damage to files or reputation.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      30,
      26,
      31,
      28,
      29
    ],
    "source": "9781394211395"
  },
  {
    "id": 840,
    "question": "Olivia has provisioned a new virtual machine in a cloud environment and is conducting forensic exercises to practice cloud forensic activities. She discovers data on her newly provisioned drive when she begins to analyze the drive. What issue has Olivia encountered?",
    "choice_a": "A VM escape issue",
    "choice_b": "Improper chain of custody",
    "choice_c": "A resource reuse issueImproper legal hold",
    "choice_d": "",
    "correct_answer": "C",
    "explanation": "Olivia has encountered a resource reuse issue. It is likely that the drive was reallocated without being securely wiped and that the previous user did not encrypt their drives. While this is unlikely with major cloud service providers now, it has been observed in the past and could still occur. There is no indication that a VM escape occurred that would run software on the host hypervisor, and no procedural issues around chain of custody or legal hold are described in the question.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      183,
      202,
      244,
      88,
      17
    ],
    "source": "9781394211395"
  },
  {
    "id": 841,
    "question": "Chuck wants to help his organization protect against business email compromise (BEC) attacks. Which of the following is not a common best practice to defend against BEC?",
    "choice_a": "Delete all attachments from emails.",
    "choice_b": "Use two\u2010factor authentication.",
    "choice_c": "Review suspicious email carefully for typos and other indicators.",
    "choice_d": "Don\u2019t click URLs in unsolicited emails\u2014visit URLs manually.",
    "correct_answer": "A",
    "explanation": "While attachments are a common vector for BEC attacks, deleting all attachments is not a common practice. Instead, users should be taught to be careful about clicking on and opening attachments, particularly on unsolicited email. Using two\u2010factor authentication, reviewing suspicious emails for potential indicators of BEC, and not clicking on URLs but instead visiting sites manually are all common anti\u2010BEC practices.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      34,
      33,
      244,
      37,
      19
    ],
    "source": "9781394211395"
  },
  {
    "id": 842,
    "question": "A penetration tester calls a staff member for her target organization and introduces herself as a member of the IT support team. She asks if the staff member has encountered a problem with their system, then proceeds to ask for details about the individual, claiming she needs to verify that she is talking to the right person. What type of social engineering attack is this?",
    "choice_a": "Pretexting",
    "choice_b": "A watering hole attack",
    "choice_c": "Phishing",
    "choice_d": "Shoulder surfing",
    "correct_answer": "A",
    "explanation": "Pretexting is a type of social engineering that involves using a false motive and lying to obtain information. Here, the penetration tester lied about their role and why they are calling (impersonation), and then built some trust with the user before asking for personal information. A watering hole attack leverages a website that the targeted users all use and places malware on it to achieve their purpose. Phishing is the process of attempting to gain credentials or other information, typically via email or similar means. Shoulder surfing involves looking over an individual's shoulder or otherwise observing them entering sensitive information like passwords.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      34,
      33,
      32,
      73,
      14
    ],
    "source": "9781394211395"
  },
  {
    "id": 843,
    "question": "What type of attack targets a specific group of users by infecting one or more websites that group is specifically known to visit frequently?",
    "choice_a": "A watercooler attack",
    "choice_b": "A phishing net attack",
    "choice_c": "A watering hole attack",
    "choice_d": "A phish pond attack",
    "correct_answer": "C",
    "explanation": "Watering hole attacks target groups by focusing on common shared behaviors like visiting specific websites. If attackers can compromise the site or deliver targeted attacks through it, they can then target that group. Watercooler, phishing net, and phish pond attacks were all made up for this question.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      36,
      33,
      19,
      245,
      15
    ],
    "source": "9781394211395"
  },
  {
    "id": 844,
    "question": "When a multithreaded application does not properly handle various threads accessing a common value, and one thread can change the data while another thread is relying on it, what flaw is this?",
    "choice_a": "Memory leak",
    "choice_b": "Buffer overflow",
    "choice_c": "Integer overflow",
    "choice_d": "Time\u2010of\u2010check/time\u2010of\u2010use",
    "correct_answer": "D",
    "explanation": "If access is not handled properly, a time\u2010of\u2010check (TOC)/time\u2010of\u2010use (TOU) condition can exist where the memory is checked, changed, then used. Memory leaks occur when memory is allocated but not deallocated. A buffer overflow is when more data is put into a variable than it can hold. An integer overflow occurs when an attempt is made to put an integer that is too large into a variable, such as trying to put a 64\u2010bit integer into a 32\u2010bit variable.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      90,
      89,
      69,
      83,
      67
    ],
    "source": "9781394211395"
  },
  {
    "id": 845,
    "question": "Geoff believes that a workstation on his network may have been the target of an on\u2010path attack. What indicator is most likely to indicate this type of attack on a local network segment?",
    "choice_a": "External DNS resolution shows an improper result.",
    "choice_b": "The ARP table shows an alternate address for the gateway.",
    "choice_c": "Encrypted traffic has been forced to use a less secure algorithm.",
    "choice_d": "A website\u2019s URL has been modified.",
    "correct_answer": "B",
    "explanation": "Local on\u2010path attacks typically involve responding to ARP requests with a different gateway MAC address before the gateway itself can respond or through modification of local hosts files. External DNS should not be resolving local network DNS information. Encrypted traffic using a less secure algorithm is a downgrade attack. Website URLs being modified might be an example of typo squatting or another attack.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      226,
      227,
      36,
      74,
      244
    ],
    "source": "9781394211395"
  },
  {
    "id": 846,
    "question": "Kathleen\u2019s IPS flags traffic from two IP addresses as shown here: <br> <code>Source IP: 10.11.94.111</code> <br> <code>http://example.com/home/show.php?SESSIONID=a3fghbby</code> <br> <code>Source IP: 192.168.5.34</code> <br> <code>http://example.com/home/show.php?SESSIONID=a3fghbby</code> <br>What type of attack should she investigate this as?",
    "choice_a": "A SQL injection attack",
    "choice_b": "A cross\u2010site scripting attack",
    "choice_c": "A session replay attack",
    "choice_d": "A server\u2010side request forgery attack",
    "correct_answer": "C",
    "explanation": "Session IDs should be unique for distinct users and systems. A very basic type of session replay attack involves providing a victim with a session ID and then using that session ID once they have used the link and authenticated themselves. Protections such as session timeouts and encrypting session data, as well as encoding the source IP, hostname, or other identifying information in the session key, can all help prevent session replay attacks.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      74,
      82,
      90,
      244,
      69
    ],
    "source": "9781394211395"
  },
  {
    "id": 847,
    "question": "Andy is an end user in an organization that uses an application allow list to control what applications are used on workstations. What does Andy need to do if he wants to install an application on his workstation?",
    "choice_a": "Download the application, then run the installer using an administrator account.",
    "choice_b": "Manually add the application installer to the allow list for his workstation.",
    "choice_c": "Request that the application be added to the allow list and have it installed by his organization\u2019s administrators.",
    "choice_d": "Use a jailbreak to install the application.",
    "correct_answer": "C",
    "explanation": "End users cannot add applications that are not on the allow list to their workstations in environments using an application allow list. Since Andy is an end user, not an administrator, he cannot install applications as an administrator, nor can he add the application to the allow list. Andy will need to request that the application be added and then administrators will need to install the application. Jailbreaks are used for mobile devices, not workstations.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      67,
      83,
      79,
      19,
      14
    ],
    "source": "9781394211395"
  },
  {
    "id": 848,
    "question": "Frank is traveling and wants to connect to an unsecure wired network in his hotel. Which of the following is not a common threat he should consider how to prevent while on an unsecured hotel wired network?",
    "choice_a": "Network packet capture",
    "choice_b": "Network\u2010based attacks",
    "choice_c": "Evil twins",
    "choice_d": "Worms",
    "correct_answer": "C",
    "explanation": "Evil twins are threats for wireless networks, not wired networks. Frank should consider how to keep all his traffic secure, likely by using a VPN that tunnels all his traffic to a trusted network exit point, and both worms and network\u2010based attacks are possible from infected or malicious systems.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      230,
      27,
      31,
      226,
      234
    ],
    "source": "9781394211395"
  },
  {
    "id": 849,
    "question": "An attacker is trying to get access to your network. He is sending users on your network a link to a new game with a hacked license code program. However, the game files also include software that will give the attacker access to any machine that it is installed on. What type of attack is this?",
    "choice_a": "Rootkit",
    "choice_b": "Trojan horse",
    "choice_c": "Spyware",
    "choice_d": "Boot sector virus",
    "correct_answer": "B",
    "explanation": "The malware in this example is a Trojan horse\u2014it pretends to be something desirable, or at least innocuous, and installs malicious software in addition to or instead of the desired software. A rootkit gives root or administrative access, spyware is malware that records user activities, and a boot sector virus is a virus that infects the boot sector of the hard drive.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      26,
      29,
      30,
      27,
      25
    ],
    "source": "9781394211395"
  },
  {
    "id": 850,
    "question": "Rae\u2019s company recently received an email from a former employee threatening to release company data that they copied before they left the organization if the organization does not pay them a severance package. What threat actor motivation should she categorize this as?",
    "choice_a": "Espionage",
    "choice_b": "Revenge",
    "choice_c": "Blackmail",
    "choice_d": "Service disruption",
    "correct_answer": "C",
    "explanation": "The former employee is threatening to release data making this blackmail. Espionage\u2014including both nation\u2010state driven and corporate\u2014typically involves theft of data or other information, and there is no description of revenge or an attempt to disrupt services.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      12,
      19,
      18,
      17,
      15
    ],
    "source": "9781394211395"
  },
  {
    "id": 851,
    "question": "Jack wants to sideload applications to his Android phone. What does he need to do first to allow this?",
    "choice_a": "Jailbreak the phone.",
    "choice_b": "Transfer the files to the phone.",
    "choice_c": "Install a package manager.",
    "choice_d": "Disable antimalware protection.",
    "correct_answer": "B",
    "explanation": "Sideloading can be as simple as loading files on the phone, although some bundles and applications require installers or other tools. Jailbreaking, disabling antimalware protection, or even installing a package manager are not required to sideload applications for Android but may be done. Jailbreaking and package managers are commonly used for iOS devices.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      25
    ],
    "source": "9781394211395"
  },
  {
    "id": 852,
    "question": "Jill is conducting a penetration test and uses the following query against a vulnerable web application. What data will she see if it succeeds? <br> <code>SELECT * FROM users WHERE category = 'customers' OR 1=1--'</code> <br>",
    "choice_a": "A list of all customers",
    "choice_b": "A list of all customers whose userID is 1 or larger",
    "choice_c": "A list of all customers whose userID is 1",
    "choice_d": "A list of all users",
    "correct_answer": "D",
    "explanation": "If this query is successful, it will match all categories because it looks for categories that match customers or <code>TRUE</code> which is how <code>OR 1=1</code> resolves. That means that any category will match, providing Jill with a list of all users, not just all customers or customers with specific userIDs.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      72,
      82,
      83,
      68,
      13
    ],
    "source": "9781394211395"
  },
  {
    "id": 853,
    "question": "Greg\u2019s checklist for securing new Linux\u2010based devices includes disabling unneeded ports and protocols. What primary purpose does this serve?",
    "choice_a": "It speeds up port scans.",
    "choice_b": "It reduces the number of logged events.",
    "choice_c": "It prevents using up default ports.",
    "choice_d": "It reduces the device\u2019s attack footprint.",
    "correct_answer": "D",
    "explanation": "Disabling unnecessary ports and protocols reduced a device or system's attack footprint. The fewer targets attackers have, the less likely they are to be successful at finding a viable target. Reducing ports and protocols will speed up port scans and will reduce the number of logged events, but this is not the primary purpose of the change. Default ports are set for services based on common practice, and ports and protocols are not disabled to save default ports.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      183,
      19,
      82,
      202,
      88
    ],
    "source": "9781394211395"
  },
  {
    "id": 854,
    "question": "Nathaniel\u2019s organization has recently deployed multifactor authentication (MFA), which requires both a password and an MFA code to be provided to authenticate to critical services. Despite this, an attacker has recently logged into an administrative console using a password and MFA code belonging to a user. Which of the following types of malware is most likely to allow an attacker to successfully undertake this type of attack?",
    "choice_a": "A virus",
    "choice_b": "A worm",
    "choice_c": "A logic bomb",
    "choice_d": "A keylogger",
    "correct_answer": "D",
    "explanation": "Attackers are increasingly relying on keyloggers that can capture information entered at a keyboard and send it to them, allowing them to quickly use the information to log in before the user can use an MFA code. Viruses, worms, and logic bombs are not designed to provide this functionality.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      30,
      73,
      32,
      37,
      25
    ],
    "source": "9781394211395"
  },
  {
    "id": 855,
    "question": "Which of the following is not a common attribute of organized crime threat actors?",
    "choice_a": "Internal",
    "choice_b": "Well resourced",
    "choice_c": "Sophisticated",
    "choice_d": "External",
    "correct_answer": "A",
    "explanation": "Organized crime actors are typically external rather than internal actors. They are often well resourced and sophisticated.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      12,
      16,
      19,
      17,
      15
    ],
    "source": "9781394211395"
  },
  {
    "id": 856,
    "question": "Darryl is showing Valerie his iPhone and explains that his niece installed a package manager called Cydia on the device that allows him to install applications that are not available via the Apple App Store. What does Valerie know about his iPhone?",
    "choice_a": "It has been infected with malware.",
    "choice_b": "It can be remotely controlled via SSH.",
    "choice_c": "It can be remotely controlled via a web interface.",
    "choice_d": "It is jailbroken.",
    "correct_answer": "D",
    "explanation": "Package managers like Cydia and Sileo are used to add applications and other functionality to jailbroken iPhones. If the phone is an organizationally owned phone or contains organizational data, Valerie may need to take action based on organizational policies. Cydia and other package managers do not open up remote management tools by default and are not malware, although they may not be permitted software for many organizational devices.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      202,
      183,
      29,
      26,
      31
    ],
    "source": "9781394211395"
  },
  {
    "id": 857,
    "question": "Isaac is reviewing IPS rules used by his organization and notices rules that block the use of <code>'</code> as well as <code>OR 1=1</code> in HTTP queries. What type of attacks is Isaac\u2019s organization attempting to stop?",
    "choice_a": "Buffer overflow attacks",
    "choice_b": "SQL injection attacks",
    "choice_c": "Replay attacks",
    "choice_d": "Directory traversal attacks",
    "correct_answer": "B",
    "explanation": "Simple SQL injection attacks often rely on the single quote or Boolean conditions like <code>OR 1=1</code> as part of their attack. While these are simple examples and more complex options exist, Isaac's organization is wise to prevent simple attacks. Buffer overflow attacks target memory locations or variables, replay attacks re\u2010send legitimate traffic, and directory traversal attacks attempt to access other file structures.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      70,
      72,
      84,
      82,
      87
    ],
    "source": "9781394211395"
  },
  {
    "id": 858,
    "question": "Vicki is reviewing common BEC attack methods with her team. Which of the following is not a common BEC technique?",
    "choice_a": "Using compromised email accounts",
    "choice_b": "Using slightly modified spoofed email addresses",
    "choice_c": "Sending email from the user\u2019s personal email account",
    "choice_d": "Using malware to access email accounts",
    "correct_answer": "C",
    "explanation": "Sending email from a user's personal email account to them is not a common BEC exploit, but using compromised accounts, spoofing email with slightly modified email addresses, and using malware to gain access to accounts and send email are all common techniques.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      34,
      33,
      26,
      25,
      31
    ],
    "source": "9781394211395"
  },
  {
    "id": 859,
    "question": "Craig wants to control the applications employees can install on the laptops they are issued. If he wants the greatest level of control and is not concerned about flexibility or overhead to manage his solution, which of the following will best meet his needs?",
    "choice_a": "An access control list",
    "choice_b": "Application allow list",
    "choice_c": "An application deny list",
    "choice_d": "Segmentation",
    "correct_answer": "B",
    "explanation": "An application allow list provides the greatest control over what applications are installed on devices. Application deny lists are useful for preventing specific software from being installed but cannot handle the breadth of possible applications that users may find and use. Access control lists (ACLs) are used like firewall rules to apply rules to network traffic, and segmentation is used to separate systems based on various factors like data sensitivity or trust levels.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      83,
      84,
      72,
      203,
      183
    ],
    "source": "9781394211395"
  },
  {
    "id": 860,
    "question": "Ron wants to prevent users from using SSH between two network segments. Which of the following ACLs will prevent users in a segment 10.10.10.0/24 from using SSH to connect to the 10.10.20.0/24 network segment?",
    "choice_a": "PERMIT IP 10.10.10.0/24 * 10.10.20.0/24 22",
    "choice_b": "DENY IP 10.10.10.0/24 * 10.10.20.0/24 22",
    "choice_c": "PERMIT IP 10.10.20.0/24 * 10.10.10.0/24 22",
    "choice_d": "DENY IP 10.10.20.0/24 * 10.10.10.0/24 22",
    "correct_answer": "B",
    "explanation": "Ron wants to deny any source port to systems on the 10.10.20.0/24 network with a service port of TCP 22 for SSH.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      27,
      31,
      25,
      29,
      83
    ],
    "source": "9781394211395"
  },
  {
    "id": 861,
    "question": "Sam\u2019s organization uses a DNS black hole to prevent access to known malicious sites. The organization relies on a reputation service feed that is used to add the known malicious domains and IP addresses. DNS lookups that would go to those sites is sent to an internal redirect site that lets users know the site is inaccessible. Sam reviews the logs to determine if a system is trying to access those blocked sites regularly. What type of indicator of compromise is Sam looking for?",
    "choice_a": "Blocked content",
    "choice_b": "Resource inaccessibility",
    "choice_c": "Missing logs",
    "choice_d": "Published or documented indicators",
    "correct_answer": "A",
    "explanation": "Sam is using blocked content logging to determine what systems may be compromised and attempting to connect to malicious domains and if users are trying to access those IP addresses or domains. This can help Sam intervene with individual users and can also help identify infected systems. Resource inaccessibility is typically an unintentional indicator rather than a result of a security measure as described here. No logs are missing, and there is not a specific indicator of compromise that was described or published listed in the question.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      244,
      25,
      31,
      227,
      36
    ],
    "source": "9781394211395"
  },
  {
    "id": 862,
    "question": "Christina is reviewing a Linux system that she is responsible for, and notices that the <code>/usr</code> filesystem is 80 percent full. After review, she notices that a single user\u2019s home directory has hundreds of files in it that were recently added. What type of indicator of compromise should she categorize this as?",
    "choice_a": "Resource inaccessibility",
    "choice_b": "Blocked content",
    "choice_c": "Impossible travel",
    "choice_d": "Resource consumption",
    "correct_answer": "D",
    "explanation": "While resource consumption alone may not indicate a compromise, unexpected consumption of resources may indicate unexpected or unwanted activity. Christina should look for other indicators of compromise to determine if she needs to declare a security incident. Resource inaccessibility would require the resource to not be available or working, and at 80% full a Linux filesystem will still work. There is no description of the content, and no content access was prevented, so this is not blocked content. Impossible travel occurs when logins or other resource usage occur in two locations at times that do not allow for travel between the locations.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      244,
      25,
      26,
      29,
      31
    ],
    "source": "9781394211395"
  },
  {
    "id": 863,
    "question": "What term is used to describe the unwanted but generally harmless programs that are commonly installed on consumer computers when they are purchased?",
    "choice_a": "Spyware",
    "choice_b": "Bloatware",
    "choice_c": "Logic bombs",
    "choice_d": "Firmware",
    "correct_answer": "B",
    "explanation": "Bloatware is a general term used to describe the unnecessary and unwanted programs that are installed on many PCs by manufacturers. Spyware is more harmful, sending information about the user, their browsing habits, or the computer back to the software's vendor or other organizations. Logic bombs are malware that take action under specific circumstances like a time, date, or other trigger, and firmware is the software that runs on top of hardware to provide basic underlying functionality.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      30,
      28,
      27,
      25,
      202
    ],
    "source": "9781394211395"
  },
  {
    "id": 864,
    "question": "Michael is performing a forensic analysis of a compromised workstation and discovers a copy of <code>cmd.exe</code> in the <code>\\system32</code> folder on a Windows workstation that does not match the real <code>cmd.ex</code>e file. When he looks at the file, he discovers that it is capable of running as an administrator. What type of attack has he discovered?",
    "choice_a": "A buffer overflow attack",
    "choice_b": "A Trojan attack",
    "choice_c": "A privilege escalation attack",
    "choice_d": "A replay attack",
    "correct_answer": "C",
    "explanation": "The ability to run a program as a privileged user like an administrator from an unexpected or uncommon location is a common indicator of a privilege escalation attack. A buffer overflow would push data into a variable to attempt to cause it to take a desired action, a Trojan would look like a wanted or desirable file but would be malware, and a replay attack would send successful authentication or other information again to gain access to a system.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      79,
      26,
      89,
      244,
      183
    ],
    "source": "9781394211395"
  },
  {
    "id": 865,
    "question": "While reviewing logs, Chris sees an Apache web log that includes the following entry: <br> <code>https://www.example.com/viewer.php?filename=../../../etc/passwd%00.png</code> <br>What type of attack has Chris most likely uncovered, and what file will it return?",
    "choice_a": "A replay attack, password00.png",
    "choice_b": "A directory traversal attack, password00.png",
    "choice_c": "A replay attack, passwd",
    "choice_d": "A directory traversal attack, passwd",
    "correct_answer": "D",
    "explanation": "This is a directory traversal attack. The characteristic <code>/../../</code> is the first indicator you should pay attention to. The <code>%00</code> is a null byte, meaning that many applications will stop reading when they encounter it. You might not know that detail as you take the exam, but you should know that attackers would look for the <code>passwd</code> file, not a PNG of a password!",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      77,
      82,
      78,
      72,
      76
    ],
    "source": "9781394211395"
  },
  {
    "id": 866,
    "question": "What common mitigation technique relies on VLANs to separate systems?",
    "choice_a": "Encryption",
    "choice_b": "Segmentation",
    "choice_c": "Impossible travel",
    "choice_d": "HIPS",
    "correct_answer": "B",
    "explanation": "VLANs are commonly used to provide segmentation for networks by placing them in separate logical networks. Encryption doesn't require or use VLANs, impossible travel describes logins and other activities from disparate physical locations in a time frame that would be impossible for travel to occur during, and a HIPS is a host intrusion prevention system.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      203,
      27,
      221,
      245,
      244
    ],
    "source": "9781394211395"
  },
  {
    "id": 867,
    "question": "Mark\u2019s coworker recently discovered that he can use the Linux <code>su</code> command to run programs as one of his peers. What type of attack is this?",
    "choice_a": "A replay attack",
    "choice_b": "A vertical privilege escalation attack",
    "choice_c": "A horizontal privilege escalation attack",
    "choice_d": "A forgery attack",
    "correct_answer": "C",
    "explanation": "Horizontal privilege escalation occurs when users at a similar level are able to use privileges or accounts belonging to peer users. Here, Mark's coworker is able to act as another similar user. Vertical privilege escalation focuses on greater privileges like administrative rights. Replay attacks re\u2010send traffic to authenticate or otherwise repeat a transaction. Forgery attacks like cross\u2010site request forgery (XSRF) leverage trusted sessions to allow malicious apps to take action due to the trust between a browser and a web application.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      79,
      82,
      74,
      81,
      72
    ],
    "source": "9781394211395"
  },
  {
    "id": 868,
    "question": "Jason is monitoring his network and notices that hundreds of different IP addresses are sending requests to one of his organization\u2019s servers. The requests are small, and when he inspects them he sees a simple <code>HTTP GET</code> command for a file. When the server responds, it sends back a very large response. What type of attack is likely occurring, and what is it attempting to accomplish?",
    "choice_a": "A DoS attack and exploiting a vulnerable service",
    "choice_b": "A DDoS and a buffer overflow",
    "choice_c": "A DDoS and resource exhaustion",
    "choice_d": "A DoS attack and an on\u2010path attack",
    "correct_answer": "C",
    "explanation": "This is most likely a distributed denial\u2010of\u2010service (DDoS) attack since it is coming from many different IP addresses. Using small requests to generate large responses is an example of a resource exhaustion attack. Since this is coming from many addresses rather than one or a small number, it is more properly called a DDoS than a simple denial\u2010of\u2010service (DoS) attack. There is no indication that the service is vulnerable, the requests are small and no mention is made of a specific payload other than a HTTP <code>GET</code> for a file, and there is no traffic redirection as you would expect in an on\u2010path attack.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      228,
      31,
      244,
      89,
      19
    ],
    "source": "9781394211395"
  },
  {
    "id": 869,
    "question": "Dan was recently troubleshooting a web server and deployed a firewall rule to his organization\u2019s datacenter firewall at the beginning of the ruleset. The rule reads: <br> <code>ALLOW FROM ANY:TCP 80 TO ANY:ANY</code> <br>What type of vulnerability should the security team at Dan\u2019s workplace label this as?",
    "choice_a": "A jailbreak",
    "choice_b": "A race condition",
    "choice_c": "A misconfiguration",
    "choice_d": "An injection attack",
    "correct_answer": "C",
    "explanation": "Allowing all TCP 80 traffic to any internal system is a common misconfiguration for firewalls when troubleshooting. Placing an overly broad rule in a firewall ruleset, particularly when it is processed early (at the top) of a ruleset is dangerous, even though it happens more than security practitioners want to think about! Jailbreaks are done on iOS\u2010based mobile devices to bypass security; race conditions occur when the time\u2010of\u2010check (TOC) and time\u2010of\u2010use (TOU) of a variable, memory location, or other resource allows for changes when it shouldn't; and injection attacks are typically conducted against memory, code, or other resources, not firewall rules.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      183,
      77,
      82,
      84,
      72
    ],
    "source": "9781394211395"
  },
  {
    "id": 870,
    "question": "Brian wants to protect files that are regularly sent via email as part of his organization\u2019s business practice. What type of encryption is best suited to this type of usage?",
    "choice_a": "Full\u2010disk encryption",
    "choice_b": "File\u2010level encryption",
    "choice_c": "Volume encryption",
    "choice_d": "Transport encryption",
    "correct_answer": "B",
    "explanation": "File\u2010level encryption will allow Brian's organization to encrypt individual files rather than entire disks or volumes and will protect files even when they are not in transit, unlike transport encryption using TLS.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      25,
      67,
      226,
      33,
      202
    ],
    "source": "9781394211395"
  },
  {
    "id": 871,
    "question": "Olivia has deployed Microsoft\u2019s Intune for her environment. What capability has she gained for her devices?",
    "choice_a": "Malware detection and response",
    "choice_b": "Configuration enforcement",
    "choice_c": "Code versioning",
    "choice_d": "Web application firewalling",
    "correct_answer": "B",
    "explanation": "Intune, formerly known as Microsoft Endpoint Manager and SCCM, provides configuration management, mobile app management, and other central system, software, and device management capabilities. It does not detect and respond to malware, but it can deploy configurations for Defender. It is not a code repository and versioning tool like git, and it does not provide web application firewalling.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      183,
      202,
      84,
      88,
      69
    ],
    "source": "9781394211395"
  },
  {
    "id": 872,
    "question": "Jill is concerned about supply chain attacks against her organization\u2019s service providers. Which of the following should be her most significant concern about her software\u2010as\u2010a\u2010service (SaaS) service provider as she documents her supply chain risks?",
    "choice_a": "Compromise of the SaaS vendor, leading to access to her data",
    "choice_b": "Attacks against the SaaS vendor, leading to hours of downtime",
    "choice_c": "Lack of availability of hardware from her SaaS vendor for delivery",
    "choice_d": "Software vulnerabilities in tools provided by the vendor",
    "correct_answer": "A",
    "explanation": "Data exposure is typically a more significant risk than downtime, particularly when the downtime is limited to hours. SaaS vendors do not typically sell or deliver hardware, as they provide services. Software vulnerabilities may exist, but without a known impact, compromise leading to data loss remains the most significant issue.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      19,
      88,
      202,
      25,
      68
    ],
    "source": "9781394211395"
  },
  {
    "id": 873,
    "question": "Elizabeth is investigating a network breach at her company. She discovers a program that was able to execute code within the address space of another process by using the target process to load a specific library. What best describes this attack?",
    "choice_a": "A logic bomb",
    "choice_b": "Session hijacking",
    "choice_c": "Buffer overflow",
    "choice_d": "DLL injection",
    "correct_answer": "D",
    "explanation": "In a DLL injection, the malware attempts to inject code into the running process of a library in memory. This is a rather advanced attack. A logic bomb executes its misdeed when some condition is met. Session hijacking is taking over an authenticated session. Buffer overflows are done by sending more data to a variable than it can hold.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      71,
      72,
      78,
      89,
      29
    ],
    "source": "9781394211395"
  },
  {
    "id": 874,
    "question": "Annie wants to prevent a TOC/TOU issue that occurs with her organization\u2019s business application. The issue occurs when scripts run as part of the application access a shared data file. Sometimes one instance of the script opens the file, checks that inventory is sufficient to meet customer needs, then waits for the customer\u2019s interaction. At the same time, another instance of the script checks, sees that there is sufficient inventory, and also provides that information to another customer. If both customers place orders, Annie\u2019s organization is unable to meet demand. If Annie wants to continue to grow her business\u2019s use of the application, which of the following options is the best way to prevent this issue?",
    "choice_a": "Delete the resource after each use.",
    "choice_b": "Only run one instance of the process.",
    "choice_c": "Make multiple copies of the resource so each process has its own.",
    "choice_d": "Lock the resource until the process is done with it.",
    "correct_answer": "D",
    "explanation": "Locking the resource until the action is completed is a common method of preventing TOC/TOU issues. Deleting the resource after each use doesn't allow resources to be persistent, preventing applications from using them on an ongoing basis. Running a single instance of the process will heavily limit the ability for Annie's business to scale the service. Making multiple copies doesn't allow for a shared resource.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      90,
      67,
      82,
      83,
      72
    ],
    "source": "9781394211395"
  },
  {
    "id": 875,
    "question": "Nancy wants to adopt a backup strategy that will meet her organization's desires about the amount of data that could be lost in a scenario where a restoration from backup was required and also wants to establish guidelines for how long a restoration should take. What two key objectives should she set?",
    "choice_a": "An RPO and an RTO",
    "choice_b": "An RFBT and an RPO",
    "choice_c": "An RPO and an MTBF",
    "choice_d": "An MTBF and an RFBT",
    "correct_answer": "A",
    "explanation": "Organizations set recovery point objectives (RPOs) which describe how much data is acceptable to lose in a data loss event, and recovery time objectives (RTOs), which describe the maximum amount of time that it should take to recover data. Together these two objectives help guide backup strategy and infrastructure design and implementation. MTBF (mean time before failure) describes the mean time before a device like a hard drive, power supply, or network switch will fail, typically described in hours of powered\u2010on operation. RFBT was made up for this question.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      153,
      315,
      154,
      155,
      161
    ],
    "source": "9781394211395"
  },
  {
    "id": 876,
    "question": "John is running an IDS on his network. Users sometimes report that the IDS flags legitimate traffic as an attack. What describes this?",
    "choice_a": "False positive",
    "choice_b": "False negative",
    "choice_c": "False trigger",
    "choice_d": "False flag",
    "correct_answer": "A",
    "explanation": "When an intrusion detection system (IDS) or antivirus/antimalware mistakes legitimate traffic for an attack, this is called a false positive. A false negative is when the IDS mistakes an attack for legitimate traffic. It is the opposite of a false positive. Options C and D are both incorrect. Although these may be grammatically correct, these are not the terms used in the industry. In military operations, false flag operations attempt to transfer blame to another organization or adversary, thus a \u201cfalse flag.\u201d.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      156,
      211,
      151,
      161,
      212
    ],
    "source": "9781394211395"
  },
  {
    "id": 877,
    "question": "Enrique is concerned about backup data being infected by malware. The company backs up key servers to digital storage on a backup server. Which of the following would be most effective in preventing the backup data being infected by malware?",
    "choice_a": "Place the backup server on a separate VLAN.",
    "choice_b": "Air gap the backup server.",
    "choice_c": "Place the backup server on a different network segment.",
    "choice_d": "Use a honeynet.",
    "correct_answer": "B",
    "explanation": "Air gapping refers to the server not being on a network. This means literally that there is \u201cair\u201d between the server and the network. This prevents malware from infecting the backup server. A separate virtual local area network (VLAN) or physical network segment can enhance security but is not as effective as air gapping. A honeynet is used to detect attacks against a network, but it doesn't provide effective defense against malware in this scenario.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      212,
      193,
      11,
      154,
      153
    ],
    "source": "9781394211395"
  },
  {
    "id": 878,
    "question": "What type of system is used to control and monitor power plant power generation systems?",
    "choice_a": "IPG",
    "choice_b": "SEED",
    "choice_c": "SCADA",
    "choice_d": "ICD",
    "correct_answer": "C",
    "explanation": "SCADA, or supervisory control and data acquisition systems, are commonly used to manage facilities like power plants. The remaining options were made up.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      201,
      173,
      204,
      151,
      210
    ],
    "source": "9781394211395"
  },
  {
    "id": 879,
    "question": "Geoff wants to establish a contract with a company to have datacenter space that is equipped and ready to go so that he can bring his data to the location in the event of a disaster. What type of disaster recovery site is he looking for?",
    "choice_a": "A hot site",
    "choice_b": "A cold site",
    "choice_c": "A warm site",
    "choice_d": "An RTO site",
    "correct_answer": "C",
    "explanation": "Geoff is looking for a warm site, which has some or all of the infrastructure and systems he needs but does not have data. If a disaster occurs, Geoff can bring any equipment that he needs or wants to the site along with his organization's data to resume operations. A hot site is a fully functional environment with all the hardware, software, and data needed to operate an organization. They are expensive to maintain and run but are used by organizations that cannot take the risk of downtime. A cold site is a location that can be brought online but does not have systems; cold sites typically have access to power and bandwidth but need to be fully equipped to operate after a disaster since they are just rented space. An RTO is a recovery time objective, and it measures how long it should take to resume operations; it is not a type of disaster recovery site.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      158,
      153,
      157,
      150,
      161
    ],
    "source": "9781394211395"
  },
  {
    "id": 880,
    "question": "Olivia needs to ensure an IoT device does not have its operating system modified by third parties after it is sold. What solution should she implement to ensure that this does not occur?",
    "choice_a": "Set a default password.",
    "choice_b": "Require signed and encrypted firmware.",
    "choice_c": "Check the MD5sum for new firmware versions.",
    "choice_d": "Patch regularly.",
    "correct_answer": "B",
    "explanation": "If Olivia wants to ensure that third parties will be unable to modify the operating system for Internet of Things (IoT) devices, requiring signed and encrypted firmware for operating system updates is an effective means of stopping all but the most advanced threats. Setting a default password means that a common password will be known. Checking the MD5sum for new firmware versions will help administrators validate that the firmware is legitimate, but signed and encrypted firmware is a much stronger control. Finally, regular patching may help secure the devices but won't prevent OS modifications.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      185,
      204,
      193,
      8,
      222
    ],
    "source": "9781394211395"
  },
  {
    "id": 881,
    "question": "Maria is a security engineer with a manufacturing company. During a recent investigation, she discovered that an engineer's compromised workstation was being used to connect to SCADA systems while the engineer was not logged in. The engineer is responsible for administering the SCADA systems and cannot be blocked from connecting to them. What should Maria do to mitigate this threat?",
    "choice_a": "Install host\u2010based antivirus/antimalware software on the engineer's system.",
    "choice_b": "Implement account usage auditing on the SCADA system.",
    "choice_c": "Implement an NIPS on the SCADA system.",
    "choice_d": "Use FDE on the engineer's system.",
    "correct_answer": "B",
    "explanation": "Maria should implement ongoing auditing of the account usage on the SCADA system. This will provide a warning that someone's account is being used when they are not actually using it. Host\u2010based antivirus/antimalware is almost never a bad idea, but this scenario did not indicate that the compromise was due to malware, so antimalware may not address the threat. Since the engineer has access to the SCADA system, a network intrusion prevention system (NIPS) is unlikely to block them from accessing the system, and full\u2010disk encryption (FDE) will not mitigate this threat because the system is live and running, meaning that the disk will be decrypted in use.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      201,
      11,
      9,
      156,
      212
    ],
    "source": "9781394211395"
  },
  {
    "id": 882,
    "question": "Mike is a security analyst and has just removed malware from a virtual server. What feature of virtualization would he use to return the virtual server to a last known good state?",
    "choice_a": "Sandboxing",
    "choice_b": "Hypervisor",
    "choice_c": "Snapshot",
    "choice_d": "Elasticity",
    "correct_answer": "C",
    "explanation": "A snapshot is an image of the virtual machine (VM) at some point in time. It is standard practice to periodically take a snapshot of a virtual system so that you can return that system to a last known good state. Sandboxing is the process of isolating a system or software. The hypervisor is the mechanism through which the virtual environment interacts with the hardware, and elasticity is the ability for the system to scale.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      156,
      175,
      174,
      179,
      161
    ],
    "source": "9781394211395"
  },
  {
    "id": 883,
    "question": "Which of the following is not an advantage of a serverless architecture?",
    "choice_a": "It does not require a system administrator.",
    "choice_b": "It can scale as function call frequency increases.",
    "choice_c": "It can scale as function call frequency decreases.",
    "choice_d": "It is ideal for complex applications.",
    "correct_answer": "D",
    "explanation": "Serverless architectures do not require a system administrator because the provider manages the underlying function\u2010as\u2010a\u2010service (FaaS) capability. It can also scale up or scale down as needed, allowing it to be very flexible. Serverless architectures are typically not ideal for complex applications and instead tend to work better for microservices.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      170,
      172,
      175,
      173,
      151
    ],
    "source": "9781394211395"
  },
  {
    "id": 884,
    "question": "Which of the following is the most important benefit from implementing SDN?",
    "choice_a": "It will stop malware.",
    "choice_b": "It provides scalability.",
    "choice_c": "It will detect intrusions.",
    "choice_d": "It will prevent session hijacking.",
    "correct_answer": "B",
    "explanation": "Software\u2010defined networking (SDN) makes the network very scalable. It is relatively easy to add on new resources or remove unneeded resources, and it helps with high availability efforts. SDN does not stop malware, detect intrusions, or prevent session hijacking.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      170,
      157,
      177,
      151,
      159
    ],
    "source": "9781394211395"
  },
  {
    "id": 885,
    "question": "Derek has been asked to implement his organization's service\u2010oriented architecture as a set of microservices. What does he need to implement?",
    "choice_a": "A set of loosely coupled services with specific purposes",
    "choice_b": "A set of services that run on very small systems",
    "choice_c": "A set of tightly coupled services with custom\u2010designed protocols to ensure continuous operation",
    "choice_d": "A set of services using third\u2010party applications in a connected network enabled with industry standard protocols",
    "correct_answer": "A",
    "explanation": "A microservice architecture builds applications as a set of loosely coupled services that provide specific functions using lightweight protocols. It doesn't specifically define the size of the systems, but it is not a tightly coupled environment. Protocol choice is often open standards\u2013based, but the emphasis is on lightweight protocols. There is not a requirement that services be in\u2010house or third party exclusively.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      175,
      170,
      157,
      172,
      150
    ],
    "source": "9781394211395"
  },
  {
    "id": 886,
    "question": "Abigail is responsible for datacenters in a large, multinational company. She has to support multiple datacenters in diverse geographic regions. What would be the most effective way for her to manage these centers consistently across the enterprise?",
    "choice_a": "Hire datacenter managers for each center.",
    "choice_b": "Implement enterprise\u2010wide SDN.",
    "choice_c": "Implement infrastructure as code (IaC).",
    "choice_d": "Automate provisioning and deprovisioning.",
    "correct_answer": "C",
    "explanation": "The correct answer is to implement IaC. Infrastructure as code (IaC) is the process of managing and provisioning computer datacenters through machine\u2010readable definition files, rather than physical hardware configuration or interactive configuration tools. Whether the datacenter(s) use physical machines or virtual machines, this is an effective way to manage the datacenters. Although datacenter managers may be needed, that won't necessarily provide consistent management across the enterprise. Software\u2010defined networking (SDN) will not fix this problem, but it would help if Abigail needed to configure and manage her network based on usage and performance. Finally, this issue is not just about provisioning; it is about management.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      156,
      170,
      159,
      169,
      160
    ],
    "source": "9781394211395"
  },
  {
    "id": 887,
    "question": "Naomi wants to secure a real\u2010time operating system (RTOS). Which of the following techniques is best suited to providing RTOS security?",
    "choice_a": "Disable the web browser.",
    "choice_b": "Install a host firewall.",
    "choice_c": "Use secure firmware.",
    "choice_d": "Install antimalware software.",
    "correct_answer": "C",
    "explanation": "Using secure firmware, as well as using an RTOS with time and space partitioning, are both common methods to help ensure RTOS security. Unlike traditional operating systems, real\u2010time operating systems are used in applications where they need to deal with inputs immediately. That means that adding additional load like firewalls and antimalware is not a typical component in RTOS applications. For similar reasons, you're unlikely to find a web browser on most devices running an RTOS.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      204,
      201,
      185,
      218,
      151
    ],
    "source": "9781394211395"
  },
  {
    "id": 888,
    "question": "Ben has been asked to explain the security implications for an embedded system that his organization is considering building and selling. Which of the following is not a typical concern for embedded systems?",
    "choice_a": "Limited processor power",
    "choice_b": "An inability to patch",
    "choice_c": "Lack of authentication capabilities",
    "choice_d": "Lack of bulk storage",
    "correct_answer": "D",
    "explanation": "Embedded systems can bring a broad range of security implications, many of which are driven by the limited capabilities of the processors and hardware they are frequently built with. Low\u2010power consumption designs may lack computational power and thus have challenges implementing strong cryptography, network connectivity, and other similar problems. Patching embedded systems can be challenging both because of where they are deployed and because of a lack of connectivity for them\u2014in fact, in many environments, you may not want the devices to be connected to your network. Since many don't have a screen, keyboard, or a network connection, authentication is also a problem. Few embedded devices, however, need bulk storage, making the lack of bulk storage a problem that typically isn't a major concern.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      204,
      173,
      193,
      211,
      151
    ],
    "source": "9781394211395"
  },
  {
    "id": 889,
    "question": "Madhuri has configured a backup that will back up all of the changes to a system since the last time that a full backup occurred. What type of backup has she set up?",
    "choice_a": "A snapshot",
    "choice_b": "A full backup",
    "choice_c": "An incremental backup",
    "choice_d": "A differential",
    "correct_answer": "D",
    "explanation": "Differential backups back up all of the changes since the last full backup. An incremental backup backs up all changes since the last incremental backup. A snapshot captures machine state and the full drive at a bitwise level, and full backups are a complete copy of a system but typically do not include the memory state.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      152,
      153,
      154,
      155,
      161
    ],
    "source": "9781394211395"
  },
  {
    "id": 890,
    "question": "Devin is building a cloud system and wants to ensure that it can adapt to changes in its workload by provisioning or deprovisioning resources automatically. His goal is to ensure that the environment is not overprovisioned or underprovisioned and that he is efficiently spending money on his infrastructure. What concept describes this?",
    "choice_a": "Vertical scalability",
    "choice_b": "Elasticity",
    "choice_c": "Horizontal scalability",
    "choice_d": "Normalization",
    "correct_answer": "B",
    "explanation": "Elasticity is a cloud computing concept that matches resources to demand to ensure that an infrastructure closely matches the needs of the environment. Scalability is the ability to grow or shrink as needed but does not directly include the concept of matching to workload. Normalization is a code development concept used to ensure that data is in a consistent form.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      170,
      157,
      159,
      168,
      151
    ],
    "source": "9781394211395"
  },
  {
    "id": 891,
    "question": "Nathaniel wants to improve the fault tolerance of a server in his datacenter. If he wants to ensure that a power outage does not cause the server to lose power, what is the first control he should deploy from the following list?",
    "choice_a": "A UPS",
    "choice_b": "A generator",
    "choice_c": "Dual power supplies",
    "choice_d": "Managed power units (PDUs)",
    "correct_answer": "A",
    "explanation": "An uninterruptable power supply (UPS) should be Nathaniel's first priority. Ensuring that power is not disrupted during an outage and can be maintained for a short period until alternate power like a generator can come online is critical, and a UPS can provide that capability. A generator alone will take longer to come online, resulting in an outage. Dual power supplies can help to build resilience by allowing multiple power sources and avoiding issues if a power supply does fail, but that is not the focus of the question. A managed power distribution unit (PDU) provides remote management and power monitoring but will not prevent power loss in an outage.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      150,
      151,
      160,
      152,
      159
    ],
    "source": "9781394211395"
  },
  {
    "id": 892,
    "question": "George is a network administrator at a power plant. He notices that several turbines had unusual ramp\u2010ups in cycles last week. After investigating, he finds that an executable was uploaded to the system control console and caused this. Which of the following would be most effective in preventing this from affecting the SCADA system in the future?",
    "choice_a": "Implement SDN.",
    "choice_b": "Improve patch management.",
    "choice_c": "Place the SCADA system on a separate VLAN.",
    "choice_d": "Implement encrypted data transmissions.",
    "correct_answer": "C",
    "explanation": "Separating the SCADA (supervisory control and data acquisition) system from the main network makes it less likely that the SCADA system can be affected from the main network. This includes malware as well as human action. Software\u2010defined networking (SDN) would make isolating the SCADA system easier but would not actually isolate it. Patch management is always important, but in this case, it would not have prevented the issue. Encrypted data transmissions, such as TLS, would have no effect on this situation.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      201,
      212,
      11,
      177,
      193
    ],
    "source": "9781394211395"
  },
  {
    "id": 893,
    "question": "Mia is a network administrator for a bank. She is responsible for secure communications with her company's customer website. Which of the following would be the best for her to implement?",
    "choice_a": "SSL",
    "choice_b": "PPTP",
    "choice_c": "IPSec",
    "choice_d": "TLS",
    "correct_answer": "D",
    "explanation": "Transport Layer Security (TLS) provides a reliable method of encrypting web traffic. It supports mutual authentication and is considered secure. Although Secure Sockets Layer (SSL) can encrypt web traffic, TLS was created in 1999 as its successor. Although many network administrators still use the term SSL, in most cases today what you are using is actually TLS, not the outdated SSL. Point\u2010to\u2010point Tunneling Protocol (PPTP) and Internet Protocol Security (IPSec) are protocols for establishing a VPN, not for encrypting web traffic.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      222,
      8,
      210,
      218,
      177
    ],
    "source": "9781394211395"
  },
  {
    "id": 894,
    "question": "Nora has rented a building with access to bandwidth and power in case her organization ever experiences a disaster. What type of site has she established?",
    "choice_a": "A hot site",
    "choice_b": "A cold site",
    "choice_c": "A warm site",
    "choice_d": "A MOU site",
    "correct_answer": "B",
    "explanation": "Nora has established a cold site. A cold site is a location that can be brought online but does not have systems; cold sites typically have access to power and bandwidth, but they need to be fully equipped to operate after a disaster since they are just rented space. Warm sites have some or all of the infrastructure and systems Nora needs but does not have data. A hot site is a fully functional environment with all of the hardware, software, and data needed to operate an organization. They are expensive to maintain and run but are used by organizations that cannot take the risk of downtime. A MOU is a memorandum of understanding and is not a type of disaster recovery site.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      158,
      159,
      161,
      315,
      150
    ],
    "source": "9781394211395"
  },
  {
    "id": 895,
    "question": "Mike is concerned about data sovereignty for data that his organization captures and maintains. What best describes his concern?",
    "choice_a": "Who owns the data that is captured on systems hosted in a cloud provider's infrastructure?",
    "choice_b": "Can Mike's organization make decisions about data that is part of its service, or does it belong to users?",
    "choice_c": "Is the data located in a country subject to the laws of the country where it is stored?",
    "choice_d": "Does data have rights on its own, or does the owner of the data determine what rights may apply to it?",
    "correct_answer": "C",
    "explanation": "Data sovereignty refers to the concept that data that is collected and stored in a country is subject to that country's laws. This can be a complex issue with multinational cloud services and providers that may store data in multiple countries as part of their normal architecture. It may also create compliance and other challenges based on differences in national laws regarding data, data privacy, and similar issues.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      179,
      180,
      169,
      11,
      319
    ],
    "source": "9781394211395"
  },
  {
    "id": 896,
    "question": "What are the key limiting factors for cryptography on low\u2010power devices?",
    "choice_a": "There are system limitations on memory, CPU, and storage.",
    "choice_b": "The devices cannot support public key encryption due to an inability to factor prime numbers.",
    "choice_c": "There is a lack of chipset support for encryption.",
    "choice_d": "Legal limitations for low\u2010power devices prevent encryption from being supported.",
    "correct_answer": "A",
    "explanation": "Low\u2010power devices typically have limited processor speed, memory, and storage, meaning that encryption can be a challenge. Fortunately, solutions exist that implement low\u2010power cryptographic processing capabilities, and continued advances in processor design continue to make lower\u2010power processors faster and more efficient. Legal limitations do not typically take into account whether a device is a low\u2010power device, and public key encryption can be implemented on a wide range of CPUs and embedded systems, so factoring prime numbers is unlikely to be an issue.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      204,
      190,
      173,
      201,
      182
    ],
    "source": "9781394211395"
  },
  {
    "id": 897,
    "question": "Elaine wants to adopt appropriate response and recovery controls for natural disasters. What type of control should she use to prepare for a multi\u2010hour power outage caused by a tornado?",
    "choice_a": "A hot site",
    "choice_b": "A generator",
    "choice_c": "A PDU",
    "choice_d": "A UPS",
    "correct_answer": "B",
    "explanation": "A generator is the most appropriate answer to a multi\u2010hour outage. Although a hot site would allow her organization to stay online, the cost of a hot site is much higher than that of a generator. A PDU, or power distribution unit, is used to manage and distribute power, not to handle power outages. Finally, UPS systems are not typically designed to handle long outages. Instead, they condition power and ensure that systems remain online long enough for a generator to take over providing power.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      315,
      150,
      158,
      160,
      161
    ],
    "source": "9781394211395"
  },
  {
    "id": 898,
    "question": "Tim wants to ensure that his web servers can scale horizontally during traffic increases, while also allowing them to be patched or upgraded without causing outages. What type of network device should he deploy?",
    "choice_a": "A firewall",
    "choice_b": "A switch",
    "choice_c": "A horizontal scaler",
    "choice_d": "A network load balancer",
    "correct_answer": "D",
    "explanation": "Network load balancers distribute traffic among systems, allowing systems to be added or removed, and making patching and upgrades easier by draining connections from systems and removing them from the pool when work needs to be done on them. They can also help monitor systems for performance, report on issues, and ensure that loads match the capabilities of the systems that they are in front of. Firewalls are used for security, switches are a network device used to transfer traffic to the correct system, and a horizontal scaler was made up for this question.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      157,
      150,
      170,
      218,
      211
    ],
    "source": "9781394211395"
  },
  {
    "id": 899,
    "question": "Nathaniel has deployed the control infrastructure for his manufacturing plant without a network connection to his other networks. What term describes this type of configuration?",
    "choice_a": "Screened subnet",
    "choice_b": "Air gap",
    "choice_c": "Vaulting",
    "choice_d": "A hot aisle",
    "correct_answer": "B",
    "explanation": "Nathaniel has created an air gap, a physical separation that will require manual transport of files, patches, and other data between the two environments. This helps to ensure that attackers cannot access critical systems and that insiders cannot export data from the environment easily. A screened subnet, also known as a demilitarized zone (DMZ), is a separate network segment or zone that is exposed to the outside world or other lower trust area. A vault is a secured space or room. Hot and cold isles are equipment arrangements used in server rooms or datacenters to efficiently circulate air and keep server racks and other equipment cool.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      212,
      211,
      11,
      201,
      193
    ],
    "source": "9781394211395"
  },
  {
    "id": 900,
    "question": "Chris is preparing to implement an 802.1X\u2010enabled wireless infrastructure. He knows that he wants to use an Extensible Authentication Protocol (EAP)\u2010based protocol that does not require client\u2010side certificates. Which of the following options should he choose?",
    "choice_a": "EAP\u2010MD5",
    "choice_b": "PEAP",
    "choice_c": "LEAP",
    "choice_d": "EAP\u2010TLS",
    "correct_answer": "B",
    "explanation": "The option that best meets the needs described is PEAP, the Protected Extensible Authentication Protocol. PEAP relies on server\u2010side certificates and on tunneling to ensure communications security. EAP\u2010MD5 is not recommended for wireless networks and does not support mutual authentication of the wireless client and network. LEAP, the Lightweight Extensible Authentication Protocol, uses WEP keys for its encryption and is not recommended due to security issues. Finally, EAP\u2010TLS, or EAP Transport Layer Security, requires certificates on both the client and server, consuming more management overhead.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      232,
      222,
      210,
      193,
      231
    ],
    "source": "9781394211395"
  },
  {
    "id": 901,
    "question": "Olivia is implementing a load\u2010balanced web application cluster. Her organization already has a redundant pair of load balancers, but each unit is not rated to handle the maximum designed throughput of the cluster by itself. Olivia has recommended that the load balancers be implemented in an active/active design. What concern should she raise as part of this recommendation?",
    "choice_a": "The load balancer cluster cannot be patched without a service outage.",
    "choice_b": "The load balancer cluster is vulnerable to a denial\u2010of\u2010service attack.",
    "choice_c": "If one of the load balancers fails, it could lead to service degradation.",
    "choice_d": "The load balancer cannot handle the throughput due to having two active nodes.",
    "correct_answer": "C",
    "explanation": "Olivia should make her organization aware that a failure in one of the active nodes would result in less maximum throughput and a potential for service degradation. Since services are rarely run at maximum capacity, and many can have maintenance windows scheduled, this does not mean that the load balancers cannot be patched. There is nothing in this design that makes the load balancers more vulnerable to denial\u2010of\u2010service than they would be under any other design. Having two active nodes will typically increase throughput over a single node.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      217,
      150,
      151,
      157,
      315
    ],
    "source": "9781394211395"
  },
  {
    "id": 902,
    "question": "Mark is responsible for managing his company's load balancer and wants to use a load\u2010balancing scheduling technique that will take into account the current server load and active sessions. Which of the following techniques should he choose?",
    "choice_a": "Round\u2010robin",
    "choice_b": "Weighted response time",
    "choice_c": "Least connection",
    "choice_d": "Source IP hashing",
    "correct_answer": "C",
    "explanation": "Least connection\u2013based load balancing takes load into consideration and sends the next request to the server with the least number of active sessions. Round\u2010robin simply distributes requests to each server in order, whereas weighted time uses health checks to determine which server responds the most quickly on an ongoing basis and then sends the traffic to that server. Finally, source IP hashing uses the source and destination IP addresses to generate a hash key and then uses that key to track sessions, allowing interrupted sessions to be reallocated to the same server, and thus allowing the sessions to continue.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      217,
      150,
      151,
      170,
      159
    ],
    "source": "9781394211395"
  },
  {
    "id": 903,
    "question": "Ramon is building a new web service and is considering which parts of the service should use Transport Layer Security (TLS). Components of the application include: <ol> <li>Authentication</li> <li>A payment form</li> <li>User data, including address and shopping cart</li> <li>A user comments and reviews section</li> </ol> <p><b></b>Where should he implement TLS?",
    "choice_a": "At points 1 and 2, and 4",
    "choice_b": "At points 2 and 3, and 4",
    "choice_c": "At points 1, 2, and 3",
    "choice_d": "At all points in the infrastructure",
    "correct_answer": "D",
    "explanation": "The safest and most secure answer is that Ramon should simply implement TLS for the entire site. Although TLS does introduce some overhead, modern systems can handle large numbers of simultaneous TLS connections, making a secure website an easy answer in almost all cases.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      222,
      8,
      316,
      211,
      151
    ],
    "source": "9781394211395"
  },
  {
    "id": 904,
    "question": "Which device would most likely process the following rules? <br> <code>PERMIT IP ANY EQ 443</code> <br> <code>DENY IP ANY ANY</code> <br>",
    "choice_a": "NIPS",
    "choice_b": "HIPS",
    "choice_c": "Content filter",
    "choice_d": "Firewall",
    "correct_answer": "D",
    "explanation": "A firewall has two types of rules. One type is to allow specific traffic on a given port. The other type of rule is to deny traffic. What is shown here is a typical firewall rule. Options A, B, and C are incorrect. The rule shown is clearly a firewall rule.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      218,
      211,
      210,
      177,
      213
    ],
    "source": "9781394211395"
  },
  {
    "id": 905,
    "question": "Charles wants to use IPSec and needs to be able to determine the IPSec policy for traffic based on the port it is being sent to on the remote system. Which IPSec mode should he use?",
    "choice_a": "IPSec tunnel mode",
    "choice_b": "IPSec PSK mode",
    "choice_c": "IPSec IKE mode",
    "choice_d": "IPSec transport mode",
    "correct_answer": "D",
    "explanation": "Unlike IPSec's tunnel mode, IPSec transport mode allows different policies per port. The IP addresses in the outer header for transport mode packets are used to determine the policy applied to the packet. IPSec doesn't have a PSK mode, but WPA2 does. IKE is used to set up security associations in IPSec but doesn't allow this type of mode setting.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      222,
      210,
      232,
      11,
      8
    ],
    "source": "9781394211395"
  },
  {
    "id": 906,
    "question": "What two connection methods are used for most geofencing applications?",
    "choice_a": "Cellular and GPS",
    "choice_b": "USB and Bluetooth",
    "choice_c": "GPS and Wi\u2010Fi",
    "choice_d": "Cellular and Bluetooth",
    "correct_answer": "C",
    "explanation": "Global Positioning System (GPS) data and data about local Wi\u2010Fi networks are the two most commonly used protocols to help geofencing applications determine where they are. When a known Wi\u2010Fi signal is gained or lost, the geofencing application knows it is within range of that network. GPS data is even more useful because it can work in most locations and provide accurate location data. Although Bluetooth is sometimes used for geofencing, its limited range means that it is a third choice. Cellular information would require accurate tower\u2010based triangulation, which means it is not typically used for geofencing applications, and of course USB is a wired protocol.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      204,
      193,
      173,
      232,
      231
    ],
    "source": "9781394211395"
  },
  {
    "id": 907,
    "question": "Jason wants to implement a remote access virtual private network (VPN) for users in his organization who primarily rely on hosted web applications. What common VPN type is best suited to this if he wants to avoid deploying client software to his end\u2010user systems?",
    "choice_a": "A TLS VPN",
    "choice_b": "An RDP (Remote Desktop Protocol) VPN",
    "choice_c": "An Internet Control Message Protocol (ICMP) VPN",
    "choice_d": "An IPSec VPN",
    "correct_answer": "A",
    "explanation": "A Transport Layer Security (TLS) VPN is frequently chosen when ease of use is important, and web applications are the primary usage mode. RDP is a remote access tool, not a VPN tool, and ICMP is used for things like ping, not for VPN. IPSec VPNs are used for site\u2010to\u2010site VPNs and for purposes where other protocols may be needed, because they make the endpoint system appear to be on the remote network.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      222,
      177,
      210,
      218,
      211
    ],
    "source": "9781394211395"
  },
  {
    "id": 908,
    "question": "Binary data is an example of what type of data?",
    "choice_a": "Non\u2010human\u2010readable",
    "choice_b": "Encrypted",
    "choice_c": "Human\u2010readable",
    "choice_d": "Masked",
    "correct_answer": "A",
    "explanation": "Binary data is a form of non\u2010human\u2010readable data. Encrypted data may be in binary format, but not all binary data is encrypted. Binary data is not human\u2010readable, nor is it masked, which hides elements of data to allow for it to be used without exposing the underlying data.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      318,
      10,
      316,
      319,
      9
    ],
    "source": "9781394211395"
  },
  {
    "id": 909,
    "question": "What IP address does a load balancer provide for external connections to connect to web servers in a load\u2010balanced group?",
    "choice_a": "The IP address for each server, in a prioritized order",
    "choice_b": "The load balancer's IP address",
    "choice_c": "The IP address for each server in a round\u2010robin order",
    "choice_d": "A virtual IP address",
    "correct_answer": "D",
    "explanation": "Load balancers provide a virtual IP, or VIP. Traffic sent to the VIP is directed to servers in the pool based on the load\u2010balancing scheme that that pool is using\u2014often a round\u2010robin scheme, but other versions that include priority order and capacity tracking or ratings are also common. The load balancer's IP address is normally used to administer the system, and individual IP addresses for the clustered hosts are shielded by the load balancer to prevent traffic from consistently going to those hosts, thus creating a failure or load point.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      217,
      157,
      150,
      177,
      159
    ],
    "source": "9781394211395"
  },
  {
    "id": 910,
    "question": "Matt has enabled port security on the network switches in his building. What does port security do?",
    "choice_a": "Filters by MAC address",
    "choice_b": "Prevents routing protocol updates from being sent from protected ports",
    "choice_c": "Establishes private VLANs",
    "choice_d": "Prevents duplicate MAC addresses from connecting to the network",
    "correct_answer": "A",
    "explanation": "Port security filters by MAC address, permitting allow listed MAC addresses to connect to the port and blocking block listed MAC addresses. Port security can be static, using a predetermined list or dynamically allowing a specific number of addresses to connect, or it can be run in a combination mode of both static and dynamic modes.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      210,
      211,
      193,
      177,
      11
    ],
    "source": "9781394211395"
  },
  {
    "id": 911,
    "question": "Tom is responsible for VPN connections in his company. His company uses IPSec for VPNs. What is the primary purpose of AH in IPSec?",
    "choice_a": "Encrypt the entire packet.",
    "choice_b": "Encrypt just the header.",
    "choice_c": "Authenticate the entire packet.",
    "choice_d": "Authenticate just the header.",
    "correct_answer": "C",
    "explanation": "Authentication headers (AHs) provide complete packet integrity, authenticating the packet and the header. Authentication headers do not provide any encryption at all, and authentication headers authenticate the entire packet, not just the header.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      210,
      8,
      212,
      218,
      9
    ],
    "source": "9781394211395"
  },
  {
    "id": 912,
    "question": "Abigail is responsible for setting up a network\u2010based intrusion prevention system (NIPS) on her network. The NIPS is located in one particular network segment. She is looking for a passive method to get a copy of all traffic to the NIPS network segment so that it can analyze the traffic. Which of the following would be her best choice?",
    "choice_a": "Using a network tap",
    "choice_b": "Using port mirroring",
    "choice_c": "Setting the NIPS on a VLAN that is connected to all other segments",
    "choice_d": "Setting up a NIPS on each segment",
    "correct_answer": "A",
    "explanation": "Network taps copy all traffic to another destination, allowing traffic visibility without a device inline. They are completely passive methods of getting network traffic to a central location. Port mirroring would get all the traffic to the network\u2010based intrusion prevention system (NIPS) but is not completely passive. It requires the use of resources on switches to route a copy of the traffic. Incorrect switch configurations can cause looping. Configuring loop detection can prevent looped ports. Putting a network NIPS on every segment can be very expensive and require extensive configuration work. Setting up a NIPS on each segment would also dramatically increase administrative efforts.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      211,
      212,
      193,
      9,
      210
    ],
    "source": "9781394211395"
  },
  {
    "id": 913,
    "question": "Janice is explaining how IPSec works to a new network administrator. She is trying to explain the role of IKE. Which of the following most closely matches the role of IKE in IPSec?",
    "choice_a": "It encrypts the packet.",
    "choice_b": "It establishes the SAs.",
    "choice_c": "It authenticates the packet.",
    "choice_d": "It establishes the tunnel.",
    "correct_answer": "B",
    "explanation": "Internet key exchange (IKE) is used to set up security associations (SAs) on each end of the tunnel. The security associations have all the settings (i.e., cryptographic algorithms, hashes) for the tunnel. IKE is not directly involved in encrypting or authenticating. IKE itself does not establish the tunnel\u2014it establishes the SAs.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      222,
      190,
      177,
      211,
      182
    ],
    "source": "9781394211395"
  },
  {
    "id": 914,
    "question": "Emily manages the IDS/IPS for her network. She has a network\u2010based intrusion prevention system (NIPS) installed and properly configured. It is not detecting obvious attacks on one specific network segment. She has verified that the NIPS is properly configured and working properly. What would be the most efficient way for her to address this?",
    "choice_a": "Implement port mirror/monitor mode for that segment.",
    "choice_b": "Install a NIPS on that segment.",
    "choice_c": "Upgrade to a more effective NIPS.",
    "choice_d": "Isolate that segment on its own VLAN.",
    "correct_answer": "A",
    "explanation": "The NIPS is not seeing the traffic on that network segment. By implementing port mirroring, the traffic from that segment can be copied to the segment where the NIPS is installed. Installing a network IPS on the segment would require additional resources. This would work but is not the most efficient approach. Nothing in this scenario suggests that the NIPS is inadequate. It just is not seeing all the traffic. Finally, isolating the segment to its own VLAN would isolate that network segment but would still not allow the NIPS to analyze the traffic from that segment.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      211,
      193,
      212,
      150,
      151
    ],
    "source": "9781394211395"
  },
  {
    "id": 915,
    "question": "You are responsible for an e\u2010commerce site. The site is hosted in a cluster. Which of the following techniques would be best in assuring availability?",
    "choice_a": "A VPN concentrator",
    "choice_b": "Aggregate switching",
    "choice_c": "An SSL accelerator",
    "choice_d": "Load balancing",
    "correct_answer": "D",
    "explanation": "Load\u2010balancing the cluster will prevent any single server from being overloaded. And if a given server is offline, other servers can take on its workload. A VPN concentrator, as the name suggests, is used to initiate virtual private networks (VPNs). Aggregate switching can shunt more bandwidth to the servers but won't mitigate the threat of one or more servers being offline. SSL accelerators are a method of offloading processor\u2010intensive public key encryption for Transport Layer Security (TLS) and Secure Sockets Layer (SSL) to a hardware accelerator.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      150,
      170,
      177,
      151,
      158
    ],
    "source": "9781394211395"
  },
  {
    "id": 916,
    "question": "Ryan is concerned about the security of his company's web application. Since the application processes confidential data, he is most concerned about data exposure. Which of the following would be the most important for him to implement?",
    "choice_a": "WAF",
    "choice_b": "TLS",
    "choice_c": "NIPS",
    "choice_d": "NIDS",
    "correct_answer": "B",
    "explanation": "The correct answer is to encrypt all the web traffic to this application using Transport Layer Security (TLS). This is one of the most fundamental security steps to take with any website. A web application firewall (WAF) is probably a good idea, but it is not the most important thing for Ryan to implement. While a network\u2010based intrusion prevention system (NIPS) or network\u2010based intrusion detection system (NIDS) may be a good idea, those should be considered after TLS is configured.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      8,
      222,
      9,
      318,
      11
    ],
    "source": "9781394211395"
  },
  {
    "id": 917,
    "question": "Claire has been notified of a zero\u2010day flaw in a web application. She has the exploit code, including a SQL injection attack that is being actively exploited. How can she quickly react to prevent this issue from impacting her environment if she needs the application to continue to function?",
    "choice_a": "Deploy a detection rule to her IDS.",
    "choice_b": "Manually update the application code after reverse\u2010engineering it.",
    "choice_c": "Deploy a fix via her WAF.",
    "choice_d": "Install the vendor\u2010provided patch.",
    "correct_answer": "C",
    "explanation": "Claire's best option is to deploy a detection and fix via her web application firewall (WAF) that will detect the SQL injection (SQLi) attempt and prevent it. An intrusion detection system (IDS) only detects attacks and cannot stop them. Manually updating the application code after reverse\u2010engineering it will take time, and she may not even have the source code or the ability to modify it. Finally, vendor patches for zero days typically take some time to come out even in the best of circumstances, meaning that Claire could be waiting on a patch for quite a while if that is the option she chooses.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      218,
      179,
      151,
      210,
      156
    ],
    "source": "9781394211395"
  },
  {
    "id": 918,
    "question": "Christina wants to ensure that session persistence is maintained by her load balancer. What is she attempting to do?",
    "choice_a": "Ensure that all of a client's requests go to the same server for the duration of a given session or transaction.",
    "choice_b": "Assign the same internal IP address to clients whenever they connect through the load balancer.",
    "choice_c": "Ensure that all transactions go to the current server in a round\u2010robin during the time it is the primary server.",
    "choice_d": "Assign the same external IP address to all servers whenever they are the primary server assigned by the load balancer.",
    "correct_answer": "A",
    "explanation": "Session persistence makes sure that all of a client's traffic for a transaction or session goes to the same server or service. The remaining options do not properly describe how session persistence works.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      217,
      157,
      150,
      151,
      180
    ],
    "source": "9781394211395"
  },
  {
    "id": 919,
    "question": "Next\u2010generation firewalls include many cutting\u2010edge features. Which of the following is not a common next\u2010generation firewall capability?",
    "choice_a": "Geolocation",
    "choice_b": "IPS and/or IDS",
    "choice_c": "Sandboxing",
    "choice_d": "SQL injection",
    "correct_answer": "D",
    "explanation": "Although next\u2010generation firewalls (NGFWs) provide may defensive capabilities, SQL injection (SQLi) is an attack instead of a defense. In addition to geolocation, intrusion detection system (IDS) and intrusion prevention system (IPS), and sandboxing capabilities, many next\u2010generation firewalls include web application firewalls, load balancing, IP reputation and URL filtering, and antimalware and antivirus features.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      218,
      217,
      9,
      193,
      211
    ],
    "source": "9781394211395"
  },
  {
    "id": 920,
    "question": "Patrick has been asked to identify a UTM appliance for his organization. Which of the following capabilities is not a common feature for a UTM device?",
    "choice_a": "IDS and or IPS",
    "choice_b": "Antivirus/antimalware",
    "choice_c": "MDM",
    "choice_d": "DLP",
    "correct_answer": "C",
    "explanation": "UTM, or unified threat management, devices commonly serve as firewalls, intrusion detection system (IDS)/intrusion prevention system (IPS), antivirus/antimalware, web proxies, web application and deep packet inspection, secure email gateways, data loss prevention (DLP), security information and event management (SIEM), and even virtual private networking (VPN) devices. They aren't mobile device management (MDM) or universal endpoint management devices, however, since their primary focus is on network security, not systems or device management.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      218,
      9,
      235,
      211,
      193
    ],
    "source": "9781394211395"
  },
  {
    "id": 921,
    "question": "Theresa implements a network\u2010based IDS. What can she do to traffic that passes through the IDS?",
    "choice_a": "Review the traffic based on rules and detect and alert about unwanted or undesirable traffic.",
    "choice_b": "Review the traffic based on rules and detect and stop traffic based on those rules.",
    "choice_c": "Detect sensitive data being sent to the outside world and encrypt it as it passes through the IDS.",
    "choice_d": "All of the above.",
    "correct_answer": "A",
    "explanation": "IDSs, or intrusion detection systems, can only detect unwanted and malicious traffic based on the detection rules and signatures that they have. They cannot stop traffic or modify it. An IPS, or intrusion prevention system, that is placed in line with network traffic can take action on that traffic. Thus, IDSs are often used when it is not acceptable to block network traffic, or when a tap or other network device is used to clone traffic for inspection.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      211,
      213,
      9,
      193,
      210
    ],
    "source": "9781394211395"
  },
  {
    "id": 922,
    "question": "Murali is building his organization's container security best practices document and wants to ensure that he covers the most common items for container security. Which of the following is not a specific concern for containers?",
    "choice_a": "The security of the container host",
    "choice_b": "Securing the management stack for the container",
    "choice_c": "Insider threats",
    "choice_d": "Monitoring network traffic to and from the containers for threats and attacks",
    "correct_answer": "C",
    "explanation": "Although insider threats are a concern, they're not any different for containers than any other system. Ensuring container host security, securing the management stack, and making sure that network traffic to and from containers is secure are all common container security concerns.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      175,
      177,
      182,
      11,
      193
    ],
    "source": "9781394211395"
  },
  {
    "id": 923,
    "question": "Fred sets up his authentication and authorization system to apply the following rules to authenticated users: <ul> <li>Users who are not logging in from inside the trusted network must use multifactor authentication.</li> <li>Users who have logged in from geographic locations that are more than 100 miles apart within 15 minutes will be denied.</li> </ul> <b></b> <p>What type of access control is Fred using?",
    "choice_a": "Geographic restrictions",
    "choice_b": "Time\u2010based logins",
    "choice_c": "Supervisory control",
    "choice_d": "Role\u2010based access",
    "correct_answer": "A",
    "explanation": "This is an example of using geographic restrictions to protect data. Fred has rules that require additional authentication for those who are off\u2010site and also those who may be performing impossible travel. Time is not part of both rules, there's no role description, and supervisory control is not a term used for this.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      11,
      212,
      193,
      182,
      169
    ],
    "source": "9781394211395"
  },
  {
    "id": 924,
    "question": "Maria is responsible for security at a small company. She is concerned about unauthorized devices being connected to the network. She is looking for a device authentication process. Which of the following would be the best choice for her?",
    "choice_a": "CHAP",
    "choice_b": "Kerberos",
    "choice_c": "802.11i",
    "choice_d": "802.1X",
    "correct_answer": "D",
    "explanation": "802.1X is the IEEE standard for port\u2010based network access control. This protocol is frequently used to authenticate devices. Challenge Handshake Authentication Protocol (CHAP) is an authentication protocol but not the best choice for device authentication. Kerberos is an authentication protocol but not the best choice for device authentication. 802.11i is the Wi\u2010Fi security standard and is fully implemented in WPA2 and WPA3. It is not a device authentication procedure.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      210,
      11,
      193,
      212,
      231
    ],
    "source": "9781394211395"
  },
  {
    "id": 925,
    "question": "Jason is considering deploying a network intrusion prevention system (IPS) and wants to be able to detect advanced persistent threats (APTs). What type of IPS detection method is most likely to detect the behaviors of an APT after it has gathered baseline information about normal operations?",
    "choice_a": "Signature\u2010based IPS detections",
    "choice_b": "Heuristic\u2010based IPS detections",
    "choice_c": "Malicious tool hash IPS detections",
    "choice_d": "Anomaly\u2010based IPS detections",
    "correct_answer": "D",
    "explanation": "Anomaly\u2010based detection systems build a behavioral baseline for networks and then assess differences from those baselines. They may use heuristic capabilities on top of those, but the question specifically asks about baselined operations pointing to an anomaly\u2010based system. Heuristic\u2010based detections look for behaviors that are typically malicious, and signature\u2010based or hash\u2010based detections look for known malicious tools or files.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      168,
      169,
      170,
      180,
      159
    ],
    "source": "9781394211395"
  },
  {
    "id": 926,
    "question": "Mila wants to generate a unique digital fingerprint for a file, and needs to choose between a checksum and a hash. Which option should she choose and why should she choose it?",
    "choice_a": "A hash, because it is unique to the file",
    "choice_b": "A checksum, because it verifies the contents of the file",
    "choice_c": "A hash, because it can be reversed to validate the file",
    "choice_d": "A checksum, because it is less prone to collisions than a hash",
    "correct_answer": "A",
    "explanation": "Mila should select a hash because a hash is designed to be unique to each possible input. That means that multiple files could have the same checksum value, whereas a hashing algorithm will be unique for each file that it is run against.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      318,
      10,
      9,
      11,
      319
    ],
    "source": "9781394211395"
  },
  {
    "id": 927,
    "question": "Mila gives her team a scenario, and then asks them questions about how they would respond, what issues they expect they might encounter, and how they would handle those issues. What type of exercise has she conducted?",
    "choice_a": "A tabletop exercise",
    "choice_b": "A walk\u2010through",
    "choice_c": "A simulation",
    "choice_d": "A drill",
    "correct_answer": "A",
    "explanation": "Tabletop exercises are used to talk through a process. Unlike walk\u2010throughs, which focus on a step\u2010by\u2010step review of an incident, Mila will focus more on how her team responds and on learning from those answers. A tabletop exercise can involve gaming out a situation. A simulation actually emulates an event or incident, either on a small or a large scale. Drills are not defined as part of the Security+ exam outline.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      161,
      151,
      315,
      158,
      153
    ],
    "source": "9781394211395"
  },
  {
    "id": 928,
    "question": "Jerome needs to explain the key difference between high availability and fault tolerance to his management. What is the major difference between the two?",
    "choice_a": "High availability is designed to avoid service interruptions almost entirely, whereas fault\u2010tolerant environments have minimal service disruptions.",
    "choice_b": "High availability provides services, whereas fault tolerance handles issues.",
    "choice_c": "High availability focuses on data, whereas fault tolerance focuses on infrastructure.",
    "choice_d": "High availability has minimal service interruptions, whereas fault\u2010tolerant environments are designed to avoid service interruptions almost entirely.",
    "correct_answer": "D",
    "explanation": "High\u2010availability designs are less expensive because they attempt to minimize service interruptions, whereas fault\u2010tolerant designs seek to avoid service interruptions almost entirely, and thus cost significantly more. Both focus on service availability and typically use both hardware and software tools to meet their goals.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      150,
      157,
      151,
      159,
      161
    ],
    "source": "9781394211395"
  },
  {
    "id": 929,
    "question": "What element of the CIA triad is geographic dispersion intended to help with?",
    "choice_a": "Confidentiality",
    "choice_b": "Integrity",
    "choice_c": "Assurance",
    "choice_d": "Availability",
    "correct_answer": "D",
    "explanation": "Geographic dispersion is intended to help with availability by ensuring that a single disaster does not take multiple datacenters or other facilities offline. It does not directly impact confidentiality or integrity, and assurance is not part of the CIA triad.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      159,
      150,
      180,
      158,
      161
    ],
    "source": "9781394211395"
  },
  {
    "id": 930,
    "question": "Valentine wants to choose an appropriate obfuscation method to allow her customer service representatives to validate credit card numbers without exposing the full number to the staff member. What obfuscation method should she select?",
    "choice_a": "Masking",
    "choice_b": "Tokenization",
    "choice_c": "Steganography",
    "choice_d": "Hashing",
    "correct_answer": "A",
    "explanation": "Masking replaces some characters with an alternate character, allowing tasks like validating credit card numbers without exposing all of a data field. Tokenization replaces values with a replacement value allowing data to be accessed without exposing the actual value. Steganography hides data in images and is not a useful solution in this scenario. Hashing is a mathematical technique that analyzes a file and computes a unique fingerprint, known as a message digest or hash, for that file.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      10,
      318,
      319,
      316,
      11
    ],
    "source": "9781394211395"
  },
  {
    "id": 931,
    "question": "Mateo wants to conduct a fail over test for his datacenter. What will he need to do to accomplish this?",
    "choice_a": "Turn off all systems in his datacenter.",
    "choice_b": "Simulate what would occur during a datacenter outage.",
    "choice_c": "Force a fail over using his network or other systems.",
    "choice_d": "Cause an outage of a critical system.",
    "correct_answer": "C",
    "explanation": "Datacenters should have a fail over process that can be manually executed in case of emergency. Mateo should use that process to fail over to his organization's fail over site. Turning off every system in a datacenter is not recommended as this may lead to other unexpected failures. Simulation is not a fail over test, and creating an outage of a critical system typically will not cause an entire datacenter to fail over.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      161,
      158,
      150,
      315,
      160
    ],
    "source": "9781394211395"
  },
  {
    "id": 932,
    "question": "Casey's organization has proprietary information models that they use to analyze the market that they operate in. What data type best describes this information?",
    "choice_a": "Trade secret",
    "choice_b": "Regulated",
    "choice_c": "Financial information",
    "choice_d": "Public information",
    "correct_answer": "A",
    "explanation": "Trade secrets are intellectual property that is commercially valuable and is limited to a small group of individuals. Regulated information is controlled by law or has legal requirements around it. Financial information involves things related to monetary transactions or accounts. Public information is not controlled and is available to the public or could be without causing harm or concern.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      319,
      316,
      318,
      10,
      9
    ],
    "source": "9781394211395"
  },
  {
    "id": 933,
    "question": "Nicole wants to protect her SMTP email exchanges from being read by others while on the wire. What can she implement to protect SMTP?",
    "choice_a": "SPF",
    "choice_b": "TLS",
    "choice_c": "DKIM",
    "choice_d": "EXIF",
    "correct_answer": "B",
    "explanation": "Implementing Transport Layer Security (TLS) to encapsulate Simple Mail Transfer Protocol (SMTP) would allow the traffic to be encrypted in transit, protecting it from being read. Sender Policy Framework (SPF) and DomainKeys Identified Mail (DKIM) are both used to prevent spoofing, and Exchangeable Image File Format (EXIF) is information found in an image file.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      222,
      8,
      210,
      11,
      319
    ],
    "source": "9781394211395"
  },
  {
    "id": 934,
    "question": "Brandon deploys a server in a VLAN used for IoT devices. He then creates firewall rules that allow users in a system administration network to SSH to that server so that they can manage systems in the protected network segment. What type of solution has Brandon deployed?",
    "choice_a": "A UTM",
    "choice_b": "A jump server",
    "choice_c": "An ICS server",
    "choice_d": "A VPN",
    "correct_answer": "B",
    "explanation": "Jump servers are used to access secured zones and are typically carefully controlled and monitored because they are the single point of entry from untrusted environments. A Unified Threat Management (UTM) is a security device that combines firewall features with a variety of other security functions. ICS stands for Industrial Control System. This is not an ICS, although the IoT devices it allows connections to may be a form of ICS. VPNs, or virtual private networks, encapsulate and protect network traffic as it moves through untrusted networks.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      211,
      212,
      193,
      218,
      11
    ],
    "source": "9781394211395"
  },
  {
    "id": 935,
    "question": "What protocol is commonly used to allow for secured tunnels between corporate networks through untrusted networks?",
    "choice_a": "RTOS",
    "choice_b": "SHA\u20101",
    "choice_c": "IPSec",
    "choice_d": "RSA",
    "correct_answer": "C",
    "explanation": "IPSec virtual private networks are commonly established to tunnel through public or untrusted networks. A RTOS, or real\u2010time operating system, is used for embedded systems. SHA\u20101 is a hashing algorithm, and RSA is an encryption algorithm that is used for IPSec as part of its authentication process. IPSec tunnels themselves commonly use AES, but may use other algorithms as well.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      222,
      177,
      212,
      11,
      8
    ],
    "source": "9781394211395"
  },
  {
    "id": 936,
    "question": "Asher's organization has created a list of potential customers based on an analysis of their use of their site, buying habits, and ability to spend money on new products. What type of data is a list like this?",
    "choice_a": "Legal information",
    "choice_b": "Trade secrets",
    "choice_c": "Regulated data",
    "choice_d": "Classified data",
    "correct_answer": "B",
    "explanation": "Intellectual property that would have value to competitors and that is kept confidential to preserve it for competitive advantage is a trade secret. Legal information is typically related to contracts, regulations, or similar matters. Regulated data is covered by law, and classified data is used by governments.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      319,
      316,
      318,
      10,
      9
    ],
    "source": "9781394211395"
  },
  {
    "id": 937,
    "question": "Eva wants to deploy a network security device that will provide firewall services as well as IPS and email filtering. Which device should she deploy?",
    "choice_a": "A UTM",
    "choice_b": "An FWSM",
    "choice_c": "A WAF",
    "choice_d": "An ELB",
    "correct_answer": "A",
    "explanation": "A unified threat management (UTM) device combines multiple security services including firewall, IDS or IPS, antivirus/antimalware, email filtering, WAF, and similar services into a single solution. An FWSM, or firewall service module, is an older Cisco chassis\u2010based firewall; a WAF is a web application firewall; and an ELB is Elastic Load Balancer, a load\u2010balancing service available via AWS.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      218,
      211,
      193,
      210,
      9
    ],
    "source": "9781394211395"
  },
  {
    "id": 938,
    "question": "Ramon wants to conduct an exercise for his organization with the least potential to cause disruption. Which of the following testing methodologies is least likely to cause potential issues with service delivery?",
    "choice_a": "Tabletop exercises",
    "choice_b": "Fail over exercises",
    "choice_c": "Simulation exercises",
    "choice_d": "Parallel processing exercises",
    "correct_answer": "A",
    "explanation": "Tabletop exercises do not involve an actual technical system and instead are gamed out in a room. This means they're least likely to cause disruptions. Fail over and parallel processing exercises can have actual impact to live systems, and simulation exercises require care because simulated calls and actions may inadvertently become real if staff are not fully aware of the scenario being an exercise or accidentally execute a command that can cause actual impact.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      161,
      315,
      160,
      150,
      159
    ],
    "source": "9781394211395"
  },
  {
    "id": 939,
    "question": "Cassandra is considering transitioning from an on\u2010premises to a hybrid cloud environment. Which of the following concerns will she need to consider that would not have been required in a single on\u2010premises datacenter previously?",
    "choice_a": "RPOs",
    "choice_b": "Data sovereignty",
    "choice_c": "RTOs",
    "choice_d": "Power resilience",
    "correct_answer": "B",
    "explanation": "Data sovereignty is a new concern for organizations that host services and data outside of their local area, including across state or national boundaries. Recovery point objectives (RPOs), recovery time objectives (RTOs), and power resilience are all common concerns for on\u2010premises datacenters.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      179,
      180,
      169,
      168,
      11
    ],
    "source": "9781394211395"
  },
  {
    "id": 940,
    "question": "Nick wants to protect Microsoft Excel files in transit across a network. Which of the following is not a method he could use to protect data in transit?",
    "choice_a": "TLS",
    "choice_b": "VPN",
    "choice_c": "File encryption",
    "choice_d": "Disk encryption",
    "correct_answer": "D",
    "explanation": "Disk encryption is used to protect data at rest, not data in use or data in transit. TLS, VPNs, and file encryption can all be used to protect files that are sent via a network.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      8,
      222,
      190,
      10,
      318
    ],
    "source": "9781394211395"
  },
  {
    "id": 941,
    "question": "Dani wants to protect HTTP traffic that is sent from SCADA devices on her network to a cloud\u2010hosted controller. The devices don't natively support an HTTPS connection. What could she do to transparently protect the data?",
    "choice_a": "Set up a VPN connection from each SCADA device to the remote server.",
    "choice_b": "Set up a TLS\u2010enabled proxy between the devices and the server.",
    "choice_c": "Set up SD\u2010WAN.",
    "choice_d": "Install X.509 certificates on each SCADA device.",
    "correct_answer": "B",
    "explanation": "A TLS\u2010enabled proxy between the devices and server doesn't require anything else to be installed on the devices, which is typically impossible with SCADA devices. That means the VPN connection and the X.509 certificates are unlikely to work. SD\u2010WAN helps to manage external connectivity, not to directly protect traffic in this scenario.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      222,
      204,
      173,
      193,
      8
    ],
    "source": "9781394211395"
  },
  {
    "id": 942,
    "question": "Selah's organization is conducting a simulation exercise. Which of the following is not a common element of a simulation?",
    "choice_a": "Testing of notification processes",
    "choice_b": "Testing of procedures",
    "choice_c": "Testing of fail over capabilities",
    "choice_d": "Testing of communication systems",
    "correct_answer": "C",
    "explanation": "Simulations try to avoid causing potential outages and work to simulate a scenario. They may validate that notification processes communication systems and procedures all work.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      161,
      160,
      315,
      158,
      157
    ],
    "source": "9781394211395"
  },
  {
    "id": 943,
    "question": "Which of the following is not a common practice used to secure data in transit?",
    "choice_a": "Encryption",
    "choice_b": "TLS",
    "choice_c": "Geolocation",
    "choice_d": "VPN",
    "correct_answer": "C",
    "explanation": "Geolocation is used to control where data can be accessed from but does not protect data in transit. Encrypting data, encapsulating via TLS, or use of a VPN are all common methods to protect data in transit.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      8,
      222,
      182,
      11,
      318
    ],
    "source": "9781394211395"
  },
  {
    "id": 944,
    "question": "Olivia wants to deploy a new firewall. What type of firewall should she select if the ability to operate at layer 7 is important to her?",
    "choice_a": "A WAF",
    "choice_b": "An NGFW",
    "choice_c": "A stateful firewall",
    "choice_d": "A packet filter",
    "correct_answer": "B",
    "explanation": "Next\u2010generation firewalls (NGFWs) typically provide the ability to inspect traffic at both the transport layer (layer 4) and the application layer (layer 7). This means an NGFW will best fit the need. Web application firewalls also work at this level, but only focus on web applications, which does not fully meet the broad application inspection requirement in the question. Stateful firewalls and packet filters both operate at layer 4 only.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      218,
      210,
      222,
      177,
      213
    ],
    "source": "9781394211395"
  },
  {
    "id": 945,
    "question": "Marcellus wants to ensure that his organization has sufficient capacity to handle the failure of a web server. What type of technology could he deploy to ensure that individual web server failures are handled gracefully without using an overly complex solution?",
    "choice_a": "Platform diversity",
    "choice_b": "A multi\u2010cloud system",
    "choice_c": "A load balancer",
    "choice_d": "A warm site",
    "correct_answer": "C",
    "explanation": "A load balancer can help handle individual web server failures gracefully by moving load to the functioning web servers in a cluster. In scalable environments, this can also result in more servers being instantiated. Platform diversity helps to protect against failures or vulnerabilities in a single vendor, platform, or system. Multi\u2010cloud systems could help in this case but are much more complex than required by the relatively simple need to handle an individual web server's failure. A warm site would be suited to a datacenter failure, not a single web server failing.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      217,
      157,
      150,
      158,
      151
    ],
    "source": "9781394211395"
  },
  {
    "id": 946,
    "question": "What failure mode is typically preferred for in\u2010line network taps?",
    "choice_a": "Fail\u2010open",
    "choice_b": "Fail over",
    "choice_c": "Fail\u2010closed",
    "choice_d": "Fail\u2010reset",
    "correct_answer": "A",
    "explanation": "In\u2010line network taps are typically configured to fail\u2010open since they are used to create a copy of the network traffic. Devices that provide in\u2010line security like IPS systems may be configured to fail\u2010closed because their failure removes critical security functionality. Fail over describes the ability to fail to another device, which is not a common function for an in\u2010line tap. Fail\u2010reset was made up for this question.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      211,
      150,
      151,
      212,
      161
    ],
    "source": "9781394211395"
  },
  {
    "id": 947,
    "question": "What key network technology is the core of an SASE implementation?",
    "choice_a": "TLS",
    "choice_b": "VLANs",
    "choice_c": "IPSec",
    "choice_d": "SD\u2010WAN",
    "correct_answer": "D",
    "explanation": "Software\u2010defined wide area networks (SD\u2010WANs) are the core component of secure access, secure edge technology. Additional tools like zero trust functionality, cloud access security brokers, and firewalls are all combined to build a complete SASE implementation.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      177,
      213,
      218,
      211,
      179
    ],
    "source": "9781394211395"
  },
  {
    "id": 948,
    "question": "Mikayla wants to prevent unauthorized users from plugging network devices into her wired network. What control would be most effective for this if she needs Ethernet jacks to be available in publicly accessible spaces for her staff to plug devices in as they move around the facility, but also wants to ensure those devices are secure?",
    "choice_a": "NAC",
    "choice_b": "Port security",
    "choice_c": "IPS",
    "choice_d": "Jump servers",
    "correct_answer": "A",
    "explanation": "Network access control (NAC) has the ability to both profile device security and validate that a given user is authorized to plug a device into a specific Ethernet jack makes this the best solution for Mikayla's use case. Port security's list of recognized MAC addresses is both potentially vulnerable to MAC spoofing and does not meet the device security check requirements described. An IPS can help prevent network attacks but does not control port\u2010level access, and jump servers are used to allow access to secured network segments, not to protect individual network jacks.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      211,
      212,
      177,
      193,
      9
    ],
    "source": "9781394211395"
  },
  {
    "id": 949,
    "question": "Mark's organization is preparing to move to an infrastructure as code model. He's worried about what to do if a change in code causes issues. What common IaC practice will help the most with this?",
    "choice_a": "Threat modeling",
    "choice_b": "Least privilege",
    "choice_c": "Version control",
    "choice_d": "Artifact signing",
    "correct_answer": "C",
    "explanation": "Version control will allow staff from Mark's organization to identify a bad version and revert to a previous known\u2010good version if needed. Threat modeling, least privilege, and artifact signing are all common best practices for IaC, but don't directly impact version changes.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      156,
      159,
      154,
      161,
      315
    ],
    "source": "9781394211395"
  },
  {
    "id": 950,
    "question": "The company that Alex works for is preparing to adopt a platform as a service tool for their customer relationship management needs. Alex knows that third\u2010party vendors are responsible for some, but not all, security in a PaaS environment. Which of the following is the PaaS vendor responsible for?",
    "choice_a": "Network security",
    "choice_b": "Endpoint security",
    "choice_c": "User account security",
    "choice_d": "Application security",
    "correct_answer": "A",
    "explanation": "PaaS vendors are responsible for the underlying service and platform, including the networks, systems, and infrastructure that it runs on, including their security. Customers are responsible for their use of the platform, including endpoints, users, and applications built on the platform, again including their security.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      168,
      172,
      182,
      169,
      180
    ],
    "source": "9781394211395"
  },
  {
    "id": 951,
    "question": "Nick's organization houses tape\u2010based backups for their critical data in their primary datacenter. What resilience issue could result in the event of a major disaster?",
    "choice_a": "The tapes may not have been validated and might not be able to be restored.",
    "choice_b": "A single disaster could destroy both the facility and the tapes.",
    "choice_c": "The tapes may not last for the expected lifetime of the backups.",
    "choice_d": "Tapes are relatively slow and may not allow for timely restoration.",
    "correct_answer": "B",
    "explanation": "The biggest issue for resilience is that placing backups in the same facility as the devices or systems they are backing up means that a single disaster could destroy both. Nick should consider off\u2010site backup storage. Tape recovery can be slow, but this is a restoration timeframe issue, not a resilience issue. Tape lifetime is typically quite long, and backups are usually rolled over in time periods shorter than a year for most organizations. Finally, validation of backups can be a concern, but there is no description in the question that would lead to conclusions about testing.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      150,
      158,
      154,
      155,
      159
    ],
    "source": "9781394211395"
  },
  {
    "id": 952,
    "question": "Charles wants to adopt an encryption tool. What encryption standard should he look for the tool to support to ensure that he is using a current secure standard to protect his data?",
    "choice_a": "AES\u2010512",
    "choice_b": "AES\u2010256",
    "choice_c": "AES\u2010128",
    "choice_d": "AES\u2010192",
    "correct_answer": "B",
    "explanation": "AES\u2010256 is the current mainstream standard for encryption. AES 128 and 192 are both less secure, and AES\u2010512 is not an implemented or commonly used standard.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      190,
      318,
      8,
      155,
      182
    ],
    "source": "9781394211395"
  },
  {
    "id": 953,
    "question": "Which of the following is not a common security concern with real\u2010time operating systems?",
    "choice_a": "Inability to install security tools",
    "choice_b": "Lack of updates or patches",
    "choice_c": "Likelihood of malware infection",
    "choice_d": "Vulnerability concerns",
    "correct_answer": "C",
    "explanation": "While RTOS issues with vulnerabilities, the inability to install security tools. and a lack of patches for RTOS\u2010based devices are all common security concerns, they are not as frequently targeted by malware infections.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      204,
      201,
      173,
      151,
      156
    ],
    "source": "9781394211395"
  },
  {
    "id": 954,
    "question": "Chris wants to create a token to substitute for data in a database. Which of the following is not a common attribute for tokens?",
    "choice_a": "They don't have exploitable meaning themselves.",
    "choice_b": "They are easily reversible to identify the original data, even without the tokenization scheme.",
    "choice_c": "They frequently rely on one\u2010way hash functions.",
    "choice_d": "Tokens must be mapped to matching original data.",
    "correct_answer": "B",
    "explanation": "Tokens should not be easily reversible. Instead, they should require access to the original tokenization function or a mapping to the original data. Tokens should not have intrinsic meaning or value, and frequently rely on hash functions as part of their generation process to ensure this.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      318,
      10,
      319,
      316,
      8
    ],
    "source": "9781394211395"
  },
  {
    "id": 955,
    "question": "Pete's organization has had a system fail and Pete wants to recover from backup. Which of the following backup methods will typically result in the fastest restoration timeframe?",
    "choice_a": "Snapshots",
    "choice_b": "Replication",
    "choice_c": "Journaling",
    "choice_d": "Tape backup",
    "correct_answer": "B",
    "explanation": "Replication is typically the fastest means to recovery since the replica system is running and ready to take over. Snapshot recovery is normally the next fastest, followed by restoration from other storage. Journaling can introduce additional slowdowns depending on how long it has been since the last backup, as the journal is replayed from the time that occurred to the time of failure.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      315,
      153,
      154,
      155,
      158
    ],
    "source": "9781394211395"
  },
  {
    "id": 956,
    "question": "Henry accesses a database server from his workstation. What data state best describes the data while it is on the network?",
    "choice_a": "Data at rest",
    "choice_b": "Data in use",
    "choice_c": "Data on the wire",
    "choice_d": "Data in transit",
    "correct_answer": "D",
    "explanation": "The Security+ exam outline recognizes three data states: data at rest, data in transit, and data in use. When Henry accesses the data and it is transferred via the network, it is data in transit. When he is working with the data, including modifying or otherwise using it, it is data in use. When it resides on the drives the database is stored in, it is data at rest. Data on the wire is not a common term for this\u2014data in motion and data in transit are both common in industry usage, and the Security+ exam outline uses data in transit.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      8,
      9,
      11,
      210,
      177
    ],
    "source": "9781394211395"
  },
  {
    "id": 957,
    "question": "Theresa's organization operates in multiple countries. She knows that there are different laws that apply to her organization's use of data in each country they operate in. What concept describes this?",
    "choice_a": "Obfuscation",
    "choice_b": "Legal hold",
    "choice_c": "Data sovereignty",
    "choice_d": "Geographic restrictions",
    "correct_answer": "C",
    "explanation": "Data sovereignty means that governments have the ability to control data within their borders via law and regulations. Theresa's organization will need to comply with the laws of each country they operate in. Obfuscation refers to making something difficult to understand or read. Legal holds are used to require preservation of data when legal action is occurring or pending. Geographic restriction is used to limit where data can be accessed from and is a technical control used by organizations as part of data security efforts.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      179,
      180,
      11,
      318,
      10
    ],
    "source": "9781394211395"
  },
  {
    "id": 958,
    "question": "Hrant is deploying a network tap that supports an IPS for monitoring. If he wants to ensure that his organization's security remains the same even if the tap and IPS fails, and prefers downtime to a lack of monitoring, what type of failure mode and monitoring deployment should he select?",
    "choice_a": "In\u2010line, fail\u2010closed",
    "choice_b": "In\u2010line, fail\u2010open",
    "choice_c": "Tap, fail\u2010closed",
    "choice_d": "Tap, fail\u2010open",
    "correct_answer": "A",
    "explanation": "Hrant's use of an IPS means he wants to be in\u2010line to allow him to block traffic. Since he prefers that a failure remain secure rather than potentially allowing attacks through, he should select a fail\u2010closed implementation.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      211,
      150,
      151,
      161,
      157
    ],
    "source": "9781394211395"
  },
  {
    "id": 959,
    "question": "Troy wants to physically isolate a device. What does he need to do to accomplish this?",
    "choice_a": "Move it to a secure VLAN.",
    "choice_b": "Implement 802.1X.",
    "choice_c": "Create a physical air gap.",
    "choice_d": "Unplug the device from power and the network.",
    "correct_answer": "C",
    "explanation": "Physical isolation requires the creation of an air gap. This means unplugging the device from the network. A secure VLAN won't accomplish this, nor will 802.1X. Unplugging the device from power isn't required for physical isolation.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      212,
      211,
      193,
      11,
      210
    ],
    "source": "9781394211395"
  },
  {
    "id": 960,
    "question": "Yasmine wants to ensure that her organization has appropriate connectivity as part of their infrastructure design for their primary site. Which of the following concerns should she review to ensure that physical disasters do not disable her company's operations?",
    "choice_a": "Service provider path diversity",
    "choice_b": "Ensuring both fiber and copper connectivity are used",
    "choice_c": "Implementing SD\u2010WAN",
    "choice_d": "Geographic dispersion",
    "correct_answer": "A",
    "explanation": "Path diversity ensures that the connectivity to the facility does not take the same path. This helps to prevent the moment network managers dread when a single accident\u2014or construction equipment in the wrong place\u2014tears up multiple fiber or copper paths, taking organizations offline. Diversity of the cabling type is not a requirement or need, SD\u2010WAN does not directly address physical disasters, and geographic dispersion is not possible at a single site.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      211,
      150,
      159,
      210,
      160
    ],
    "source": "9781394211395"
  },
  {
    "id": 961,
    "question": "Carlos uses a remote desktop tool to connect to a server through a firewall that protects his organization's database servers. He then uses software on the server to manage the database servers. What type of solution is Carlos using?",
    "choice_a": "A network tap",
    "choice_b": "SASE",
    "choice_c": "SD\u2010WAN",
    "choice_d": "A jump server",
    "correct_answer": "D",
    "explanation": "Carlos is using a jump server that is used to connect from an untrusted or lower trust zone from outside of a firewall. A network tap is used to provide copies of network traffic for analysis. SASE combines SD\u2010WAN and other security technologies to provide network security services regardless of where systems are for enterprises. SD\u2010WAN (software\u2010defined wide area networking) is used to manage network connectivity through commodity Internet providers and other services.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      11,
      212,
      177,
      211,
      213
    ],
    "source": "9781394211395"
  },
  {
    "id": 962,
    "question": "Alaina is planning how to staff her warm site in the case of a natural disaster that disables her primary site. What concern is most likely to impact her capacity planning for staff in this scenario?",
    "choice_a": "Whether staff will be able to reach the site",
    "choice_b": "Whether staff will be impacted by the disaster",
    "choice_c": "Whether the site will be impacted by the disaster",
    "choice_d": "Whether generator fuel will be available",
    "correct_answer": "B",
    "explanation": "Capacity planning for disaster operations needs to take the impact on staff themselves into account. While modern operations can frequently be conducted remotely, reducing the number of staff required to be physically able to reach the site, staff members may not have power, Internet access, or even housing in disaster scenarios. The remote site's ability to operate is not directly a staff capacity planning issue, nor is how generators will be fueled.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      160,
      158,
      161,
      150,
      157
    ],
    "source": "9781394211395"
  },
  {
    "id": 963,
    "question": "Which of the following is not a common type of incident response exercise?",
    "choice_a": "Drills",
    "choice_b": "Simulations",
    "choice_c": "Tabletop",
    "choice_d": "Walk\u2010throughs",
    "correct_answer": "A",
    "explanation": "Typical exercise types for most organizations include simulations that emulate an actual incident response process, walk\u2010throughs that guide staff through an event, and tabletop exercises that are gamed out without taking actual action. Drills are classified as more focused on specific actions or functions, and they are less common because they can result in inadvertent action or mistakes and do not cover the breadth of an incident.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      161,
      158,
      315,
      151,
      157
    ],
    "source": "9781394211395"
  },
  {
    "id": 964,
    "question": "Jack wants to ensure that files have not changed. What technique can he use to compare current versions of the files to an original copy?",
    "choice_a": "Encryption.",
    "choice_b": "Check the file size.",
    "choice_c": "Check the file metadata.",
    "choice_d": "Compare hashes of the files.",
    "correct_answer": "D",
    "explanation": "Comparing hashes is an effective way of determining if a file is different from the original. While file length may be the same and metadata can be modified, hashes will still show changes. Encrypting the files does not compare them, and should not be used for this purpose.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      318,
      9,
      8,
      156,
      154
    ],
    "source": "9781394211395"
  },
  {
    "id": 965,
    "question": "Yuri wants to use an off\u2010site backup location. What challenge can off\u2010site backup locations create for organizations?",
    "choice_a": "It is difficult to validate the integrity of the backups.",
    "choice_b": "Retrieving the backups may slow down recovery.",
    "choice_c": "The backups cannot be easily updated.",
    "choice_d": "Off\u2010site backups may be impacted by the same disaster.",
    "correct_answer": "B",
    "explanation": "Off\u2010site backup locations are typically chosen so that they will not be impacted by the same disaster. That means that recovery may be slow if the backups either need to be physically retrieved or must be downloaded via an Internet connection. Backup integrity is typically verified as part of the backup process, and this can be checked easily. Off\u2010site backups are typically updated as part of the backup process, and this should not be an issue.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      155,
      154,
      158,
      159,
      315
    ],
    "source": "9781394211395"
  },
  {
    "id": 966,
    "question": "Which of the following is a common part of technology capacity planning for resilience?",
    "choice_a": "Cross\u2010training staff",
    "choice_b": "Using load balancers",
    "choice_c": "Using multiple geographically diverse datacenters",
    "choice_d": "Deploying uninterruptible power supplies",
    "correct_answer": "B",
    "explanation": "Load balancers are commonly used to help provide resilience by allowing applications and servers to be clustered. Cross\u2010training staff is a people\u2010 or staff\u2010based capacity planning solution. Both geographically diverse datacenters and UPS are examples of infrastructure resilience options.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      150,
      217,
      160,
      157,
      158
    ],
    "source": "9781394211395"
  },
  {
    "id": 967,
    "question": "Which of the following data types best describes data covered by the European Union's GDPR?",
    "choice_a": "Trade secrets",
    "choice_b": "Intellectual property",
    "choice_c": "Regulated data",
    "choice_d": "Legal information",
    "correct_answer": "C",
    "explanation": "The European Union's (EU) General Data Protection Regulation (GDPR) is a privacy regulation, and thus, data covered by the GDPR is regulated data. The GDPR does include language that addresses not adversely impacting the rights of others, including intellectual property rights, particularly in terms of software, but the best answer remains that this is regulated data. Trade secrets and legal information are not broad enough to describe this data.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      319,
      316,
      10,
      318,
      11
    ],
    "source": "9781394211395"
  },
  {
    "id": 968,
    "question": "What is the biggest downside of using journaling as part of a backup restoration process?",
    "choice_a": "Larger volumes of data may be lost.",
    "choice_b": "The time it takes to restore from a journal.",
    "choice_c": "Journals cannot be encrypted for security.",
    "choice_d": "Journaling does not support live databases.",
    "correct_answer": "B",
    "explanation": "Journaling replays transactions, which can take an extended period of time if the time between the last backup and the data loss event was longer and there was a high volume of transactions. Journals typically minimize the amount of transaction data that is lost; they can be encrypted, although care must be taken to ensure that they can be recovered; and journaling is used with live databases to ensure transactions are recoverable to as close to the point in time of a data loss event as possible.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      153,
      154,
      155,
      158,
      315
    ],
    "source": "9781394211395"
  },
  {
    "id": 969,
    "question": "Jill wants to design her organization for high availability. Which of the following design elements best supports power resilience for a high\u2010availability environment for an on\u2010site datacenter?",
    "choice_a": "Using generators",
    "choice_b": "Using UPS systems",
    "choice_c": "Using UPS systems backed up by generators",
    "choice_d": "Using a warm site on a separate power grid",
    "correct_answer": "C",
    "explanation": "Using UPS with generators will allow systems to remain online during a power outage even if the power outage extends for some time. Generators alone will not spin up fast enough to avoid an outage, and UPS systems will run out of battery power in extended outages. A warm site requires setup time to bring it online, resulting in an outage.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      150,
      151,
      160,
      161,
      315
    ],
    "source": "9781394211395"
  },
  {
    "id": 970,
    "question": "Valerie is concerned that the data obfuscation technique that her organization is using to ensure customer data is not visible to staff members who do not need to see it for their jobs may be vulnerable to client\u2010side tampering. Which of the following techniques is most likely to be vulnerable to client\u2010side tampering resulting in de\u2010obfuscation?",
    "choice_a": "Masking",
    "choice_b": "Tokenization",
    "choice_c": "Encryption",
    "choice_d": "Hashing",
    "correct_answer": "A",
    "explanation": "Masking may be conducted in client\u2010side code, resulting in potential exposures of data. Secure designs require masking to occur in server\u2010side code rather than in the client\u2010side web application. Tokenization typically relies on a separate database or field, making it less likely to be a problem. Encryption and hashing are both unlikely to have problems with client\u2010side tampering, making them less secure.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      318,
      10,
      11,
      316,
      9
    ],
    "source": "9781394211395"
  },
  {
    "id": 971,
    "question": "Which of the following is not a commonly used business data classification?",
    "choice_a": "Sensitive",
    "choice_b": "Confidential",
    "choice_c": "Top Secret",
    "choice_d": "Public",
    "correct_answer": "C",
    "explanation": "Top Secret and Secret are examples of government classifications. Businesses typically use classifications like sensitive, confidential, and public.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      316,
      319,
      318,
      10,
      9
    ],
    "source": "9781394211395"
  },
  {
    "id": 972,
    "question": "Malia is reviewing potential considerations for her ICS deployment. Which of the following is typically not a consideration that Malia can control or change for embedded devices?",
    "choice_a": "Ease of deployment",
    "choice_b": "Patch availability",
    "choice_c": "Risk transference",
    "choice_d": "Compute",
    "correct_answer": "D",
    "explanation": "Compute is rarely a significant concern for embedded systems. They're designed to function for long periods of time performing a specific function and do not have additional software or functions added. How easy they are to deploy, if they can be patched and updated, and the support lifespan as guaranteed or promised by the vendor, and risk transference by engaging third\u2010party vendors are all likely concerns for a major industrial control system (ICS) deployment that Malia can control through the selection process.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      201,
      204,
      151,
      160,
      315
    ],
    "source": "9781394211395"
  },
  {
    "id": 973,
    "question": "What layer is Layer 7 in the OSI model?",
    "choice_a": "The physical layer",
    "choice_b": "The application layer",
    "choice_c": "The transport layer",
    "choice_d": "The session layer",
    "correct_answer": "B",
    "explanation": "Layer 7 is the application layer. In order the layers are: 1 \u2013 physical, 2 \u2013 data link, 3 \u2013 network, 4 \u2013 transport, 5 \u2013 session, 6 \u2013 presentation, and 7 \u2013 application. The Security+ exam outline only focuses on Layer 4 and Layer 7 in the context of network security devices that can operate at those layers.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      210,
      218,
      211,
      222,
      193
    ],
    "source": "9781394211395"
  },
  {
    "id": 974,
    "question": "Network connected devices built into washing machines, microwaves, and other household appliances are examples of what type of network device?",
    "choice_a": "ICS",
    "choice_b": "SCADA",
    "choice_c": "Embedded systems",
    "choice_d": "Virtualization",
    "correct_answer": "C",
    "explanation": "These are all examples of embedded systems, computers built into devices to allow them to function. Other examples include computers built into cars, digital cameras, and thermostats. They often receive fewer (or no) updates, and are required to function for long periods of time as part of other devices or systems.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      204,
      173,
      193,
      201,
      11
    ],
    "source": "9781394211395"
  },
  {
    "id": 975,
    "question": "What term best describes a set of loosely coupled, fine\u2010grained services that communicate via lightweight protocols, allowing organizations to easily build new services without additional dependencies or infrastructure?",
    "choice_a": "Containerization",
    "choice_b": "IoT",
    "choice_c": "Software\u2010defined infrastructure",
    "choice_d": "Microservices",
    "correct_answer": "D",
    "explanation": "Microservices are loosely coupled and fine\u2010grained, and they are intended to be easy to deploy without significant overhead or dependencies. They rely on lightweight protocols like HTTP to make them easier to deploy in common infrastructures. Containers are used to allow applications to be easily deployed without moving a complete operating system but with the required libraries and components to function. The Internet of Things (IoT) describes Internet\u2010enabled devices of all sorts, including embedded systems. Software\u2010defined infrastructure is commonly used for cloud services.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      175,
      168,
      170,
      151,
      157
    ],
    "source": "9781394211395"
  },
  {
    "id": 976,
    "question": "What type of backup is done to update a full backup with changes made after the full backup occurred?",
    "choice_a": "Incremental",
    "choice_b": "Partial",
    "choice_c": "Daily",
    "choice_d": "Snapshots",
    "correct_answer": "A",
    "explanation": "Incremental backups only include the data that has changed since the last full backup. To restore a backup using incremental backups, the full backup is restored, then incremental backups are applied in order from oldest to most recent. Partial backups describe a backup of only certain data or parts of a system. Daily backups are just that\u2014daily\u2014and may be full or incremental. Snapshots are point\u2010in\u2010time images of a system's or a device's data and memory.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      153,
      154,
      155,
      156,
      315
    ],
    "source": "9781394211395"
  },
  {
    "id": 977,
    "question": "As part of an exercise for her organization, Sharon calls a team member and asks them to check the status of critical systems. The team member, who is aware of the exercise, does not actually validate the systems but responds that specific systems are down based on the scenario. What type of exercise is Sharon most likely part of?",
    "choice_a": "A tabletop exercise",
    "choice_b": "A fail over exercise",
    "choice_c": "A simulation exercise",
    "choice_d": "A parallel processing test",
    "correct_answer": "C",
    "explanation": "Sharon is most likely part of a simulation exercise, where organizations test how they would respond to a scenario without taking actual actions. This is safer than a fail over or parallel processing test but is closer to a real event than a tabletop exercise.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      161,
      315,
      150,
      159,
      160
    ],
    "source": "9781394211395"
  },
  {
    "id": 978,
    "question": "Zhuri wants to ensure that her organization's datacenter remains online during an extended power outage. What power resilience option is best suited to extended outages?",
    "choice_a": "Generators",
    "choice_b": "Solar",
    "choice_c": "UPS",
    "choice_d": "PDUs",
    "correct_answer": "A",
    "explanation": "Generators are used by organizations that need to handle extended power outages. They are commonly paired with UPS systems that handle the immediate power outage, allowing the generator to start and stabilize. Solar power alone is not a good solution without a significant battery system, and datacenter\u2010scale battery systems paired with solar are not yet common. PDUs (power distribution units) are used to distribute and control power in a datacenter but do not provide power generation or backup capabilities.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      150,
      158,
      160,
      161,
      153
    ],
    "source": "9781394211395"
  },
  {
    "id": 979,
    "question": "Cesar wants to ensure that his organization's SCADA and ICS devices remain secure. What is the most effective way to ensure that network attacks cannot impact his operation's critical infrastructure?",
    "choice_a": "Separate VLANs",
    "choice_b": "TLS",
    "choice_c": "Physical isolation",
    "choice_d": "SDN",
    "correct_answer": "C",
    "explanation": "Physically isolating the network for the SCADA and ICS systems can prevent attacks from outside of the network. In critical infrastructure like power generation stations, this is a common technique to ensure that external attacks cannot cause outages to critical physical infrastructure. Separate VLANs is a common logical control, but attacks against the network or using VLAN hopping techniques can allow attackers to bypass the separation. TLS is useful for protecting traffic but does not meet the security requirement described, and SDN is useful for managing networks but again does not meet the enhanced security requirements in the question.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      212,
      201,
      211,
      193,
      11
    ],
    "source": "9781394211395"
  },
  {
    "id": 980,
    "question": "What key data element is used to validate which systems are allowed to use Ethernet ports where port security is enabled?",
    "choice_a": "Their IP address",
    "choice_b": "The network card's manufacturer",
    "choice_c": "The user's password",
    "choice_d": "Their MAC address",
    "correct_answer": "D",
    "explanation": "Hardware addresses, known as MAC addresses, are used for port security to determine which systems can connect to a port. Their IP address, the network card manufacturer, and the user's password are not used by port security.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      211,
      177,
      193,
      210,
      212
    ],
    "source": "9781394211395"
  },
  {
    "id": 981,
    "question": "Which of the following is not a common concern for extended power outages where generators are providing power to a datacenter they were designed to support during outages?",
    "choice_a": "Fuel availability",
    "choice_b": "Generator maintenance",
    "choice_c": "Generator capacity",
    "choice_d": "Physical redundancy",
    "correct_answer": "C",
    "explanation": "Generators are typically sized to the datacenter they support, so capacity is rarely a primary concern. Fuel availability, maintenance and maintenance cycles for extended runs, and ensuring physical redundancy so that a secondary generator can take over during maintenance cycles for long outages are all common concerns.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      160,
      315,
      157,
      150,
      161
    ],
    "source": "9781394211395"
  },
  {
    "id": 982,
    "question": "Rafael wants to protect his data from being accessed by unauthorized users. Which of the following is not well suited to preventing attacks by insider threats?",
    "choice_a": "Encryption",
    "choice_b": "Geographic restrictions",
    "choice_c": "Tokenization",
    "choice_d": "Permission restrictions",
    "correct_answer": "B",
    "explanation": "Geographic restrictions are rarely helpful for insider threats because insiders are likely to already be in the same location as authorized users in most organizations. Encryption, tokenization, and permission restrictions can all be used to ensure that only authorized users gain access to the data.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      11,
      318,
      10,
      9,
      182
    ],
    "source": "9781394211395"
  },
  {
    "id": 983,
    "question": "Malia wants to protect data in use. Which technique is not a good solution to ensuring that data in use is protected?",
    "choice_a": "Encryption",
    "choice_b": "Control access to the data",
    "choice_c": "Hashing data",
    "choice_d": "Limiting where data is processed",
    "correct_answer": "C",
    "explanation": "Use of encryption through secure enclaves and restricted processing environments, controlling access to the data, and limiting where data is processed are all useful controls. Hashing the data does not leave it in a usable form since hashes transform the data, and thus is not a useful solution.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      8,
      318,
      10,
      11,
      182
    ],
    "source": "9781394211395"
  },
  {
    "id": 984,
    "question": "Lisa wants to ensure that her organization's datacenter can properly handle short power disruptions and temporary undervoltage events. What power resilience solution is best suited to her needs?",
    "choice_a": "Generators",
    "choice_b": "UPS systems",
    "choice_c": "PDUs",
    "choice_d": "Solar power",
    "correct_answer": "B",
    "explanation": "UPS systems are perfectly suited to handling short power outages and temporary undervoltage events. They sit between systems and grid power, ensuring clean, reliable power is available. Generators take time to start, meaning that a UPS + generator solution is used for longer outages. PDUs (power distribution units) are used to distribute and manage power in datacenters. Solar power is increasingly used by datacenters to help offset their power consumption but is not a solution during nighttime hours.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      153,
      151,
      150,
      158,
      160
    ],
    "source": "9781394211395"
  },
  {
    "id": 985,
    "question": "Valentine has containerized her applications. What will not be part of the container?",
    "choice_a": "The operating system",
    "choice_b": "The application",
    "choice_c": "Needed libraries",
    "choice_d": "Configuration files",
    "correct_answer": "A",
    "explanation": "Containers do not include an operating system, but do contain applications, libraries, and configuration files.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      175,
      168,
      172,
      169,
      177
    ],
    "source": "9781394211395"
  },
  {
    "id": 986,
    "question": "Jaime wants to manage connectivity, including both MPLS and broadband Internet services, for her organization. What technology should she select to enable her to manage multiple connection types using a software\u2010based control system?",
    "choice_a": "SASE",
    "choice_b": "SDN",
    "choice_c": "SD\u2010WAN",
    "choice_d": "VSAN",
    "correct_answer": "C",
    "explanation": "SD\u2010WAN, or software\u2010defined wide area network, is a virtual wide area network architecture that relies on a software\u2010based controller to manage multiple connections and connection types. MPLS, LTE, and broadband are commonly managed using SD\u2010WAN technology. SASE, or Secure Access Service Edge, is used to provide end\u2010to\u2010end security in modern environments with systems and users spread throughout many locations and networks. SDN, or software\u2010defined networking, is a code\u2010based network management scheme. However, SD\u2010WAN is the correct answer for wide area networks that rely on things like MPLS and broadband rather than on\u2010premises networks. VSAN, or virtual SAN, is a virtual storage area network.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      177,
      211,
      213,
      159,
      172
    ],
    "source": "9781394211395"
  },
  {
    "id": 987,
    "question": "Cassandra wants to deploy a network security device that can detect and stop attacks. What type of network security device should she use if she wants to stop attacks based on behaviors and threat feeds?",
    "choice_a": "An IDS",
    "choice_b": "A proxy server",
    "choice_c": "An IPS",
    "choice_d": "A jump server",
    "correct_answer": "C",
    "explanation": "An IPS, or intrusion prevention system, can stop attacks based on behaviors and threat feed data. An IDS can detect attacks using the same information but cannot stop them. Proxy servers are used to filter content but do not meet this requirement, and jump servers are used for secure access into higher trust environments.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      218,
      211,
      210,
      9,
      213
    ],
    "source": "9781394211395"
  },
  {
    "id": 988,
    "question": "Contracts, NDAs, and SOWs are all examples of what type of data?",
    "choice_a": "Legal information",
    "choice_b": "Trade secrets",
    "choice_c": "Regulated",
    "choice_d": "Financial",
    "correct_answer": "A",
    "explanation": "Contracts, nondisclosure agreements (NDAs), and statements of work (SOWs) are all examples of legal information. They may include trade secrets or financial information but do not have to. Regulated data is regulated by law and is not the same as legal information.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      319,
      316,
      318,
      10,
      9
    ],
    "source": "9781394211395"
  },
  {
    "id": 989,
    "question": "Jackson has deployed a next\u2010generation firewall. Which of the following features is most likely to help him prevent new attacks without having to create individual rules to stop them?",
    "choice_a": "Threat feeds",
    "choice_b": "Application awareness",
    "choice_c": "Deep packet inspection",
    "choice_d": "High throughput",
    "correct_answer": "A",
    "explanation": "Using threat feeds allows administrators to have rules that automatically block new threats using IP reputation and other services. Those detections may rely on application awareness or deep packet inspection, but without the feed information new rules will have to be crafted to address specific new threats. High throughput allows NGFW devices to deal with significant load as well as the demands of deep packet inspection and application awareness.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      218,
      9,
      11,
      222,
      151
    ],
    "source": "9781394211395"
  },
  {
    "id": 990,
    "question": "Which of the following is not provided by an IPSec VPN?",
    "choice_a": "Confidentiality",
    "choice_b": "Authentication",
    "choice_c": "Availability",
    "choice_d": "Integrity",
    "correct_answer": "C",
    "explanation": "IPSec VPNs provide encryption, which allows for confidentiality and integrity through hashing. They also provide authentication because both ends authenticate as part of the VPN connection process. Availability is not a feature of an IPSec connection, and it must be designed and built into the hardware and network infrastructure that the IPSec VPN relies on.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      151,
      150,
      157,
      211,
      315
    ],
    "source": "9781394211395"
  },
  {
    "id": 991,
    "question": "What technologies are most frequently used to help enforce geographic restrictions?",
    "choice_a": "Wi\u2010Fi and Bluetooth",
    "choice_b": "GPS and Wi\u2010Fi",
    "choice_c": "GPS and encryption",
    "choice_d": "DNS and GPS",
    "correct_answer": "B",
    "explanation": "GPS and Wi\u2010Fi are commonly used to enforce geofencing by determining where individual devices are. Bluetooth may be used in some cases as well, but Wi\u2010Fi and GPS are the dominant options. DNS is not used as part of geographic restrictions, nor is encryption.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      11,
      177,
      193,
      204,
      210
    ],
    "source": "9781394211395"
  },
  {
    "id": 992,
    "question": "In the cloud responsibility matrix, what three areas is the provider always responsible for in an IaaS environment?",
    "choice_a": "Data, devices, and accounts",
    "choice_b": "Identities, applications, and network controls",
    "choice_c": "Operating systems, applications, and physical hosts",
    "choice_d": "Datacenters, networks, and physical hosts",
    "correct_answer": "D",
    "explanation": "Infrastructure\u2010as\u2010a\u2010service (IaaS) providers are responsible for the underlying infrastructure, including datacenters, networks, and physical hosts. In some cases, they may also be responsible for some operating systems, network controls, applications, and Identity and Access Management (IAM) infrastructure. Customers are always responsible for data and accounts, but may be responsible for applications, network controls, and operating systems as well.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      168,
      172,
      175,
      176,
      177
    ],
    "source": "9781394211395"
  },
  {
    "id": 993,
    "question": "Kirk's organization contracts with a cloud service provider. Kirk is concerned about third\u2010party vendors that his cloud service provider uses. How can Kirk best address these concerns?",
    "choice_a": "Through direct contracts with the third\u2010party vendors",
    "choice_b": "By requiring regular audits of third\u2010party vendors",
    "choice_c": "Through the contract with his cloud service provider",
    "choice_d": "By performing vulnerability scans of the third\u2010party vendors",
    "correct_answer": "C",
    "explanation": "Ensuring that third\u2010party vendors are held to appropriate standards is best accomplished through contracts with direct suppliers. Since the third\u2010party vendors sign contracts with Kirk's cloud provider, not with Kirk's organization, the only way to have influence over them is through the cloud service provider. Audits and vulnerability scans will typically not be allowed by organizations that do not have a contract with a vendor.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      172,
      179,
      155,
      151,
      169
    ],
    "source": "9781394211395"
  },
  {
    "id": 994,
    "question": "Frankie wants to connect two remote sites so that they appear to be on the same local network segment. What type of solution is best suited to this requirement if she wants traffic sent between the locations to be secure despite traversing the public Internet?",
    "choice_a": "Establish a VLAN between the two locations.",
    "choice_b": "Use TLS to encapsulate each service provided between the two locations.",
    "choice_c": "Set up a VPN tunnel between the two locations.",
    "choice_d": "Reclassify the data as public and send the data as normal.",
    "correct_answer": "C",
    "explanation": "VPNs, or virtual private networks, are commonly established between two locations to provide a secure connection that can make the networks appear to be on the same network segment. A VLAN may then be used if desired, but a VLAN alone does not provide encryption and cannot be set up across a public connection. TLS encapsulating each service would provide security, but that would not make the two sites appear to be on the same network segment. Reclassifying the data does not secure the data or make the networks appear to be on the same segment, either.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      212,
      11,
      177,
      8,
      222
    ],
    "source": "9781394211395"
  },
  {
    "id": 995,
    "question": "Which of the following best describes replication as a resilience strategy?",
    "choice_a": "It makes a complete backup copy of live data that can be restored from media if needed, then journaled changes can be replayed to catch up to the moment of failure.",
    "choice_b": "It creates a continuous copy of live data either asynchronously or synchronously.",
    "choice_c": "It uses a series of snapshots to provide disaster recovery for virtual machines.",
    "choice_d": "It requires high\u2010speed media to keep up with live data.",
    "correct_answer": "B",
    "explanation": "Replication can be synchronous or asynchronous but focuses on keeping an up\u2010do\u2010date copy of live data. It does not require high\u2010speed media but does require storage media that is fast enough to keep up with the speed of change from the production environment. Replication does not rely on journaling or snapshots.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      150,
      158,
      159,
      155,
      161
    ],
    "source": "9781394211395"
  },
  {
    "id": 996,
    "question": "Sade works for a large organization that wants to ensure that their connectivity is properly secured. What type of security device should she select if throughput and advanced security capabilities are both important factors in selection?",
    "choice_a": "A UTM device",
    "choice_b": "An NGFW device",
    "choice_c": "A WAF",
    "choice_d": "A proxy server",
    "correct_answer": "B",
    "explanation": "NGFW devices are typically deployed where throughput and advanced security features are both needed. UTM devices are more common in small to mid\u2010sized organizations where they can be set up and will often require less management and configuration. A WAF is appropriate for web services, but does not provide enough protection for an entire organization's Internet connectivity. A proxy server is useful for filtering traffic but has the same issues with limited functionality.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      218,
      211,
      151,
      150,
      157
    ],
    "source": "9781394211395"
  },
  {
    "id": 997,
    "question": "Barb's organization has a recovery point objective of 6 hours. At least how often should Barb conduct incremental backups to meet this RPO?",
    "choice_a": "Once every hour",
    "choice_b": "Once every 6 hours",
    "choice_c": "Once every 12 hours",
    "choice_d": "Once a day",
    "correct_answer": "B",
    "explanation": "Barb needs to back up her data at least once every 6 hours to meet a 6\u2010hour RPO, and Barb might even choose to run her backups slightly more often to ensure the RPO can be met. Running backups every hour significantly exceeds that target, and may have other implications on performance time to recover, so a more aggressive timeframe would need to be carefully reviewed. Every 12 or 24 hours would not meet the RPO set by Barb's company.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      153,
      315,
      158,
      155,
      161
    ],
    "source": "9781394211395"
  },
  {
    "id": 998,
    "question": "Geoff's data is stored in a cloud service's database. What data state is the data in?",
    "choice_a": "It is at rest.",
    "choice_b": "It is in transit.",
    "choice_c": "It is in use.",
    "choice_d": "It is sovereign.",
    "correct_answer": "A",
    "explanation": "Since the data is not actively being moved between systems or via a network, and it is not being processed, it is data at rest. If the database was being actively accessed, the data might be in transit when it was sent to an application server and in use as the server processed it. Data sovereignty is the concept that countries can regulate data within their own borders.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      8,
      179,
      11,
      316,
      9
    ],
    "source": "9781394211395"
  },
  {
    "id": 999,
    "question": "Tara's web development team has written code that allows sensitive customer information to be hidden from users who do not have the right permissions. When individuals who do not have the proper rights to view sensitive information use the application, the data is displayed as a series of asterisks: <br>Account number: ****\u2010******\u2010**<br>What data obfuscation technique has Tara's team employed to help protect her organization's data?",
    "choice_a": "Encryption",
    "choice_b": "Data classification",
    "choice_c": "Hashing",
    "choice_d": "Masking",
    "correct_answer": "D",
    "explanation": "Masking replaces some characters with an alternate character, allowing tasks like validating credit card numbers without exposing all of a data field. Encryption and hashing would transform the data, not replace it with an alternate character. Data classification is involved, but it's not a data obfuscation technique.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      10,
      318,
      11,
      316,
      319
    ],
    "source": "9781394211395"
  },
  {
    "id": 1000,
    "question": "Ed is building a continuity of operations plan (COOP) for his organization. What three scenarios does a COOP address?",
    "choice_a": "Loss of personnel, loss of systems, loss of availability",
    "choice_b": "Natural disasters, human\u2010made disasters, mistakes or errors",
    "choice_c": "Loss of access to a facility, damage to a facility, natural disasters",
    "choice_d": "Loss of access to a facility, loss of personnel, and loss of services",
    "correct_answer": "D",
    "explanation": "COOP plans address loss of access to some or all of a facility, personnel, or services. Other items may cause those losses, but the focus is on continued operations addressing the key components of an organization's business or purpose\u2014facilities, staff, and services.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      315,
      160,
      161,
      150,
      158
    ],
    "source": "9781394211395"
  },
  {
    "id": 1001,
    "question": "Which of the following properly describes a SPAN port configured on a switch or router for monitoring?",
    "choice_a": "Active and inline",
    "choice_b": "Passive and inline",
    "choice_c": "Active and a monitor",
    "choice_d": "Passive and a monitor",
    "correct_answer": "C",
    "explanation": "Switch Port Analyzer (SPAN) ports, also known as mirrored ports, configured on a network switch or router are active because the device is powered and are a monitor because they simply copy traffic rather than being inline.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      211,
      193,
      212,
      210,
      177
    ],
    "source": "9781394211395"
  },
  {
    "id": 1002,
    "question": "Renee wants to choose a control that will protect her organization against SQL injection attacks. Which of the following is likely to be the most effective control for attacks that are announced without prior notice and that require a very quick response?",
    "choice_a": "Web application penetration testing",
    "choice_b": "A WAF",
    "choice_c": "Static code review",
    "choice_d": "SASE",
    "correct_answer": "B",
    "explanation": "A major advantage of WAFs is the ability to use thread and rule feeds from vendors that quickly respond to new threats and attacks. At the same time, Renee can also build WAF rules faster than it would take to deploy code fixes in many cases. Penetration testing and static code review are both slow processes and are not suited to the rapid respond described. SASE is used to protect diverse endpoints in many locations, not to counter SQL injection (SQLi) against a web service.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      218,
      151,
      161,
      156,
      150
    ],
    "source": "9781394211395"
  },
  {
    "id": 1003,
    "question": "Maria wants to deploy a web application firewall that will stop new attacks against her organization. What should she do to make sure that her web application firewall rules are as current as possible?",
    "choice_a": "Manually add new rules based on email updates.",
    "choice_b": "Deploy rules based on the OWASP Top 10.",
    "choice_c": "Subscribe to a threat feed and deploy rules based on the feed.",
    "choice_d": "Subscribe to the vendor's managed WAF rule service.",
    "correct_answer": "D",
    "explanation": "Many vendors offer a managed service that provides rules that stop trending and new attacks. Maria can subscribe to the service, but needs to be aware that sometimes rules may cause outages or issues if they block legitimate traffic accidentally. Manually deploying rules is slow and requires careful crafting. The Open Worldwide Application Security Project (OWASP) Top 10 is a short list and it is not updated quickly. Threat feeds are useful as a way to write rules but will be less effective than a managed service in most cases due to the variety of attacks and new threats.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      172,
      218,
      170,
      151,
      179
    ],
    "source": "9781394211395"
  },
  {
    "id": 1004,
    "question": "Gary's organization provides Wi\u2010Fi network connectivity for customers, employees, and IoT building automation devices. What should he implement if he needs each of the three groups to have access to the same resources at times without the three groups of users being able to connect to each other?",
    "choice_a": "Fail\u2010closed networks",
    "choice_b": "Security zones",
    "choice_c": "Data classification",
    "choice_d": "Fail\u2010open networks",
    "correct_answer": "B",
    "explanation": "Each network segment should be considered a separate security zone that can be managed and secured appropriately for its ongoing use. Networks are not typically considered fail\u2010open or fail\u2010closed\u2014devices are. Data classification is used to label data.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      193,
      11,
      212,
      177,
      211
    ],
    "source": "9781394211395"
  },
  {
    "id": 1005,
    "question": "Kendra is designing a web application infrastructure and wants to use a load balanced cluster. Which of the following considerations is not directly addressed by using a load balancer?",
    "choice_a": "Availability",
    "choice_b": "Responsiveness",
    "choice_c": "Scalability",
    "choice_d": "Risk transference",
    "correct_answer": "D",
    "explanation": "Load balancers can help with availability by automatically removing failed notes from a load balanced group. They can help with responsiveness by distributing load to the least loaded systems in a load balanced pool, and they can help with scalability by allowing systems to transparently be added or removed from the pool. They don't directly help with risk transference since risk transference usually requires a contract or insurance.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      217,
      150,
      157,
      151,
      170
    ],
    "source": "9781394211395"
  },
  {
    "id": 1006,
    "question": "Angie is logging in to a server. What data state is her authentication information in?",
    "choice_a": "Data in storage",
    "choice_b": "Data at rest",
    "choice_c": "Data in validation",
    "choice_d": "Data in use",
    "correct_answer": "D",
    "explanation": "When Angie logs in, her authentication data is processed, making it data in use. Data at rest is data that is stored and not in active use or processing. Data in storage and data in validation were made up for this question and are not typically considered data states.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      8,
      9,
      10,
      318,
      11
    ],
    "source": "9781394211395"
  },
  {
    "id": 1007,
    "question": "Patrick wants to deploy a virtual private networking (VPN) technology that is as easy for end users to use as possible. What type of VPN should he deploy?",
    "choice_a": "An IPSec VPN",
    "choice_b": "An SSL/TLS VPN",
    "choice_c": "An HTML5 L2TP VPN",
    "choice_d": "An SAML VPN",
    "correct_answer": "B",
    "explanation": "A TLS\u2010based VPN (often called an SSL\u2010based VPN, despite SSL being outmoded) provides the easiest way for users to use VPN since it does not require a client. SSL VPNs also work only for specific applications rather than making a system appear as though it is fully on a remote network. HTML5 is not a VPN technology, but some VPN portals may be built using HTML5. Security Assertion Markup Language (SAML) is not a VPN technology. IPSec VPNs require a client or configuration and are thus harder for end users to use in most cases.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      222,
      177,
      212,
      211,
      193
    ],
    "source": "9781394211395"
  },
  {
    "id": 1008,
    "question": "Servers in redundant clusters are typically not placed in the same server rack in case of a water leak or other issue that impacts the rack. What consideration describes this type of design decision?",
    "choice_a": "Connectivity",
    "choice_b": "Geographic dispersion",
    "choice_c": "Device placement",
    "choice_d": "Attack surface",
    "correct_answer": "C",
    "explanation": "Device placement can matter due to physical risks or because of concerns about latency, access to services, or other considerations. Connectivity concerns focus on whether an organization can obtain a network connection and whether it meets the organization's needs, including throughput and reliability. Geographic dispersion refers to the distance between locations that helps to ensure that a single disaster does not take an organization offline. Attack surface is the set of services, ports, and physical access that an attacker could leverage.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      150,
      211,
      159,
      160,
      217
    ],
    "source": "9781394211395"
  },
  {
    "id": 1009,
    "question": "Akio is considering a decentralized model to manage her organization's multiple datacenters. What key advantage could this provide for her organization?",
    "choice_a": "Reductions in cost",
    "choice_b": "Increased resilience",
    "choice_c": "Reductions in complexity",
    "choice_d": "Increased complexity",
    "correct_answer": "B",
    "explanation": "Decentralized approaches can provide increased resilience since a failure or compromise of the management plane or services in a single location will not disrupt other locations. Unfortunately, this normally comes with increased cost and complexity. Increased complexity is not an advantage.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      150,
      159,
      151,
      158,
      160
    ],
    "source": "9781394211395"
  },
  {
    "id": 1010,
    "question": "Kim's organization operates a cloud\u2010hosted IaaS environment and uses an infrastructure as code model to deploy systems. A vulnerability has been found in the web server software that the organization uses. What process should her team use to remediate the vulnerability?",
    "choice_a": "Manually patch each web server.",
    "choice_b": "Update the underlying base image for the servers and redeploy the web servers.",
    "choice_c": "Add the patch to the code repository for the servers, transfer the load to other servers, and replace unpatched servers with patched versions by reinstantiating them.",
    "choice_d": "Update the underlying base image, drain the load from working servers, and replace with new instances.",
    "correct_answer": "C",
    "explanation": "In an infrastructure as code (IaC) environment, updating the code that defines what a fully patched server is, then replacing servers in a cluster one at a time will be the least disruptive option while also ensuring that future instances will have the patches installed. Rebuilding a base image each time a patch comes out is not efficient, and manually patching is not a best practice in IaC environments and may lead to human error.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      156,
      168,
      170,
      150,
      172
    ],
    "source": "9781394211395"
  },
  {
    "id": 1011,
    "question": "Jason's organization wants to classify data that the organization regularly uses. The data is customer data, and could cause harm to the company if it was released. Which of the following data classifications best fits this type of data?",
    "choice_a": "Confidential",
    "choice_b": "Restricted",
    "choice_c": "Critical",
    "choice_d": "Public",
    "correct_answer": "A",
    "explanation": "The data should not be released or exposed and could cause harm. This means that confidential best describes this data from the list of available terms. Restricted data is typically limited to a subset of staff, but that is not reflected in the question. The data is also not described as being critical to the operations of the organization; instead the emphasis is on confidentiality. Since this data must remain confidential, it is not public data.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      316,
      319,
      11,
      9,
      10
    ],
    "source": "9781394211395"
  },
  {
    "id": 1012,
    "question": "Which of the following is not a common consideration for legacy devices?",
    "choice_a": "Cost",
    "choice_b": "Ease of recovery",
    "choice_c": "Patch availability",
    "choice_d": "Inability to patch",
    "correct_answer": "A",
    "explanation": "Legacy devices typically cannot be purchased, so their cost becomes irrelevant. Whether they can be recovered, if patches are available, and the issues that lack of patching may cause are all common issues for legacy devices.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      201,
      204,
      211,
      193,
      185
    ],
    "source": "9781394211395"
  },
  {
    "id": 1013,
    "question": "Which of the following is not a common service provided by a UTM device?",
    "choice_a": "Firewall",
    "choice_b": "SD\u2010WAN",
    "choice_c": "IPS",
    "choice_d": "Antivirus/antimalware",
    "correct_answer": "B",
    "explanation": "UTM devices commonly provide firewall, IPS, antivirus/antimalware, and a variety of other services. They are also commonly part of SD\u2010WAN architectures, but do not themselves provide the SD\u2010WAN service.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      218,
      172,
      193,
      210,
      150
    ],
    "source": "9781394211395"
  },
  {
    "id": 1014,
    "question": "Nick wants to enable remote access for his organization and wants users to have a simple experience without significant overhead when connecting. What type of solution should he implement?",
    "choice_a": "A TLS VPN",
    "choice_b": "SD\u2010WAN",
    "choice_c": "SDN",
    "choice_d": "An IPSec VPN",
    "correct_answer": "A",
    "explanation": "TLS VPNs are typically easier to set up and don't require clients to be installed, unlike an IPSec VPN. SD\u2010WAN is used to manage external connectivity, and software\u2010defined networking (SDN) is used to manage networks and their performance, not to allow remote access by users.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      222,
      168,
      169,
      11,
      193
    ],
    "source": "9781394211395"
  },
  {
    "id": 1015,
    "question": "Jaime has deployed smart lighting and thermostats to her new buildings. What technique will have the largest impact if she wants to harden the devices?",
    "choice_a": "Applying an industry standard baseline configuration",
    "choice_b": "Moving the devices to a separate security zone",
    "choice_c": "Fully patching the devices when they are deployed",
    "choice_d": "Vulnerability scanning, then remediating the devices on a regular basis",
    "correct_answer": "B",
    "explanation": "Moving devices to an isolated network segment that has appropriate controls in place to protect devices that may not be able to be secured or that may not receive regular patches is the best option available. Baselines, patching, and even scanning and remediation only help if the devices can be secured, patched, and otherwise protected. IoT devices are often not able to be secured this way, particularly as they age and both lighting and thermostats have relatively long useful lifespans.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      193,
      11,
      204,
      177,
      201
    ],
    "source": "9781394211395"
  },
  {
    "id": 1016,
    "question": "Chuck has deployed a cloud\u2010based security environment that combines SD\u2010WAN, zero trust, cloud access security broker (CASB), and firewall services to replace traditional VPNs. What sort of service has Chuck deployed?",
    "choice_a": "SaaS",
    "choice_b": "SASE",
    "choice_c": "SONET",
    "choice_d": "SCM",
    "correct_answer": "B",
    "explanation": "Secure access service edge (SASE) deployments combine SD\u2010WAN with a variety of cloud\u2010hosted security services, including zero trust and CASB tools to replace VPNs. This provides an edge device\u2013oriented security architecture with end\u2010to\u2010end security. SaaS is involved but is not a specific enough answer. SONET is a communication protocol used for fiber networks. Supply chain management (SCM) is not a term used in this context.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      172,
      177,
      213,
      179,
      150
    ],
    "source": "9781394211395"
  },
  {
    "id": 1017,
    "question": "Lucca wants to fully validate his organization's hot site's ability to perform as needed in the event of an outage. What type of testing should he run to ensure that the hot site is completely tested as though an actual disaster has occurred?",
    "choice_a": "Fail over",
    "choice_b": "Simulation",
    "choice_c": "Tabletop",
    "choice_d": "Parallel processing",
    "correct_answer": "A",
    "explanation": "Fail over testing goes beyond parallel processing and completely takes over running services. This is the most complex and risky testing mode, but also the only one that completely tests failure scenarios in a real\u2010world exercise. Simulations and tabletops are more abstract and would not test the site, instead focusing on practices and behaviors.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      161,
      158,
      315,
      160,
      150
    ],
    "source": "9781394211395"
  },
  {
    "id": 1018,
    "question": "Christina's organization has purchased a remote facility that they intend to use in case of a major disaster. The building has basic utilities, including Internet connectivity, but no other preparation has been made. What type of site is this?",
    "choice_a": "A warm site",
    "choice_b": "A hot site",
    "choice_c": "A cold site",
    "choice_d": "A dispersion site",
    "correct_answer": "C",
    "explanation": "Cold sites are spaces that are ready to be used in a disaster but without equipment or other necessary items in place to quickly take over production if needed. A warm site would have some hardware ready to be used, but the hardware would not be configured or otherwise ready for immediate resumption of service. A hot site is prepared to take over processing for an organization immediately, and infrastructure is running in parallel with your production site. Geographic dispersion is used to ensure that a single disaster does not impact multiple sites.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      158,
      159,
      150,
      161,
      315
    ],
    "source": "9781394211395"
  },
  {
    "id": 1019,
    "question": "Which of the following is not commonly part of a tabletop exercise?",
    "choice_a": "A discussion of roles",
    "choice_b": "A discussion of likely actions",
    "choice_c": "Simulated calls to resources",
    "choice_d": "A guided conversation",
    "correct_answer": "C",
    "explanation": "Tabletop exercises are not simulations and typically do not involve simulated calls to resources. Simulations are a different type of exercise and have the potential for disruptions if staff are not aware of the exercise being conducted.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      161,
      315,
      160,
      158,
      150
    ],
    "source": "9781394211395"
  },
  {
    "id": 1020,
    "question": "Helen has deployed both Cisco and Juniper routers in her organization to ensure that a vulnerability in one vendor's products does not result in a complete outage of her organization. What is this type of design called?",
    "choice_a": "Platform agnostic",
    "choice_b": "Platform diversity",
    "choice_c": "Multi\u2010cloud",
    "choice_d": "Parallel processing",
    "correct_answer": "B",
    "explanation": "This type of architecture leverages the idea of platform diversity. Having multiple vendors and platforms helps to ensure that a single vendor's failure or vulnerability does not prevent an organization from continuing to function. Platform agnostic is not on the Security+ exam but typically means that organizations don't have a vested interest in which platform is selected or used. Multi\u2010cloud environments run in multiple cloud vendors' tools, but this question involves physical router hardware. Parallel processing is a failure testing mode where two or more sites run at the same time during a test.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      150,
      151,
      158,
      159,
      161
    ],
    "source": "9781394211395"
  },
  {
    "id": 1021,
    "question": "Kaito has deployed a system that accepts traffic from web browsers and distributes it to systems based on the number of connections that each server has. He has assigned each server a rating based on how powerful it is. Each time a new request comes in, requests are sent to the system with the lowest number of connections after taking into account the relative rating of each server. What type of load balancing is Kaito using?",
    "choice_a": "Source IP hashing",
    "choice_b": "Resource\u2010based",
    "choice_c": "Weighted least connection",
    "choice_d": "Round\u2010robin",
    "correct_answer": "C",
    "explanation": "Kaito is using a weighted least connection load balancing approach, which distributes traffic based on both a server weight and connection number count. Source IP hashing uses a hash of the source and destination IP addresses to determine which server receives the connection. This also allows for interrupted sessions to go to the same server. Resource\u2010based load balancing takes into account the availability of resources like CPU, memory, and network bandwidth for a server. Round\u2010robin load balancing simply distributes connections as they come in by moving through a list of servers.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      217,
      157,
      150,
      151,
      170
    ],
    "source": "9781394211395"
  },
  {
    "id": 1022,
    "question": "Jessica has port\u2010scanned a multifunction printer and has discovered that the device provides services on ports 80, 443, 515, and 9100. Which of the following terms best describes this?",
    "choice_a": "The printer's attack surface",
    "choice_b": "The printer's security zone",
    "choice_c": "The printer's scalability",
    "choice_d": "The printer's resilience",
    "correct_answer": "A",
    "explanation": "Attack surfaces are the potential points for an attack to occur. For devices, this is often the open services. For organizations, attack surfaces can include open ports and services, physical security concerns, and human vectors. Security zones are a way for organizations to categorize and manage different devices and systems based on security classification. Scalability describes whether a service or system can grow or shrink to handle demand or load. Resilience describes if a system or service can tolerate issues that might otherwise result in outages.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      211,
      193,
      204,
      222,
      150
    ],
    "source": "9781394211395"
  },
  {
    "id": 1023,
    "question": "Geoff is considering whether to deploy on\u2010premises infrastructure or cloud\u2010hosted infrastructure. His most important requirements in order are: <ul> <li>Ease of scalability</li> <li>Management overhead</li> <li>Cost</li> </ul> <b></b> <p>If Geoff wants to run a containerized service that can handle very large loads, what model should he select?",
    "choice_a": "SaaS",
    "choice_b": "PaaS",
    "choice_c": "IaaS",
    "choice_d": "On\u2010premises",
    "correct_answer": "C",
    "explanation": "An infrastructure\u2010as\u2010a\u2010service (IaaS) cloud\u2010hosted model where a third\u2010party provider focuses on scalability and administration of a containerization service will meet Geoff's needs. When scaling from low to very large load is a common event, the ability to grow or shrink in a cloud environment can also provide significant cost savings over paying for an on\u2010premises option that can handle the full scaling event. Software as a service (SaaS) and platform as a service (PaaS) provide full applications or platforms, not containerization environments.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      168,
      170,
      175,
      157,
      159
    ],
    "source": "9781394211395"
  },
  {
    "id": 1024,
    "question": "Bank account numbers, credit card numbers, and invoice information are all examples of what type of data?",
    "choice_a": "Intellectual property",
    "choice_b": "Financial",
    "choice_c": "Public",
    "choice_d": "Trade secrets",
    "correct_answer": "B",
    "explanation": "Financial data includes transactions, accounts, and many other types of information related to finances. Intellectual property is a broad category of data created by humans. Public information is information that is available to the public, and trade secrets are kept private to a limited number of individuals in a company for competitive advantage or other purposes.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      319,
      318,
      9,
      10,
      316
    ],
    "source": "9781394211395"
  },
  {
    "id": 1025,
    "question": "John has deployed three servers that all respond as though they're the same device to provide service he runs. What term best describes this configuration?",
    "choice_a": "Load balancing",
    "choice_b": "Clustering",
    "choice_c": "Fail\u2010open",
    "choice_d": "Fail\u2010closed",
    "correct_answer": "B",
    "explanation": "Clustering involves using two or more systems to provide a service as though they're a single server. Load balancing spreads workloads across multiple independent systems while front\u2010ending them with a load balancer device or service to distribute load. Fail\u2010open means that if a network device fails, traffic continues to pass through it. Fail\u2010closed devices stop traffic if they fail. Decisions about fail\u2010open and fail\u2010closed are made based on security in most cases, with fail\u2010closed being more secure if the organization relies on the device for security.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      150,
      217,
      157,
      151,
      211
    ],
    "source": "9781394211395"
  },
  {
    "id": 1026,
    "question": "Alaina's organization is required to comply with the PCI DSS standard. What type of data is she most likely dealing with?",
    "choice_a": "Intellectual property",
    "choice_b": "Trade secrets",
    "choice_c": "Financial information",
    "choice_d": "Regulated information",
    "correct_answer": "C",
    "explanation": "PCI DSS is a credit card data security standard, meaning that Alaina is most likely dealing with financial information. PCI DSS does not directly address intellectual property or trade secrets, and it's not a regulation.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      319,
      316,
      318,
      9,
      11
    ],
    "source": "9781394211395"
  },
  {
    "id": 1027,
    "question": "Theresa wants to back up her virtualization environment. What backup scheme is most frequently used for virtual machines?",
    "choice_a": "Journaling",
    "choice_b": "Snapshots",
    "choice_c": "Replication",
    "choice_d": "Grandfather/Father/Son",
    "correct_answer": "B",
    "explanation": "Snapshots are used to copy both the data and machine state for virtual machines. Journaling is used for databases and similar uses where replaying actions can be useful to recover if an issue occurs. Replication copies the data synchronously or asynchronously, allowing for a separate copy to be available at all times. Grandfather/Father/Son is a backup cycle commonly used for tape backup.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      156,
      153,
      154,
      155,
      174
    ],
    "source": "9781394211395"
  },
  {
    "id": 1028,
    "question": "What is the primary reason an organization might choose a parallel processing testing scenario over a fail over testing scenario?",
    "choice_a": "Parallel processing allows for more throughput.",
    "choice_b": "Fail over does not fully test redundant systems.",
    "choice_c": "Fail over requires organizations to create a significant issue to allow for the fail over to occur.",
    "choice_d": "Parallel processing typically handles issues without outages.",
    "correct_answer": "D",
    "explanation": "Parallel processing allows for systems to be tested without taking them offline. This means that in the event of an issue with the backup systems or facility, the primary facility can continue to operate. Parallel processing does allow for more throughput, but organizations should not rely on this as parallel processing environments need to be able to handle the full load for the organization if the primary or backup fails. Fail over does test redundant systems and does not require organizations to create a significant issue. Instead, manual fail over processes are used to conduct fail over tests.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      161,
      150,
      157,
      153,
      217
    ],
    "source": "9781394211395"
  },
  {
    "id": 1029,
    "question": "Brent wants to monitor traffic using an IPS. He needs to prevent attack traffic from impacting his datacenter and wants to minimize the amount of traffic that the IPS device has to filter. Where should he place the device to best match these requirements based on the following figure? <img src=\"/question_assets/Security+/c03uf001.png\" alt=\"A diagram has five phases connected horizontally using two-way arrows labeled from A to D. The phases are internet, border firewall, core router, datacenter firewall, and datacenter router.\"/>\n\n<figcaption>A diagram has five phases connected horizontally using two-way arrows labeled from A to D. The phases are internet, border firewall, core router, datacenter firewall, and datacenter router.</figcaption>",
    "choice_a": "Position A",
    "choice_b": "Position B",
    "choice_c": "Position C",
    "choice_d": "Position D",
    "correct_answer": "D",
    "explanation": "Placing the IPS inline at position D will reduce the amount of traffic it has to filter while still allowing it to filter traffic bound for the datacenter. Points A, B, and C will all have more traffic, although point A will have the most, with reductions likely at points C and D.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      211,
      210,
      151,
      9,
      11
    ],
    "source": "9781394211395"
  },
  {
    "id": 1030,
    "question": "Marco is preparing to brief his organization's leadership about challenges that may result from adopting a hybrid cloud design. Which of the following is the primary concern that he should highlight?",
    "choice_a": "Jurisdictional challenges",
    "choice_b": "Increased complexity",
    "choice_c": "Increased cost",
    "choice_d": "Regulatory challenges",
    "correct_answer": "B",
    "explanation": "Increased complexity can include jurisdictional challenges, increased cost, and regulatory challenges as well as visibility challenges, management overhead increases, and a wide range of additional challenges from operating in multiple locations and models.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      169,
      179,
      172,
      151,
      159
    ],
    "source": "9781394211395"
  },
  {
    "id": 1031,
    "question": "Julia is designing her organization's external connectivity as part of infrastructure capacity planning. She knows that the organization typically uses approximately 7 gigabits per second of connectivity from their primary site. Julia has the following connectivity options, what should she select?",
    "choice_a": "A 10 Gbps primary and a 5 Gbps secondary connection",
    "choice_b": "A 5 Gbps primary and a 5 Gbps secondary connection",
    "choice_c": "A 100 Gbps primary and a 10 Gbps secondary connection",
    "choice_d": "A 10 Gbps primary and a 10 Gbps secondary connection",
    "correct_answer": "D",
    "explanation": "In general, fail over connections should be able to handle an organization's full throughput. Overprovisioning for 100 Gbps will typically create significantly more cost not only for connectivity but also for network devices that can handle high speeds, and underprovisioning at 5 Gbps will mean that traffic would need to be reduced in a fail over scenario.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      160,
      315,
      157,
      150,
      211
    ],
    "source": "9781394211395"
  },
  {
    "id": 1032,
    "question": "Daria wants to establish a disaster recovery site that can immediately take over for her organization's primary datacenter in the event of a disaster. What sort of site should she build out?",
    "choice_a": "A hot site",
    "choice_b": "A warm site",
    "choice_c": "A cold site",
    "choice_d": "A dispersion site",
    "correct_answer": "A",
    "explanation": "A hot site is prepared to take over processing for on organization immediately, and infrastructure is running in parallel with your production site. A warm site would have some hardware ready to be used, but the hardware would not be configured or otherwise ready for immediate resumption of service. Cold sites are spaces that are ready to be used in a disaster but without equipment or other necessary items in place to quickly take over production if needed. The term dispersion site is not commonly used, but the concept of geographic dispersion describes placement of sites with sufficient distance between them to make the likelihood of a single disaster impacting both quite low.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      158,
      159,
      315,
      161,
      150
    ],
    "source": "9781394211395"
  },
  {
    "id": 1033,
    "question": "Cathy wants to build a high\u2010availability infrastructure for her midsize company's headquarters building network. Which of the following is not a common element for a high\u2010availability network core?",
    "choice_a": "Redundant routers",
    "choice_b": "Generators",
    "choice_c": "Geographic dispersion",
    "choice_d": "Multiple connectivity providers",
    "correct_answer": "C",
    "explanation": "Geographic dispersion is unlikely for a single building's network core. Redundancy, power backups, and multiple connectivity options are commonly part of designing a highly available network.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      150,
      151,
      157,
      152,
      180
    ],
    "source": "9781394211395"
  },
  {
    "id": 1034,
    "question": "The GDPR, HIPAA, FERPA, and the GLBA all impact what type of data?",
    "choice_a": "Intellectual property",
    "choice_b": "Classified data",
    "choice_c": "Regulated data",
    "choice_d": "Trade secrets",
    "correct_answer": "C",
    "explanation": "The General Data Protection Regulation (GDPR), Health Insurance Portability and Accountability Act (HIPAA), Family Educational Rights and Privacy Act (FERPA), and the Gramm\u2013Leach\u2013Bliley Act (GLBA) are all regulations, meaning that data they cover is regulated data. Intellectual property is the result of human creativity, classified data is a designation used by governments, and trade secrets are proprietary data with limited access often used by organizations for competitive advantage.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      319,
      316,
      10,
      318,
      11
    ],
    "source": "9781394211395"
  },
  {
    "id": 1035,
    "question": "Jacob is concerned about attacks against his virtual machines that would target the hypervisor. What term describes this type of attack?",
    "choice_a": "VM escape",
    "choice_b": "Hypervisor escalation",
    "choice_c": "VM shell attacks",
    "choice_d": "Container breaches",
    "correct_answer": "A",
    "explanation": "Virtual machine (VM) escape attacks attempt to access or gain control of the underlying hypervisor through virtual machines. While uncommon, if this occurred it could result in serious issues due to the number of systems run on a single hypervisor host particularly in cloud or shared environments. The other options were made up for the question.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      179,
      174,
      175,
      168,
      169
    ],
    "source": "9781394211395"
  },
  {
    "id": 1036,
    "question": "Jill knows that IPSec uses a number of common protocols. Which of the following is not a key IPSec protocol?",
    "choice_a": "AH",
    "choice_b": "ISA",
    "choice_c": "ESP",
    "choice_d": "IKE",
    "correct_answer": "B",
    "explanation": "AH (Authentication Header), ESP (Encapsulating Security Payload), and IKE (Internet Key Exchange) are all important IPSec (Internet Protocol Security) protocols. ISA is not an IPSec protocol.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      210,
      222,
      8,
      177,
      211
    ],
    "source": "9781394211395"
  },
  {
    "id": 1037,
    "question": "An IDS is an example of what type of network device?",
    "choice_a": "Active",
    "choice_b": "Air gapped",
    "choice_c": "Fail\u2010closed",
    "choice_d": "Passive",
    "correct_answer": "D",
    "explanation": "Intrusion detection systems are considered passive systems because they cannot block traffic. Active systems like firewalls, IPS, and proxies all have the ability to directly interact with and stop or allow traffic. Air gapped devices do not have a physical connection to a network, or they are on a separate network that is not connected to other networks. Fail\u2010closed devices stop traffic when they fail. Most IPS systems are not deployed inline since they do not need to be interactive and having them inline only creates another potential failure point.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      211,
      218,
      212,
      9,
      193
    ],
    "source": "9781394211395"
  },
  {
    "id": 1038,
    "question": "Why can't hashing be used to securely store data that needs to be accessed in its original form?",
    "choice_a": "Hashing takes too long to reverse.",
    "choice_b": "Hashing uses symmetric encryption.",
    "choice_c": "Hashing uses a one\u2010way function.",
    "choice_d": "Hashing uses asymmetric encryption.",
    "correct_answer": "C",
    "explanation": "Hashing uses a one\u2010way function and should not be able to be reversed. This means that you can use hashing to securely store a password because you can hash the password, then compare hashes without needing to know the password. If you hash a database field, however, there's no way to know what the original data was from the hash. Hashing should not be reversible, and it does not use symmetric or asymmetric encryption.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      318,
      10,
      8,
      316,
      182
    ],
    "source": "9781394211395"
  },
  {
    "id": 1039,
    "question": "Jerome wants to use an obfuscation method to protect data in his database. His organization works with sensitive customer data and does not want to run the risk of that data being exposed via their web application, but still wants to use the rest of their customer data in the application. What obfuscation process or tool should he use to ensure that the data can be matched to customers while remaining secure?",
    "choice_a": "Use a steganographic program to modify the data, then use that data for the web application.",
    "choice_b": "Use a masking algorithm to completely mask the data, then use a single database.",
    "choice_c": "Tokenize the data and use the tokenized data in a database set up for the web application.",
    "choice_d": "Hash the data in the original database, then use the database for the web application.",
    "correct_answer": "C",
    "explanation": "Tokenizing the data in a separate database will allow both the original unaltered database and a secured database to be used. This reduces risk while retaining data integrity where required. Steganography hides data in images and does not fit this use case. Masking only conceals data and does not protect it against attacks against the underlying application or database in many cases. Hashing the original database will transform the data, and using a single database remains risky.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      318,
      10,
      316,
      11,
      9
    ],
    "source": "9781394211395"
  },
  {
    "id": 1040,
    "question": "Jules is planning a SCADA deployment for her organization. Which of the following is most likely to be a major concern over the lifetime of the SCADA system?",
    "choice_a": "Cost",
    "choice_b": "Scalability",
    "choice_c": "Inability to patch",
    "choice_d": "Availability",
    "correct_answer": "C",
    "explanation": "SCADA and ICS systems often suffer from a lack of patches and updates. Cost is typically amortized over long periods of time, and SCADA and ICS systems are critical to organizational functions. Scalability is rarely a concern for embedded devices, and SCADA and ICS devices are designed for long life cycles and reliability.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      201,
      204,
      151,
      160,
      315
    ],
    "source": "9781394211395"
  },
  {
    "id": 1041,
    "question": "Susan has deployed a network using software\u2010defined networking. What part of her network is most critical to secure as part of this architecture?",
    "choice_a": "The routers",
    "choice_b": "The switches",
    "choice_c": "The SDN controller",
    "choice_d": "The SD\u2010WAN connections",
    "correct_answer": "C",
    "explanation": "In a SDN environment, the SDN controller provides manages and controls all the network devices, including switches and routers. That means that a compromise of the SDN controller would result in compromise of the entire network. No mention is made of SD\u2010WAN in the question, so we don't know the connectivity or relative importance of SD\u2010WAN in the scenario.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      177,
      211,
      212,
      218,
      150
    ],
    "source": "9781394211395"
  },
  {
    "id": 1042,
    "question": "The ability to obtain third\u2010party support for a device or system is an example of which consideration?",
    "choice_a": "Availability",
    "choice_b": "Risk transference",
    "choice_c": "Compute",
    "choice_d": "Responsiveness",
    "correct_answer": "B",
    "explanation": "Third\u2010party support availability is an example of risk transference where the support contract moves the risk to the contractor. Availability and responsiveness may be considerations for the contractor, but the ability to obtain support doesn't imply either of these. Compute is most commonly a concern where embedded devices or hardware solutions may not have sufficient computational power to meet new needs.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      151,
      172,
      159,
      160,
      315
    ],
    "source": "9781394211395"
  },
  {
    "id": 1043,
    "question": "Yarif wants to create security zones in his network. Which of the following technologies is best suited to doing this based on roles and user identities?",
    "choice_a": "NAC and VLANs",
    "choice_b": "802.1X and containerization",
    "choice_c": "SDN and MAC address filtering",
    "choice_d": "SD\u2010WAN and VLANs",
    "correct_answer": "A",
    "explanation": "Network access control (NAC) tools that can allow for authentication and authorization based on user groups or roles and VLANs that separate groups based on those roles once they're on the network exactly fit the needs Yarif has. 802.1X can also be helpful with this, but containerization is used to allow applications to be deployed without worrying about the application environment. SDN and MAC address filtering doesn't account for user authentication and identities, just machine hardware addresses. SD\u2010WAN is for external connectivity, not internal networks.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      193,
      212,
      211,
      11,
      213
    ],
    "source": "9781394211395"
  },
  {
    "id": 1044,
    "question": "Elle is conducting an exercise for her organization and wants to run an exercise that is as close to an actual event as possible. What type of event should she run to help her organization get this type of real\u2010world practice?",
    "choice_a": "A simulation",
    "choice_b": "A tabletop exercise",
    "choice_c": "A walk\u2010through",
    "choice_d": "A wargame",
    "correct_answer": "A",
    "explanation": "A simulation is the closest you can get to a real\u2010world event without having one. A tabletop exercise has personnel discussing scenarios, whereas a walk\u2010through goes through checklists and procedures. A wargame is not a common exercise type.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      161,
      158,
      159,
      315,
      160
    ],
    "source": "9781394211395"
  },
  {
    "id": 1045,
    "question": "What security advantage does a serverless model provide?",
    "choice_a": "Cost savings",
    "choice_b": "No need to patch infrastructure",
    "choice_c": "No vulnerable functions",
    "choice_d": "No need to log events",
    "correct_answer": "B",
    "explanation": "Serverless deployments remove the need to patch underlying infrastructure. They may still have vulnerable functions and should be logged. Cost savings is not a direct security advantage.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      168,
      175,
      182,
      179,
      172
    ],
    "source": "9781394211395"
  },
  {
    "id": 1046,
    "question": "Laura is planning for continuity of operations. What personnel concern should she plan to handle for her hot site in the event of a large\u2010scale natural disaster in the area where her primary facility is?",
    "choice_a": "Lack of facility power",
    "choice_b": "Inability to authenticate personnel",
    "choice_c": "Insider threats",
    "choice_d": "Lack of available personnel",
    "correct_answer": "D",
    "explanation": "In a large\u2010scale disaster scenario, personnel may be unwilling or unable to report to work. Organizations planning for disaster in an area where their personnel live and work often need to identify ways to ensure staffing in a scenario that impacts their staff. Lack of facility power is not a personnel issue. Authentication should be part of the hot\u2010site capability. Insider threats are not a common concern during disasters.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      160,
      158,
      315,
      161,
      150
    ],
    "source": "9781394211395"
  },
  {
    "id": 1047,
    "question": "Which of the following is not a common means of enforcing segmentation on a network?",
    "choice_a": "ACLs",
    "choice_b": "VLANs",
    "choice_c": "Firewalls",
    "choice_d": "Air gaps",
    "correct_answer": "D",
    "explanation": "ACLs, VLANs, and firewalls are all commonly used to implement network segmentation. Due to the operational challenges that air gaps create, they are far less commonly implemented and are only used when absolutely necessary.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      212,
      193,
      218,
      11,
      177
    ],
    "source": "9781394211395"
  },
  {
    "id": 1048,
    "question": "Binary files are an example of what type of data?",
    "choice_a": "Human\u2010readable",
    "choice_b": "Restricted",
    "choice_c": "Non\u2010human\u2010readable",
    "choice_d": "Confidential",
    "correct_answer": "C",
    "explanation": "Binary files like executable programs are examples of non\u2010human\u2010readable data. That's one of the reasons encoding schemes like XML were created for data files that can allow both machines and humans to read and interact with data. Restricted and confidential are both classification schemes that businesses may use to describe their organizational data.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      319,
      316,
      10,
      318,
      9
    ],
    "source": "9781394211395"
  },
  {
    "id": 1049,
    "question": "Erin uses a journaling backup scheme for her database. After a system outage she needs to restore from her backups. If her organization uses a daily backup scheme that runs at midnight, and the issue occurred at 2 a.m., how much data is Erin likely to lose?",
    "choice_a": "Two hours of data",
    "choice_b": "One day and two hours of data",
    "choice_c": "One week of data",
    "choice_d": "Little or no data",
    "correct_answer": "D",
    "explanation": "Journaling tracks transactions as they occur. Unless the journal itself was lost, Melissa should be able to restore the backup, then replay the journal to ensure the organization loses very little data.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      153,
      154,
      155,
      315,
      161
    ],
    "source": "9781394211395"
  },
  {
    "id": 1050,
    "question": "Which of the following is typically used to manage an ICS?",
    "choice_a": "SDN",
    "choice_b": "SCADA",
    "choice_c": "Active Directory",
    "choice_d": "SD\u2010WAN",
    "correct_answer": "B",
    "explanation": "SCADA systems are often used to manage industrial control systems (ICSs). SDN and SD\u2010WAN are used to manage networks and connectivity respectively, whereas Active Directory is used to manage Windows servers and workstations in a domain environment.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      201,
      204,
      177,
      193,
      212
    ],
    "source": "9781394211395"
  },
  {
    "id": 1051,
    "question": "Maria's organization uses a cloud backup provider and performs encrypted backups for their IaaS infrastructure and data. If the data needs to be restored, what will Maria need to do?",
    "choice_a": "Ask the vendor for the recovery key.",
    "choice_b": "Provide the recovery key.",
    "choice_c": "Restore the recovery key from backup and use it.",
    "choice_d": "Generate a new recovery key and restore from backup.",
    "correct_answer": "B",
    "explanation": "Encrypted backups require the encryption key, so Maria's organization will need to preserve and protect the recovery key in a secure manner that does not rely on the backups. This is often done via multiple physical copies of the key stored in secured locations with geographic diversity or using both physical and cloud secure storage like a key management system (KMS).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      190,
      155,
      182,
      8,
      315
    ],
    "source": "9781394211395"
  },
  {
    "id": 1052,
    "question": "What two major differences separate backups and replication?",
    "choice_a": "Replication is periodic, but does not require restoration processes before data is able to be used.",
    "choice_b": "Backups are continuous but require restoration processes before data is able to be used.",
    "choice_c": "Backups are periodic and do not require restoration before data is able to be used",
    "choice_d": "Replication is continuous and does not require restoration processes before data is able to be used.",
    "correct_answer": "D",
    "explanation": "Replication is a continuous process and because of this it does not require restoration processes like restoring differential backups or journals to allow data to be used. Backups are periodic, and they typically require additional restoration work in order to be used.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      153,
      315,
      156,
      161,
      159
    ],
    "source": "9781394211395"
  },
  {
    "id": 1053,
    "question": "Erin's organization uses a backup schedule that creates a full backup once a week, then creates differential backups once a day on all other days. If the full backup was done four days ago, and Erin needs to restore from it, how many backups will she have to restore in total?",
    "choice_a": "One",
    "choice_b": "Two",
    "choice_c": "Three",
    "choice_d": "Four",
    "correct_answer": "D",
    "explanation": "Erin will need to restore the full backup, then apply the differential backups from each of the remaining three days for a total of four backups.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      153,
      154,
      155,
      160,
      156
    ],
    "source": "9781394211395"
  },
  {
    "id": 1054,
    "question": "What advantage does an IPSec VPN have over a TLS VPN when protecting traffic?",
    "choice_a": "It operates at the network layer rather than the transport layer.",
    "choice_b": "It supports stronger encryption types.",
    "choice_c": "It does not rely on tunneling.",
    "choice_d": "It does not provide advantages over TLS, and TLS should be used instead when possible.",
    "correct_answer": "A",
    "explanation": "IPSec VPNs operate at the network layer instead of the transport layer. That means less information is visible to potential attackers. Both support strong encryption, IPSec VPNs do support tunneling, and not relying on tunneling is not an advantage in most use cases.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      210,
      222,
      212,
      211,
      8
    ],
    "source": "9781394211395"
  },
  {
    "id": 1055,
    "question": "Vera wants to manage multiple commercial Internet services for her organization to ensure connectivity. What technology should she select to manage and maintain this?",
    "choice_a": "SASE",
    "choice_b": "SDN",
    "choice_c": "IPSec",
    "choice_d": "SD\u2010WAN",
    "correct_answer": "D",
    "explanation": "Vera can use a SD\u2010WAN, or software\u2010defined wide area network, to manage multiple connections dynamically, ensuring connectivity and performance for her organization. SASE is used to secure networks and device connectivity in modern organizations with complex and mobile boundaries. SDN is software\u2010defined networking and manages networks as code. IPSec is a suite of protocols used to secure network traffic.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      177,
      211,
      157,
      159,
      169
    ],
    "source": "9781394211395"
  },
  {
    "id": 1056,
    "question": "Katie is considering deploying embedded devices. Which of the following limitations is most commonly associated with embedded devices?",
    "choice_a": "Compute limitations",
    "choice_b": "Responsiveness limitations",
    "choice_c": "Availability issues",
    "choice_d": "Cost issues",
    "correct_answer": "A",
    "explanation": "Embedded devices typically have minimal CPUs, memory, and storage. They prioritize responsiveness for their core functions, and thus availability and responsiveness are typically met with the device. Cost for embedded devices is typically associated with the larger device they're part of rather than the embedded device itself as they are there to monitor or operate the system.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      204,
      151,
      193,
      211,
      157
    ],
    "source": "9781394211395"
  },
  {
    "id": 1057,
    "question": "What term best describes intangible assets created by staff members of a company like designs and concepts?",
    "choice_a": "Trade secrets",
    "choice_b": "Sensitive data",
    "choice_c": "Intellectual property",
    "choice_d": "Trademarks",
    "correct_answer": "C",
    "explanation": "Intellectual property is intangible creations by the human mind. Patents, copyrights, trademarks, and trade secrets are all examples of intellectual property. Intellectual property is not necessarily sensitive data, but it could be.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      319,
      316,
      318,
      10,
      11
    ],
    "source": "9781394211395"
  },
  {
    "id": 1058,
    "question": "Jaime is concerned about the volume of logs that her new application may create. What capacity planning item should she focus on?",
    "choice_a": "Compute",
    "choice_b": "Power",
    "choice_c": "Storage",
    "choice_d": "People",
    "correct_answer": "C",
    "explanation": "Storage capacity should be part of Jaime's infrastructure planning to ensure that large volumes of logs do not overwhelm her infrastructure. Compute is typically not an issue with logs, but it could be with log analysis later in her design process. People and power are not directly impacted by logging, but people might be needed for log analysis later as well.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      160,
      176,
      170,
      154,
      155
    ],
    "source": "9781394211395"
  },
  {
    "id": 1059,
    "question": "Henry's organization relies on remote workers in multiple regions. Each region has an office where workers work part\u2010time, and the organization's core services rely on a variety of SaaS providers. What network model best describes this type of usage model?",
    "choice_a": "Centralized",
    "choice_b": "Decentralized",
    "choice_c": "On\u2010premises",
    "choice_d": "Logically segmented",
    "correct_answer": "B",
    "explanation": "This organization is using a decentralized model where there is no datacenter or primary hosting or operational facility. With remote workers making up much of the company, as well as flexible working locations, this design makes sense for the company but introduces additional complexity because endpoints will need to be secured wherever they are, regardless of what network they are on. A centralized design can somewhat simplify that, but modern application stacks and working conditions often make that less likely. This is not an on\u2010premises design since workers and cloud tools are remote. There is no description of segmentation in the question.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      169,
      168,
      180,
      211,
      177
    ],
    "source": "9781394211395"
  },
  {
    "id": 1060,
    "question": "Tom wants to use geographic restrictions as part of his security design. What type of tool is commonly used to manage geographic restrictions for mobile devices?",
    "choice_a": "EDR",
    "choice_b": "MDM",
    "choice_c": "802.1X",
    "choice_d": "VPNs",
    "correct_answer": "B",
    "explanation": "Mobile device management (MDM) tools are often used to enforce geographic restrictions on devices by using GPS and Wi\u2010Fi to determine where they are and to limit their access to sensitive systems or data if they are not in an allowed geographic boundary. This often matches being in a specific office building with known Wi\u2010Fi for highly sensitive access or work hour requirements. Endpoint detection and response (EDR) is used to counter ransomware and other malicious software, 802.1X is used to control access to networks, and VPNs are used to provide site\u2010to\u2010site connectivity through untrusted networks as well as to location shift devices.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      235,
      11,
      9,
      182,
      193
    ],
    "source": "9781394211395"
  },
  {
    "id": 1061,
    "question": "Jack has deployed a load balancer for his organization. When a new connection is made, the load balancer assigns the connection to the next server in a list, moving through the list over time as it distributes connections. What type of load balancing algorithm is in use?",
    "choice_a": "Capacity\u2010based",
    "choice_b": "Round\u2010robin",
    "choice_c": "Least load",
    "choice_d": "User pinning",
    "correct_answer": "B",
    "explanation": "Round\u2010robin load balancer algorithms spread load by assigning incoming connections to servers or services on a list. This helps to spread the load evenly even without awareness of the relative load each connection creates or that the server is under simply by relying on connections evening out over time. Load\u2010based and capacity\u2010based models use more knowledge of the state of the servers or services. User pinning is not a load balancing model.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      217,
      157,
      150,
      159,
      151
    ],
    "source": "9781394211395"
  },
  {
    "id": 1062,
    "question": "What is the best way to protect data at rest?",
    "choice_a": "Classification",
    "choice_b": "Segmentation",
    "choice_c": "Encryption",
    "choice_d": "Hashing",
    "correct_answer": "C",
    "explanation": "Encryption is the most effective way to protect data at rest. Classification is useful to ensure data is handled in appropriate ways, but does not directly protect the data. Segmentation can help keep data in the right locations with appropriate controls around it, but again does not directly protect the data if the server or data store is accessible. Hashing is a one\u2010way function and does not leave data in a usable state for most purposes that rely on the data being intact and in its original form.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      8,
      10,
      318,
      316,
      190
    ],
    "source": "9781394211395"
  },
  {
    "id": 1063,
    "question": "Kathleen wants to monitor her datacenter's environmental status. What solution should she invest in to meet this need?",
    "choice_a": "An HVAC system",
    "choice_b": "UPS systems",
    "choice_c": "Environmental sensor appliances",
    "choice_d": "A load balancer",
    "correct_answer": "C",
    "explanation": "Environmental sensor appliances are frequently deployed to datacenters and network closets to monitor for potential issues like high temperatures. Heating, ventilation, and air\u2010conditioning (HVAC) systems monitor and control temperatures, but datacenters commonly add additional monitoring tools in case the HVAC system fails or other issues arise. UPS systems are not used for environmental monitoring, and load balancers are used to distribute load to servers and services.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      160,
      150,
      201,
      173,
      204
    ],
    "source": "9781394211395"
  },
  {
    "id": 1064,
    "question": "Danielle's organization has experienced a total power outage. The datacenter is currently running on its UPS. What concern should Danielle have if the UPS is her organization's only power resilience control?",
    "choice_a": "The generator may not start.",
    "choice_b": "The UPS batteries may run out before the outage is over.",
    "choice_c": "The generator may run out of fuel in a long outage.",
    "choice_d": "The UPS may not handle the surge when power resumes.",
    "correct_answer": "B",
    "explanation": "Organizations typically deploy both a UPS and a generator (or generators!). Long power outages will drain the batteries that a UPS relies on. Since UPS systems are typically intended to run for minutes, rather than hours, for datacenters this should be Danielle's first concern. No generator was mentioned, and in fact the UPS is her only power resilience control. While a UPS may experience issues with surges when power resumes, temporary drops in voltage, and power outages are not uncommon even on well\u2010maintained power grids, and UPS systems are designed to handle them under normal circumstances while protecting the systems they provide emergency power to.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      150,
      151,
      160,
      161,
      152
    ],
    "source": "9781394211395"
  },
  {
    "id": 1065,
    "question": "Valerie wants to connect one of her company's remote locations back to the organization's main network. What type of solution can she use for a persistent connection between the networks that will securely tunnel data across a commodity Internet connection?",
    "choice_a": "A TLS VPN",
    "choice_b": "A web proxy",
    "choice_c": "An IPSec VPN",
    "choice_d": "An 802.1X tunnel",
    "correct_answer": "C",
    "explanation": "An IPSec VPN is a common option for organizations that need to create a secure VPN tunnel between two locations. A VPN connection is established by network devices at both locations and traffic is able to travel securely over commodity Internet connections. TLS VPNs are more commonly used for individuals to connect to an organization's network. Web proxies are used to filter and control web traffic, not for this purpose. 802.1X is used to authenticate to networks and protect them from unauthorized connections, not to create secure, multisite tunnels.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      222,
      218,
      211,
      193,
      11
    ],
    "source": "9781394211395"
  },
  {
    "id": 1066,
    "question": "What does port security use to determine what machines or devices can connect to a network port?",
    "choice_a": "A list of userIDs",
    "choice_b": "A multifactor token code for each user",
    "choice_c": "A list of MAC addresses",
    "choice_d": "A list of IP addresses",
    "correct_answer": "C",
    "explanation": "Port security associates a list of allowed hardware (MAC) addresses with a port and only allows systems with permitted MAC addresses to connect to and send traffic through the network port. 802.1X uses authentication, which can include userIDs and multifactor. IP addresses are not a way that port security filters systems.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      211,
      193,
      11,
      210,
      222
    ],
    "source": "9781394211395"
  },
  {
    "id": 1067,
    "question": "Valerie wants to provide remote access to her organization's applications to users who are traveling or working remotely. She wants to ensure that users have a secure way to work with organizational data, but also wants to provide the simplest and easiest secure means of access. What should Valerie implement?",
    "choice_a": "An IPSec VPN",
    "choice_b": "A jump server",
    "choice_c": "A TLS VPN",
    "choice_d": "An SD\u2010WAN controller",
    "correct_answer": "C",
    "explanation": "TLS VPNs provide an easier user experience from the browser without installing additional software or additional configuration like an IPSec VPN typically requires. A jump server is used for access to secure zones but isn\u2019t ideal for traveling and remote employees\u2014often a VPN is used to access a jump server in scenarios like that. SD\u2010WAN is useful to manage connectivity options, not for individual users.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      222,
      11,
      211,
      193,
      212
    ],
    "source": "9781394211395"
  },
  {
    "id": 1068,
    "question": "Which of the following is not available as part of a snapshot?",
    "choice_a": "The underlying hypervisor's configuration",
    "choice_b": "The virtual machine's power state",
    "choice_c": "The virtual machine's memory state",
    "choice_d": "The virtual machine's disks",
    "correct_answer": "A",
    "explanation": "The virtual machine's power state, memory state, and disk are all captured as part of a snapshot. The underlying hypervisor's configuration is not captured by a snapshot.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      174,
      175,
      156,
      179,
      152
    ],
    "source": "9781394211395"
  },
  {
    "id": 1069,
    "question": "What role does geolocation play in considerations related to data?",
    "choice_a": "It determines if data is at rest.",
    "choice_b": "It impacts data sovereignty concerns.",
    "choice_c": "It determines if data is in use.",
    "choice_d": "It determines the data's criticality.",
    "correct_answer": "B",
    "explanation": "Data sovereignty concerns are driven by where the data resides, and geolocation can help understand the applicable law or regulations. Data can be at rest, in use, or in transit in any given location. Data criticality is determined by an organization, not by its location.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      179,
      180,
      11,
      8,
      316
    ],
    "source": "9781394211395"
  },
  {
    "id": 1070,
    "question": "Dane works for an energy provider that manages devices throughout a large geographic region using a control system that monitors and controls power infrastructure. The system operates from a central command center and uses cellular, broadband, and other connectivity methods to connect devices to the control center. What type of system is Dane's company using?",
    "choice_a": "RTOS",
    "choice_b": "Embedded systems",
    "choice_c": "IoT",
    "choice_d": "SCADA",
    "correct_answer": "D",
    "explanation": "SCADA manages complex systems by combining central and local control systems with communication systems to manage large\u2010scale industrial processes. The endpoint devices described may be embedded systems, Internet of Things (IoT), or real\u2010time operating systems (RTOSs), but together they are a SCADA system.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      201,
      204,
      173,
      193,
      212
    ],
    "source": "9781394211395"
  },
  {
    "id": 1071,
    "question": "Jorge wants to assess his organization's Internet\u2010accessible attack surface. Which of the following methods is most likely to provide a complete understanding?",
    "choice_a": "Open source intelligence (OSINT) review",
    "choice_b": "Threat feeds",
    "choice_c": "Vulnerability scanning",
    "choice_d": "Penetration testing",
    "correct_answer": "D",
    "explanation": "Penetration tests will typically include vulnerability scanning as well as other activities that can provide a more complete view of an organization's Internet\u2010facing attack surface. OSINT alone will not provide technical testing. Threat feeds do not provide information about a specific organization's attack surface, and vulnerability scanning may not reveal other issues like application issues.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      211,
      161,
      319,
      11,
      218
    ],
    "source": "9781394211395"
  },
  {
    "id": 1072,
    "question": "Brent has deployed multiple brands of IoT devices across his organization to ensure that if an issue with one type of device or device vendor occurs others will still function. What is the largest concern he should address with this design that focuses on platform diversity?",
    "choice_a": "Complexity of management",
    "choice_b": "Availability",
    "choice_c": "Resilience",
    "choice_d": "Ease of deployment",
    "correct_answer": "A",
    "explanation": "IoT devices are typically deployed for long periods of time, meaning that over time the complexity of managing a multiple device and vendor environment is the largest concern. Initial concerns about ease of deployment would exist but could be overcome. Availability and resilience are both typically helped by platform diversity as outages or issues found with one device or vendor should not impact others.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      150,
      151,
      204,
      193,
      160
    ],
    "source": "9781394211395"
  },
  {
    "id": 1073,
    "question": "Mark wants to protect data in use. Which of the following options should he select to protect data in use?",
    "choice_a": "Hashing",
    "choice_b": "A secure enclave",
    "choice_c": "Containerization",
    "choice_d": "Tunneling data",
    "correct_answer": "B",
    "explanation": "A secure enclave is one way of protecting data in use. This relies on secured hardware that stores data that is in use and that only allows processes that run in the enclave from accessing data. Hashing, containerization, and using tunneling do not provide security for data in use.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      8,
      318,
      10,
      190,
      182
    ],
    "source": "9781394211395"
  },
  {
    "id": 1074,
    "question": "The following figure shows two simplified design concepts. What security architecture is shown in Model 2? <img src=\"/question_assets/Security+/c03uf002.png\" alt=\"Two model diagrams. Model 1. A webserver and a private network is connected using a firewall. Model 2. A web server and a private network is not connected.\"/>\n\n<figcaption>Two model diagrams. Model 1. A webserver and a private network is connected using a firewall. Model 2. A web server and a private network is not connected.</figcaption>",
    "choice_a": "Logical segmentation",
    "choice_b": "Air gapped",
    "choice_c": "Serverless",
    "choice_d": "On\u2010premises",
    "correct_answer": "B",
    "explanation": "There is no connection between the two network security zones in Model 2. This is an air gapped model with physical isolation. Logical segmentation would show VLANs or other logical segmentation options. Servers are shown, easily dismissing serverless as an option, and there is no indication of whether this is an on\u2010premises or an off\u2010site design.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      212,
      211,
      11,
      193,
      218
    ],
    "source": "9781394211395"
  },
  {
    "id": 1075,
    "question": "Masking, encryption, and tokenization are all examples of what?",
    "choice_a": "Data encryption methods",
    "choice_b": "Data classification methods",
    "choice_c": "Data obfuscation methods",
    "choice_d": "Data tagging methods",
    "correct_answer": "C",
    "explanation": "Masking, encryption, and tokenization are all examples of data obfuscation methods that protect against data exposure. None of these are encryption or classification methods, and none of them are tagging methods, although classification often involves tagging data if it will be managed or monitored using automated methods.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      318,
      10,
      319,
      9,
      316
    ],
    "source": "9781394211395"
  },
  {
    "id": 1076,
    "question": "Liana wants to deploy a load balancer and wants to ensure that if a session is interrupted users have the highest chance of being reconnected to the same server. What algorithm should she select?",
    "choice_a": "Round\u2010robin",
    "choice_b": "IP hash",
    "choice_c": "Weighted least connection",
    "choice_d": "Resource\u2010based",
    "correct_answer": "B",
    "explanation": "IP hash relies on a hash of the client and server's IP addresses to associate them with a server. Even if you're not familiar with load\u2010balancing techniques, you can rule out round\u2010robin, which simply distributes sessions through a list in order; weighted least connection, which looks at which servers have the least traffic and a weight assigned to the server; and resource\u2010based, which looks at how heavily loaded a server is.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      217,
      150,
      157,
      180,
      161
    ],
    "source": "9781394211395"
  },
  {
    "id": 1077,
    "question": "Kyle wants to authenticate users who plug into his network, then assign them to a VLAN based on their role. What technology could he use to do this?",
    "choice_a": "802.1X",
    "choice_b": "Port security",
    "choice_c": "VLAN tagging",
    "choice_d": "EAP",
    "correct_answer": "A",
    "explanation": "802.1X allows for authentication via EAP, then assignment to a VLAN based on a role or other attributes. EAP alone does not perform this function, port security leverages MAC addresses to determine if a system is allowed to connect, and VLAN tagging is part of how traffic is labeled for a specific VLAN but does not support authentication or role\u2010based labels directly.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      213,
      11,
      212,
      222,
      232
    ],
    "source": "9781394211395"
  },
  {
    "id": 1078,
    "question": "Using VLANs is an example of what type of segmentation?",
    "choice_a": "Air gapping",
    "choice_b": "Logical segmentation",
    "choice_c": "Physical segmentation",
    "choice_d": "Physical isolation",
    "correct_answer": "B",
    "explanation": "Logical segmentation uses software to define and create segmentation. VLANs are defined at the network layer using VLAN tags. Air gapping would remove network connectivity between a system or systems and other networks to prevent access via the network. Physical segmentation would require separate network infrastructure. Physical isolation typically means removing a system from a network.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      212,
      193,
      211,
      210,
      177
    ],
    "source": "9781394211395"
  },
  {
    "id": 1079,
    "question": "Lucca has deployed an SD\u2010WAN controller. Which of the following types of connectivity will not typically be managed with an SD\u2010WAN solution?",
    "choice_a": "Wi\u2010Fi",
    "choice_b": "MPLS",
    "choice_c": "Broadband",
    "choice_d": "LTE",
    "correct_answer": "A",
    "explanation": "Wi\u2010Fi and other on premises network solutions are not typically part of an SD\u2010WAN implementation. SD\u2010WAN focuses on wide area networks, which are outside the on\u2010premises network borders of organizations, and thus technologies like MPLS, broadband, and LTE are used with SD\u2010WAN controllers.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      211,
      177,
      193,
      210,
      172
    ],
    "source": "9781394211395"
  },
  {
    "id": 1080,
    "question": "The information that is found on Kirk's company's Internet\u2010facing website needs to be classified as part of his organization\u2010wide data classification process. What classification should he apply?",
    "choice_a": "Public",
    "choice_b": "Internal",
    "choice_c": "Confidential",
    "choice_d": "Restricted",
    "correct_answer": "A",
    "explanation": "Information that is available without restriction or authentication and that is available on an Internet\u2010facing website should be considered public information. Internal, confidential, and restricted information all require additional controls and handling practices.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      316,
      319,
      9,
      10,
      11
    ],
    "source": "9781394211395"
  },
  {
    "id": 1081,
    "question": "Jim wants to design his network for high availability (HA). What first step is commonly taken in HA designs for networks?",
    "choice_a": "Configure a hot site.",
    "choice_b": "Purchase redundant hardware.",
    "choice_c": "Identify single points of failure.",
    "choice_d": "Implement clustering.",
    "correct_answer": "C",
    "explanation": "Identifying single points of failure is a common first step in network high availability designs. This allows network designers to plan for failures and how to avoid them. Configuring a hot site, implementing clustering, and purchasing redundant hardware all occur much further into the design process when needs are identified and prioritized.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      151,
      150,
      158,
      315,
      161
    ],
    "source": "9781394211395"
  },
  {
    "id": 1082,
    "question": "Theo wants to ensure that artifacts in his IaC environment have not been tampered with. What should he require as part of his version control check\u2010in system?",
    "choice_a": "Artifact signing",
    "choice_b": "Container image scanning",
    "choice_c": "Dependency checks",
    "choice_d": "Static analysis",
    "correct_answer": "A",
    "explanation": "Having artifacts signed after they have made it through the build and validation process helps ensure that they haven't been modified and that the artifact has had the organization's checks done. Container image scanning helps to find issues like malware and dependency issues. Dependency checks can validate things like open source tool risks or issues. Static analysis requires manual review of code.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      182,
      175,
      10,
      318,
      156
    ],
    "source": "9781394211395"
  },
  {
    "id": 1083,
    "question": "Angela is considering using encryption as part of the security controls applied to her backups. In the event of a major disaster, what concern should she address about having encrypted backups?",
    "choice_a": "Time to decrypt the backups",
    "choice_b": "Cost of encrypting the backups",
    "choice_c": "Ensuring the key is recoverable in a disaster",
    "choice_d": "The amount of space that the encryption adds to the backups",
    "correct_answer": "C",
    "explanation": "A primary concern for organizations that encrypt their backups is whether the keys are available in a disaster. Ensuring that the keys are stored in a manner that ensures that they are recoverable if the backups are recoverable is critical. Modern backup encryption typically does not add a meaningful amount of time to backups, nor does it increase cost or space to such a significant degree that it is a primary concern.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      155,
      190,
      154,
      153,
      182
    ],
    "source": "9781394211395"
  },
  {
    "id": 1084,
    "question": "Which of the following is not a common security issue with IoT devices?",
    "choice_a": "Insecure communication",
    "choice_b": "Data leaks",
    "choice_c": "Ransomware",
    "choice_d": "Device vulnerabilities",
    "correct_answer": "C",
    "explanation": "Ransomware concerns are typically found with desktops, laptops, mobile devices, and servers instead of IoT devices. IoT devices often don't have patches or aren't patched, send data to third parties that may not be desired, and may not use secure communications.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      204,
      193,
      201,
      222,
      8
    ],
    "source": "9781394211395"
  },
  {
    "id": 1085,
    "question": "Jack is worried about outages that may disrupt service from his IaaS vendor's cloud environment. Which of the following options provides the greatest likelihood of avoiding service disruptions from an outage from his current IaaS vendor?",
    "choice_a": "Deploying to multiple availability zones (AZs)",
    "choice_b": "Deploying to multiple regions",
    "choice_c": "Deploying to multiple cloud vendors",
    "choice_d": "Requiring contractual terms around uptime",
    "correct_answer": "C",
    "explanation": "In circumstances where a single vendor's outages are a major concern, multi\u2010cloud deployments may be appropriate. This is more common when the application is containerized or otherwise easily portable. The more customized to the current cloud vendor the application or service is, the more difficult it is to move to other cloud vendors and the more costly the move will be. In addition, multi\u2010cloud can drive additional costs for overhead services, making multi\u2010cloud a choice organizations undertake cautiously. Deploying in multiple AZs or regions will not avoid an outage if the IaaS vendor has a cloud\u2010wide issue, and contractual obligations won't stop outages\u2014they will typically just provide penalties if there is an outage longer than the contract allows.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      159,
      150,
      180,
      151,
      169
    ],
    "source": "9781394211395"
  },
  {
    "id": 1086,
    "question": "Chuck is responsible for an on\u2010site datacenter. He wants to ensure that the datacenter has appropriate network connectivity to ensure resilience and performance. Which of the following will have the greatest impact on meeting that requirement?",
    "choice_a": "Contract for a higher bandwidth connection from a single vendor.",
    "choice_b": "Deploy a UPS.",
    "choice_c": "Contract with two separate network service providers.",
    "choice_d": "Install a generator.",
    "correct_answer": "C",
    "explanation": "Meeting both resilience and performance requirements can be best addressed in this scenario by contracting with two separate network service providers. This allows for both resilience and the possibility of sending traffic through both connections for greater performance. Both a generator and a UPS can help with power resilience, but the focus of this question is network connectivity.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      150,
      159,
      180,
      158,
      160
    ],
    "source": "9781394211395"
  },
  {
    "id": 1087,
    "question": "Ben has grouped his data based on use cases and sensitivity and has applied different security practices based on those groupings. What data security technique is he using?",
    "choice_a": "Segmentation",
    "choice_b": "Obfuscation",
    "choice_c": "Masking",
    "choice_d": "Tokenization",
    "correct_answer": "A",
    "explanation": "Segmentation of data separates data based on factors like use cases, sensitivity, roles, and types or classifications of information. Obfuscation attempts to conceal or hide information. Masking replaces information with other data like asterisks or X's when displayed, allowing partial data to be displayed for business purposes. Tokenization replaces data with an alternate value, often based on a hashing algorithm that allows the alternate value to be used as an index or reference without the actual data visible.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      316,
      11,
      10,
      318,
      319
    ],
    "source": "9781394211395"
  },
  {
    "id": 1088,
    "question": "Monica wants to prevent users from sharing data and cares more about control than flexibility. What type of access control model is best suited to ensuring central control over file access?",
    "choice_a": "Role BAC",
    "choice_b": "DAC",
    "choice_c": "MAC",
    "choice_d": "Rule BAC",
    "correct_answer": "C",
    "explanation": "Mandatory access control (MAC) is used in scenarios where users should not have the ability to grant access to files. Role\u2010based access control and rule\u2010based access control both provide more flexibility, and they are more commonly used than mandatory access control in cases where that is desired. Discretionary access control (DAC) allows users to grant access to other users and does not fit the requirements either.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      11,
      213,
      177,
      9,
      182
    ],
    "source": "9781394211395"
  },
  {
    "id": 1089,
    "question": "Tara is monitoring web traffic to her organization's website from a local public library and notices that all of the logins seem to come from the same IP address. She knows that the library provides multiple workstations for public use as well as public Wi\u2010Fi. What type of network appliance might be in use?",
    "choice_a": "A jump server",
    "choice_b": "A proxy server",
    "choice_c": "A load balancer",
    "choice_d": "A DLP system",
    "correct_answer": "B",
    "explanation": "A proxy server is likely to be used in an environment where the ability to filter searches may be required, such as a library with public workstations. A jump server is used to access more secure zones, a load balancer is typically used to allow multiple systems to provide a service, and a DLP system is used to prevent unauthorized data exfiltration.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      217,
      150,
      211,
      11,
      9
    ],
    "source": "9781394211395"
  },
  {
    "id": 1090,
    "question": "What three responsibilities are typically shared in PaaS environments according to the cloud responsibility matrix?",
    "choice_a": "Identity infrastructure, applications, and network controls",
    "choice_b": "Data, devices, and accounts",
    "choice_c": "Physical hosts, physical networks, and physical datacenters",
    "choice_d": "Operating systems, applications, and data",
    "correct_answer": "A",
    "explanation": "In platform\u2010as\u2010a\u2010service (PaaS) environments, customers and providers typically share responsibility for identity and directory infrastructure, applications, and network controls. Customers are responsible for data, devices, and accounts, and the provider is responsible for the underlying systems, including operating systems and physical infrastructure.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      168,
      172,
      169,
      177,
      175
    ],
    "source": "9781394211395"
  },
  {
    "id": 1091,
    "question": "Marco wants to build a set of services for financial transactions for his company. The services need to be capable of scaling quickly to very large numbers of transactions, and need to be able to operate without major dependencies on other components of the architecture. What architecture should he select to best meet these needs?",
    "choice_a": "Containerization",
    "choice_b": "Virtualization",
    "choice_c": "Microservices",
    "choice_d": "SCADA",
    "correct_answer": "C",
    "explanation": "A microservices design will allow for each component or service to be separate and lightweight, allowing them to be developed independently and thus easier to fix without complex dependencies. Containerization would allow for easy deployment of applications to different service environments, but the focus for containerization is on portability, not on the design requirements listed. Virtualization requires even more resources because operating systems are virtualized, but it suffers from the same lack of a direct means of addressing the needs explained in the question. SCADA stands for supervisory control and data acquisition and is used to manage complex industrial or controls\u2019 environments, not service environments like the question describes.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      175,
      170,
      157,
      151,
      172
    ],
    "source": "9781394211395"
  },
  {
    "id": 1092,
    "question": "What major advantage does a monitoring port have over an inline network tap?",
    "choice_a": "It is easier to configure.",
    "choice_b": "It has higher performance.",
    "choice_c": "It is more secure.",
    "choice_d": "If it fails, it will not impact the network.",
    "correct_answer": "D",
    "explanation": "The biggest advantage of a monitoring port over an inline network tap is that if the monitoring port fails, it will not impact the network traffic flow. If an inline device fails, it may impact the network traffic even if it is designed to avoid that scenario. Inline taps don't have to rely on the performance of the switch, meaning that they are often higher performance; they can be passive, meaning that they cannot be attacked like a switch's operating system can be; and since inline passive devices simply copy traffic, they are often easier to configure since you merely plug them in.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      211,
      150,
      152,
      315,
      177
    ],
    "source": "9781394211395"
  },
  {
    "id": 1093,
    "question": "Which of the following is not typically true of embedded systems?",
    "choice_a": "They provide the ability to install additional software.",
    "choice_b": "They have a long lifespan.",
    "choice_c": "They have memory and CPU constraints.",
    "choice_d": "They are not designed for end\u2010user configuration and control.",
    "correct_answer": "A",
    "explanation": "Embedded systems are often used for long periods of time, use relatively low\u2010power CPUs and have limited memory and storage, and are typically not user configurable or manageable in meaningful ways. They typically don't have the ability to install additional software as they are purpose\u2010built to serve a specific need.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      204,
      173,
      201,
      170,
      151
    ],
    "source": "9781394211395"
  },
  {
    "id": 1094,
    "question": "Naomi wants to be able to easily move her application between cloud service providers and to use automation to allow for deployment of the application. What technology best allows for applications to be bundled with the libraries and other components they need without requiring additional overhead like an operating system?",
    "choice_a": "Containerization",
    "choice_b": "Snapshots",
    "choice_c": "Embedded systems",
    "choice_d": "Segmentation",
    "correct_answer": "A",
    "explanation": "Containerization technologies bundle the needed libraries and other components for an application together in a lightweight package format that can easily be deployed to a provider's containerization service. Snapshots are used to capture a virtual machine's state and data at a given point in time. Embedded systems are computers that are built into a device or system. Segmentation is the concept of dividing a network or system into separate parts, often with security and other boundaries between them.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      175,
      168,
      169,
      159,
      170
    ],
    "source": "9781394211395"
  },
  {
    "id": 1095,
    "question": "What term describes the right of countries to pass laws that control the use of data within their borders?",
    "choice_a": "Data classification",
    "choice_b": "Treaty obligations",
    "choice_c": "Treaty rights",
    "choice_d": "Data sovereignty",
    "correct_answer": "D",
    "explanation": "Data sovereignty is the right of nations to pass laws that control the use of data within their borders. This means that organizations must follow each country's laws when they store, process, or otherwise handle data in the country they operate in. Data classification is a process of classifying data to set handling or other processes and practices around it. Treaties are not covered by the Security+ exam.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      179,
      180,
      11,
      316,
      319
    ],
    "source": "9781394211395"
  },
  {
    "id": 1096,
    "question": "Ian's organization uses a root certificate authority that only allows certificate signing locally. All certificates are transferred via USB drives because the system is not connected to the network. What type of security design is in use?",
    "choice_a": "Port security",
    "choice_b": "An air gapped design",
    "choice_c": "Defense\u2010in\u2010depth",
    "choice_d": "A zero\u2010trust design",
    "correct_answer": "B",
    "explanation": "This is an example of air gapped design where there is no network connectivity. This prevents network\u2010based attacks from being possible against the high\u2010value certificate authority server. Port security is used to enable or disable network ports. Defense\u2010in\u2010depth is a design concept that relies on layers of defenses to ensure security. Zero trust requires continuous authentication and rights verification to provide ongoing security for a network or system architecture.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      212,
      211,
      213,
      190,
      11
    ],
    "source": "9781394211395"
  },
  {
    "id": 1097,
    "question": "The company that Jayne works for has moved their web application infrastructure to a serverless model. Jayne's security team has informed her that they believe the application is undergoing a large\u2010scale resource exhaustion\u2010based distributed denial\u2010of\u2010service attack. If the application is running in Microsoft's serverless Azure environment, what is the most critical concern Jayne should have about the attack?",
    "choice_a": "Loss of data",
    "choice_b": "Cost of the resource usage",
    "choice_c": "Inability to review logs",
    "choice_d": "Vulnerabilities in the application",
    "correct_answer": "B",
    "explanation": "A large\u2010scale denial\u2010of\u2010service attack that is using resources can be costly. Microsoft's cloud will be able to scale to meet the demand, but Jayne's organization may spend large amounts of money without benefiting any legitimate customers. Loss of data is unlikely because the application is being heavily used without any underlying issue for the application's data. Log files will still be created, but the size and scale of the logs may drive cost. There is nothing in the scenario that demonstrates a vulnerability, and resource exhaustion attacks do not require a vulnerability to be successful.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      170,
      151,
      157,
      172,
      180
    ],
    "source": "9781394211395"
  },
  {
    "id": 1098,
    "question": "Elaine knows that prior to 802.1X enabling a port, only EAP traffic is allowed through the port. What does this permit?",
    "choice_a": "Vulnerability scanning",
    "choice_b": "Authentication",
    "choice_c": "Port scanning",
    "choice_d": "System security status validation",
    "correct_answer": "B",
    "explanation": "EAP (Extensible Authentication Protocol) is used for 802.1X authentication before the port is enabled for other traffic. EAP does not permit vulnerability or port scanning, nor does it provide system security status validation.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      222,
      212,
      210,
      193,
      211
    ],
    "source": "9781394211395"
  },
  {
    "id": 1099,
    "question": "Tristan deploys the network device shown in the following figure. The organization's web browsing traffic is directed through it and the traffic is filtered as described in the image. What type of network appliance is shown? <img src=\"/question_assets/Security+/c03uf003.png\" alt=\"A laptop and a server is connected to internet with a mediator labeled as follows. Conceals internal I P addresses for web traffic, blocks website ads, applies content control for websites.\"/>\n\n<figcaption>A laptop and a server is connected to internet with a mediator labeled as follows. Conceals internal I P addresses for web traffic, blocks website ads, applies content control for websites.</figcaption>",
    "choice_a": "A web application firewall",
    "choice_b": "A proxy server",
    "choice_c": "A jump server",
    "choice_d": "A load balancer",
    "correct_answer": "B",
    "explanation": "The functions shown are typical of a proxy server. The proxy can be used to apply content controls and to conceal the IP addresses of internal users. A web application firewall filters web traffic but is specifically targeting attacks and malicious behavior. A jump server is used between a low\u2010trust and a higher\u2010trust area to provide access, and this is not shown or described in the image or question. A load balancer is used to distribute traffic load between servers, and this is not shown in the image or reflected in the question.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      218,
      211,
      217,
      179,
      177
    ],
    "source": "9781394211395"
  },
  {
    "id": 1100,
    "question": "Parvati wants to configure her web application firewall to prevent basic SQL injection attacks. Which of the following rules could she use to accomplish this?",
    "choice_a": "Filter out all OR statements.",
    "choice_b": "Filter out single quotes.",
    "choice_c": "Block all SQL statements.",
    "choice_d": "Block all AND statements.",
    "correct_answer": "B",
    "explanation": "While blocking single quotes won't stop all SQL injection, it will stop many basic injection attacks. Preventing the use of SQL or <code>AND</code> and <code>OR</code> statements may break some applications, although secure web applications should be using stored queries.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      218,
      11,
      179,
      222,
      318
    ],
    "source": "9781394211395"
  },
  {
    "id": 1101,
    "question": "John wants to harden his organization's routers. If there are no currently known vulnerabilities or issues with the device, which of the following hardening options will provide the biggest benefit?",
    "choice_a": "Moving their administrative interfaces to a protected VLAN",
    "choice_b": "Disabling unnecessary services",
    "choice_c": "Installing the most current patch level for the OS",
    "choice_d": "Enabling SNMP\u2010based logging",
    "correct_answer": "A",
    "explanation": "While all of these are best practices, moving the device's administrative interface to a protected VLAN will provide the most significant improvement in security since there are no known issues or vulnerabilities at the moment. If there were, patching or disabling services would quickly move up the list.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      194,
      51,
      53,
      214,
      93
    ],
    "source": "9781394211395"
  },
  {
    "id": 1102,
    "question": "Jackson is reviewing his organization's logs and discovers multiple new user accounts created after business hours using administrative credentials. What term describes searching for potential issues like this?",
    "choice_a": "IoC creation",
    "choice_b": "Threat hunting",
    "choice_c": "Root cause analysis",
    "choice_d": "Eradication",
    "correct_answer": "B",
    "explanation": "Threat hunting is the process of searching for threats, often using IoCs, threat intelligence, technological tools, and expertise to identify threats that might impact an organization. IoC creation involves documenting and defining an indicator of compromise. Root cause analysis looks for the underlying cause of an issue or event, and eradication is the complete removal of a threat or artifacts of malicious activity.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      62,
      250,
      246,
      240,
      258
    ],
    "source": "9781394211395"
  },
  {
    "id": 1103,
    "question": "Cynthia is concerned about attacks against an application programming interface (API) that her company provides for its customers. What should she recommend to ensure that the API is only used by customers who have paid for the service?",
    "choice_a": "Require authentication.",
    "choice_b": "Install and configure a firewall.",
    "choice_c": "Filter by IP address.",
    "choice_d": "Install and use an IPS.",
    "correct_answer": "A",
    "explanation": "The simplest way to ensure that APIs are only used by legitimate users is to require the use of authentication. API keys are one of the most frequently used methods for this. If an API key is lost or stolen, the key can be invalidated and reissued, and since API keys can be matched to usage, Cynthia's company can also bill customers based on their usage patterns if they want to. A firewall or IP restrictions may be able to help, but they can be fragile; customer IP addresses may change. An intrusion prevention system (IPS) can detect and prevent attacks, but legitimate usage would be hard to tell from those who are not customers using an IPS.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      132,
      140,
      214,
      219,
      189
    ],
    "source": "9781394211395"
  },
  {
    "id": 1104,
    "question": "Greg wants to gain admission to a network which is protected by a network access control (NAC) system that recognized the hardware address of systems. How can he bypass this protection?",
    "choice_a": "Spoof a legitimate IP address.",
    "choice_b": "Conduct a denial\u2010of\u2010service attack against the NAC system.",
    "choice_c": "Use MAC cloning to clone a legitimate MAC address.",
    "choice_d": "None of the above.",
    "correct_answer": "C",
    "explanation": "Greg can clone a legitimate Media Access Control (MAC) address if he can identify one on the network. Greg can do this by checking for a MAC label on some devices or by capturing traffic on the network if he can physically access it.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      215,
      214,
      59,
      267,
      56
    ],
    "source": "9781394211395"
  },
  {
    "id": 1105,
    "question": "Melissa's organization has deployed a firewall that uses three interfaces to provide services. The first interface connects to the Internet, the second to a network where the organization's web servers reside, and the third to a secured network where the organization's workstations are connected. What type of firewall architecture has Melissa's organization deployed?",
    "choice_a": "An ACL",
    "choice_b": "A screened subnet",
    "choice_c": "A binary firewall",
    "choice_d": "A multihomed, multiroute NGFW",
    "correct_answer": "B",
    "explanation": "Screened subnet designs use a firewall with three interfaces, one for the Internet or an untrusted network, one for a protected but front\u2010facing network, and one for a shielded or protected network. ACLs (access control lists) use rules to control access. This design may use ACLs, but an ACL alone does not describe it. Binary firewalls were made up for this question, and while an NGFW may be multihomed, \u201cmultiroute\u201d is not a term used to describe this design.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      189,
      255,
      250,
      240,
      62
    ],
    "source": "9781394211395"
  },
  {
    "id": 1106,
    "question": "CVE is an example of what type of feed?",
    "choice_a": "A threat intelligence feed",
    "choice_b": "A vulnerability feed",
    "choice_c": "A critical infrastructure listing feed",
    "choice_d": "A critical virtualization exploits feed",
    "correct_answer": "B",
    "explanation": "The Common Vulnerabilities and Exposures (CVE) list has entries that describe and provide references to publicly known cybersecurity vulnerabilities. A CVE feed will provide updated information about new vulnerabilities and a useful index number to cross reference with other services.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      50,
      63,
      20,
      22,
      23
    ],
    "source": "9781394211395"
  },
  {
    "id": 1107,
    "question": "Amanda scans a Red Hat Linux server that she believes is fully patched and discovers that the Apache version on the server is reported as vulnerable to an exploit from a few months ago. When she checks to see if she is missing patches, Apache is fully patched. What has occurred?",
    "choice_a": "A false positive",
    "choice_b": "An automatic update failure",
    "choice_c": "A false negative",
    "choice_d": "An Apache version mismatch",
    "correct_answer": "A",
    "explanation": "This is an example of a false positive. A false positive can cause a vulnerability to show that was not actually there. This sometimes happens when a patch or fix is installed but the application does not change in a way that shows the change, and it has been an issue with updates where the version number is the primary check for a vulnerability. When a vulnerability scanner sees a vulnerable version number but a patch has been installed that does not update it, a false positive report can occur. A false negative would report a patch or fix where there was actually a vulnerability. Automatic updates were not mentioned, nor was a specific Apache version.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      48,
      43,
      47,
      63,
      51
    ],
    "source": "9781394211395"
  },
  {
    "id": 1108,
    "question": "Telnet, RSH, and FTP are all examples of what?",
    "choice_a": "File transfer protocols",
    "choice_b": "Unsecure protocols",
    "choice_c": "Core protocols",
    "choice_d": "Open ports",
    "correct_answer": "B",
    "explanation": "All of these protocols are unsecure. FTP has been replaced by secure versions in some uses (SFTP/FTPS), whereas Telnet has been superseded by SSH in modern applications. RSH is outmoded and should be seen only on truly ancient systems. If you find a system or device exposing these protocols, you will need to dig in further to determine why they are exposed and how they can be protected if they must remain open for a legitimate reason.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      53,
      54,
      52,
      133,
      192
    ],
    "source": "9781394211395"
  },
  {
    "id": 1109,
    "question": "What term describes data that is collected from publicly available sources that can be used in an intelligence context?",
    "choice_a": "OPSEC",
    "choice_b": "OSINT",
    "choice_c": "STIX",
    "choice_d": "IntCon",
    "correct_answer": "B",
    "explanation": "OSINT, or open source intelligence, is intelligence information obtained from public sources like search engines, websites, domain name registrars, and a host of other locations. OPSEC, or operational security, refers to habits such as not disclosing unnecessary information. STIX is the Structured Threat Intelligence Exchange protocol, and IntCon was made up for this question.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      20,
      59,
      23,
      22,
      21
    ],
    "source": "9781394211395"
  },
  {
    "id": 1110,
    "question": "Patrick has subscribed to a commercial threat intelligence feed that is only provided to subscribers who have been vetted and who pay a monthly fee. What industry term is used to refer to this type of threat intelligence?",
    "choice_a": "Proprietary threat intelligence",
    "choice_b": "OSINT",
    "choice_c": "ELINT",
    "choice_d": "Corporate threat intelligence",
    "correct_answer": "A",
    "explanation": "Proprietary, or closed threat, intelligence is threat intelligence that is not openly available. OSINT, or open source threat intelligence, is freely available. ELINT is a military term for electronic and signals intelligence. Corporate threat intelligence was made up for this question.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      20,
      22,
      23,
      21,
      59
    ],
    "source": "9781394211395"
  },
  {
    "id": 1111,
    "question": "Susan receives $10,000 for reporting a vulnerability to a vendor who participates in a program to identify issues. What term is commonly used to describe this type of payment?",
    "choice_a": "A ransom",
    "choice_b": "A zero\u2010day disclosure",
    "choice_c": "A bug bounty",
    "choice_d": "A payday",
    "correct_answer": "C",
    "explanation": "Bug bounties are increasingly common and can be quite lucrative. Bug bounty websites match vulnerability researchers with organizations that are willing to pay for information about issues with their software or services. Ransoms are sometimes demanded by attackers, but this is not a ransom since it was voluntarily paid as part of a reward system. A zero\u2010day disclosure happens when a vulnerability is disclosed and the organization has not been previously informed and allowed to fix the issue. Finally, you might feel like $10,000 is a payday, but the term is not used as a technical term and doesn't appear on the exam.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      62,
      55,
      59,
      21,
      23
    ],
    "source": "9781394211395"
  },
  {
    "id": 1112,
    "question": "Ben runs a vulnerability scan using up\u2010to\u2010date definitions for a system that he knows has a vulnerability in the version the web server is running. The vulnerability scan does not show that issue when he reviews the report. What has Ben encountered?",
    "choice_a": "A silent patch",
    "choice_b": "A missing vulnerability update",
    "choice_c": "A false negative",
    "choice_d": "A false positive",
    "correct_answer": "C",
    "explanation": "A false negative occurs with a vulnerability scanning system when a scan is run and an issue that exists is not identified. This can be because of a configuration option, a firewall, or other security setting or because the vulnerability scanner is otherwise unable to detect the issue. A missing vulnerability update might be a concern if the problem did not specifically state that the definitions are fully up\u2010to\u2010date. Unless the vulnerability is so new that there is no definition, a missing update shouldn't be the issue. Silent patching refers to a patching technique that does not show messages to users that a patch is occurring. A false positive would have caused a vulnerability to show that was not actually there. This sometimes happens when a patch or fix is installed but the application does not change in a way that shows the change.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      48,
      43,
      47,
      45,
      42
    ],
    "source": "9781394211395"
  },
  {
    "id": 1113,
    "question": "Angela reviews bulletins and advisories to determine what threats her organization is likely to face. What type of activity is this associated with?",
    "choice_a": "Incident response",
    "choice_b": "Threat hunting",
    "choice_c": "Penetration testing",
    "choice_d": "Vulnerability scanning",
    "correct_answer": "B",
    "explanation": "Threat hunting can involve a variety of activities such as intelligence fusion, combining multiple data sources and threat feeds, and reviewing advisories and bulletins to remain aware of the threat environment for your organization or industry. Incident response happens once an incident has occurred, penetration testing tests security from an attacker's perspective, and vulnerability scanning seeks to identify vulnerabilities using testing through technical means like connecting to services or checking local version information.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      62,
      20,
      22,
      23,
      21
    ],
    "source": "9781394211395"
  },
  {
    "id": 1114,
    "question": "Frank is using the cloud hosting service's web publishing service rather than running his own web servers. Where will Frank need to look to review his logs to see what types of traffic his application is creating?",
    "choice_a": "Syslog",
    "choice_b": "Apache logs",
    "choice_c": "The cloud service's web logs",
    "choice_d": "None of the above",
    "correct_answer": "C",
    "explanation": "Since Frank is using the cloud service provider's web services, he will need to review the logs that they capture. If he has not configured them, he will need to do so, and he will then need a service or capability to analyze them for the types of traffic he is concerned about. Syslog and Apache logs are both found on a traditional web host, and they would be appropriate if Frank was running his own web servers in the infrastructure\u2010as\u2010a\u2010service (IaaS) environment.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      171,
      181,
      246,
      250,
      251
    ],
    "source": "9781394211395"
  },
  {
    "id": 1115,
    "question": "The following graphic shows a report from an OpenVAS vulnerability scan. What should Charles do first to determine the best fix for the vulnerability shown? <img src=\"/question_assets/Security+/c04uf001.png\" alt=\"A screenshot of a page titled, result, P H {-C G I-based setups vulnerability when parsing query string parameters from p h p files. It displays the following information in six columns. Vulnerability, severity, Q o D, host, location, and actions.\"/>\n\n<figcaption>A screenshot of a page titled, result, P H {-C G I-based setups vulnerability when parsing query string parameters from p h p files. It displays the following information in six columns. Vulnerability, severity, Q o D, host, location, and actions.</figcaption>",
    "choice_a": "Disable PHP\u2010CGI.",
    "choice_b": "Upgrade PHP to version 5.4.",
    "choice_c": "Review the vulnerability descriptions in the CVEs listed.",
    "choice_d": "Disable the web server.",
    "correct_answer": "C",
    "explanation": "Although it may be tempting to immediately upgrade, reading and understanding the CVEs for a vulnerability is a good best practice. Once Charles understands the issue, he can then remediate it based on the recommendations for that specific problem. Disabling PHP or the web server would break the service, and in this case, only newer versions of PHP than 5.4 have the patch Charles needs.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      63,
      47,
      49,
      42,
      43
    ],
    "source": "9781394211395"
  },
  {
    "id": 1116,
    "question": "Ian runs a vulnerability scan, which notes that a service is running on TCP port 8080. What type of service is most likely running on that port?",
    "choice_a": "SSH",
    "choice_b": "RDP",
    "choice_c": "MySQL",
    "choice_d": "HTTP",
    "correct_answer": "D",
    "explanation": "Although 80 and 443 are the most common HTTP ports, it is common practice to run additional web servers on port 8080 when a nonstandard port is needed. SSH would be expected to be on port 22, RDP on 3389, and MySQL on 3306.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      59,
      49,
      52,
      53,
      192
    ],
    "source": "9781394211395"
  },
  {
    "id": 1117,
    "question": "Carolyn runs a vulnerability scan of a network device and discovers that the device is running services on TCP ports 22 and 443. What services has she most likely discovered?",
    "choice_a": "Telnet and a web server",
    "choice_b": "FTP and a Windows file share",
    "choice_c": "SSH and a web server",
    "choice_d": "SSH and a Windows file share",
    "correct_answer": "C",
    "explanation": "A network device running SSH on port 22 and a web server on TCP port 443 is a very typical discovery when running a vulnerability scan. Without any demonstrated issues, Carolyn should simply note that she saw those services. Telnet runs on port 21, an unencrypted web server will run on TCP 80 in most cases, and Windows file shares use a variety of ports, including TCP ports 135\u2013139 and 445.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      192,
      52,
      53,
      49,
      40
    ],
    "source": "9781394211395"
  },
  {
    "id": 1118,
    "question": "Susan is responsible for application development in her company. She wants to have all web applications tested before they are deployed live. She wants to use a test system that is identical to the live server. What is this called?",
    "choice_a": "A production server",
    "choice_b": "A development server",
    "choice_c": "A test server",
    "choice_d": "A predeployment server",
    "correct_answer": "C",
    "explanation": "A test server should be identical to the production server. This can be used for functional testing as well as security testing, before deploying the application. The production server is the live server. A development server would be one the programmers use during development of a web application, and predeployment server is not a term typically used in the industry.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      65,
      49,
      85,
      178,
      242
    ],
    "source": "9781394211395"
  },
  {
    "id": 1119,
    "question": "Alexandra is preparing to run automated security tests against the code that developers in her organization have completed. Which environment is she most likely to run them in if the next step is to deploy the code to production?",
    "choice_a": "Development",
    "choice_b": "Test",
    "choice_c": "Staging",
    "choice_d": "Production",
    "correct_answer": "C",
    "explanation": "Staging environments, sometimes called preproduction environments, are typically used for final quality assurance (QA) and validation before code enters the production environment as part of a deployment pipeline. Staging environments closely mirror production, allowing realistic testing and validation to be done. Development and test environments are used to create the code and for testing while it is being developed.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      65,
      66,
      42,
      41,
      48
    ],
    "source": "9781394211395"
  },
  {
    "id": 1120,
    "question": "Chris wants to limit who can use an API that his company provides and be able to log usage of the API uniquely to each organization that they provide access to. What solution is most often used to do this?",
    "choice_a": "Firewalls with rules for each company's public IP address",
    "choice_b": "User credentials for each company",
    "choice_c": "API keys",
    "choice_d": "API passwords",
    "correct_answer": "C",
    "explanation": "Application programming interface (API) keys are frequently used to meet this need. An API key can be issued to an individual or organization, and then use of the API can be tracked to each API key. If the API key is compromised or abused, it can be revoked and a new API key can be issued. Firewall rules written to use public IP addresses can be fragile, since IP addresses may change or organizations may have a broad range of addresses that may be in use, making it hard to validate which systems or users are using the API. Credentials, including passwords, are not as frequently used as API keys.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      132,
      133,
      145,
      246,
      250
    ],
    "source": "9781394211395"
  },
  {
    "id": 1121,
    "question": "Angela wants to ensure that IoT devices in her organization have a secure configuration when they are deployed and that they are ready for further configuration for their specific purposes. What term is used to describe these standard configurations used as part of her configuration management program?",
    "choice_a": "A baseline configuration",
    "choice_b": "An essential settings list",
    "choice_c": "A preinstall checklist",
    "choice_d": "A setup guide",
    "correct_answer": "A",
    "explanation": "Baseline configurations, per NIST 800\u201053: \u201cBaseline configurations serve as a basis for future builds, releases, and/or changes to information systems. Baseline configurations include information about information system components (e.g., standard software packages installed on workstations, notebook computers, servers, network components, or mobile devices; current version numbers and patch information on operating systems and applications; and configuration settings/parameters), network topology, and the logical placement of those components within the system architecture. Maintaining baseline configurations requires creating new baselines as organizational information systems change over time. Baseline configurations of information systems reflect the current enterprise architecture.\u201d.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      196,
      194,
      192,
      197,
      93
    ],
    "source": "9781394211395"
  },
  {
    "id": 1122,
    "question": "Chris is following the CIS Windows Server 2022 benchmark and notices that it recommends that Computer Configuration\\Policies\\Administrative Templates\\Windows Components\\Search\\Allow indexing of encrypted files is set to disabled. What potential issue would this help to prevent?",
    "choice_a": "Data leakage",
    "choice_b": "Denial of service",
    "choice_c": "Insecure service",
    "choice_d": "Dark web access",
    "correct_answer": "A",
    "explanation": "Indexing encrypted files will mean that an unencrypted index is stored, potentially exposing the content of encrypted files. Disabling the indexing service for encrypted files helps to protect them. There is no denial\u2010of\u2010service scenario for this unless a vulnerability in the indexing service is discovered and none is mentioned. The service is not exposed via the network, and dark web access is not accomplished via indexing services.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      194,
      192,
      63,
      254,
      93
    ],
    "source": "9781394211395"
  },
  {
    "id": 1123,
    "question": "Elizabeth wants to implement a cloud\u2010based authorization system. Which of the following protocols is she most likely to use for that purpose?",
    "choice_a": "OpenID",
    "choice_b": "Kerberos",
    "choice_c": "SAML",
    "choice_d": "OAuth",
    "correct_answer": "D",
    "explanation": "OAuth is a common authorization service used for cloud services. It allows users to decide which websites or applications to entrust their information to without requiring them to give them the user's password. OpenID is frequently paired with OAuth as the authentication layer. Kerberos is more frequently used for on\u2010site authentication, and SAML is Security Assertion Markup Language.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      135,
      136,
      134,
      133,
      140
    ],
    "source": "9781394211395"
  },
  {
    "id": 1124,
    "question": "Tony wants to implement a biometric system for entry access in his organization. Which of the following systems is likely to be most accepted by members of his organization's staff?",
    "choice_a": "Fingerprint",
    "choice_b": "Retina",
    "choice_c": "Iris",
    "choice_d": "Voice",
    "correct_answer": "A",
    "explanation": "Fingerprint reader systems are the most widely accepted biometric systems in common use for entry access and other purposes today. Facial recognition systems are increasingly in use and are also likely to be more accepted by user populations based on their broad deployment in phones, but they are not listed as an option. Both retina and iris scans are less likely to be accepted, whereas voice systems are both relatively uncommon and more disruptive for frequent usage.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      142,
      140,
      139,
      148,
      92
    ],
    "source": "9781394211395"
  },
  {
    "id": 1125,
    "question": "What is the primary threat model against static codes used for multifactor authentication?",
    "choice_a": "Brute force",
    "choice_b": "Collisions",
    "choice_c": "Theft",
    "choice_d": "Clock mismatch",
    "correct_answer": "C",
    "explanation": "Static codes are typically recorded in a secure location, but if they are not properly secured, or are otherwise exposed, they can be stolen. Brute\u2010force attempts should be detected and prevented by backoff algorithms and other techniques that prevent attacks against multifactor authentication systems. Collisions exist with hashing algorithms, not with static multifactor codes, and clock mismatch issues occur for time\u2010based one\u2010time password (TOTP) codes.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      141,
      140,
      138,
      137,
      54
    ],
    "source": "9781394211395"
  },
  {
    "id": 1126,
    "question": "Nadine's organization stores and uses sensitive information, including Social Security numbers. After a recent compromise, she has been asked to implement technology that can help prevent this sensitive data from leaving the company's systems and networks. What type of technology should Nadine implement?",
    "choice_a": "Stateful firewalls",
    "choice_b": "OEM",
    "choice_c": "DLP",
    "choice_d": "SIEM",
    "correct_answer": "C",
    "explanation": "The best answer from this list is DLP, or data loss prevention technology. DLP is designed to protect data from being exposed or leaking from a network using a variety of techniques and technology. Stateful firewalls are used to control which traffic is sent to or from a system, but will not detect sensitive data. OEM is an original equipment manufacturer, and security information and event management (SIEM) can help track events and incidents but will not directly protect data itself.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      188,
      246,
      254,
      250,
      256
    ],
    "source": "9781394211395"
  },
  {
    "id": 1127,
    "question": "Social login, the ability to use an existing identity from a site like Google, Facebook, or a Microsoft account, is an example of which of the following concepts?",
    "choice_a": "Federation",
    "choice_b": "AAA",
    "choice_c": "Privilege creep",
    "choice_d": "Identity and access management",
    "correct_answer": "A",
    "explanation": "Social login is an example of a federated approach to using identities. The combination of identity providers and service providers, along with authorization management, is a key part of federation. AAA (authentication, authorization, and accounting) is typically associated with protocols like RADIUS. Privilege creep occurs as staff members change jobs and their privileges are not adjusted to only match their current role. IAM is a broader set of identity and access management practices. Although IAM may be involved in federated identity, this question does not directly describe IAM.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      136,
      135,
      133,
      140,
      145
    ],
    "source": "9781394211395"
  },
  {
    "id": 1128,
    "question": "Charles has configured his multifactor system to require both a PIN and a password. How many effective factors does he have in place once he presents both of these and his username?",
    "choice_a": "One",
    "choice_b": "Two",
    "choice_c": "Three",
    "choice_d": "Four",
    "correct_answer": "A",
    "explanation": "Although it may seem like Charles has presented two factors, in fact he has only presented two types of things he knows along with his identity. To truly implement a multifactor environment, he should use more than one of something you have, something you know, and something you are.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      140,
      142,
      139,
      137,
      145
    ],
    "source": "9781394211395"
  },
  {
    "id": 1129,
    "question": "Naomi is designing her organization's wireless network and wants to ensure that the design places access points in areas where they will provide optimum coverage. She also wants to plan for any sources of RF interference as part of her design. What should Naomi do first?",
    "choice_a": "Contact the FCC for a wireless map.",
    "choice_b": "Conduct a site survey.",
    "choice_c": "Disable all existing access points.",
    "choice_d": "Conduct a port scan to find all existing access points.",
    "correct_answer": "B",
    "explanation": "A site survey is the process of identifying where access points should be located for best coverage and identifying existing sources of RF interference, including preexisting wireless networks and other devices that may use the same radio frequency spectrum. By conducting a site survey, Naomi can guide the placement of her access points as well as create a channel design that will work best for her organization.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      233,
      214,
      133,
      216,
      20
    ],
    "source": "9781394211395"
  },
  {
    "id": 1130,
    "question": "Charlene wants to provision her organization's standard set of marketing information to mobile devices throughout her organization. What MDM feature is best suited to this task?",
    "choice_a": "Application management",
    "choice_b": "Remote wipe",
    "choice_c": "Content management",
    "choice_d": "Push notifications",
    "correct_answer": "C",
    "explanation": "Mobile device management (MDM) suites often provide the ability to manage content on devices as well as applications. Using content management tools can allow Charlene to provision files, documents, and media to the devices that staff members in her organization are issued. Application management would be useful for apps. Remote wipe can remove data and applications from the device if it is lost or stolen, or an employee leaves the organization. Push notifications are useful when information needs to be provided to the device user.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      237,
      239,
      255,
      254,
      197
    ],
    "source": "9781394211395"
  },
  {
    "id": 1131,
    "question": "Denny wants to deploy antivirus for his organization and wants to ensure that it will stop the most malware. What deployment model should Denny select?",
    "choice_a": "Install antivirus from the same vendor on individual PCs and servers to best balance visibility, support, and security.",
    "choice_b": "Install antivirus from more than one vendor on all PCs and servers to maximize coverage.",
    "choice_c": "Install antivirus from one vendor on PCs and from another vendor on the server to provide a greater chance of catching malware.",
    "choice_d": "Install antivirus only on workstations to avoid potential issues with server performance.",
    "correct_answer": "C",
    "explanation": "In this scenario, Denny specifically needs to ensure that he stops the most malware. In situations like this, vendor diversity is the best way to detect more malware, and installing a different vendor's antivirus (AV) package on servers like email servers and then installing a managed package for PCs will result in the most detections in almost all cases. Installing more than one AV package on the same system is rarely recommended, since this often causes performance issues and conflicts between the packages\u2014in fact, at times AV packages have been known to detect other AV packages because of the deep hooks they place into the operating system to detect malicious activity!",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      186,
      44,
      41,
      93,
      254
    ],
    "source": "9781394211395"
  },
  {
    "id": 1132,
    "question": "Madhuri's web application converts numbers that are input into fields by specifically typing them and then applies strict exception handling. It also sets a minimum and maximum length for the inputs that it allows and uses predefined arrays of allowed values for inputs like months or dates. What term describes the actions that Madhuri's application is performing?",
    "choice_a": "Buffer overflow prevention",
    "choice_b": "String injection",
    "choice_c": "Input validation",
    "choice_d": "Schema validation",
    "correct_answer": "C",
    "explanation": "The application includes input validation techniques that are used to ensure that unexpected or malicious input does not cause problems with the application. Input validation techniques will strip out control characters, validate data, and perform a variety of other actions to clean input before it is processed by the application or stored for future use. This validation may help prevent buffer overflows, but other techniques described here are not used for buffer overflow prevention. String injection is actually something this helps to prevent, and schema validation looks at data to ensure that requests match a schema, but again this is a narrower description than the broad range of input validation occurring in the description.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      66,
      86,
      250,
      191,
      93
    ],
    "source": "9781394211395"
  },
  {
    "id": 1133,
    "question": "You're outlining your plans for implementing a wireless network to upper management. What wireless security standard should you adopt if you don't want to use enterprise authentication but want to provide secure authentication for users that doesn't require a shared password or passphrase?",
    "choice_a": "WPA3",
    "choice_b": "WPA",
    "choice_c": "WPA2",
    "choice_d": "WEP",
    "correct_answer": "A",
    "explanation": "WPA3 supports SAE, or simultaneous authentication of equals, providing a more secure way to authenticate that limits the potential for brute\u2010force attacks and allows individuals to use different passwords. WPA is not as secure as WPA2, and WEP is the oldest, and least secure, wireless security protocol. WPA2 is not as secure as WPA3 but remains in use due to broad deployment.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      139,
      133,
      137,
      141,
      54
    ],
    "source": "9781394211395"
  },
  {
    "id": 1134,
    "question": "You are the chief security officer (CSO) for a large company. You have discovered malware on one of the workstations. You are concerned that the malware might have multiple functions and might have caused more security issues with the computer than you can currently detect. What is the best way to test this malware?",
    "choice_a": "Leave the malware on that workstation until it is tested.",
    "choice_b": "Place the malware in a sandbox environment for testing.",
    "choice_c": "It is not important to analyze or test it; just remove it from the machine.",
    "choice_d": "Place the malware on a honeypot for testing.",
    "correct_answer": "B",
    "explanation": "The correct answer is to use a sandboxed environment to test the malware and determine its complete functionality. A sandboxed system could be an isolated virtual machine (VM) or an actual physical machine that is entirely isolated from the network. Leaving the malware on a production system is never the correct approach. You should test or analyze the malware to determine exactly what malware it is, allowing you to respond to the threat properly. A honeypot is used for luring and trapping attackers, not for testing malware.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      186,
      240,
      246,
      254,
      262
    ],
    "source": "9781394211395"
  },
  {
    "id": 1135,
    "question": "Isaac is reviewing his organization's secure coding practices document for customer\u2010facing web applications and wants to ensure that their input validation recommendations are appropriate. Which of the following is not a common best practice for input validation?",
    "choice_a": "Ensure validation occurs on a trusted server.",
    "choice_b": "Validate all client\u2010supplied data before it is processed.",
    "choice_c": "Validate expected data types and ranges.",
    "choice_d": "Ensure validation occurs on a trusted client.",
    "correct_answer": "D",
    "explanation": "Isaac knows that trusting client systems to be secure is not a good idea, and thus ensuring that validation occurs on a trusted client is not an appropriate recommendation. Ensuring that validation occurs on a trusted server, that client data is validated, and that data types and ranges are reasonable are all good best practices for him to recommend.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      66,
      53,
      54,
      191,
      171
    ],
    "source": "9781394211395"
  },
  {
    "id": 1136,
    "question": "Isaac wants to prevent corporate mobile devices from being used outside of his company's buildings and corporate campus. What mobile device management (MDM) capability should he use to allow this?",
    "choice_a": "Patch management",
    "choice_b": "IP filtering",
    "choice_c": "Geofencing",
    "choice_d": "Network restrictions",
    "correct_answer": "C",
    "explanation": "Isaac can configure a geofence that defines his corporate buildings and campus. He can then set up a geofence policy that will only allow devices to work while they are inside that geofenced area. Patch management, IP filtering, and network restrictions are not suitable solutions for this.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      238,
      237,
      239,
      236,
      148
    ],
    "source": "9781394211395"
  },
  {
    "id": 1137,
    "question": "Sophia wants to test her company's web application to see if it is handling business logic properly. Which testing method would be most effective for this?",
    "choice_a": "Static code analysis",
    "choice_b": "Fuzzing",
    "choice_c": "Baselining",
    "choice_d": "Version control",
    "correct_answer": "A",
    "explanation": "Static code analysis can help identify business logic issues by leveraging expert knowledge and understanding of the business process and logic involved. Fuzzing is a technique whereby the tester intentionally enters incorrect values into input fields to see how the application will handle it but doesn't directly test business logic. Baselining is the process of establishing security standards, and version control simply tracks changes in the code\u2014it does not test the code.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      49,
      48,
      65,
      85,
      63
    ],
    "source": "9781394211395"
  },
  {
    "id": 1138,
    "question": "Endpoint detection and response has three major components that make up its ability to provide visibility into endpoints. Which of the following is not one of those three parts?",
    "choice_a": "Data search",
    "choice_b": "Malware analysis",
    "choice_c": "Data exploration",
    "choice_d": "Suspicious activity detection",
    "correct_answer": "B",
    "explanation": "Endpoint detection and response (EDR) focuses on identifying anomalies and issues, but it is not designed to be a malware analysis tool. Instead, the ability to search and explore data, identify suspicious activities, and coordinate responses is what makes up an EDR tool.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      187,
      246,
      254,
      186,
      189
    ],
    "source": "9781394211395"
  },
  {
    "id": 1139,
    "question": "Carl has been asked to set up access control for a server. The requirements state that users at a lower privilege level should not be able to see or access files or data at a higher privilege level. What access control model would best fit these requirements?",
    "choice_a": "MAC",
    "choice_b": "DAC",
    "choice_c": "RBAC",
    "choice_d": "SAML",
    "correct_answer": "A",
    "explanation": "Mandatory access control (MAC) is the correct solution. It will not allow lower privileged users to even see the data at a higher privilege level. Discretionary access control (DAC) has each data owner configure their own security. Role\u2010based access control (RBAC) could be configured to meet the needs, but it's not the best solution for these requirements. Security Assertion Markup Language (SAML) is not an access control model.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      148,
      144,
      143,
      149,
      191
    ],
    "source": "9781394211395"
  },
  {
    "id": 1140,
    "question": "Jack wants to deploy a network access control (NAC) system that will stop systems that are not fully patched from connecting to his network. If he wants to have full details of system configuration, antivirus version, and patch level, what type of NAC deployment is most likely to meet his needs?",
    "choice_a": "Agentless, preadmission",
    "choice_b": "Agent\u2010based, preadmission",
    "choice_c": "Agentless, postadmission",
    "choice_d": "Agent\u2010based, postadmission",
    "correct_answer": "B",
    "explanation": "An agent\u2010based, preadmission system will provide greater insight into the configuration of the system using the agent, and using a preadmission model will allow the system configuration to be tested before the system is allowed to connect to the network. Agentless NAC uses scanning and/or network inventory techniques and will typically not have as deep a level of insight into the configuration and software versions running on a system. Postadmission systems make enforcement decisions based on what users do after they gain admission to a network, rather than prior to gaining admission, allowing you to quickly rule out two of these options.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      214,
      197,
      196,
      133,
      43
    ],
    "source": "9781394211395"
  },
  {
    "id": 1141,
    "question": "Eric wants to provide company\u2010purchased devices, but his organization prefers to provide end users with choices among devices that can be managed and maintained centrally. What mobile device deployment model best fits this need?",
    "choice_a": "BYOD",
    "choice_b": "COPE",
    "choice_c": "CYOD",
    "choice_d": "VDI",
    "correct_answer": "C",
    "explanation": "CYOD, or choose your own device, allows users to choose a device that is corporate owned and paid for. Choices may be limited to set of devices, or users may be allowed to choose essentially any device depending on the organization's deployment decisions. BYOD allows users to bring their own device, whereas COPE, or corporate\u2010owned, personally enabled, provides devices to users that they can then use for personal use. VDI uses a virtual desktop infrastructure as an access layer for any security model where specialized needs or security requirements may require access to remote desktop or application services.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      237,
      239,
      238,
      236,
      197
    ],
    "source": "9781394211395"
  },
  {
    "id": 1142,
    "question": "Claire is concerned about an attacker getting information regarding network devices and their configuration in her company. Which protocol should she implement that would be most helpful in mitigating this risk while providing management and reporting about network devices?",
    "choice_a": "RADIUS",
    "choice_b": "TLS",
    "choice_c": "SNMPv3",
    "choice_d": "SFTP",
    "correct_answer": "C",
    "explanation": "If Claire is using Simple Network Management Protocol (SNMP) to manage and monitor her network devices, she should make sure she is using SNMPv3 and that it is properly configured. SNMPv3 can provide information about the status and configuration of her network devices. Remote Authentication Dial\u2010In User Service (RADIUS) might be used to authenticate to the network, but Transport Layer Security (TLS) and SSH File Transfer Protocol (SFTP) are not specifically used for the purposes described.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      133,
      53,
      196,
      250,
      246
    ],
    "source": "9781394211395"
  },
  {
    "id": 1143,
    "question": "Eric is responsible for his organization's mobile device security. They use a modern mobile device management (MDM) tool to manage a BYOD mobile device environment. Eric needs to ensure that the applications and data that his organization provides to users of those mobile devices remain as secure as possible. Which of the following technologies will provide him with the best security?",
    "choice_a": "Storage segmentation",
    "choice_b": "Containerization",
    "choice_c": "Full\u2010device encryption",
    "choice_d": "Remote wipe",
    "correct_answer": "B",
    "explanation": "Containerization will allow Eric's company's tools and data to be run inside of an application\u2010based container, isolating the data and programs from the self\u2010controlled bring your own device (BYOD) devices. Storage segmentation can be helpful, but the operating system itself as well as the applications would remain a concern. Eric should recommend full\u2010device encryption (FDE) as a security best practice, but encrypting the container and the data it contains can provide a reasonable security layer even if the device itself is not fully encrypted. Remote wipe is helpful if devices are lost or stolen, but the end user may not be okay with having the entire device wiped, and there are ways to work around remote wipes, including blocking cellular and Wi\u2010Fi signals.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      238,
      237,
      236,
      239,
      207
    ],
    "source": "9781394211395"
  },
  {
    "id": 1144,
    "question": "Tara is concerned about staff in her organization sending email with sensitive information like customer Social Security numbers (SSNs) included in it. What type of solution can she implement to help prevent inadvertent exposures of this type of sensitive data?",
    "choice_a": "FDE",
    "choice_b": "DLP",
    "choice_c": "S/MIME",
    "choice_d": "POP3S",
    "correct_answer": "B",
    "explanation": "Data loss prevention (DLP) tools allow sensitive data to be tagged and monitored so that if a user attempts to send it, they will be notified, administrators will be informed, and if necessary, the data can be protected using encryption or other protection methods before it is sent. Full\u2010disk encryption (FDE) would protect data at rest, and S/MIME and POP3S would protect mail being retrieved from a server but would not prevent the SSNs from being sent.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      188,
      220,
      54,
      246,
      254
    ],
    "source": "9781394211395"
  },
  {
    "id": 1145,
    "question": "Mason is responsible for security at a company that has traveling salespeople. The company has been using ABAC for access control to the network. Which of the following is an issue that is specific to ABAC and might cause it to incorrectly reject logins?",
    "choice_a": "Geographic location.",
    "choice_b": "Wrong password.",
    "choice_c": "Remote access is not allowed by ABAC.",
    "choice_d": "Firewalls usually block ABAC.",
    "correct_answer": "A",
    "explanation": "Attribute\u2010based access control (ABAC) looks at a group of attributes, in addition to the login username and password, to make decisions about whether or not to grant access. One of the attributes examined is the location of the person. Since the users in this company travel frequently, they will often be at new locations, and that might cause ABAC to reject their logins. Wrong passwords can certainly prevent login, but are not specific to ABAC. ABAC does not prevent remote access, and a firewall can be configured to allow, or prohibit, any traffic you wish.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      140,
      148,
      214,
      133,
      144
    ],
    "source": "9781394211395"
  },
  {
    "id": 1146,
    "question": "Darrell is concerned that users on his network have too many passwords to remember and might write down their passwords, thus creating a significant security risk. Which of the following would be most helpful in mitigating this issue?",
    "choice_a": "Multifactor authentication",
    "choice_b": "SSO",
    "choice_c": "SAML",
    "choice_d": "LDAP",
    "correct_answer": "B",
    "explanation": "Single sign\u2010on (SSO) is designed specifically to address this risk and would be the most helpful. Users have only a single logon to remember; thus, they have no need to write down the password. OAuth (Open Authorization) is an open standard for token\u2010based authentication and authorization on the Internet. It does not eliminate the use or need for multiple passwords. Multifactor authentication helps prevent risks due to lost passwords, but does not remove the need for multiple passwords by itself. Security Assertion Markup Language (SAML) and Lightweight Directory Access Protocol (LDAP) do not stop users from needing to remember multiple passwords.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      135,
      137,
      138,
      140,
      139
    ],
    "source": "9781394211395"
  },
  {
    "id": 1147,
    "question": "Frank is a security administrator for a large company. Occasionally, a user needs to access a specific resource that they don't have permission to access. Which access control methodology would be most helpful in this situation?",
    "choice_a": "Mandatory access control (MAC)",
    "choice_b": "Discretionary access control (DAC)",
    "choice_c": "Role\u2010based access control",
    "choice_d": "Rule\u2010based access control",
    "correct_answer": "D",
    "explanation": "Rule\u2010based access control applies a set of rules to an access request. Based on the application of the rules, the user may be given access to a specific resource that they were not explicitly granted permission to. MAC, DAC, and role\u2010based access control wouldn't give a user access unless that user has already been explicitly given that access.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      145,
      144,
      148,
      191,
      254
    ],
    "source": "9781394211395"
  },
  {
    "id": 1148,
    "question": "Oliver needs to explain the access control scheme used by both the Windows and Linux filesystems. What access control scheme do they implement by default?",
    "choice_a": "Role\u2010based access control",
    "choice_b": "Mandatory access control",
    "choice_c": "Rule\u2010based access control",
    "choice_d": "Discretionary access control",
    "correct_answer": "D",
    "explanation": "Both the Windows and Linux filesystems work based on a discretionary access control scheme where file and directory owners can determine who can access, change, or otherwise work with files under their control. Role\u2010based access controls systems determine rights based on roles that are assigned to users. Rule\u2010based access control systems use a series of rules to determine which actions can occur, and mandatory access control systems enforce control at the operating system level.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      149,
      144,
      148,
      145,
      143
    ],
    "source": "9781394211395"
  },
  {
    "id": 1149,
    "question": "Stefan just became the new security officer for a university. He is concerned that student workers who work late on campus could try to log in with faculty credentials. Which of the following would be most effective in preventing this?",
    "choice_a": "Time\u2010of\u2010day restrictions",
    "choice_b": "Usage auditing",
    "choice_c": "Password length",
    "choice_d": "Credential management",
    "correct_answer": "A",
    "explanation": "Restricting each faculty account so that it is only usable when that particular faculty member is typically on campus will prevent someone from logging in with that account after hours, even if they have the password. Usage auditing may detect misuse of accounts but will not prevent it. Longer passwords are effective security, but a longer password can still be stolen. Credential management is always a good idea, but it won't address this specific issue.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      145,
      144,
      140,
      52,
      248
    ],
    "source": "9781394211395"
  },
  {
    "id": 1150,
    "question": "Chloe has noticed that users on her company's network frequently have simple passwords made up of common words. Thus, they have weak passwords. How could Chloe best mitigate this issue?",
    "choice_a": "Increase minimum password length.",
    "choice_b": "Have users change passwords more frequently.",
    "choice_c": "Require password complexity.",
    "choice_d": "Implement single sign\u2010on (SSO).",
    "correct_answer": "C",
    "explanation": "Password complexity requires that passwords have a mixture of uppercase letters, lowercase letters, numbers, and special characters. This would be the best approach to correct the problem described in the question. Longer passwords are a good security measure but will not correct the issue presented here. Changing passwords won't make those passwords any stronger, and SSO will have no effect on the strength of passwords.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      137,
      140,
      144,
      93,
      52
    ],
    "source": "9781394211395"
  },
  {
    "id": 1151,
    "question": "A companywide policy is being created to define various security levels. Which of the following systems of access control would use documented security levels like Confidential or Secret for information?",
    "choice_a": "RBAC",
    "choice_b": "MAC",
    "choice_c": "DAC",
    "choice_d": "BAC",
    "correct_answer": "B",
    "explanation": "Mandatory access control (MAC) is based on documented security levels associated with the information being accessed. Role\u2010based access control (RBAC) is based on the role the user is placed in. Discretionary access control (DAC) lets the data owner set access control. BAC is not an access control model.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      148,
      144,
      145,
      149,
      143
    ],
    "source": "9781394211395"
  },
  {
    "id": 1152,
    "question": "Users in your network are able to assign permissions to their own shared resources. Which of the following access control models is used in your network?",
    "choice_a": "DAC",
    "choice_b": "RBAC",
    "choice_c": "MAC",
    "choice_d": "ABAC",
    "correct_answer": "A",
    "explanation": "Discretionary access control (DAC) allows data owners to assign permissions. Role\u2010based access control (RBAC) assigns access based on the role the user is in. Mandatory access control (MAC) is stricter and enforces control at the OS level. Attribute\u2010cased access control (ABAC) considers various attributes such as location, time, and computer in addition to username and password.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      144,
      145,
      149,
      143,
      148
    ],
    "source": "9781394211395"
  },
  {
    "id": 1153,
    "question": "Cynthia is preparing a new server for deployment, and her process includes turning off unnecessary services, setting security settings to match her organization's baseline configurations, and installing patches and updates. What is this process known as?",
    "choice_a": "OS hardening",
    "choice_b": "Security uplift",
    "choice_c": "Configuration management",
    "choice_d": "Endpoint lockdown",
    "correct_answer": "A",
    "explanation": "OS hardening is the process of securing an operating system by patching, updating, and configuring the operating system to be secure. Configuration management is the ongoing process of managing configurations for systems, rather than this initial security step. Both security uplift and endpoint lockdown were made up for this question.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      194,
      192,
      196,
      197,
      51
    ],
    "source": "9781394211395"
  },
  {
    "id": 1154,
    "question": "John is performing a port scan of a network as part of a security audit. He notices that the domain controller is using secure LDAP. Which of the following ports would lead him to that conclusion?",
    "choice_a": "53",
    "choice_b": "389",
    "choice_c": "443",
    "choice_d": "636",
    "correct_answer": "D",
    "explanation": "Secure Lightweight Directory Access Protocol (LDAPS) uses port 636 by default. DNS uses port 53, LDAP uses 389, and secure HTTP uses port 443.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      135,
      59,
      192,
      53,
      133
    ],
    "source": "9781394211395"
  },
  {
    "id": 1155,
    "question": "Which of the following access control methods grants permissions based on the user's position in the organization?",
    "choice_a": "MAC",
    "choice_b": "RBAC",
    "choice_c": "DAC",
    "choice_d": "ABAC",
    "correct_answer": "B",
    "explanation": "Role\u2010based access control (RBAC) grants permissions based on the user's position within the organization. Mandatory access control (MAC) uses security classifications to grant permissions. Discretionary access control (DAC) allows data owners to set permissions. Attribute\u2010based access control (ABAC) considers various attributes such as location, time, and computer, in addition to username and password.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      144,
      145,
      143,
      148,
      52
    ],
    "source": "9781394211395"
  },
  {
    "id": 1156,
    "question": "Gary is designing his cloud infrastructure and needs to provide a firewall\u2010like capability for the virtual systems he is running. Which of the following cloud capabilities acts like a virtual firewall?",
    "choice_a": "Security groups",
    "choice_b": "Dynamic resource allocation",
    "choice_c": "VPC endpoints",
    "choice_d": "Instance awareness",
    "correct_answer": "A",
    "explanation": "Security groups are a virtual firewall for instances, allowing rules to be applied to traffic between instances. Dynamic resource allocation is a concept that allows resources to be applied as they are needed, including scaling up and down infrastructure and systems on the fly. Virtual private cloud (VPC) endpoints are a way to connect to services inside of a cloud provider without an Internet gateway. Finally, instance awareness is a concept that means that tools know about the differences between instances, rather than treating each instance in a scaling group as the same. This can be important during incident response processes and security monitoring for scaled groups, where resources may all appear identical without instance awareness.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      256,
      255,
      181,
      246,
      240
    ],
    "source": "9781394211395"
  },
  {
    "id": 1157,
    "question": "Henry is an employee at Acme Company. The company requires him to change his password every three months. He has trouble remembering new passwords, so he keeps switching between just two passwords. Which policy would be most effective in preventing this?",
    "choice_a": "Password complexity",
    "choice_b": "Password history",
    "choice_c": "Password length",
    "choice_d": "Multifactor authentication",
    "correct_answer": "B",
    "explanation": "If the system maintains a password history, that will prevent any user from reusing an old password. Password complexity and length are common security settings but would not prevent the behavior described. Multifactor authentication helps prevent brute\u2010force attacks and reduces the potential impact of stolen passwords but would not help with this scenario.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      194,
      137,
      144,
      145,
      140
    ],
    "source": "9781394211395"
  },
  {
    "id": 1158,
    "question": "Tracy wants to limit when users can log in to a stand\u2010alone Windows workstation. What should Tracy do to meet this requirement?",
    "choice_a": "Set login time restrictions.",
    "choice_b": "Turn the system off automatically during hours it should not be used.",
    "choice_c": "Hire security guards to monitor the space.",
    "choice_d": "Disable remote login during the hours the system should not be used.",
    "correct_answer": "A",
    "explanation": "Setting login time restrictions is a common method to control when a system can be used. Turning off a system does not prevent it from being turned back on. Guards are expensive compared to a simple technical control limiting logins, and disabling remote login does not prevent local login.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      148,
      194,
      192,
      143,
      133
    ],
    "source": "9781394211395"
  },
  {
    "id": 1159,
    "question": "Lucas is looking for an XML\u2010based open standard for exchanging authentication information. Which of the following would best meet his needs?",
    "choice_a": "SAML",
    "choice_b": "OAuth",
    "choice_c": "RADIUS",
    "choice_d": "NTLM",
    "correct_answer": "A",
    "explanation": "Security Assertion Markup Language (SAML) is an XML\u2010based, open standard format for exchanging authentication and authorization data between parties. OAuth allows an end user's account information to be used by third\u2010party services, without exposing the user's password. RADIUS is a remote access protocol. New Technology LAN Manager (NTLM) is not XML\u2010based.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      135,
      134,
      132,
      233,
      133
    ],
    "source": "9781394211395"
  },
  {
    "id": 1160,
    "question": "Murali is preparing to acquire data from various devices and systems that are targets in a forensic investigation. Which of the following devices is the least volatile according to the order of volatility?",
    "choice_a": "Backups",
    "choice_b": "CPU cache",
    "choice_c": "Local disk",
    "choice_d": "RAM",
    "correct_answer": "A",
    "explanation": "Backups are considered to be the least volatile type of storage since they change at a much slower pace and, in fact, may be intentionally retained for long periods of time without changing. In this list, CPU cache will change the most frequently, then RAM, then local disk contents.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      262,
      263,
      268,
      269,
      260
    ],
    "source": "9781394211395"
  },
  {
    "id": 1161,
    "question": "What phase of the incident response process should be placed at point A in the following image? <img src=\"/question_assets/Security+/c04uf002.png\" alt=\"A cycle diagram lists the steps involved in the incident response process. A, preparation, detection, analysis, containment, and eradication.\"/>\n\n<figcaption>A cycle diagram lists the steps involved in the incident response process. A, preparation, detection, analysis, containment, and eradication.</figcaption>",
    "choice_a": "Simulations",
    "choice_b": "Review",
    "choice_c": "Recovery",
    "choice_d": "Patching",
    "correct_answer": "C",
    "explanation": "After eradication of the issue has been completed, recovery can begin. Recovery can include restoration of services and a return to normal operations.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      240,
      243,
      241,
      257,
      254
    ],
    "source": "9781394211395"
  },
  {
    "id": 1162,
    "question": "Brent wants to use a tool to help him analyze malware and attacks and wants to cover a broad range of tactics and tools that are used by adversaries. Which of the following is broadly implemented in technical tools and covers techniques and tactics without requiring a specific order of operations?",
    "choice_a": "The CIS Benchmark",
    "choice_b": "The Dark Web Analysis Project",
    "choice_c": "The MITRE ATT&CK framework",
    "choice_d": "The CVSS standard",
    "correct_answer": "C",
    "explanation": "The MITRE ATT&amp;CK framework focuses on techniques and tactics. CIS Benchmarks are security configuration baselines, the Dark Web Analysis Project was made up for this question, and the CVSS standard is a vulnerability scoring system and is not a useful framework for analyzing malware and attacks.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      22,
      62,
      49,
      247,
      254
    ],
    "source": "9781394211395"
  },
  {
    "id": 1163,
    "question": "Ted needs to preserve a server for forensic purposes. Which of the following should he not do?",
    "choice_a": "Turn the system off to ensure that data does not change.",
    "choice_b": "Remove the drive while the system is running to ensure that data does not change.",
    "choice_c": "Leave the machine connected to the network so that users can continue to use it.",
    "choice_d": "All of the above.",
    "correct_answer": "D",
    "explanation": "To properly preserve the system, Ted needs to ensure that it does not change. Turning off the system will cause anything in memory to be lost, which may be needed for the investigation. Removing the drive while a system is running can cause data to be lost. Instead, live\u2010imaging the machine and its memory may be required. Allowing users to continue to use a machine will result in changes, which can also damage Ted's ability to perform a forensic investigation.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      262,
      264,
      263,
      256,
      269
    ],
    "source": "9781394211395"
  },
  {
    "id": 1164,
    "question": "Jessica wants to review the network traffic that her Windows system has sent to determine if a file containing sensitive data was uploaded from the system. What Windows log file can she use to find this information?",
    "choice_a": "The application log",
    "choice_b": "The network log",
    "choice_c": "The security log",
    "choice_d": "None of the above",
    "correct_answer": "D",
    "explanation": "Windows does not log network traffic at a level of granularity that will show if a file has been uploaded. Basic traffic statistics can be captured, but without additional sensors and information\u2010gathering capabilities, Jessica will not be able to determine if files are sent from a Windows system.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      250,
      251,
      267,
      246,
      252
    ],
    "source": "9781394211395"
  },
  {
    "id": 1165,
    "question": "What term is used to describe the documentation trail for control, analysis, transfer, and final disposition of evidence for digital forensic work?",
    "choice_a": "Evidence log",
    "choice_b": "Paper trail",
    "choice_c": "Chain of custody",
    "choice_d": "Digital footprint",
    "correct_answer": "C",
    "explanation": "The chain of custody in forensic activities tracks who has a device, data, or other forensic artifact at any time, when transfers occur, who performed analysis, and where the item, system, or device goes when the forensic process is done. Evidence logs may be maintained by law enforcement to track evidence that is gathered. Paper trail and digital footprint are not technical terms used for digital forensics.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      263,
      259,
      265,
      261,
      269
    ],
    "source": "9781394211395"
  },
  {
    "id": 1166,
    "question": "Nathan needs to know how many times an event occurred and wants to check a log file for that event. Which of the following <code>grep</code> commands will tell him how many times the event happened if each occurrence is logged independently in the <code>logfile.txt</code> log file, and uses a unique event ID, <code>event101</code>?",
    "choice_a": "grep logfile.txt \u2010n 'event101'",
    "choice_b": "grep \u2010c 'event101' logfile.txt",
    "choice_c": "grep logfile.txt \u2010c 'event101'",
    "choice_d": "grep \u2010c event101 \u2010i logfile.txt",
    "correct_answer": "B",
    "explanation": "The <code>\u2010c</code> flag for <code>grep</code> counts the number of occurrences for a given string in a file. The <code>\u2010n</code> flag shows the matched lines and line numbers. Even if you're not sure about which flag is which, the syntax should help on a question like this. When using <code>grep</code>, the pattern comes before the filename, allowing you to rule out two of the options right away.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      250,
      246,
      249,
      253
    ],
    "source": "9781394211395"
  },
  {
    "id": 1167,
    "question": "Eric wants to determine how much bandwidth was used during a compromise and where the traffic was directed to. What technology can he implement before the event to help him see this detail and allow him to have an effective bandwidth monitoring solution?",
    "choice_a": "A firewall",
    "choice_b": "NetFlow",
    "choice_c": "Packetflow",
    "choice_d": "A DLP",
    "correct_answer": "B",
    "explanation": "Network flows using NetFlow or sFlow would provide the information that Eric wants, with details of how much traffic was used, when, and where traffic was directed. A firewall or data loss prevention (DLP) would not show the bandwidth detail, although a firewall may show the connection information for events. Packetflow was made up for this question and is not a technology used for this purpose.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      251,
      267,
      246,
      252,
      250
    ],
    "source": "9781394211395"
  },
  {
    "id": 1168,
    "question": "Naomi has acquired an image of a drive as part of a forensic process. She wants to ensure that the drive image matches the original. What should she create and record to validate this?",
    "choice_a": "A third image to compare to the original and new image",
    "choice_b": "A directory listing to show that the directories match",
    "choice_c": "A photographic image of the two drives to show that they match",
    "choice_d": "A hash of the drives to show that their hashes match",
    "correct_answer": "D",
    "explanation": "Hashing using MD5 or SHA1 is commonly used to validate that a forensic image matches the original drive. Many forensic duplicators automatically generate a hash of both drives when they complete the imaging process to ensure that there is a documentation chain for the forensic artifacts. A third image may be useful but does not validate this. Directory listings do not prove that drives match, and photos, though useful to document the drives and serial numbers, do not validate the contents of the drives.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      265,
      264,
      263,
      259,
      269
    ],
    "source": "9781394211395"
  },
  {
    "id": 1169,
    "question": "Ryan has been asked to run Nessus on his network. What type of tool has he been asked to run?",
    "choice_a": "A fuzzer",
    "choice_b": "A vulnerability scanner",
    "choice_c": "A WAF",
    "choice_d": "A protocol analyzer",
    "correct_answer": "B",
    "explanation": "Nessus is a popular vulnerability scanning tool. It is not a fuzzer, web application firewall (WAF), or protocol analyzer.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      49,
      40,
      42,
      47,
      48
    ],
    "source": "9781394211395"
  },
  {
    "id": 1170,
    "question": "Michelle wants to check for authentication failures on a RedHat Linux\u2013based system. Where should she look for these event logs?",
    "choice_a": "/var/log/auth.log",
    "choice_b": "/var/log/fail",
    "choice_c": "/var/log/events",
    "choice_d": "/var/log/secure",
    "correct_answer": "D",
    "explanation": "Red Hat stores authentication log information in <code>/var/log/secure</code> instead of <code>/var/log/auth.log</code> used by Debian and Ubuntu systems. Knowing the differences between the major distributions can help speed up your forensic and incident investigations, and consistency is one of the reasons that organizations often select a single Linux distribution for their infrastructure whenever it is possible to do so.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      250,
      253,
      246,
      149,
      252
    ],
    "source": "9781394211395"
  },
  {
    "id": 1171,
    "question": "Nelson has discovered malware on one of the systems he is responsible for and wants to test it in a safe environment. Which of the following tools is best suited to that testing?",
    "choice_a": "strings",
    "choice_b": "scanless",
    "choice_c": "Cuckoo",
    "choice_d": "Sn1per",
    "correct_answer": "C",
    "explanation": "<code>Cuckoo</code>, or Cuckoo Sandbox, is a malware analysis sandbox that will safely run malware and then analyze and report on its behavior. <code>strings</code> is a command\u2010line tool that retrieves strings from binary data. <code>scanless</code> is a tool described as a port scraper, which retrieves port information without running a port scan by using websites and services to run the scan for you. <code>Sn1per</code> is a pen test framework.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      186,
      62,
      60,
      270,
      269
    ],
    "source": "9781394211395"
  },
  {
    "id": 1172,
    "question": "Lucca wants to review metadata related to a JPEG file. What will he need to do to review it?",
    "choice_a": "Change the JPEG to a GIF to see the metadata.",
    "choice_b": "Download the metadata file from the original author.",
    "choice_c": "Use a metadata viewer.",
    "choice_d": "Analyze the hash of the file.",
    "correct_answer": "C",
    "explanation": "Metadata viewing tools will allow Lucca to view the metadata that is embedded in the file itself. Metadata is not downloaded separately or available via the hash for a JPEG file.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      252,
      264,
      265,
      269,
      268
    ],
    "source": "9781394211395"
  },
  {
    "id": 1173,
    "question": "Jason is conducting a forensic investigation and has retrieved artifacts in addition to drives and files. What should he do to document the artifacts he has acquired?",
    "choice_a": "Image them using dd and ensure that a valid MD5sum is generated.",
    "choice_b": "Take a picture of them, label them, and add them to the chain\u2010of\u2010custody documentation.",
    "choice_c": "Contact law enforcement to properly handle the artifacts.",
    "choice_d": "Engage legal counsel to advise him how to handle artifacts in an investigation.",
    "correct_answer": "B",
    "explanation": "When artifacts are acquired as part of an investigation, they should be logged and documented as part of the evidence related to the investigation. Artifacts could include a piece of paper with passwords on it, tools or technology related to an exploit or attack, smartcards, or any other element of an investigation.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      259,
      263,
      270,
      261,
      269
    ],
    "source": "9781394211395"
  },
  {
    "id": 1174,
    "question": "Joseph is writing a forensic report and wants to be sure he includes appropriate detail. Which of the following would not typically be included while discussing analysis of a system?",
    "choice_a": "Validation of the system clock's time settings",
    "choice_b": "The operating system in use",
    "choice_c": "The methods used to create the image",
    "choice_d": "A picture of the person from whom the system was taken",
    "correct_answer": "D",
    "explanation": "Forensic reports should include appropriate technical detail. Analysis of a system does not include a picture of the person from whom the system was acquired.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      270,
      259,
      269,
      252,
      264
    ],
    "source": "9781394211395"
  },
  {
    "id": 1175,
    "question": "Elaine wants to determine what websites a user has recently visited using the contents of a forensically acquired hard drive. Which of the following locations would not be useful for her investigation?",
    "choice_a": "The browser cache",
    "choice_b": "The browser history",
    "choice_c": "The browser's bookmarks",
    "choice_d": "Session data",
    "correct_answer": "C",
    "explanation": "The browser cache, history, and session information will all contain information from recently visited sites. Bookmarks may indicate sites that a user has visited at some point, but a bookmark can be added without visiting a site at all.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      262,
      268,
      252,
      270,
      250
    ],
    "source": "9781394211395"
  },
  {
    "id": 1176,
    "question": "Susan has discovered evidence of a compromise that occurred approximately five months ago. She wants to conduct an incident investigation but is concerned about whether the data will exist. What policy guides how long logs and other data are kept in most organizations?",
    "choice_a": "The organization's data classification policy",
    "choice_b": "The organization's backup policy",
    "choice_c": "The organization's retention policy",
    "choice_d": "The organization's legal hold policy",
    "correct_answer": "C",
    "explanation": "Organizations define retention policies for different data types and systems. Many organizations use 30\u2010, 45\u2010, 90\u2010, 180\u2010, or 365\u2010day retention policies, with some information required to be kept longer due to law or compliance reasons. Susan's organization may keep logs for as little as 30 days depending on storage limitations and business needs. Data classification policies typically impact how data is secured and handled. Backup policies determine how long backups are retained and rotated and may have an impact on data if the logs are backed up, but backing up logs are a less common practice due to the space they take up versus the value of having logs backed up. Legal hold practices are common, but policies are less typically defined for legal holds since requirements are set by law.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      208,
      259,
      263,
      262,
      241
    ],
    "source": "9781394211395"
  },
  {
    "id": 1177,
    "question": "Alaina sets her antimalware solution to move infected files to a safe storage location without removing them from the system. What type of setting has she enabled?",
    "choice_a": "Purge",
    "choice_b": "Deep\u2010freeze",
    "choice_c": "Quarantine",
    "choice_d": "Retention",
    "correct_answer": "C",
    "explanation": "A quarantine process or setting will preserve malicious or dangerous files and programs without allowing them to run. This allows defenders to retrieve them for further analysis as well as to return them to use if they are determined not to be malicious, or if the malicious components can be removed from needed files. Purging, deep\u2010freezing, and retention are not terms used to describe this behavior or setting.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      186,
      240,
      246,
      248,
      250
    ],
    "source": "9781394211395"
  },
  {
    "id": 1178,
    "question": "A senior vice president in the organization that Chuck works in recently lost a phone that contained sensitive business plans and information about suppliers, designs, and other important materials. After interviewing the vice president, Chuck finds out that the phone did not have a passcode set and was not encrypted, and that it could not be remotely wiped. What type of control should Chuck recommend for his company to help prevent future issues like this?",
    "choice_a": "Use containment techniques on the impacted phones.",
    "choice_b": "Deploy a DLP system.",
    "choice_c": "Deploy an MDM system.",
    "choice_d": "Isolate the impacted phones.",
    "correct_answer": "C",
    "explanation": "Chuck should recommend a mobile device management (MDM) system to ensure that organizational devices can be managed and protected in the future. Data loss prevention (DLP) will not stop a lost phone from being a potential leak of data, isolating the phones is not a realistic scenario for devices that will actually be used, nor is containment because the phone is out of the organization's control once lost.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      237,
      236,
      238,
      188,
      240
    ],
    "source": "9781394211395"
  },
  {
    "id": 1179,
    "question": "Charles wants to ensure that the forensic work that he is doing cannot be repudiated. How can he validate his attestations and documentation to ensure nonrepudiation?",
    "choice_a": "Encrypt all forensic output.",
    "choice_b": "Digitally sign the records.",
    "choice_c": "Create a MD5 checksum of all images.",
    "choice_d": "All of the above.",
    "correct_answer": "B",
    "explanation": "The most important action Charles can take while working with his forensic artifacts to provide nonrepudiation is to digitally sign the artifacts and information that he is creating in his evidence records. Encrypting the output will ensure its confidentiality but will not provide nonrepudiation by itself. MD5 checksums for images are commonly gathered but must then be signed so that they can be validated to ensure they have not been modified.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      263,
      265,
      264,
      270,
      269
    ],
    "source": "9781394211395"
  },
  {
    "id": 1180,
    "question": "Megan needs to conduct a forensic investigation of a virtual machine (VM) hosted in a VMware environment as part of an incident response effort. What is the best way for her to collect the VM?",
    "choice_a": "As a snapshot using the VMware built\u2010in tools",
    "choice_b": "By using dd to copy the VM to an external drive",
    "choice_c": "By using dd to copy the VM to an internal drive",
    "choice_d": "By using a forensic imaging device after removing the server's drives",
    "correct_answer": "A",
    "explanation": "The best way to capture a virtual machine from a running hypervisor is usually to use the built\u2010in tools to obtain a snapshot of the system. Imaging tools are not typically capable of capturing machine state, and <code>dd</code> is not designed to capture VMs. Removing a server's drives can be challenging due to possible RAID and other specific server configuration items, and doing so might impact all other running VMs and services on the system.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      262,
      264,
      263,
      269,
      240
    ],
    "source": "9781394211395"
  },
  {
    "id": 1181,
    "question": "Which of the following groups is not typically part of an incident response team?",
    "choice_a": "Law enforcement",
    "choice_b": "Security analysts",
    "choice_c": "Management",
    "choice_d": "Communications staff",
    "correct_answer": "A",
    "explanation": "Law enforcement is not typically part of organizational incident response teams, but incident response teams often maintain a relationship with local law enforcement officers. Security analysts, management, and communication staff as well as technical experts are all commonly part of a core incident response team.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      241,
      243,
      246,
      257,
      249
    ],
    "source": "9781394211395"
  },
  {
    "id": 1182,
    "question": "Bob needs to block Secure Shell (SSH) traffic between two security zones. Which of the following Linux <code>iptables</code> firewall rules will block that traffic from the 10.0.10.0/24 network to the system the rule is running on?",
    "choice_a": "iptables \u2010A INPUT \u2010p tcp \u2010\u2010dport 22 \u2010i eth0 \u2010s 10.0.10.0/24 \u2010j DROP",
    "choice_b": "iptables \u2010D OUTPUT \u2010p udp \u2010dport 21 \u2010i eth0 \u2010s 10.0.10.255 \u2010j DROP",
    "choice_c": "iptables \u2010A OUTPUT \u2010p udp \u2010\u2010dport 22 \u2010i eth0 \u2010s 10.0.10.255 \u2010j BLOCK",
    "choice_d": "iptables \u2010D INPUT \u2010p udp \u2010\u2010dport 21 \u2010I eth0 \u2010s 10.0.10.0/24 \u2010j DROP",
    "correct_answer": "A",
    "explanation": "Even if you're not familiar with <code>iptables</code>, you can read through these rules and guess which rule includes the right details. <code>DROP</code> makes sense for a block, and you should know that SSH will be a TCP service on port 22.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      255,
      192,
      53,
      215,
      250
    ],
    "source": "9781394211395"
  },
  {
    "id": 1183,
    "question": "A Windows system that Maria is responsible for has been experiencing service outages. The outages correspond to processes run on another system in the datacenter, and Maria believes that unexpected traffic may be sent to the Windows system. Which of the following data sources should Maria use to best understand what is happening?",
    "choice_a": "Perform a packet capture.",
    "choice_b": "Enable a network firewall.",
    "choice_c": "Use SIEM logs.",
    "choice_d": "Perform a forensic drive copy.",
    "correct_answer": "A",
    "explanation": "A packet capture will show attempts to connect to the service and will help Maria determine if there is unexpected traffic to the system. A network firewall could stop the traffic, but analyzing the actual traffic itself is best done with a packet capture. Logs may be useful as part of the analysis, but again, packet captures will provide more information. A forensic disk image is not useful for reviewing network traffic.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      267,
      251,
      246,
      250,
      240
    ],
    "source": "9781394211395"
  },
  {
    "id": 1184,
    "question": "Amanda's organization does not currently have an incident response plan. Which of the following reasons is not one she should present to management in support of creating one?",
    "choice_a": "It will prevent incidents from occurring.",
    "choice_b": "It will help responders react appropriately under stress.",
    "choice_c": "It will prepare the organization for incidents.",
    "choice_d": "It may be required for legal or compliance reasons.",
    "correct_answer": "A",
    "explanation": "Incident response plans don't stop incidents from occurring, but they do help responders react appropriately and prepare the organization for incidents, and may be required for legal or compliance reasons.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      243,
      240,
      241,
      242,
      258
    ],
    "source": "9781394211395"
  },
  {
    "id": 1185,
    "question": "Which of the following scenarios is least likely to result in data recovery being possible?",
    "choice_a": "A file is deleted from a disk.",
    "choice_b": "A file is overwritten by a smaller file.",
    "choice_c": "A hard drive is quick\u2010formatted.",
    "choice_d": "A disk is degaussed.",
    "correct_answer": "D",
    "explanation": "Degaussing a drive uses strong magnetic fields to wipe it and is the least likely to result in recoverable data. Deleted files can often be recovered because only the file index information will be removed until that space is needed and is overwritten. Quick formats work in a similar way and will leave remnant data, and files that are overwritten by smaller files will also leave fragments of data that can be recovered and analyzed.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      268,
      207,
      263,
      252,
      240
    ],
    "source": "9781394211395"
  },
  {
    "id": 1186,
    "question": "Henry records a video of the removal of a drive from a system as he is preparing for a forensic investigation. What is the most likely reason for Henry to record the video?",
    "choice_a": "To meet the order of volatility",
    "choice_b": "To establish guilt beyond a reasonable doubt",
    "choice_c": "To ensure data preservation",
    "choice_d": "To document the chain of custody and provenance of the drive",
    "correct_answer": "D",
    "explanation": "Henry's most likely use for the video is to document the forensic process, part of the chain of custody and provenance of the forensic data he acquires. The order of volatility helps determine what devices or drives he would image first. There is no crime being committed, so establishing guilt is not relevant to this scenario, and the video will not ensure data is preserved on a drive during a forensic process.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      263,
      259,
      265,
      270,
      256
    ],
    "source": "9781394211395"
  },
  {
    "id": 1187,
    "question": "Charlene wants to set up a tool that can allow her to see all the systems a given IP address connects to and how much data is sent to that IP by port and protocol. Which of the following tools is not suited to meet that need?",
    "choice_a": "IPFIX",
    "choice_b": "IPSec",
    "choice_c": "sFlow",
    "choice_d": "NetFlow",
    "correct_answer": "B",
    "explanation": "IPSec is not a tool used to capture network flows. sFlow, NetFlow, and IPFIX are all used to capture network flow information, which will provide the information Charlene needs.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      251,
      267,
      250,
      247,
      248
    ],
    "source": "9781394211395"
  },
  {
    "id": 1188,
    "question": "Tools like PRTG and Cacti that monitor SNMP information are used to provide what type of information for an incident investigation?",
    "choice_a": "Authentication logs",
    "choice_b": "Bandwidth monitoring",
    "choice_c": "System log information",
    "choice_d": "Email metadata",
    "correct_answer": "B",
    "explanation": "PRTG and Cacti are both network monitoring tools that can provide bandwidth monitoring information. Bandwidth monitors can help identify exfiltration, heavy and abnormal bandwidth usage, and other information that can be helpful for both incident identification and incident investigations. If you encounter a question like this on the exam, even if you're not familiar with either tool, you can use your knowledge of what Simple Network Management Protocol (SNMP) is used for to identify which of the categories is most likely correct.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      251,
      250,
      246,
      252,
      267
    ],
    "source": "9781394211395"
  },
  {
    "id": 1189,
    "question": "The company Charles works for has recently had a stolen company cell phone result in a data breach. Charles wants to prevent future incidents of a similar nature. Which of the following mitigation techniques would be the most effective?",
    "choice_a": "Enable FDE via MDM.",
    "choice_b": "A firewall change.",
    "choice_c": "A DLP rule.",
    "choice_d": "A new URL filter rule.",
    "correct_answer": "A",
    "explanation": "A variety of configuration changes could be pushed to mobile devices to help: setting passcodes, enabling full\u2010disk encryption (FDE) on mobile devices via organizationally deployed mobile device management (MDM), or even preventing some sensitive files from being downloaded or kept on those devices could all help. Firewall rules, data loss prevention (DLP) rules, and URL filters will not prevent a stolen device from being accessed and the data being exposed.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      236,
      237,
      255,
      239,
      238
    ],
    "source": "9781394211395"
  },
  {
    "id": 1190,
    "question": "What incident response step is missing from point X in the following image? <img src=\"/question_assets/Security+/c04uf003.png\" alt=\"A cycle diagram lists the steps involved in the incident response process. Preparation, detection, analysis, X, eradication, recovery, and lessons learned.\"/>\n\n<figcaption>A cycle diagram lists the steps involved in the incident response process. Preparation, detection, analysis, X, eradication, recovery, and lessons learned.</figcaption>",
    "choice_a": "Business continuity",
    "choice_b": "Containment",
    "choice_c": "Response",
    "choice_d": "Discovery",
    "correct_answer": "B",
    "explanation": "The Security+ exam outline talks about seven incident response process steps: Preparation, Detection, Analysis, Containment, Eradication, Recovery, and Lessons Learned.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      240,
      243,
      254,
      256,
      257
    ],
    "source": "9781394211395"
  },
  {
    "id": 1191,
    "question": "Jill has been asked to perform data recovery due to her forensic skills. What should she tell the person asking to perform data recovery to give her the best chance of restoring lost files that were accidentally deleted?",
    "choice_a": "Immediately reboot using the reset switch to create a lost file memory dump.",
    "choice_b": "Turn off Secure Delete so that the files can be more easily recovered.",
    "choice_c": "Do not save any files or make any changes to the system.",
    "choice_d": "All of the above.",
    "correct_answer": "C",
    "explanation": "Jill wants the least possible changes to occur on the system, so she should instruct the user to not save any files or make any changes. Rebooting the system will not create a memory dump, and may cause new files to be written or changed if patches were waiting to install or other changes are set to occur during a reboot. Turning off Secure Delete or making other changes will not impact the files that were deleted prior to that setting change.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      268,
      262,
      260,
      250,
      255
    ],
    "source": "9781394211395"
  },
  {
    "id": 1192,
    "question": "Veronica has completed the recovery phase of her organization's incident response plan. What phase should she move into next?",
    "choice_a": "Preparation",
    "choice_b": "Lessons learned",
    "choice_c": "Recovery",
    "choice_d": "Documentation",
    "correct_answer": "B",
    "explanation": "The IR process used for the Security+ exam outline is Preparation, Detection, Analysis, Containment, Eradication, Recovery, and Lessons Learned. Veronica should move into the lessons learned phase.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      240,
      243,
      258,
      270,
      261
    ],
    "source": "9781394211395"
  },
  {
    "id": 1193,
    "question": "Michelle has been asked to sanitize a number of drives to ensure that sensitive data is not exposed when systems are removed from service. Which of the following is not a valid means of sanitizing hard drives?",
    "choice_a": "Physical destruction",
    "choice_b": "Degaussing",
    "choice_c": "Quick\u2010formatting the drives",
    "choice_d": "Zero\u2010wiping the drives",
    "correct_answer": "C",
    "explanation": "Quick formatting merely deletes file indexes rather than removing and overwriting files, making it inappropriate for sanitization. Physical destruction will ensure that the data is not readable, as will degaussing and zero wiping.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      207,
      208,
      268,
      264,
      209
    ],
    "source": "9781394211395"
  },
  {
    "id": 1194,
    "question": "Bart is investigating an incident, and needs to identify the creator of a Microsoft Office document. Where would he find that type of information?",
    "choice_a": "In the filename",
    "choice_b": "In the Microsoft Office log files",
    "choice_c": "In the Windows application log",
    "choice_d": "In the file metadata",
    "correct_answer": "D",
    "explanation": "Microsoft Office places information like the name of the creator of the file, editors, creation and change dates, and other useful information in the file metadata that is stored in each Office document. Bart can simply open the Office document to review this information, or he can use a forensic or file metadata tool to review it. Filenames may contain the creator's name, but this would only be if the creator included it. Microsoft Office does not create or maintain a log, and the application log for Windows does not contain this information.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      252,
      270,
      269,
      263,
      261
    ],
    "source": "9781394211395"
  },
  {
    "id": 1195,
    "question": "Nathaniel wants to allow Chrome through the Windows Defender firewall. What type of firewall rule change will he need to permit this?",
    "choice_a": "Allow TCP 80 and 443 traffic from the system to the Internet.",
    "choice_b": "Add Chrome to the Windows Defender Firewall allowed applications.",
    "choice_c": "Allow TCP 80 and 443 traffic from the Internet to the system.",
    "choice_d": "All of the above.",
    "correct_answer": "B",
    "explanation": "Windows Defender Firewall operates on a per\u2010application model and can filter traffic based on whether the system is on a trusted private network or a public network. Nathaniel should allow Chrome by name in the firewall, which will allow it to send traffic without needing to specify ports or protocols.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      189,
      255,
      194,
      192,
      254
    ],
    "source": "9781394211395"
  },
  {
    "id": 1196,
    "question": "What key forensic tool used to generate reports about what happened relies on correctly set system clocks to work properly?",
    "choice_a": "Disk hashing",
    "choice_b": "Timelining",
    "choice_c": "Forensic disk acquisition",
    "choice_d": "File metadata analysis",
    "correct_answer": "B",
    "explanation": "Building a timeline, particularly from multiple systems, relies on accurately set system clocks or adding a manually configured offset. Disk hashing and acquisition does not need an accurate system clock, and file metadata can be reviewed even without an accurate clock, although accurate clock information or knowing the offset can be useful for analysis.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      262,
      259,
      270,
      265,
      252
    ],
    "source": "9781394211395"
  },
  {
    "id": 1197,
    "question": "Valerie is writing her organization's forensic playbooks and knows that the state that she operates in has a data breach notification law. Which of the following key items is most likely to be influenced by that law?",
    "choice_a": "Whether Valerie calls the police for forensic investigation help",
    "choice_b": "The maximum amount of time until she has to notify customers of sensitive data breaches",
    "choice_c": "The certification types and levels that her staff have to maintain",
    "choice_d": "The maximum number of residents that she can notify about a breach",
    "correct_answer": "B",
    "explanation": "Data breach notification laws often build in a maximum length of time that can pass before notification is required. They also often include a threshold for notification, with a maximum number of exposed individuals before the state or other authorities must be notified. They do not include a maximum number of individuals who can be notified, nor do they typically have specific requirements about police involvement in forensic investigations or certification types or levels.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      266,
      240,
      259,
      270,
      261
    ],
    "source": "9781394211395"
  },
  {
    "id": 1198,
    "question": "As part of a breach response, Naomi discovers that Social Security numbers (SSNs) were sent in a spreadsheet via email by an attacker who gained control of a workstation at her company's headquarters. Naomi wants to ensure that more SSNs are not sent from her environment. What type of mitigation technique is most likely to prevent this while allowing operations to continue in as normal a manner as possible?",
    "choice_a": "Antimalware installed at the email gateway",
    "choice_b": "A firewall that blocks all outbound email",
    "choice_c": "A DLP rule blocking SSNs in email",
    "choice_d": "An IDS rule blocking SSNs in email",
    "correct_answer": "C",
    "explanation": "A data loss prevention (DLP) tool that can scan and review emails for SSN style data is the most effective tool listed here. Naomi may want to set the tool to block all emails with potential SSNs, and then review those emails manually to ensure that no further emails leave while allowing legitimate emails to pass through. An intrusion detection system (IDS) might look tempting as an answer, but an IDS can only detect, not stop, the traffic, which would allow the SSNs to exit the organization. Antimalware and firewalls will not stop this type of event.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      188,
      219,
      240,
      254,
      186
    ],
    "source": "9781394211395"
  },
  {
    "id": 1199,
    "question": "Troy wants to review metadata about an email he has received to determine what system or server the email was sent from. Where can he find this information?",
    "choice_a": "In the email message's footer",
    "choice_b": "In the to: field",
    "choice_c": "In the email message's headers",
    "choice_d": "In the from: field",
    "correct_answer": "C",
    "explanation": "Email headers contain a significant amount of metadata, including where the email was sent from. The from: field lists a sender but does not indicate where the email was actually sent from. The to: field lists who the email was sent to, and footers are not used to store this information for email.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      252,
      261,
      270,
      240,
      250
    ],
    "source": "9781394211395"
  },
  {
    "id": 1200,
    "question": "Isabelle wants to gather information about what systems a host is connecting to, how much traffic is sent, and similar details. Which of the following options would not allow her to perform that task?",
    "choice_a": "IPFIX",
    "choice_b": "NetFlow",
    "choice_c": "NXLog",
    "choice_d": "sFlow",
    "correct_answer": "C",
    "explanation": "NXLog is a log collection and centralization tool. IPFIX, NetFlow, and sFlow all gather data about network traffic, including source, destination, port, protocol, and amount of data sent to be collected.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      251,
      253,
      250,
      252,
      267
    ],
    "source": "9781394211395"
  },
  {
    "id": 1201,
    "question": "Valerie wants to check to see if a SQL injection attack occurred against her web application on a Linux system. Which log file should she check for this type of information?",
    "choice_a": "The security log",
    "choice_b": "The DNS log",
    "choice_c": "The auth log",
    "choice_d": "The web server log",
    "correct_answer": "D",
    "explanation": "SQL injection (SQLi) attempts are sent as HTTP or HTTPS requests to a web server, meaning that Valerie will be able to see the attacks in the web server log. Domain Name System (DNS) logs, if available, will not show these. Auth logs show logins, not web or SQL Server queries or requests. Unlike Windows, there is no security log file for Linux, although there is a secure log for some systems.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      250,
      253,
      246,
      267,
      262
    ],
    "source": "9781394211395"
  },
  {
    "id": 1202,
    "question": "Jean's company is preparing for litigation with another company that they believe has caused harm to Jean's organization. What type of legal action should Jean's lawyer take to ensure that the company preserves files and information related to the legal case?",
    "choice_a": "A chain\u2010of\u2010custody demand letter",
    "choice_b": "An e\u2010discovery notice",
    "choice_c": "A legal hold notice",
    "choice_d": "An order of volatility",
    "correct_answer": "C",
    "explanation": "A legal hold notice will inform the company that they must preserve and protect information related to the case. None of the other items are terms used in this process.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      260,
      263,
      270,
      208,
      246
    ],
    "source": "9781394211395"
  },
  {
    "id": 1203,
    "question": "What type of mitigation places a malicious file or application in a safe location for future review or study?",
    "choice_a": "Containment",
    "choice_b": "Quarantine",
    "choice_c": "Isolation",
    "choice_d": "Deletion",
    "correct_answer": "B",
    "explanation": "A quarantine setting will place a malicious or suspect file in a safe location and will keep it there until a set timeframe has passed or until an administrator takes action to deal with it. This can allow you to further analyze the file or to restore it if it was an incorrect identification or if the file is needed for another purpose. Containment is used to limit the extent of an incident or attack, isolation keeps a system or device from connecting to or accessing others, and deleting a file wouldn't keep it around.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      254,
      240,
      256,
      186,
      86
    ],
    "source": "9781394211395"
  },
  {
    "id": 1204,
    "question": "What phase of the incident response process often involves adding firewall rules and patching systems to address the incident?",
    "choice_a": "Preparation",
    "choice_b": "Detection",
    "choice_c": "Recovery",
    "choice_d": "Analysis",
    "correct_answer": "C",
    "explanation": "The recovery phase often involves adding firewall rules and patching systems in addition to rebuilding systems. Although preparation may involve configuring firewall rules or regular patching, it does not do so in response to an incident. Detection attempts to identify events and issues, and analysis involves investigating the events.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      240,
      255,
      257,
      243,
      242
    ],
    "source": "9781394211395"
  },
  {
    "id": 1205,
    "question": "Tim wants to check the status of malware infections in his organization using the organization's security information and event management (SIEM) device. What SIEM dashboard will tell him about whether there are more malware infections in the past few days than normal?",
    "choice_a": "The alerts dashboard",
    "choice_b": "The sensors dashboard",
    "choice_c": "The trends dashboard",
    "choice_d": "The bandwidth dashboard",
    "correct_answer": "C",
    "explanation": "Tim should look at the trend information for malware detections to check to see if there are more infections being detected than during recent weeks. This can be a useful indicator of a change, due to a new malware technique or package; a successful attack that has resulted in staff members clicking malicious links or opening malicious emails; or other paths into the organization. Tim could then check with users whose systems reported the malware to see what had occurred. Alerts might show the infections but would not show the data over time as easily as trends. Sensors will show individual places data is gathered, and bandwidth dashboards can show useful information about which systems are using more or less bandwidth, but the trends dashboard remains the right place for Tim to look in this situation.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      247,
      246,
      248,
      250,
      62
    ],
    "source": "9781394211395"
  },
  {
    "id": 1206,
    "question": "Michelle has been asked to use the CIS benchmark for Windows as part of her system security process. What information will she be using?",
    "choice_a": "Information on how secure Windows is in its default state",
    "choice_b": "A set of recommended security configurations to secure Windows",
    "choice_c": "Performance benchmark tools for Windows systems, including network speed and firewall throughput",
    "choice_d": "Vulnerability scan data for Windows systems provided by various manufacturers",
    "correct_answer": "B",
    "explanation": "The Center for Internet Security (CIS) benchmarks provide recommendations for how to secure an operating system, application, or other covered technology. Michelle will find Windows\u2010specific security configuration guidelines and techniques.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      194,
      196,
      192,
      236,
      51
    ],
    "source": "9781394211395"
  },
  {
    "id": 1207,
    "question": "All of your organization's traffic flows through a single connection to the Internet. Which of the following terms best describes this scenario?",
    "choice_a": "Cloud computing",
    "choice_b": "Load balancing",
    "choice_c": "Single point of failure",
    "choice_d": "Virtualization",
    "correct_answer": "C",
    "explanation": "A single point of failure (SPOF) is a single weakness that can bring down an entire system and prevent it from working. Cloud computing allows the delivery of hosted service over the Internet. Load balancing spreads traffic or other load between multiple systems or servers. Virtualization uses a system to host virtual machines that share the underlying resources such as RAM, hard drive, and CPU.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      41,
      192,
      214,
      240,
      258
    ],
    "source": "9781394211395"
  },
  {
    "id": 1208,
    "question": "Nina is tasked with putting radio frequency identification (RFID) tags on every new piece of equipment that enters her datacenter that costs more than $500. What type of organizational policy is most likely to include this type of requirement?",
    "choice_a": "A change management policy",
    "choice_b": "An incident response policy",
    "choice_c": "An asset management policy",
    "choice_d": "An acceptable use policy",
    "correct_answer": "C",
    "explanation": "Asset management policies typically include all stages of an asset's life cycle, and asset tags like those described are used to track assets in many organizations. Change management, incident response, and acceptable use policies do not require asset tagging.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      206,
      209,
      144,
      92,
      188
    ],
    "source": "9781394211395"
  },
  {
    "id": 1209,
    "question": "Megan is reviewing her organization's datacenter network diagram as shown in the following image. What should she note for point A on the diagram? <img src=\"/question_assets/Security+/c04uf004.png\" alt=\"An architectural diagram includes the following. Internet, internet service provider, firewalls, routers, core switches, and edge switches.\"/>\n\n<figcaption>An architectural diagram includes the following. Internet, internet service provider, firewalls, routers, core switches, and edge switches.</figcaption>",
    "choice_a": "A wireless link",
    "choice_b": "A redundant connection",
    "choice_c": "A wired link",
    "choice_d": "A single point of failure",
    "correct_answer": "D",
    "explanation": "The diagram shows a fully redundant internal network with pairs of firewalls, routers, and core switches, but with a single connection to the Internet. This means that Megan should consider how her organization would connect to the outside world if that link was severed or disrupted. There is no indication whether this is a wired or wireless link, and the image does not show a redundant link.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      246,
      44,
      133,
      240,
      258
    ],
    "source": "9781394211395"
  },
  {
    "id": 1210,
    "question": "Juan's team is in charge of responding to potential phishing attacks and advertises an <code>infosec@example.com</code> email address to his organization to send examples of potential phishing attacks to. Which of the following is not a benefit Juan's team would get from automating the creation of tickets in their support tool based on these emails?",
    "choice_a": "The ability to track whether they've been resolved",
    "choice_b": "Automated phishing prevention",
    "choice_c": "The ability to correlate multiple emails into a single event",
    "choice_d": "The ability to trigger additional actions",
    "correct_answer": "B",
    "explanation": "Support tools typically require additional steps or integrations to take action on a ticket and a human is often involved to ensure that legitimate emails do not result in the creation of unwanted rules or responses. Juan's team could use the ticketing system to track whether emails are dealt with, to correlate them, and potentially to trigger additional actions.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      92,
      91,
      93,
      248,
      240
    ],
    "source": "9781394211395"
  },
  {
    "id": 1211,
    "question": "Valerie wants to implement an email security framework that will help to ensure that only authorized systems send email on behalf of her domains. Which of the following should she implement?",
    "choice_a": "DKIM",
    "choice_b": "DMARC",
    "choice_c": "STP",
    "choice_d": "SPF",
    "correct_answer": "D",
    "explanation": "The Sender Policy Framework (SPF) lists IP addresses of systems allowed to send email in DNS TXT records for a domain. DKIM (DomainKeys Identified Mail) validates a domain's identity using a public key pair, validating the authenticity of the sender. DMARC (domain\u2010based message authentication, reporting, and conformance) controls how unauthenticated messages are handled by mailbox providers, including quarantining, rejecting, or rejecting messages. STP is not an email security framework.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      220,
      252,
      22,
      136,
      240
    ],
    "source": "9781394211395"
  },
  {
    "id": 1212,
    "question": "Jake is investigating a service outage and notices the following traffic using a Wireshark packet capture. Which of the following issues is most likely occurring? <img src=\"/question_assets/Security+/c04uf005.png\" alt=\"A screenshot of a window listing the following in seven columns. Number, time, source, destination, protocol, length, and info.\"/>\n\n<figcaption>A screenshot of a window listing the following in seven columns. Number, time, source, destination, protocol, length, and info.</figcaption>",
    "choice_a": "An email phishing campaign",
    "choice_b": "A SQL injection attack",
    "choice_c": "A dropped network connection",
    "choice_d": "A denial\u2010of\u2010service attack",
    "correct_answer": "D",
    "explanation": "The packet capture shows a high volume of SYN packets, indicating a potential SYN flood, a type of denial\u2010of\u2010service attack. There is no information to indicate SMTP traffic for a phishing campaign, nor is there HTTP traffic for SQL injection against an application. While SYN traffic is commonly seen when a connection is lost, this traffic is repeated at a rapid pace rather than a typical reconnection attempt.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      267,
      246,
      240,
      251,
      62
    ],
    "source": "9781394211395"
  },
  {
    "id": 1213,
    "question": "Gary wants to deploy a tool that will allow him to identify and effectively respond to ransomware that might target systems that his company owns. He knows that he is likely to need to identify threats based on behavior rather than just using signatures, and he wants to have a dashboard\u2010style view of his data. What tool should Gary select to meet this need?",
    "choice_a": "IPS",
    "choice_b": "NAC",
    "choice_c": "DLP",
    "choice_d": "EDR",
    "correct_answer": "D",
    "explanation": "Endpoint detection and response (EDR) tools combine behavior\u2010based detection capabilities with centralized dashboards and advanced response capabilities. Intrusion prevention systems (IPSs) can detect network threats but aren't well suited to detecting behaviors on endpoint systems. NAC (network access control) is used to limit who can connect to a network. Data loss prevention (DLP) systems monitor for data exfiltration as well as data that is sent both inadvertently and on purpose outside the organization that shouldn't be.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      187,
      186,
      219,
      189,
      248
    ],
    "source": "9781394211395"
  },
  {
    "id": 1214,
    "question": "Carl wants to test his organization's incident response process. He conducts a tabletop exercise for his security team. Which of the following best describes this type of exercise?",
    "choice_a": "A scenario is introduced and each member of the team takes actions that they would use to respond to the scenario.",
    "choice_b": "Third\u2010party penetration testers work with the security team to address issues they discovered during their penetration test.",
    "choice_c": "The security team meets to talk through what they would do in a given scenario and takes notes on what works and what doesn't.",
    "choice_d": "The organization's datacenter is manually forced to fail over to an alternate site to test the scenario's objectives.",
    "correct_answer": "C",
    "explanation": "Tabletop exercises involve teams sitting down to talk through an exercise. Teams don't perform actions or even simulate them, third\u2010party penetration testers are not reviewing their data, and no actual fail overs occur.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      242,
      240,
      243,
      241,
      249
    ],
    "source": "9781394211395"
  },
  {
    "id": 1215,
    "question": "Michelle wants to determine why attackers were able to take her organization's web server cluster offline after an incident occurred. What process should she and her team follow to determine this?",
    "choice_a": "Threat hunting",
    "choice_b": "Root cause analysis",
    "choice_c": "A lessons learned analysis",
    "choice_d": "Recovery",
    "correct_answer": "B",
    "explanation": "Root cause analysis is a process used to determine the underlying cause of an issue such as why attackers were able to successfully take down Michelle's web server cluster. Threat hunting is used to proactively look for threats using a variety of techniques, including OSINT and leveraging indicators of compromise. Lessons learned processes look for takeaways from events and incidents to allow organizations to improve their processes and procedures. Recovery is part of the incident response process but focuses on restoring the organization to normal operation.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      258,
      240,
      243,
      269,
      246
    ],
    "source": "9781394211395"
  },
  {
    "id": 1216,
    "question": "Randy wants to harden mobile devices used by his organization. Which of the following is not a typical mobile device hardening step?",
    "choice_a": "Disable Bluetooth.",
    "choice_b": "Use strong screen lock passwords.",
    "choice_c": "Install software updates.",
    "choice_d": "Jailbreak the device.",
    "correct_answer": "D",
    "explanation": "Jailbreaking is not a typical hardening process and is instead used to bypass device security to allow additional control of the device. While individuals may jailbreak devices, organizations rarely permit it. The NSA provides a guide to mobile device security practices at <code>https://media.defense.gov/2021/Sep/16/2002855921/-1/-1/0/MOBILE_DEVICE_BEST_PRACTICES_FINAL_V3%20-%20COPY.PDF</code>, which includes many practices such as disabling Bluetooth, using strong passwords, and keeping device software up\u2010to\u2010date.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      236,
      239,
      237,
      238,
      192
    ],
    "source": "9781394211395"
  },
  {
    "id": 1217,
    "question": "Lucca wants to ensure that his organization's mobile device connections are secure. Which of the following connectivity options is the most secure choice?",
    "choice_a": "WPA2 Personal",
    "choice_b": "WPA3 Personal",
    "choice_c": "WPA3 Enterprise",
    "choice_d": "WPA4 Enterprise",
    "correct_answer": "C",
    "explanation": "WPA3 Enterprise is the most secure option. It provides for central authentication as well as encryption. WPA4 has not yet been released. WPA2 and WPA3 Personal are not centrally managed, giving Lucca's organization less control over who connects.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      233,
      237,
      236,
      238,
      214
    ],
    "source": "9781394211395"
  },
  {
    "id": 1218,
    "question": "The percentage of the value of an asset that is lost due to an incident or loss event is known as what?",
    "choice_a": "Asset depreciation",
    "choice_b": "Exposure factor",
    "choice_c": "Annual loss event",
    "choice_d": "Asset valuation adjustment",
    "correct_answer": "B",
    "explanation": "The EF (exposure factor) for an asset is the value of the asset that would be lost in the event of a loss or damage scenario. Depreciation is a financial term that writes down the cost of a capital item over a given lifespan; annualized loss expectancy is a risk\u2010related term, not annual loss event; and asset valuation adjustment was made up for this question.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      206,
      40,
      207,
      258,
      188
    ],
    "source": "9781394211395"
  },
  {
    "id": 1219,
    "question": "Derek's organization has recently set up a notification process that sends a text message to system administrators when security exception log events occur on the systems they are responsible for. Unfortunately, Derek and his team have received dozens of alerts at all times of the day due to the log event happening for failed logins when users type their passwords incorrectly. What should Derek and his team do next to help with this?",
    "choice_a": "Set alert thresholds.",
    "choice_b": "Engage in alert tuning.",
    "choice_c": "Disable the alerts.",
    "choice_d": "Move the alerts to email.",
    "correct_answer": "B",
    "explanation": "Derek's team needs to carefully consider what alerts should be sent, why, and how often. That will require alert tuning. Simply setting alert thresholds may miss critical events, disabling alerts will not achieve the goal of enabling this type of notification, and moving the alerts to email will typically result in a less timely response.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      248,
      246,
      247,
      93,
      242
    ],
    "source": "9781394211395"
  },
  {
    "id": 1220,
    "question": "Jill wants to configure her IPS to detect a SQL injection attack that has become increasingly common against an open source web application that her organization runs. What information would she need to create a signature for the attack?",
    "choice_a": "The source IP address",
    "choice_b": "The SQL code",
    "choice_c": "The hash of the attack",
    "choice_d": "The source port",
    "correct_answer": "B",
    "explanation": "Jill can build a signature if she has an example of the SQL code. IPS signatures require data to match against potential attack traffic. A source IP address would only match specific potential attackers instead of the many different potential sources. A hash of the attack would detect one specific version of the attack, but a SQL injection (SQLi) attack may have multiple versions or configurations. The source port will vary with each request and isn't useful in most cases.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      219,
      22,
      63,
      250,
      48
    ],
    "source": "9781394211395"
  },
  {
    "id": 1221,
    "question": "Ben's organization has hired a new HR supervisor, Jack. When Jack was hired, Ben was asked to provide Jack with the same rights and permissions as the other HR supervisor, Erin. What is the most important issue Ben should identify with this process if the organization wants to follow identity and access management best practices?",
    "choice_a": "Jack's account should be provisioned based on his role, not on Erin's rights.",
    "choice_b": "Jack may not be senior enough to have access to the same systems as Erin does.",
    "choice_c": "Erin may work with a different staff than Jack does.",
    "choice_d": "Jack should not have access to Erin's files.",
    "correct_answer": "A",
    "explanation": "While all of these are potential problems, Jack's account should not be provisioned to match Erin. Instead, provisioning based on role is an IAM best practice. Jack's seniority, the staff he works with, and file access should all be determined by his role.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      144,
      148,
      145,
      143,
      136
    ],
    "source": "9781394211395"
  },
  {
    "id": 1222,
    "question": "Ian wants to deploy multifactor tokens to his organization. Which of the following provides the greatest security?",
    "choice_a": "Hardware tokens",
    "choice_b": "Application\u2010based tokens",
    "choice_c": "SMS multifactor",
    "choice_d": "Extended password length",
    "correct_answer": "A",
    "explanation": "Hardware tokens provide the greatest security because they need to be physically present to be used. Application\u2010based tokens are more secure than SMS in many cases because SMS can be redirected or accessed through SIM\u2010swapping and other attacks. Extending password length does not provide a second factor and is the least secure of these options by far.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      140,
      141,
      139,
      132,
      145
    ],
    "source": "9781394211395"
  },
  {
    "id": 1223,
    "question": "Gurvinder wants to explain the advantages of investing in automating security workflows to his organization's leadership. Recent audit findings have shown that systems are not all fully patched and that settings may vary between systems using the same operating system. Which common benefit of automation should he emphasize with leadership?",
    "choice_a": "Enforcing baselines",
    "choice_b": "Scaling in a secure manner",
    "choice_c": "Improving reaction time",
    "choice_d": "Automation's role as a workforce multiplier",
    "correct_answer": "A",
    "explanation": "The lack of consistency could be addressed by enforcing baselines across the organization. Gurvinder should emphasize this, then explain the other common benefits of security automation, including scaling in a secure manner, improving reaction time, automation's impact as a workforce multiplier, efficiency, employee retention advantages, and the ability to more easily standardize infrastructure configurations.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      93,
      91,
      92,
      194,
      178
    ],
    "source": "9781394211395"
  },
  {
    "id": 1224,
    "question": "Jake wants to understand the root cause of a security incident. He knows a number of the events that occurred, but he wants to engage other staff members to define the root cause. What common root cause analysis (RCA) technique should he use?",
    "choice_a": "The Five W's",
    "choice_b": "A fishbone diagram",
    "choice_c": "The Five Why's",
    "choice_d": "A recursion analysis",
    "correct_answer": "C",
    "explanation": "The Five Why's process is well suited to interviews because it asks \u201cWhy\u201d each time an answer is provided to get to a root cause. The Five W's are a common reference in journalism to who, what, when, where, and why\u2014not a root cause analysis tool. Fishbone diagrams are commonly used for RCA, but are not as useful for an interview process. They're more likely to be used after the interview to see how answers and events fit together. Recursion analysis is not an RCA process.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      258,
      240,
      241,
      242,
      269
    ],
    "source": "9781394211395"
  },
  {
    "id": 1225,
    "question": "Amanda is testing her company's incident response process and has her staff perform actual recovery actions without impacting production to validate how long it would take to accomplish them. What type of event has she conducted?",
    "choice_a": "A fail over test",
    "choice_b": "A simulation",
    "choice_c": "A plan review",
    "choice_d": "A tabletop exercise",
    "correct_answer": "B",
    "explanation": "Amanda has conducted a simulation, or walk\u2010through, where actual recovery actions are simulated to ensure that recovery plans will work as expected. A fail over test moves production to a backup environment like a hot site, and a plan review is just that\u2014a review of the response plan. A tabletop exercise involves discussions about the scenario and what would be done without taking any actual action.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      242,
      243,
      241,
      240,
      246
    ],
    "source": "9781394211395"
  },
  {
    "id": 1226,
    "question": "Liam's company has been notified of impending legal action and has been told to place a legal hold on related items. What must Liam's company do?",
    "choice_a": "Continue their normal operations, including data life\u2010cycle\u2013related activities.",
    "choice_b": "Identify data covered by the hold and preserve it, regardless of normal data life cycles or activities.",
    "choice_c": "Engage a law firm to preserve the data required by the legal hold.",
    "choice_d": "Contact law enforcement to allow them to gather the data required by the legal hold.",
    "correct_answer": "B",
    "explanation": "Legal holds require organizations and individuals to preserve data related to pending or active litigation, regardless of its normal data life cycle once the hold notice is received. This means that Liam needs to identify and preserve the data and that normal processes like wiping drives or reusing backup media may not be possible. It does not necessarily mean that Liam's company must engage a lawyer to preserve the data, and law enforcement is not typically involved in legal holds.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      260,
      208,
      261,
      263,
      264
    ],
    "source": "9781394211395"
  },
  {
    "id": 1227,
    "question": "Paul wants to integrate his organization's web application with common cloud identity providers like Google and Microsoft. What authentication standard should he select if he wants to maximize interoperability?",
    "choice_a": "OAuth",
    "choice_b": "Kerberos",
    "choice_c": "LDAP",
    "choice_d": "Active Directory",
    "correct_answer": "A",
    "explanation": "OAuth is an open standard widely supported by cloud identity providers. Kerberos is used for internal use rather than for external integrations; LDAP is used for some services but is no longer a common choice for this type of integration with cloud service providers compared to options like OAuth, SAML, and OpenID\u2010based integrations; and Active Directory is used by Microsoft but is not as interoperable.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      135,
      136,
      134,
      132,
      133
    ],
    "source": "9781394211395"
  },
  {
    "id": 1228,
    "question": "Jim wants to ensure that users who are located in his organization's London office have access to the building. What type of access control scheme should he select to best fit this specific need?",
    "choice_a": "Rule BAC",
    "choice_b": "ABAC",
    "choice_c": "Role BAC",
    "choice_d": "MAC",
    "correct_answer": "B",
    "explanation": "Attribute\u2010based access control (ABAC) provides access based on attributes like location, age, rank, or other attributes of a user. Rule\u2010based access control uses defined rules to make access decisions. Role\u2010based access control uses a user's role in an organization to make access control decisions, and mandatory access control (MAC) enforces access control using centralized control.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      132,
      144,
      148,
      145,
      181
    ],
    "source": "9781394211395"
  },
  {
    "id": 1229,
    "question": "Dane wants to implement passwordless authentication for his organization. What type of device should he issue to his users to support this type of authentication?",
    "choice_a": "A password manager",
    "choice_b": "An RFID card",
    "choice_c": "A security key",
    "choice_d": "A biometric token",
    "correct_answer": "C",
    "explanation": "Security keys are commonly used for passwordless authentication since they can provide both a physical token and cryptographic login credentials that are unlocked using a password, fingerprint reader, or camera. A password manager does not provide this but does securely store and manage passwords. RFID cards are simply something you have, and biometrics are typically not tokens\u2014they're data stored to match a user's biometric signature.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      139,
      140,
      132,
      138,
      141
    ],
    "source": "9781394211395"
  },
  {
    "id": 1230,
    "question": "Ensuring that inetd services like echo, time, rsh, and telnet are not enabled are all examples of what type of action?",
    "choice_a": "Preventing SQL injection",
    "choice_b": "Hardening a Linux system",
    "choice_c": "Hardening a Windows system",
    "choice_d": "Patching insecure services",
    "correct_answer": "B",
    "explanation": "Older, insecure services like chargen, daytime, echo, time, rsh, and telnet are all managed by inetd in Linux distributions. Disabling these services is a common item in security hardening benchmarks like the CIS benchmarks. These services are not Windows services, they are not SQL\u2010related, and disabling them is not a type of patching.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      192,
      194,
      196,
      53,
      236
    ],
    "source": "9781394211395"
  },
  {
    "id": 1231,
    "question": "What mobile device deployment model provides the least control for the organization and leaves the end user with the greatest choice?",
    "choice_a": "BYOD",
    "choice_b": "COPE",
    "choice_c": "CYOD",
    "choice_d": "COBO",
    "correct_answer": "A",
    "explanation": "Bring your own device (BYOD) leaves the choice of device in the hands of the end user. Since the device is the end user's device, it often means that the organization has less, if any, control over the device. Corporate\u2010owned, personally enabled (COPE) allows users to use organizationally owned devices for their own use. Choose your own device (CYOD) lets users choose a device that the organization owns. COBO, or company\u2010owned, business\u2010only, is a model that only allows business use of business\u2010provided devices.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      237,
      239,
      144,
      197,
      93
    ],
    "source": "9781394211395"
  },
  {
    "id": 1232,
    "question": "Akio has set the <code>Secure Cookie</code> attribute as part of her web application's process for sending new cookies to users. What does this attribute do?",
    "choice_a": "It encrypts the cookie's content when it is stored.",
    "choice_b": "It stores the cookie on the server instead of on the remove device.",
    "choice_c": "It removes the cookie after it has been used.",
    "choice_d": "It requires that the cookie be sent only via HTTPS.",
    "correct_answer": "D",
    "explanation": "The <code>Secure Cookie</code> attribute is intended to keep cookies secure in transit. That means that it requires secure cookies be sent only via HTTPS. It does not encrypt the cookie at rest, store it on the server instead of the remote system, nor does it remove the cookie after it has been used.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      140,
      134,
      54,
      53
    ],
    "source": "9781394211395"
  },
  {
    "id": 1233,
    "question": "Helen wants to sign her code. What will the output of code signing be?",
    "choice_a": "An encrypted copy of the code using her private key",
    "choice_b": "A signed hash of the software using her private key",
    "choice_c": "A signed hash of the software using her public key",
    "choice_d": "An encrypted copy of the code using her public key",
    "correct_answer": "B",
    "explanation": "Code signing uses the signing organization or individual's private key to sign a hash of the code. This allows the code to be verified using the organization's or individual's public key. Signing code does not involve encrypting it.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      85,
      139,
      134,
      140,
      93
    ],
    "source": "9781394211395"
  },
  {
    "id": 1234,
    "question": "Naomi's organization has recently acquired another company. Naomi is concerned about asset tracking and inventory because the acquired company does not have an inventory of their systems and devices. What major security concern should she express about this from a hardware asset management perspective?",
    "choice_a": "There may not be an appropriate hardware life\u2010cycle process.",
    "choice_b": "Manufacturer support may not be possible without an inventory.",
    "choice_c": "There is no way to know if systems are missing.",
    "choice_d": "Vulnerability scans may not be accurate without an inventory.",
    "correct_answer": "C",
    "explanation": "Without an inventory, organizations may misplace, lose, or even have devices stolen. That may result in data breaches or simply loss of assets. A hardware life cycle process is an operational concern; manufacturer support is typically tied to individual devices; and vulnerability scans are possible without an inventory, but Naomi may not know what the device itself is until she physically locates it.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      206,
      209,
      207,
      40,
      240
    ],
    "source": "9781394211395"
  },
  {
    "id": 1235,
    "question": "As part of his CI/CD pipeline process, Felix reviews source code manually to identify any flaws or security concerns. What type of process is Felix following?",
    "choice_a": "Dynamic analysis",
    "choice_b": "Agile code development",
    "choice_c": "Static analysis",
    "choice_d": "Internal review",
    "correct_answer": "C",
    "explanation": "Static analysis processes for code involve reviewing the source code itself. Dynamic analysis processes use running code. Agile is a project management framework, and internal review is not a term used to describe this.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      66,
      49,
      47,
      62,
      85
    ],
    "source": "9781394211395"
  },
  {
    "id": 1236,
    "question": "As part of his research, Pedro uses a TOR browser to access threat actors' sites. He is able to see information about recent breaches and can download data dumps provided by the threat actors. What information source is Pedro using?",
    "choice_a": "The dark web",
    "choice_b": "An information\u2010sharing organization",
    "choice_c": "Proprietary information",
    "choice_d": "A threat feed",
    "correct_answer": "A",
    "explanation": "Sites accessible using TOR are considered part of the dark web. Information\u2010sharing organizations like ISACs share information in an industry vertical or among other organizations that participate. Proprietary information is provided by vendors, typically as part of a contract or service. Threat feeds may be public or private and provide information about threats in a digestible format for use with security tools.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      20,
      23,
      22,
      21,
      59
    ],
    "source": "9781394211395"
  },
  {
    "id": 1237,
    "question": "Alaina has completed the eradication and recovery steps of the incident response process. What step commonly comes after these two phases?",
    "choice_a": "A lessons learned session",
    "choice_b": "Detection",
    "choice_c": "Training",
    "choice_d": "A tabletop exercise",
    "correct_answer": "A",
    "explanation": "A lessons learned session is commonly conducted at the end of an incident response process. Once eradication and recovery are complete, incident response processes are typically over and the response effort can be reviewed. The lessons learned are then leveraged as part of the preparation process to be ready for the next incident. That may involve more training, tabletop exercises, or additional detection methods.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      240,
      258,
      243,
      242,
      257
    ],
    "source": "9781394211395"
  },
  {
    "id": 1238,
    "question": "Lucca knows that the CVSS environmental score is made up of three components, including an impact metric. What three components does he need to consider as part of the impact metric score?",
    "choice_a": "Confidentiality, integrity, and availability",
    "choice_b": "Network, disk, and memory",
    "choice_c": "Severity, likelihood, and impact",
    "choice_d": "Probability, impact, and cost",
    "correct_answer": "A",
    "explanation": "The CVSS environmental score's impact metric takes into account confidentiality, integrity, and availability risks, with each rated between high, medium, and low levels. It is not a direct rating of network, disk, memory, severity, likelihood, probability, or cost.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      46,
      47,
      50,
      63,
      41
    ],
    "source": "9781394211395"
  },
  {
    "id": 1239,
    "question": "What tool is commonly used to allow for measurement and monitoring of security settings to align with NIST 800\u201053 controls?",
    "choice_a": "SAML",
    "choice_b": "CVE",
    "choice_c": "CVSS",
    "choice_d": "SCAP",
    "correct_answer": "D",
    "explanation": "The Security Content Automation Protocol (SCAP) is frequently used to allow for monitoring and measurement of NIST 800\u201053\u2010based controls. SAML is used for authorization and authentication, and CVE and CVSS are used to identify and rank vulnerabilities.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      50,
      63,
      47,
      93,
      91
    ],
    "source": "9781394211395"
  },
  {
    "id": 1240,
    "question": "Adam has implemented a WPA3 Enterprise network. What type of encryption will be used to protect data sent across the Wi\u2010Fi connection?",
    "choice_a": "AES",
    "choice_b": "3DES",
    "choice_c": "SHA\u20101",
    "choice_d": "SHA\u2010256",
    "correct_answer": "A",
    "explanation": "WPA3 Enterprise uses Advanced Encryption Standard (AES) and can use 128\u2010, 192\u2010, and 256\u2010bit keys. It does not support 3DES, and both SHA\u20101 and SHA\u2010256 are hashing algorithms.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      54,
      233,
      214,
      265,
      196
    ],
    "source": "9781394211395"
  },
  {
    "id": 1241,
    "question": "Tom wants to set up an authentication service for network devices. Which of the following is commonly used for authentication to enterprise network devices?",
    "choice_a": "Kerberos",
    "choice_b": "SAML",
    "choice_c": "TKIP",
    "choice_d": "OpenID",
    "correct_answer": "A",
    "explanation": "Kerberos is one of a small number of commonly used AAA protocols for network devices. SAML and OpenID are more commonly used for federated services, and TKIP is an encryption method.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      134,
      133,
      135,
      136,
      140
    ],
    "source": "9781394211395"
  },
  {
    "id": 1242,
    "question": "Ian wants to test embedded device web servers for potential security issues with the version of the web server software. What tool should he select to do this most effectively across his large organization's network of IoT devices?",
    "choice_a": "A WAF",
    "choice_b": "Pentesting",
    "choice_c": "A vulnerability scanner",
    "choice_d": "A port scanner",
    "correct_answer": "C",
    "explanation": "Vulnerability scanners are perfectly suited to this type of task and can be configured to specifically test the web servers that are part of the IoT devices to increase the speed of the scan. A WAF is used to protect web applications and servers, not to assess vulnerabilities and security issues. Pentesting can identify these problems but is typically not fast or scalable. Port scanners identify open ports and service but don't identify vulnerabilities as effectively as a dedicated vulnerability scanning tool will.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      49,
      40,
      41,
      43,
      52
    ],
    "source": "9781394211395"
  },
  {
    "id": 1243,
    "question": "Tom wants his email servers to reject email that is not authenticated in a way to prevent spoofing. Which of the following should he implement?",
    "choice_a": "SPF",
    "choice_b": "DMARC",
    "choice_c": "DKIM",
    "choice_d": "TLS",
    "correct_answer": "B",
    "explanation": "DMARC, or Domain\u2010based Message Authentication, Reporting, and Conformance, controls how unauthenticated messages are handled by mailbox providers, including quarantining, rejecting, or rejecting messages. SPF (Sender Policy Framework) lists IP addresses of systems allowed to send email in DNS TXT records for a domain. DomainKeys Identified Mail (DKIM) validates a domain's identity using a public key pair, validating the authenticity of the sender. TLS (Transport Layer Security) is used to encrypt data in motion.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      220,
      252,
      214,
      136,
      132
    ],
    "source": "9781394211395"
  },
  {
    "id": 1244,
    "question": "Wayne has identified a vulnerable server that is part of his organization's critical infrastructure but that is no longer supported by the vendor and for which no additional patches exist. Every time Wayne scans the server using his vulnerability scanner, the services on the device crash. What should Wayne do?",
    "choice_a": "Report the server as vulnerable and suggest that it be replaced immediately.",
    "choice_b": "Disable the network connection on the device and isolate the server to protect it.",
    "choice_c": "Identify a third\u2010party insurance provider who will insure the organization against potential issues with the server.",
    "choice_d": "Document an exemption, remove the server from automated scans, and implement compensating controls.",
    "correct_answer": "D",
    "explanation": "In most organization, Wayne's next steps should be to document the exemption due to the criticality of the server and its extenuating circumstances. Removing the server from scans will prevent it from being effectively impacted by a denial\u2010of\u2010service attack each time a scan occurs, but this also means that compensating controls should be implemented if possible. Reporting the server as vulnerable and suggesting it be replaced does not remediate the server or protect it, and will continue to allow it to fail based on future scans. Disabling the device's network connection will also cause a service outage. Insurance will not prevent service outages or protect the device.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      63,
      41,
      42,
      51,
      144
    ],
    "source": "9781394211395"
  },
  {
    "id": 1245,
    "question": "Valentine's organization wants to ensure that users who sign up for their web services are who they claim to be. As part of the process they ask for information like birth date, Social Security number, and previous addresses. What type of activity is Valentine's organization engaging in?",
    "choice_a": "Provisioning user accounts",
    "choice_b": "Identity proofing",
    "choice_c": "Deprovisioning user accounts",
    "choice_d": "Social identity",
    "correct_answer": "B",
    "explanation": "Identity proofing is used to validate a user's claim to an identity. Here, Valentine's company uses information that only a legitimate owner of that identity should have easy access to. Provisioning is the process of creating an account and providing it with appropriate resources and rights. Deprovisioning removes accounts and rights. Social identity is the process of using existing user accounts like those found through Facebook or Google to create accounts for existing users at other organizations like Valentine's.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      144,
      136,
      135,
      132,
      145
    ],
    "source": "9781394211395"
  },
  {
    "id": 1246,
    "question": "Sam has completed patching of a critical vulnerability. What step is often performed next to ensure that the patching occurred properly?",
    "choice_a": "Noting false positives",
    "choice_b": "Rebooting the system",
    "choice_c": "Rescanning the system",
    "choice_d": "Performing an audit",
    "correct_answer": "C",
    "explanation": "Organizations often immediately rescan a system after patching to ensure that the patching worked. While this isn't an absolutely certain means of validating the patch, it helps to quickly ensure that patching was effective across many machines. Noting false positives may occur if the patch was successful, but systems continue to show as vulnerable. Rebooting may be done but doesn't necessarily validate the patching installation's success, and performing an audit may be done but is a less common next step.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      48,
      63,
      197,
      43,
      41
    ],
    "source": "9781394211395"
  },
  {
    "id": 1247,
    "question": "Joan's organization has recently remediated issues in their credit card processing environment. If Joan wants to be able to attest to the security of the environment, what action might she need to take to prove the security of the environment to customers?",
    "choice_a": "Have third\u2010party auditors validate the remediation.",
    "choice_b": "Rescan the systems and document the differences between the scans.",
    "choice_c": "Rescan the systems and provide updated reports to customers.",
    "choice_d": "Allow customers to scan the systems to validate the changes.",
    "correct_answer": "A",
    "explanation": "Third\u2010party audit documentation is a common practice for organizations that want to attest to their customers that they have a secure environment. Rescanning systems and providing vulnerability scans is not a common practice, nor is allowing customers to conduct their own scans of production systems.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      63,
      47,
      41,
      42,
      43
    ],
    "source": "9781394211395"
  },
  {
    "id": 1248,
    "question": "Alan wants to configure his firewall to allow Microsoft SQL traffic through to the database server from web application servers in a screened subnet design. What is the minimum set of ports that he should port to allow this?",
    "choice_a": "TCP 3389 and 1433",
    "choice_b": "TCP 1433",
    "choice_c": "TCP 8080",
    "choice_d": "TCP 139 and 445",
    "correct_answer": "B",
    "explanation": "TCP port 1433 is the minimum port requirement for a Microsoft SQL server connection. TCP 3389 is used for Remote Desktop Protocol (RDP). TCP 8080 is a common alternate port for web servers, and TCP 139 and 445 are used for SMB connections.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      192,
      215,
      219,
      53,
      148
    ],
    "source": "9781394211395"
  },
  {
    "id": 1249,
    "question": "Which of the following terms refers to the process of establishing a standard for security?",
    "choice_a": "Baselining",
    "choice_b": "Security evaluation",
    "choice_c": "Hardening",
    "choice_d": "Normalization",
    "correct_answer": "A",
    "explanation": "Baselining is the process of establishing a standard for security. A change from the original baseline configuration is referred to as baseline deviation. Security evaluations or audits check security but don't establish security standards. Hardening is the process of securing a given system, but it does not establish security standards. Normalization is the process of removing redundant entries from a database.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      196,
      93,
      192,
      194,
      236
    ],
    "source": "9781394211395"
  },
  {
    "id": 1250,
    "question": "Zhen's new organization has informed him that they used a COPE model for their mobile devices. What does this tell Zhen about what he can do with the device?",
    "choice_a": "He can choose what device he uses, but the organization will own it.",
    "choice_b": "He will be provided with a device but can use it for reasonable personal use.",
    "choice_c": "He will be provided with a device and can only use it for business purposes.",
    "choice_d": "He will have to bring his own device but can use it for personal and business use.",
    "correct_answer": "B",
    "explanation": "COPE, or company\u2010owned, personally enabled, models allow staff to use organizationally owned devices for reasonable personal use. CYOD, or choose your own device, allows users to pick their company\u2010owned device from a list of approved devices. COBO, or company\u2010owned, business\u2010only, is just that\u2014users can only use the devices for business purposes. BYOD asks users to bring their own device, often leaving organizations with limited or no control of the device.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      237,
      238,
      236,
      239,
      209
    ],
    "source": "9781394211395"
  },
  {
    "id": 1251,
    "question": "The Windows Task Manager can be used to identify malware through what technique?",
    "choice_a": "Dynamic analysis",
    "choice_b": "Process auditing",
    "choice_c": "CVSS matching",
    "choice_d": "Vulnerability scanning",
    "correct_answer": "B",
    "explanation": "Process auditing involves reviewing processes to identify unknown or unexpected processes. During incident response scenarios, this is often initially done via the Task Manager. Dynamic analysis is a code review process that uses running code. CVSS matching was made up for this question, and vulnerability scanning tests open services and doesn't involve the Task Manager.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      240,
      250,
      186,
      258,
      269
    ],
    "source": "9781394211395"
  },
  {
    "id": 1252,
    "question": "Ujama wants to deploy a network device that will allow him to use policy\u2010based controls for email as well as active defenses against phishing attacks before email is delivered to his users. Which of the following devices is best suited to this purpose?",
    "choice_a": "A web application firewall",
    "choice_b": "An email security gateway",
    "choice_c": "A DKIM appliance",
    "choice_d": "A DMARC appliance",
    "correct_answer": "B",
    "explanation": "Email security gateways are appliances or software virtual appliances that provide anti\u2010spam, anti\u2010phishing, and other email security\u2013related services. They're purpose\u2010built to deliver exactly the capabilities that Ujama is looking for. A WAF (web application firewall) is used to protect web applications. DKIM and DMARC are both email security frameworks, but they're not implemented as appliances themselves.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      220,
      186,
      246,
      214,
      250
    ],
    "source": "9781394211395"
  },
  {
    "id": 1253,
    "question": "Allison wants to aggregate her logs and have them automatically correlated and reported on. What sort of tool should she acquire for her organization?",
    "choice_a": "MDM",
    "choice_b": "A jump server",
    "choice_c": "SDN",
    "choice_d": "SIEM",
    "correct_answer": "D",
    "explanation": "A SIEM (security information and event management) tool is designed to aggregate, analyze, correlate, alert on, and report on log entries. MDM (mobile device management) is used to manage mobile devices, jump servers provide access from less secure zones to more secure zones, and SDN is software\u2010defined networking.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      246,
      249,
      248,
      247,
      250
    ],
    "source": "9781394211395"
  },
  {
    "id": 1254,
    "question": "Natasha's staff have been complaining about repetitive tasks that must be manually accomplished to secure endpoint devices, then they are deployed. What could Natasha ask her team to do to address this?",
    "choice_a": "Leverage automation and scripting.",
    "choice_b": "Deploy fewer devices.",
    "choice_c": "Leverage baselines.",
    "choice_d": "Move devices to the cloud.",
    "correct_answer": "A",
    "explanation": "Leveraging automation and scripting to increase employee happiness and retention as well as improving efficiency and realizing time savings is a common strategy in situations like this. Deploying fewer devices only works if the organization needs fewer devices, baselines are most useful when paired with automation and scripting for deployment, and a physical endpoint device typically can't be moved to the cloud.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      92,
      93,
      91,
      197,
      66
    ],
    "source": "9781394211395"
  },
  {
    "id": 1255,
    "question": "Which of the following methods typically provides the greatest insight into vulnerabilities that exist on systems owned by a company?",
    "choice_a": "Penetration tests",
    "choice_b": "Authenticated scans",
    "choice_c": "Unauthenticated scans",
    "choice_d": "Port scans",
    "correct_answer": "B",
    "explanation": "Authenticated scans can identify vulnerabilities that are not visible to unauthenticated scans. Penetration testers may not be able to obtain access equivalent to authenticated scans, so an authenticated scan is more likely to provide detailed data. Port scans do not provide deep vulnerability data.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      43,
      44,
      42,
      47,
      40
    ],
    "source": "9781394211395"
  },
  {
    "id": 1256,
    "question": "Quarantine and isolation are both common options in what phase of the incident response process?",
    "choice_a": "Detection",
    "choice_b": "Analysis",
    "choice_c": "Containment",
    "choice_d": "Eradication",
    "correct_answer": "C",
    "explanation": "Quarantine and isolation are both commonly used in the containment phase of an incident to ensure that impacted systems are unable to impact other systems or parts of the organization. Files may also be quarantined to prevent further impact from malware. Detection and analysis typically do not involve quarantine and isolation, but quarantine and isolation may carry through into the eradication phase before systems are returned to normal operation.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      240,
      256,
      254,
      241,
      250
    ],
    "source": "9781394211395"
  },
  {
    "id": 1257,
    "question": "Rick is reviewing Linux system permissions and finds a directory that is set to: <br> <code>-rwxr--r--</code> <br>Who will have access to the directory to read the file?",
    "choice_a": "The user",
    "choice_b": "The user and their group",
    "choice_c": "All users",
    "choice_d": "No users except root",
    "correct_answer": "C",
    "explanation": "Linux permissions are read left to right for user, group, and other. With r's at each location, this means everyone can read the contents of the directory. Only the user can write and execute files in the directory.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      149,
      144,
      145,
      192,
      93
    ],
    "source": "9781394211395"
  },
  {
    "id": 1258,
    "question": "Beena is granted access to her organization's customer information because she is a data steward; her access occurs between 8 a.m. and 5 p.m., and it is occurring from a known workstation that has passed security checks. What type of access control scheme is in use?",
    "choice_a": "Rule\u2010based access control",
    "choice_b": "Role\u2010based access control",
    "choice_c": "Mandatory access control",
    "choice_d": "Attribute\u2010based access control",
    "correct_answer": "A",
    "explanation": "A set of rules that defines who can access the data has determined if Beena is granted access. Here, rules assess her role, the time of day, and the workstation's status. This is not accomplished using a classification or clearance system like MAC uses, and it does not rely on just an attribute like Beena's location or other information about her.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      148,
      144,
      145,
      149,
      246
    ],
    "source": "9781394211395"
  },
  {
    "id": 1259,
    "question": "Juan wants to use his IDS to detect anomalous behavior. What type of detection technique would most effectively help him identify unknown new attacks?",
    "choice_a": "Trend analysis",
    "choice_b": "Signature\u2010based detection",
    "choice_c": "IP\u2010based detection",
    "choice_d": "Port\u2010based detection",
    "correct_answer": "A",
    "explanation": "Trend analysis is commonly used as part of behavior\u2010based detections, which can help identify new attacks. Signatures require knowledge of existing attacks to match signatures. IP\u2010 and port\u2010based detection is useful for known attacks but not typically useful for unknown attacks.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      219,
      186,
      246,
      187,
      62
    ],
    "source": "9781394211395"
  },
  {
    "id": 1260,
    "question": "Geenah wants to identify where Wi\u2010Fi signals are weakest in her building. What should she create to visually display signal coverage and strength throughout her building?",
    "choice_a": "A war walk",
    "choice_b": "A spectrum analysis",
    "choice_c": "An SSID plot",
    "choice_d": "A heatmap",
    "correct_answer": "D",
    "explanation": "Heatmaps are used to show signal strength and coverage, allowing organizations to identify areas where there may be poor coverage or where multiple signals may conflict. War walking (and war driving) are techniques used to map wireless access points to geographic locations. Spectrum analysis and SSID plots are not terms used for this type of activity.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      59,
      247,
      40,
      47,
      21
    ],
    "source": "9781394211395"
  },
  {
    "id": 1261,
    "question": "What term describes the concept that individuals should be given the minimum permissions necessary to accomplish their role or tasks?",
    "choice_a": "Zero trust",
    "choice_b": "Provisioning",
    "choice_c": "Least privilege",
    "choice_d": "Deprovisioning",
    "correct_answer": "C",
    "explanation": "The concept of least privilege is that only the minimum rights or privileges required to accomplish a role or task are provided. Zero trust requires continuous authentication and authorization, and least privilege is part of a zero trust environment, but zero trust goes beyond least privilege. Provisioning and deprovisioning are part of the account life cycle, and provisioning should respect the concept of least privilege.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      144,
      148,
      145,
      52,
      92
    ],
    "source": "9781394211395"
  },
  {
    "id": 1262,
    "question": "Joanna wants to explain the advantages of automation for user and resource provisioning. Which of the following is not an advantage of automation over manual processes for provisioning?",
    "choice_a": "Automation ensures consistency in the provisioning process.",
    "choice_b": "Automation provides faster provisioning.",
    "choice_c": "Automation decreases mistakes in provisioning.",
    "choice_d": "Automation provides auditability of provisioning.",
    "correct_answer": "D",
    "explanation": "Automation provides many advantages for the provisioning process, including improving consistency, decreasing the potential for mistakes, and providing faster provisioning. It does not specifically address auditability in ways that manual processes cannot. Regardless of how provisioning is done, audit logs and trails should be created for all events, not just automated ones.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      93,
      92,
      144,
      91,
      257
    ],
    "source": "9781394211395"
  },
  {
    "id": 1263,
    "question": "Bug bounty programs are an example of what type of program?",
    "choice_a": "Contracted penetration testing",
    "choice_b": "Responsible disclosure",
    "choice_c": "Third\u2010party bounty",
    "choice_d": "Trusted threat",
    "correct_answer": "B",
    "explanation": "Bug bounty programs are frequently part of responsible disclosure programs intended to provide a way for third parties to report security issues and to be incentivized to report them in responsible ways. Bug bounties can help identify flaws, but they're not typically part of contracted penetration testing engagements. Third\u2010party bounty is not a typical way of describing them, and trusted threat programs were made up for this question.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      59,
      56,
      55,
      60,
      62
    ],
    "source": "9781394211395"
  },
  {
    "id": 1264,
    "question": "Jack is hardening a Cisco switch based on the CIS IOS benchmark. As part of the configuration process, he configures settings including <code>ntp authenticate</code> and <code>ntp trusted\u2010key</code>. Why would Jack configure this on his network switches?",
    "choice_a": "To ensure that the switch has Network Terminal Protocol enabled",
    "choice_b": "To prevent attackers from modifying logs",
    "choice_c": "To prevent attackers from capturing network time traffic",
    "choice_d": "To ensure that network time is from a trusted source",
    "correct_answer": "D",
    "explanation": "Even if you're not familiar with specific Cisco IOS commands and configuration you can quickly determine that this is a Network Time Protocol (NTP)\u2010related setting. Authenticating NTP and ensuring a trusted key is enabled would help to ensure that network time is trusted and secure. This prevents attackers from conducting attacks that rely on modifying network time or the switch recording incorrect time in its logs. There is no Network Terminal Protocol, this does not impact logs, and network time traffic is not encrypted.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      196,
      269,
      250,
      215,
      133
    ],
    "source": "9781394211395"
  },
  {
    "id": 1265,
    "question": "Tony wants to use a cellular connection to transfer data to his organization. What should he do to ensure that his data is as secure as possible?",
    "choice_a": "Make sure he is connected to his cellular provider's towers.",
    "choice_b": "Fully patch the phone.",
    "choice_c": "Use a VPN.",
    "choice_d": "Deploy a security baseline to the phone.",
    "correct_answer": "C",
    "explanation": "Using a VPN is a best practice over any untrusted or potentially untrusted network connection. Patching the phone and deploying a security baseline are good for the phone's security, but they won't help directly with the security of data in transit.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      188,
      256,
      214,
      53,
      93
    ],
    "source": "9781394211395"
  },
  {
    "id": 1266,
    "question": "The hospital that Isabella works for leverages threat information from the Health\u2010ISAC as part of their security team's work. What type of threat information provider is the Health\u2010ISAC?",
    "choice_a": "An OSINT provider",
    "choice_b": "A dark web source",
    "choice_c": "An information\u2010sharing organization",
    "choice_d": "A proprietary threat data source",
    "correct_answer": "C",
    "explanation": "ISACs, or Information Sharing and Analysis Centers, are information\u2010sharing organizations established to connect organizations in verticals like health care, government, utilities, and higher education. While it may provide OSINT information, they go far beyond that. They are not typically found via the dark web and don't require TOR to access their information, and they are not commercial or proprietary threat data sources.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      23,
      20,
      21,
      91,
      248
    ],
    "source": "9781394211395"
  },
  {
    "id": 1267,
    "question": "Mark presents his driver's license as part of the creation of his user account for a secure online service. What process requires this type of information to validate ownership of an identity?",
    "choice_a": "Attestation",
    "choice_b": "Provisioning",
    "choice_c": "SSO",
    "choice_d": "De\u2010provisioning",
    "correct_answer": "A",
    "explanation": "Attestation is the verification of ownership or that a person matches who they claim to be. In this case, Mark presents his driver's license to attest to his own identity. Provisioning is the creation of accounts and the granting of rights, and deprovisioning is the removal of accounts and rights for accounts. SSO is single sign\u2010on.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      144,
      140,
      145,
      143,
      92
    ],
    "source": "9781394211395"
  },
  {
    "id": 1268,
    "question": "Hector is concerned about Bluetooth security. Which of the following is a legitimate security concern about Bluetooth?",
    "choice_a": "It is not encrypted.",
    "choice_b": "Bluetooth is only useful at short range.",
    "choice_c": "Bluejacking may occur.",
    "choice_d": "Bluetooth devices can be fingerprinted.",
    "correct_answer": "D",
    "explanation": "Bluetooth devices can be fingerprinted relatively easily, making it easy to identify individual users who have Bluetooth turned on. Modern Bluetooth traffic is encrypted, its relatively short range is not a security concern, and Bluejacking sends unwanted spam, which isn't a direct data security issue.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      259,
      269,
      137,
      139,
      238
    ],
    "source": "9781394211395"
  },
  {
    "id": 1269,
    "question": "Privileged access management (PAM) tools provide functions for enterprise access management. Which of the following is not a common PAM component?",
    "choice_a": "Just\u2010in\u2010time permissions",
    "choice_b": "Password vaulting",
    "choice_c": "Ephemeral credentials",
    "choice_d": "Password persistence",
    "correct_answer": "D",
    "explanation": "PAM tools provide a variety of capabilities, including just\u2010in\u2010time permissions, password vaulting, and ephemeral credentials. Password persistence was made up for this question and is not a typical feature.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      145,
      144,
      148,
      138,
      137
    ],
    "source": "9781394211395"
  },
  {
    "id": 1270,
    "question": "What role do port scans play in asset tracking?",
    "choice_a": "Enumeration of assets.",
    "choice_b": "They provide OSINT.",
    "choice_c": "Version tracking for assets.",
    "choice_d": "They do not play a role in asset tracking.",
    "correct_answer": "A",
    "explanation": "Port scans can help with enumeration of assets when an inventory does not exist. They do not provide OSINT; OSINT is a passive information\u2010gathering process and a scan is an active process. Version tracking via port scans is inaccurate and does not provide full information. Identifying assets via port scans is a reasonably common part of asset management, particularly for initial discovery.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      206,
      40,
      59,
      52,
      43
    ],
    "source": "9781394211395"
  },
  {
    "id": 1271,
    "question": "A fingerprint is an example of what type of authentication factor?",
    "choice_a": "Something you know",
    "choice_b": "Something you have",
    "choice_c": "Something you are",
    "choice_d": "Somewhere you are",
    "correct_answer": "C",
    "explanation": "Fingerprints are biometric factors and are something you are. Something you know is a knowledge factor like a password or PIN. Something you have is a hardware token, RFID card, or other similar factor. Somewhere you are is a geographic factor based on location such as GPS coordinates.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      140,
      142,
      139,
      141,
      132
    ],
    "source": "9781394211395"
  },
  {
    "id": 1272,
    "question": "Dana wants to ensure that her software acquisition process for open source software is as secure as possible. What should she to do validate the security of the open source software?",
    "choice_a": "Ensure that the software source code is escrowed.",
    "choice_b": "Review the source code for the software.",
    "choice_c": "Check dependencies for known vulnerabilities.",
    "choice_d": "Purchase the software from a software vendor.",
    "correct_answer": "C",
    "explanation": "Dependency checking for open source software is a common best practice to help ensure that underlying components do not have known security vulnerabilities. There are dependency security checking applications and tools available that Dana could use to help with this process. Software source code escrow is often used to ensure that organizations can obtain the software code if a company goes out of business or other adverse events occur that might endanger the company relying on the code. Reviewing the source code for an entire application is outside of the scope and capability of the majority of organizations, particularly when other dependencies are included. Purchasing software from a known vendor can help, but does not necessarily ensure that the software is secure and dependencies don't introduce or include known issues.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      45,
      22,
      85,
      63,
      197
    ],
    "source": "9781394211395"
  },
  {
    "id": 1273,
    "question": "Sharon wants to implement WPA3 Enterprise. What technology will she need to use for authorization after wireless devices associate with access points?",
    "choice_a": "LDAP",
    "choice_b": "802.1X",
    "choice_c": "Kerberos",
    "choice_d": "SAML",
    "correct_answer": "B",
    "explanation": "Sharon knows that Enterprise mode authentication is typically done with 802.1X. LDAP and Kerberos are not typically used for this, and SAML is more frequently part of federated and cloud services.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      233,
      214,
      133,
      135,
      134
    ],
    "source": "9781394211395"
  },
  {
    "id": 1274,
    "question": "What purpose do the password history and password minimum age settings have in Windows?",
    "choice_a": "To prevent attackers from resetting passwords",
    "choice_b": "To prevent brute\u2010force attacks",
    "choice_c": "To prevent password reuse",
    "choice_d": "To ensure proper password expiration",
    "correct_answer": "C",
    "explanation": "Windows supports both password history and a minimum password age to help prevent users from simply resetting their password over and over again until they can reuse their preferred password. This does not prevent attackers from resetting passwords or using brute\u2010force attacks and doesn't ensure password expiration.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      194,
      137,
      148,
      143,
      192
    ],
    "source": "9781394211395"
  },
  {
    "id": 1275,
    "question": "A CVSS score is based on what three metric groups of data?",
    "choice_a": "Scope, Impact, Environmental",
    "choice_b": "Base, Temporal, and Environmental",
    "choice_c": "Risk, Threat, Impact",
    "choice_d": "Time, Risk, Scope",
    "correct_answer": "B",
    "explanation": "CVSS scores are based on base metrics like the attack vector; complexity; scope; user interaction required and privileges required; the temporal group, which includes exploit code maturity, remediation level, and report confidence; and the environmental group, including confidentiality, availability, and integrity requirements. While scope, impact, risk, and threat all play into these elements, CVSS calls the three metric groups Base, Temporal, and Environmental.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      46,
      50,
      47,
      63,
      21
    ],
    "source": "9781394211395"
  },
  {
    "id": 1276,
    "question": "Quentin wants to decommission solid\u2010state drives (SSDs). What process should he follow if he wants to be absolutely certain that the data cannot be recovered?",
    "choice_a": "Zero wiping",
    "choice_b": "Destruction",
    "choice_c": "Sanitation",
    "choice_d": "Reformatting",
    "correct_answer": "B",
    "explanation": "In scenarios where the data needs to be guaranteed to be unrecoverable, physical destruction is a common choice. Zero wiping and reformatting both leave remnant data on SSDs, and sanitization processes are reasonably secure but cannot always be guaranteed to result in total data removal.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      207,
      268,
      209,
      264,
      259
    ],
    "source": "9781394211395"
  },
  {
    "id": 1277,
    "question": "What challenge is commonly encountered when organizations want to harden IoT devices?",
    "choice_a": "The devices have limited security options.",
    "choice_b": "The devices cannot run current operating systems.",
    "choice_c": "Industry benchmarks for security are not up\u2010to\u2010date.",
    "choice_d": "Central management tools only support new devices.",
    "correct_answer": "A",
    "explanation": "IoT devices often have very limited security options, if any. That means that hardening them using built\u2010in tools and configurations is limited, if not impossible. IoT devices typically use their own OS; benchmarks are rarely available, not just out\u2010of\u2010date; and central management for many IoT devices is frequently not available.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      236,
      237,
      192,
      196,
      52
    ],
    "source": "9781394211395"
  },
  {
    "id": 1278,
    "question": "Guillermo wants to establish his organization's security baseline for Linux systems. After selecting the CIS benchmark that best matches his organization's commonly used Linux distribution, what should he do next?",
    "choice_a": "Deploy the benchmark to a test system to see how it performs in normal use.",
    "choice_b": "Install SELinux to allow for the baseline to be implemented fully.",
    "choice_c": "Review the baseline to determine any settings that are not a good fit for the organization's usage.",
    "choice_d": "Identify the deployment method for the baseline to the Linux systems.",
    "correct_answer": "C",
    "explanation": "Reviewing any baseline to determine its fit for the organization and how the organization's systems and services operate is an appropriate next step after selecting a benchmark. Deploying SELinux may be necessary for some features depending on the distribution in use, but nothing in the question indicates that this is required. Once the benchmark has been modified to purpose and suitability, it can be tested, and further modifications can be made if necessary. Finally, it can be deployed and managed.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      196,
      192,
      93,
      194,
      149
    ],
    "source": "9781394211395"
  },
  {
    "id": 1279,
    "question": "Renee has implemented WPA3 Enterprise, and she wants to use an EAP protocol for secure authentication. What EAP version should she implement?",
    "choice_a": "LEAP",
    "choice_b": "EAP\u2010TLS",
    "choice_c": "EAP\u2010PSK",
    "choice_d": "EAP\u2010PWD",
    "correct_answer": "B",
    "explanation": "EAP\u2010TLS provides TLS\u2010based Transport Layer Security as part of a secure authentication implementation. LEAP is the Lightweight Extensible Authentication Protocol, which was in use before 802.11i but is now largely outdated. EAP\u2010PSK uses a preshared key for mutual authentication and does not rely on public key encryption, but it is not supported in WPA3 deployments. EAP\u2010PWD uses a shared password for authentication and, like EAP\u2010PSK, is not supported by WPA3.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      233,
      133,
      214,
      132,
      140
    ],
    "source": "9781394211395"
  },
  {
    "id": 1280,
    "question": "The organization that Chris works for has recently acquired another company. As part of the acquisition, Chris is preparing to address the data that the newly acquired company used, including setting up rules to handle it in his data loss prevention (DLP) system. What step is commonly required prior to data being protected by a DLP system?",
    "choice_a": "Hashing the data and creating signatures",
    "choice_b": "Encrypting the data",
    "choice_c": "Classifying and tagging the data",
    "choice_d": "Applying a mandatory access control scheme to the data",
    "correct_answer": "C",
    "explanation": "DLP systems often rely on classification, tagging, and metadata to help them identify sensitive data that the organization handles and which could be exfiltrated or sent inadvertently outside of the organization. Hashing and creating signatures is more commonly associated with filesystem\u2010monitoring tools. Encrypting the data is not required by a DLP and may actually make it harder for the DLP to identify the data. Applying a mandatory access control scheme to the data is not a typical step in preparing for DLP\u2010based protection.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      188,
      255,
      252,
      207,
      246
    ],
    "source": "9781394211395"
  },
  {
    "id": 1281,
    "question": "Mark wants to have a way to determine if attackers have modified files on a critical web application server. What type of tool should he deploy if he wants to be able to check for changes of this nature?",
    "choice_a": "Drive encryption",
    "choice_b": "File availability monitoring",
    "choice_c": "File encryption",
    "choice_d": "File integrity monitoring",
    "correct_answer": "D",
    "explanation": "File integrity monitoring tools use hashes to validate that files match their original content. If the files change, the hashes will not match, allowing the tool to alert administrators that a change has occurred. Drive encryption and file encryption both protect the confidentiality of data but don't indicate changes without a signature. File availability monitoring is not a typical tool, although system or service availability monitoring is.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      265,
      252,
      250,
      187,
      254
    ],
    "source": "9781394211395"
  },
  {
    "id": 1282,
    "question": "Katie's organization uses an IoC feed that helps her to identify new threats. A recent feed update includes the following hash for Emotet malware: <br> <code>cecc5bba6193d744837e689e68bc25c43eda7235</code> <br>Where is Katie most likely going to be able to use this hash to identify potential attacks?",
    "choice_a": "Via her EDR tools",
    "choice_b": "Via her firewall",
    "choice_c": "Via her system logs",
    "choice_d": "All of the above",
    "correct_answer": "A",
    "explanation": "Endpoint detection and response (EDR) tools are most likely to use hashing to match known malicious files like this. Firewalls may provide the capability, but system logs do not, ruling out the \u201call of the above\u201d option.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      187,
      22,
      246,
      254,
      186
    ],
    "source": "9781394211395"
  },
  {
    "id": 1283,
    "question": "Which of the following tools is best suited to deploying and maintaining a secure baseline for Windows systems for an entire enterprise?",
    "choice_a": "PowerShell",
    "choice_b": "Group Policy",
    "choice_c": "Manual configuration",
    "choice_d": "Script\u2010based deployments",
    "correct_answer": "B",
    "explanation": "Group Policy is the most common way of deploying baselines throughout Windows organizations. Group Policy Objects (GPOs) are set and managed across the entire Active Directory organization, allowing them to be modified for groups or specific purposes while inheriting most settings from the top of the organizational structure. PowerShell is a scripting tool, and both PowerShell and Group Policy are commonly used for specific purposes, but GPOs are typically preferred at scale. Manual configuration is not recommended for an entire organization.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      196,
      194,
      92,
      93,
      144
    ],
    "source": "9781394211395"
  },
  {
    "id": 1284,
    "question": "Perry wants to ensure that an unsecure protocol is secured when in transit through his local network. What solution could he adopt to ensure that this traffic is protected?",
    "choice_a": "Use SD\u2010WAN.",
    "choice_b": "Wrap the protocol using TLS.",
    "choice_c": "Encrypt all files that are sent using AES.",
    "choice_d": "Encrypt all files that are sent using SHA\u20101.",
    "correct_answer": "B",
    "explanation": "A common technique to ensure that traffic sent via unsecure protocols remains secure is to wrap it using TLS. SD\u2010WAN is used to manage external connectivity, and there is no mention of files, only of an unsecure protocol. Even if files were encrypted, the rest of the traffic might leak information. Hashing does not leave data recoverable, making it unusable for this type of use in almost all cases.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      53,
      133,
      233,
      267,
      251
    ],
    "source": "9781394211395"
  },
  {
    "id": 1285,
    "question": "Annie wants to implement a passwordless authentication system. Which of the following would not meet her needs?",
    "choice_a": "Windows Hello",
    "choice_b": "A PIN\u2010based factor",
    "choice_c": "A cell\u2010phone authenticator application",
    "choice_d": "A FIDO2 security key",
    "correct_answer": "B",
    "explanation": "Passwordless authentication avoids making users provide a password or PIN by using a proof of identity from a device or token. Windows Hello, cell\u2010based authenticator applications, and FIDO2 security keys all support this, but entering a PIN does not.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      139,
      140,
      142,
      141,
      132
    ],
    "source": "9781394211395"
  },
  {
    "id": 1286,
    "question": "Laura wants to harden an ICS and SCADA devices her organization uses to manage critical infrastructure. The devices are old and unsupported, without recent updates. What hardening techniques are most likely to be available to her to help deal with these devices?",
    "choice_a": "Isolation",
    "choice_b": "Segmentation",
    "choice_c": "Adding host\u2010based firewalls",
    "choice_d": "Configuring host\u2010based IPS",
    "correct_answer": "B",
    "explanation": "Since ICS and SCADA devices need connectivity as part of their design, Laura knows that using segmentation to place the devices in a secure network is likely her best hardening option. Isolating the devices would break the functionality of ICS/SCADA systems. Neither ICS nor SCADA devices typically have support for host\u2010based firewalls or host\u2010based IPS.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      256,
      199,
      215,
      214,
      192
    ],
    "source": "9781394211395"
  },
  {
    "id": 1287,
    "question": "Bob uses an IoC feed to allow his SIEM to identify and correlate common malicious activity. What phase of the incident response process best describes this?",
    "choice_a": "Preparation",
    "choice_b": "Detection",
    "choice_c": "Containment",
    "choice_d": "Eradication",
    "correct_answer": "B",
    "explanation": "The detection and analysis phases of the incident response process both commonly leverage IoCs to detect and then correlate information to identify incidents. Preparation might involve setting up threat feeds and building automations to help notify security administrators of issues. Containment and eradication may leverage threat data to help understand common actions taken by threat actors, but the SIEM detecting and correlating events is not typically part of containment or eradication.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      240,
      22,
      246,
      249,
      248
    ],
    "source": "9781394211395"
  },
  {
    "id": 1288,
    "question": "Yael's organization has received a very convincing phishing email that has resulted in staff clicking on a malicious link. If Yael can't remove the email from inboxes, which of the following options will allow her to quickly prevent users from being compromised?",
    "choice_a": "Set up DNS filtering using the URL from the email.",
    "choice_b": "Disable the organization's Internet connection.",
    "choice_c": "Block inbound traffic from the phishing email's source IP.",
    "choice_d": "Enable reputation services for the email.",
    "correct_answer": "A",
    "explanation": "Enabling DNS filtering based on the URL from the email is the most effective option listed. Disabling the organization's Internet connection will result in additional disruption. Blocking the email's source IP for an already received email will not be effective, nor will enabling reputation services for email after the email has already been received.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      255,
      254,
      240,
      22,
      250
    ],
    "source": "9781394211395"
  },
  {
    "id": 1289,
    "question": "Nick is reviewing his system configurations and notes that logon event auditing settings on the system are set as shown in the example figure. What concern should he express about the setting? <img src=\"/question_assets/Security+/c04uf006.png\" alt=\"A screenshot of a window titled, audit account logon events properties. The local security setting tab is selected. Checkbox labeled, failure is selected. A warning message is displayed below. O K, cancel, and apply buttons are listed at the bottom.\"/>\n\n<figcaption>A screenshot of a window titled, audit account logon events properties. The local security setting tab is selected. Checkbox labeled, failure is selected. A warning message is displayed below. O K, cancel, and apply buttons are listed at the bottom.</figcaption> <p></p>",
    "choice_a": "Log files may fill up quickly.",
    "choice_b": "Successful authentication will not be logged.",
    "choice_c": "Failed authentication will not be logged.",
    "choice_d": "Policy may not be enforced properly.",
    "correct_answer": "B",
    "explanation": "Successful authentications will not be logged based on these settings. Having access to both successes and failures can be useful when investigating incidents, particularly if attackers have stolen credentials. Text\u2010based log files take up minimal space on most workstations and servers and should not be a significant concern. While the message notes that the policy may be overridden, Nick's primary concern should be missing log data.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      250,
      240,
      246,
      262,
      270
    ],
    "source": "9781394211395"
  },
  {
    "id": 1290,
    "question": "Brian is reviewing vulnerabilities discovered as part of a vulnerability scan. He sees a score for a vulnerability of 3.0. What does he know about this vulnerability based on its score?",
    "choice_a": "It is a high\u2010severity vulnerability and should be addressed quickly.",
    "choice_b": "It is a low\u2010severity vulnerability and may not need to be addressed.",
    "choice_c": "It is a medium\u2010severity vulnerability and should be reviewed before being addressed.",
    "choice_d": "It is a critical vulnerability and should be addressed immediately.",
    "correct_answer": "B",
    "explanation": "CVSS scores range from 0 to 10.0, with 10.0 being the most critical. A score of .1\u20133.9 is considered a low rating, meaning that Brian can take his time to review and remediate the risk. Scores of 4.0\u20136.9 are medium, 7.0\u20138.9 are high, and 9.0\u201310.0 are critical.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      46,
      47,
      48,
      40,
      45
    ],
    "source": "9781394211395"
  },
  {
    "id": 1291,
    "question": "Nick wants to allow email servers to validate that email from his servers is actually from them. What email security framework should he adopt to allow this?",
    "choice_a": "DKIM",
    "choice_b": "DMARC",
    "choice_c": "SPF",
    "choice_d": "SMTP",
    "correct_answer": "A",
    "explanation": "DKIM (DomainKeys Identified Mail) validates a domain's identity using a public key pair, validating the authenticity of the sender. DMARC (Domain\u2010based Message Authentication, Reporting, and Conformance) controls how unauthenticated messages are handled by mailbox providers, including quarantining, rejecting, or rejecting messages. The Sender Policy Framework (SPF) lists IP addresses of systems allowed to send email in DNS TXT records for a domain. STP is not an email security framework. The Simple Mail Transfer Protocol (SMTP) is the default email protocol.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      220,
      252,
      250,
      241,
      246
    ],
    "source": "9781394211395"
  },
  {
    "id": 1292,
    "question": "Jack wants to configure a Linux system to use mandatory access controls. What tool should he select that is commonly used to provide this functionality?",
    "choice_a": "Group Policy",
    "choice_b": "CIS benchmarks",
    "choice_c": "SELinux",
    "choice_d": "Containerization",
    "correct_answer": "C",
    "explanation": "SELinux is a Linux kernel module that provides a variety of security capabilities and access control methods, including support for MAC (mandatory access control) for Linux systems. Group Policy is a Windows tool, the CIS benchmarks provide security configuration recommendations for systems but do not directly provide mandatory access control, and containerization is used to make application installations portable.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      192,
      196,
      144,
      148,
      145
    ],
    "source": "9781394211395"
  },
  {
    "id": 1293,
    "question": "What process is commonly used with open source tools to ensure that dependencies are secure?",
    "choice_a": "Static analysis",
    "choice_b": "Package monitoring",
    "choice_c": "Fagan testing",
    "choice_d": "Port scanning",
    "correct_answer": "B",
    "explanation": "Package monitoring tools review the dependencies and packages that make up open source tools to identify vulnerable components. Static analysis is manual review of code. Fagan testing is a formal code analysis process. Port scanning is not used to monitor for dependency security.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      49,
      63,
      197,
      41,
      47
    ],
    "source": "9781394211395"
  },
  {
    "id": 1294,
    "question": "Yarif wants to harden his SaaS cloud infrastructure. Which of the following hardening techniques is he most likely to be able to implement in an SaaS environment?",
    "choice_a": "Host\u2010based firewalls",
    "choice_b": "Least privilege",
    "choice_c": "Operating system security configuration",
    "choice_d": "Physical security for systems",
    "correct_answer": "B",
    "explanation": "SaaS environments allow customers to manage information, data, devices, accounts, and identities. That means that ensuring least privilege is used is possible through use of accounts and identities. Host\u2010based firewalls, OS configurations, and physical security are all the responsibility of the SaaS provider.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      171,
      145,
      144,
      148,
      52
    ],
    "source": "9781394211395"
  },
  {
    "id": 1295,
    "question": "Which of the following is not a technical control used to address a vulnerability?",
    "choice_a": "Insurance",
    "choice_b": "Patching",
    "choice_c": "Segmentation",
    "choice_d": "Firewalling",
    "correct_answer": "A",
    "explanation": "Unlike the other controls listed, insurance simply transfers the risk to another organization at a cost. It does not take any action to prevent the risk from occurring. Patching, segmentation, and firewalling are all technical controls.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      47,
      46,
      93,
      254,
      148
    ],
    "source": "9781394211395"
  },
  {
    "id": 1296,
    "question": "Kelsey's organization has established an asset and inventory management process for servers. Which of the following is not a common part of asset tracking?",
    "choice_a": "Data classification",
    "choice_b": "Identifying owners",
    "choice_c": "Documenting acquisition dates",
    "choice_d": "Sanitization",
    "correct_answer": "D",
    "explanation": "Sanitization is part of decommissioning and disposal processes, not asset management. Tracking data classification used on systems, identifying owners, and documenting acquisition dates for warranty and life\u2010cycle tracking are all common parts of this process.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      206,
      207,
      188,
      209,
      208
    ],
    "source": "9781394211395"
  },
  {
    "id": 1297,
    "question": "Kirk needs to allow system administrators to access root passwords in emergencies. What type of solution could he implement to allow them to check out passwords when needed while also tracking those checkouts and requiring the passwords to be changed after use?",
    "choice_a": "EAP",
    "choice_b": "Multifactor authentication",
    "choice_c": "An enterprise password manager",
    "choice_d": "Passwordless",
    "correct_answer": "C",
    "explanation": "Enterprise password managers provide functionality just like this, allowing passwords to be stored securely and tracked on use. EAP is an authentication protocol; multifactor authentication adds one or more factors, increasing security, but doesn't provide the functionality described; and passwordless isn't designed for a checkout and reset function.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      145,
      138,
      140,
      133,
      143
    ],
    "source": "9781394211395"
  },
  {
    "id": 1298,
    "question": "Selah wants to prevent staff in her organization from visiting malicious websites while they're in the office. If she wants to use the most up\u2010to\u2010date threat data, what web filter capability should she take advantage of?",
    "choice_a": "Agent\u2010based web filtering",
    "choice_b": "Reputation tools",
    "choice_c": "A centralized web filtering proxy",
    "choice_d": "URL scanning",
    "correct_answer": "B",
    "explanation": "Using threat data from reputation tools will best fit Selah's needs. Agent\u2010based web filtering is used when systems will be mobile or connected to networks that are not controlled centrally. Centralized web filtering proxies and URL scanning are useful general controls, but reputation tools answer the specific need more directly.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      22,
      20,
      21,
      255,
      186
    ],
    "source": "9781394211395"
  },
  {
    "id": 1299,
    "question": "Joe has configured ACLs on a Cisco network device. The ACL he has configured is as follows: <br> <code>interface ethernet0</code> <br> <code> ip access-group 111 in</code> <br> <code>!</code> <br> <code>access-list 111 deny tcp any any eq http</code> <br> <code>access-list 111 permit ip any any</code> <br> <code>access-list 111 deny tcp any any eq https</code> <br>What does this ACL do?",
    "choice_a": "Blocks HTTP traffic",
    "choice_b": "Blocks both HTTP and HTTPS traffic",
    "choice_c": "Prevents web application attacks",
    "choice_d": "Allows for inspection of web traffic",
    "correct_answer": "A",
    "explanation": "ACLs are interpreted in the order they are listed. This ACL is not properly written if it is intended to block HTTPS because the ACL order includes a rule that allows any traffic after the rule that blocks HTTP is processed. This means that traffic will first be checked to see if it is HTTP traffic. If it is not, it will be allowed, and thus will bypass the HTTPS block. It will not prevent web application attacks since HTTPS can pass the ACL, and no specific configuration is set for inspection of web traffic.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      191,
      254,
      249,
      250,
      267
    ],
    "source": "9781394211395"
  },
  {
    "id": 1300,
    "question": "The use of machine learning and algorithms to analyze user behavior in order to identify anomalous behavior is a feature of what specialized type of tool?",
    "choice_a": "UEBA",
    "choice_b": "SIEM",
    "choice_c": "EDR",
    "choice_d": "DMARC",
    "correct_answer": "A",
    "explanation": "User and entity behavior analytics (UEBA) tools are specifically designed to use behavior\u2010based analytic tools leveraging machine learning and algorithmic analysis. SIEM is used to correlate events and log data as part of ongoing monitoring. EDR focuses on malicious behavior detection on endpoints. DMARC is used for email security.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      246,
      187,
      188,
      220,
      48
    ],
    "source": "9781394211395"
  },
  {
    "id": 1301,
    "question": "What password best practice is supported by the ability to set password history in Windows?",
    "choice_a": "Password length",
    "choice_b": "Password complexity",
    "choice_c": "Password reuse",
    "choice_d": "Password age",
    "correct_answer": "C",
    "explanation": "Password history is intended to prevent password reuse in Windows. It is commonly paired with a minimum password age to prevent users from simply resetting their password multiple times until they can reuse their password, and a longer history is used to make this more difficult too. It does not influence password length or complexity.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      194,
      137,
      148,
      143,
      208
    ],
    "source": "9781394211395"
  },
  {
    "id": 1302,
    "question": "Donna is reviewing a script that was found on a Windows system. What does the following script do? <br> <code>$ip = \"10.1.1.101\"</code> <br> <code>$svc_name = \"WinDefend\"</code> <br> <code>get-service -ComputerName $ip | Where-Object {$_.Name -eq $svc_name} | Stop-Service | Set-Service -StartupType Disabled</code> <br>",
    "choice_a": "Stops the Windows Defender service",
    "choice_b": "Starts the Windows Defender service",
    "choice_c": "Stops and disables the Windows Defender service",
    "choice_d": "Enables the Windows Defender service",
    "correct_answer": "C",
    "explanation": "This script will stop and disable the Windows Defender service on a system with IP address 10.1.1.101. You can identify both the <code>Stop\u2010Service</code> and <code>StartupType Disabled</code> values in the script to determine what it is likely to do. It does not start Windows Defender, nor does it enable the service.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      192,
      194,
      240,
      186,
      254
    ],
    "source": "9781394211395"
  },
  {
    "id": 1303,
    "question": "Batu has been asked to build scripts that will allow automated ticket creation through a new help desk tool for his organization. As he considers the lifespan of the scripts, which of the following concerns should he address to ensure that the scripts do not become an issue over time?",
    "choice_a": "Their initial creation cost",
    "choice_b": "Their ongoing supportability",
    "choice_c": "Existing technical debt",
    "choice_d": "Whether they're a single point of failure",
    "correct_answer": "B",
    "explanation": "Since Batu has been asked to consider the lifespan of the scripts, ensuring that they're supportable in an ongoing manner is the biggest concern. Initial cost is typically small compared to the ongoing benefit of scripts like these. Existing technical debt is not a major concern for automated ticket creation with a new tool, and while having a single point of failure can be a concern, automated ticket outages are a point\u2010in\u2010time concern not a lifetime\u2010centered concern.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      92,
      93,
      178,
      66,
      144
    ],
    "source": "9781394211395"
  },
  {
    "id": 1304,
    "question": "Alex is responsible for his organization's vulnerability management program. A recent vulnerability scan shows that IoT devices that are used for building automation are vulnerable to a known issue with their built\u2010in web server. After reviewing the manufacturer's website, Alex is unable to find an updated operating system or software update. He chooses to move the IoT devices to a protected VLAN and require a jump server to access them. What vulnerability remediation option has he used?",
    "choice_a": "A compensating control",
    "choice_b": "Patching",
    "choice_c": "Insurance",
    "choice_d": "An exemption",
    "correct_answer": "A",
    "explanation": "Alex has used a compensating control because he cannot remediate the underlying vulnerability. This reduces the risk by preventing the devices from being available on the network to untrusted devices and users. He cannot patch, no insurance was purchased, and no exemption was granted or registered.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      51,
      199,
      47,
      46,
      214
    ],
    "source": "9781394211395"
  },
  {
    "id": 1305,
    "question": "Wiping a drive and reinstalling from known good media is an example of what incident response option?",
    "choice_a": "Recovery",
    "choice_b": "Containment",
    "choice_c": "Eradication",
    "choice_d": "Root cause elimination",
    "correct_answer": "C",
    "explanation": "Eradication efforts focus on completely removing all artifacts of a compromise or event. Wiping drives to ensure that no remnant malware or other artifacts remain, then reinstalling using known good media are examples of eradication processes. Restoring the system to service after it has been remediated occurs after eradication. Containment efforts attempt to limit the potential spread or ongoing impact of an incident, and root cause analysis is used to determine the underlying causes of an issue, incident, or event. Root cause elimination is not a commonly used term for this.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      240,
      207,
      259,
      254,
      242
    ],
    "source": "9781394211395"
  },
  {
    "id": 1306,
    "question": "Melissa's company wants to contract with a third\u2010party organization to oversee their hardware decommissioning and disposal process. What should she ask the company to do to prove that the disposal process was done properly?",
    "choice_a": "Certification.",
    "choice_b": "Follow a data retention policy.",
    "choice_c": "Provide photographic evidence.",
    "choice_d": "Keep a log of devices.",
    "correct_answer": "A",
    "explanation": "Certification of destruction can include photographic evidence, logs, and other data that demonstrate the disposal contract was followed. Data retention policies are applied internally, not to third\u2010party companies that are contracted for disposal.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      208,
      207,
      270,
      242,
      48
    ],
    "source": "9781394211395"
  },
  {
    "id": 1307,
    "question": "Sally wants to identify a way to prioritize vulnerabilities discovered by her vulnerability scanner. Which of the following options will allow her to prioritize vulnerabilities effectively while taking her own organization's needs into account?",
    "choice_a": "Use CVSS base and temporal metrics.",
    "choice_b": "Use a qualitative risk assessment process.",
    "choice_c": "Use CVSS scores that include environmental metrics.",
    "choice_d": "Use a quantitative risk assessment process.",
    "correct_answer": "C",
    "explanation": "CVSS environmental scores help organizations take their own requirements and risks into account. That means that Sally can use numeric scores to prioritize risk while using her organization's needs and unique threat model. Qualitative and quantitative risk assessments are useful, but they are not as well suited to leveraging data from a vulnerability scanner in a timely manner.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      46,
      47,
      63,
      40,
      21
    ],
    "source": "9781394211395"
  },
  {
    "id": 1308,
    "question": "Henry wants to prevent password reuse outside of his organization from impacting the accounts his staff use. Which of the following password settings can have the largest impact if passwords are reused outside of his organization and they are breached due to a security issue at the third\u2010party site or service?",
    "choice_a": "Password expiration policies",
    "choice_b": "Password length policies",
    "choice_c": "Password complexity policies",
    "choice_d": "Password minimum age policies",
    "correct_answer": "A",
    "explanation": "Password expiration polices help reduce the length of time a password could be exposed for. Henry knows that if his staff change their password periodically that it can help avoid issues with reuse on other sites. He also knows that multifactor is a more effective solution and that he should focus his time there as well. Password length and complexity don't matter if the password was compromised elsewhere, and minimum age policies are used to prevent reuse in the organization by resetting passwords over and over again to return to an original desired password. Note that policies like this don't stop reuse outside of a user's organization on 3<sup>rd</sup> party sites!",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      194,
      140,
      138,
      144,
      93
    ],
    "source": "9781394211395"
  },
  {
    "id": 1309,
    "question": "Fuzzing is an example of what type of code analysis?",
    "choice_a": "Static analysis",
    "choice_b": "Code review",
    "choice_c": "Pentesting",
    "choice_d": "Dynamic analysis",
    "correct_answer": "D",
    "explanation": "Fuzzing, the process of feeding unexpected and random input to programs to see how they behave, is an example of dynamic analysis where the code is actually run to test it. Static analysis involves reviewing the code, as does code review. Fuzzing is typically done as part of software testing rather than penetration testing, but it may be used by pentesters.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      49,
      85,
      65,
      240,
      242
    ],
    "source": "9781394211395"
  },
  {
    "id": 1310,
    "question": "Steve's organization is concerned about the potential for devices they are purchasing to be modified before they reach the organization. Which of the following solutions will help the most in preventing this potential issue?",
    "choice_a": "Buying from a value\u2010added reseller",
    "choice_b": "Buying directly from the OEM",
    "choice_c": "Buying from a gray market seller",
    "choice_d": "Buying from a local reseller",
    "correct_answer": "B",
    "explanation": "Ensuring supply chain security can be challenging, but buying directly from a vendor can remove opportunities for devices to be modified. Trusted value\u2010added resellers are the second best choice. Buying from the gray market or a reseller typically adds additional opportunities for device modification.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      171,
      93,
      207,
      144,
      41
    ],
    "source": "9781394211395"
  },
  {
    "id": 1311,
    "question": "What password setting has the greatest impact when attempting to prevent brute\u2010force password cracking?",
    "choice_a": "Password history settings",
    "choice_b": "Password length increases",
    "choice_c": "Password expiration settings",
    "choice_d": "Password length decreases",
    "correct_answer": "B",
    "explanation": "Increasing password length makes it harder to crack. Decreasing the password length would make passwords easier to crack. History and expiration do not influence brute\u2010force attacks unless the expiration happens to land during the time the password cracking was attempted.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      137,
      194,
      140,
      143,
      144
    ],
    "source": "9781394211395"
  },
  {
    "id": 1312,
    "question": "Jill wants to identify a potential network\u2010based distributed denial\u2010of\u2010service (DDoS) attack. Which of the following log sources is most likely to provide information that will allow her to identify the attack?",
    "choice_a": "OS\u2010specific security logs",
    "choice_b": "Endpoint logs",
    "choice_c": "IDS/IPS logs",
    "choice_d": "Authentication logs",
    "correct_answer": "C",
    "explanation": "IDS and IPS devices are the only network security device in this list. Other common logs used to identify potential DDoS attacks include network logs and firewall logs. Application and web server logs may be useful if the DDoS is associated with an application. OS\u2010specific security logs, endpoint logs, and authentication logs are not typical places to find useful information for a network\u2010based DDoS attack.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      219,
      250,
      246,
      247,
      267
    ],
    "source": "9781394211395"
  },
  {
    "id": 1313,
    "question": "Jake has configured WPA3 Personal for his network. What feature makes WPA3 more secure than WPA2's PSK mode?",
    "choice_a": "SAE",
    "choice_b": "PKI",
    "choice_c": "TLS",
    "choice_d": "EAP",
    "correct_answer": "A",
    "explanation": "SAE (Simultaneous Authentication of Equals) provides a secure authentication mode that replaced WPA2's preshared key session key negotiation process. PKI is public key encryption and is not the solution in use. TLS is Transport Layer Security, used to encrypt data in motion, and EAP is an authentication protocol.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      214,
      133,
      54,
      216,
      238
    ],
    "source": "9781394211395"
  },
  {
    "id": 1314,
    "question": "Molly wants to harden embedded systems in her environment. Which of the following options is most likely to be available?",
    "choice_a": "Hardening benchmarks.",
    "choice_b": "Central management tools.",
    "choice_c": "Add\u2010on security software.",
    "choice_d": "None; embedded systems have very limited hardening options.",
    "correct_answer": "D",
    "explanation": "Embedded systems typically have few, if any hardening options because of their purpose\u2010built functionality. Benchmarks are rarely available for them, and most are not designed for central management or adding on security software.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      199,
      192,
      51,
      194,
      236
    ],
    "source": "9781394211395"
  },
  {
    "id": 1315,
    "question": "Jean wants to use an identity proofing process as part of her user account creation process. Which of the following is most likely to be useful for identity proofing?",
    "choice_a": "A Google email account",
    "choice_b": "A state or nationally issued ID",
    "choice_c": "A Facebook account",
    "choice_d": "A credit card",
    "correct_answer": "B",
    "explanation": "Identity proofing uses information about a user to prove that they are who they claim to be. A state or nationally issued ID is a better proof than a Facebook or Google account which can be created under any name without validation. Credit cards are not a form of identity.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      144,
      132,
      136,
      139,
      142
    ],
    "source": "9781394211395"
  },
  {
    "id": 1316,
    "question": "The company that Scott works for has experienced a data breach, and the personal information of thousands of customers has been exposed. Which of the following impact categories is not a concern as described in this scenario?",
    "choice_a": "Reputation",
    "choice_b": "Financial",
    "choice_c": "Availability loss",
    "choice_d": "Data loss",
    "correct_answer": "C",
    "explanation": "This description does not include any risk to availability since there is no information about systems or services being down or offline. This scenario would likely result in reputational, financial, and data loss impacts for Scott's company.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      3,
      307,
      306,
      312,
      310
    ],
    "source": "9781394211395"
  },
  {
    "id": 1317,
    "question": "Sameer wants to assess whether the key risk indicators (KRIs) his team have suggested are appropriate for his organization. Which of the following is not a common characteristic of a useful KRI?",
    "choice_a": "Actionable",
    "choice_b": "Measurable",
    "choice_c": "Relevant",
    "choice_d": "Inexpensive",
    "correct_answer": "D",
    "explanation": "KRIs, or key risk indicators, need to be actionable so that the organization can use them to control or manage risk, they need to be measurable so that they can be assessed, and they must be relevant to the risks that they measure. They don't necessarily have to be inexpensive, as organizations may make choices about costs based on their risks and business models.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      310,
      313,
      309,
      312,
      305
    ],
    "source": "9781394211395"
  },
  {
    "id": 1318,
    "question": "Jill's organization wants to ensure that services and systems are back online and functioning normally within 4 hours of an event or incident. What term best describes this goal?",
    "choice_a": "An RTO",
    "choice_b": "An MTTR",
    "choice_c": "An RPO",
    "choice_d": "An MTBF",
    "correct_answer": "A",
    "explanation": "A recovery time objective (RTO) is set by organizations to describe how long restoring systems or services to normal function after a disruption can take. Mean time to repair (MTTR) is the average time it takes to repair a system or device. A recovery point objective (RPO) describes how much data can be lost in the event of an outage or issue, and the mean time between failures (MTBF) is a measure of the reliability of a system. It is the expected amount of time that will elapse between system failures.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      310,
      312,
      309,
      313,
      297
    ],
    "source": "9781394211395"
  },
  {
    "id": 1319,
    "question": "Eric's organization has created a policy document that describes how users can and cannot use the organization's network, systems, and services. What type of policy has he created?",
    "choice_a": "Business continuity policy.",
    "choice_b": "An acceptable use policy.",
    "choice_c": "An incident response policy.",
    "choice_d": "This is a standard, not a policy.",
    "correct_answer": "B",
    "explanation": "Acceptable use policies (AUPs) describe how and what users can use organizational resources, systems, and services for. Business continuity policies describe how an organization approaches business continuity, and incident response policies focus on how organizations respond to incidents. A standard acts as the rules to achieve an intent, while policies describe the organization's intent. This policy describes intent, not specific implementations.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      276,
      275,
      277,
      279,
      273
    ],
    "source": "9781394211395"
  },
  {
    "id": 1320,
    "question": "Angie is performing a penetration test and has gathered information using the Shodan search engine about her target. What type of reconnaissance has she performed?",
    "choice_a": "Active",
    "choice_b": "Commercial",
    "choice_c": "Scanner\u2010based",
    "choice_d": "Passive",
    "correct_answer": "D",
    "explanation": "Angie has conducted passive reconnaissance. She did not perform a scan or otherwise take direct active action to gather her information. Instead, she used the existing Shodan engine to gather information. While Shodan is a commercial product and does gather information using scans, databases like Shodan are considered passive reconnaissance, and the Security+ exam objectives recognize two types of reconnaissance: active and passive.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      57,
      58,
      61,
      288,
      290
    ],
    "source": "9781394211395"
  },
  {
    "id": 1321,
    "question": "What role do data processors have in an organization?",
    "choice_a": "They determine how data is processed.",
    "choice_b": "They own the data.",
    "choice_c": "They process data on behalf of a controller.",
    "choice_d": "They contract with third parties to use the data.",
    "correct_answer": "C",
    "explanation": "Data processors do just that\u2014they process the data on behalf of a data controller, who determines how data is processed and what purposes it is used for. They do not own the data, and they are typically contracted to process the data rather than contracting with third parties themselves.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      317,
      292,
      287,
      273,
      280
    ],
    "source": "9781394211395"
  },
  {
    "id": 1322,
    "question": "Ginger's personal data is used by an organization, including identifiable information like her name, address, and Social Security number. What term best describes Ginger?",
    "choice_a": "Data owner",
    "choice_b": "Data controller",
    "choice_c": "Data processor",
    "choice_d": "Data subject",
    "correct_answer": "D",
    "explanation": "Ginger is a data subject, a person who can be identified by her personally identifiable information (PII). Data owners are responsible for protection, usage, and quality of datasets. Data controllers determine how data will be used, and processors do the actual data processing.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      317,
      292,
      3,
      286,
      273
    ],
    "source": "9781394211395"
  },
  {
    "id": 1323,
    "question": "Hong's company conducts regular risk assessments. As part of their assessment process, they gather a team of experts who assess risks on a scale from low to high based on their knowledge and experience. What type of risk assessment is Hong's company conducting?",
    "choice_a": "Ad hoc",
    "choice_b": "Quantitative",
    "choice_c": "Qualitative",
    "choice_d": "Continuous",
    "correct_answer": "C",
    "explanation": "Qualitative risk assessment uses knowledge and expertise to assess risk rather than assigning numeric values and calculations like a quantitative assessment process would. Ad hoc risk assessment is done when risks need to be assessed for a specific, immediate need unlike the planned, regular risk assessments described. Continuous risk assessment is ongoing, whereas this is conducted regularly.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      307,
      306,
      305,
      314,
      309
    ],
    "source": "9781394211395"
  },
  {
    "id": 1324,
    "question": "How is likelihood measured in qualitative risk assessments?",
    "choice_a": "A scale like high, medium, low",
    "choice_b": "A numeric scale from 0 to 1",
    "choice_c": "By calculating loss events per year",
    "choice_d": "A numeric scale from 1 to 100",
    "correct_answer": "A",
    "explanation": "Qualitative risk assessments measure likelihood on a descriptive scale like high, medium, or low. Quantitative assessments measure likelihood on a numeric scale using known event occurrence rates where possible.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      307,
      306,
      310,
      314,
      313
    ],
    "source": "9781394211395"
  },
  {
    "id": 1325,
    "question": "Grace wants to establish a governance structure that will leverage third\u2010party experts who are paid by her organization. What governance structure should she select?",
    "choice_a": "Board\u2010based",
    "choice_b": "Committee\u2010based",
    "choice_c": "Government\u2010based",
    "choice_d": "Market\u2010based",
    "correct_answer": "A",
    "explanation": "Boards often include external members who may have industry or other experience and expertise that will benefit the organization, and they are sometimes, but not always, paid as part of their work on the board. Committees are frequently composed of internal staff; government\u2010based governance occurs through laws or as part of public service. Market\u2010based is not a type of governance outlined by the Security+ exam objectives.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      272,
      273,
      287,
      290,
      276
    ],
    "source": "9781394211395"
  },
  {
    "id": 1326,
    "question": "Carmen's organization wants to purchase cybersecurity insurance to offset the cost of potential breaches. What risk management strategy has her organization adopted?",
    "choice_a": "Transfer",
    "choice_b": "Accept",
    "choice_c": "Avoid",
    "choice_d": "Mitigate",
    "correct_answer": "A",
    "explanation": "Risk transfer options move the costs of risks to another organization such as through insurance. Acceptance involves management acknowledging that the risk and its impacts may occur, and that the organization will move forward despite that chance. Avoidance seeks to prevent the risk from occurring. Mitigation works to limit the impact of a risk.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      309,
      313,
      306,
      310,
      311
    ],
    "source": "9781394211395"
  },
  {
    "id": 1327,
    "question": "Marissa has been recruited to a group that provides oversight for an organization but that doesn't engage in the day\u2010to\u2010day operations of the organization. The group focuses on strategy and direction for the organization and meets a few times a year. What type of governance group is Marissa part of?",
    "choice_a": "An activist investor's group",
    "choice_b": "A committee",
    "choice_c": "A board",
    "choice_d": "A regulator",
    "correct_answer": "C",
    "explanation": "Boards provide strategic oversight and direction for organizations. Boards may form subcommittees to accomplish specific tasks or to provide oversight over specific areas. Regulators oversee an industry based on law. Activist investor's groups are not covered by the exam, but typically they own stock in an organization and seek to direct the organization through their activism and stock ownership.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      272,
      273,
      274,
      276,
      293
    ],
    "source": "9781394211395"
  },
  {
    "id": 1328,
    "question": "Governance at Selah's organization is delegated to business units. This allows the units to determine how to balance their operational needs against their governance processes. What type of governance is this?",
    "choice_a": "Centralized",
    "choice_b": "Board\u2010based",
    "choice_c": "Decentralized",
    "choice_d": "Committee\u2010based",
    "correct_answer": "C",
    "explanation": "This governance approach is a decentralized approach with each unit or area providing their own governance. While flexible, this can be problematic because of a lack of consistency and overhead due to unique circumstances and requirements. Centralized designs do not delegate authority and instead place authority in a central place, organization, or individual. There is no mention of a board or committee.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      274,
      273,
      276,
      280,
      296
    ],
    "source": "9781394211395"
  },
  {
    "id": 1329,
    "question": "Sharon's organization wants to understand the risks that it will experience due to acquiring a new subsidiary, but it needs to conduct the assessment quickly while leveraging their industry expertise. Which of the following risk assessment options should Sharon recommend to address this need?",
    "choice_a": "Conduct an ad hoc risk assessment.",
    "choice_b": "Conduct a one\u2010time risk assessment.",
    "choice_c": "Conduct a third\u2010party risk assessment.",
    "choice_d": "Build a continuous risk assessment process.",
    "correct_answer": "B",
    "explanation": "A one\u2010time risk assessment that addresses the acquisition will best meet Sharon's needs. Ad hoc assessments are less formal, and they are often used to quickly assess a system or other potential risk. There is no requirement listed for third\u2010party assessment, and they can be both expensive and time\u2010consuming. Continuous risk assessment efforts are typically built into ongoing processes and are not suited to this type of one\u2010time review.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      305,
      310,
      287,
      304,
      309
    ],
    "source": "9781394211395"
  },
  {
    "id": 1330,
    "question": "What term describes a third party that takes actions on behalf of a data controller?",
    "choice_a": "Data subject",
    "choice_b": "Data owner",
    "choice_c": "Data processor",
    "choice_d": "Data administrator",
    "correct_answer": "C",
    "explanation": "Data processors process data on behalf of controllers. Data subjects are the individuals or organizations that data describes. Data owners create and are responsible for data, and data administrator is not a broadly or consistently used term in this context.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      317,
      287,
      289,
      290,
      58
    ],
    "source": "9781394211395"
  },
  {
    "id": 1331,
    "question": "Which of the following will provide a customer the opportunity to engage a third party to deliver an SOC 2, Type 1 report created by third\u2010party assessors?",
    "choice_a": "A penetration testing agreement",
    "choice_b": "A risk assessment agreement",
    "choice_c": "A vulnerability scan clause",
    "choice_d": "A right\u2010to\u2010audit clause",
    "correct_answer": "D",
    "explanation": "Right\u2010to\u2010audit clauses provide customers with the right to have an audit of their vendor like an SOC 2, Type 1 assessment performed. SOC 2, Type 1 reports are not penetration testing reports, vulnerability scan reports, or risk assessment reports.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      288,
      289,
      290,
      287,
      293
    ],
    "source": "9781394211395"
  },
  {
    "id": 1332,
    "question": "Isaac has been asked to be his organization's data owner for customer data. Which of the following is not a typical part of that role?",
    "choice_a": "Processing the data",
    "choice_b": "Classifying data",
    "choice_c": "Protecting data",
    "choice_d": "Ensuring the quality of the data",
    "correct_answer": "A",
    "explanation": "Data owners are responsible for data, including classifying it, protecting it, overseeing the use of it, and ensuring the quality of the overall data. They are not, however, responsible for directly processing the data.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      317,
      292,
      298,
      276,
      277
    ],
    "source": "9781394211395"
  },
  {
    "id": 1333,
    "question": "Pedro's organization uses industrial machinery, which runs an RTOS that is no longer supported. His organization's policies require systems to be removed from service if they cannot be patched for security issues, and the RTOS has a known vulnerability. The machines are very expensive and are a core part of the organization's industrial processes. What risk process would Pedro follow if he wanted to retain the devices, despite the risk?",
    "choice_a": "Transfer the risk.",
    "choice_b": "Seek an exception.",
    "choice_c": "Document the risk.",
    "choice_d": "Mitigate the risk.",
    "correct_answer": "B",
    "explanation": "Risk exceptions are granted when a risk is accepted by the organization, despite not following typical organizational policies or processes. This is not a transfer or mitigation, and simply documenting the risk does not cause it to be accepted.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      309,
      280,
      313,
      312,
      276
    ],
    "source": "9781394211395"
  },
  {
    "id": 1334,
    "question": "Jake's team has begun handling new data related to customers, including their personally identifiable information. Jake takes on a new role that has responsibilities including classifying each data element gathered about customers. What is Jake's role in the data handling process?",
    "choice_a": "Controller",
    "choice_b": "Custodian",
    "choice_c": "Owner",
    "choice_d": "Processor",
    "correct_answer": "C",
    "explanation": "Data owners classify, protect, oversee the use of, and ensure the quality of data. Controllers are responsible for the procedures and purposes of data use, often described as the why and how. Custodians are the staff and teams who handle data, and processors work with data on behalf of a controller.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      317,
      273,
      275,
      276,
      300
    ],
    "source": "9781394211395"
  },
  {
    "id": 1335,
    "question": "Which of the following measures is not commonly used as part of a business impact analysis?",
    "choice_a": "RTO",
    "choice_b": "MTTR",
    "choice_c": "ARO",
    "choice_d": "MTBF",
    "correct_answer": "C",
    "explanation": "There are four commonly used business impact analysis (BIA) measures that are part of the Security+ exam objectives: recovery time objectives (RTOs), recovery point objectives (RPOs), mean time to repair (MTTR), and mean time between failures (MTBF). ARO, or annual rate of occurrence, is associated with risk assessment, not BIA.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      310,
      305,
      306,
      312,
      314
    ],
    "source": "9781394211395"
  },
  {
    "id": 1336,
    "question": "As part of her organization's marketing efforts, Julie's team gathers information about customers and others who visit their website. Julie has engaged an analytics company that uses the data gathered to identify trends and potential new market opportunities. What data role does this third\u2010party company play?",
    "choice_a": "Data owner",
    "choice_b": "Data processor",
    "choice_c": "Data controller",
    "choice_d": "Data custodian",
    "correct_answer": "B",
    "explanation": "Data processors process data for data controllers. In this scenario, Julie or a member of her staff is the data controller and the third\u2010party organization is a processor. They do not own the data, and they are not custodians who are responsible for the data on an ongoing basis.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      317,
      287,
      288,
      290,
      289
    ],
    "source": "9781394211395"
  },
  {
    "id": 1337,
    "question": "Neil's organization has signed a contract that includes guarantees of 99.9 percent uptime. What type of agreement has Neil's organization created?",
    "choice_a": "An MSA",
    "choice_b": "An NDA",
    "choice_c": "A MTBF",
    "choice_d": "An SLA",
    "correct_answer": "D",
    "explanation": "Service level agreements (SLAs) set forth the expected service level as well as penalties for nonperformance. A master services agreement (MSA) is a broad agreement that additional work may be performed under. An NDA, or nondisclosure agreement, sets forth what information may and may not be shared or disclosed. The mean time between failures (MTBF) is a measure of the reliability of a system. It is the expected amount of time that will elapse between system failures.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      289,
      290,
      287,
      58,
      57
    ],
    "source": "9781394211395"
  },
  {
    "id": 1338,
    "question": "Which of the following best describes a data controller?",
    "choice_a": "Manages the flow of data between custodians",
    "choice_b": "Creates and formats data when it is collected or created",
    "choice_c": "Any system that handles data",
    "choice_d": "Determines the purpose and methods of processing data",
    "correct_answer": "D",
    "explanation": "Data controllers determine the purpose and methods of data processing. They may be individuals, groups, or organizations. This is defined by the General Data Protection Regulation (GDPR). That may involve how data flows, and the formats or other details of data, but the best\u2014and legally defined\u2014role of a controller is the one set by the GDPR.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      317,
      292,
      320,
      276,
      275
    ],
    "source": "9781394211395"
  },
  {
    "id": 1339,
    "question": "As part of his role, Augie is responsible for implementation of business rules related to data, as well as for storage, and use of data and datasets. What data\u2010related role does Augie hold?",
    "choice_a": "Data owner",
    "choice_b": "Data custodian",
    "choice_c": "Data processor",
    "choice_d": "Data subject",
    "correct_answer": "B",
    "explanation": "Augie is a data custodian. In this role he is responsible for data's use in the business, including storing and properly handling data. Data owners are responsible and accountable for data as well as ensuring that custodians and others are handling the data appropriately. Data processors do actual data processing, and may be an individual, organization, or group. Data subjects are the people who the data describes or is about.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      317,
      320,
      292,
      276,
      275
    ],
    "source": "9781394211395"
  },
  {
    "id": 1340,
    "question": "Which of the following penalties is most typically imposed on a country rather than on a company?",
    "choice_a": "Fines",
    "choice_b": "Loss of license",
    "choice_c": "Sanctions",
    "choice_d": "Mandatory reporting",
    "correct_answer": "C",
    "explanation": "Sanctions are typically applied to countries rather than companies or individuals. Fines and loss of license are typically aimed at companies and individuals, and mandatory reporting is not a penalty included in the Security+ exam.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      292,
      4,
      294,
      309,
      313
    ],
    "source": "9781394211395"
  },
  {
    "id": 1341,
    "question": "Which of the following is not a commonly used term to describe risk appetite?",
    "choice_a": "Intentional",
    "choice_b": "Neutral",
    "choice_c": "Expansionary",
    "choice_d": "Conservative",
    "correct_answer": "A",
    "explanation": "Terms used for risk appetite in the Security+ exam objectives include conservative, neutral, and expansionary. Intentional is not a term used for risk appetite.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      313,
      309,
      310,
      304,
      305
    ],
    "source": "9781394211395"
  },
  {
    "id": 1342,
    "question": "What does a data steward do?",
    "choice_a": "Create data.",
    "choice_b": "Carry out data use and security policies.",
    "choice_c": "Explain compliance requirements for data.",
    "choice_d": "Oversee data throughout its life cycle.",
    "correct_answer": "B",
    "explanation": "Data stewards are responsible for the data in their charge. That means they carry out data usage and security policies and ensure that data is handled appropriately. Creating data is typically done by data owners, who also explain and set data security policies. Multiple roles oversee data throughout its life cycle, not just a data steward.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      317,
      276,
      275,
      298,
      280
    ],
    "source": "9781394211395"
  },
  {
    "id": 1343,
    "question": "Marcus determines what organizationally owned data is used for a given purpose and how it is processed. What data role does he have in his organization?",
    "choice_a": "He is a data controller.",
    "choice_b": "He is a supervisory authority.",
    "choice_c": "He is a data protection officer.",
    "choice_d": "He is a data processor.",
    "correct_answer": "A",
    "explanation": "Data controllers determine what data is used and how it is processed. Supervisory authorities are public authorities in the European Union (EU) that monitor for compliance with the General Data Protection Regulation (GDPR). Data protection officers are required by the GDPR and oversee data protection strategies and their implementation. Data processors do just that\u2014they process the data on behalf of a data controller who determines how data is processed and what purposes it is used for. They do not own the data, and are typically contracted to process the data rather than contracting with third parties themselves.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      317,
      292,
      320,
      273,
      276
    ],
    "source": "9781394211395"
  },
  {
    "id": 1344,
    "question": "Colleen's organization has deployed web application firewalls (WAFs) to protect their web services from being impacted by a known SQL injection attack. What risk management strategy has the organization adopted?",
    "choice_a": "Transfer",
    "choice_b": "Accept",
    "choice_c": "Avoid",
    "choice_d": "Mitigate",
    "correct_answer": "C",
    "explanation": "Avoidance seeks to prevent the risk from occurring. In this case, the WAF is a method of preventing the attack, thus avoiding the risk. Risk transfer options move the costs of risks to another organization such as through insurance. Acceptance involves management acknowledging that the risk and its impacts may occur and that the organization will move forward despite that chance. Mitigation works to limit the impact of a risk.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      309,
      312,
      311,
      310,
      313
    ],
    "source": "9781394211395"
  },
  {
    "id": 1345,
    "question": "Requiring all web traffic to be sent via HTTPS is an example of what type of standard?",
    "choice_a": "Access control",
    "choice_b": "Encryption",
    "choice_c": "Password",
    "choice_d": "Physical security",
    "correct_answer": "B",
    "explanation": "HTTPS using TLS is a form of encryption for data in motion. Encryption standards often require specific ways to use encryption, encryption algorithms, settings or configurations for encryption, or times and places where encryption must be used. Access control standards focus on how access is controlled, by whom, and who is impacted. Password standards define settings and requirements related to passwords, and physical security standards address physical security requirements.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      277,
      298,
      275,
      279,
      299
    ],
    "source": "9781394211395"
  },
  {
    "id": 1346,
    "question": "Why are cloud IaaS vendors unlikely to agree to including a right\u2010to\u2010audit clause in their contracts?",
    "choice_a": "The risk to their other customers is too great.",
    "choice_b": "The cost of the assessment is too high.",
    "choice_c": "They may not pass the audit.",
    "choice_d": "They have competing regulatory requirements.",
    "correct_answer": "A",
    "explanation": "Cloud vendors rarely agree to right\u2010to\u2010audit clauses, instead choosing to provide their own third\u2010party audit results. This reduces the chances of an audit or assessment causing issues with their other customers. Third\u2010party audit costs covered by right\u2010to\u2010audit clauses are often borne by the customers, not the vendor. Not passing an audit is unlikely for major vendors, regulatory requirements are more likely to require audits, and regulations rarely limit auditability.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      288,
      287,
      310,
      294,
      4
    ],
    "source": "9781394211395"
  },
  {
    "id": 1347,
    "question": "Chuck's organization requires that user accounts only be able to log in during the staff member's working hours. What type of standard would drive a setting like this?",
    "choice_a": "Access control",
    "choice_b": "Encryption",
    "choice_c": "Password",
    "choice_d": "Physical security",
    "correct_answer": "A",
    "explanation": "Access control standards often define how and when users can access or use systems and services. Defining user access to only be allowed during working hours is an example of an access control standard. Encryption standards often require specific ways to use encryption, encryption algorithms, settings or configurations for encryption, or times and places where encryption must be used. Password standards define settings and requirements related to passwords, and physical security standards address physical security requirements.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      277,
      275,
      299,
      276,
      280
    ],
    "source": "9781394211395"
  },
  {
    "id": 1348,
    "question": "Frankie wants to establish her organization's encryption standard. Which of the following should she recommend for a default encryption algorithm for general use if cryptographic strength is a critical feature?",
    "choice_a": "AES\u2010128",
    "choice_b": "SHA\u20101",
    "choice_c": "AES\u2010256",
    "choice_d": "SHA\u20102",
    "correct_answer": "C",
    "explanation": "The Advanced Encryption Standard (AES) is the most commonly accepted and used encryption standard as of this writing. Selecting a longer key length like 256 over a 128\u2010bit option provides greater resistance to brute\u2010force attacks. SHA\u20101 and SHA\u20102 are hashing algorithms, not encryption algorithms.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      277,
      298,
      299,
      275,
      309
    ],
    "source": "9781394211395"
  },
  {
    "id": 1349,
    "question": "Jill's organization has selected Agile with a CI/CD process for their organization. What type of policy would document this selection?",
    "choice_a": "Business continuity",
    "choice_b": "Disaster recovery",
    "choice_c": "Incident response",
    "choice_d": "Software development life cycle",
    "correct_answer": "D",
    "explanation": "Agile, along with continuous integration/continuous delivery (CI/CD) pipelines, describes a software development life cycle. Business continuity, disaster recovery, and incident response policies may mention the Agile process and impacts on the CI/CD pipeline, but it is not the primary focus of those types of policies.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      64,
      275,
      276,
      273,
      278
    ],
    "source": "9781394211395"
  },
  {
    "id": 1350,
    "question": "Megan's organization wants to create a change management policy. Which of the following is not a typical change type found in a change policy?",
    "choice_a": "Preauthorized changes",
    "choice_b": "Emergency changes",
    "choice_c": "Legislated changes",
    "choice_d": "Standard changes",
    "correct_answer": "C",
    "explanation": "Change management practices often include options for preapproved changes, emergency changes, and standard changes. Changes required by legislation or other external factors are not typically built into most change management processes.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      278,
      275,
      280,
      309,
      293
    ],
    "source": "9781394211395"
  },
  {
    "id": 1351,
    "question": "Liz wants to assess the critical functions of her business and ensure that the systems that are part of those functions are assessed to determine how often they are likely to fail, how long it would take to restore them, and what recovery objectives will be. What process should she engage in?",
    "choice_a": "A quantitative risk assessment",
    "choice_b": "A business impact analysis",
    "choice_c": "A qualitative risk assessment",
    "choice_d": "A penetration test",
    "correct_answer": "B",
    "explanation": "A business impact analysis (BIA) is a formal process used to identify mission\u2010critical functions and to ensure that critical systems that support those functions are identified and assessed. Risk assessment seeks to identify risks and their probability and impact, and a penetration test attempts to emulate how attackers might gain access to or otherwise impact systems and services.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      310,
      305,
      306,
      307,
      309
    ],
    "source": "9781394211395"
  },
  {
    "id": 1352,
    "question": "What describes the key difference between policies and standards?",
    "choice_a": "Policies are defined by third parties; standards are defined by organizations.",
    "choice_b": "Policies are defined by organizations; standards are defined by third parties.",
    "choice_c": "Policies are a statement of intent; standards define how rules help enforce policy.",
    "choice_d": "Policies are legally enforceable; standards are optional.",
    "correct_answer": "C",
    "explanation": "Policies are a statement of organizational intent. Standards are defined to help organization achieve that intent through the use of rules. Policies are typically defined by an organization, and standards may be adopted from third parties or created by the organization itself. Policies might be defined by law but are not required to be defined that way.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      275,
      276,
      277,
      279,
      280
    ],
    "source": "9781394211395"
  },
  {
    "id": 1353,
    "question": "Sophie wants to ensure that her vendor meets their SLA. What does Sophie need to do?",
    "choice_a": "Ensure performance targets are defined in the contract with appropriate penalties.",
    "choice_b": "Establish key performance indicators (KPIs) for her team and assess them regularly.",
    "choice_c": "Ensure that security levels are not reduced when performing maintenance.",
    "choice_d": "Determine if supply chain levels are met in order to meet demand.",
    "correct_answer": "A",
    "explanation": "Service level agreements set forth the expected service level as well as penalties for nonperformance. That means that Sophie needs to determine whether her vendor is meeting their promised delivery levels or availability levels and to claim appropriate penalties as defined in the contract if they are not met. KPIs may be involved but would be measured against her vendor's performance, not her team's performance. Security levels and supply chain availability levels are not the only potential items covered by an SLA.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      289,
      290,
      288,
      287,
      309
    ],
    "source": "9781394211395"
  },
  {
    "id": 1354,
    "question": "Tuan is assessing risk and knows that he needs to be able to explain risk to his management. What two factors are combined to describe risk?",
    "choice_a": "Impact and acceptance",
    "choice_b": "Likelihood and ALE",
    "choice_c": "Probability and impact",
    "choice_d": "Probability and SLE",
    "correct_answer": "C",
    "explanation": "Probability and impact are used to describe risk. ALE is the annual loss expectancy, or how much risks will likely cost an organization per year, and SLE is the single loss expectancy, or how much a single risk will cost if it occurs. Acceptance is a risk\u2010handling process, not a way of describing risks.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      314,
      307,
      306,
      305,
      309
    ],
    "source": "9781394211395"
  },
  {
    "id": 1355,
    "question": "Marco wants to conduct active reconnaissance of a target for a penetration test. Which of the following is an appropriate action based on this desire?",
    "choice_a": "Looking up information in Shodan",
    "choice_b": "Conducting a nmap scan",
    "choice_c": "Querying local DNS for the organization",
    "choice_d": "Using public records to gather information",
    "correct_answer": "B",
    "explanation": "The only active reconnaissance task listed here is the nmap scan. Looking up information in Shodan, querying local DNS, and using public records are all examples of passive information gathering that does not actively probe the organization.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      57,
      58,
      288,
      61,
      7
    ],
    "source": "9781394211395"
  },
  {
    "id": 1356,
    "question": "Beth is a data owner in her company. Which of the following is not a typical part of the role of data owner?",
    "choice_a": "They categorize data.",
    "choice_b": "They are responsible for processing data.",
    "choice_c": "They are responsible for protecting data.",
    "choice_d": "They are responsible for data quality.",
    "correct_answer": "B",
    "explanation": "Data owners are responsible for categorizing, overseeing the usage of, and protecting data, but are typically not directly responsible for processing it.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      317,
      320,
      276,
      275,
      287
    ],
    "source": "9781394211395"
  },
  {
    "id": 1357,
    "question": "NIST SP 800\u201063B, Digital Identity Guidelines, provides advice on passwords and password standards. Why does the guide recommend that knowledge\u2010based authentication like \u201cWhat was your mother's maiden name?\u201d not be used for processes like password reset and recovery?",
    "choice_a": "Users may not remember the answer.",
    "choice_b": "Knowledge\u2010based authentication information is often easily discovered through searches and social media.",
    "choice_c": "Knowledge\u2010based authentication information is not a valid factor for MFA.",
    "choice_d": "Attackers can easily recover knowledge\u2010based information from compromised authentication stores.",
    "correct_answer": "B",
    "explanation": "Knowledge\u2010based authentication information is often easily available via social media or searches. Thus, using it as part of password recovery processes is problematic for organizations. Users will typically remember answers to knowledge\u2010based authentication questions. While knowledge\u2010based authentication isn't typically used for multifactor, something you know is a legitimate option, and knowledge\u2010based authentication information could be recovered from compromised organizations, but this is not a common threat model.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      277,
      301,
      320,
      292,
      303
    ],
    "source": "9781394211395"
  },
  {
    "id": 1358,
    "question": "The company that Leon works for has experienced a significant malware infection and has segmented their network to prevent further spread. What risk mitigation strategy have they chosen?",
    "choice_a": "Avoid",
    "choice_b": "Transfer",
    "choice_c": "Accept",
    "choice_d": "Mitigate",
    "correct_answer": "D",
    "explanation": "Mitigation works to limit the impact of a risk, such as by taking action like segmenting the network to prevent further malware spread. Avoidance seeks to prevent the risk from occurring. Risk transfer options move the costs of risks to another organization such as through insurance. Acceptance involves management acknowledging that the risk and its impacts may occur, and that the organization will move forward despite that chance.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      309,
      310,
      311,
      312,
      280
    ],
    "source": "9781394211395"
  },
  {
    "id": 1359,
    "question": "Not using hints, preventing password expiration, storing passwords only in a hashed and salted form, and using minimum password length settings are all examples of what?",
    "choice_a": "Password standards",
    "choice_b": "Multifactor authentication",
    "choice_c": "Establishing knowledge\u2010based passwords",
    "choice_d": "Biometrics",
    "correct_answer": "A",
    "explanation": "Password standards typically include elements like the NIST 800\u201063B recommendations, not using password hints, not expiring passwords, storing passwords in a secure way, and establishing a minimum password length of at least 8 characters for user\u2010generated passwords.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      277,
      275,
      298,
      296,
      280
    ],
    "source": "9781394211395"
  },
  {
    "id": 1360,
    "question": "Anastasia works for a government entity that requires very strong risk controls and that has significant regulatory requirements it must meet. What risk appetite model should she expect her organization to adopt?",
    "choice_a": "Expansionary",
    "choice_b": "Conservative",
    "choice_c": "Authoritarian",
    "choice_d": "Legislative",
    "correct_answer": "B",
    "explanation": "Organizations that focus on reducing risk and that have significant compliance requirements are likely to adopt a conservative risk appetite. Expansionary risk appetite is rare when compliance and risk reduction are primary goals of the organization. Authoritarian and legislative are not typically used terms to describe risk appetite.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      313,
      309,
      294,
      297,
      295
    ],
    "source": "9781394211395"
  },
  {
    "id": 1361,
    "question": "Jack recently joined his organization's security team. A system was identified as likely being impacted by ransomware, and Jack was given a document that described the organization's ransomware handling practices. What common security document has he been given?",
    "choice_a": "The IR policy",
    "choice_b": "A ransomware cookbook",
    "choice_c": "A ransomware playbook",
    "choice_d": "A disaster recovery handbook",
    "correct_answer": "C",
    "explanation": "Detailed guides to organization practices for security events are called playbooks. In this case, Jack received the organization's ransomware playbook. A policy would include high\u2010level statements of intent, cookbooks are not a typical term used for documents like these, and this situation involves ransomware, not a disaster recovery scenario.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      275,
      277,
      279,
      276,
      281
    ],
    "source": "9781394211395"
  },
  {
    "id": 1362,
    "question": "Connie wants to explain the consequences of noncompliance with data regulations to her organization's management. Which of the following is the most common statutory consequence of noncompliance with regulations?",
    "choice_a": "Data breaches",
    "choice_b": "Reputational damage",
    "choice_c": "Contractual impacts",
    "choice_d": "Fines",
    "correct_answer": "D",
    "explanation": "Regulations most commonly have fines and sanctions as their primary punishments levied against noncompliant organizations. Data breaches and reputational damage may occur, but are they are not enforced by regulation. Contractual impacts may occur, but again are not directly enforced by regulations.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      294,
      4,
      3,
      309,
      312
    ],
    "source": "9781394211395"
  },
  {
    "id": 1363,
    "question": "Hank wants to create a playbook for his incident response process. What will he create?",
    "choice_a": "A detailed process for incident response",
    "choice_b": "A legal document describing incident response",
    "choice_c": "A high\u2010level statement of purpose for incident response",
    "choice_d": "A document describing the general incident response (IR) process",
    "correct_answer": "A",
    "explanation": "Playbooks are detailed documents describing how to respond to a type of incident or event. An example is the CISA's Cybersecurity Incident and Vulnerability Response playbook, which includes steps like identifying anomalous activity, identifying root cause, and analyzing for common adversary TTPs (<code>www.cisa.gov/sites/default/files/publications/Federal_Government_Cybersecurity_Incident_and_Vulnerability_Response_Playbooks_508C.pdf</code>). They are not legal documents, are detailed instead of high\u2010level like a policy, and are more detailed than a general IR process document.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      275,
      278,
      276,
      296,
      57
    ],
    "source": "9781394211395"
  },
  {
    "id": 1364,
    "question": "What type of agreement is used by organizations that want to protect their proprietary data while working with third parties or individuals who will have access to the data?",
    "choice_a": "SLAs",
    "choice_b": "NDAs",
    "choice_c": "MSAs",
    "choice_d": "BPAs",
    "correct_answer": "B",
    "explanation": "Nondisclosure agreements (NDAs) are used to protect sensitive data. Service level agreements (SLAs) determine service levels and penalties if they are not met. Master service agreements (MSAs) are foundational documents determining how organizations will work together as a foundation for specific work covered in SOWs (statements of work). BPAs (business partners agreements) are used when two organizations want to do business as a partnership.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      286,
      289,
      287,
      308,
      57
    ],
    "source": "9781394211395"
  },
  {
    "id": 1365,
    "question": "Oliver has joined an organization and has completed employee orientation, has received his username and password, and has reviewed the new employee security training. What process has he participated in?",
    "choice_a": "Identity proofing",
    "choice_b": "Mandatory access control",
    "choice_c": "Onboarding",
    "choice_d": "Biometric enrollment",
    "correct_answer": "C",
    "explanation": "Onboarding processes commonly include things like new employee orientation, creation of user accounts and provisioning of rights for the employee's account, and ensuring the employee has completed security training. Identity proofing may be part of that process, but was not mentioned here. Mandatory access control is an access control model, and biometric enrollment involves capturing information about an individual's biometric markers or profile.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      286,
      278,
      302,
      276,
      275
    ],
    "source": "9781394211395"
  },
  {
    "id": 1366,
    "question": "What GDPR provision allows individuals to ask organization to delete their personal data?",
    "choice_a": "The right to be forgotten",
    "choice_b": "The right to deletion",
    "choice_c": "The right to privacy",
    "choice_d": "The right to ownership",
    "correct_answer": "A",
    "explanation": "The GDPR provides the right to be forgotten, which allows individuals to request that their data be deleted. The rights to deletion, privacy, and ownership were made up for this question.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      320,
      292,
      317,
      294,
      298
    ],
    "source": "9781394211395"
  },
  {
    "id": 1367,
    "question": "Damian has provided a comprehensive risk register to his management, including a risk of employees violating policy by taking pictures of sensitive information displayed on their screens using their cell phones. Damian's recommendation was to ban employees from carrying personal cell phones inside the office, but management has overruled that recommendation and will allow phones. What risk management strategy has his organization's leadership chosen?",
    "choice_a": "Transfer",
    "choice_b": "Accept",
    "choice_c": "Avoid",
    "choice_d": "Mitigate",
    "correct_answer": "B",
    "explanation": "Acceptance involves management acknowledging that the risk and its impacts may occur, and that the organization will move forward despite that chance. Risk transfer options move the costs of risks to another organization such as through insurance. Avoidance seeks to prevent the risk from occurring. Mitigation works to limit the impact of a risk, such as by taking action to prevent further malware spread.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      309,
      313,
      314,
      310,
      311
    ],
    "source": "9781394211395"
  },
  {
    "id": 1368,
    "question": "Which of the following is not a typical part of an offboarding process?",
    "choice_a": "Returning company equipment",
    "choice_b": "Copying files to a USB drive for the departing employee",
    "choice_c": "Disabling or removing accounts",
    "choice_d": "Changing passwords on shared accounts",
    "correct_answer": "B",
    "explanation": "Sending organizational data with a departing employee is not a common practice. In fact, organizations often ask employees to certify that they have returned all organizational devices and data. Returning company equipment, disabling the departing employee's accounts or removing them, and changing any passwords on shared accounts are all common offboarding practices.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      286,
      278,
      317,
      320,
      287
    ],
    "source": "9781394211395"
  },
  {
    "id": 1369,
    "question": "Daryl wants to ensure that his organization balances risks and its goals. What risk appetite model should he suggest the organization adopts?",
    "choice_a": "Conservative",
    "choice_b": "Expansionary",
    "choice_c": "Reactionary",
    "choice_d": "Neutral",
    "correct_answer": "D",
    "explanation": "Neutral risk appetites balance organizational goals against risk. Conservative risk appetites seek to reduce risks over addressing other goals, and expansionary risk appetites will accept risk to achieve goals. Reactionary is not a typical description of risk appetite.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      313,
      309,
      310,
      314,
      272
    ],
    "source": "9781394211395"
  },
  {
    "id": 1370,
    "question": "Charlene is preparing to conduct a penetration test and has been provided with access to all of her organization's information about the systems, services, and configurations involved. What type of penetration test is she conducting?",
    "choice_a": "A partially known environment test",
    "choice_b": "An unknown environment test",
    "choice_c": "A known environment test",
    "choice_d": "A third\u2010party test",
    "correct_answer": "C",
    "explanation": "Known environment tests provide full information to testers, allowing them to use information about the environment without having to discover it. Partially known environment tests provide some, but not all information about the environment for testers. Unknown environment tests simulate what an attacker would encounter and do not provide information; instead, the testers have to discover it themselves. Third\u2010party tests are conducted by external groups or individuals and may be known, unknown, or partial knowledge tests.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      57,
      61,
      58,
      288,
      290
    ],
    "source": "9781394211395"
  },
  {
    "id": 1371,
    "question": "The company that Omar works for wants to co\u2010develop a mobile application with a third\u2010party company. What type of agreement should they both sign as part of this?",
    "choice_a": "An SLA",
    "choice_b": "An NDA",
    "choice_c": "An MSA",
    "choice_d": "A BPA",
    "correct_answer": "D",
    "explanation": "BPAs, or business partners agreements, are used when two organizations want to do business as a partnership. SLAs, or service level agreements, determine service levels and penalties if they are not met. Nondisclosure agreements, or NDAs, are used to protect sensitive data. Master service agreements, or MSAs, are foundational documents determining how organizations will work together as a foundation for specific work covered in SOWs, or statements of work.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      289,
      287,
      290,
      286,
      308
    ],
    "source": "9781394211395"
  },
  {
    "id": 1372,
    "question": "Alex wants to hire a penetration tester who will simulate an attacker's potential attacks against his environment. What type of test best fits this model?",
    "choice_a": "A partially known environment test",
    "choice_b": "An unknown environment test",
    "choice_c": "A known environment test",
    "choice_d": "A third\u2010party test",
    "correct_answer": "B",
    "explanation": "Unknown environment tests simulate what an attacker would encounter and do not provide information; instead, the testers have to discover it themselves. Known environment tests provide full information to testers, allowing them to use information about the environment without having to discover it. Partially known environment tests provide some, but not all information about the environment for testers. Third\u2010party tests are conducted by external groups or individuals and may be known, unknown, or partial knowledge tests.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      57,
      61,
      288,
      58,
      290
    ],
    "source": "9781394211395"
  },
  {
    "id": 1373,
    "question": "What term describes the possibility of a risk occurring?",
    "choice_a": "Impact",
    "choice_b": "Likelihood",
    "choice_c": "Potential",
    "choice_d": "Rate of occurrence",
    "correct_answer": "B",
    "explanation": "Likelihood describes the possibility of a risk occurring. Impact describes what will happen if it does, potential is not a term used in this space, and rate of occurrence is how often a risk occurs on an annual basis.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      305,
      306,
      314,
      313,
      309
    ],
    "source": "9781394211395"
  },
  {
    "id": 1374,
    "question": "Killian's organization wants to perform a penetration test that will provide the maximum amount of information about his organization and that will optimize penetration testers' time. What type of test should he have conducted?",
    "choice_a": "A partially known environment test",
    "choice_b": "An unknown environment test",
    "choice_c": "A known environment test",
    "choice_d": "A third\u2010party test",
    "correct_answer": "C",
    "explanation": "Known environment tests provide full information to testers, allowing them to use information about the environment without having to discover it. This means that the testing will be more efficient and will provide more information in most cases. Partially known environment tests provide some, but not all information about the environment for testers. Unknown environment tests simulate what an attacker would encounter and do not provide information; instead, the testers have to discover it themselves. Third\u2010party tests are conducted by external groups or individuals and may be known, unknown, or partial knowledge tests.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      57,
      61,
      288,
      58,
      7
    ],
    "source": "9781394211395"
  },
  {
    "id": 1375,
    "question": "Justin's organization has recently undergone a third\u2010party audit that determined that their data\u2010handling processes don't comply with the GDPR. Changes to become compliant will take almost a year due to existing systems and software. What risk management strategy is Justin's organization choosing if they continue to operate knowing they are noncompliant?",
    "choice_a": "Transfer",
    "choice_b": "Exception",
    "choice_c": "Avoidance",
    "choice_d": "Mitigate",
    "correct_answer": "B",
    "explanation": "Risk exception recognizes risk areas where an organization may not be in compliance with policies or regulations, and may be acknowledged because they cannot be addressed in a timely manner or are required for the organization to conduct business. Risk transfer options move the costs of risks to another organization such as through insurance. Risk avoidance involves preventing the risk from occurring. Mitigation works to limit the impact of a risk, such as by taking action to prevent further malware spread.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      309,
      280,
      310,
      292,
      312
    ],
    "source": "9781394211395"
  },
  {
    "id": 1376,
    "question": "Risk assessments required for regulatory compliance are most frequently conducted in which of the following modes?",
    "choice_a": "As ad hoc risk assessments",
    "choice_b": "As one\u2010time risk assessments",
    "choice_c": "As recurring risk assessments",
    "choice_d": "As continuous risk assessments",
    "correct_answer": "C",
    "explanation": "Regulatory compliance typically requires risk assessment on a regular basis, often once a year. Ad hoc, one\u2010time, and continuous risk assessments are used for other purposes to serve the organization but are not as common for regulatory compliance.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      305,
      310,
      295,
      292,
      297
    ],
    "source": "9781394211395"
  },
  {
    "id": 1377,
    "question": "Jack's organization has engaged penetration testers for their annual penetration test. As part of the contract, the testers are provided with a list of target systems, operating systems, and software that they will be testing. What type of penetration test is Jack's organization conducting?",
    "choice_a": "A partially known environment test",
    "choice_b": "An unknown environment test",
    "choice_c": "A known environment test",
    "choice_d": "A third\u2010party test",
    "correct_answer": "A",
    "explanation": "Partially known environment tests provide some, but not all information about the environment for testers. In this case, knowledge of the systems, IPs, and services is an example of partial knowledge. Known environment tests provide full information to testers, allowing them to use information about the environment without having to discover it. Unknown environment tests simulate what an attacker would encounter and do not provide information; instead, the testers have to discover it themselves. Third\u2010party tests are conducted by external groups or individuals and may be known, unknown, or partial knowledge tests.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      57,
      58,
      288,
      290,
      289
    ],
    "source": "9781394211395"
  },
  {
    "id": 1378,
    "question": "The company that Jim works for is willing to accept significant risk in order to expand. How should Jim describe the organization's risk appetite?",
    "choice_a": "Conservative",
    "choice_b": "Expansionary",
    "choice_c": "Limited",
    "choice_d": "Neutral",
    "correct_answer": "B",
    "explanation": "An organization willing to accept significant risk has adopted an expansionary risk appetite. Neutral risk appetites balance risk and other factors, conservative appetites seek to limit risk rather than prioritize other goals or objectives, and limited is not a term used on the Security+ exam objectives in this area.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      313,
      309,
      310,
      307,
      306
    ],
    "source": "9781394211395"
  },
  {
    "id": 1379,
    "question": "As part of the early stages of a penetration test, Hui has researched her target organization's domain names and IP addresses, and has conducted a port scan. What type of activity is Hui engaging in?",
    "choice_a": "Reconnaissance",
    "choice_b": "An unknown environment test",
    "choice_c": "A known environment test",
    "choice_d": "OSINT gathering",
    "correct_answer": "A",
    "explanation": "Information gathering and scanning together are common elements of reconnaissance. Since this involves both scanning and OSINT gathering, this is reconnaissance instead of passive information gathering via OSINT. Known environment tests provide full information to testers, allowing them to use information about the environment without having to discover it. Unknown environment tests simulate what an attacker would encounter and do not provide information; instead, the testers have to discover it themselves.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      57,
      58,
      61,
      288,
      287
    ],
    "source": "9781394211395"
  },
  {
    "id": 1380,
    "question": "What role does a person who has exercised the GDPR's right to be forgotten hold?",
    "choice_a": "Data subject",
    "choice_b": "Data controller",
    "choice_c": "Data processor",
    "choice_d": "Data owner",
    "correct_answer": "A",
    "explanation": "Individuals who use the GDPR's right to be forgotten are data subjects, a person who can be identified by their personally identifiable information. Data controllers determine how data will be used, and processors do the actual data processing. Data owners are responsible for protection, usage, and quality of datasets.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      317,
      320,
      292,
      298,
      276
    ],
    "source": "9781394211395"
  },
  {
    "id": 1381,
    "question": "How is exposure factor (EF) expressed for risk calculations?",
    "choice_a": "As a calculation of the ALE multiplied by the ARO",
    "choice_b": "As the likelihood of loss",
    "choice_c": "As a potential percentage of loss",
    "choice_d": "As a calculation of the SLE multiplied by the ARO",
    "correct_answer": "C",
    "explanation": "Exposure factors are the percentage of value of an asset that would be lost due to an incident. ALE is the annual loss expectancy, and the ARO is the annual rate of occurrence. SLE is the single loss expectancy. Calculating these gives the cost of an incident, but EF is the impact of the risk and is not calculated using these, nor does it involve the likelihood of the risk.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      306,
      310,
      312,
      309,
      305
    ],
    "source": "9781394211395"
  },
  {
    "id": 1382,
    "question": "As part of his penetration testing process Nick intends to follow an employee of his target company into a secured area. What type of penetration testing is Nick engaged in?",
    "choice_a": "Defensive",
    "choice_b": "Offensive",
    "choice_c": "Physical",
    "choice_d": "Integrated",
    "correct_answer": "C",
    "explanation": "Physical security testing involves testing an organization's physical security defenses and practices, including guards, locks and doors, and other physical security components. Offensive penetration testing involves acting like attackers, while defensive penetration testing seeks to learn as defenders. Integrated penetration testing combines both.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      61,
      57,
      58,
      290,
      302
    ],
    "source": "9781394211395"
  },
  {
    "id": 1383,
    "question": "Valerie's organization wants to ensure that their access control vestibule, ID card system, and guards are effective in stopping unwanted entrance. What type of penetration test should she use to validate this?",
    "choice_a": "Physical",
    "choice_b": "Offensive",
    "choice_c": "Defensive",
    "choice_d": "Integrated",
    "correct_answer": "D",
    "explanation": "Integrated penetration testing combines both offensive and defensive penetration testing, and testing guards as well as attempting to make it through access controls is an example of an integrated test. Physical security testing involves testing an organization's physical security defenses and practices, including guards, locks and doors, and other physical security components like access control vestibules. Offensive penetration testing involves acting like attackers, while defensive penetration testing seeks to learn as defenders.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      61,
      57,
      58,
      288,
      290
    ],
    "source": "9781394211395"
  },
  {
    "id": 1384,
    "question": "Jason's organization has engaged a penetration testing firm that specializes in using techniques commonly employed by nation\u2010state actors, including using social engineering techniques, advanced tools, and methods that will provide significant footholds within his infrastructure. What type of penetration test best describes this?",
    "choice_a": "Physical",
    "choice_b": "Offensive",
    "choice_c": "Defensive",
    "choice_d": "Integrated",
    "correct_answer": "B",
    "explanation": "Offensive penetration testing involves acting like attackers, including nation\u2010state actors with advanced capabilities like those described in this question. Physical security testing involves testing an organization's physical security defenses and practices, including guards, locks and doors, and other physical security components like access control vestibules. Defensive penetration testing seeks to learn as defenders. Integrated penetration testing combines both.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      61,
      57,
      58,
      287,
      288
    ],
    "source": "9781394211395"
  },
  {
    "id": 1385,
    "question": "Joshua's organization is required to comply with the EU's GDPR. As part of their annual assessments, they conduct a GDPR compliance review and receive a report from their auditors. What type of assessment is this?",
    "choice_a": "A penetration test",
    "choice_b": "A regulatory assessment",
    "choice_c": "An internal audit",
    "choice_d": "An attestation\u2010based assessment",
    "correct_answer": "B",
    "explanation": "The GDPR is a regulation, making this a regulatory assessment or audit. There is no penetration testing mentioned, the auditors are not described as internal or external, and no attestation is mentioned.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      292,
      293,
      295,
      294,
      296
    ],
    "source": "9781394211395"
  },
  {
    "id": 1386,
    "question": "Alexandria wants to mitigate the risk of ransomware during its initial infection stages. Which of the following strategies should she employ?",
    "choice_a": "Deploy an EDR tool.",
    "choice_b": "Purchase cybersecurity insurance.",
    "choice_c": "Use secure, ransomware\u2010resistant backups.",
    "choice_d": "Continue to operate as usual.",
    "correct_answer": "A",
    "explanation": "Secure, ransomware resistant backups can mitigate the impact of ransomware but cannot stop it from impacting systems like an endpoint detection and response (EDR) tool can. Since Alexandria's focus is on immediate mitigation, her best answer is EDR. Cybersecurity insurance is a means of transferring risk, and simply operating as usual is an acceptance strategy.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      309,
      312,
      310,
      307,
      306
    ],
    "source": "9781394211395"
  },
  {
    "id": 1387,
    "question": "Shane's organization has determined that they can accept up to $10,000,000 a year in risk\u2010related loss in support of their strategic plans. What term best describes this?",
    "choice_a": "Risk acceptance",
    "choice_b": "Risk appetite",
    "choice_c": "Ad hoc risk",
    "choice_d": "A conservative risk tolerance",
    "correct_answer": "B",
    "explanation": "Shane's organization has determined their risk appetite. They are willing to accept some risk, but may also choose to mitigate, transfer, or otherwise deal with their risk to match their appetite. Ad hoc describes risk assessment, not risk appetite or thresholds, and there is no way to determine if this is a conservative, neutral, or expansionary risk appetite.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      313,
      309,
      310,
      314,
      306
    ],
    "source": "9781394211395"
  },
  {
    "id": 1388,
    "question": "Eric manages his organization's internal security team and wants to leverage a penetration test as part of his team's testing that allows them to respond to simulated attacks. What type of model best describes this?",
    "choice_a": "Physical",
    "choice_b": "Offensive",
    "choice_c": "Defensive",
    "choice_d": "Integrated",
    "correct_answer": "C",
    "explanation": "Defensive penetration testing seeks to allow the organization to learn as defenders. Offensive penetration testing involves acting like attackers, including nation\u2010state actors with advanced capabilities like those described in this question. Physical security testing involves testing an organization's physical security defenses and practices, including guards, locks and doors, and other physical security components like access control vestibules. Integrated penetration testing combines both.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      61,
      57,
      58,
      290,
      7
    ],
    "source": "9781394211395"
  },
  {
    "id": 1389,
    "question": "Henry's organization leverages penetration testing as part of its ongoing security practices, using attacker techniques as well as blue teaming to improve security constantly. What type of penetration testing methodology is Henry's organization using?",
    "choice_a": "Physical",
    "choice_b": "Offensive",
    "choice_c": "Defensive",
    "choice_d": "Integrated",
    "correct_answer": "D",
    "explanation": "Integrated penetration testing combines both offensive and defensive techniques and is often woven into an organization's practices on an ongoing basis. Offensive penetration testing involves acting like attackers, including nation\u2010state actors with advanced capabilities like those described in this question. Defensive penetration testing seeks to allow the organization to learn as defenders. Physical security testing involves testing an organization's physical security defenses and practices, including guards, locks and doors, and other physical security components like access control vestibules.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      61,
      57,
      58,
      7,
      280
    ],
    "source": "9781394211395"
  },
  {
    "id": 1390,
    "question": "Jackie is an auditor and has completed an SOC 2, Type 2 audit. Her firm then provides a statement about the organization's audit results and posture. What is this process known as?",
    "choice_a": "Penetration testing",
    "choice_b": "Audit sign\u2010off",
    "choice_c": "Regulatory defense",
    "choice_d": "Attestation",
    "correct_answer": "D",
    "explanation": "Auditors provide a statement about an organization's posture as part of an attestation process. This provides assurance that the auditors have reviewed the organization's practices and have found them suitable or that deficiencies have been identified. Penetration testing is the process of testing the security of an organization and is not an audit. Audit sign\u2010off occurs when management signs an audit to acknowledge their awareness of its results. Regulatory defense was made up for this question.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      293,
      298,
      281,
      310,
      287
    ],
    "source": "9781394211395"
  },
  {
    "id": 1391,
    "question": "Joe is an auditor who is on the staff of an organization that employs him to audit their own practices. What type of audit does Joe perform?",
    "choice_a": "Internal",
    "choice_b": "Regulatory",
    "choice_c": "External",
    "choice_d": "Compliance",
    "correct_answer": "A",
    "explanation": "Without more information about the specific audits that Joe conducts, all we know is that he is an internal auditor. As an employee of the company that he is working for, he is considered an internal auditor. External audits are conducted by third parties. Regulatory audits assess compliance with laws, whereas compliance audits may look at laws or other compliance targets.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      273,
      293,
      295,
      290,
      287
    ],
    "source": "9781394211395"
  },
  {
    "id": 1392,
    "question": "Irene's organization needs to follow PCI DSS standards. If she engages a third party to assess this, what type of audit is she having performed?",
    "choice_a": "An internal regulatory audit",
    "choice_b": "An external regulatory audit",
    "choice_c": "An internal compliance audit",
    "choice_d": "An external compliance audit",
    "correct_answer": "D",
    "explanation": "The Payment Card Industry Data Security Standard (PCI DSS) is an industry standard, not a law, so this is a compliance audit, not a regulatory audit. Third\u2010party auditors make it an external rather than an internal audit.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      292,
      295,
      290,
      293,
      287
    ],
    "source": "9781394211395"
  },
  {
    "id": 1393,
    "question": "Anton's organization processes credit cards but is a small organization. As part of their annual requirements related to PCI DSS, Anton fills out a form about their PCI DSS compliance and submits it to their acquiring bank. What type of assessment has his organization conducted?",
    "choice_a": "An internal regulatory audit",
    "choice_b": "A self\u2010assessment",
    "choice_c": "An independent, third\u2010party audit",
    "choice_d": "An external compliance audit",
    "correct_answer": "B",
    "explanation": "Filling out forms attesting to your own organization's compliance status is an example of a self\u2010assessment. This is not an audit activity, PCI DSS is not a regulation, and no third parties were involved to make it external or independent and third party.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      295,
      293,
      292,
      287,
      288
    ],
    "source": "9781394211395"
  },
  {
    "id": 1394,
    "question": "What organization typically includes an audit committee for a company?",
    "choice_a": "The security office",
    "choice_b": "The shareholders",
    "choice_c": "The board of directors",
    "choice_d": "The third\u2010party assessors",
    "correct_answer": "C",
    "explanation": "Audit committees are typically part of the organization's board of directors, and they oversee financial reporting\u2013related activities. Audit committees are required for US\u2010traded companies that are listed on stock exchanges. Shareholders, third\u2010party assessors, and the security office are not typical places to find an audit committee.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      272,
      274,
      292,
      276,
      289
    ],
    "source": "9781394211395"
  },
  {
    "id": 1395,
    "question": "What type of risk assessment process is most commonly associated with a CI/CD pipeline model?",
    "choice_a": "Ad hoc risk assessments",
    "choice_b": "One\u2010time risk assessments",
    "choice_c": "Third\u2010party risk assessments",
    "choice_d": "Continuous risk assessments",
    "correct_answer": "D",
    "explanation": "Continuous integration/continuous delivery (CI/CD) pipelines deploy software on an ongoing basis, making them a good fit for continuous risk assessment techniques. Ad hoc, one\u2010time, and third\u2010party assessments are not suited to the ongoing, rapid assessment pace needed for a CI/CD model.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      305,
      64,
      306,
      307,
      314
    ],
    "source": "9781394211395"
  },
  {
    "id": 1396,
    "question": "Cristobal wants to ensure that a vendor his company is considering hiring has conducted an SOC 2, Type 2 audit that is reliable and that will reveal any critical issues. What should he ensure was done?",
    "choice_a": "An internal audit with attestation by the CEO",
    "choice_b": "An independent, third\u2010party audit",
    "choice_c": "A self\u2010assessment",
    "choice_d": "A third\u2010party penetration test with attestation",
    "correct_answer": "B",
    "explanation": "External audits like a SOC 2, Type 2 audit should be conducted by an independent third party to be considered valid. An internal audit, no matter who signs off on it, is not used for this purpose, nor are self\u2010assessments. Penetration tests do not generate an SOC 2 audit report.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      288,
      287,
      290,
      295,
      308
    ],
    "source": "9781394211395"
  },
  {
    "id": 1397,
    "question": "Kim's organization has assessed the risk of floods that may impact their datacenter and has determined that the likely rate of occurrence and its cost if it does occur are not acceptable. Given this, the organization has opted to move their datacenter in the next year. What has occurred?",
    "choice_a": "The risk dropped below their risk threshold.",
    "choice_b": "The risk assessment failed.",
    "choice_c": "A control failure occurred.",
    "choice_d": "The risk passed their risk threshold.",
    "correct_answer": "D",
    "explanation": "An organization's risk threshold is the level where they will switch from accepting a risk to seeking to handle the risk. In this case, the risk has surpassed the organization's risk threshold, resulting in a plan to avoid the risk. The risk did not drop below the threshold, the risk assessment was successful in helping the organization identify a concern, and no controls failed.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      313,
      309,
      310,
      305,
      306
    ],
    "source": "9781394211395"
  },
  {
    "id": 1398,
    "question": "Vanessa's organization is a US\u2010based health\u2010care organization that is required to be compliant with HIPAA. What type of external assessment should they conduct?",
    "choice_a": "Regulatory",
    "choice_b": "Offensive",
    "choice_c": "Known environment",
    "choice_d": "Physical",
    "correct_answer": "A",
    "explanation": "The Health Insurance Portability and Accountability Act (HIPAA) is a regulation, and organizations that must comply with laws need to conduct regulatory assessments. Offensive testing is a penetration testing model that mirrors actual attackers. Known environment testing leverages full knowledge of an organization as part of a penetration test. Physical testing validates physical security controls.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      292,
      4,
      7,
      293,
      296
    ],
    "source": "9781394211395"
  },
  {
    "id": 1399,
    "question": "Jaime wants to establish her organization's change management policy. What should the policy include?",
    "choice_a": "High\u2010level descriptions of how the organization will review, approve, and implement proposed changes",
    "choice_b": "A detailed process for review and approval of changes",
    "choice_c": "Descriptions of how a change request should be created, formatted, reviewed, and approved",
    "choice_d": "An outline of the regulatory requirements for changes",
    "correct_answer": "A",
    "explanation": "Policies are high\u2010level descriptions of an organization's intent and understanding of their topic. Procedures will have descriptions of how a change is made in detailed form, while standards will describe how changes are created, made, and approved. Regulatory requirements are most likely to be part of standards or procedures.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      275,
      276,
      278,
      281,
      280
    ],
    "source": "9781394211395"
  },
  {
    "id": 1400,
    "question": "Marek's organization has a system that needs to receive a deviation from a defined security process. What best practice should he follow to ensure that this is done correctly?",
    "choice_a": "He should conduct a risk assessment and document the results.",
    "choice_b": "He should remove the system from the network segment to protect it.",
    "choice_c": "He should ensure the deviation is approved through change management processes.",
    "choice_d": "All of the above.",
    "correct_answer": "C",
    "explanation": "Marek should follow his organization's change management process to document the change required and to ensure that it is regularly reviewed. This may not require a risk assessment since it may be a simple requirement or may have already been assessed. The type of security variance needed is not described, so it is not clear if removing the system from the network is necessary.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      280,
      278,
      309,
      310,
      281
    ],
    "source": "9781394211395"
  },
  {
    "id": 1401,
    "question": "What is the key difference between a business continuity plan and a business continuity policy?",
    "choice_a": "The plan describes how an organization will respond, whereas the policy outlines the high\u2010level intent of the organization's business continuity efforts.",
    "choice_b": "The plan includes detailed steps for each part of the response, including how to restore systems and investigate issues, whereas the policy outlines the high\u2010level intent of the organization's business continuity efforts.",
    "choice_c": "The plan describes the high\u2010level intent of the organization's business continuity efforts, whereas the incident response policy describes how the organization will respond.",
    "choice_d": "They are the same; the terms are interchangeable.",
    "correct_answer": "A",
    "explanation": "Business continuity plans address how the organization will respond, including referencing runbooks that may detail how to handle restoration or other efforts on a step\u2010by\u2010step basis, but doesn't itself include that level of detail. Business continuity policies describe the organization's intent at a high level and are likely to reference the business continuity plan. They are not the same, as the policy is a higher\u2010level document than the plan is.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      275,
      276,
      4,
      281,
      280
    ],
    "source": "9781394211395"
  },
  {
    "id": 1402,
    "question": "Christina has prepared a document that includes high\u2010level statements about how her organization will handle major incidents and what its overall stance on incidents is. What has she created?",
    "choice_a": "An incident response process",
    "choice_b": "A runbook",
    "choice_c": "An incident response policy",
    "choice_d": "An incident response standard",
    "correct_answer": "C",
    "explanation": "Policies are distinct from procedures and standards because they include high\u2010level statements of intent rather than specific practices. Procedures document the practices an organization will use, whereas standards set expectations or specific configurations or details about how something is done or set up.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      275,
      276,
      278,
      279,
      281
    ],
    "source": "9781394211395"
  },
  {
    "id": 1403,
    "question": "Terry wants to have all of his account data removed from organizations he has interacted with. What GDPR right can he leverage if he is an EU citizen?",
    "choice_a": "Data stewardship",
    "choice_b": "Personal data ownership",
    "choice_c": "The right to be forgotten",
    "choice_d": "His HIPAA rights",
    "correct_answer": "C",
    "explanation": "The EU's GDPR provides the right to be forgotten, which allows Terry to request that organizations remove all of his data from their systems. HIPAA is a US regulation; data stewardship is an organizational role, not a right; and personal data ownership is not a right.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      320,
      292,
      317,
      294,
      273
    ],
    "source": "9781394211395"
  },
  {
    "id": 1404,
    "question": "Probability and impact are used to rate what key security item?",
    "choice_a": "Cost",
    "choice_b": "Risk",
    "choice_c": "Vulnerability",
    "choice_d": "Audit findings",
    "correct_answer": "B",
    "explanation": "Risk exposure is calculated by multiplying probability and impact. Cost is measured in currency, time, or other cost metrics; vulnerability is often measured using CVSS scores; and audit findings may have criticality ratings.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      310,
      306,
      312,
      309,
      305
    ],
    "source": "9781394211395"
  },
  {
    "id": 1405,
    "question": "Gary wants to determine the probability of a risk occurring. What should he base his assessment on if he is performing a qualitative risk assessment?",
    "choice_a": "A calculated rate of occurrence using industry statistical data",
    "choice_b": "A rating from an experienced team of staff",
    "choice_c": "The number of times it has happened to their competitors in a year",
    "choice_d": "Actuarial tables provided by his insurance broker",
    "correct_answer": "B",
    "explanation": "Qualitative risk assessment relies on expertise and staff members who have relevant knowledge to provide a rating based on their experience, skills, and knowledge. A common rating for probability in a qualitative risk assessment might be low, medium, or high, rather than a 0\u2013100 rating based on statistics or large datasets.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      307,
      310,
      306,
      314,
      313
    ],
    "source": "9781394211395"
  },
  {
    "id": 1406,
    "question": "Which of the following is not a common element for a penetration test's rules of engagement?",
    "choice_a": "Handling of sensitive and pentest\u2010related data",
    "choice_b": "A list of passwords",
    "choice_c": "A list of in\u2010scope IPs or domains",
    "choice_d": "A list of emergency contacts",
    "correct_answer": "B",
    "explanation": "Rules of engagement determine how a penetration tester will conduct an engagement. Passwords may be part of the information provided before the test for a full knowledge or partial knowledge test but are not part of the rules of engagement.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      57,
      58,
      288,
      287,
      61
    ],
    "source": "9781394211395"
  },
  {
    "id": 1407,
    "question": "Maeve is preparing to sign a penetration testing contract with a third\u2010party security service provider. The security service provider provides a questionnaire that asks the scope of systems that can and cannot be tested, the schedule and times that penetration testing can and cannot occur, and what to do if a preexisting compromise is discovered. What document is the third\u2010party service provider assembling?",
    "choice_a": "A right\u2010to\u2010audit clause",
    "choice_b": "A service\u2010level agreement",
    "choice_c": "A memorandum of understanding",
    "choice_d": "Rules of engagement",
    "correct_answer": "D",
    "explanation": "Rules of engagement are created for penetration testing efforts that include a wide variety of information, including scope, schedules, what to do if a preexisting compromise is discovered, requirements for how to handle third\u2010party\u2010hosted tools and environments, how sensitive data and data related to the penetration test will be handled, and who to contact in emergencies. A right\u2010to\u2010audit clause is included in contracts, allowing audits to occur as part of the contract. SLAs are used to set service levels and penalties if they are not met, and MOUs document organizations' interest and willingness to work together.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      57,
      290,
      289,
      58,
      288
    ],
    "source": "9781394211395"
  },
  {
    "id": 1408,
    "question": "Alaina wants to describe the level of impact and probability where her organization will either accept or attempt to mitigate or otherwise handle a risk at. What term describes this?",
    "choice_a": "Risk threshold",
    "choice_b": "Ad hoc risk level",
    "choice_c": "Third\u2010party risk level",
    "choice_d": "Risk appetite",
    "correct_answer": "A",
    "explanation": "An organization's risk threshold is the level where they will switch from accepting a risk to seeking to handle the risk. Their risk appetite is the amount of risk an organization is willing to accept to achieve its goals. Ad hoc risk level and third\u2010party risk level were made up for this question.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      313,
      309,
      310,
      314,
      312
    ],
    "source": "9781394211395"
  },
  {
    "id": 1409,
    "question": "Alaina has been asked to create an AUP for her organization. Which of the following should she include?",
    "choice_a": "An access and usage policy that lists times and roles allowed to access specific resources",
    "choice_b": "A document that describes how the organization intends to approach change and related functions",
    "choice_c": "An antivirus (AV) update policy that describes when and how AV updates are deployed",
    "choice_d": "A description of acceptable use by organizational users",
    "correct_answer": "D",
    "explanation": "AUPs, or acceptable use policies, describe how organizational resources, systems, and services can and should be used.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      276,
      275,
      273,
      281,
      286
    ],
    "source": "9781394211395"
  },
  {
    "id": 1410,
    "question": "Kyle's organization is a very well\u2010known, multinational organization. A recent data breach has exposed data for millions of customers, including all of their account information. As part of the breach, Kyle's company was discovered to have not followed common security practices, and in fact was operating in intentionally careless ways. Which of the following consequences should he highlight as most critical to the organization's ongoing operations when he considers their customer base?",
    "choice_a": "Fines",
    "choice_b": "Due diligence",
    "choice_c": "Reputational damage",
    "choice_d": "Contractual impacts",
    "correct_answer": "C",
    "explanation": "Large breaches, particularly when the organization has been negligent, can have large impacts on the organization's reputation, resulting in long\u2010term damage. Fines and contractual impacts may be impactful but are often resolved relatively quickly. Due diligence was not shown but is not an impact\u2014rather, it is part of an organization's responsibilities.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      294,
      307,
      4,
      295,
      312
    ],
    "source": "9781394211395"
  },
  {
    "id": 1411,
    "question": "What type of agreement do organizations create after signing an MSA that describes the specific tasks or deliverables that will be created or performed?",
    "choice_a": "A MOU",
    "choice_b": "A SOW",
    "choice_c": "A punch list",
    "choice_d": "A BPA",
    "correct_answer": "B",
    "explanation": "A statement of work (SOW) or work order (WO) is created to list the tasks and deliverables that will be performed under the blanket master services agreement (MSA). An MOU, or memorandum of understanding, declares how two organizations want to work together; a business partners agreement (BPA) establishes a partnership between two organizations; and punch lists are not covered under the Security+ exam outline but are a list of tasks that must be accomplished for a contractor to be paid.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      289,
      58,
      57,
      287,
      290
    ],
    "source": "9781394211395"
  },
  {
    "id": 1412,
    "question": "Jack's organization recently received a shipment of SSDs and has begun to deploy them. What information would best help Jack assess the useful life of the devices?",
    "choice_a": "An RTO",
    "choice_b": "An MTTR",
    "choice_c": "An RPO",
    "choice_d": "An MTBF",
    "correct_answer": "D",
    "explanation": "Jack should use the manufacturer's published mean time between failures (MTBF), which is a measure of the reliability of a system. It is the expected amount of time that will elapse between system failures. While organizations typically replace devices well before their MTBF ratings, knowing how long the devices should last on average can be useful in long\u2010lived applications and for budgetary planning. A recovery time objective, or RTO, is set by organizations to describe how long restoring systems or services to normal function after a disruption can take. Mean time to repair, or MTTR, is the average time it takes to repair a system or device. A recovery point objective, or RPO, describes how much data can be lost in the event of an outage or issue.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      289,
      287,
      291,
      310,
      309
    ],
    "source": "9781394211395"
  },
  {
    "id": 1413,
    "question": "The hard drives that Jason's organization recently purchased have an MTBF of 300,000 hours. When can Jason expect the first drive to fail?",
    "choice_a": "At 150,000 hours",
    "choice_b": "At 300,000 hours",
    "choice_c": "At 450,000 hours",
    "choice_d": "None of the above",
    "correct_answer": "D",
    "explanation": "Mean time between failures (MTBF) is a measure of the reliability of a system. It is the expected amount of time that will elapse between system failures, but it is merely an average. Jason should expect that drives will fail, and that their average service life will be 300,000 hours. That means that half of the drives are likely to fail before 300,000 hours, and half will fail after that number.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      310,
      306,
      312,
      309,
      305
    ],
    "source": "9781394211395"
  },
  {
    "id": 1414,
    "question": "Melissa's organization wants to establish a metric that defines how much data could be lost if an issue occurs. What should they set?",
    "choice_a": "An RTO",
    "choice_b": "An MTTR",
    "choice_c": "An RPO",
    "choice_d": "An MTBF",
    "correct_answer": "C",
    "explanation": "A recovery point objective, or RPO, describes how much data can be lost in the event of an outage or issue. A recovery time objective, or RTO, is set by organizations to describe how long restoring systems or services to normal function after a disruption can take. Mean time to repair, or MTTR, is the average time it takes to repair a system or device. The mean time between failures (MTBF) is a measure of the reliability of a system. It is the expected amount of time that will elapse between system failures.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      310,
      312,
      309,
      305,
      297
    ],
    "source": "9781394211395"
  },
  {
    "id": 1415,
    "question": "What common terms are used to categorize anomalous behavior?",
    "choice_a": "Risky, unexpected, and unintentional",
    "choice_b": "Recurring, occasional, and unique",
    "choice_c": "Unintentional, insider, and accidental",
    "choice_d": "Active, passive, and integrated",
    "correct_answer": "A",
    "explanation": "The Security+ exam objectives list three categorizations you need to be familiar with for anomalous behavior: risky, unexpected, and unintentional. The other terms listed are not ways that the exam categorizes anomalous behavior.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      303,
      304,
      310,
      312,
      309
    ],
    "source": "9781394211395"
  },
  {
    "id": 1416,
    "question": "Greg is reviewing a server and notices that it is both running outdated software and that the organization heavily relies on the services that it provides. He pulls together a team to determine what the risk of operating the server is and what issues would occur if it were removed from service that day. What type of assessment has he conducted?",
    "choice_a": "An ad hoc risk assessment",
    "choice_b": "A one\u2010time risk assessment",
    "choice_c": "A third\u2010party risk assessment",
    "choice_d": "A continuous risk assessment",
    "correct_answer": "A",
    "explanation": "Greg has conducted an ad hoc assessment by quickly pulling together a team without a formal process or procedure. Instead, he is seeking to quickly assess risk and take action. A one\u2010time assessment typically follows an established methodology but is only conducted once. Third\u2010party risk assessment uses external teams or staff, and continuous risk assessment is done on an ongoing basis.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      305,
      310,
      304,
      312,
      309
    ],
    "source": "9781394211395"
  },
  {
    "id": 1417,
    "question": "Olivia's organization operates servers in a datacenter that support customers across the country. As Olivia is determining her service level agreements, what information is most important in determining how quickly a server can be restored to operation if its motherboard fails?",
    "choice_a": "An RTO",
    "choice_b": "An MTTR",
    "choice_c": "An RPO",
    "choice_d": "An MTBF",
    "correct_answer": "B",
    "explanation": "Mean time to repair, or MTTR, is the average time it takes to repair a system or device, and Olivia needs to know that to determine what she can promise in her service level agreements that rely on server repair timelines. A recovery time objective, or RTO, is set by organizations to describe how long restoring systems or services to normal function after a disruption can take; it doesn't determine how fast the server can be fixed but sets a goal that needs to take things like repair and recovery time into account as it is determined. A recovery point objective, or RPO, describes how much data can be lost in the event of an outage or issue, and the mean time between failures (MTBF) is a measure of the reliability of a system. It is the expected amount of time that will elapse between system failures.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      289,
      310,
      309,
      313,
      290
    ],
    "source": "9781394211395"
  },
  {
    "id": 1418,
    "question": "Irina's organization wants to work with one of their vendors and wishes to establish an ongoing relationship with them. What type of agreement should they create between the organizations so that they can create SOWs as they determine what services they need from their service provider's organization?",
    "choice_a": "An MOU",
    "choice_b": "An SLA",
    "choice_c": "An MSA",
    "choice_d": "A BPA",
    "correct_answer": "C",
    "explanation": "The underlying agreement between two organizations that determines how the organizations will work together is a master services agreement (MSA). A MOU, or memorandum of understanding, declares how two organizations want to work together; a business partners agreement (BPA) establishes a partnership between two organizations; SLAs (service level agreements) set service level expectations and penalties if they are not met; and a business partners agreement (BPA) establishes two organizations as partners rather than establishing a working relationship for services as set forth in SOWs.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      289,
      290,
      287,
      286,
      291
    ],
    "source": "9781394211395"
  },
  {
    "id": 1419,
    "question": "Dani's organization relies on journaling to help protect transactions that occur through its database. Which of the following does journaling impact the most?",
    "choice_a": "An RTO",
    "choice_b": "An MTTR",
    "choice_c": "An RPO",
    "choice_d": "An MTBF",
    "correct_answer": "C",
    "explanation": "A recovery point objective, or RPO, describes how much data can be lost in the event of an outage or issue, and journaling allows recovery of database transactions by replaying them against the database once it is restored. Journaling may slow down recovery time objectives as the actions are replayed. A recovery time objective, or RTO, is set by organizations to describe how long restoring systems or services to normal function after a disruption can take. Mean time to repair, or MTTR, is the average time it takes to repair a system or device. The mean time between failures (MTBF) is a measure of the reliability of a system. It is the expected amount of time that will elapse between system failures.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      310,
      306,
      309,
      305,
      312
    ],
    "source": "9781394211395"
  },
  {
    "id": 1420,
    "question": "Henry's organization has set their RTO to 12 hours. What does this mean?",
    "choice_a": "Outages must be less than 6 hours long.",
    "choice_b": "Recovery from outages should take less than 12 hours.",
    "choice_c": "Outages longer than 12 hours will require fail over to a warm site.",
    "choice_d": "SLAs for third\u2010party services should specify a 12 hour MTBF.",
    "correct_answer": "B",
    "explanation": "A recovery time objective, or RTO, is set by organizations to describe how long restoring systems or services to normal function after a disruption can take. A 12\u2010hour RTO means that recovery from outages should take less than 12 hours. Failing over to a warm site will typically take a while, meaning that starting to fail over after 12 hours will miss the RTO, and MTBF is the mean time between failures, not a recovery timeframe. Failing every 12 hours on average would be unacceptable for almost any technical service or system!",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      289,
      309,
      313,
      305,
      314
    ],
    "source": "9781394211395"
  },
  {
    "id": 1421,
    "question": "Valerie knows that her organization's datacenter power infrastructure has an MTTR of 24 hours. What should she do if there is a critical component failure in her power infrastructure, and the organization has a warm site with an activation of 12 hours and needs to be back online as soon as possible?",
    "choice_a": "Wait to see if the recovery can be done in less than 24 hours.",
    "choice_b": "Immediately begin a move to the warm site.",
    "choice_c": "Wait to see if the recovery can be done in less than12 hours.",
    "choice_d": "Wait for 12 hours, then begin the move to the warm site.",
    "correct_answer": "B",
    "explanation": "Valerie should immediately begin a move to the warm site. She knows that moving to her warm site takes half the average time to repair for her datacenter's power infrastructure. That means that in most cases, moving will result in at least a 12\u2010hour shorter outage. If the time to repair proves to be shorter than 12 hours, she can simply stop the move. Waiting does not restore her to operation sooner than 24 hours in the average case, and waiting to make the decision reduces the amount of advantage she gets from moving to the warm site.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      309,
      305,
      310,
      313,
      306
    ],
    "source": "9781394211395"
  },
  {
    "id": 1422,
    "question": "Peter's risk assessment process includes calculations of single loss expectancy, the annualized rate of occurrence of risks, and the annualized loss expectancy. What type of risk assessment is Peter conducting?",
    "choice_a": "Quantitative",
    "choice_b": "Calculated",
    "choice_c": "Qualitative",
    "choice_d": "Registered",
    "correct_answer": "A",
    "explanation": "Quantitative risk assessments assign numeric values and calculations to determine relative risk. Qualitative risk assessment uses knowledge and expertise to assess risk. Calculated risk is not a term that is commonly used to describe assessment processes like these, and risk registers list risks that an organization has identified but that don't necessarily involve calculations.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      307,
      310,
      314,
      312
    ],
    "source": "9781394211395"
  },
  {
    "id": 1423,
    "question": "What organizational document is used to enumerate and rate an organization's risks?",
    "choice_a": "A risk appetite plan",
    "choice_b": "A risk register",
    "choice_c": "A quantitative register",
    "choice_d": "A qualitative assessment report",
    "correct_answer": "B",
    "explanation": "Risk registers list organizations risks and their ratings, along with additional information that the organization uses to track or describe risks. Risk appetite plans, quantitative registers, and qualitative assessment reports were made up for this question.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      314,
      310,
      305,
      312,
      309
    ],
    "source": "9781394211395"
  },
  {
    "id": 1424,
    "question": "Amanda's organization wants to conduct a risk assessment and needs to prioritize a timely completion of the process over rigorous detail. What type of assessment should she advise her organization to select?",
    "choice_a": "Internal",
    "choice_b": "External",
    "choice_c": "Qualitative",
    "choice_d": "Quantitative",
    "correct_answer": "C",
    "explanation": "Qualitative risk assessment uses knowledge and expertise to assess risk and are thus typically faster and more likely to be completed than a quantitative risk assessment. Quantitative risk assessments assign numeric values and calculations to determine relative risk. Choosing internal or external risk assessments is not a primary driver of speed compared to choosing quantitative over qualitative risk assessments.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      307,
      306,
      310,
      314,
      313
    ],
    "source": "9781394211395"
  },
  {
    "id": 1425,
    "question": "Chuck wants to conduct a quantitative risk assessment. Which of the following will he need to be able to determine the single loss expectancy for a server?",
    "choice_a": "Its purchase date",
    "choice_b": "Which department manages the server",
    "choice_c": "The operating system the server uses",
    "choice_d": "The cost of the server",
    "correct_answer": "D",
    "explanation": "SLE, or single loss expectancy, uses the asset value (AV) and exposure factor (EF) to determine the SLE. Purchase date, which department manages the server, and its operating system are not part of the calculation.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      310,
      312,
      303,
      305
    ],
    "source": "9781394211395"
  },
  {
    "id": 1426,
    "question": "Shawna's organization has undertaken reasonable steps to meet their compliance requirements for data handling. What is this process or effort called?",
    "choice_a": "Data stewardship",
    "choice_b": "Due diligence",
    "choice_c": "Attestation",
    "choice_d": "Data sanctioning",
    "correct_answer": "B",
    "explanation": "Undertaking reasonable steps to meet legal requirements like compliance with regulations is known as due diligence. Data stewardship may be part of those actions, but it focuses on oversight of data and data governance and may not be specifically regulatory focused.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      295,
      287,
      317,
      292,
      4
    ],
    "source": "9781394211395"
  },
  {
    "id": 1427,
    "question": "Jeremy knows that his customer data is worth $500,000, and that the value of the data would be reduced by 25 percent if it was exposed. What is the SLE for this data?",
    "choice_a": "$25,000",
    "choice_b": "$125,000",
    "choice_c": "$250,000",
    "choice_d": "$375,000",
    "correct_answer": "B",
    "explanation": "Single loss expectancy, or SLE, is calculated by multiplying the asset value (AV) by the exposure factor (EF). In this case, that means that the potential loss during a loss event would be $125,000.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      310,
      312,
      309,
      305
    ],
    "source": "9781394211395"
  },
  {
    "id": 1428,
    "question": "Ian wants to calculate the annualized loss expectancy for an asset. What two values does he need to know?",
    "choice_a": "SLE and ARO",
    "choice_b": "ARO and MTBF",
    "choice_c": "SLE and RPO",
    "choice_d": "MTBF and RTO",
    "correct_answer": "A",
    "explanation": "Annualized loss expectancy (ALE) is calculated by multiplying the annual rate of occurrence (ARO) by the single loss expectancy (SLE). If a single loss expectancy for a $1,000,000 asset is $100,000 and the annual rate of occurrence is .5\u2014in other words, it happens every two years on average\u2014then the ALE is $50,000.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      310,
      309,
      305,
      314
    ],
    "source": "9781394211395"
  },
  {
    "id": 1429,
    "question": "Waylon is charged with ensuring that risks related to customer data used as part of his organization's primary application are managed appropriately. What is his role?",
    "choice_a": "Board member",
    "choice_b": "Data processor",
    "choice_c": "Auditor",
    "choice_d": "Risk owner",
    "correct_answer": "D",
    "explanation": "Waylon is a risk owner. He is responsible for ensuring that the risks related to data and the application are managed appropriately. Board members have overall responsibility for an organization. Data processors have a data role, not a risk ownership role, and auditors assess organizations against standards and practices rather than owning risk.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      317,
      309,
      310,
      312,
      314
    ],
    "source": "9781394211395"
  },
  {
    "id": 1430,
    "question": "Nathaniel's organization is reviewing potential issues that may result from noncompliance with regulations that apply to his company. Which of the following would create the most significant operational harm?",
    "choice_a": "Reputational damage",
    "choice_b": "Loss of license",
    "choice_c": "Fines",
    "choice_d": "Contractual impacts",
    "correct_answer": "B",
    "explanation": "Without a license to operate, Nathaniel's organization will be unable to conduct business. Reputational damage, fines, and contractual impacts can all be navigated if the organization can continue to do business.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      294,
      309,
      310,
      4,
      3
    ],
    "source": "9781394211395"
  },
  {
    "id": 1431,
    "question": "Susan wants to calculate the annualized loss expectancy for an asset that has a value of $50,000, an exposure factor of 50 percent, and an annual rate of occurrence of 2. What is the annualized loss expectancy for the asset?",
    "choice_a": "$5,000",
    "choice_b": "$25,000",
    "choice_c": "$50,000",
    "choice_d": "$100,000",
    "correct_answer": "C",
    "explanation": "Susan can calculate the single loss expectancy (SLE) by multiplying the asset value (AV) by the exposure factor (EF), resulting in $25,000. If this loss occurs twice a year, then the annualized loss expectancy (ALE) is $50,000.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      310,
      309,
      305,
      307
    ],
    "source": "9781394211395"
  },
  {
    "id": 1432,
    "question": "Tim's organization knows that a major breach occurs once every four years, resulting in a loss of $250,000 for his organization. What is the annual rate of occurrence that Tim should use in his risk calculations?",
    "choice_a": ".25",
    "choice_b": "$75,000",
    "choice_c": ".75",
    "choice_d": "$50,000",
    "correct_answer": "A",
    "explanation": "Annual rate of occurrence is calculated by determining how many times in a year the event happens, on average. If it happens less than once a year, the rate is a fraction based on that rate. Here the event happens once every four years, or .25 of the time during a given year.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      310,
      305,
      307,
      309
    ],
    "source": "9781394211395"
  },
  {
    "id": 1433,
    "question": "Charlene wants to calculate the annualized loss expectancy for a risk event. What two factors does she need to know to calculate the ALE for a risk?",
    "choice_a": "ARO and TCO",
    "choice_b": "SLE and RPO",
    "choice_c": "TCO and RPO",
    "choice_d": "ARO and SLE",
    "correct_answer": "D",
    "explanation": "Annualized loss expectancy is calculated by multiplying the annualized rate of occurrence (ARO) and the single loss expectancy (SLE). Total cost of ownership (TCO) and recovery point objectives (RPO) are not part of this type of risk calculation.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      310,
      309,
      314,
      313
    ],
    "source": "9781394211395"
  },
  {
    "id": 1434,
    "question": "John is conducting a penetration test of a client's network. He is currently gathering information from sources such as <code>archive.org</code>, <code>netcraft.com</code>, social media, and information websites. What best describes this stage?",
    "choice_a": "Active reconnaissance",
    "choice_b": "Passive reconnaissance",
    "choice_c": "Initial exploitation",
    "choice_d": "Pivot",
    "correct_answer": "B",
    "explanation": "Passive reconnaissance is any reconnaissance that is done without actually connecting to the target. In this case, John is conducting a form of OSINT, or open source intelligence, by using commonly available third\u2010party information sources to gather information about his target. Active reconnaissance involves communicating with the target network, such as doing a port scan. The initial exploitation is not information gathering; it is actually breaking into the target network. A pivot is when you have breached one system and use that to move to another system.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      58,
      57,
      61,
      273,
      275
    ],
    "source": "9781394211395"
  },
  {
    "id": 1435,
    "question": "Juan is responsible for incident response at a large financial institution. He discovers that the company Wi\u2010Fi has been breached. The attacker used the same login credentials that ship with the wireless access point (WAP). The attacker was able to use those credentials to access the WAP administrative console and make changes. Which of the following best describes the lack of standards or procedures that caused this vulnerability to exist?",
    "choice_a": "Improperly configured accounts",
    "choice_b": "Untrained users",
    "choice_c": "Using default settings",
    "choice_d": "Failure to patch systems",
    "correct_answer": "C",
    "explanation": "Using default settings is a form of weak configuration and indicates that the organization is not using baselines effectively and may not have appropriate processes and standards in place. Many vulnerability scanners and attack tools have default settings built\u2010in to test with, and default settings are easily obtained for most devices with a quick search of the Internet. Configuring the accounts is not the issue; using default credentials and settings is. Although training users is important, that's not the issue in this scenario. Patching systems is important, but that won't change default settings.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      277,
      275,
      278,
      299,
      312
    ],
    "source": "9781394211395"
  },
  {
    "id": 1436,
    "question": "What is the primary difference between active and passive reconnaissance?",
    "choice_a": "Active will be done manually, passive with tools.",
    "choice_b": "Active is done with unknown environment tests and passive with known environment tests.",
    "choice_c": "Active is usually done by attackers and passive by testers.",
    "choice_d": "Active will actually connect to the network and could be detected; passive won't.",
    "correct_answer": "D",
    "explanation": "Active reconnaissance connects to the network using techniques such as port scanning. Both active and passive reconnaissance can be done manually or with tools. Unknown and known environment tests refer to the amount of information the tester is given. Attackers and testers use both types of reconnaissance.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      58,
      57,
      61
    ],
    "source": "9781394211395"
  },
  {
    "id": 1437,
    "question": "The type and scope of testing, client contact details, how sensitive data will be handled, and the type and frequency of status meetings and reports are all common elements of what artifact of a penetration test?",
    "choice_a": "The unknown environment (black\u2010box) outline",
    "choice_b": "The rules of engagement",
    "choice_c": "The known environment (white\u2010box) outline",
    "choice_d": "The close\u2010out report",
    "correct_answer": "B",
    "explanation": "The rules of engagement for a penetration test typically include the type and scope of testing, client contact information and requirements for when the team should be notified, sensitive data handling requirements, and details of regular status meetings and reports. The remaining options were made up for this question.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      57,
      58,
      290,
      288,
      289
    ],
    "source": "9781394211395"
  },
  {
    "id": 1438,
    "question": "Charlene has been asked to write a business continuity (BC) plan for her organization. Which of the following will a BC plan best handle?",
    "choice_a": "How to respond during a person\u2010made disaster",
    "choice_b": "How to keep the organization running during a system outage",
    "choice_c": "How to respond during a natural disaster",
    "choice_d": "All of the above",
    "correct_answer": "B",
    "explanation": "Unlike a disaster recovery plan that is written to help an organization recovery from a person\u2010made or natural disaster, a business continuity plan focuses on how to keep the business running when it is disrupted. Thus, Charlene's BC plan would detail how to keep the organization running when a system outage occurs.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      4,
      309,
      312,
      310,
      297
    ],
    "source": "9781394211395"
  },
  {
    "id": 1439,
    "question": "Alaina's company is considering signing a contract with a cloud service provider and wants to determine how secure their services are. Which of the following is a method she is likely to be able to use to assess it?",
    "choice_a": "Ask for permission to vulnerability scan the vendor's production service.",
    "choice_b": "Conduct an audit of the organization.",
    "choice_c": "Review an existing SOC audit.",
    "choice_d": "Hire a third party to audit the organization.",
    "correct_answer": "C",
    "explanation": "Many cloud service providers do not allow customer\u2010driven audits, either by the customer or a third party. They also commonly prohibit vulnerability scans of their production environment to avoid service outages. Instead, many provide third\u2010party audit results in the form of a service organization controls (SOC) report or similar audit artifact.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      308,
      287,
      290,
      309,
      310
    ],
    "source": "9781394211395"
  },
  {
    "id": 1440,
    "question": "Gurvinder's corporate datacenter is located in an area that FEMA has identified as being part of a 100\u2010year flood plain. He knows that there is a chance in any given year that his datacenter could be completely flooded and underwater, and he wants to ensure that his organization knows what to do if that happens. What type of plan should he write?",
    "choice_a": "A continuity of operations plan",
    "choice_b": "A business continuity plan",
    "choice_c": "A flood insurance plan",
    "choice_d": "A disaster recovery plan",
    "correct_answer": "D",
    "explanation": "A disaster recovery plan addresses what to do during a person\u2010made or natural disaster. A flood that completely fills a datacenter would require significant efforts to recover from, and Gurvinder will need a solid disaster recovery plan\u2014and perhaps a new datacenter location as soon as possible! A COOP, or continuity of operations plan, is needed for U.S. government agencies but is not required for businesses. A business continuity plan would cover how to keep the business running, but it does not cover all the requirements in a natural disaster of this scale, and a flood insurance plan is not a term used in the Security+ exam objectives.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      309,
      310,
      312,
      304,
      275
    ],
    "source": "9781394211395"
  },
  {
    "id": 1441,
    "question": "Which of the following environments is least likely to allow a right\u2010to\u2010audit clause in a contract?",
    "choice_a": "A datacenter co\u2010location facility in your state",
    "choice_b": "A rented facility for a corporate headquarters",
    "choice_c": "A cloud server provider",
    "choice_d": "A datacenter co\u2010location facility in the same country but not the same state",
    "correct_answer": "C",
    "explanation": "Right\u2010to\u2010audit clauses are commonly accepted as part of service and leasing contracts regardless of location for datacenter co\u2010location and facility rental contracts. Cloud service providers, however, are less likely to sign a right\u2010to\u2010audit contract. Instead, they may provide third\u2010party audit data to customers or even to potential customers.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      289,
      287,
      290,
      308,
      293
    ],
    "source": "9781394211395"
  },
  {
    "id": 1442,
    "question": "Ben writes down the checklist of steps that his organization will perform in the event of a cryptographic malware infection. What type of response document has he created?",
    "choice_a": "A playbook",
    "choice_b": "A DR plan",
    "choice_c": "A BC plan",
    "choice_d": "A runbook",
    "correct_answer": "A",
    "explanation": "Playbooks list the actions that an organization will take as part of a response process. A runbook lists the steps required to perform an action like notification, removing malware, or similar tasks. Playbooks tend to be used to document processes, whereas runbooks tend to be used for specific actions. A disaster recovery (DR) plan is used to recover from disasters, and a business continuity (BC) plan is used to ensure that the organization continues to function.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      278,
      275,
      276,
      281,
      57
    ],
    "source": "9781394211395"
  },
  {
    "id": 1443,
    "question": "Caroline has been asked to find an international standard to guide her company's choices in implementing information security management systems. Which of the following would be the best choice for her?",
    "choice_a": "ISO 27002",
    "choice_b": "ISO 27701",
    "choice_c": "NIST 800\u201012",
    "choice_d": "NIST 800\u201053",
    "correct_answer": "A",
    "explanation": "Caroline should select ISO 27002. ISO 27002 is an international standard for implementing and maintaining information security systems. ISO 27701 is an international standard security technique for privacy information management systems; NIST 800\u201012 is a general security standard and it is a US standard, not an international one; and NIST 800\u201053 is a collection of security and privacy controls for information systems and organizations.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      298,
      277,
      292,
      296,
      273
    ],
    "source": "9781394211395"
  },
  {
    "id": 1444,
    "question": "Which of the following principles stipulates that multiple changes to a computer system should not be made at the same time?",
    "choice_a": "Due diligence",
    "choice_b": "Acceptable use",
    "choice_c": "Change management",
    "choice_d": "Due care",
    "correct_answer": "C",
    "explanation": "Change management is the process of documenting all changes made to a company's network and computers. Avoiding making changes at the same time makes tracking any problems that can occur much simpler. Due diligence is the process of investigation and verification of the accuracy of a particular act. Acceptable use policies state what actions and practices are allowed in an organization while using technology. Due care is the effort made by a reasonable party to avoid harm to another. It is the level of judgment, care, determination, and activity a person would reasonably expect to do under certain conditions.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      276,
      275,
      280,
      7,
      290
    ],
    "source": "9781394211395"
  },
  {
    "id": 1445,
    "question": "You are a security engineer and discovered an employee using the company's computer systems to operate their small business. The employee installed their personal software on the company's computer and is using the computer hardware, such as the USB port. What policy would you recommend the company implement to prevent any risk of the company's data and network being compromised?",
    "choice_a": "Acceptable use policy",
    "choice_b": "Clean desk policy",
    "choice_c": "Mandatory vacation policy",
    "choice_d": "Job rotation policy",
    "correct_answer": "A",
    "explanation": "An acceptable use policy (AUP) is a document stating what a user may or may not have access to on a company's network or the Internet. A clean desk policy ensures that all sensitive/confidential documents are removed from an end\u2010user workstation and locked up when the documents are not in use. Mandatory vacation policy is used by companies to detect fraud by having a second person, familiar with the duties, help discover any illicit activities. Job rotation is a policy that describes the practice of moving employees between different tasks. Job rotation can help detect fraud because employees cannot perform the same actions for long periods of time.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      276,
      275,
      277,
      286,
      280
    ],
    "source": "9781394211395"
  },
  {
    "id": 1446,
    "question": "What standard is used for credit card security?",
    "choice_a": "GDPR",
    "choice_b": "COPPA",
    "choice_c": "PCI DSS",
    "choice_d": "CIS",
    "correct_answer": "C",
    "explanation": "The PCI DSS, or Payment Card Industry Data Security Standard, is a security standard that is mandated by credit card vendors. The Payment Card Industry Security Standards Council is responsible for updates and changes to the standard. GDPR, or the General Data Protection Regulation, is a standard for data privacy and security in the European Union (EU). COPPA is the Children's Online Privacy Protection Act, a U.S. federal law. CIS is the Center for Internet Security and is not a law or a regulation.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      292,
      277,
      293,
      280,
      7
    ],
    "source": "9781394211395"
  },
  {
    "id": 1447,
    "question": "Which of the following techniques attempts to predict the likelihood a threat will occur and assigns monetary values should a loss occur?",
    "choice_a": "Change management",
    "choice_b": "Vulnerability assessment",
    "choice_c": "Qualitative risk assessment",
    "choice_d": "Quantitative risk assessment",
    "correct_answer": "D",
    "explanation": "Quantitative risk assessment is the process of assigning numerical values to the probability an event will occur and what the impact of the event will have. Change management is the process of managing configuration changes made to a network. Vulnerability assessment attempts to identify, quantify, and rank the weaknesses in a system. Qualitative risk assessment is the process of ranking which risk poses the most danger using ratings like low, medium, and high.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      307,
      310,
      312,
      309
    ],
    "source": "9781394211395"
  },
  {
    "id": 1448,
    "question": "Which of the following agreements is less formal than a traditional contract but still has a certain level of importance to all parties involved?",
    "choice_a": "SLA",
    "choice_b": "BPA",
    "choice_c": "ISA",
    "choice_d": "MOU",
    "correct_answer": "D",
    "explanation": "A memorandum of understanding (MOU) is a type of agreement that is usually not legally binding. This agreement is intended to be mutually beneficial without involving courts or money. An SLA (service level agreement) defines the level of service the customer expects from the service provider. The level of service definitions should be specific and measurable in each area. A BPA (business partner agreement) is a legal agreement between partners. It establishes the terms, conditions, and expectations of the relationship between the partners. An ISA (interconnection security agreement) is an agreement that specifies the technical and security requirements of the interconnection between organizations.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      289,
      290,
      287,
      58,
      57
    ],
    "source": "9781394211395"
  },
  {
    "id": 1449,
    "question": "You have an asset that is valued at $16,000, the exposure factor of a risk affecting that asset is 35 percent, and the annualized rate of occurrence is 75 percent. What is the SLE?",
    "choice_a": "$5,600",
    "choice_b": "$5,000",
    "choice_c": "$4,200",
    "choice_d": "$3,000",
    "correct_answer": "A",
    "explanation": "The single loss expectancy (SLE) is the product of the asset value ($16,000) and the exposure factor (.35), or $5,600.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      310,
      307,
      305,
      312
    ],
    "source": "9781394211395"
  },
  {
    "id": 1450,
    "question": "You are a security administrator for your company and you identify a security risk. You decide to continue with the current security plan. However, you develop a contingency plan in case the security risk occurs. Which of the following type of risk response technique are you demonstrating?",
    "choice_a": "Accept",
    "choice_b": "Transfer",
    "choice_c": "Avoid",
    "choice_d": "Mitigate",
    "correct_answer": "A",
    "explanation": "Risk acceptance is a strategy of recognizing, identifying, and accepting a risk that is sufficiently unlikely or that has such limited impact that a corrective control is not warranted. Risk transfer is the act of moving the risk to hosted providers who assume the responsibility for recovery and restoration or by acquiring insurance to cover the costs emerging from a risk. Risk avoidance is the removal of the vulnerability that can increase a particular risk so that it is avoided altogether. Risk mitigation is when a company implements controls to reduce vulnerabilities or weaknesses in a system. It can also reduce the impact of a threat.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      309,
      313,
      310,
      311,
      312
    ],
    "source": "9781394211395"
  },
  {
    "id": 1451,
    "question": "Which of the following is not a common security policy type?",
    "choice_a": "Acceptable use policy",
    "choice_b": "Business continuity",
    "choice_c": "Incident response",
    "choice_d": "Parking policy",
    "correct_answer": "D",
    "explanation": "A parking policy generally outlines parking provisions for employees and visitors. This includes the criteria and procedures for allocating parking spaces for employees and is not a part of organizational security policy. Instead, it is an operational or business policy. An acceptable use policy (AUP) describes the limits and guidelines for users to make use of an organization's physical and intellectual resources. This includes allowing or limiting the use of personal email during work hours. Business continuity policies describe how the organization approaches business continuity efforts, and incident response (IR) policies document the organization's IR intentions and high\u2010level goals.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      275,
      276,
      278,
      279,
      277
    ],
    "source": "9781394211395"
  },
  {
    "id": 1452,
    "question": "Your security manager wants to decide which risks to mitigate based on cost. What is this an example of?",
    "choice_a": "Quantitative risk assessment",
    "choice_b": "Qualitative risk assessment",
    "choice_c": "Business impact analysis",
    "choice_d": "Threat assessment",
    "correct_answer": "A",
    "explanation": "Quantitative risk assessment is the process of assigning numerical values like cost and frequency of occurrence to the probability an event will occur and what impact the event will have, and thus directly evaluates the cost of a risk occurring. Qualitative risk assessment is the process of ranking which risk poses the most danger such as low, medium, and high. A business impact analysis (BIA) is used to evaluate the possible effect a business can suffer should an interruption to critical system operations occur. This interruption could be as a result of an accident, emergency, or disaster. Threat assessment is the process of identifying and categorizing different threats such as environmental and person\u2010made. It also attempts to identify the potential impact from the threats.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      310,
      309,
      307,
      312
    ],
    "source": "9781394211395"
  },
  {
    "id": 1453,
    "question": "Your company has outsourced its proprietary processes to Acme Corporation. Due to technical issues, Acme wants to include a third\u2010party vendor to help resolve the technical issues. Which of the following must Acme consider before sending data to the third party?",
    "choice_a": "This data should be encrypted before it is sent to the third\u2010party vendor.",
    "choice_b": "This may constitute unauthorized data sharing.",
    "choice_c": "This may violate the privileged user role\u2010based awareness training.",
    "choice_d": "This may violate a nondisclosure agreement.",
    "correct_answer": "D",
    "explanation": "A nondisclosure agreement (NDA) protects sensitive and intellectual data from getting into the wrong hands. An NDA is a legal contract between the company and a third\u2010party vendor to not disclose information per the agreement. Encrypted data that is sent can still be decrypted by the third\u2010party vendor if they have the appropriate certificate or the key but does not restrict access to the data. Violating an NDA would constitute unauthorized data sharing, and a violation of privileged user role\u2010based awareness training has nothing to do with sharing proprietary information.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      286,
      289,
      287,
      288,
      309
    ],
    "source": "9781394211395"
  },
  {
    "id": 1454,
    "question": "Which of the following is typically included in a BPA?",
    "choice_a": "Clear statements detailing the expectation between a customer and a service provider",
    "choice_b": "The agreement that a specific function or service will be delivered at the agreed\u2010on level of performance",
    "choice_c": "Sharing of profits and losses and the addition or removal of a partner",
    "choice_d": "Security requirements associated with interconnecting IT systems",
    "correct_answer": "C",
    "explanation": "Sharing of profits and losses and the addition or removal of a partner, as well as the responsibilities of each partner, are typically included in a BPA (business partner agreement). Expectations between parties such as a company and an Internet service provider are typically found in a service level agreement (SLA). Expectations include the level of performance given during the contractual service. An SLA will provide a clear means of determining whether a specific function or service has been provided according to the agreed\u2010on level of performance. Security requirements associated with interconnecting IT systems are typically found in an interconnection security agreement, or ISA.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      289,
      290,
      287,
      291,
      293
    ],
    "source": "9781394211395"
  },
  {
    "id": 1455,
    "question": "A security administrator is reviewing the company's continuity plan, and it specifies an RTO of four hours and an RPO of one day. Which of the following is the plan describing?",
    "choice_a": "Systems should be restored within one day and should remain operational for at least four hours.",
    "choice_b": "Systems should be restored within four hours and no later than one day after the incident.",
    "choice_c": "Systems should be restored within one day and lose, at most, four hours' worth of data.",
    "choice_d": "Systems should be restored within four hours with a loss of one day's worth of data at most.",
    "correct_answer": "D",
    "explanation": "Systems should be restored within four hours with a minimum loss of one day's worth of data. The RTO (recovery time objective) is the amount of time within which a process or service must be restored after a disaster to meet business continuity. It defines how much time it takes to recover after notification of process disruption. The recovery point objective, or RPO, specifies the amount of time that can pass before the amount of data lost may exceed the organization's maximum tolerance for data loss.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      309,
      310,
      313,
      289,
      4
    ],
    "source": "9781394211395"
  },
  {
    "id": 1456,
    "question": "Which of the following statements is true regarding a data retention policy?",
    "choice_a": "Regulations require financial transactions to be stored for seven years.",
    "choice_b": "Employees must remove and lock up all sensitive and confidential documents when not in use.",
    "choice_c": "It describes a formal process of managing configuration changes made to a network.",
    "choice_d": "It is a legal document that describes a mutual agreement between parties.",
    "correct_answer": "A",
    "explanation": "A data retention policy defines how long an organization will keep data. Removing sensitive documents not in use is a clean desk policy. A formal process for managing configuration changes is change management, and a memorandum of understanding consists of legal documents that describe mutual agreement between two parties.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      320,
      275,
      276,
      277,
      278
    ],
    "source": "9781394211395"
  },
  {
    "id": 1457,
    "question": "How do you calculate the annual loss expectancy (ALE) that may occur due to a threat?",
    "choice_a": "Exposure factor (EF) / single loss expectancy (SLE)",
    "choice_b": "Single loss expectancy (SLE) \u00d7 annual rate of occurrence (ARO)",
    "choice_c": "Asset value (AV) \u00d7 exposure factor (EF)",
    "choice_d": "Single loss expectancy (SLE) / exposure factor (EF)",
    "correct_answer": "B",
    "explanation": "ALE (annual loss expectancy) is the product of the ARO (annual rate of occurrence) and the SLE (single loss expectancy) and is mathematically expressed as ALE = ARO \u00d7 SLE. Single loss expectancy is the cost of any single loss, and it is mathematically expressed as SLE = AV (asset value) \u00d7 EF (exposure factor).",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      310,
      305,
      312,
      309
    ],
    "source": "9781394211395"
  },
  {
    "id": 1458,
    "question": "You are a security administrator for your company and you identify a security risk that you do not have in\u2010house skills to address. You decide to acquire contract resources. The contractor will be responsible for handling and managing this security risk. Which of the following type of risk response techniques are you demonstrating?",
    "choice_a": "Accept",
    "choice_b": "Mitigate",
    "choice_c": "Transfer",
    "choice_d": "Avoid",
    "correct_answer": "C",
    "explanation": "Risk transfer is the act of moving the risk to hosted providers who assume the responsibility for recovery and restoration or by acquiring insurance to cover the costs emerging from a risk. Risk acceptance is a strategy of recognizing, identifying, and accepting a risk that is sufficiently unlikely or that has such limited impact that a corrective control is not warranted. Risk mitigation is when a company implements controls to reduce vulnerabilities or weaknesses in a system. It can also reduce the impact of a threat. Risk avoidance is the removal of the vulnerability that can increase a particular risk so that it is avoided altogether.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      309,
      310,
      287,
      290,
      308
    ],
    "source": "9781394211395"
  },
  {
    "id": 1459,
    "question": "You are a server administrator for your company's private cloud. To provide service to employees, you are instructed to use reliable hard disks in the server to host a virtual environment. Which of the following best describes the reliability of hard drives?",
    "choice_a": "MTTR",
    "choice_b": "RPO",
    "choice_c": "MTBF",
    "choice_d": "ALE",
    "correct_answer": "C",
    "explanation": "The mean time between failures (MTBF) is a measure of the reliability of a system or component. It is the expected amount of time that will elapse between system or device failures. MTTR (mean time to repair) is the average time it takes for a failed device or component to be repaired or replaced. An RPO (recovery point objective) is the period of time a company can tolerate lost data being unrecoverable between backups. ALE (annual loss expectancy) is the product of the annual rate of occurrence (ARO) and the single loss expectancy (SLE).",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      310,
      306,
      307,
      289,
      299
    ],
    "source": "9781394211395"
  },
  {
    "id": 1460,
    "question": "Which of the following best describes a key challenge of quantitative risk analysis compared to qualitative risk analysis?",
    "choice_a": "Quantitative risk analysis requires detailed financial data.",
    "choice_b": "Quantitative risk analysis is sometimes subjective.",
    "choice_c": "Quantitative risk analysis requires expertise on systems and infrastructure.",
    "choice_d": "Quantitative risk provides clear answers to risk\u2010based questions.",
    "correct_answer": "A",
    "explanation": "Quantitative risk analysis requires complex calculations and is more time\u2010consuming because it requires detailed financial data and calculations. Quantitative risk assessment is often subjective and requires expertise on systems and infrastructure, and both types of assessment can provide clear answers on risk\u2010based questions.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      307,
      310,
      312,
      314
    ],
    "source": "9781394211395"
  },
  {
    "id": 1461,
    "question": "Categorizing residual risk is most important to which of the following risk response techniques?",
    "choice_a": "Risk mitigation",
    "choice_b": "Risk acceptance",
    "choice_c": "Risk avoidance",
    "choice_d": "Risk transfer",
    "correct_answer": "B",
    "explanation": "Risk acceptance is a strategy of recognizing, identifying, and accepting a risk that is sufficiently unlikely or that has such limited impact that a corrective control is not warranted. Risk mitigation is when a company implements controls to reduce vulnerabilities or weaknesses in a system. It can also reduce the impact of a threat. Risk avoidance is the removal of the vulnerability that can increase a particular risk so that it is avoided altogether. Risk transfer is the act of moving the risk to other organizations like insurance providers or hosting companies who assume the responsibility for recovery and restoration or by acquiring insurance to cover the costs emerging from a risk.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      312,
      309,
      313,
      310,
      314
    ],
    "source": "9781394211395"
  },
  {
    "id": 1462,
    "question": "You are the IT manager and one of your employees asks who assigns data labels. Which of the following assigns data labels?",
    "choice_a": "Owner",
    "choice_b": "Custodian",
    "choice_c": "Privacy officer",
    "choice_d": "System administrator",
    "correct_answer": "A",
    "explanation": "Data owners assign labels such as top secret to data. Custodians assign security controls to data. A privacy officer ensures that companies comply with privacy laws and regulations. System administrators are responsible for the overall functioning of IT systems.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      317,
      276,
      275,
      272,
      302
    ],
    "source": "9781394211395"
  },
  {
    "id": 1463,
    "question": "A security analyst is analyzing the cost the company could incur if the customer database was breached. The database contains 2,500 records with personally identifiable information (PII). Studies show the cost per record would be $300. The likelihood that the database would be breached in the next year is only 5 percent. Which of the following would be the ALE for a security breach?",
    "choice_a": "$15,000",
    "choice_b": "$37,500",
    "choice_c": "$150,000",
    "choice_d": "$750,000",
    "correct_answer": "B",
    "explanation": "ALE (annual loss expectancy) = SLE (single loss expectancy) \u00d7 ARO (annualized rate of occurrence). SLE equals $750,000 (2,500 records \u00d7 $300), and ARO equals 5%, so $750,000 times 5% equals $37,500.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      306,
      310,
      309,
      312,
      305
    ],
    "source": "9781394211395"
  },
  {
    "id": 1464,
    "question": "Which of the following concepts defines a company goal for system restoration and acceptable data loss?",
    "choice_a": "MTBF",
    "choice_b": "MTTR",
    "choice_c": "RPO",
    "choice_d": "ARO",
    "correct_answer": "C",
    "explanation": "RPO (recovery point objective) specifies the allowable data loss. It is the amount of time that can pass during an interruption before the quantity of data lost during that period surpasses business continuity planning's maximum acceptable threshold. MTBF (mean time between failures) is the rating on a device or component that predicts the expected time between failures. MTTR (mean time to repair) is the average time it takes for a failed device or component to be repaired or replaced. ARO (annual rate of occurrence) is the ratio of an estimated possibility that a threat will take place within a one\u2010year time frame.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      306,
      310,
      312,
      313,
      4
    ],
    "source": "9781394211395"
  },
  {
    "id": 1465,
    "question": "You are a network administrator and have been given the duty of creating user accounts for new employees the company has hired. These employees are added to the identity and access management (IAM) system and assigned mobile devices. What process are you performing?",
    "choice_a": "Offboarding",
    "choice_b": "System owner",
    "choice_c": "Onboarding",
    "choice_d": "Executive user",
    "correct_answer": "C",
    "explanation": "Onboarding is the process of adding an employee to a company's identity and access management system. Offboarding is the process of removing an employee from the company's identity and access management system. A system owner is an individual who is in charge of managing one or more systems and can include patching and updating operating systems. An executive user was made up for this question.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      286,
      317,
      276,
      287,
      301
    ],
    "source": "9781394211395"
  },
  {
    "id": 1466,
    "question": "Visa's published documentation for \u201cWhat to Do if Compromised\u201d includes requirements to notify Visa within 3 days of an incident, to provide notice to other relevant parties, and to conduct forensic investigations while preserving evidence. What type of document is this?",
    "choice_a": "A policy",
    "choice_b": "A playbook",
    "choice_c": "A checklist",
    "choice_d": "A procedure",
    "correct_answer": "D",
    "explanation": "This is a procedure, which documents what you should do in general terms. A policy lays out an organization's intent, and this is more specific than that. A playbook has specific, detailed action, and this procedure does not include that level of detail. Checklists are a step\u2010by\u2010step guide to accomplishing a task, and this document outlines required steps, not step\u2010by\u2010step detail.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      275,
      277,
      279,
      292,
      293
    ],
    "source": "9781394211395"
  },
  {
    "id": 1467,
    "question": "An organization's information security policy framework typically contains what four types of documents?",
    "choice_a": "A risk register, an audit report, a vulnerability scan, and a pentest report",
    "choice_b": "Policies, standards, procedures, and guidelines",
    "choice_c": "Laws, policies, standards, and practices",
    "choice_d": "Policies, practices, procedures, and playbooks",
    "correct_answer": "B",
    "explanation": "Organizational policy frameworks typically contain policies, standards and procedures that support and expand on the policy, and guidelines. Risk registers, audit reports, vulnerability scans, and pentest reports are all artifacts organizations generate in support of information security practices. Laws are not part of a policy framework but may influence it.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      275,
      277,
      279,
      276,
      281
    ],
    "source": "9781394211395"
  },
  {
    "id": 1468,
    "question": "Which of the following terms is used to measure how maintainable a system or device is?",
    "choice_a": "MTBF",
    "choice_b": "MTTF",
    "choice_c": "MTTR",
    "choice_d": "MITM",
    "correct_answer": "C",
    "explanation": "The mean time to repair (MTTR) for a system or devices is the average time that it will take to repair it if it fails. The MTTR is used as part of business continuity planning to determine if a system needs additional redundancy or other options put in place if a failure and repair would exceed the maximum tolerable outage. It is calculated by dividing the total maintenance time by the total number of repairs. MTBF is the mean time between failures, MTTF the mean time to failure, and MITM is an on\u2010path attack.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      4,
      310,
      309,
      312,
      289
    ],
    "source": "9781394211395"
  },
  {
    "id": 1469,
    "question": "Helen's organization provides telephone support for their entire customer base as a critical business function. She has created a plan that will ensure that her organization's Voice over IP (VoIP) phones will be restored in the event of a tornado. What type of plan has she created?",
    "choice_a": "A disaster recovery plan",
    "choice_b": "An RPO plan",
    "choice_c": "An incident response plan",
    "choice_d": "An MTBF plan",
    "correct_answer": "A",
    "explanation": "Helen has created a disaster recovery plan (DRP). RPOs, or recovery point objectives, are set to determine how much data may be lost if an event or incident occurs; incident response plans focus on incidents, not outages or disasters; and MTBF, or mean time between failures, is not a type of plan.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      310,
      312,
      4,
      278,
      289
    ],
    "source": "9781394211395"
  },
  {
    "id": 1470,
    "question": "Greg has data that is classified as health information that his organization uses as part of their company's HR data. Which of the following statements is true for his company's security policy?",
    "choice_a": "The health information must be encrypted.",
    "choice_b": "Greg should review relevant law to ensure the health information is handled properly.",
    "choice_c": "Companies are prohibited from storing health information and must outsource to third parties.",
    "choice_d": "All of the above.",
    "correct_answer": "B",
    "explanation": "Personal health information (PHI) may be covered by state, local, or federal law, and Greg's organization should ensure that they understand any applicable laws before storing, processing, or handling health information.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      292,
      4,
      317,
      275,
      294
    ],
    "source": "9781394211395"
  },
  {
    "id": 1471,
    "question": "What type of impact is an individual most likely to experience if a data breach that includes PII occurs?",
    "choice_a": "IP theft",
    "choice_b": "Reputation damage",
    "choice_c": "Fines",
    "choice_d": "Identity theft",
    "correct_answer": "D",
    "explanation": "An individual is most likely to face identity theft issues if their personally identifiable information (PII) is stolen or breached.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      3,
      317,
      304,
      306,
      307
    ],
    "source": "9781394211395"
  },
  {
    "id": 1472,
    "question": "Isaac has been asked to write his organization's access control standards. What policy is commonly put in place for service accounts?",
    "choice_a": "They must be issued only to system administrators.",
    "choice_b": "They must use multifactor authentication.",
    "choice_c": "They cannot use interactive logins.",
    "choice_d": "All of the above.",
    "correct_answer": "C",
    "explanation": "It is common practice to prohibit interactive logins to a GUI or shell for service accounts. Use of a service account for interactive logins or attempting to log in as one should be immediately flagged and alerted on as an indicator of compromise (IoC).",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      277,
      275,
      276,
      280,
      300
    ],
    "source": "9781394211395"
  },
  {
    "id": 1473,
    "question": "Emma is reviewing third\u2010party risks to her organization, and Nate, her organization's procurement officer, notes that purchases of some laptops from the company's hardware vendor have been delayed due to lack of availability of SSDs (solid\u2010state drives) and specific CPUs (central processing units) for specific configurations. What type of risk should Emma describe this as?",
    "choice_a": "Financial risk",
    "choice_b": "A lack of vendor support",
    "choice_c": "System integration",
    "choice_d": "Supply chain",
    "correct_answer": "D",
    "explanation": "Emma should categorize this as a supply chain risk. When organizations cannot get the systems, equipment, and supplies they need to operate, it can have a significant impact on their ability to conduct business. That could create financial risk, but financial risk is not the direct risk here. There is no indication that the vendor will not support the systems, nor is there any information about whether there is an integration issue in the description.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      308,
      304,
      310,
      309,
      288
    ],
    "source": "9781394211395"
  },
  {
    "id": 1474,
    "question": "Patching systems immediately after patches are released is an example of what risk management strategy?",
    "choice_a": "Acceptance",
    "choice_b": "Avoidance",
    "choice_c": "Mitigation",
    "choice_d": "Transference",
    "correct_answer": "B",
    "explanation": "Patching is a form of avoidance because it works to remove a risk from the environment. Acceptance of flaws that need patching would involve leaving the software unpatched; mitigation strategies might include firewalls, intrusion prevention systems (IPSs), or web application firewall (WAF) devices; and transference options include third\u2010party hosting or services.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      309,
      310,
      312,
      311,
      303
    ],
    "source": "9781394211395"
  },
  {
    "id": 1475,
    "question": "What key element of regulations, like the European Union's GDPR, drive organizations to include them in their overall assessment of risk posture?",
    "choice_a": "Potential fines",
    "choice_b": "Their annual loss expectancy (ALE)",
    "choice_c": "Their recovery time objective (RTO)",
    "choice_d": "The likelihood of occurrence",
    "correct_answer": "A",
    "explanation": "The fines that can result from violation or infringement of regulations like the General Data Protection Regulation (GDPR) can have a significant impact on an organization, or could even potentially put it out of business. Due to this, organizations will track compliance with regulations as part of their risk posture.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      294,
      310,
      312,
      313,
      295
    ],
    "source": "9781394211395"
  },
  {
    "id": 1476,
    "question": "What phases of handling a disaster are covered by a disaster recovery plan?",
    "choice_a": "What to do before the disaster",
    "choice_b": "What to do during the disaster",
    "choice_c": "What to do after the disaster",
    "choice_d": "All of the above",
    "correct_answer": "D",
    "explanation": "Disaster recovery requires forethought and preparation, response to issues to minimize impact during a disaster, and response activities after a disaster. Thus, a complete disaster recovery plan should include actions that may or will occur before, during, and after a disaster, and not just the recovery process after the fact.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      309,
      296,
      278,
      4,
      297
    ],
    "source": "9781394211395"
  },
  {
    "id": 1477,
    "question": "Naomi's organization has recently experienced a breach of credit card information. After investigation, it is discovered that her organization was inadvertently not fully compliant with PCI DSS and is not currently fully compliant. Which of the following penalties is her organization most likely to incur?",
    "choice_a": "Criminal charges",
    "choice_b": "Fines",
    "choice_c": "Termination of the credit card processing agreement",
    "choice_d": "All of the above",
    "correct_answer": "B",
    "explanation": "Although data breaches could result in termination of a card processing agreement, the fact that her organization is noncompliant is most likely to result in a fine. PCI DSS, or Payment Card Industry Data Security Standard, is a vendor standard, not a law, and criminal charges would not typically be filed in a situation like this.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      294,
      292,
      280,
      293,
      7
    ],
    "source": "9781394211395"
  },
  {
    "id": 1478,
    "question": "What law or regulation requires a DPO in organizations?",
    "choice_a": "FISMA",
    "choice_b": "COPPA",
    "choice_c": "PCI DSS",
    "choice_d": "GDPR",
    "correct_answer": "D",
    "explanation": "The General Data Protection Regulation, or GDPR, requires a data protection officer (DPO). They oversee the organization's data protection strategy and implementation, and make sure that the organization complies with the GDPR.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      292,
      317,
      273,
      298,
      320
    ],
    "source": "9781394211395"
  },
  {
    "id": 1479,
    "question": "Your company is considering moving its mail server to a hosting company. This will help reduce hardware and server administrator costs at the local site. Which of the following documents would formally state the reliability and recourse if the reliability is not met?",
    "choice_a": "MOU",
    "choice_b": "SLA",
    "choice_c": "ISA",
    "choice_d": "BPA",
    "correct_answer": "B",
    "explanation": "An SLA (service level agreement) defines the level of service the customer expects from the service provider. The level of service definitions should be specific and measurable in each area. An MOU (memorandum of understanding) is a legal document that describes a mutual agreement between parties. An ISA (interconnection security agreement) is an agreement that specifies the technical and security requirements of the interconnection between organizations. A BPA (business partners agreement) is a legal agreement between partners. It establishes the terms, conditions, and expectations of the relationship between the partners.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      289,
      287,
      308,
      309,
      286
    ],
    "source": "9781394211395"
  },
  {
    "id": 1480,
    "question": "Risk severity is calculated using the equation shown here. What information should be substituted for X? <b></b> <p>Risk severity = X * Impact</p>",
    "choice_a": "Inherent risk",
    "choice_b": "MTTR (mean time to repair)",
    "choice_c": "Likelihood of occurrence",
    "choice_d": "RTO (recovery time objective)",
    "correct_answer": "C",
    "explanation": "The likelihood of occurrence, or probability, is multiplied by the impact to determine a risk's severity.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      310,
      307,
      305,
      312
    ],
    "source": "9781394211395"
  },
  {
    "id": 1481,
    "question": "How is asset value determined?",
    "choice_a": "The original cost of the item",
    "choice_b": "The depreciated cost of the item",
    "choice_c": "The cost to replace the item",
    "choice_d": "Any of the above based on organizational preference",
    "correct_answer": "D",
    "explanation": "Organizations can determine how they want to determine asset value, but consistency is important in many cases. Thus, the original cost, the replacement cost, or a depreciated cost may be used.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      306,
      310,
      312,
      309,
      305
    ],
    "source": "9781394211395"
  },
  {
    "id": 1482,
    "question": "What process is used to help identify critical systems?",
    "choice_a": "A BIA",
    "choice_b": "An MTBF",
    "choice_c": "An RTO",
    "choice_d": "An ICD",
    "correct_answer": "A",
    "explanation": "A business impact analysis (BIA) helps to identify critical systems by determining which systems will create the largest impact if they are not available. MTBF is the mean time between failures, an RTO is a recovery time objective, and an ICD was made up for this question.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      310,
      306,
      307,
      314,
      309
    ],
    "source": "9781394211395"
  },
  {
    "id": 1483,
    "question": "Zarmeena wants to transfer the risk for breaches to another organization. Which of the following options should she use to transfer the risk?",
    "choice_a": "Explain to her management that breaches will occur.",
    "choice_b": "Blame future breaches on competitors.",
    "choice_c": "Sell her organization's data to another organization.",
    "choice_d": "Purchase cybersecurity insurance.",
    "correct_answer": "D",
    "explanation": "The most common means of transferring breach risk is to purchase cybersecurity insurance. Accepting breaches is rarely considered a valid risk process, blaming breaches on competitors does not actually transfer risk, and selling data to another organization is not a risk handling process but may be a business process.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      309,
      310,
      289,
      314,
      311
    ],
    "source": "9781394211395"
  },
  {
    "id": 1484,
    "question": "The financial cost of a breach is an example of what component of risk calculations?",
    "choice_a": "Probability",
    "choice_b": "Risk severity",
    "choice_c": "Impact",
    "choice_d": "All of the above",
    "correct_answer": "C",
    "explanation": "The cost of a breach is an example of the impact of a breach. Probability is how likely the risk is to occur, and risk severity is calculated by multiplying probability and impact.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      306,
      310,
      312,
      309,
      314
    ],
    "source": "9781394211395"
  },
  {
    "id": 1485,
    "question": "Joanna's penetration test target is an unknown environment that is isolated from the Internet and requires VPN access. What type of testing will she need to do to gather vulnerability information from systems?",
    "choice_a": "Passive reconnaissance",
    "choice_b": "OSINT reconnaissance",
    "choice_c": "Active reconnaissance",
    "choice_d": "Known environment reconnaissance",
    "correct_answer": "C",
    "explanation": "Gathering vulnerability information for a system that isn't scannable from the Internet will require active reconnaissance as part of the penetration testing effort. OSINT and passive reconnaissance do not involve active scans, and known environments provide full knowledge of the environment.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      57,
      58,
      61,
      305,
      310
    ],
    "source": "9781394211395"
  },
  {
    "id": 1486,
    "question": "Olivia's cloud service provider claims to provide zero data loss from storage, and Olivia's company wants to take advantage of that service because loss of data would be extremely costly for the business. What business agreement can Oliva put in place to help ensure that the reliability that the vendor advertises is maintained?",
    "choice_a": "An MOU",
    "choice_b": "An SLA",
    "choice_c": "An MSA",
    "choice_d": "A BPA",
    "correct_answer": "B",
    "explanation": "Olivia should establish a service level agreement (SLA) with her provider to ensure that they meet the expected level of service. If they don't, financial or other penalties are typically included. Olivia should ensure that those penalties are meaningful to her vendor to make sure they are motivated to meet the SLA. An MOU is a memorandum of understanding and explains the relationship between two organizations; an MSA is a master services agreement, which establishes a business relationship under which additional work orders or other documentation describe the actual work that is done; and a BPA is a business partners agreement, which is used when companies wish to partner on efforts and may outline division of profits or responsibilities in the partnership.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      289,
      290,
      287,
      308,
      310
    ],
    "source": "9781394211395"
  },
  {
    "id": 1487,
    "question": "How is SLE calculated?",
    "choice_a": "AV * EF",
    "choice_b": "RTO * AV",
    "choice_c": "MTTR * EF",
    "choice_d": "AV * ARO",
    "correct_answer": "A",
    "explanation": "The single loss expectancy (SLE) describes what a single risk event is likely to cost. It is calculated using the asset value (AV) times the exposure factor (EF), which is an estimated percentage of the cost that will occur in damage if the loss occurs. MTTR is the mean time to repair, ARO is the annual rate of occurrence, and RTO is the recovery time objective. These are not part of the SLE equation.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      310,
      307,
      309,
      312
    ],
    "source": "9781394211395"
  },
  {
    "id": 1488,
    "question": "Wayne has estimated the ARO for a risk in his organization to be 3. How often does Wayne think the event will happen?",
    "choice_a": "Once every 3 months",
    "choice_b": "Three times a year",
    "choice_c": "Once every three years",
    "choice_d": "Once a year for three years",
    "correct_answer": "B",
    "explanation": "Annual rate of occurrence (ARO) is expressed as the number of times an event will occur in a year. Wayne has estimated that the risk event that is being assessed will happen three times a year.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      310,
      309,
      305,
      313
    ],
    "source": "9781394211395"
  },
  {
    "id": 1489,
    "question": "Elle works for a credit card company that handles credit card transactions for businesses around the world. What data privacy role does her company play?",
    "choice_a": "A data controller",
    "choice_b": "A data steward",
    "choice_c": "A data custodian",
    "choice_d": "A data processor",
    "correct_answer": "D",
    "explanation": "Data processors are service providers that process data for data controllers. A data controller or data owner is the organization or individual who collects and controls data. A data steward carries out the intent of the data controller and is delegated responsibility for the data. Data custodians are those who are entrusted with the data to store, manage, or secure the data.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      317,
      292,
      289,
      287,
      290
    ],
    "source": "9781394211395"
  },
  {
    "id": 1490,
    "question": "Nicole determines how her organization processes data that it collects about its customers and also decides how and why personal information should be processed. What role does Nicole play in her organization?",
    "choice_a": "Data steward",
    "choice_b": "Data custodian",
    "choice_c": "Data controller",
    "choice_d": "Data consumer",
    "correct_answer": "C",
    "explanation": "Nicole is a data controller, sometimes called a data owner. She determines the reasons for processing personal information and how it is processed. A data steward carries out the intents of the data controller, data custodians are charged with safeguarding information, and data consumer is not a common data privacy role.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      317,
      292,
      273,
      276,
      298
    ],
    "source": "9781394211395"
  },
  {
    "id": 1491,
    "question": "Kirk's organization has been experiencing large\u2010scale denial\u2010of\u2010service (DoS) attacks against their primary website. Kirk contracts with his Internet service provider to increase the organization's bandwidth and expands the server pool for the website to handle significantly more traffic than any of the previous DoS attacks. What type of risk management strategy has he employed?",
    "choice_a": "Acceptance",
    "choice_b": "Avoidance",
    "choice_c": "Transfer",
    "choice_d": "Mitigation",
    "correct_answer": "D",
    "explanation": "Kirk has mitigated the risk to his organization by increasing the resources targeted by the DoS attack in an attempt to ensure that the attack will not be successful. Acceptance would involve simply letting the attacks occur knowing they are likely to stop, avoidance might involve finding a way to ensure the attacks cannot occur, and transfer could leverage a third\u2010party mirror or anti\u2010DoS hosting service.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      309,
      310,
      311,
      312,
      313
    ],
    "source": "9781394211395"
  },
  {
    "id": 1492,
    "question": "After Angela left her last organization, she discovered that she still had access to her shared drives and could log in to her email account. What critical process was likely forgotten when she left?",
    "choice_a": "An exit interview",
    "choice_b": "Job rotation",
    "choice_c": "Offboarding",
    "choice_d": "Governance",
    "correct_answer": "C",
    "explanation": "Offboarding processes are conducted to ensure that accounts and access are removed and that materials, computers, and data are all recovered from the staff member when a member of an organization leaves. Exit interviews are an HR process, job rotation helps to prevent an individual from conducting fraudulent activities over time, and governance helps to manage and maintain data by establishing high\u2010level control over the processes, procedures, and classification of the data an organization uses.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      286,
      273,
      317,
      292,
      302
    ],
    "source": "9781394211395"
  },
  {
    "id": 1493,
    "question": "Kelly's organization has created an incident response policy that outlines the high\u2010level goals of the IR process. Next, she wants to create detailed documents that describe the steps to handle specific incident types like denial\u2010of\u2010service attacks. What document should she create?",
    "choice_a": "Standards",
    "choice_b": "Playbooks",
    "choice_c": "Regulations",
    "choice_d": "Guidelines",
    "correct_answer": "B",
    "explanation": "Playbooks provide detailed, step\u2010by\u2010step instructions for how to address specific topics like denial\u2010of\u2010service attacks. Standards describe the settings or requirements that the organization wishes to use. Regulations are law and are not set by the organization, and guidelines provide advice to organizations seeking to comply with the policy and standards.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      275,
      278,
      276,
      277,
      279
    ],
    "source": "9781394211395"
  },
  {
    "id": 1494,
    "question": "Mohammed wants to show his organization's senior leadership the impact of their risk management process over time. What risk reporting method effectively conveys this in an easily digestible visual format for senior leadership?",
    "choice_a": "Ad hoc reports",
    "choice_b": "Risk registers",
    "choice_c": "Risk trend analysis",
    "choice_d": "Risk event reports",
    "correct_answer": "C",
    "explanation": "Risk trend analysis shows the change in risks over time, allowing senior leadership to quickly and easily understand where risks are being addressed and where they may be increasing or not getting the attention they need. Ad hoc reports are used when risk information is needed in specific areas, typically in response to specific needs. Risk registers list an organization's risks in detail and are not a quick, visual tool. Risk event reports detail specific events related to risks.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      314,
      305,
      309,
      312,
      293
    ],
    "source": "9781394211395"
  },
  {
    "id": 1495,
    "question": "Presenting certification that a third\u2010party organization has validated a vendor's practices against ISO 27001 is an example of what practice?",
    "choice_a": "Internal audit",
    "choice_b": "Vendor assessment",
    "choice_c": "Vulnerability scanning",
    "choice_d": "Data inventory",
    "correct_answer": "B",
    "explanation": "Third\u2010party assessments of an organization's efforts to meet ISO standards is an example of vendor assessment. Internal audit would leverage internal staff to perform an audit, vulnerability scans use technical tools to identify vulnerabilities, and data inventories identify data and its locations and uses.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      288,
      298,
      295,
      287,
      308
    ],
    "source": "9781394211395"
  },
  {
    "id": 1496,
    "question": "What common limitation do IaaS vendors place on penetration testing by their customers?",
    "choice_a": "It can only be done by third parties.",
    "choice_b": "It must be prescheduled.",
    "choice_c": "It can only be done by the customers themselves.",
    "choice_d": "Notification must be sent immediately after it occurs.",
    "correct_answer": "B",
    "explanation": "Vendors often ask that customers work with them to preschedule the testing so that they are aware of it. They typically do not place limitations on whether customers or third parties conduct the testing, and after\u2010the\u2010fact notification instead of prior notification is not a typical requirement.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      57,
      58,
      288,
      290,
      289
    ],
    "source": "9781394211395"
  },
  {
    "id": 1497,
    "question": "Chandra is providing guidance on recognizing phishing campaigns. Which of these is not a common way to recognize phishing emails?",
    "choice_a": "It creates a false sense of urgency.",
    "choice_b": "The IP address of the recipient.",
    "choice_c": "The attachment is encrypted and password protected.",
    "choice_d": "The email claims that there is a problem with your password.",
    "correct_answer": "B",
    "explanation": "The IP address of the recipient is not a common way of identifying phishing emails. The source system, domain, or IP may indicate a malicious sender, however! Phishing often focuses on creating a false sense of urgency, uses encrypted and password\u2010protected files to bypass filters, and may claim there is a problem with your password.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      301,
      300,
      303,
      304,
      310
    ],
    "source": "9781394211395"
  },
  {
    "id": 1498,
    "question": "Juan's company trains users to be cautious about revealing information about security controls, practices, configurations, and even the tools and software the company deploys. What is this practice known as?",
    "choice_a": "Awareness training",
    "choice_b": "Social engineering",
    "choice_c": "An insider threat",
    "choice_d": "Operational security",
    "correct_answer": "D",
    "explanation": "Operational security is the practice of educating users on the importance of protecting sensitive information, including security practices, configurations, and other details. Awareness training is a broad term describing all elements of security awareness. Social engineering is used by attackers to leverage human behaviors and practices for their own gain. Insider threats are threats created by those inside the organization.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      301,
      302,
      300,
      286,
      276
    ],
    "source": "9781394211395"
  },
  {
    "id": 1499,
    "question": "Mark's organization operates in the EU and sells products in multiple countries. It wants to determine its compliance requirements based on regulations that will impact it. Which of the following regions should it focus its review of legal implication on?",
    "choice_a": "Local",
    "choice_b": "National",
    "choice_c": "Global",
    "choice_d": "All of the above",
    "correct_answer": "D",
    "explanation": "An organization operating in the European Union (EU) and selling in multiple countries means that the company needs to assess legal implications on local, national, and global levels.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      292,
      294,
      293,
      317,
      287
    ],
    "source": "9781394211395"
  },
  {
    "id": 1500,
    "question": "What occurs when a vendor has a competing interest that could influence their behavior in a way that is not aligned with the best interests of one of their customers?",
    "choice_a": "An insider threat",
    "choice_b": "A MOU violation",
    "choice_c": "A conflict of interest",
    "choice_d": "A SOW violation",
    "correct_answer": "C",
    "explanation": "Conflicts of interest occur when an organization has a competing interest that could influence their behavior in a way that is not aligned with the best interest of a customer. Insider threats occur because an insider creates a problem or threat, either on purpose or inadvertently. MOU and SOW violations are both contractual violations and could be conflicts of interest but are not limited to that.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      287,
      290,
      289,
      304,
      310
    ],
    "source": "9781394211395"
  },
  {
    "id": 1501,
    "question": "Selma's organization allows individual business units to manage their cybersecurity needs and practices as they see fit. What type of governance structure have they adopted?",
    "choice_a": "Centralized",
    "choice_b": "Board\u2010based",
    "choice_c": "Committee\u2010based",
    "choice_d": "Decentralized",
    "correct_answer": "D",
    "explanation": "Decentralized governance allows individual business units to manage themselves rather than central organizations doing so. There is no board or committee described in the question.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      274,
      273,
      275,
      280,
      281
    ],
    "source": "9781394211395"
  },
  {
    "id": 1502,
    "question": "The US Treasury Department regulates banks and their behaviors, including security\u2010related regulations. What term best describes this type of governance structure?",
    "choice_a": "Government entity\u2013based",
    "choice_b": "Shareholder driven",
    "choice_c": "Board\u2010based",
    "choice_d": "Centralized",
    "correct_answer": "A",
    "explanation": "The Treasury Department is a government entity, making this governance government entity\u2013based. Shareholders and boards may play a role, but not via the Treasury Department. Centralized governance occurs inside the organization, not from an external entity.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      274,
      273,
      292,
      276,
      296
    ],
    "source": "9781394211395"
  },
  {
    "id": 1503,
    "question": "The company that Sandra wants to work with does not provide third\u2010party audit statements. If Sandra wants to engage with them, what should she request as part of her vendor assessment process prior to signing a contract in order to have the most useful data available?",
    "choice_a": "A right\u2010to\u2010audit clause",
    "choice_b": "A supply chain analysis",
    "choice_c": "Evidence of internal audits",
    "choice_d": "A due diligence statement",
    "correct_answer": "C",
    "explanation": "Requesting evidence of internal audits and then assessing that evidence is the best option Sandra has. While a right\u2010to\u2010audit clause can be important in contracts, it would only be useful after the contract is signed, not prior to engagement. Supply chain analysis can be useful in specific circumstances, but nothing in the question indicates specific supply chain requirements or concerns. Due diligence is performed, not stated.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      288,
      287,
      295,
      290,
      307
    ],
    "source": "9781394211395"
  },
  {
    "id": 1504,
    "question": "Leigh wants to provide new users with information about her organization's security goals and high\u2010level practices. What do organizations typically provide to accomplish this?",
    "choice_a": "Audit reports",
    "choice_b": "Policy handbooks",
    "choice_c": "Runbooks",
    "choice_d": "User awareness training",
    "correct_answer": "B",
    "explanation": "Policy handbooks are used to provide information about high\u2010level security practices and goals. Audit reports may not be broadly available in an organization, runbooks are detailed how\u2010to guides for processes or tasks, and user awareness training focuses on security awareness rather than high\u2010level goals and policies.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      276,
      275,
      277,
      278,
      300
    ],
    "source": "9781394211395"
  },
  {
    "id": 1505,
    "question": "Jodi wants to prepare her staff to defend against social engineering. What should she invest in to help her staff address this threat?",
    "choice_a": "EDR tools",
    "choice_b": "Awareness training",
    "choice_c": "A NGFW",
    "choice_d": "Security policies",
    "correct_answer": "B",
    "explanation": "Awareness training remains the best protection against social engineering aimed at individual staff members. While awareness won't stop all attacks, protecting individuals requires them to be trained on a regular basis. Endpoint detection and response (EDR) and next\u2010generation firewall (NGFW) are both technical tools that cannot stop social engineering directly, and security policies help the organization establish their approach to security but won't stop individual responses to social engineering directly.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      301,
      302,
      300,
      303,
      309
    ],
    "source": "9781394211395"
  },
  {
    "id": 1506,
    "question": "How do audits and examinations differ?",
    "choice_a": "An examination is simpler and less costly.",
    "choice_b": "Audits are external and examinations are internal.",
    "choice_c": "Audits are internal and examinations are external.",
    "choice_d": "An audit is simpler and less costly.",
    "correct_answer": "A",
    "explanation": "Examinations are simpler, typically smaller in scope, and less costly than an audit. Both help provide assurance, but the standards applied are different.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      281,
      295,
      7,
      310,
      296
    ],
    "source": "9781394211395"
  },
  {
    "id": 1507,
    "question": "Evangeline wants to develop a security training program. What should she do first?",
    "choice_a": "Determine how the training will be presented.",
    "choice_b": "Establish a budget.",
    "choice_c": "Review regulatory requirements for training.",
    "choice_d": "Assess the threats and risks the organization faces.",
    "correct_answer": "D",
    "explanation": "The first step in developing security training programs is to determine what risks and threats the organization faces. Once those are understood, an appropriate program can be created, including obtaining a budget, determining how training will be presented, and ensuring that regulatory requirements, if any, are met.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      303,
      310,
      304,
      309,
      298
    ],
    "source": "9781394211395"
  },
  {
    "id": 1508,
    "question": "Angelo is designing his organization's security governance groups and has created a committee. Which of the following is not a typical member of internal security governance committees?",
    "choice_a": "Subject matter experts",
    "choice_b": "Regulators",
    "choice_c": "Management",
    "choice_d": "Internal legal counsel",
    "correct_answer": "B",
    "explanation": "Internal governance committees do not typically include external entities like regulators. Subject matter experts (SMEs), management, and counsel are all commonly members of security governance committees.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      273,
      274,
      276,
      293,
      287
    ],
    "source": "9781394211395"
  },
  {
    "id": 1509,
    "question": "Dana wants to assess regulatory impacts on her organization's security policy. Which of the following is not a typical regulatory impact she will need to assess?",
    "choice_a": "Global",
    "choice_b": "National",
    "choice_c": "Local",
    "choice_d": "Corporate",
    "correct_answer": "D",
    "explanation": "Global, national, and local regulations may impact Dana's security policy, but corporations do not set regulations. Instead, they will influence the policy through contractual obligations.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      292,
      294,
      273,
      289,
      287
    ],
    "source": "9781394211395"
  },
  {
    "id": 1510,
    "question": "Marty wants to ensure that his security policies are up\u2010to\u2010date and effective. Which of the following data sources is least likely to be useful as he reviews his organization's security policies?",
    "choice_a": "Security system logs and reports",
    "choice_b": "Staff feedback",
    "choice_c": "NDAs",
    "choice_d": "Review of regulations",
    "correct_answer": "C",
    "explanation": "Feedback on policies from staff, integrating new and changed regulations, and validating reports from security tools are all common elements used to update security policies. Nondisclosure agreements (NDAs) seek to keep data secure through contractual obligations and are not a typical element in policy updates.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      281,
      276,
      275,
      292,
      287
    ],
    "source": "9781394211395"
  },
  {
    "id": 1511,
    "question": "What term describes a formal document that outlines the terms and details of an agreement between two organizations, including the roles and responsibilities each will have?",
    "choice_a": "A statement of work",
    "choice_b": "A business partners agreement",
    "choice_c": "A memorandum of agreement",
    "choice_d": "A service level agreement",
    "correct_answer": "C",
    "explanation": "A MOA, or memorandum of agreement, is a formal document that outlines the terms and details of an agreement between two organizations, including the roles and responsibilities each will have. A SOW, or statement of work, describes the specific work that will be under a master services agreement for an engagement. Service level agreements (SLAs) are written contracts that specify the conditions of service that will be provided by the vendor and the remedies available to the customer if the vendor fails to meet the SLA. Business partners agreements (BPAs) are used when organizations agree to do business with each other in a partnership.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      289,
      287,
      290,
      58,
      286
    ],
    "source": "9781394211395"
  },
  {
    "id": 1512,
    "question": "Victoria wants to understand a potential vendor's security practices. Which of the following is the simplest way for her to gather that information from multiple potential vendors?",
    "choice_a": "Third\u2010party audits",
    "choice_b": "Questionnaires",
    "choice_c": "Penetration testing",
    "choice_d": "OSINT",
    "correct_answer": "B",
    "explanation": "Companies commonly send questionnaires to potential vendors to gather information about security practices prior to acquiring their products or engaging their services. This is a simpler method than requiring audits or penetration tests, and OSINT will not provide organizational answers about practices in most cases.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      287,
      308,
      286,
      292,
      280
    ],
    "source": "9781394211395"
  },
  {
    "id": 1513,
    "question": "What two things most frequently drive external compliance reporting?",
    "choice_a": "Regulatory bodies and contractual obligations",
    "choice_b": "Internal and external audit",
    "choice_c": "Contractual requirements and board reporting",
    "choice_d": "Regulatory bodies and KPIs",
    "correct_answer": "A",
    "explanation": "External reporting for compliance is most often driven by the need to meet regulations or contractual obligations. Audit assesses compliance rather than driving reporting, board reporting is considered internal, and KPIs are typically internal measures.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      293,
      292,
      289,
      274,
      281
    ],
    "source": "9781394211395"
  },
  {
    "id": 1514,
    "question": "Blaine wants to ensure that his organization consistently meets PCI DSS requirements. What should he implement to meet this goal?",
    "choice_a": "Annual PCI DSS internal audits",
    "choice_b": "Automated compliance monitoring",
    "choice_c": "Annual PCI DSS external audits",
    "choice_d": "Compliance KPIs",
    "correct_answer": "B",
    "explanation": "Automated compliance monitoring is a key tool when organizations want to ensure they are consistently meeting compliance targets. Annual audits do not ensure compliance during the year, whether they are internal or external. Compliance KPIs give organizations compliance targets and measures, but without underlying tools they are simply a way to know the state of compliance when they are checked or updated.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      295,
      305,
      281,
      7,
      280
    ],
    "source": "9781394211395"
  },
  {
    "id": 1515,
    "question": "Ujama is reviewing logs and notices that one of his users has repeatedly failed their login process. After calling the user, he discovers that the user had mistyped their password multiple times. What type of anomalous behavior should he classify this as?",
    "choice_a": "Insider",
    "choice_b": "Risky",
    "choice_c": "Unintentional",
    "choice_d": "Unexpected",
    "correct_answer": "C",
    "explanation": "Mistakes like this are classified as unintentional anomalous behavior. Risky and unexpected behaviors are the other two classifications that are part of the Security+ exam outline. Insider attacks or threats are intentional or unintentional malicious activity, which mistyping a password is not an example of.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      300,
      302,
      301,
      304,
      310
    ],
    "source": "9781394211395"
  },
  {
    "id": 1516,
    "question": "Common password management practices include which of the following?",
    "choice_a": "Disabling MFA",
    "choice_b": "Reusing passwords across multiple sites",
    "choice_c": "Enabling password hints",
    "choice_d": "Changing passwords only when necessary",
    "correct_answer": "D",
    "explanation": "NIST no longer recommends requiring password changes on a regular basis, and instead suggests that passwords only be changed when necessary. This helps to prevent password reuse and avoids influencing users to slightly modify passwords. Disabling MFA, reusing passwords, and using passwords hints are all practices that should be avoided.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      301,
      277,
      302,
      296,
      312
    ],
    "source": "9781394211395"
  },
  {
    "id": 1517,
    "question": "Mark is responsible for the execution of his organization's security awareness program. Why might he deploy multiple training methods like workshops, online training, and simulations as part of the training?",
    "choice_a": "To meet compliance requirements",
    "choice_b": "To address learning preferences",
    "choice_c": "To decrease costs for training",
    "choice_d": "To meet KPIs",
    "correct_answer": "B",
    "explanation": "Organizations often use multiple formats for awareness training to address learning preferences and styles. Compliance requirements typically do not specify how awareness is accomplished, just that it has occurred and can be validated. Multiple modes of training tend to increase costs rather than decreasing them, and KPIs for security awareness look at impact, not modes.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      302,
      301,
      300,
      275,
      281
    ],
    "source": "9781394211395"
  },
  {
    "id": 1518,
    "question": "Natasha wants to establish a vendor monitoring practice for her organization. What should she establish to ensure that her vendor is performing as expected?",
    "choice_a": "A MOU",
    "choice_b": "Ongoing compliance audits",
    "choice_c": "Regulatory requirements",
    "choice_d": "KPIs",
    "correct_answer": "D",
    "explanation": "Organizations typically establish KPIs (key performance indicators), which may be described in MSAs (master service agreements), SLAs (service level agreements), or SOWs (statements of work). These help to measure and monitor the vendor's performance. MOUs are used to document how organizations want to work together, not to establish performance measures. Compliance audits and regulatory requirements are only part of performance management.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      289,
      290,
      288,
      295,
      287
    ],
    "source": "9781394211395"
  },
  {
    "id": 1519,
    "question": "Mikayla is working remotely in a public space and has been trained to make sure that others cannot see her screen or keyboard. What term is used to describe this?",
    "choice_a": "Insider threats",
    "choice_b": "Situational awareness",
    "choice_c": "Social engineering",
    "choice_d": "Unintentional risky behavior",
    "correct_answer": "B",
    "explanation": "Staff should be trained to maintain situational awareness by keeping an eye on their environment and the behaviors of individuals around them. Insider threats are internal actors who undertake malicious actions. Social engineering uses human behaviors to conduct malicious activities, and unintentionally risky behavior is typically accidental threats caused by users.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      301,
      302,
      300,
      304,
      309
    ],
    "source": "9781394211395"
  },
  {
    "id": 1520,
    "question": "What data role is typically the most senior in an organization?",
    "choice_a": "Data processor",
    "choice_b": "Data controller",
    "choice_c": "Data owner",
    "choice_d": "Data steward",
    "correct_answer": "C",
    "explanation": "Data owners are typically the most senior data\u2013related role in an organization and bear broad responsibility for the data, including oversight roles over stewards, controllers, and processors.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      317,
      272,
      276,
      287,
      293
    ],
    "source": "9781394211395"
  },
  {
    "id": 1521,
    "question": "Which of the following is not a common hybrid work environment security practice?",
    "choice_a": "Use of VPNs",
    "choice_b": "Use of secure Wi\u2010Fi networks",
    "choice_c": "Ensuring physical security",
    "choice_d": "Deploying security cameras",
    "correct_answer": "D",
    "explanation": "Deploying security cameras is not a common hybrid work environment option. Use of VPNs, secure Wi\u2010Fi, and appropriate physical security are all common options.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      301,
      302,
      276,
      279,
      280
    ],
    "source": "9781394211395"
  },
  {
    "id": 1522,
    "question": "Which of the following is not a common driver of external compliance reporting?",
    "choice_a": "Contracts",
    "choice_b": "Regulation",
    "choice_c": "Reputation",
    "choice_d": "Licensing",
    "correct_answer": "C",
    "explanation": "Contracts, regulations, and licensing all drive external compliance reporting. Reputations may be damaged if organizations are not compliant, but it does not drive reporting.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      293,
      292,
      294,
      289,
      287
    ],
    "source": "9781394211395"
  },
  {
    "id": 1523,
    "question": "Justin wants to have work done by a contractor with whom his organization has a master services agreement. What should he prepare to fully document the required work?",
    "choice_a": "A work order",
    "choice_b": "A service level agreement",
    "choice_c": "A memorandum of understanding",
    "choice_d": "A memorandum of agreement",
    "correct_answer": "A",
    "explanation": "Work orders (WO) and statements of work (SOWs) are used to document the specific tasks and deliverables that are performed under an MSA. SLAs, MOUs, and MOAs are not used for this purpose.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      289,
      290,
      57,
      58,
      273
    ],
    "source": "9781394211395"
  },
  {
    "id": 1524,
    "question": "What measure is used to describe the average functional lifespan of a device in use?",
    "choice_a": "An RTO",
    "choice_b": "An MTTR",
    "choice_c": "An RPO",
    "choice_d": "An MTBF",
    "correct_answer": "D",
    "explanation": "MTBF, or mean time between failure, describes the average time before a device will fail, or the average amount of time between failures of a system. A recovery time objective, or RTO, is set by organizations to describe how long restoring systems or services to normal function after a disruption can take. Mean time to repair, or MTTR, is the average time it takes to repair a system or device. A recovery point objective, or RPO, describes how much data can be lost in the event of an outage or issue.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      310,
      306,
      307,
      289,
      297
    ],
    "source": "9781394211395"
  },
  {
    "id": 1525,
    "question": "Jackie wants to use an ISO standard to help her select and implement information security controls and to develop information security management guidelines. Which ISO standard should she use?",
    "choice_a": "ISO 27001",
    "choice_b": "ISO 27701",
    "choice_c": "ISO 27002",
    "choice_d": "ISO 31000",
    "correct_answer": "C",
    "explanation": "ISO 27002 describes controls and helps select and implement controls while also providing guidance on developing information security management guidelines. ISO 27001 establishes control objectives for 14 different categories, including things like HR security, asset management, and operations security. ISO 27701 focuses on managing privacy controls, and ISO 31000 provides guidelines for risk management.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      298,
      275,
      277,
      279,
      273
    ],
    "source": "9781394211395"
  },
  {
    "id": 1526,
    "question": "Establishing requirements like the height of fences is part of what standard for most organizations?",
    "choice_a": "Physical security",
    "choice_b": "Access control",
    "choice_c": "Business continuity",
    "choice_d": "Onboarding",
    "correct_answer": "A",
    "explanation": "Physical security standards set requirements for physical security controls like fences, locks, doors, and cameras. Access control policies may be logical or physical control\u2013based, but fence height is not an access control. Business continuity and onboarding don't impact fence height, nor do they rely on it.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      277,
      275,
      278,
      298,
      299
    ],
    "source": "9781394211395"
  },
  {
    "id": 1527,
    "question": "What organization typically elects an organization's board of directors in a public company?",
    "choice_a": "The employees",
    "choice_b": "The CEO",
    "choice_c": "Shareholders",
    "choice_d": "All relevant stakeholders",
    "correct_answer": "C",
    "explanation": "Boards are typically elected by shareholders. Employees, the CEO, and non\u2010shareholders typically do not have the ability to elect or name members of the board.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      272,
      274,
      276,
      317,
      287
    ],
    "source": "9781394211395"
  },
  {
    "id": 1528,
    "question": "Greg wants to classify anomalous behavior he has observed. The behavior involves a user's workstation sending large volumes of data to an off\u2010site web server. How should he classify this behavior?",
    "choice_a": "Risky",
    "choice_b": "Unexpected",
    "choice_c": "Unintentional",
    "choice_d": "An insider threat",
    "correct_answer": "B",
    "explanation": "Until he knows more details, Greg should classify this behavior as unexpected. Sending large volumes of data may be intentional, could be legitimate and thus not risky, and if it is intentional and part of business needs, would not be an insider threat.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      304,
      303,
      310,
      312,
      309
    ],
    "source": "9781394211395"
  },
  {
    "id": 1529,
    "question": "Amber is responsible for compliance with PCI DSS in her organization and wants to ensure that she meets ongoing compliance monitoring requirements. Which of the following options will best help her achieve ongoing compliance?",
    "choice_a": "Conduct quarterly audits.",
    "choice_b": "Use compliance monitoring capabilities in scanning and management tools.",
    "choice_c": "Conduct regular training on compliance requirements.",
    "choice_d": "Require an auditor's attestation of compliance.",
    "correct_answer": "C",
    "explanation": "Using existing tools to monitor for changes that would move the organization out of compliance is a common practice to help ensure ongoing compliance. Quarterly audits are point\u2010in\u2010time checks and won't ensure ongoing compliance. Training helps to keep staff aware, but additional actions are required to ensure compliance, and attestation does not provide ongoing compliance, only a statement at a point in time.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      295,
      281,
      292,
      293,
      305
    ],
    "source": "9781394211395"
  },
  {
    "id": 1530,
    "question": "The third\u2010party auditors that Dion hired for his organization have completed their audit. What action does the audit firm take after management acknowledgment is received from Dion's company?",
    "choice_a": "Compliance reports are sent to third parties.",
    "choice_b": "Regulatory statements are sent to customers.",
    "choice_c": "Attestation is provided by the auditor.",
    "choice_d": "Follow\u2010up vulnerability scans will validate findings.",
    "correct_answer": "C",
    "explanation": "After audits are acknowledged by management, the auditors will attest that the audit is complete and accurate based on their work and knowledge. Compliance and regulatory reporting may or may not happen depending on the reasons for the audit and the organization's needs. Once an audit is complete, further scans and other work may be conducted by the company but are not guaranteed.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      295,
      293,
      281,
      296,
      298
    ],
    "source": "9781394211395"
  },
  {
    "id": 1531,
    "question": "Latisha is conducting a security review and notices that one of her users consistently uses her organization's VPN from Chile while the employee is based in the United States. After reviewing logs, she notes that the user is sometimes logged in from both the US and the remote location in Chile, and believes that the user may be allowing a third party to access their VPN account to perform some or all of their job tasks. What type of threat most accurately describes this?",
    "choice_a": "Anomalous",
    "choice_b": "Insider",
    "choice_c": "Social engineering",
    "choice_d": "Nation\u2010state",
    "correct_answer": "B",
    "explanation": "The employee at Latisha's company can be considered an insider threat because they have provided access to a third party. Most organizations will terminate employees who do this due to violations of their acceptable use policy (AUP). The behavior is anomalous, but an insider threat is a better description. No social engineering is evident, nor is a nation\u2010state actor described.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      304,
      276,
      301,
      302,
      286
    ],
    "source": "9781394211395"
  },
  {
    "id": 1532,
    "question": "Marzita wants to respond to a phishing campaign that is sending links to malware to organizations. What effective tactic can she use to react to these campaigns quickly?",
    "choice_a": "Deploy a WAF to block suspicious links.",
    "choice_b": "Subscribe to a threat feed and automatically block phishing campaign URLs.",
    "choice_c": "Manually block phishing URLs as they are reported by users.",
    "choice_d": "Implement user awareness training.",
    "correct_answer": "B",
    "explanation": "Using threat feeds to block phishing campaign URLs as they enter the feed is a proactive way to quickly respond. Web application firewalls (WAFs) are used to protect applications rather than as border devices to block outbound traffic. Manual blocks are commonly used but are slower to implement than threat feed\u2013based responses. Conducting user awareness training is a best practice but doesn't directly respond to campaigns.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      301,
      302,
      290,
      305,
      309
    ],
    "source": "9781394211395"
  },
  {
    "id": 1533,
    "question": "Amanda discovers that a member of her organization's staff has installed a remote access Trojan on their accounting software server and has been accessing it remotely. What type of threat has she discovered?",
    "choice_a": "Zero\u2010day",
    "choice_b": "Insider threat",
    "choice_c": "Misconfiguration",
    "choice_d": "Weak encryption",
    "correct_answer": "B",
    "explanation": "Amanda has discovered an insider threat. Insider threats can be difficult to discover, as a malicious administrator or other privileged user will often have the ability to conceal their actions or may actually be the person tasked with hunting for threats like this! This is not a zero\u2010day\u2014no vulnerability was mentioned, there was no misconfiguration since this was an intentional action, and encryption is not mentioned or discussed.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      304,
      303,
      312,
      307,
      61
    ],
    "source": "9781394211395"
  },
  {
    "id": 1534,
    "question": "Phil recently received an email claiming to be from HR with a link to a list of every employee's compensation attached. Phil clicks on it without checking the URL because he is curious about the pay that others in his department receive. How would this behavior be classified?",
    "choice_a": "Risky",
    "choice_b": "Irresponsible",
    "choice_c": "Unexpected",
    "choice_d": "Unintentional",
    "correct_answer": "A",
    "explanation": "Behavior like this would be considered risky, as clicking on unknown, unexpected links is a common way to succumb to a phishing attack. Unexpected typically describes behavior that isn't typical for the user, and we do now know if this user typically behaves this way. The Security+ exam outline doesn't use irresponsible as a category, and the click was intentional.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      301,
      302,
      303,
      309,
      310
    ],
    "source": "9781394211395"
  },
  {
    "id": 1535,
    "question": "What should Ben do if he wants to assess the initial state of his information security awareness?",
    "choice_a": "Implement security awareness based on a standard like ISO 27001.",
    "choice_b": "Conduct a baseline analysis to determine his starting state.",
    "choice_c": "Implement security awareness based on NIST standards.",
    "choice_d": "Conduct a penetration test to determine how staff respond to security issues.",
    "correct_answer": "B",
    "explanation": "Establishing a baseline for security awareness is important so that Ben can determine what, if any, impact a program is having. This will drive KPIs as well as influence which actions and steps are taken to evolve the program. Implementing a security program is recommended by many standards, but they don't determine initial awareness state. Penetration tests can provide information about where issues lie but don't provide a broad baseline assessment either.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      302,
      300,
      305,
      310,
      298
    ],
    "source": "9781394211395"
  },
  {
    "id": 1536,
    "question": "During an incident investigation, Naomi notices that a second keyboard was plugged into a system in a public area of her company's building. Shortly after that event, the system was infected with malware, resulting in a data breach. What should Naomi look for in her in\u2010person investigation?",
    "choice_a": "A Trojan horse download",
    "choice_b": "A malicious USB cable or drive",
    "choice_c": "A worm",
    "choice_d": "None of the above",
    "correct_answer": "B",
    "explanation": "Malicious tools like BadUSB can make a USB cable or drive look like a keyboard when they are plugged in. Malicious thumb drives have been used by penetration testers simply by dropping them in a parking lot near their intended target. A Trojan or a worm is a possibility, but the clue involving the keyboard would point to a USB device as the first place Naomi should look.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      57,
      61,
      288,
      303,
      302
    ],
    "source": "9781394211395"
  },
  {
    "id": 1537,
    "question": "Jill wants to train her users to appropriately respond to suspicious email messages. Which of the following will provide her organization with the most useful input from users?",
    "choice_a": "Ask users to report the email to the email provider using a reporting button.",
    "choice_b": "Ask users to report the email to an internal security team.",
    "choice_c": "Ask users to delete the email to avoid further issues.",
    "choice_d": "Ask users to click on the message and links to explore the potential security issue.",
    "correct_answer": "B",
    "explanation": "A common practice is to report suspicious messages to an internal security team so that they can take action on phishing and other potential security issues. Reporting to third parties will not provide the same visibility, nor will deleting the messages. Asking users to click on messages works against security best practices!",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      302,
      301,
      278,
      273,
      280
    ],
    "source": "9781394211395"
  },
  {
    "id": 1538,
    "question": "Marcia wants to assess the effectiveness of her security awareness program. What should she do?",
    "choice_a": "Establish and monitor awareness KPIs.",
    "choice_b": "Require a third\u2010party awareness audit.",
    "choice_c": "Conduct regular surveys about security awareness.",
    "choice_d": "Track incident rates versus training participation.",
    "correct_answer": "A",
    "explanation": "Establishing security awareness KPIs, including incident rates, training uptake, responses to security awareness surveys, and other measurable indicators, is both the broadest and most useful option listed. Third\u2010party awareness audits are not a typical method for doing this, and conducting surveys and tracking incident rates are both actions that will be part of common awareness KPIs.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      302,
      301,
      295,
      273,
      312
    ],
    "source": "9781394211395"
  },
  {
    "id": 1539,
    "question": "Myles wants to describe the impact of noncompliance with regulations on his organization's business. If his organization is not compliant, what impact is most likely to occur related to his customers?",
    "choice_a": "Fines",
    "choice_b": "Contractual impacts",
    "choice_c": "Loss of license",
    "choice_d": "Sanctions",
    "correct_answer": "B",
    "explanation": "Myles should be concerned about contractual impacts as part of his customer relationships. Noncompliance with regulations is likely to make him unable to fulfill contracts or to be in violation of contractual terms that require his company to be in compliance. Fines, loss of license, and sanctions may also occur, but they are less directly impactful to customers and are not guaranteed.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      289,
      294,
      293,
      290,
      287
    ],
    "source": "9781394211395"
  },
  {
    "id": 1540,
    "question": "Sabrina wants to train her users on password management best practices. Which of the following options will have the largest impact on her organization's password security?",
    "choice_a": "Implementing biometrics authentication factors",
    "choice_b": "Conducting annual training on password best practices",
    "choice_c": "Adopting NIST password length and complexity standards",
    "choice_d": "Requiring staff to use an enterprise password manager",
    "correct_answer": "D",
    "explanation": "An enterprise password manager can help to make it easier to use appropriate passwords without requiring users to memorize them. This results in less reuse, stronger passwords, and the ability to manage them, including preventing password reuse. Biometrics, training, and adopting NIST password complexity and length standards will not have the same broad impact.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      301,
      277,
      309,
      310,
      287
    ],
    "source": "9781394211395"
  },
  {
    "id": 1541,
    "question": "Jill wants to explain her organization's risks to senior management, but she knows that the risk register is lengthy and detailed. What type of document is commonly used to convey the most important high\u2010level information found in a risk register to senior leaders?",
    "choice_a": "A risk matrix",
    "choice_b": "An SLE report",
    "choice_c": "An ALE report",
    "choice_d": "A risk KPI list",
    "correct_answer": "A",
    "explanation": "Risk matrices are often used to summarize risk registers for senior management. SLE and ALE reports are not common documents, although ALE and SLE reports are commonly used as part of quantitative risk assessment and reporting. Risk KPIs are used to track progress on risk management, not to provide a summary of a risk register.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      314,
      310,
      307,
      306,
      313
    ],
    "source": "9781394211395"
  },
  {
    "id": 1542,
    "question": "Which of the following best describes guidelines?",
    "choice_a": "They outline the principles and rules that guide the execution of security efforts throughout the enterprise.",
    "choice_b": "They provide advice to organizations seeking to comply with the policies and standards.",
    "choice_c": "They provide mandatory requirements describing how an organization will carry out its information security policies.",
    "choice_d": "They are detailed, step\u2010by\u2010step processes that individuals and organizations must follow in specific circumstances.",
    "correct_answer": "B",
    "explanation": "Guidelines provide advice to organizations seeking to comply with policies and standards. Policies outline the principles and rules that guide the execution of security efforts throughout the enterprise. Standards provide mandatory requirements describing how an organization will carry out its information security policies.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      275,
      279,
      277,
      276,
      278
    ],
    "source": "9781394211395"
  }
];
